(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './korge-root-korge-core.js', './korge-root-korlibs-datastructure.js', './korge-root-korge-foundation.js', './korge-root-korlibs-time.js', './korge-root-korlibs-logger.js', './korge-root-korlibs-crypto.js', './korge-root-korlibs-concurrent.js', './korge-root-korlibs-platform.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./korge-root-korge-core.js'), require('./korge-root-korlibs-datastructure.js'), require('./korge-root-korge-foundation.js'), require('./korge-root-korlibs-time.js'), require('./korge-root-korlibs-logger.js'), require('./korge-root-korlibs-crypto.js'), require('./korge-root-korlibs-concurrent.js'), require('./korge-root-korlibs-platform.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korge-core'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korge-core' was not found. Please, check whether 'korge-root-korge-core' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korlibs-datastructure'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korlibs-datastructure' was not found. Please, check whether 'korge-root-korlibs-datastructure' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korge-foundation'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korge-foundation' was not found. Please, check whether 'korge-root-korge-foundation' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korlibs-time'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korlibs-time' was not found. Please, check whether 'korge-root-korlibs-time' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korlibs-logger'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korlibs-logger' was not found. Please, check whether 'korge-root-korlibs-logger' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korlibs-crypto'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korlibs-crypto' was not found. Please, check whether 'korge-root-korlibs-crypto' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korlibs-concurrent'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korlibs-concurrent' was not found. Please, check whether 'korge-root-korlibs-concurrent' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['korge-root-korlibs-platform'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'korge-root-korlibs-platform' was not found. Please, check whether 'korge-root-korlibs-platform' is loaded prior to 'korge-root-korge'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korge'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'korge-root-korge'.");
    }
    root['korge-root-korge'] = factory(typeof this['korge-root-korge'] === 'undefined' ? {} : this['korge-root-korge'], this['kotlin-kotlin-stdlib'], this['korge-root-korge-core'], this['korge-root-korlibs-datastructure'], this['korge-root-korge-foundation'], this['korge-root-korlibs-time'], this['korge-root-korlibs-logger'], this['korge-root-korlibs-crypto'], this['korge-root-korlibs-concurrent'], this['korge-root-korlibs-platform'], this['kotlinx-coroutines-core']);
  }
}(this, function (_, kotlin_kotlin, kotlin_com_soywiz_korge_korge_core, kotlin_com_soywiz_korge_korlibs_datastructure, kotlin_com_soywiz_korge_korge_foundation, kotlin_com_soywiz_korge_korlibs_time, kotlin_com_soywiz_korge_korlibs_logger, kotlin_com_soywiz_korge_korlibs_crypto, kotlin_com_soywiz_korge_korlibs_concurrent, kotlin_com_soywiz_korge_korlibs_platform, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_instance = kotlin_kotlin.$_$.a5;
  var protoOf = kotlin_kotlin.$_$.uc;
  var cancel = kotlin_com_soywiz_korge_korge_core.$_$.d4;
  var CloseableCancellable = kotlin_com_soywiz_korge_korge_core.$_$.e4;
  var classMeta = kotlin_kotlin.$_$.jb;
  var setMetadataFor = kotlin_kotlin.$_$.vc;
  var VOID = kotlin_kotlin.$_$.f;
  var FastArrayList_init_$Create$ = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.c;
  var FastIdentityMap = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.d1;
  var ensureNotNull = kotlin_kotlin.$_$.ih;
  var get = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.n2;
  var set = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.v2;
  var THROW_CCE = kotlin_kotlin.$_$.qg;
  var toFastList = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.b3;
  var toString = kotlin_kotlin.$_$.zc;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.t1;
  var CancellableGroup = kotlin_com_soywiz_korge_korge_core.$_$.c4;
  var interfaceMeta = kotlin_kotlin.$_$.wb;
  var objectMeta = kotlin_kotlin.$_$.tc;
  var Enum = kotlin_kotlin.$_$.gg;
  var getNumberHashCode = kotlin_kotlin.$_$.rb;
  var equals = kotlin_kotlin.$_$.lb;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
  var Companion_getInstance = kotlin_kotlin.$_$.r4;
  var toString_0 = kotlin_kotlin.$_$.y2;
  var Char__hashCode_impl_otmys = kotlin_kotlin.$_$.t2;
  var getBooleanHashCode = kotlin_kotlin.$_$.pb;
  var getStringHashCode = kotlin_kotlin.$_$.tb;
  var Companion_getInstance_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.r3;
  var Mixin = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.y;
  var Companion_getInstance_1 = kotlin_com_soywiz_korge_korlibs_time.$_$.e;
  var fillArrayVal = kotlin_kotlin.$_$.nb;
  var FastIntMap = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.e1;
  var joinToString = kotlin_kotlin.$_$.w7;
  var DateTime__hashCode_impl_yf0bc9 = kotlin_com_soywiz_korge_korlibs_time.$_$.a;
  var Exception = kotlin_kotlin.$_$.ig;
  var hashCode = kotlin_kotlin.$_$.ub;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.o;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b6;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
  var arraycopy = kotlin_com_soywiz_korge_korge_foundation.$_$.r8;
  var Vector2D_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.y;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.qh;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.h1;
  var get_niceStr = kotlin_com_soywiz_korge_korge_foundation.$_$.gb;
  var booleanArray = kotlin_kotlin.$_$.cb;
  var IntArrayList = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.l1;
  var get_lastIndex = kotlin_kotlin.$_$.c8;
  var Companion_getInstance_2 = kotlin_com_soywiz_korge_korlibs_logger.$_$.g;
  var Level_INFO_getInstance = kotlin_com_soywiz_korge_korlibs_logger.$_$.c;
  var emptySet = kotlin_kotlin.$_$.d7;
  var _Int8Buffer___init__impl__e20lvc = kotlin_com_soywiz_korge_korge_foundation.$_$.m2;
  var _Int8Buffer___get_buffer__impl__q0gulb = kotlin_com_soywiz_korge_korge_foundation.$_$.n2;
  var sliceWithSize = kotlin_com_soywiz_korge_korge_foundation.$_$.db;
  var arrayequal = kotlin_com_soywiz_korge_korge_foundation.$_$.z8;
  var clone = kotlin_com_soywiz_korge_korge_foundation.$_$.f9;
  var objectCreate = kotlin_kotlin.$_$.sc;
  var RectangleI_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.o;
  var Long = kotlin_kotlin.$_$.kg;
  var NullBitmap = kotlin_com_soywiz_korge_korge_core.$_$.d2;
  var Companion_getInstance_3 = kotlin_com_soywiz_korge_korge_foundation.$_$.v3;
  var Closeable = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.u;
  var Level_ERROR_getInstance = kotlin_com_soywiz_korge_korlibs_logger.$_$.b;
  var MultiBitmap = kotlin_com_soywiz_korge_korge_core.$_$.a2;
  var ForcedTexId = kotlin_com_soywiz_korge_korge_core.$_$.z1;
  var isInterface = kotlin_kotlin.$_$.gc;
  var get_isPowerOfTwo = kotlin_com_soywiz_korge_korge_foundation.$_$.i7;
  var extract = kotlin_com_soywiz_korge_korge_foundation.$_$.j9;
  var insert5 = kotlin_com_soywiz_korge_korge_foundation.$_$.qa;
  var insert2 = kotlin_com_soywiz_korge_korge_foundation.$_$.na;
  var insert = kotlin_com_soywiz_korge_korge_foundation.$_$.ua;
  var distinct = kotlin_kotlin.$_$.z6;
  var compareTo = kotlin_kotlin.$_$.kb;
  var fastArrayListOf = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.d2;
  var insert4 = kotlin_com_soywiz_korge_korge_foundation.$_$.pa;
  var Companion_getInstance_4 = kotlin_kotlin.$_$.u4;
  var fromLowHigh = kotlin_com_soywiz_korge_korge_foundation.$_$.l9;
  var get_low = kotlin_com_soywiz_korge_korge_foundation.$_$.va;
  var get_high = kotlin_com_soywiz_korge_korge_foundation.$_$.ia;
  var insert8 = kotlin_com_soywiz_korge_korge_foundation.$_$.ra;
  var insert3 = kotlin_com_soywiz_korge_korge_foundation.$_$.oa;
  var toShortClamped = kotlin_com_soywiz_korge_korge_foundation.$_$.d8;
  var toIntRound = kotlin_com_soywiz_korge_korge_foundation.$_$.c8;
  var toIntRound_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.b8;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.l4;
  var ShortCompanionObject_instance = kotlin_kotlin.$_$.m4;
  var Companion_getInstance_5 = kotlin_com_soywiz_korge_korge_foundation.$_$.n3;
  var insert14 = kotlin_com_soywiz_korge_korge_foundation.$_$.la;
  var ilog2 = kotlin_com_soywiz_korge_korge_foundation.$_$.f7;
  var get_unreachable = kotlin_com_soywiz_korge_korge_core.$_$.k4;
  var RGBA = kotlin_com_soywiz_korge_korge_core.$_$.k2;
  var RGBA__hashCode_impl_h59qf6 = kotlin_com_soywiz_korge_korge_core.$_$.p;
  var extractScaledf01 = kotlin_com_soywiz_korge_korge_foundation.$_$.h9;
  var insertScaledf01 = kotlin_com_soywiz_korge_korge_foundation.$_$.sa;
  var insert_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.ta;
  var numberToInt = kotlin_kotlin.$_$.qc;
  var Vector2D_init_$Create$_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.x;
  var BoundsBuilder__plus_impl_cz7f7x = kotlin_com_soywiz_korge_korge_foundation.$_$.t1;
  var min = kotlin_com_soywiz_korge_korge_foundation.$_$.m7;
  var max = kotlin_com_soywiz_korge_korge_foundation.$_$.l7;
  var ByteUnits = kotlin_com_soywiz_korge_korge_foundation.$_$.g8;
  var KProperty1 = kotlin_kotlin.$_$.ud;
  var getPropertyCallableRef = kotlin_kotlin.$_$.sb;
  var setExtra = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.u2;
  var getExtraTyped = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.l2;
  var RuntimeException = kotlin_kotlin.$_$.pg;
  var get_hex = kotlin_com_soywiz_korge_korlibs_crypto.$_$.d;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.a2;
  var captureStack = kotlin_kotlin.$_$.db;
  var toList = kotlin_kotlin.$_$.o9;
  var arraycopy_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.w8;
  var Buffer_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.z;
  var get_i32 = kotlin_com_soywiz_korge_korge_foundation.$_$.ja;
  var arraycopy_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.u8;
  var get_f32 = kotlin_com_soywiz_korge_korge_foundation.$_$.k9;
  var arraycopy_2 = kotlin_com_soywiz_korge_korge_foundation.$_$.v8;
  var FloatBitmap32 = kotlin_com_soywiz_korge_korge_core.$_$.y1;
  var get_i8 = kotlin_com_soywiz_korge_korge_foundation.$_$.ka;
  var arraycopy_3 = kotlin_com_soywiz_korge_korge_foundation.$_$.s8;
  var Bitmap8 = kotlin_com_soywiz_korge_korge_core.$_$.v1;
  var unsupported = kotlin_com_soywiz_korge_korge_core.$_$.l4;
  var NativeImage = kotlin_com_soywiz_korge_korge_core.$_$.c2;
  var toLong = kotlin_kotlin.$_$.xc;
  var listOf = kotlin_kotlin.$_$.i8;
  var get_size = kotlin_com_soywiz_korge_korge_foundation.$_$.bb;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.z;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.r;
  var lazy = kotlin_kotlin.$_$.ph;
  var Ref = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.o1;
  var _RGBA___get_rf__impl__kvz75k = kotlin_com_soywiz_korge_korge_core.$_$.s;
  var _RGBA___get_gf__impl__5gcu1f = kotlin_com_soywiz_korge_korge_core.$_$.o;
  var _RGBA___get_bf__impl__1xz5yg = kotlin_com_soywiz_korge_korge_core.$_$.n;
  var _RGBA___get_af__impl__vu36qv = kotlin_com_soywiz_korge_korge_core.$_$.m;
  var numberToLong = kotlin_kotlin.$_$.rc;
  var println = kotlin_kotlin.$_$.ab;
  var sliceBuffer = kotlin_com_soywiz_korge_korge_foundation.$_$.cb;
  var KMutableProperty1 = kotlin_kotlin.$_$.sd;
  var Companion_instance = kotlin_com_soywiz_korge_korge_core.$_$.q1;
  var PropertyThis = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.z;
  var NotImplementedError = kotlin_kotlin.$_$.mg;
  var korAtomic = kotlin_com_soywiz_korge_korge_core.$_$.w3;
  var korAtomic_0 = kotlin_com_soywiz_korge_korge_core.$_$.x3;
  var Lock = kotlin_com_soywiz_korge_korlibs_concurrent.$_$.a;
  var incrementAndGet = kotlin_com_soywiz_korge_korge_core.$_$.v3;
  var mapCapacity = kotlin_kotlin.$_$.k8;
  var coerceAtLeast = kotlin_kotlin.$_$.hd;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
  var FastStringMap = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.g1;
  var Level_TRACE_getInstance = kotlin_com_soywiz_korge_korlibs_logger.$_$.d;
  var listOf_0 = kotlin_kotlin.$_$.j8;
  var Level_DEBUG_getInstance = kotlin_com_soywiz_korge_korlibs_logger.$_$.a;
  var Triple = kotlin_kotlin.$_$.tg;
  var stackTraceToString = kotlin_kotlin.$_$.th;
  var last = kotlin_kotlin.$_$.f8;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.n1;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.f1;
  var replace = kotlin_kotlin.$_$.se;
  var isCharSequence = kotlin_kotlin.$_$.bc;
  var trim = kotlin_kotlin.$_$.xf;
  var toIntOrNull = kotlin_kotlin.$_$.if;
  var Size2D_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.r;
  var linkedHashMapOf = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.r2;
  var getKClassFromExpression = kotlin_kotlin.$_$.c;
  var get_portableSimpleName = kotlin_com_soywiz_korge_korge_core.$_$.i4;
  var nextMultipleOf = kotlin_com_soywiz_korge_korge_foundation.$_$.r7;
  var copyOf = kotlin_com_soywiz_korge_korge_foundation.$_$.g9;
  var _RGBAPremultiplied___get_rf__impl__pt0c4y = kotlin_com_soywiz_korge_korge_core.$_$.y;
  var _RGBAPremultiplied___get_gf__impl__ivron7 = kotlin_com_soywiz_korge_korge_core.$_$.x;
  var _RGBAPremultiplied___get_bf__impl__qa3on2 = kotlin_com_soywiz_korge_korge_core.$_$.w;
  var _RGBAPremultiplied___get_af__impl__euwcjn = kotlin_com_soywiz_korge_korge_core.$_$.v;
  var Companion_getInstance_6 = kotlin_com_soywiz_korge_korge_foundation.$_$.l3;
  var KMutableProperty0 = kotlin_kotlin.$_$.rd;
  var Companion_getInstance_7 = kotlin_com_soywiz_korge_korlibs_platform.$_$.d;
  var getOrNull = kotlin_kotlin.$_$.o7;
  var Os_UNKNOWN_getInstance = kotlin_com_soywiz_korge_korlibs_platform.$_$.c;
  var Comparator = kotlin_kotlin.$_$.dg;
  var compareValues = kotlin_kotlin.$_$.ba;
  var sortedWith = kotlin_kotlin.$_$.d9;
  var charSequenceLength = kotlin_kotlin.$_$.hb;
  var emptyList = kotlin_kotlin.$_$.b7;
  var reversed = kotlin_kotlin.$_$.w8;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.u;
  var plus = kotlin_kotlin.$_$.r8;
  var Companion_getInstance_8 = kotlin_com_soywiz_korge_korge_core.$_$.r1;
  var invalidOp = kotlin_com_soywiz_korge_korge_core.$_$.h4;
  var Indenter = kotlin_com_soywiz_korge_korge_core.$_$.p4;
  var joinToString_0 = kotlin_kotlin.$_$.x7;
  var contains = kotlin_kotlin.$_$.ce;
  var toFastList_0 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.d3;
  var nextAlignedTo = kotlin_com_soywiz_korge_korge_foundation.$_$.q7;
  var maxOrNull = kotlin_kotlin.$_$.n8;
  var Iterable = kotlin_kotlin.$_$.h5;
  var toList_0 = kotlin_kotlin.$_$.p9;
  var checkIndexOverflow = kotlin_kotlin.$_$.a6;
  var contentEquals = kotlin_kotlin.$_$.e6;
  var contentHashCode = kotlin_kotlin.$_$.j6;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.x;
  var to = kotlin_kotlin.$_$.yh;
  var plus_0 = kotlin_kotlin.$_$.q8;
  var withIndex = kotlin_kotlin.$_$.aa;
  var get_invalidOp = kotlin_com_soywiz_korge_korge_core.$_$.g4;
  var charSequenceGet = kotlin_kotlin.$_$.gb;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x2;
  var setInt8 = kotlin_com_soywiz_korge_korge_foundation.$_$.za;
  var getInt8 = kotlin_com_soywiz_korge_korge_foundation.$_$.n9;
  var numberToChar = kotlin_kotlin.$_$.oc;
  var toString_1 = kotlin_kotlin.$_$.xh;
  var until = kotlin_kotlin.$_$.pd;
  var toSet = kotlin_kotlin.$_$.w9;
  var split = kotlin_kotlin.$_$.we;
  var setInt32 = kotlin_com_soywiz_korge_korge_foundation.$_$.ya;
  var getInt32 = kotlin_com_soywiz_korge_korge_foundation.$_$.m9;
  var Companion_instance_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.w3;
  var allocDirect = kotlin_com_soywiz_korge_korge_foundation.$_$.j8;
  var CoroutineImpl = kotlin_kotlin.$_$.wa;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.m;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.fa;
  var get_RegisteredImageFormats = kotlin_com_soywiz_korge_korge_core.$_$.w2;
  var Companion_instance_1 = kotlin_com_soywiz_korge_korlibs_time.$_$.g;
  var Injector = kotlin_com_soywiz_korge_korge_foundation.$_$.a4;
  var Colors_getInstance = kotlin_com_soywiz_korge_korge_core.$_$.f1;
  var Companion_getInstance_9 = kotlin_com_soywiz_korge_korge_core.$_$.n1;
  var withContext = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f;
  var Companion_getInstance_10 = kotlin_com_soywiz_korge_korge_foundation.$_$.p3;
  var Companion_getInstance_11 = kotlin_com_soywiz_korge_korge_foundation.$_$.e3;
  var Companion_getInstance_12 = kotlin_com_soywiz_korge_korge_foundation.$_$.t3;
  var Companion_getInstance_13 = kotlin_com_soywiz_korge_korge_foundation.$_$.q3;
  var Size2D = kotlin_com_soywiz_korge_korge_foundation.$_$.v5;
  var coroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d;
  var Vector2D = kotlin_com_soywiz_korge_korge_foundation.$_$.x5;
  var DateTime = kotlin_com_soywiz_korge_korlibs_time.$_$.h;
  var printStackTrace = kotlin_kotlin.$_$.sh;
  var Companion_instance_2 = kotlin_com_soywiz_korge_korlibs_platform.$_$.e;
  var PerformanceCounter_instance = kotlin_com_soywiz_korge_korlibs_time.$_$.f;
  var DurationUnit_MICROSECONDS_getInstance = kotlin_kotlin.$_$.g;
  var toDuration = kotlin_kotlin.$_$.zf;
  var get_resourcesVfs = kotlin_com_soywiz_korge_korge_core.$_$.a4;
  var readBitmap = kotlin_com_soywiz_korge_korge_core.$_$.g;
  var InjectorContext = kotlin_com_soywiz_korge_korge_foundation.$_$.y3;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.t;
  var Companion_instance_3 = kotlin_com_soywiz_korge_korge_core.$_$.o1;
  var Dyn__set_impl_2ozvx8 = kotlin_com_soywiz_korge_korge_core.$_$.d1;
  var getKClass = kotlin_kotlin.$_$.d;
  var get_NIL = kotlin_com_soywiz_korge_korlibs_time.$_$.j;
  var launchImmediately = kotlin_com_soywiz_korge_korge_core.$_$.s3;
  var get_nativeSoundProvider = kotlin_com_soywiz_korge_korge_core.$_$.t1;
  var first = kotlin_kotlin.$_$.k7;
  var Companion_instance_4 = kotlin_com_soywiz_korge_korge_core.$_$.s1;
  var get_workerImpl = kotlin_com_soywiz_korge_korge_core.$_$.s4;
  var get_DEBUG_WORKER = kotlin_com_soywiz_korge_korge_core.$_$.r4;
  var get_localCurrentDirVfs = kotlin_com_soywiz_korge_korge_core.$_$.z3;
  var Resources = kotlin_com_soywiz_korge_korge_core.$_$.n4;
  var CoroutineContext = kotlin_kotlin.$_$.va;
  var TimeProvider = kotlin_com_soywiz_korge_korlibs_time.$_$.k;
  var CompletableDeferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var toMutableList = kotlin_kotlin.$_$.s9;
  var Duration = kotlin_kotlin.$_$.yf;
  var DurationUnit_MILLISECONDS_getInstance = kotlin_kotlin.$_$.h;
  var Duration__times_impl_sfuzvp = kotlin_kotlin.$_$.p2;
  var DurationUnit_SECONDS_getInstance = kotlin_kotlin.$_$.j;
  var Duration__compareTo_impl_pchp0f = kotlin_kotlin.$_$.g2;
  var min_0 = kotlin_com_soywiz_korge_korlibs_time.$_$.t;
  var Duration__plus_impl_yu9v8f = kotlin_kotlin.$_$.n2;
  var get_seconds = kotlin_com_soywiz_korge_korlibs_time.$_$.w;
  var convertRange = kotlin_com_soywiz_korge_korge_foundation.$_$.b7;
  var clamp01 = kotlin_com_soywiz_korge_korge_foundation.$_$.u6;
  var toRatio = kotlin_com_soywiz_korge_korge_foundation.$_$.s6;
  var Duration__minus_impl_q5cfm7 = kotlin_kotlin.$_$.m2;
  var invoke = kotlin_com_soywiz_korge_korge_core.$_$.q3;
  var Signal = kotlin_com_soywiz_korge_korge_core.$_$.p3;
  var TGenDeque_init_$Create$ = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.i;
  var retainAll = kotlin_kotlin.$_$.v8;
  var cancel_0 = kotlin_com_soywiz_korge_korge_core.$_$.f4;
  var Companion_getInstance_14 = kotlin_com_soywiz_korge_korge_foundation.$_$.k3;
  var get_lastIndex_0 = kotlin_kotlin.$_$.le;
  var get_immutable = kotlin_com_soywiz_korge_korge_foundation.$_$.c6;
  var Companion_instance_5 = kotlin_com_soywiz_korge_korge_core.$_$.h1;
  var Companion_instance_6 = kotlin_com_soywiz_korge_korge_core.$_$.g1;
  var Glyph = kotlin_com_soywiz_korge_korge_core.$_$.l2;
  var toIntMap = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.f3;
  var IntMap_init_$Create$ = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.g;
  var numberToDouble = kotlin_kotlin.$_$.pc;
  var BitmapFontImpl = kotlin_com_soywiz_korge_korge_core.$_$.m2;
  var fromBase64 = kotlin_com_soywiz_korge_korlibs_crypto.$_$.b;
  var openAsync = kotlin_com_soywiz_korge_korge_core.$_$.o4;
  var ImageDecodingProps = kotlin_com_soywiz_korge_korge_core.$_$.v2;
  var readBitmap_0 = kotlin_com_soywiz_korge_korge_core.$_$.f;
  var slice = kotlin_com_soywiz_korge_korge_core.$_$.i2;
  var arraycopy_4 = kotlin_com_soywiz_korge_korge_foundation.$_$.y8;
  var get_nanoseconds = kotlin_com_soywiz_korge_korlibs_time.$_$.u;
  var DurationUnit_NANOSECONDS_getInstance = kotlin_kotlin.$_$.i;
  var get_milliseconds = kotlin_com_soywiz_korge_korlibs_time.$_$.r;
  var copyToArray = kotlin_kotlin.$_$.y6;
  var setBits = kotlin_com_soywiz_korge_korge_foundation.$_$.wa;
  var launchImmediately_0 = kotlin_com_soywiz_korge_korge_core.$_$.r3;
  var AsyncSignal = kotlin_com_soywiz_korge_korge_core.$_$.o3;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.vh;
  var Vector2D_init_$Create$_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.v;
  var DateTime__minus_impl_10njw8 = kotlin_com_soywiz_korge_korlibs_time.$_$.b;
  var Pool_init_$Create$ = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.h;
  var valueOf = kotlin_com_soywiz_korge_korlibs_logger.$_$.h;
  var startsWith = kotlin_kotlin.$_$.ye;
  var isBlank = kotlin_kotlin.$_$.je;
  var charArrayOf = kotlin_kotlin.$_$.eb;
  var split_0 = kotlin_kotlin.$_$.ve;
  var get_lastIndex_1 = kotlin_kotlin.$_$.b8;
  var MutableMap = kotlin_kotlin.$_$.p5;
  var Pool = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.n1;
  var contains_0 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.z1;
  var clear = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.y1;
  var get_size_0 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.w2;
  var get_baseMipmapLevel = kotlin_com_soywiz_korge_korge_core.$_$.e2;
  var get_maxMipmapLevel = kotlin_com_soywiz_korge_korge_core.$_$.h2;
  var Companion_instance_7 = kotlin_com_soywiz_korge_korge_foundation.$_$.a3;
  var RectangleI = kotlin_com_soywiz_korge_korge_foundation.$_$.t5;
  var RectSlice = kotlin_com_soywiz_korge_korge_foundation.$_$.h4;
  var FastSmallSet = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.f1;
  var getAndRemove = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.h2;
  var get_keys = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.q2;
  var Uint16Buffer__set_impl_g0kliu = kotlin_com_soywiz_korge_korge_foundation.$_$.w2;
  var Float32Buffer__get_impl_659lhu = kotlin_com_soywiz_korge_korge_foundation.$_$.k2;
  var Float32Buffer__set_impl_34szne = kotlin_com_soywiz_korge_korge_foundation.$_$.l2;
  var get_u16 = kotlin_com_soywiz_korge_korge_foundation.$_$.eb;
  var ReturnablePool = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.q1;
  var setFloat32 = kotlin_com_soywiz_korge_korge_foundation.$_$.xa;
  var toByte = kotlin_kotlin.$_$.wc;
  var _RGBA___get_value__impl__hhco8v = kotlin_com_soywiz_korge_korge_core.$_$.u;
  var asUShortArrayInt = kotlin_com_soywiz_korge_korge_foundation.$_$.e9;
  var arraycopy_5 = kotlin_com_soywiz_korge_korge_foundation.$_$.x8;
  var toShort = kotlin_kotlin.$_$.yc;
  var arrayadd = kotlin_com_soywiz_korge_korge_foundation.$_$.o8;
  var arraycopy_6 = kotlin_com_soywiz_korge_korge_foundation.$_$.t8;
  var arrayfill = kotlin_com_soywiz_korge_korge_foundation.$_$.a9;
  var contains_1 = kotlin_kotlin.$_$.d6;
  var Matrix4_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.m;
  var Command_instance = kotlin_com_soywiz_korge_korge_foundation.$_$.d3;
  var Companion_getInstance_15 = kotlin_com_soywiz_korge_korge_foundation.$_$.u3;
  var Companion_getInstance_16 = kotlin_com_soywiz_korge_korge_foundation.$_$.y2;
  var _Ratio___init__impl__9mwvn2 = kotlin_com_soywiz_korge_korge_foundation.$_$.d2;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.g4;
  var toMatrix4 = kotlin_com_soywiz_korge_korge_foundation.$_$.l6;
  var arrayfill_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.b9;
  var round = kotlin_kotlin.$_$.dd;
  var coerceAtLeast_0 = kotlin_kotlin.$_$.gd;
  var MMatrix = kotlin_com_soywiz_korge_korge_foundation.$_$.n5;
  var SizeInt = kotlin_com_soywiz_korge_korge_foundation.$_$.w5;
  var Companion_instance_8 = kotlin_com_soywiz_korge_korge_foundation.$_$.o3;
  var allocNoDirect = kotlin_com_soywiz_korge_korge_foundation.$_$.k8;
  var MountableVfs = kotlin_com_soywiz_korge_korge_core.$_$.y3;
  var InjectorDependency = kotlin_com_soywiz_korge_korge_foundation.$_$.z3;
  var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q;
  var cancel_1 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x;
  var CancellationException = kotlin_kotlin.$_$.ea;
  var KClass = kotlin_kotlin.$_$.qd;
  var Ratio = kotlin_com_soywiz_korge_korge_foundation.$_$.m6;
  var launchUnscopedAndWait = kotlin_com_soywiz_korge_korge_core.$_$.j;
  var launchUnscoped = kotlin_com_soywiz_korge_korge_core.$_$.t3;
  var launchUnscoped_0 = kotlin_com_soywiz_korge_korge_core.$_$.u3;
  var arrayListOf = kotlin_kotlin.$_$.w5;
  var Ratio__compareTo_impl_z2ienc = kotlin_com_soywiz_korge_korge_foundation.$_$.e2;
  var Ratio__toFloat_impl_1ftup5 = kotlin_com_soywiz_korge_korge_foundation.$_$.h2;
  var KProperty0 = kotlin_kotlin.$_$.td;
  var THROW_ISE = kotlin_kotlin.$_$.sg;
  var getLocalDelegateReference = kotlin_kotlin.$_$.qb;
  var Duration__div_impl_dknbf4 = kotlin_kotlin.$_$.i2;
  var clamp = kotlin_com_soywiz_korge_korge_foundation.$_$.x6;
  var maxOrNull_0 = kotlin_kotlin.$_$.m8;
  var Companion_instance_9 = kotlin_kotlin.$_$.v4;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z2;
  var clamp_0 = kotlin_com_soywiz_korge_korlibs_time.$_$.m;
  var intercepted = kotlin_kotlin.$_$.ha;
  var get_MODE_CANCELLABLE = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i;
  var returnIfSuspended = kotlin_kotlin.$_$.l;
  var Duration__times_impl_sfuzvp_0 = kotlin_kotlin.$_$.o2;
  var withTimeoutNullable = kotlin_com_soywiz_korge_korge_core.$_$.k;
  var TimeoutCancellationException = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u;
  var get_isNil = kotlin_com_soywiz_korge_korlibs_time.$_$.o;
  var Duration__hashCode_impl_u4exz6 = kotlin_kotlin.$_$.j2;
  var interpolate = kotlin_com_soywiz_korge_korge_foundation.$_$.o6;
  var getExtra = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.m2;
  var Size2D_init_$Create$_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.s;
  var RectangleD = kotlin_com_soywiz_korge_korge_foundation.$_$.s5;
  var Bitmaps_instance = kotlin_com_soywiz_korge_korge_core.$_$.e1;
  var get_Bitmaps_transparent = kotlin_com_soywiz_korge_korge_core.$_$.w1;
  var get_bmp = kotlin_com_soywiz_korge_korge_core.$_$.f2;
  var MatrixTransform_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.n;
  var toIntCeil = kotlin_com_soywiz_korge_korge_foundation.$_$.w7;
  var NativeImageOrBitmap32 = kotlin_com_soywiz_korge_korge_core.$_$.b2;
  var get_indices = kotlin_kotlin.$_$.u7;
  var anyToString = kotlin_kotlin.$_$.bb;
  var Ref_0 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.p1;
  var Scale_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.p;
  var get_isLow = kotlin_com_soywiz_korge_korge_core.$_$.n3;
  var getOrNull_0 = kotlin_kotlin.$_$.p7;
  var sortWith = kotlin_kotlin.$_$.c9;
  var Companion_getInstance_17 = kotlin_com_soywiz_korge_korge_foundation.$_$.g3;
  var BoundsBuilder__plus_impl_cz7f7x_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.w1;
  var _BoundsBuilder___get_bounds__impl__s1l1gx = kotlin_com_soywiz_korge_korge_foundation.$_$.q1;
  var clamp_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.y6;
  var FastArrayList_init_$Create$_0 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.b;
  var Collection = kotlin_kotlin.$_$.e5;
  var MutableIterable = kotlin_kotlin.$_$.n5;
  var List = kotlin_kotlin.$_$.k5;
  var firstOrNull = kotlin_kotlin.$_$.i7;
  var VectorPath = kotlin_com_soywiz_korge_korge_foundation.$_$.z4;
  var Companion_getInstance_18 = kotlin_com_soywiz_korge_korge_foundation.$_$.m3;
  var RectCorners = kotlin_com_soywiz_korge_korge_foundation.$_$.r5;
  var get_niceStr_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.fb;
  var IntDeque = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.m1;
  var get_microsecondsInt = kotlin_com_soywiz_korge_korlibs_time.$_$.q;
  var roundDecimalPlaces = kotlin_com_soywiz_korge_korge_foundation.$_$.v7;
  var convertRange_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.d7;
  var coerceAtMost = kotlin_kotlin.$_$.id;
  var Duration__div_impl_dknbf4_0 = kotlin_kotlin.$_$.h2;
  var toFrequency = kotlin_com_soywiz_korge_korlibs_time.$_$.x;
  var _Frequency___get_hertz__impl__9m7k6x = kotlin_com_soywiz_korge_korlibs_time.$_$.c;
  var ShapeBuilder = kotlin_com_soywiz_korge_korge_core.$_$.l3;
  var EmptyShape_instance = kotlin_com_soywiz_korge_korge_core.$_$.m1;
  var Resourceable = kotlin_com_soywiz_korge_korge_core.$_$.m4;
  var readBitmapSlice = kotlin_com_soywiz_korge_korge_core.$_$.e;
  var get_Bitmaps_white = kotlin_com_soywiz_korge_korge_core.$_$.x1;
  var Companion_getInstance_19 = kotlin_com_soywiz_korge_korge_foundation.$_$.i3;
  var convertRange_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.c7;
  var HorizontalAlign__getOffsetX_impl_urzzxf = kotlin_com_soywiz_korge_korge_core.$_$.a1;
  var VerticalAlign__getOffsetY_impl_iso0y6 = kotlin_com_soywiz_korge_korge_core.$_$.b1;
  var readFont = kotlin_com_soywiz_korge_korge_core.$_$.d;
  var get_DefaultTtfFontAsBitmap = kotlin_com_soywiz_korge_korge_core.$_$.o2;
  var Companion_getInstance_20 = kotlin_com_soywiz_korge_korge_core.$_$.j1;
  var get_DefaultStringTextRenderer = kotlin_com_soywiz_korge_korge_core.$_$.c3;
  var Text2TextRendererActions = kotlin_com_soywiz_korge_korge_core.$_$.f3;
  var Entry = kotlin_com_soywiz_korge_korge_core.$_$.d3;
  var FontMetrics = kotlin_com_soywiz_korge_korge_core.$_$.p2;
  var TextMetrics = kotlin_com_soywiz_korge_korge_core.$_$.s2;
  var BitmapFont = kotlin_com_soywiz_korge_korge_core.$_$.n2;
  var Font = kotlin_com_soywiz_korge_korge_core.$_$.q2;
  var getTextBounds = kotlin_com_soywiz_korge_korge_core.$_$.t2;
  var TextMetricsResult = kotlin_com_soywiz_korge_korge_core.$_$.r2;
  var invoke_0 = kotlin_com_soywiz_korge_korge_core.$_$.g3;
  var LineInfo = kotlin_com_soywiz_korge_korge_core.$_$.e3;
  var _VerticalAlign___get_ratioFake__impl__1h2fwv = kotlin_com_soywiz_korge_korge_core.$_$.c1;
  var Companion_getInstance_21 = kotlin_com_soywiz_korge_korge_core.$_$.k1;
  var Anchor2D = kotlin_com_soywiz_korge_korge_foundation.$_$.h5;
  var Scale = kotlin_com_soywiz_korge_korge_foundation.$_$.u5;
  var Companion_getInstance_22 = kotlin_com_soywiz_korge_korge_foundation.$_$.f3;
  var ColorTransformMul = kotlin_com_soywiz_korge_korge_core.$_$.j2;
  var interpolate_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.n6;
  var _Angle___get_degrees__impl__qg56vw = kotlin_com_soywiz_korge_korge_foundation.$_$.i1;
  var _Angle___get_absoluteValue__impl__4qoakv = kotlin_com_soywiz_korge_korge_foundation.$_$.g1;
  var niceStr = kotlin_com_soywiz_korge_korge_foundation.$_$.ib;
  var _RGBA___get_hexString__impl__kocngm = kotlin_com_soywiz_korge_korge_core.$_$.q;
  var _RGBA___get_rgb__impl__tijaqt = kotlin_com_soywiz_korge_korge_core.$_$.t;
  var toStringDecimal = kotlin_com_soywiz_korge_korge_core.$_$.q4;
  var HitTestDirection_ANY_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.b;
  var _Frequency___get_timeSpan__impl__f9mrmt = kotlin_com_soywiz_korge_korlibs_time.$_$.d;
  var StandardPaths_instance = kotlin_com_soywiz_korge_korge_core.$_$.p1;
  var SizeInt_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.t;
  var toFloat = kotlin_com_soywiz_korge_korge_foundation.$_$.h6;
  var toRef = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.h3;
  var toInt = kotlin_com_soywiz_korge_korge_foundation.$_$.k6;
  var injector = kotlin_com_soywiz_korge_korge_foundation.$_$.j;
  var Direction_FORWARD_getInstance = kotlin_com_soywiz_korge_korge_core.$_$.a;
  var getCyclicOrNull = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.i2;
  var Companion_instance_10 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.s;
  var Companion_getInstance_23 = kotlin_com_soywiz_korge_korge_core.$_$.l1;
  var Companion_instance_11 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.r;
  var isIntArray = kotlin_kotlin.$_$.fc;
  var IntArray2 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.k1;
  var umod = kotlin_com_soywiz_korge_korge_foundation.$_$.e8;
  var Direction_ONCE_REVERSE_getInstance = kotlin_com_soywiz_korge_korge_core.$_$.b;
  var Direction_REVERSE_getInstance = kotlin_com_soywiz_korge_korge_core.$_$.c;
  var Map = kotlin_kotlin.$_$.m5;
  var FastArrayList_init_$Create$_1 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.d;
  var FastArrayList = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.b1;
  var MarginInt = kotlin_com_soywiz_korge_korge_foundation.$_$.o5;
  var hasExtra = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.o2;
  var get_lastIndex_2 = kotlin_kotlin.$_$.z7;
  var Companion_getInstance_24 = kotlin_com_soywiz_korge_korge_foundation.$_$.j3;
  var Property = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.a1;
  var clamp_2 = kotlin_com_soywiz_korge_korge_foundation.$_$.z6;
  var removeAll = kotlin_kotlin.$_$.s8;
  var min_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.n7;
  var max_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.k7;
  var get_endY = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.c2;
  var get_endX = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.b2;
  var get_nextPowerOfTwo = kotlin_com_soywiz_korge_korge_foundation.$_$.s7;
  var toStacked = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.i3;
  var StackedIntArray2 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.u1;
  var FastIdentityCacheMap = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.c1;
  var PolylineShape = kotlin_com_soywiz_korge_korge_core.$_$.k3;
  var FillShape = kotlin_com_soywiz_korge_korge_core.$_$.j3;
  var TextShape = kotlin_com_soywiz_korge_korge_core.$_$.m3;
  var CompoundShape = kotlin_com_soywiz_korge_korge_core.$_$.i3;
  var toCurvesList = kotlin_com_soywiz_korge_korge_foundation.$_$.f5;
  var StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.a;
  var toStrokePointsList = kotlin_com_soywiz_korge_korge_foundation.$_$.d4;
  var BoundsBuilder__plus_impl_cz7f7x_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.v1;
  var _BoundsBuilder___get_xmax__impl__gsz0km = kotlin_com_soywiz_korge_korge_foundation.$_$.x1;
  var _BoundsBuilder___get_xmin__impl__o2sib0 = kotlin_com_soywiz_korge_korge_foundation.$_$.y1;
  var _BoundsBuilder___get_ymax__impl__oia4uz = kotlin_com_soywiz_korge_korge_foundation.$_$.a2;
  var _BoundsBuilder___get_ymin__impl__5n2e8j = kotlin_com_soywiz_korge_korge_foundation.$_$.b2;
  var get_cachedPoints = kotlin_com_soywiz_korge_korge_foundation.$_$.f4;
  var getPoints2List = kotlin_com_soywiz_korge_korge_foundation.$_$.g4;
  var MarginInt_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.l;
  var Winding_NON_ZERO_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.h;
  var LineScaleMode_NONE_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.e;
  var LineCap_BUTT_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.c;
  var LineJoin_MITER_getInstance = kotlin_com_soywiz_korge_korge_foundation.$_$.d;
  var StrokeInfo = kotlin_com_soywiz_korge_korge_foundation.$_$.m4;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.k4;
  var floatArrayListOf = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.f2;
  var _Float32Buffer___init__impl__403k2m = kotlin_com_soywiz_korge_korge_foundation.$_$.i2;
  var _Float32Buffer___get_buffer__impl__x5nu9x = kotlin_com_soywiz_korge_korge_foundation.$_$.j2;
  var _RGBA___get_premultiplied__impl__3bulqc = kotlin_com_soywiz_korge_korge_core.$_$.r;
  var get_PI = kotlin_kotlin.$_$.ad;
  var Bitmap32 = kotlin_com_soywiz_korge_korge_core.$_$.u1;
  var _RgbaPremultipliedArray___init__impl__lx83hy = kotlin_com_soywiz_korge_korge_core.$_$.z;
  var Vector4F = kotlin_com_soywiz_korge_korge_foundation.$_$.z5;
  var GradientPaint = kotlin_com_soywiz_korge_korge_core.$_$.a3;
  var BitmapPaint = kotlin_com_soywiz_korge_korge_core.$_$.z2;
  var NonePaint = kotlin_com_soywiz_korge_korge_core.$_$.b3;
  var get_degrees = kotlin_com_soywiz_korge_korge_foundation.$_$.b6;
  var Angle__times_impl_v3s9y2 = kotlin_com_soywiz_korge_korge_foundation.$_$.o1;
  var Angle = kotlin_com_soywiz_korge_korge_foundation.$_$.j5;
  var mapOf = kotlin_kotlin.$_$.l8;
  var ObservableProperty = kotlin_kotlin.$_$.ed;
  var delay = kotlin_com_soywiz_korge_korge_core.$_$.i;
  var IntTimedCache = kotlin_com_soywiz_korge_korlibs_time.$_$.i;
  var Delegates_instance = kotlin_kotlin.$_$.o4;
  var cancelChildren = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var max_1 = kotlin_com_soywiz_korge_korlibs_time.$_$.p;
  var get_0 = kotlin_kotlin.$_$.ra;
  var fold = kotlin_kotlin.$_$.qa;
  var minusKey = kotlin_kotlin.$_$.sa;
  var plus_1 = kotlin_kotlin.$_$.ua;
  var Element = kotlin_kotlin.$_$.ta;
  var CoroutineDispatcher = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k;
  var TGenQueue = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.v1;
  var Companion_instance_12 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.t;
  var NonRecursiveLock = kotlin_com_soywiz_korge_korlibs_concurrent.$_$.b;
  var createFailure = kotlin_kotlin.$_$.hh;
  var Level_WARN_getInstance = kotlin_com_soywiz_korge_korlibs_logger.$_$.e;
  var roundMilliseconds = kotlin_com_soywiz_korge_korlibs_time.$_$.v;
  var Delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p;
  var SyncEventLoop = kotlin_com_soywiz_korge_korge_foundation.$_$.x3;
  var toDuration_0 = kotlin_kotlin.$_$.ag;
  var toDisposable = kotlin_com_soywiz_korge_korge_core.$_$.j4;
  var toSet_0 = kotlin_kotlin.$_$.x9;
  var reversed_0 = kotlin_kotlin.$_$.md;
  var toMutableList_0 = kotlin_kotlin.$_$.t9;
  var get_arrayUByte = kotlin_com_soywiz_korge_korge_foundation.$_$.n8;
  var get_arrayInt = kotlin_com_soywiz_korge_korge_foundation.$_$.m8;
  var get_arrayFloat = kotlin_com_soywiz_korge_korge_foundation.$_$.l8;
  var HtmlNativeImage = kotlin_com_soywiz_korge_korge_core.$_$.u2;
  var removeSuffix = kotlin_kotlin.$_$.qe;
  var cancelAndJoin = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c;
  var toVfs = kotlin_com_soywiz_korge_korge_core.$_$.b4;
  var isInfinite = kotlin_kotlin.$_$.mh;
  var isNaN_0 = kotlin_kotlin.$_$.nh;
  var toHtmlNative = kotlin_com_soywiz_korge_korge_core.$_$.x2;
  var MainScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Listener, 'Listener', classMeta, VOID, [CloseableCancellable]);
  setMetadataFor(ListenerNode, 'ListenerNode', classMeta);
  function onEvents(etypes, handler) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (etypes.length === 0) {
      // Inline function 'kotlin.error' call
      var message = 'Must have at least one event type';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var closeable = new CancellableGroup();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < etypes.length) {
      // Inline function 'korlibs.event.EventListener.onEvents.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = etypes[tmp0];
      closeable.z6g(this.h7m(it, handler));
    }
    return closeable;
  }
  function dispatch(type, event, result) {
    return this.j7m(type, event, result, true, true);
  }
  function dispatch$default(type, event, result, $super) {
    result = result === VOID ? null : result;
    return $super === VOID ? this.q7m(type, event, result) : dispatch(type, event, result);
  }
  function dispatchDown(type, event, result) {
    return this.j7m(type, event, result, false, true);
  }
  function dispatchUp(type, event, result) {
    return this.j7m(type, event, result, true, false);
  }
  function dispatch_0(event) {
    // Inline function 'korlibs.datastructure.fastCastTo' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.r7m(event.u2f(), event);
  }
  setMetadataFor(EventListener, 'EventListener', interfaceMeta);
  setMetadataFor(BaseEventListener, 'BaseEventListener', classMeta, VOID, [EventListener], BaseEventListener);
  setMetadataFor(EventResult, 'EventResult', classMeta, VOID, VOID, EventResult);
  setMetadataFor(Event, 'Event', classMeta);
  setMetadataFor(TypedEvent, 'TypedEvent', classMeta, Event);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(Type, 'Type', classMeta, Enum);
  setMetadataFor(GestureEvent, 'GestureEvent', classMeta, Event, VOID, GestureEvent);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(Type_0, 'Type', classMeta, Enum);
  setMetadataFor(KeyEvent, 'KeyEvent', classMeta, Event, VOID, KeyEvent);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(Type_1, 'Type', classMeta, Enum);
  setMetadataFor(ScrollDeltaMode, 'ScrollDeltaMode', classMeta, Enum);
  setMetadataFor(MouseEvent, 'MouseEvent', classMeta, Event, VOID, MouseEvent);
  setMetadataFor(Status, 'Status', classMeta, Enum);
  setMetadataFor(Kind, 'Kind', classMeta, Enum);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(Touch, 'Touch', classMeta, VOID, VOID, Touch);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(Type_2, 'Type', classMeta, Enum);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor(TouchEvent, 'TouchEvent', classMeta, Event, VOID, TouchEvent);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor(ReshapeEvent, 'ReshapeEvent', classMeta, TypedEvent, VOID, ReshapeEvent);
  setMetadataFor(StopPropagatingException, 'StopPropagatingException', classMeta, Exception);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(PauseEvent, 'PauseEvent', classMeta, TypedEvent, VOID, PauseEvent);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(ResumeEvent, 'ResumeEvent', classMeta, TypedEvent, VOID, ResumeEvent);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor(StopEvent, 'StopEvent', classMeta, TypedEvent, VOID, StopEvent);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor(DestroyEvent, 'DestroyEvent', classMeta, TypedEvent, VOID, DestroyEvent);
  setMetadataFor(RenderEvent, 'RenderEvent', classMeta, TypedEvent, VOID, RenderEvent);
  setMetadataFor(Companion_10, 'Companion', objectMeta, RenderEvent);
  setMetadataFor(InitEvent, 'InitEvent', classMeta, TypedEvent, VOID, InitEvent);
  setMetadataFor(Companion_11, 'Companion', objectMeta, InitEvent);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor(DisposeEvent, 'DisposeEvent', classMeta, TypedEvent, VOID, DisposeEvent);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor(FullScreenEvent, 'FullScreenEvent', classMeta, TypedEvent, VOID, FullScreenEvent);
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor(Type_3, 'Type', classMeta, Enum);
  setMetadataFor(DropFileEvent, 'DropFileEvent', classMeta, Event, VOID, DropFileEvent);
  setMetadataFor(Mode, 'Mode', classMeta, Enum);
  setMetadataFor(TouchBuilder, 'TouchBuilder', classMeta, VOID, VOID, TouchBuilder);
  setMetadataFor(Companion_15, 'Companion', objectMeta);
  setMetadataFor(GamePadUpdateEvent, 'GamePadUpdateEvent', classMeta, Event, VOID, GamePadUpdateEvent);
  setMetadataFor(BatteryStatus, 'BatteryStatus', classMeta, Enum);
  setMetadataFor(Companion_16, 'Companion', objectMeta);
  setMetadataFor(GamepadInfo, 'GamepadInfo', classMeta, VOID, VOID, GamepadInfo);
  setMetadataFor(Companion_17, 'Companion', objectMeta);
  setMetadataFor(Type_4, 'Type', classMeta, Enum);
  setMetadataFor(GamePadConnectionEvent, 'GamePadConnectionEvent', classMeta, Event, VOID, GamePadConnectionEvent);
  setMetadataFor(Companion_18, 'Companion', objectMeta);
  setMetadataFor(GameStick, 'GameStick', classMeta, Enum);
  setMetadataFor(Companion_19, 'Companion', objectMeta);
  setMetadataFor(GameButton, 'GameButton', classMeta, Enum);
  setMetadataFor(GamepadInfoEmitter, 'GamepadInfoEmitter', classMeta);
  setMetadataFor(Companion_20, 'Companion', objectMeta);
  setMetadataFor(Key, 'Key', classMeta, Enum);
  setMetadataFor(Companion_21, 'Companion', objectMeta);
  setMetadataFor(MouseButton, 'MouseButton', classMeta, Enum);
  setMetadataFor(Companion_22, 'Companion', objectMeta);
  function get_parentFeatures() {
    return null;
  }
  function get_isUniformBuffersSupported() {
    var tmp0_safe_receiver = this.v7u();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w7u();
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  function get_isVertexArraysSupported() {
    var tmp0_safe_receiver = this.v7u();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x7u();
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  setMetadataFor(AGFeatures, 'AGFeatures', interfaceMeta);
  setMetadataFor(AG, 'AG', classMeta, VOID, [AGFeatures]);
  setMetadataFor(Immutable, 'Immutable', classMeta, VOID, [AGFeatures], Immutable);
  setMetadataFor(AGObject, 'AGObject', classMeta, VOID, [Closeable], AGObject);
  setMetadataFor(AGBuffer, 'AGBuffer', classMeta, AGObject, VOID, AGBuffer);
  setMetadataFor(Companion_23, 'Companion', objectMeta);
  setMetadataFor(AGTextureUnits, 'AGTextureUnits', classMeta, VOID, VOID, AGTextureUnits_init_$Create$);
  setMetadataFor(Companion_24, 'Companion', objectMeta);
  setMetadataFor(AGFrameBuffer, 'AGFrameBuffer', classMeta, VOID, [Closeable], AGFrameBuffer_init_$Create$);
  setMetadataFor(AGTexture, 'AGTexture', classMeta, AGObject, [AGObject, Closeable], AGTexture);
  setMetadataFor(Companion_25, 'Companion', objectMeta);
  setMetadataFor(AGTextureUnitInfo, 'AGTextureUnitInfo', classMeta);
  setMetadataFor(AGFrameBufferBase, 'AGFrameBufferBase', classMeta, AGObject);
  setMetadataFor(AGTextureUnitInfoArray, 'AGTextureUnitInfoArray', classMeta);
  setMetadataFor(AGNativeObject, 'AGNativeObject', interfaceMeta);
  setMetadataFor(BufferCache, 'BufferCache', classMeta, VOID, VOID, BufferCache);
  setMetadataFor(AGProgramWithUniforms, 'AGProgramWithUniforms', classMeta);
  setMetadataFor(AGVertexArrayObject, 'AGVertexArrayObject', classMeta);
  setMetadataFor(AGVertexData, 'AGVertexData', classMeta, VOID, VOID, AGVertexData);
  setMetadataFor(Companion_26, 'Companion', objectMeta);
  setMetadataFor(AGDrawType, 'AGDrawType', classMeta);
  setMetadataFor(Companion_27, 'Companion', objectMeta);
  setMetadataFor(AGIndexType, 'AGIndexType', classMeta);
  setMetadataFor(Companion_28, 'Companion', objectMeta);
  setMetadataFor(AGBlending, 'AGBlending', classMeta);
  setMetadataFor(Companion_29, 'Companion', objectMeta);
  setMetadataFor(AGStencilReference, 'AGStencilReference', classMeta);
  setMetadataFor(Companion_30, 'Companion', objectMeta);
  setMetadataFor(AGStencilOpFunc, 'AGStencilOpFunc', classMeta);
  setMetadataFor(Companion_31, 'Companion', objectMeta);
  setMetadataFor(AGColorMask, 'AGColorMask', classMeta);
  setMetadataFor(Companion_32, 'Companion', objectMeta);
  setMetadataFor(AGScissor, 'AGScissor', classMeta);
  setMetadataFor(AGBatch, 'AGBatch', classMeta);
  setMetadataFor(Companion_33, 'Companion', objectMeta);
  setMetadataFor(AGFrameBufferInfo, 'AGFrameBufferInfo', classMeta);
  setMetadataFor(AGMultiBatch, 'AGMultiBatch', classMeta);
  setMetadataFor(Companion_34, 'Companion', objectMeta);
  setMetadataFor(AGBlendFactor, 'AGBlendFactor', classMeta);
  setMetadataFor(Companion_35, 'Companion', objectMeta);
  setMetadataFor(AGBlendEquation, 'AGBlendEquation', classMeta);
  setMetadataFor(AGFinish, 'AGFinish', objectMeta);
  setMetadataFor(AGClear, 'AGClear', classMeta);
  setMetadataFor(Companion_36, 'Companion', objectMeta);
  setMetadataFor(AGDepthAndFrontFace, 'AGDepthAndFrontFace', classMeta);
  setMetadataFor(Companion_37, 'Companion', objectMeta);
  setMetadataFor(AGCullFace, 'AGCullFace', classMeta);
  setMetadataFor(Companion_38, 'Companion', objectMeta);
  setMetadataFor(AGTextureTargetKind, 'AGTextureTargetKind', classMeta);
  setMetadataFor(Companion_39, 'Companion', objectMeta);
  setMetadataFor(AGWrapMode, 'AGWrapMode', classMeta);
  setMetadataFor(Companion_40, 'Companion', objectMeta);
  setMetadataFor(AGStencilOp, 'AGStencilOp', classMeta);
  setMetadataFor(Companion_41, 'Companion', objectMeta);
  setMetadataFor(AGCompareMode, 'AGCompareMode', classMeta);
  setMetadataFor(Companion_42, 'Companion', objectMeta);
  setMetadataFor(Companion_43, 'Companion', objectMeta);
  setMetadataFor(AGConfig, 'AGConfig', classMeta, VOID, VOID, AGConfig);
  setMetadataFor(AGBufferKind, 'AGBufferKind', classMeta, Enum);
  setMetadataFor(AGStats, 'AGStats', classMeta, VOID, VOID, AGStats);
  setMetadataFor(UniformBlock, 'UniformBlock', classMeta);
  setMetadataFor(ProjViewUB, 'ProjViewUB', objectMeta, UniformBlock);
  setMetadataFor(DefaultShaders, 'DefaultShaders', objectMeta);
  function get_Float1() {
    return VarType_Float1_getInstance();
  }
  function get_Float2() {
    return VarType_Float2_getInstance();
  }
  function get_Float4() {
    return VarType_Float4_getInstance();
  }
  setMetadataFor(VarTypeAccessor, 'VarTypeAccessor', interfaceMeta);
  function get_out() {
    return Output_getInstance();
  }
  function atan(y, x) {
    return Func_init_$Create$('atan', [y, x]);
  }
  function texture2D(sampler, coord) {
    return Func_init_$Create$('texture2D', [sampler, coord], VarType_Float4_getInstance());
  }
  function TERNARY(cond, otrue, ofalse) {
    return new Ternary(cond, otrue, ofalse);
  }
  function pow(b, e) {
    return Func_init_$Create$('pow', [b, e]);
  }
  function sqrt(v) {
    return Func_init_$Create$('sqrt', [v]);
  }
  function abs(v) {
    return Func_init_$Create$('abs', [v]);
  }
  function fract(v) {
    return Func_init_$Create$('fract', [v]);
  }
  function clamp_3(v, min, max) {
    return Func_init_$Create$('clamp', [v, min, max]);
  }
  function min_2(a, b) {
    return Func_init_$Create$('min', [a, b]);
  }
  function max_2(a, b) {
    return Func_init_$Create$('max', [a, b]);
  }
  function fwidth(a) {
    return Func_init_$Create$('fwidth', [a]);
  }
  function mix(a, b, step) {
    return Func_init_$Create$('mix', [a, b, step]);
  }
  function smoothstep(a, b, c) {
    return Func_init_$Create$('smoothstep', [a, b, c]);
  }
  function length(a) {
    return Func_init_$Create$('length', [a]);
  }
  function get_lit(_this__u8e3s4) {
    return new FloatLiteral(_this__u8e3s4);
  }
  function vec2(ops) {
    return new Vector(VarType_Float2_getInstance(), ops);
  }
  function vec4(ops) {
    return new Vector(VarType_Float4_getInstance(), ops);
  }
  function vec2_0(ops) {
    var tmp = VarType_Float2_getInstance();
    var tmp_0 = 0;
    var tmp_1 = ops.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = this.e8a(ops[tmp_3]);
      tmp_0 = tmp_0 + 1 | 0;
    }
    return new Vector(tmp, tmp_2);
  }
  function get_1(_this__u8e3s4, swizzle) {
    return new Swizzle(_this__u8e3s4, swizzle);
  }
  function get_x(_this__u8e3s4) {
    return this.h8a(_this__u8e3s4, 'x');
  }
  function get_y(_this__u8e3s4) {
    return this.h8a(_this__u8e3s4, 'y');
  }
  function get_z(_this__u8e3s4) {
    return this.h8a(_this__u8e3s4, 'z');
  }
  function get_w(_this__u8e3s4) {
    return this.h8a(_this__u8e3s4, 'w');
  }
  function get_a(_this__u8e3s4) {
    return this.h8a(_this__u8e3s4, 'w');
  }
  function unaryMinus(_this__u8e3s4) {
    return new Unop('-', _this__u8e3s4);
  }
  function minus(_this__u8e3s4, that) {
    return new Binop(_this__u8e3s4, '-', that);
  }
  function plus_2(_this__u8e3s4, that) {
    return new Binop(_this__u8e3s4, '+', that);
  }
  function times(_this__u8e3s4, that) {
    return new Binop(_this__u8e3s4, '*', that);
  }
  function div(_this__u8e3s4, that) {
    return new Binop(_this__u8e3s4, '/', that);
  }
  function eq(_this__u8e3s4, that) {
    return new Binop(_this__u8e3s4, '==', that);
  }
  function lt(_this__u8e3s4, that) {
    return new Binop(_this__u8e3s4, '<', that);
  }
  function le(_this__u8e3s4, that) {
    return new Binop(_this__u8e3s4, '<=', that);
  }
  function gt(_this__u8e3s4, that) {
    return new Binop(_this__u8e3s4, '>', that);
  }
  function minus_0(_this__u8e3s4, that) {
    return this.w8b(this.e8a(_this__u8e3s4), that);
  }
  function plus_3(_this__u8e3s4, that) {
    return this.x8b(this.e8a(_this__u8e3s4), that);
  }
  function times_0(_this__u8e3s4, that) {
    return this.c8a(this.e8a(_this__u8e3s4), that);
  }
  function plus_4(_this__u8e3s4, that) {
    return this.x8b(_this__u8e3s4, this.e8a(that));
  }
  function gt_0(_this__u8e3s4, that) {
    return this.b8c(_this__u8e3s4, this.e8a(that));
  }
  setMetadataFor(ExpressionBuilder, 'ExpressionBuilder', interfaceMeta);
  setMetadataFor(Builder, 'Builder', classMeta, VOID, [VarTypeAccessor, ExpressionBuilder], Builder);
  function get_u_Tex() {
    return DefaultShaders_getInstance().i8a();
  }
  function get_u_ProjMat() {
    return DefaultShaders_getInstance().d89();
  }
  function get_u_ViewMat() {
    return DefaultShaders_getInstance().e89();
  }
  function get_a_Pos() {
    return DefaultShaders_getInstance().l86_1;
  }
  function get_a_Tex() {
    return DefaultShaders_getInstance().m86_1;
  }
  function get_a_Col() {
    return DefaultShaders_getInstance().n86_1;
  }
  function get_v_Tex() {
    return DefaultShaders_getInstance().o86_1;
  }
  function get_v_Col() {
    return DefaultShaders_getInstance().p86_1;
  }
  function get_t_Temp0() {
    return DefaultShaders_getInstance().q86_1;
  }
  function get_t_Temp1() {
    return DefaultShaders_getInstance().r86_1;
  }
  setMetadataFor(IDefaultShaders, 'IDefaultShaders', interfaceMeta);
  setMetadataFor(ProgramBuilderDefault, 'ProgramBuilderDefault', classMeta, Builder, [Builder, IDefaultShaders], ProgramBuilderDefault);
  setMetadataFor(ShaderIndices, 'ShaderIndices', objectMeta);
  setMetadataFor(GLVAO, 'GLVAO', classMeta);
  setMetadataFor(ShaderException, 'ShaderException', classMeta, RuntimeException);
  setMetadataFor(TextureUnitParams, 'TextureUnitParams', classMeta);
  setMetadataFor(AGOpengl, 'AGOpengl', classMeta, AG);
  setMetadataFor(GLGlobalState, 'GLGlobalState', classMeta);
  setMetadataFor(GLBaseObject, 'GLBaseObject', classMeta, VOID, [AGNativeObject]);
  setMetadataFor(GLBaseProgram, 'GLBaseProgram', classMeta, GLBaseObject);
  setMetadataFor(GLBuffer, 'GLBuffer', classMeta, GLBaseObject);
  setMetadataFor(GLTexture, 'GLTexture', classMeta, GLBaseObject);
  setMetadataFor(GLFrameBuffer, 'GLFrameBuffer', classMeta, GLBaseObject);
  setMetadataFor(GLProgramInfo, 'GLProgramInfo', classMeta);
  setMetadataFor(GLShaderCompiler, 'GLShaderCompiler', objectMeta);
  setMetadataFor(AGDummy, 'AGDummy', classMeta, AG, VOID, AGDummy);
  setMetadataFor(AGBaseLog, 'AGBaseLog', classMeta, AGDummy, VOID, AGBaseLog);
  setMetadataFor(AGPrint, 'AGPrint', classMeta, AGBaseLog, VOID, AGPrint);
  setMetadataFor(Kind_0, 'Kind', classMeta, Enum);
  setMetadataFor(Companion_44, 'Companion', objectMeta);
  setMetadataFor(UniformBlocksBuffersRef, 'UniformBlocksBuffersRef', classMeta);
  setMetadataFor(Gen, 'Gen', classMeta);
  setMetadataFor(Operand, 'Operand', classMeta);
  setMetadataFor(OperandWithArray, 'OperandWithArray', classMeta, Operand);
  setMetadataFor(Variable, 'Variable', classMeta, OperandWithArray);
  setMetadataFor(VariableWithOffset, 'VariableWithOffset', classMeta, Variable);
  setMetadataFor(TypedUniform, 'TypedUniform', classMeta, VariableWithOffset);
  setMetadataFor(Companion_45, 'Companion', objectMeta);
  setMetadataFor(UniformBlockBuffer, 'UniformBlockBuffer', classMeta);
  setMetadataFor(UBLayoutBuilder, 'UBLayoutBuilder', classMeta, VOID, VOID, UBLayoutBuilder);
  setMetadataFor(UniformsRef, 'UniformsRef', classMeta);
  setMetadataFor(Companion_46, 'Companion', objectMeta);
  setMetadataFor(GLVariant, 'GLVariant', classMeta);
  setMetadataFor(Visitor, 'Visitor', classMeta);
  setMetadataFor(GlobalsProgramVisitor, 'GlobalsProgramVisitor', classMeta, Visitor, VOID, GlobalsProgramVisitor);
  setMetadataFor(Companion_47, 'Companion', objectMeta);
  setMetadataFor(Result, 'Result', classMeta);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  function precToString(prec) {
    var tmp;
    if (!_GLVariant___get_isES__impl__yezzg8(this.y8s().t8f_1)) {
      tmp = '';
    } else {
      var tmp_0;
      switch (prec.ka_1) {
        case 0:
          tmp_0 = '';
          break;
        case 1:
          tmp_0 = 'lowp ';
          break;
        case 2:
          tmp_0 = 'mediump ';
          break;
        case 3:
          tmp_0 = 'highp ';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function typeToString(type) {
    var tmp;
    switch (type.ka_1) {
      case 0:
        tmp = 'void';
        break;
      case 21:
        tmp = 'vec4';
        break;
      case 1:
        tmp = 'mat2';
        break;
      case 2:
        tmp = 'mat3';
        break;
      case 3:
        tmp = 'mat4';
        break;
      case 4:
        tmp = 'sampler1D';
        break;
      case 5:
        tmp = 'sampler2D';
        break;
      case 6:
        tmp = 'sampler3D';
        break;
      case 7:
        tmp = 'samplerCube';
        break;
      default:
        var tmp_0;
        switch (type.h8h_1.ka_1) {
          case 0:
            var tmp_1;
            switch (type.i8h_1) {
              case 1:
                tmp_1 = 'bool';
                break;
              case 2:
                tmp_1 = 'bvec2';
                break;
              case 3:
                tmp_1 = 'bvec3';
                break;
              case 4:
                tmp_1 = 'bvec4';
                break;
              default:
                errorType(this, type);
                break;
            }

            tmp_0 = tmp_1;
            break;
          case 1:
          case 2:
          case 3:
          case 4:
          case 6:
            var tmp_2;
            switch (type.i8h_1) {
              case 1:
                tmp_2 = 'float';
                break;
              case 2:
                tmp_2 = 'vec2';
                break;
              case 3:
                tmp_2 = 'vec3';
                break;
              case 4:
                tmp_2 = 'vec4';
                break;
              default:
                errorType(this, type);
                break;
            }

            tmp_0 = tmp_2;
            break;
          case 5:
            var tmp_3;
            switch (type.i8h_1) {
              case 1:
                tmp_3 = 'int';
                break;
              case 2:
                tmp_3 = 'ivec2';
                break;
              case 3:
                tmp_3 = 'ivec3';
                break;
              case 4:
                tmp_3 = 'ivec4';
                break;
              default:
                errorType(this, type);
                break;
            }

            tmp_0 = tmp_3;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  }
  function get_arrayDecl(_this__u8e3s4) {
    return !(_this__u8e3s4.a8h_1 === 1) ? '[' + _this__u8e3s4.a8h_1 + ']' : '';
  }
  function get_IN() {
    return this.y8s().h8s();
  }
  function get_OUT() {
    return this.y8s().m8s();
  }
  function get_UNIFORM() {
    return this.y8s().l8s();
  }
  setMetadataFor(BaseGlslGenerator, 'BaseGlslGenerator', interfaceMeta);
  setMetadataFor(GlslGenerator, 'GlslGenerator', classMeta, VOID, [BaseGlslGenerator]);
  setMetadataFor(Companion_48, 'Companion', objectMeta);
  setMetadataFor(GlslConfig, 'GlslConfig', classMeta);
  setMetadataFor(GlslBodyGenerator, 'GlslBodyGenerator', classMeta, Visitor, [Visitor, BaseGlslGenerator]);
  setMetadataFor(ProgramLayout, 'ProgramLayout', classMeta, VOID, [Iterable]);
  setMetadataFor(Attribute, 'Attribute', classMeta, VariableWithOffset);
  setMetadataFor(Stm, 'Stm', classMeta);
  setMetadataFor(Stms, 'Stms', classMeta, Stm);
  setMetadataFor(Set, 'Set', classMeta, Stm);
  setMetadataFor(Return, 'Return', classMeta, Stm);
  setMetadataFor(Break, 'Break', objectMeta, Stm);
  setMetadataFor(Continue, 'Continue', objectMeta, Stm);
  setMetadataFor(Discard, 'Discard', objectMeta, Stm);
  setMetadataFor(If, 'If', classMeta, Stm);
  setMetadataFor(ForSimple, 'ForSimple', classMeta, Stm);
  setMetadataFor(Raw, 'Raw', classMeta, Stm);
  setMetadataFor(Program$ExpressionBuilder$Companion$INSTANCE$1, VOID, classMeta, VOID, [ExpressionBuilder]);
  setMetadataFor(Companion_49, 'Companion', objectMeta);
  setMetadataFor(FuncBuilder, 'FuncBuilder', classMeta, Builder);
  setMetadataFor(FuncDeclGetter, 'FuncDeclGetter', classMeta);
  setMetadataFor(FuncProvider, 'FuncProvider', classMeta);
  setMetadataFor(Program$Builder$_funcs$1, VOID, classMeta, Visitor);
  setMetadataFor(Ternary, 'Ternary', classMeta, Operand);
  setMetadataFor(Unop, 'Unop', classMeta, Operand);
  setMetadataFor(Binop, 'Binop', classMeta, Operand);
  setMetadataFor(IntLiteral, 'IntLiteral', classMeta, Operand);
  setMetadataFor(FloatLiteral, 'FloatLiteral', classMeta, Operand);
  setMetadataFor(BoolLiteral, 'BoolLiteral', classMeta, Operand);
  setMetadataFor(Vector, 'Vector', classMeta, Operand);
  setMetadataFor(Swizzle, 'Swizzle', classMeta, Operand);
  setMetadataFor(ArrayAccess, 'ArrayAccess', classMeta, Operand);
  setMetadataFor(BaseFunc, 'BaseFunc', classMeta, Operand);
  setMetadataFor(Func, 'Func', classMeta, BaseFunc);
  setMetadataFor(CustomFunc, 'CustomFunc', classMeta, BaseFunc);
  setMetadataFor(FuncRef, 'FuncRef', interfaceMeta);
  setMetadataFor(BuilderContext, 'BuilderContext', classMeta, VOID, VOID, BuilderContext);
  setMetadataFor(Program, 'Program', classMeta, VOID, [Closeable]);
  setMetadataFor(Shader, 'Shader', classMeta);
  setMetadataFor(Varying, 'Varying', classMeta, Variable);
  setMetadataFor(Output, 'Output', objectMeta, Varying);
  setMetadataFor(Provider, 'Provider', classMeta);
  setMetadataFor(Sampler, 'Sampler', classMeta, Variable);
  setMetadataFor(SamplerVarType, 'SamplerVarType', classMeta, Enum);
  setMetadataFor(Uniform, 'Uniform', classMeta, VariableWithOffset);
  setMetadataFor(Companion_50, 'Companion', objectMeta);
  setMetadataFor(VarType, 'VarType', classMeta, Enum);
  setMetadataFor(Precision, 'Precision', classMeta, Enum);
  setMetadataFor(Temp, 'Temp', classMeta, Variable);
  setMetadataFor(FuncDecl, 'FuncDecl', classMeta, VOID, [FuncRef]);
  setMetadataFor(VarKind, 'VarKind', classMeta, Enum);
  setMetadataFor(UniformInProgram, 'UniformInProgram', classMeta);
  setMetadataFor(Arg, 'Arg', classMeta, Variable);
  setMetadataFor(ShaderType, 'ShaderType', classMeta, Enum);
  setMetadataFor(ContextInfo, 'ContextInfo', classMeta, VOID, VOID, ContextInfo);
  setMetadataFor(Companion_51, 'Companion', objectMeta);
  setMetadataFor(KmlGl, 'KmlGl', classMeta, VOID, [AGFeatures], KmlGl);
  setMetadataFor(Companion_52, 'Companion', objectMeta);
  setMetadataFor(Korge$_init_$slambda_ys8r4w, 'Korge$<init>$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(Korge$start$slambda, 'Korge$start$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(Korge, 'Korge', classMeta, VOID, VOID, Korge, VOID, VOID, [1]);
  setMetadataFor(Companion_53, 'Companion', objectMeta);
  setMetadataFor(KorgeDisplayMode, 'KorgeDisplayMode', classMeta);
  setMetadataFor(KorgeRunner$invoke$slambda$slambda$slambda, 'KorgeRunner$invoke$slambda$slambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(KorgeRunner$invoke$slambda$slambda, 'KorgeRunner$invoke$slambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(KorgeRunner$invoke$slambda, 'KorgeRunner$invoke$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(KorgeRunner$prepareViewsBase$lambda$slambda, 'KorgeRunner$prepareViewsBase$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor($invokeCOROUTINE$0, '$invokeCOROUTINE$0', classMeta, CoroutineImpl);
  setMetadataFor(KorgeRunner, 'KorgeRunner', objectMeta, VOID, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(Korge$slambda, 'Korge$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(Korge$slambda_1, 'Korge$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(KorgeReload, 'KorgeReload', objectMeta);
  setMetadataFor(KorgeReloadInternalImpl, 'KorgeReloadInternalImpl', classMeta, VOID, VOID, KorgeReloadInternalImpl);
  setMetadataFor(Companion_54, 'Companion', objectMeta);
  setMetadataFor(ReloadClassContext, 'ReloadClassContext', classMeta);
  setMetadataFor(Companion_55, 'Companion', objectMeta);
  setMetadataFor(RootAnimationNode, 'RootAnimationNode', classMeta);
  setMetadataFor(TweenNode, 'TweenNode', classMeta);
  setMetadataFor(BlockNode, 'BlockNode', classMeta);
  setMetadataFor(Animator, 'Animator', classMeta, VOID, [CloseableCancellable], VOID, VOID, VOID, [1]);
  setMetadataFor($debugBmpFontCOROUTINE$2, '$debugBmpFontCOROUTINE$2', classMeta, CoroutineImpl);
  setMetadataFor(GamePadEvents, 'GamePadEvents', classMeta);
  setMetadataFor(Companion_56, 'Companion', objectMeta);
  setMetadataFor(GamePadStickEvent, 'GamePadStickEvent', classMeta, TypedEvent, VOID, GamePadStickEvent);
  setMetadataFor(Type_5, 'Type', classMeta, Enum);
  setMetadataFor(GamePadButtonEvent, 'GamePadButtonEvent', classMeta, Event, VOID, GamePadButtonEvent);
  setMetadataFor(InputKeys, 'InputKeys', classMeta, VOID, VOID, InputKeys);
  setMetadataFor(Companion_57, 'Companion', objectMeta);
  setMetadataFor(Input, 'Input', classMeta, VOID, VOID, Input);
  setMetadataFor(KeysEvents$lambda$slambda, 'KeysEvents$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(KeysEvents$lambda$slambda_1, 'KeysEvents$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(KeysEvents$lambda$slambda_3, 'KeysEvents$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(KeysEvents, 'KeysEvents', classMeta, VOID, [Closeable]);
  setMetadataFor(Info, 'Info', classMeta, VOID, VOID, Info);
  setMetadataFor(TouchEvents, 'TouchEvents', classMeta);
  setMetadataFor(SingleTouchHandler, 'SingleTouchHandler', classMeta, VOID, VOID, SingleTouchHandler);
  setMetadataFor(singleTouch$SingleTouchInfo, 'SingleTouchInfo', classMeta);
  setMetadataFor(DefaultViewport, 'DefaultViewport', objectMeta);
  setMetadataFor(Companion_58, 'Companion', objectMeta);
  setMetadataFor(Props, 'Props', classMeta, VOID, [MutableMap], Props);
  setMetadataFor($configureLoggerFromPropertiesCOROUTINE$3, '$configureLoggerFromPropertiesCOROUTINE$3', classMeta, CoroutineImpl);
  setMetadataFor(Entry_0, 'Entry', classMeta, VOID, VOID, Entry_0);
  setMetadataFor(AgAutoFreeManager, 'AgAutoFreeManager', classMeta, VOID, [Closeable], AgAutoFreeManager);
  setMetadataFor(BitmapTextureInfo, 'BitmapTextureInfo', classMeta, VOID, VOID, BitmapTextureInfo);
  setMetadataFor(AgBitmapTextureManager, 'AgBitmapTextureManager', classMeta, VOID, [Closeable]);
  setMetadataFor(AgBufferManager, 'AgBufferManager', classMeta);
  setMetadataFor(AgCachedBuffer, 'AgCachedBuffer', classMeta);
  setMetadataFor(BatchBuffers, 'BatchBuffers', classMeta, VOID, VOID, BatchBuffers);
  setMetadataFor(Companion_59, 'Companion', objectMeta);
  setMetadataFor(BatchBuilder2D, 'BatchBuilder2D', classMeta);
  setMetadataFor(Companion_60, 'Companion', objectMeta);
  setMetadataFor(LineRenderBatcher, 'LineRenderBatcher', classMeta);
  setMetadataFor(FlushKind, 'FlushKind', classMeta, Enum);
  function get_actualVirtualWidth() {
    return toIntRound_0(this.haa().n2d_1);
  }
  function get_actualVirtualHeight() {
    return toIntRound_0(this.haa().o2d_1);
  }
  function get_virtualLeft() {
    return this.haa().r2d();
  }
  function get_virtualTop() {
    return this.haa().t2d();
  }
  function get_virtualRight() {
    return this.haa().s2d();
  }
  function get_virtualBottom() {
    return this.haa().u2d();
  }
  function get_windowToGlobalScaleAvg() {
    return this.xaa().q2h().s2h();
  }
  function get_globalToWindowScaleAvg() {
    return this.oaa().s2h();
  }
  function windowToGlobalCoords(pos) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.uaa();
      if (this_0.p2d()) {
        tmp$ret$0 = pos;
        break $l$block;
      }
      tmp$ret$0 = new Vector2D(this_0.w2f(pos.g28_1, pos.h28_1), this_0.z2f(pos.g28_1, pos.h28_1));
    }
    return tmp$ret$0;
  }
  setMetadataFor(BoundsProvider, 'BoundsProvider', interfaceMeta);
  function get_devicePixelRatio() {
    return 1.0;
  }
  function get_pixelsPerInch() {
    return 96.0 * this.zaa();
  }
  function get_pixelsPerLogicalInchRatio() {
    var tmp = this.aab();
    Companion_getInstance_48();
    return tmp / 96.0;
  }
  function get_computedPixelRatio() {
    return this.zaa() * this.bab();
  }
  setMetadataFor(DeviceDimensionsProvider, 'DeviceDimensionsProvider', interfaceMeta);
  setMetadataFor(RenderContext, 'RenderContext', classMeta, VOID, [BoundsProvider, AGFeatures, DeviceDimensionsProvider, Closeable]);
  setMetadataFor(RenderContext2D, 'RenderContext2D', classMeta);
  setMetadataFor(SDFShaders, 'SDFShaders', objectMeta, Builder);
  setMetadataFor(TextureBase, 'TextureBase', classMeta, VOID, [Closeable]);
  setMetadataFor(Companion_61, 'Companion', objectMeta);
  setMetadataFor(TexturedVertexArray, 'TexturedVertexArray', classMeta);
  setMetadataFor(ShrinkableTexturedVertexArray, 'ShrinkableTexturedVertexArray', classMeta);
  setMetadataFor(ResourcesRoot, 'ResourcesRoot', classMeta, VOID, [InjectorDependency], ResourcesRoot, VOID, VOID, [1]);
  setMetadataFor($sceneAfterDestroyInternalCOROUTINE$6, '$sceneAfterDestroyInternalCOROUTINE$6', classMeta, CoroutineImpl);
  setMetadataFor(Scene, 'Scene', classMeta, VOID, [InjectorDependency, CoroutineScope], VOID, VOID, VOID, [0]);
  setMetadataFor(EmptyScene, 'EmptyScene', classMeta, Scene, VOID, EmptyScene, VOID, VOID, [0]);
  setMetadataFor(VisitEntry, 'VisitEntry', classMeta);
  setMetadataFor(Companion_62, 'Companion', objectMeta);
  setMetadataFor(SceneContainer$lambda$slambda, 'SceneContainer$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda_1, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda_3, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda_5, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda_7, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(SceneContainer$_changeTo$slambda_9, 'SceneContainer$_changeTo$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor($_changeToCOROUTINE$8, '$_changeToCOROUTINE$8', classMeta, CoroutineImpl);
  setMetadataFor($_changeToCOROUTINE$9, '$_changeToCOROUTINE$9', classMeta, CoroutineImpl);
  setMetadataFor(BaseView, 'BaseView', classMeta, BaseEventListener, VOID, BaseView);
  setMetadataFor(View, 'View', classMeta, BaseView);
  setMetadataFor(Container, 'Container', classMeta, View, VOID, Container);
  setMetadataFor(CachedContainer, 'CachedContainer', classMeta, Container, VOID, CachedContainer);
  setMetadataFor(Reference, 'Reference', interfaceMeta);
  setMetadataFor(FixedSizeCachedContainer, 'FixedSizeCachedContainer', classMeta, CachedContainer, [CachedContainer, Reference], FixedSizeCachedContainer);
  setMetadataFor(UIView, 'UIView', classMeta, FixedSizeCachedContainer, VOID, UIView);
  setMetadataFor(SceneContainer, 'SceneContainer', classMeta, UIView, [UIView, CoroutineScope], VOID, VOID, VOID, [2, 4, 6, 3]);
  function start(prev, next) {
    return Unit_instance;
  }
  function end(prev, next) {
    return Unit_instance;
  }
  function render(ctx, prev, next, ratio) {
    return Unit_instance;
  }
  setMetadataFor(TransitionProcess, 'TransitionProcess', interfaceMeta);
  setMetadataFor(TransitionView, 'TransitionView', classMeta, Container, VOID, TransitionView);
  setMetadataFor(Transition$1, VOID, classMeta, VOID, [TransitionProcess]);
  setMetadataFor(withEasing$1$create$1, VOID, classMeta, VOID, [TransitionProcess]);
  setMetadataFor(withEasing$1, VOID, classMeta);
  setMetadataFor(Counter, 'Counter', classMeta);
  setMetadataFor(RCollection, 'RCollection', classMeta, VOID, VOID, RCollection);
  setMetadataFor(Stats, 'Stats', classMeta, VOID, VOID, Stats);
  setMetadataFor(MsdfRender, 'MsdfRender', objectMeta);
  setMetadataFor(TweenComponent, 'TweenComponent', classMeta);
  setMetadataFor(tween$slambda, 'tween$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor($tweenCOROUTINE$12, '$tweenCOROUTINE$12', classMeta, CoroutineImpl);
  setMetadataFor(V2, 'V2', classMeta);
  setMetadataFor(Companion_63, 'Companion', objectMeta);
  setMetadataFor(InternalViewAutoscaling, 'InternalViewAutoscaling', classMeta, VOID, VOID, InternalViewAutoscaling);
  setMetadataFor(RectBase, 'RectBase', classMeta, View, VOID, RectBase);
  setMetadataFor(BaseImage, 'BaseImage', classMeta, RectBase);
  setMetadataFor(BaseGraphics, 'BaseGraphics', classMeta, BaseImage);
  setMetadataFor(Companion_64, 'Companion', objectMeta);
  setMetadataFor(BlendMode, 'BlendMode', classMeta);
  setMetadataFor(CacheTexture, 'CacheTexture', classMeta, VOID, [Closeable]);
  setMetadataFor(Camera, 'Camera', classMeta, Container, [Container, Reference], Camera, VOID, VOID, [4]);
  setMetadataFor(ZIndexComparator, 'ZIndexComparator', objectMeta, VOID, [Comparator]);
  setMetadataFor(ContainerCollection$iterator$1, VOID, classMeta);
  setMetadataFor(ContainerCollection, 'ContainerCollection', classMeta, VOID, [MutableIterable, Collection, List]);
  setMetadataFor(CpuGraphics, 'CpuGraphics', classMeta, BaseGraphics, VOID, CpuGraphics);
  setMetadataFor(DummyView, 'DummyView', classMeta, View, VOID, DummyView);
  setMetadataFor(ShadedView, 'ShadedView', classMeta, RectBase);
  setMetadataFor(FastRoundRectBase, 'FastRoundRectBase', classMeta, ShadedView);
  setMetadataFor(FastEllipse, 'FastEllipse', classMeta, FastRoundRectBase, VOID, FastEllipse);
  setMetadataFor(SDFUB, 'SDFUB', objectMeta, UniformBlock);
  setMetadataFor(Companion_65, 'Companion', objectMeta);
  setMetadataFor(Companion_66, 'Companion', objectMeta);
  setMetadataFor(FixedSizeContainer, 'FixedSizeContainer', classMeta, Container, [Container, Reference], FixedSizeContainer);
  setMetadataFor(SContainer, 'SContainer', classMeta, FixedSizeContainer, VOID, SContainer);
  setMetadataFor(TimeSlidingWindow, 'TimeSlidingWindow', classMeta);
  setMetadataFor(GraphicsRenderer, 'GraphicsRenderer', classMeta, Enum);
  setMetadataFor(Graphics, 'Graphics', classMeta, Container, VOID, Graphics);
  setMetadataFor($forceLoadSourceFileCOROUTINE$13, '$forceLoadSourceFileCOROUTINE$13', classMeta, CoroutineImpl);
  function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
    currentVfs = currentVfs === VOID ? views.n9f_1 : currentVfs;
    sourceFile = sourceFile === VOID ? null : sourceFile;
    return $super === VOID ? this.rc7(views, currentVfs, sourceFile, $completion) : $super.rc7.call(this, views, currentVfs, sourceFile, $completion);
  }
  setMetadataFor(ViewFileRef, 'ViewFileRef', interfaceMeta, VOID, VOID, VOID, VOID, VOID, [3]);
  setMetadataFor(SmoothedBmpSlice, 'SmoothedBmpSlice', interfaceMeta);
  setMetadataFor(Image, 'Image', classMeta, BaseImage, [BaseImage, ViewFileRef, SmoothedBmpSlice], VOID, VOID, VOID, [3]);
  setMetadataFor(CoordsType, 'CoordsType', classMeta, Enum);
  setMetadataFor(Companion_67, 'Companion', objectMeta);
  setMetadataFor(Companion_68, 'Companion', objectMeta);
  setMetadataFor(SolidRect, 'SolidRect', classMeta, RectBase);
  setMetadataFor(Stage, 'Stage', classMeta, FixedSizeContainer, [FixedSizeContainer, Reference, CoroutineScope, BoundsProvider]);
  setMetadataFor(Companion_69, 'Companion', objectMeta);
  setMetadataFor(Text$_renderInternal$slambda, 'Text$_renderInternal$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor($forceLoadFontSourceCOROUTINE$14, '$forceLoadFontSourceCOROUTINE$14', classMeta, CoroutineImpl);
  setMetadataFor(Text, 'Text', classMeta, Container, VOID, VOID, VOID, VOID, [2]);
  setMetadataFor(ColorReference, 'ColorReference', interfaceMeta);
  setMetadataFor(Companion_70, 'Companion', objectMeta);
  setMetadataFor(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  function get_priority() {
    return 0;
  }
  function render_0(view, ctx) {
    return view.rax(ctx);
  }
  function beforeRender(view, ctx) {
    return Unit_instance;
  }
  function afterRender(view, ctx) {
    return Unit_instance;
  }
  setMetadataFor(ViewRenderPhase, 'ViewRenderPhase', interfaceMeta);
  setMetadataFor(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, 'ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(Mixin_0, 'Mixin', classMeta, VOID, [ViewFileRef], Mixin_0, VOID, VOID, [3]);
  setMetadataFor(Views$close$slambda, 'Views$close$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor($initCOROUTINE$15, '$initCOROUTINE$15', classMeta, CoroutineImpl);
  setMetadataFor($closeSuspendCOROUTINE$16, '$closeSuspendCOROUTINE$16', classMeta, CoroutineImpl);
  setMetadataFor(Views, 'Views', classMeta, BaseEventListener, [BaseEventListener, CoroutineScope, BoundsProvider, Closeable, DeviceDimensionsProvider], VOID, VOID, VOID, [0]);
  setMetadataFor(Base, 'Base', classMeta, VOID, [BoundsProvider], Base);
  setMetadataFor(Companion_71, 'Companion', objectMeta);
  setMetadataFor(UpdateEvent, 'UpdateEvent', classMeta, Event, VOID, UpdateEvent);
  setMetadataFor(Companion_72, 'Companion', objectMeta);
  setMetadataFor(ViewsUpdateEvent, 'ViewsUpdateEvent', classMeta, Event);
  setMetadataFor(Companion_73, 'Companion', objectMeta);
  setMetadataFor(ViewsResizedEvent, 'ViewsResizedEvent', classMeta, Event);
  setMetadataFor($viewsCOROUTINE$17, '$viewsCOROUTINE$17', classMeta, CoroutineImpl);
  setMetadataFor(ImageAnimationView, 'ImageAnimationView', classMeta, Container);
  setMetadataFor(ImageDataView, 'ImageDataView', classMeta, Container, VOID, ImageDataView);
  setMetadataFor(Companion_74, 'Companion', objectMeta);
  function get_recommendedFilterScale() {
    return 1.0;
  }
  function computeBorder(texWidth, texHeight) {
    return Companion_getInstance_24().y2e_1;
  }
  setMetadataFor(Filter, 'Filter', interfaceMeta);
  setMetadataFor(ComposedFilter, 'ComposedFilter', classMeta, VOID, [Filter], ComposedFilter_init_$Create$);
  setMetadataFor(Companion_75, 'Companion', objectMeta);
  setMetadataFor(RenderToTextureResult, 'RenderToTextureResult', classMeta, VOID, VOID, RenderToTextureResult);
  setMetadataFor(IdentityFilter, 'IdentityFilter', classMeta, VOID, [Filter]);
  setMetadataFor(Companion_76, 'Companion', objectMeta, IdentityFilter);
  setMetadataFor(Nearest, 'Nearest', objectMeta, IdentityFilter);
  setMetadataFor(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', classMeta, VOID, [ViewRenderPhase]);
  setMetadataFor(Companion_77, 'Companion', objectMeta);
  setMetadataFor(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', classMeta, VOID, [ViewRenderPhase], ViewRenderPhaseFilter);
  setMetadataFor(Info_0, 'Info', classMeta);
  setMetadataFor(Companion_78, 'Companion', objectMeta);
  setMetadataFor(TileMap, 'TileMap', classMeta, View, VOID, TileMap);
  setMetadataFor(TileMapRepeat, 'TileMapRepeat', classMeta, Enum);
  setMetadataFor(PointsResult, 'PointsResult', classMeta);
  setMetadataFor(GpuShapeView, 'GpuShapeView', classMeta, View, VOID, GpuShapeView);
  setMetadataFor(ScissorCommand, 'ScissorCommand', classMeta);
  setMetadataFor(ClearCommand, 'ClearCommand', classMeta);
  setMetadataFor(ShapeCommand, 'ShapeCommand', classMeta);
  setMetadataFor(GpuShapeViewCommands, 'GpuShapeViewCommands', classMeta, VOID, VOID, GpuShapeViewCommands);
  setMetadataFor(ShapeViewUB, 'ShapeViewUB', objectMeta, UniformBlock);
  setMetadataFor(PaintShader, 'PaintShader', classMeta);
  setMetadataFor(GpuShapeViewPrograms, 'GpuShapeViewPrograms', objectMeta);
  setMetadataFor(DEFAULT, 'DEFAULT', objectMeta, VOID, [DeviceDimensionsProvider]);
  setMetadataFor(Companion_79, 'Companion', objectMeta);
  setMetadataFor(Cursor, 'Cursor', classMeta, Enum);
  setMetadataFor(MenuItem, 'MenuItem', classMeta);
  setMetadataFor(CoroutineKey, 'CoroutineKey', objectMeta);
  setMetadataFor(Quality, 'Quality', classMeta, Enum);
  setMetadataFor(GameWindow$loop$slambda, 'GameWindow$loop$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(_no_name_provided__qut3iv, VOID, classMeta, ObservableProperty);
  setMetadataFor($waitCloseCOROUTINE$18, '$waitCloseCOROUTINE$18', classMeta, CoroutineImpl);
  setMetadataFor($loopCOROUTINE$19, '$loopCOROUTINE$19', classMeta, CoroutineImpl);
  setMetadataFor(GameWindow, 'GameWindow', classMeta, BaseEventListener, [BaseEventListener, DeviceDimensionsProvider, Element], GameWindow, VOID, VOID, [0, 1]);
  setMetadataFor(Impl, 'Impl', classMeta, VOID, VOID, Impl);
  setMetadataFor(Companion_80, 'Companion', objectMeta);
  setMetadataFor(GameWindowCreationConfig, 'GameWindowCreationConfig', classMeta, VOID, VOID, GameWindowCreationConfig);
  setMetadataFor(TimedTask, 'TimedTask', classMeta);
  setMetadataFor(Companion_81, 'Companion', objectMeta);
  setMetadataFor(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', classMeta);
  setMetadataFor(GameWindowCoroutineDispatcher, 'GameWindowCoroutineDispatcher', classMeta, CoroutineDispatcher, [CoroutineDispatcher, Delay, Closeable], GameWindowCoroutineDispatcher, VOID, VOID, [1]);
  setMetadataFor(SyncEventLoopCoroutineDispatcher, 'SyncEventLoopCoroutineDispatcher', classMeta, CoroutineDispatcher, [CoroutineDispatcher, Delay, Closeable], SyncEventLoopCoroutineDispatcher_init_$Create$, VOID, VOID, [1]);
  setMetadataFor(AGOpenglFactory, 'AGOpenglFactory', objectMeta);
  setMetadataFor(KmlGlJsCanvas, 'KmlGlJsCanvas', classMeta, KmlGl);
  setMetadataFor(WebGLExtension, 'WebGLExtension', classMeta);
  setMetadataFor(KorgeReloadInternal$1, VOID, classMeta, KorgeReloadInternalImpl);
  setMetadataFor(JsGameWindow, 'JsGameWindow', classMeta, GameWindow, VOID, JsGameWindow, VOID, VOID, [0, 1]);
  setMetadataFor(NodeJsGameWindow, 'NodeJsGameWindow', classMeta, JsGameWindow, VOID, NodeJsGameWindow, VOID, VOID, [0, 1]);
  setMetadataFor(BrowserCanvasJsGameWindow$close$slambda, 'BrowserCanvasJsGameWindow$close$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(BrowserCanvasJsGameWindow$loop$slambda, 'BrowserCanvasJsGameWindow$loop$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor($loopCOROUTINE$20, '$loopCOROUTINE$20', classMeta, CoroutineImpl);
  setMetadataFor(BrowserCanvasJsGameWindow, 'BrowserCanvasJsGameWindow', classMeta, JsGameWindow, VOID, BrowserCanvasJsGameWindow, VOID, VOID, [1, 0]);
  setMetadataFor(DialogInterfaceJs, 'DialogInterfaceJs', classMeta, VOID, VOID, DialogInterfaceJs, VOID, VOID, [1, 2, 4]);
  //endregion
  function Listener(func, node, base) {
    this.v7l_1 = func;
    this.w7l_1 = node;
    this.x7l_1 = base;
  }
  protoOf(Listener).p21 = function () {
    if (this.w7l_1.z7l_1.s(this)) {
      __updateChildListenerCount(this.x7l_1, this.w7l_1.y7l_1, -1);
    }
  };
  protoOf(Listener).b7m = function () {
    this.w7l_1.z7l_1.r(this);
    __updateChildListenerCount(this.x7l_1, this.w7l_1.y7l_1, 1);
  };
  function ListenerNode(type) {
    this.y7l_1 = type;
    this.z7l_1 = FastArrayList_init_$Create$();
    this.a7m_1 = FastArrayList_init_$Create$();
  }
  function __updateChildListenerCount($this, type, delta) {
    if (delta === 0)
      return Unit_instance;
    if ($this.f7m_1 == null)
      $this.f7m_1 = FastIdentityMap();
    var tmp1_safe_receiver = $this.f7m_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp0_elvis_lhs = get(ensureNotNull($this.f7m_1), type);
      set(tmp1_safe_receiver, type, (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) + delta | 0);
    }
    var tmp2_safe_receiver = $this.d7m_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount(tmp2_safe_receiver, type, delta);
    }
  }
  function __updateChildListenerCount_0($this, child, add) {
    var tmp0_safe_receiver = child.f7m_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.fastForEach' call
      // Inline function 'korlibs.datastructure.fastKeyForEach' call
      // Inline function 'kotlin.js.asDynamic' call
      var mapIterator = tmp0_safe_receiver.keys();
      $l$loop: while (true) {
        var v = mapIterator.next();
        if (v.done)
          break $l$loop;
        // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
        var it = v.value;
        // Inline function 'korlibs.event.BaseEventListener.__updateChildListenerCount.<anonymous>' call
        var i = ensureNotNull(get(tmp0_safe_receiver, it));
        __updateChildListenerCount($this, it, add ? +i : -i | 0);
      }
    }
  }
  function BaseEventListener() {
    this.c7m_1 = null;
    this.d7m_1 = null;
    this.e7m_1 = null;
    this.f7m_1 = null;
  }
  protoOf(BaseEventListener).h23 = function (_set____db54di) {
    this.c7m_1 = _set____db54di;
  };
  protoOf(BaseEventListener).i23 = function () {
    return this.c7m_1;
  };
  protoOf(BaseEventListener).g7m = function (other) {
    var tmp0_safe_receiver = this.d7m_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp0_safe_receiver, this, false);
    }
    this.d7m_1 = other;
    var tmp1_safe_receiver = this.d7m_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp1_safe_receiver, this, true);
    }
  };
  protoOf(BaseEventListener).h7m = function (type, handler) {
    if (this.e7m_1 == null)
      this.e7m_1 = FastIdentityMap();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = ensureNotNull(this.e7m_1);
      var res = get(this_0, type);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
      var out = new ListenerNode(type);
      set(this_0, type, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    var lists = tmp instanceof ListenerNode ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_1 = new Listener(handler, lists, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
    this_1.b7m();
    return this_1;
  };
  protoOf(BaseEventListener).i7m = function (type) {
    var tmp0_safe_receiver = this.e7m_1;
    var tmp = tmp0_safe_receiver == null ? null : get(tmp0_safe_receiver, type);
    return tmp instanceof ListenerNode ? tmp : null;
  };
  protoOf(BaseEventListener).j7m = function (type, event, result, up, down) {
    var eventListenerCount = this.k7m(type);
    if (eventListenerCount <= 0)
      return false;
    if (down) {
      this.l7m(type, event, result);
    }
    var listeners = this.i7m(type);
    var tmp1_safe_receiver = listeners == null ? null : listeners.z7l_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
      var temp = listeners.a7m_1;
      toFastList(tmp1_safe_receiver, temp);
      try {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = temp.y1u_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'get' call
          var tmp0 = n;
          n = tmp0 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array[tmp0].v7l_1(event);
          if (result == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            result.n7m_1 = result.n7m_1 + 1 | 0;
          }
        }
      }finally {
        temp.b3();
      }
    }
    if (up) {
      this.o7m(type, event, result);
    }
    if (result == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
      result.m7m_1 = result.m7m_1 + 1 | 0;
    }
    return event.p7m();
  };
  protoOf(BaseEventListener).q7m = function (type, event, result) {
    return dispatch.call(this, type, event, result);
  };
  protoOf(BaseEventListener).s7m = function (event) {
    return dispatch_0.call(this, event);
  };
  protoOf(BaseEventListener).o7m = function (type, event, result) {
  };
  protoOf(BaseEventListener).l7m = function (type, event, result) {
  };
  protoOf(BaseEventListener).k7m = function (type) {
    var tmp0_safe_receiver = this.f7m_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.getNull' call
      tmp = type == null ? null : get(tmp0_safe_receiver, type);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  function EventResult(iterationCount, resultCount) {
    iterationCount = iterationCount === VOID ? 0 : iterationCount;
    resultCount = resultCount === VOID ? 0 : resultCount;
    this.m7m_1 = iterationCount;
    this.n7m_1 = resultCount;
  }
  protoOf(EventResult).n1y = function () {
    this.m7m_1 = 0;
    this.n7m_1 = 0;
  };
  protoOf(EventResult).toString = function () {
    return 'EventResult(iterationCount=' + this.m7m_1 + ', resultCount=' + this.n7m_1 + ')';
  };
  protoOf(EventResult).hashCode = function () {
    var result = this.m7m_1;
    result = imul(result, 31) + this.n7m_1 | 0;
    return result;
  };
  protoOf(EventResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EventResult))
      return false;
    var tmp0_other_with_cast = other instanceof EventResult ? other : THROW_CCE();
    if (!(this.m7m_1 === tmp0_other_with_cast.m7m_1))
      return false;
    if (!(this.n7m_1 === tmp0_other_with_cast.n7m_1))
      return false;
    return true;
  };
  function EventListener() {
  }
  function TypedEvent(type) {
    Event.call(this);
    this.y7m_1 = type;
  }
  protoOf(TypedEvent).u2f = function () {
    return this.y7m_1;
  };
  function Event() {
    this.z7m_1 = null;
    this.a7n_1 = false;
  }
  protoOf(Event).b7n = function (_set____db54di) {
    this.z7m_1 = _set____db54di;
  };
  protoOf(Event).c7n = function (_set____db54di) {
    this.a7n_1 = _set____db54di;
  };
  protoOf(Event).p7m = function () {
    return this.a7n_1;
  };
  var Type_MAGNIFY_instance;
  var Type_ROTATE_instance;
  var Type_SWIPE_instance;
  var Type_SMART_MAGNIFY_instance;
  function Companion() {
    Companion_instance_13 = this;
    this.d7n_1 = values();
  }
  var Companion_instance_13;
  function Companion_getInstance_25() {
    Type_initEntries();
    if (Companion_instance_13 == null)
      new Companion();
    return Companion_instance_13;
  }
  function values() {
    return [Type_MAGNIFY_getInstance(), Type_ROTATE_getInstance(), Type_SWIPE_getInstance(), Type_SMART_MAGNIFY_getInstance()];
  }
  var Type_entriesInitialized;
  function Type_initEntries() {
    if (Type_entriesInitialized)
      return Unit_instance;
    Type_entriesInitialized = true;
    Type_MAGNIFY_instance = new Type('MAGNIFY', 0);
    Type_ROTATE_instance = new Type('ROTATE', 1);
    Type_SWIPE_instance = new Type('SWIPE', 2);
    Type_SMART_MAGNIFY_instance = new Type('SMART_MAGNIFY', 3);
    Companion_getInstance_25();
  }
  function Type(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Type_MAGNIFY_getInstance() {
    Type_initEntries();
    return Type_MAGNIFY_instance;
  }
  function Type_ROTATE_getInstance() {
    Type_initEntries();
    return Type_ROTATE_instance;
  }
  function Type_SWIPE_getInstance() {
    Type_initEntries();
    return Type_SWIPE_instance;
  }
  function Type_SMART_MAGNIFY_getInstance() {
    Type_initEntries();
    return Type_SMART_MAGNIFY_instance;
  }
  function GestureEvent(type, id, amountX, amountY) {
    type = type === VOID ? Type_MAGNIFY_getInstance() : type;
    id = id === VOID ? 0 : id;
    amountX = amountX === VOID ? 0.0 : amountX;
    amountY = amountY === VOID ? 0.0 : amountY;
    Event.call(this);
    this.g7n_1 = type;
    this.h7n_1 = id;
    this.i7n_1 = amountX;
    this.j7n_1 = amountY;
  }
  protoOf(GestureEvent).u2f = function () {
    return this.g7n_1;
  };
  protoOf(GestureEvent).toString = function () {
    return 'GestureEvent(type=' + this.g7n_1 + ', id=' + this.h7n_1 + ', amountX=' + this.i7n_1 + ', amountY=' + this.j7n_1 + ')';
  };
  protoOf(GestureEvent).hashCode = function () {
    var result = this.g7n_1.hashCode();
    result = imul(result, 31) + this.h7n_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.i7n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j7n_1) | 0;
    return result;
  };
  protoOf(GestureEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GestureEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GestureEvent ? other : THROW_CCE();
    if (!this.g7n_1.equals(tmp0_other_with_cast.g7n_1))
      return false;
    if (!(this.h7n_1 === tmp0_other_with_cast.h7n_1))
      return false;
    if (!equals(this.i7n_1, tmp0_other_with_cast.i7n_1))
      return false;
    if (!equals(this.j7n_1, tmp0_other_with_cast.j7n_1))
      return false;
    return true;
  };
  var Type_UP_instance;
  var Type_DOWN_instance;
  var Type_TYPE_instance;
  function Companion_0() {
    Companion_instance_14 = this;
    this.k7n_1 = values_0();
  }
  var Companion_instance_14;
  function Companion_getInstance_26() {
    Type_initEntries_0();
    if (Companion_instance_14 == null)
      new Companion_0();
    return Companion_instance_14;
  }
  function values_0() {
    return [Type_UP_getInstance(), Type_DOWN_getInstance(), Type_TYPE_getInstance()];
  }
  var Type_entriesInitialized_0;
  function Type_initEntries_0() {
    if (Type_entriesInitialized_0)
      return Unit_instance;
    Type_entriesInitialized_0 = true;
    Type_UP_instance = new Type_0('UP', 0);
    Type_DOWN_instance = new Type_0('DOWN', 1);
    Type_TYPE_instance = new Type_0('TYPE', 2);
    Companion_getInstance_26();
  }
  function Type_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Type_UP_getInstance() {
    Type_initEntries_0();
    return Type_UP_instance;
  }
  function Type_DOWN_getInstance() {
    Type_initEntries_0();
    return Type_DOWN_instance;
  }
  function Type_TYPE_getInstance() {
    Type_initEntries_0();
    return Type_TYPE_instance;
  }
  function KeyEvent(type, id, key, keyCode, character, shift, ctrl, alt, meta, str) {
    type = type === VOID ? Type_UP_getInstance() : type;
    id = id === VOID ? 0 : id;
    key = key === VOID ? Key_UP_getInstance() : key;
    keyCode = keyCode === VOID ? 0 : keyCode;
    character = character === VOID ? _Char___init__impl__6a9atx(0) : character;
    shift = shift === VOID ? false : shift;
    ctrl = ctrl === VOID ? false : ctrl;
    alt = alt === VOID ? false : alt;
    meta = meta === VOID ? false : meta;
    str = str === VOID ? null : str;
    Event.call(this);
    this.n7n_1 = type;
    this.o7n_1 = id;
    this.p7n_1 = key;
    this.q7n_1 = keyCode;
    this.r7n_1 = character;
    this.s7n_1 = shift;
    this.t7n_1 = ctrl;
    this.u7n_1 = alt;
    this.v7n_1 = meta;
    this.w7n_1 = str;
    this.x7n_1 = Companion_getInstance().va_1;
  }
  protoOf(KeyEvent).u2f = function () {
    return this.n7n_1;
  };
  protoOf(KeyEvent).toString = function () {
    return 'KeyEvent(type=' + this.n7n_1 + ', id=' + this.o7n_1 + ', key=' + this.p7n_1 + ', keyCode=' + this.q7n_1 + ', character=' + toString_0(this.r7n_1) + ', shift=' + this.s7n_1 + ', ctrl=' + this.t7n_1 + ', alt=' + this.u7n_1 + ', meta=' + this.v7n_1 + ', str=' + this.w7n_1 + ')';
  };
  protoOf(KeyEvent).hashCode = function () {
    var result = this.n7n_1.hashCode();
    result = imul(result, 31) + this.o7n_1 | 0;
    result = imul(result, 31) + this.p7n_1.hashCode() | 0;
    result = imul(result, 31) + this.q7n_1 | 0;
    result = imul(result, 31) + Char__hashCode_impl_otmys(this.r7n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s7n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t7n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u7n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v7n_1) | 0;
    result = imul(result, 31) + (this.w7n_1 == null ? 0 : getStringHashCode(this.w7n_1)) | 0;
    return result;
  };
  protoOf(KeyEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this.n7n_1.equals(tmp0_other_with_cast.n7n_1))
      return false;
    if (!(this.o7n_1 === tmp0_other_with_cast.o7n_1))
      return false;
    if (!this.p7n_1.equals(tmp0_other_with_cast.p7n_1))
      return false;
    if (!(this.q7n_1 === tmp0_other_with_cast.q7n_1))
      return false;
    if (!(this.r7n_1 === tmp0_other_with_cast.r7n_1))
      return false;
    if (!(this.s7n_1 === tmp0_other_with_cast.s7n_1))
      return false;
    if (!(this.t7n_1 === tmp0_other_with_cast.t7n_1))
      return false;
    if (!(this.u7n_1 === tmp0_other_with_cast.u7n_1))
      return false;
    if (!(this.v7n_1 === tmp0_other_with_cast.v7n_1))
      return false;
    if (!(this.w7n_1 == tmp0_other_with_cast.w7n_1))
      return false;
    return true;
  };
  var Type_MOVE_instance;
  var Type_DRAG_instance;
  var Type_UP_instance_0;
  var Type_DOWN_instance_0;
  var Type_CLICK_instance;
  var Type_ENTER_instance;
  var Type_EXIT_instance;
  var Type_SCROLL_instance;
  function Companion_1() {
    Companion_instance_15 = this;
    this.y7n_1 = values_1();
  }
  var Companion_instance_15;
  function Companion_getInstance_27() {
    Type_initEntries_1();
    if (Companion_instance_15 == null)
      new Companion_1();
    return Companion_instance_15;
  }
  function values_1() {
    return [Type_MOVE_getInstance(), Type_DRAG_getInstance(), Type_UP_getInstance_0(), Type_DOWN_getInstance_0(), Type_CLICK_getInstance(), Type_ENTER_getInstance(), Type_EXIT_getInstance(), Type_SCROLL_getInstance()];
  }
  var Type_entriesInitialized_1;
  function Type_initEntries_1() {
    if (Type_entriesInitialized_1)
      return Unit_instance;
    Type_entriesInitialized_1 = true;
    Type_MOVE_instance = new Type_1('MOVE', 0);
    Type_DRAG_instance = new Type_1('DRAG', 1);
    Type_UP_instance_0 = new Type_1('UP', 2);
    Type_DOWN_instance_0 = new Type_1('DOWN', 3);
    Type_CLICK_instance = new Type_1('CLICK', 4);
    Type_ENTER_instance = new Type_1('ENTER', 5);
    Type_EXIT_instance = new Type_1('EXIT', 6);
    Type_SCROLL_instance = new Type_1('SCROLL', 7);
    Companion_getInstance_27();
  }
  var ScrollDeltaMode_PIXEL_instance;
  var ScrollDeltaMode_LINE_instance;
  var ScrollDeltaMode_PAGE_instance;
  var ScrollDeltaMode_entriesInitialized;
  function ScrollDeltaMode_initEntries() {
    if (ScrollDeltaMode_entriesInitialized)
      return Unit_instance;
    ScrollDeltaMode_entriesInitialized = true;
    ScrollDeltaMode_PIXEL_instance = new ScrollDeltaMode('PIXEL', 0, 1.0);
    ScrollDeltaMode_LINE_instance = new ScrollDeltaMode('LINE', 1, 10.0);
    ScrollDeltaMode_PAGE_instance = new ScrollDeltaMode('PAGE', 2, 100.0);
  }
  function Type_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ScrollDeltaMode(name, ordinal, scale) {
    Enum.call(this, name, ordinal);
    this.b7o_1 = scale;
  }
  function MouseEvent$requestLock$lambda() {
    return Unit_instance;
  }
  function Type_MOVE_getInstance() {
    Type_initEntries_1();
    return Type_MOVE_instance;
  }
  function Type_DRAG_getInstance() {
    Type_initEntries_1();
    return Type_DRAG_instance;
  }
  function Type_UP_getInstance_0() {
    Type_initEntries_1();
    return Type_UP_instance_0;
  }
  function Type_DOWN_getInstance_0() {
    Type_initEntries_1();
    return Type_DOWN_instance_0;
  }
  function Type_CLICK_getInstance() {
    Type_initEntries_1();
    return Type_CLICK_instance;
  }
  function Type_ENTER_getInstance() {
    Type_initEntries_1();
    return Type_ENTER_instance;
  }
  function Type_EXIT_getInstance() {
    Type_initEntries_1();
    return Type_EXIT_instance;
  }
  function Type_SCROLL_getInstance() {
    Type_initEntries_1();
    return Type_SCROLL_instance;
  }
  function ScrollDeltaMode_PIXEL_getInstance() {
    ScrollDeltaMode_initEntries();
    return ScrollDeltaMode_PIXEL_instance;
  }
  function ScrollDeltaMode_LINE_getInstance() {
    ScrollDeltaMode_initEntries();
    return ScrollDeltaMode_LINE_instance;
  }
  function ScrollDeltaMode_PAGE_getInstance() {
    ScrollDeltaMode_initEntries();
    return ScrollDeltaMode_PAGE_instance;
  }
  function MouseEvent(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, scrollDeltaMode) {
    type = type === VOID ? Type_MOVE_getInstance() : type;
    id = id === VOID ? 0 : id;
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    button = button === VOID ? MouseButton_NONE_getInstance() : button;
    buttons = buttons === VOID ? 0 : buttons;
    scrollDeltaX = scrollDeltaX === VOID ? 0.0 : scrollDeltaX;
    scrollDeltaY = scrollDeltaY === VOID ? 0.0 : scrollDeltaY;
    scrollDeltaZ = scrollDeltaZ === VOID ? 0.0 : scrollDeltaZ;
    isShiftDown = isShiftDown === VOID ? false : isShiftDown;
    isCtrlDown = isCtrlDown === VOID ? false : isCtrlDown;
    isAltDown = isAltDown === VOID ? false : isAltDown;
    isMetaDown = isMetaDown === VOID ? false : isMetaDown;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    scrollDeltaMode = scrollDeltaMode === VOID ? ScrollDeltaMode_LINE_getInstance() : scrollDeltaMode;
    Event.call(this);
    this.e7o_1 = type;
    this.f7o_1 = id;
    this.g7o_1 = x;
    this.h7o_1 = y;
    this.i7o_1 = button;
    this.j7o_1 = buttons;
    this.k7o_1 = scrollDeltaX;
    this.l7o_1 = scrollDeltaY;
    this.m7o_1 = scrollDeltaZ;
    this.n7o_1 = isShiftDown;
    this.o7o_1 = isCtrlDown;
    this.p7o_1 = isAltDown;
    this.q7o_1 = isMetaDown;
    this.r7o_1 = scaleCoords;
    this.s7o_1 = emulated;
    this.t7o_1 = scrollDeltaMode;
    this.u7o_1 = null;
    var tmp = this;
    tmp.v7o_1 = MouseEvent$requestLock$lambda;
  }
  protoOf(MouseEvent).u2f = function () {
    return this.e7o_1;
  };
  protoOf(MouseEvent).w7o = function (mode, x, y, z) {
    this.t7o_1 = mode;
    this.k7o_1 = x;
    this.l7o_1 = y;
    this.m7o_1 = z;
  };
  protoOf(MouseEvent).toString = function () {
    return 'MouseEvent(type=' + this.e7o_1 + ', id=' + this.f7o_1 + ', x=' + this.g7o_1 + ', y=' + this.h7o_1 + ', button=' + this.i7o_1 + ', buttons=' + this.j7o_1 + ', scrollDeltaX=' + this.k7o_1 + ', scrollDeltaY=' + this.l7o_1 + ', scrollDeltaZ=' + this.m7o_1 + ', isShiftDown=' + this.n7o_1 + ', isCtrlDown=' + this.o7o_1 + ', isAltDown=' + this.p7o_1 + ', isMetaDown=' + this.q7o_1 + ', scaleCoords=' + this.r7o_1 + ', emulated=' + this.s7o_1 + ', scrollDeltaMode=' + this.t7o_1 + ')';
  };
  protoOf(MouseEvent).hashCode = function () {
    var result = this.e7o_1.hashCode();
    result = imul(result, 31) + this.f7o_1 | 0;
    result = imul(result, 31) + this.g7o_1 | 0;
    result = imul(result, 31) + this.h7o_1 | 0;
    result = imul(result, 31) + this.i7o_1.hashCode() | 0;
    result = imul(result, 31) + this.j7o_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.k7o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l7o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m7o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n7o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o7o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p7o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q7o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r7o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s7o_1) | 0;
    result = imul(result, 31) + this.t7o_1.hashCode() | 0;
    return result;
  };
  protoOf(MouseEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent))
      return false;
    var tmp0_other_with_cast = other instanceof MouseEvent ? other : THROW_CCE();
    if (!this.e7o_1.equals(tmp0_other_with_cast.e7o_1))
      return false;
    if (!(this.f7o_1 === tmp0_other_with_cast.f7o_1))
      return false;
    if (!(this.g7o_1 === tmp0_other_with_cast.g7o_1))
      return false;
    if (!(this.h7o_1 === tmp0_other_with_cast.h7o_1))
      return false;
    if (!this.i7o_1.equals(tmp0_other_with_cast.i7o_1))
      return false;
    if (!(this.j7o_1 === tmp0_other_with_cast.j7o_1))
      return false;
    if (!equals(this.k7o_1, tmp0_other_with_cast.k7o_1))
      return false;
    if (!equals(this.l7o_1, tmp0_other_with_cast.l7o_1))
      return false;
    if (!equals(this.m7o_1, tmp0_other_with_cast.m7o_1))
      return false;
    if (!(this.n7o_1 === tmp0_other_with_cast.n7o_1))
      return false;
    if (!(this.o7o_1 === tmp0_other_with_cast.o7o_1))
      return false;
    if (!(this.p7o_1 === tmp0_other_with_cast.p7o_1))
      return false;
    if (!(this.q7o_1 === tmp0_other_with_cast.q7o_1))
      return false;
    if (!(this.r7o_1 === tmp0_other_with_cast.r7o_1))
      return false;
    if (!(this.s7o_1 === tmp0_other_with_cast.s7o_1))
      return false;
    if (!this.t7o_1.equals(tmp0_other_with_cast.t7o_1))
      return false;
    return true;
  };
  var Status_ADD_instance;
  var Status_KEEP_instance;
  var Status_REMOVE_instance;
  var Status_entriesInitialized;
  function Status_initEntries() {
    if (Status_entriesInitialized)
      return Unit_instance;
    Status_entriesInitialized = true;
    Status_ADD_instance = new Status('ADD', 0);
    Status_KEEP_instance = new Status('KEEP', 1);
    Status_REMOVE_instance = new Status('REMOVE', 2);
  }
  var Kind_FINGER_instance;
  var Kind_MOUSE_instance;
  var Kind_STYLUS_instance;
  var Kind_ERASER_instance;
  var Kind_UNKNOWN_instance;
  var Kind_entriesInitialized;
  function Kind_initEntries() {
    if (Kind_entriesInitialized)
      return Unit_instance;
    Kind_entriesInitialized = true;
    Kind_FINGER_instance = new Kind('FINGER', 0);
    Kind_MOUSE_instance = new Kind('MOUSE', 1);
    Kind_STYLUS_instance = new Kind('STYLUS', 2);
    Kind_ERASER_instance = new Kind('ERASER', 3);
    Kind_UNKNOWN_instance = new Kind('UNKNOWN', 4);
  }
  function Status(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Kind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_2() {
    Companion_instance_16 = this;
    this.x7o_1 = new Touch(-1);
  }
  var Companion_instance_16;
  function Companion_getInstance_28() {
    if (Companion_instance_16 == null)
      new Companion_2();
    return Companion_instance_16;
  }
  function Status_ADD_getInstance() {
    Status_initEntries();
    return Status_ADD_instance;
  }
  function Status_KEEP_getInstance() {
    Status_initEntries();
    return Status_KEEP_instance;
  }
  function Status_REMOVE_getInstance() {
    Status_initEntries();
    return Status_REMOVE_instance;
  }
  function Kind_FINGER_getInstance() {
    Kind_initEntries();
    return Kind_FINGER_instance;
  }
  function Kind_MOUSE_getInstance() {
    Kind_initEntries();
    return Kind_MOUSE_instance;
  }
  function Touch(index, id, p, force, status, kind, button) {
    Companion_getInstance_28();
    index = index === VOID ? -1 : index;
    id = id === VOID ? -1 : id;
    p = p === VOID ? Companion_getInstance_0().d2d_1 : p;
    force = force === VOID ? 1.0 : force;
    status = status === VOID ? Status_KEEP_getInstance() : status;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    this.y7o_1 = index;
    this.z7o_1 = id;
    this.a7p_1 = p;
    this.b7p_1 = force;
    this.c7p_1 = status;
    this.d7p_1 = kind;
    this.e7p_1 = button;
    this.f7p_1 = new Mixin();
  }
  protoOf(Touch).h23 = function (_set____db54di) {
    this.f7p_1.h23(_set____db54di);
  };
  protoOf(Touch).i23 = function () {
    return this.f7p_1.i23();
  };
  protoOf(Touch).v4s = function () {
    return this.a7p_1.g28_1;
  };
  protoOf(Touch).w4s = function () {
    return this.a7p_1.h28_1;
  };
  protoOf(Touch).x1a = function () {
    return !this.c7p_1.equals(Status_REMOVE_getInstance());
  };
  protoOf(Touch).g7p = function (other) {
    this.z7o_1 = other.z7o_1;
    this.a7p_1 = other.a7p_1;
    this.b7p_1 = other.b7p_1;
    this.c7p_1 = other.c7p_1;
    this.d7p_1 = other.d7p_1;
    this.e7p_1 = other.e7p_1;
  };
  protoOf(Touch).hashCode = function () {
    return this.y7o_1;
  };
  protoOf(Touch).equals = function (other) {
    var tmp;
    if (other instanceof Touch) {
      tmp = this.y7o_1 === other.y7o_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Touch).toString = function () {
    return 'Touch(index=' + this.y7o_1 + ', id=' + this.z7o_1 + ', p=' + this.a7p_1 + ', force=' + this.b7p_1 + ', status=' + this.c7p_1 + ', kind=' + this.d7p_1 + ', button=' + this.e7p_1 + ')';
  };
  var Type_START_instance;
  var Type_END_instance;
  var Type_MOVE_instance_0;
  var Type_HOVER_instance;
  var Type_UNKNOWN_instance;
  function Companion_3() {
    Companion_instance_17 = this;
    this.h7p_1 = values_2();
  }
  var Companion_instance_17;
  function Companion_getInstance_29() {
    Type_initEntries_2();
    if (Companion_instance_17 == null)
      new Companion_3();
    return Companion_instance_17;
  }
  function values_2() {
    return [Type_START_getInstance(), Type_END_getInstance(), Type_MOVE_getInstance_0(), Type_HOVER_getInstance(), Type_UNKNOWN_getInstance()];
  }
  var Type_entriesInitialized_2;
  function Type_initEntries_2() {
    if (Type_entriesInitialized_2)
      return Unit_instance;
    Type_entriesInitialized_2 = true;
    Type_START_instance = new Type_2('START', 0);
    Type_END_instance = new Type_2('END', 1);
    Type_MOVE_instance_0 = new Type_2('MOVE', 2);
    Type_HOVER_instance = new Type_2('HOVER', 3);
    Type_UNKNOWN_instance = new Type_2('UNKNOWN', 4);
    Companion_getInstance_29();
  }
  function Type_2(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_4() {
    this.i7p_1 = 10;
  }
  var Companion_instance_18;
  function Companion_getInstance_30() {
    return Companion_instance_18;
  }
  function TouchEvent$toString$lambda(it) {
    return it.toString();
  }
  function Type_START_getInstance() {
    Type_initEntries_2();
    return Type_START_instance;
  }
  function Type_END_getInstance() {
    Type_initEntries_2();
    return Type_END_instance;
  }
  function Type_MOVE_getInstance_0() {
    Type_initEntries_2();
    return Type_MOVE_instance_0;
  }
  function Type_HOVER_getInstance() {
    Type_initEntries_2();
    return Type_HOVER_instance;
  }
  function Type_UNKNOWN_getInstance() {
    Type_initEntries_2();
    return Type_UNKNOWN_instance;
  }
  function TouchEvent(type, screen, currentTime, scaleCoords, emulated) {
    type = type === VOID ? Type_START_getInstance() : type;
    screen = screen === VOID ? 0 : screen;
    currentTime = currentTime === VOID ? Companion_getInstance_1().a1q_1 : currentTime;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    Event.call(this);
    this.l7p_1 = type;
    this.m7p_1 = screen;
    this.n7p_1 = currentTime;
    this.o7p_1 = scaleCoords;
    this.p7p_1 = emulated;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_instance_18.i7p_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new Touch(tmp_3);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.q7p_1 = tmp_2;
    this.r7p_1 = FastArrayList_init_$Create$();
    this.s7p_1 = FastArrayList_init_$Create$();
    this.t7p_1 = FastIntMap();
  }
  protoOf(TouchEvent).u2f = function () {
    return this.l7p_1;
  };
  protoOf(TouchEvent).u7p = function () {
    return this.r7p_1;
  };
  protoOf(TouchEvent).v7p = function () {
    return this.u7p().n();
  };
  protoOf(TouchEvent).w7p = function (id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.t7p_1.get(id);
  };
  protoOf(TouchEvent).toString = function () {
    var tmp = this.l7p_1;
    var tmp_0 = this.v7p();
    var tmp_1 = this.u7p();
    return 'TouchEvent[' + tmp + '][' + tmp_0 + '](' + joinToString(tmp_1, ', ', VOID, VOID, VOID, VOID, TouchEvent$toString$lambda) + ')';
  };
  protoOf(TouchEvent).x7p = function (type) {
    this.l7p_1 = type;
    this.n7p_1 = Companion_getInstance_1().e1q();
    this.r7p_1.b3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.t7p_1.clear();
  };
  protoOf(TouchEvent).y7p = function () {
    this.s7p_1.b3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.u7p();
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.event.TouchEvent.endFrame.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = this_0.f1(tmp0);
      if (it.x1a()) {
        this.s7p_1.r(it);
      }
    }
  };
  protoOf(TouchEvent).z7p = function (id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.t7p_1.get(id);
    return tmp0_elvis_lhs == null ? this.a7q(id) : tmp0_elvis_lhs;
  };
  protoOf(TouchEvent).a7q = function (id) {
    var touch = this.q7p_1[this.r7p_1.n()];
    touch.z7o_1 = id;
    this.r7p_1.r(touch);
    // Inline function 'korlibs.datastructure.set' call
    var this_0 = this.t7p_1;
    var key = touch.z7o_1;
    // Inline function 'kotlin.js.asDynamic' call
    this_0.set(key, touch);
    return touch;
  };
  protoOf(TouchEvent).b7q = function (id, p, status, force, kind, button) {
    var touch = this.z7p(id);
    touch.a7p_1 = p;
    touch.c7p_1 = status;
    touch.b7p_1 = force;
    touch.d7p_1 = kind;
    touch.e7p_1 = button;
  };
  protoOf(TouchEvent).c7q = function (id, p, status, force, kind, button, $super) {
    status = status === VOID ? Status_KEEP_getInstance() : status;
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.b7q(id, p, status, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.b7q.call(this, id, p, status, force, kind, button);
    }
    return tmp;
  };
  protoOf(TouchEvent).d7q = function (touch) {
    this.b7q(touch.z7o_1, touch.a7p_1, touch.c7p_1, touch.b7p_1, touch.d7p_1, touch.e7p_1);
  };
  protoOf(TouchEvent).e7q = function (other) {
    this.l7p_1 = other.l7p_1;
    this.m7p_1 = other.m7p_1;
    this.n7p_1 = other.n7p_1;
    this.o7p_1 = other.o7p_1;
    this.p7p_1 = other.p7p_1;
    var inductionVariable = 0;
    var last = Companion_instance_18.i7p_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.q7p_1[n].g7p(other.q7p_1[n]);
      }
       while (inductionVariable < last);
    this.r7p_1.b3();
    this.s7p_1.b3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.t7p_1.clear();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = other.u7p();
    var n_0 = 0;
    while (n_0 < this_0.n()) {
      // Inline function 'korlibs.event.TouchEvent.copyFrom.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var otherTouch = this_0.f1(tmp0);
      var touch = this.q7p_1[otherTouch.y7o_1];
      this.r7p_1.r(touch);
      if (touch.x1a()) {
        this.s7p_1.r(touch);
      }
      // Inline function 'korlibs.datastructure.set' call
      var this_1 = this.t7p_1;
      var key = touch.z7o_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_1.set(key, touch);
    }
  };
  protoOf(TouchEvent).f7q = function () {
    return this.l7p_1.equals(Type_START_getInstance());
  };
  protoOf(TouchEvent).g7q = function () {
    return this.l7p_1.equals(Type_END_getInstance());
  };
  protoOf(TouchEvent).hashCode = function () {
    var result = this.l7p_1.hashCode();
    result = imul(result, 31) + this.m7p_1 | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.n7p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o7p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p7p_1) | 0;
    return result;
  };
  protoOf(TouchEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent))
      return false;
    var tmp0_other_with_cast = other instanceof TouchEvent ? other : THROW_CCE();
    if (!this.l7p_1.equals(tmp0_other_with_cast.l7p_1))
      return false;
    if (!(this.m7p_1 === tmp0_other_with_cast.m7p_1))
      return false;
    if (!equals(this.n7p_1, tmp0_other_with_cast.n7p_1))
      return false;
    if (!(this.o7p_1 === tmp0_other_with_cast.o7p_1))
      return false;
    if (!(this.p7p_1 === tmp0_other_with_cast.p7p_1))
      return false;
    return true;
  };
  function Companion_5() {
  }
  var Companion_instance_19;
  function Companion_getInstance_31() {
    return Companion_instance_19;
  }
  function ReshapeEvent(x, y, width, height) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? 0 : width;
    height = height === VOID ? 0 : height;
    TypedEvent.call(this, Companion_instance_19);
    this.k7q_1 = x;
    this.l7q_1 = y;
    this.m7q_1 = width;
    this.n7q_1 = height;
  }
  protoOf(ReshapeEvent).toString = function () {
    return 'ReshapeEvent(x=' + this.k7q_1 + ', y=' + this.l7q_1 + ', width=' + this.m7q_1 + ', height=' + this.n7q_1 + ')';
  };
  protoOf(ReshapeEvent).hashCode = function () {
    var result = this.k7q_1;
    result = imul(result, 31) + this.l7q_1 | 0;
    result = imul(result, 31) + this.m7q_1 | 0;
    result = imul(result, 31) + this.n7q_1 | 0;
    return result;
  };
  protoOf(ReshapeEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this.k7q_1 === tmp0_other_with_cast.k7q_1))
      return false;
    if (!(this.l7q_1 === tmp0_other_with_cast.l7q_1))
      return false;
    if (!(this.m7q_1 === tmp0_other_with_cast.m7q_1))
      return false;
    if (!(this.n7q_1 === tmp0_other_with_cast.n7q_1))
      return false;
    return true;
  };
  function StopPropagatingException() {
  }
  function Companion_6() {
  }
  var Companion_instance_20;
  function Companion_getInstance_32() {
    return Companion_instance_20;
  }
  function PauseEvent() {
    TypedEvent.call(this, Companion_instance_20);
  }
  function Companion_7() {
  }
  var Companion_instance_21;
  function Companion_getInstance_33() {
    return Companion_instance_21;
  }
  function ResumeEvent() {
    TypedEvent.call(this, Companion_instance_21);
  }
  function Companion_8() {
  }
  var Companion_instance_22;
  function Companion_getInstance_34() {
    return Companion_instance_22;
  }
  function StopEvent() {
    TypedEvent.call(this, Companion_instance_22);
  }
  function Companion_9() {
  }
  var Companion_instance_23;
  function Companion_getInstance_35() {
    return Companion_instance_23;
  }
  function DestroyEvent() {
    TypedEvent.call(this, Companion_instance_23);
  }
  function Companion_10() {
    Companion_instance_24 = this;
    RenderEvent.call(this);
  }
  var Companion_instance_24;
  function Companion_getInstance_36() {
    if (Companion_instance_24 == null)
      new Companion_10();
    return Companion_instance_24;
  }
  function RenderEvent() {
    Companion_getInstance_36();
    TypedEvent.call(this, Companion_getInstance_36());
    this.r7q_1 = true;
    this.s7q_1 = true;
  }
  protoOf(RenderEvent).toString = function () {
    return 'RenderEvent(update=' + this.r7q_1 + ', render=' + this.s7q_1 + ')';
  };
  function Companion_11() {
    Companion_instance_25 = this;
    InitEvent.call(this);
  }
  var Companion_instance_25;
  function Companion_getInstance_37() {
    if (Companion_instance_25 == null)
      new Companion_11();
    return Companion_instance_25;
  }
  function InitEvent() {
    Companion_getInstance_37();
    TypedEvent.call(this, Companion_getInstance_37());
  }
  function Companion_12() {
  }
  var Companion_instance_26;
  function Companion_getInstance_38() {
    return Companion_instance_26;
  }
  function DisposeEvent() {
    TypedEvent.call(this, Companion_instance_26);
  }
  function Companion_13() {
  }
  var Companion_instance_27;
  function Companion_getInstance_39() {
    return Companion_instance_27;
  }
  function FullScreenEvent(fullscreen) {
    fullscreen = fullscreen === VOID ? false : fullscreen;
    TypedEvent.call(this, Companion_instance_27);
    this.w7q_1 = fullscreen;
  }
  protoOf(FullScreenEvent).toString = function () {
    return 'FullScreenEvent(fullscreen=' + this.w7q_1 + ')';
  };
  protoOf(FullScreenEvent).hashCode = function () {
    return getBooleanHashCode(this.w7q_1);
  };
  protoOf(FullScreenEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this.w7q_1 === tmp0_other_with_cast.w7q_1))
      return false;
    return true;
  };
  var Type_START_instance_0;
  var Type_END_instance_0;
  var Type_DROP_instance;
  function Companion_14() {
    Companion_instance_28 = this;
    this.x7q_1 = values_3();
  }
  var Companion_instance_28;
  function Companion_getInstance_40() {
    Type_initEntries_3();
    if (Companion_instance_28 == null)
      new Companion_14();
    return Companion_instance_28;
  }
  function values_3() {
    return [Type_START_getInstance_0(), Type_END_getInstance_0(), Type_DROP_getInstance()];
  }
  var Type_entriesInitialized_3;
  function Type_initEntries_3() {
    if (Type_entriesInitialized_3)
      return Unit_instance;
    Type_entriesInitialized_3 = true;
    Type_START_instance_0 = new Type_3('START', 0);
    Type_END_instance_0 = new Type_3('END', 1);
    Type_DROP_instance = new Type_3('DROP', 2);
    Companion_getInstance_40();
  }
  function Type_3(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Type_START_getInstance_0() {
    Type_initEntries_3();
    return Type_START_instance_0;
  }
  function Type_END_getInstance_0() {
    Type_initEntries_3();
    return Type_END_instance_0;
  }
  function Type_DROP_getInstance() {
    Type_initEntries_3();
    return Type_DROP_instance;
  }
  function DropFileEvent(type, files) {
    type = type === VOID ? Type_START_getInstance_0() : type;
    files = files === VOID ? null : files;
    Event.call(this);
    this.a7r_1 = type;
    this.b7r_1 = files;
  }
  protoOf(DropFileEvent).u2f = function () {
    return this.a7r_1;
  };
  protoOf(DropFileEvent).toString = function () {
    return 'DropFileEvent(type=' + this.a7r_1 + ', files=' + this.b7r_1 + ')';
  };
  protoOf(DropFileEvent).hashCode = function () {
    var result = this.a7r_1.hashCode();
    result = imul(result, 31) + (this.b7r_1 == null ? 0 : hashCode(this.b7r_1)) | 0;
    return result;
  };
  protoOf(DropFileEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this.a7r_1.equals(tmp0_other_with_cast.a7r_1))
      return false;
    if (!equals(this.b7r_1, tmp0_other_with_cast.b7r_1))
      return false;
    return true;
  };
  function invoke_1(_this__u8e3s4, block) {
    block(_this__u8e3s4);
    return _this__u8e3s4;
  }
  var Mode_JS_instance;
  var Mode_Android_instance;
  var Mode_IOS_instance;
  var Mode_entriesInitialized;
  function Mode_initEntries() {
    if (Mode_entriesInitialized)
      return Unit_instance;
    Mode_entriesInitialized = true;
    Mode_JS_instance = new Mode('JS', 0);
    Mode_Android_instance = new Mode('Android', 1);
    Mode_IOS_instance = new Mode('IOS', 2);
  }
  function Mode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Mode_JS_getInstance() {
    Mode_initEntries();
    return Mode_JS_instance;
  }
  function TouchBuilder() {
    this.c7r_1 = new TouchEvent();
    this.d7r_1 = new TouchEvent();
    this.e7r_1 = Mode_JS_getInstance();
  }
  protoOf(TouchBuilder).f7r = function (type, scaleCoords) {
    this.d7r_1.o7p_1 = scaleCoords;
    this.d7r_1.x7p(type);
    if (this.e7r_1.ka_1 === 2) {
      this.d7r_1.e7q(this.c7r_1);
      this.d7r_1.l7p_1 = type;
      // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
      var this_0 = this.d7r_1.r7p_1;
      var n = 0;
      var m = 0;
      while (n < this_0.n()) {
        if (m >= 0 ? !(m === n) : false) {
          this_0.o(m, this_0.f1(n));
        }
        // Inline function 'korlibs.event.TouchBuilder.startFrame.<anonymous>' call
        var it = this_0.f1(n);
        var tmp;
        if (it.x1a()) {
          it.c7p_1 = Status_KEEP_getInstance();
          tmp = false;
        } else {
          // Inline function 'korlibs.datastructure.remove' call
          var this_1 = this.d7r_1.t7p_1;
          var key = it.z7o_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_1.delete(key);
          tmp = true;
        }
        if (tmp) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.n() > m) {
        this_0.h1(this_0.n() - 1 | 0);
      }
    }
  };
  protoOf(TouchBuilder).g7r = function () {
    switch (this.e7r_1.ka_1) {
      case 0:
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var this_0 = this.c7r_1.u7p();
        var n = 0;
        while (n < this_0.n()) {
          // Inline function 'korlibs.event.TouchBuilder.endFrame.<anonymous>' call
          var tmp0 = n;
          n = tmp0 + 1 | 0;
          var oldTouch = this_0.f1(tmp0);
          if (this.d7r_1.w7p(oldTouch.z7o_1) == null) {
            if (oldTouch.x1a()) {
              oldTouch.c7p_1 = Status_REMOVE_getInstance();
              this.d7r_1.d7q(oldTouch);
            }
          }
        }

        break;
      case 2:
        break;
      default:
        break;
    }
    this.d7r_1.y7p();
    this.c7r_1.e7q(this.d7r_1);
    return this.d7r_1;
  };
  protoOf(TouchBuilder).h7r = function (id, p, force, kind, button) {
    var touch = this.d7r_1.z7p(id);
    touch.a7p_1 = p;
    touch.b7p_1 = force;
    touch.d7p_1 = kind;
    touch.e7p_1 = button;
    if (this.e7r_1.ka_1 === 2) {
      var tmp = touch;
      switch (this.d7r_1.l7p_1.ka_1) {
        case 0:
          tmp.c7p_1 = Status_ADD_getInstance();
          break;
        case 1:
          tmp.c7p_1 = Status_REMOVE_getInstance();
          break;
        default:
          tmp.c7p_1 = Status_KEEP_getInstance();
          break;
      }
    } else {
      var oldTouch = this.c7r_1.w7p(id);
      touch.c7p_1 = oldTouch == null ? Status_ADD_getInstance() : Status_KEEP_getInstance();
    }
  };
  protoOf(TouchBuilder).i7r = function (id, p, force, kind, button, $super) {
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.h7r(id, p, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.h7r.call(this, id, p, force, kind, button);
    }
    return tmp;
  };
  function Companion_15() {
  }
  var Companion_instance_29;
  function Companion_getInstance_41() {
    return Companion_instance_29;
  }
  function GamePadUpdateEvent(gamepadsLength, gamepads) {
    gamepadsLength = gamepadsLength === VOID ? 0 : gamepadsLength;
    var tmp;
    if (gamepads === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(4), null);
      while (tmp_0 < 4) {
        var tmp_2 = tmp_0;
        tmp_1[tmp_2] = new GamepadInfo(tmp_2);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = gamepads;
    }
    gamepads = tmp;
    Event.call(this);
    this.l7r_1 = gamepadsLength;
    this.m7r_1 = gamepads;
  }
  protoOf(GamePadUpdateEvent).u2f = function () {
    return Companion_instance_29;
  };
  protoOf(GamePadUpdateEvent).n7r = function (that) {
    this.l7r_1 = that.l7r_1;
    var inductionVariable = 0;
    var last = this.m7r_1.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.m7r_1[n].v7r(that.m7r_1[n]);
      }
       while (inductionVariable < last);
  };
  protoOf(GamePadUpdateEvent).toString = function () {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.m7r_1;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      if (element.p7r_1) {
        destination.r(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      var tmp$ret$3 = item.w7r();
      destination_0.r(tmp$ret$3);
    }
    return 'GamePadUpdateEvent(' + destination_0 + ')';
  };
  protoOf(GamePadUpdateEvent).hashCode = function () {
    var result = this.l7r_1;
    result = imul(result, 31) + hashCode(this.m7r_1) | 0;
    return result;
  };
  protoOf(GamePadUpdateEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this.l7r_1 === tmp0_other_with_cast.l7r_1))
      return false;
    if (!equals(this.m7r_1, tmp0_other_with_cast.m7r_1))
      return false;
    return true;
  };
  var BatteryStatus_CHARGING_instance;
  var BatteryStatus_DISCHARGING_instance;
  var BatteryStatus_FULL_instance;
  var BatteryStatus_UNKNOWN_instance;
  var BatteryStatus_entriesInitialized;
  function BatteryStatus_initEntries() {
    if (BatteryStatus_entriesInitialized)
      return Unit_instance;
    BatteryStatus_entriesInitialized = true;
    BatteryStatus_CHARGING_instance = new BatteryStatus('CHARGING', 0);
    BatteryStatus_DISCHARGING_instance = new BatteryStatus('DISCHARGING', 1);
    BatteryStatus_FULL_instance = new BatteryStatus('FULL', 2);
    BatteryStatus_UNKNOWN_instance = new BatteryStatus('UNKNOWN', 3);
  }
  function BatteryStatus(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_16() {
    this.x7r_1 = 'Wireless Controller';
    this.y7r_1 = 4;
    this.z7r_1 = 0.075;
  }
  protoOf(Companion_16).a7s = function (value, margin, apply) {
    var tmp;
    if (apply) {
      // Inline function 'kotlin.math.absoluteValue' call
      tmp = Math.abs(value) < margin;
    } else {
      tmp = false;
    }
    if (tmp)
      return 0.0;
    return value;
  };
  protoOf(Companion_16).b7s = function (value, margin, apply, $super) {
    margin = margin === VOID ? 0.075 : margin;
    apply = apply === VOID ? true : apply;
    return $super === VOID ? this.a7s(value, margin, apply) : $super.a7s.call(this, value, margin, apply);
  };
  var Companion_instance_30;
  function Companion_getInstance_42() {
    return Companion_instance_30;
  }
  function BatteryStatus_UNKNOWN_getInstance() {
    BatteryStatus_initEntries();
    return BatteryStatus_UNKNOWN_instance;
  }
  function GamepadInfo(index, connected, name, rawButtons, batteryLevel, name2, batteryStatus) {
    index = index === VOID ? 0 : index;
    connected = connected === VOID ? false : connected;
    name = name === VOID ? null : name;
    rawButtons = rawButtons === VOID ? new Float32Array(32) : rawButtons;
    batteryLevel = batteryLevel === VOID ? 1.0 : batteryLevel;
    name2 = name2 === VOID ? Companion_instance_30.x7r_1 : name2;
    batteryStatus = batteryStatus === VOID ? BatteryStatus_UNKNOWN_getInstance() : batteryStatus;
    this.o7r_1 = index;
    this.p7r_1 = connected;
    this.q7r_1 = name;
    this.r7r_1 = rawButtons;
    this.s7r_1 = batteryLevel;
    this.t7r_1 = name2;
    this.u7r_1 = batteryStatus;
  }
  protoOf(GamepadInfo).c7s = function () {
    var tmp0_elvis_lhs = this.q7r_1;
    return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' - ' + this.t7r_1;
  };
  protoOf(GamepadInfo).v7r = function (that) {
    this.o7r_1 = that.o7r_1;
    this.q7r_1 = that.q7r_1;
    this.t7r_1 = that.t7r_1;
    this.p7r_1 = that.p7r_1;
    this.s7r_1 = that.s7r_1;
    this.u7r_1 = that.u7r_1;
    var tmp = that.r7r_1;
    var tmp_0 = this.r7r_1;
    // Inline function 'kotlin.math.min' call
    var a = this.r7r_1.length;
    var b = that.r7r_1.length;
    var tmp$ret$0 = Math.min(a, b);
    arraycopy(tmp, 0, tmp_0, 0, tmp$ret$0);
  };
  protoOf(GamepadInfo).d7s = function (button) {
    return this.r7r_1[button.g7s()];
  };
  protoOf(GamepadInfo).h7s = function (stick) {
    return Vector2D_init_$Create$(this.i7s(stick), this.j7s(stick));
  };
  protoOf(GamepadInfo).i7s = function (stick) {
    var tmp;
    switch (stick.ka_1) {
      case 0:
        tmp = this.d7s(GameButton_LX_getInstance());
        break;
      case 1:
        tmp = this.d7s(GameButton_RX_getInstance());
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(GamepadInfo).j7s = function (stick) {
    var tmp;
    switch (stick.ka_1) {
      case 0:
        tmp = this.d7s(GameButton_LY_getInstance());
        break;
      case 1:
        tmp = this.d7s(GameButton_RY_getInstance());
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(GamepadInfo).k7s = function (includeButtons) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.GamepadInfo.toStringEx.<anonymous>' call
    this_0.u5('Gamepad[' + this.o7r_1 + '][' + this.c7s() + ']');
    if (includeButtons) {
      this_0.u5('[');
      var count = 0;
      var indexedObject = values_6();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var button = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var value = this.d7s(button);
        if (!(value === 0.0)) {
          if (count > 0) {
            this_0.u5(',');
          }
          this_0.u5('' + button + '=' + get_niceStr(value));
          count = count + 1 | 0;
        }
      }
      this_0.u5(']');
    }
    return this_0.toString();
  };
  protoOf(GamepadInfo).w7r = function (includeButtons, $super) {
    includeButtons = includeButtons === VOID ? true : includeButtons;
    return $super === VOID ? this.k7s(includeButtons) : $super.k7s.call(this, includeButtons);
  };
  protoOf(GamepadInfo).toString = function () {
    return this.k7s(false);
  };
  var Type_CONNECTED_instance;
  var Type_DISCONNECTED_instance;
  function Companion_17() {
    Companion_instance_31 = this;
    this.l7s_1 = values_4();
  }
  protoOf(Companion_17).m7s = function (connected) {
    return connected ? Type_CONNECTED_getInstance() : Type_DISCONNECTED_getInstance();
  };
  var Companion_instance_31;
  function Companion_getInstance_43() {
    Type_initEntries_4();
    if (Companion_instance_31 == null)
      new Companion_17();
    return Companion_instance_31;
  }
  function values_4() {
    return [Type_CONNECTED_getInstance(), Type_DISCONNECTED_getInstance()];
  }
  var Type_entriesInitialized_4;
  function Type_initEntries_4() {
    if (Type_entriesInitialized_4)
      return Unit_instance;
    Type_entriesInitialized_4 = true;
    Type_CONNECTED_instance = new Type_4('CONNECTED', 0);
    Type_DISCONNECTED_instance = new Type_4('DISCONNECTED', 1);
    Companion_getInstance_43();
  }
  function Type_4(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Type_CONNECTED_getInstance() {
    Type_initEntries_4();
    return Type_CONNECTED_instance;
  }
  function Type_DISCONNECTED_getInstance() {
    Type_initEntries_4();
    return Type_DISCONNECTED_instance;
  }
  function GamePadConnectionEvent(type, gamepad) {
    type = type === VOID ? Type_CONNECTED_getInstance() : type;
    gamepad = gamepad === VOID ? 0 : gamepad;
    Event.call(this);
    this.p7s_1 = type;
    this.q7s_1 = gamepad;
  }
  protoOf(GamePadConnectionEvent).u2f = function () {
    return this.p7s_1;
  };
  protoOf(GamePadConnectionEvent).toString = function () {
    return 'GamePadConnectionEvent(type=' + this.p7s_1 + ', gamepad=' + this.q7s_1 + ')';
  };
  protoOf(GamePadConnectionEvent).hashCode = function () {
    var result = this.p7s_1.hashCode();
    result = imul(result, 31) + this.q7s_1 | 0;
    return result;
  };
  protoOf(GamePadConnectionEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this.p7s_1.equals(tmp0_other_with_cast.p7s_1))
      return false;
    if (!(this.q7s_1 === tmp0_other_with_cast.q7s_1))
      return false;
    return true;
  };
  var GameStick_LEFT_instance;
  var GameStick_RIGHT_instance;
  function Companion_18() {
    Companion_instance_32 = this;
    this.r7s_1 = values_5();
  }
  var Companion_instance_32;
  function Companion_getInstance_44() {
    GameStick_initEntries();
    if (Companion_instance_32 == null)
      new Companion_18();
    return Companion_instance_32;
  }
  function values_5() {
    return [GameStick_LEFT_getInstance(), GameStick_RIGHT_getInstance()];
  }
  var GameStick_entriesInitialized;
  function GameStick_initEntries() {
    if (GameStick_entriesInitialized)
      return Unit_instance;
    GameStick_entriesInitialized = true;
    GameStick_LEFT_instance = new GameStick('LEFT', 0, 0);
    GameStick_RIGHT_instance = new GameStick('RIGHT', 1, 1);
    Companion_getInstance_44();
  }
  function GameStick(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this.u7s_1 = id;
  }
  var GameButton_LEFT_instance;
  var GameButton_RIGHT_instance;
  var GameButton_UP_instance;
  var GameButton_DOWN_instance;
  var GameButton_BUTTON_SOUTH_instance;
  var GameButton_BUTTON_EAST_instance;
  var GameButton_BUTTON_WEST_instance;
  var GameButton_BUTTON_NORTH_instance;
  var GameButton_SELECT_instance;
  var GameButton_START_instance;
  var GameButton_SYSTEM_instance;
  var GameButton_L1_instance;
  var GameButton_R1_instance;
  var GameButton_L2_instance;
  var GameButton_R2_instance;
  var GameButton_L3_instance;
  var GameButton_R3_instance;
  var GameButton_LX_instance;
  var GameButton_LY_instance;
  var GameButton_RX_instance;
  var GameButton_RY_instance;
  var GameButton_BUTTON4_instance;
  var GameButton_BUTTON5_instance;
  var GameButton_BUTTON6_instance;
  var GameButton_BUTTON7_instance;
  var GameButton_BUTTON8_instance;
  var GameButton_RECORD_instance;
  var GameButton_DPADX_instance;
  var GameButton_DPADY_instance;
  function Companion_19() {
    Companion_instance_33 = this;
    this.v7s_1 = values_6();
    this.w7s_1 = 32;
  }
  var Companion_instance_33;
  function Companion_getInstance_45() {
    GameButton_initEntries();
    if (Companion_instance_33 == null)
      new Companion_19();
    return Companion_instance_33;
  }
  function values_6() {
    return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance(), GameButton_RECORD_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
  }
  var GameButton_entriesInitialized;
  function GameButton_initEntries() {
    if (GameButton_entriesInitialized)
      return Unit_instance;
    GameButton_entriesInitialized = true;
    GameButton_LEFT_instance = new GameButton('LEFT', 0);
    GameButton_RIGHT_instance = new GameButton('RIGHT', 1);
    GameButton_UP_instance = new GameButton('UP', 2);
    GameButton_DOWN_instance = new GameButton('DOWN', 3);
    GameButton_BUTTON_SOUTH_instance = new GameButton('BUTTON_SOUTH', 4);
    GameButton_BUTTON_EAST_instance = new GameButton('BUTTON_EAST', 5);
    GameButton_BUTTON_WEST_instance = new GameButton('BUTTON_WEST', 6);
    GameButton_BUTTON_NORTH_instance = new GameButton('BUTTON_NORTH', 7);
    GameButton_SELECT_instance = new GameButton('SELECT', 8);
    GameButton_START_instance = new GameButton('START', 9);
    GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10);
    GameButton_L1_instance = new GameButton('L1', 11);
    GameButton_R1_instance = new GameButton('R1', 12);
    GameButton_L2_instance = new GameButton('L2', 13);
    GameButton_R2_instance = new GameButton('R2', 14);
    GameButton_L3_instance = new GameButton('L3', 15);
    GameButton_R3_instance = new GameButton('R3', 16);
    GameButton_LX_instance = new GameButton('LX', 17);
    GameButton_LY_instance = new GameButton('LY', 18);
    GameButton_RX_instance = new GameButton('RX', 19);
    GameButton_RY_instance = new GameButton('RY', 20);
    GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21);
    GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22);
    GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23);
    GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24);
    GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25);
    GameButton_RECORD_instance = new GameButton('RECORD', 26);
    GameButton_DPADX_instance = new GameButton('DPADX', 27);
    GameButton_DPADY_instance = new GameButton('DPADY', 28);
    Companion_getInstance_45();
  }
  function GameButton(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(GameButton).g7s = function () {
    return this.ka_1;
  };
  function GamepadInfoEmitter(dispatcher) {
    this.x7s_1 = dispatcher;
    this.y7s_1 = booleanArray(4);
    this.z7s_1 = new GamePadUpdateEvent();
    this.a7t_1 = new GamePadConnectionEvent();
    this.b7t_1 = new IntArrayList();
  }
  protoOf(GamepadInfoEmitter).c7t = function () {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z7s_1.m7r_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateStart.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      this_0[tmp0].p7r_1 = false;
    }
    this.z7s_1.l7r_1 = 0;
  };
  protoOf(GamepadInfoEmitter).d7t = function (info) {
    var tmp0_this = this.z7s_1;
    var tmp1 = tmp0_this.l7r_1;
    tmp0_this.l7r_1 = tmp1 + 1 | 0;
    var index = tmp1;
    var pad = this.z7s_1.m7r_1[index];
    pad.v7r(info);
    pad.p7r_1 = true;
    pad.o7r_1 = index;
  };
  protoOf(GamepadInfoEmitter).e7t = function (out) {
    out.b3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z7s_1.m7r_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = this_0[tmp0];
      if (!(this.y7s_1[it.o7r_1] === it.p7r_1)) {
        this.y7s_1[it.o7r_1] = it.p7r_1;
        out.m1s(it.o7r_1);
        if (!it.p7r_1) {
          it.q7r_1 = null;
        }
        // Inline function 'kotlin.apply' call
        var this_1 = this.a7t_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>.<anonymous>' call
        this_1.p7s_1 = Companion_getInstance_43().m7s(it.p7r_1);
        this_1.q7s_1 = it.o7r_1;
        this.x7s_1.s7m(this_1);
      }
    }
    this.x7s_1.s7m(this.z7s_1);
    return out;
  };
  function GameStick_LEFT_getInstance() {
    GameStick_initEntries();
    return GameStick_LEFT_instance;
  }
  function GameStick_RIGHT_getInstance() {
    GameStick_initEntries();
    return GameStick_RIGHT_instance;
  }
  function GameButton_LEFT_getInstance() {
    GameButton_initEntries();
    return GameButton_LEFT_instance;
  }
  function GameButton_RIGHT_getInstance() {
    GameButton_initEntries();
    return GameButton_RIGHT_instance;
  }
  function GameButton_UP_getInstance() {
    GameButton_initEntries();
    return GameButton_UP_instance;
  }
  function GameButton_DOWN_getInstance() {
    GameButton_initEntries();
    return GameButton_DOWN_instance;
  }
  function GameButton_BUTTON_SOUTH_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON_SOUTH_instance;
  }
  function GameButton_BUTTON_EAST_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON_EAST_instance;
  }
  function GameButton_BUTTON_WEST_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON_WEST_instance;
  }
  function GameButton_BUTTON_NORTH_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON_NORTH_instance;
  }
  function GameButton_SELECT_getInstance() {
    GameButton_initEntries();
    return GameButton_SELECT_instance;
  }
  function GameButton_START_getInstance() {
    GameButton_initEntries();
    return GameButton_START_instance;
  }
  function GameButton_SYSTEM_getInstance() {
    GameButton_initEntries();
    return GameButton_SYSTEM_instance;
  }
  function GameButton_L1_getInstance() {
    GameButton_initEntries();
    return GameButton_L1_instance;
  }
  function GameButton_R1_getInstance() {
    GameButton_initEntries();
    return GameButton_R1_instance;
  }
  function GameButton_L2_getInstance() {
    GameButton_initEntries();
    return GameButton_L2_instance;
  }
  function GameButton_R2_getInstance() {
    GameButton_initEntries();
    return GameButton_R2_instance;
  }
  function GameButton_L3_getInstance() {
    GameButton_initEntries();
    return GameButton_L3_instance;
  }
  function GameButton_R3_getInstance() {
    GameButton_initEntries();
    return GameButton_R3_instance;
  }
  function GameButton_LX_getInstance() {
    GameButton_initEntries();
    return GameButton_LX_instance;
  }
  function GameButton_LY_getInstance() {
    GameButton_initEntries();
    return GameButton_LY_instance;
  }
  function GameButton_RX_getInstance() {
    GameButton_initEntries();
    return GameButton_RX_instance;
  }
  function GameButton_RY_getInstance() {
    GameButton_initEntries();
    return GameButton_RY_instance;
  }
  function GameButton_BUTTON4_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON4_instance;
  }
  function GameButton_BUTTON5_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON5_instance;
  }
  function GameButton_BUTTON6_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON6_instance;
  }
  function GameButton_BUTTON7_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON7_instance;
  }
  function GameButton_BUTTON8_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON8_instance;
  }
  function GameButton_RECORD_getInstance() {
    GameButton_initEntries();
    return GameButton_RECORD_instance;
  }
  function GameButton_DPADX_getInstance() {
    GameButton_initEntries();
    return GameButton_DPADX_instance;
  }
  function GameButton_DPADY_getInstance() {
    GameButton_initEntries();
    return GameButton_DPADY_instance;
  }
  var Key_SPACE_instance;
  var Key_APOSTROPHE_instance;
  var Key_COMMA_instance;
  var Key_MINUS_instance;
  var Key_PLUS_instance;
  var Key_PERIOD_instance;
  var Key_SLASH_instance;
  var Key_N0_instance;
  var Key_N1_instance;
  var Key_N2_instance;
  var Key_N3_instance;
  var Key_N4_instance;
  var Key_N5_instance;
  var Key_N6_instance;
  var Key_N7_instance;
  var Key_N8_instance;
  var Key_N9_instance;
  var Key_N11_instance;
  var Key_N12_instance;
  var Key_N3D_MODE_instance;
  var Key_SEMICOLON_instance;
  var Key_EQUAL_instance;
  var Key_AT_instance;
  var Key_A_instance;
  var Key_B_instance;
  var Key_C_instance;
  var Key_D_instance;
  var Key_E_instance;
  var Key_F_instance;
  var Key_G_instance;
  var Key_H_instance;
  var Key_I_instance;
  var Key_J_instance;
  var Key_K_instance;
  var Key_L_instance;
  var Key_M_instance;
  var Key_N_instance;
  var Key_O_instance;
  var Key_P_instance;
  var Key_Q_instance;
  var Key_R_instance;
  var Key_S_instance;
  var Key_T_instance;
  var Key_U_instance;
  var Key_V_instance;
  var Key_W_instance;
  var Key_X_instance;
  var Key_Y_instance;
  var Key_Z_instance;
  var Key_LEFT_BRACKET_instance;
  var Key_BACKSLASH_instance;
  var Key_RIGHT_BRACKET_instance;
  var Key_GRAVE_ACCENT_instance;
  var Key_WORLD_1_instance;
  var Key_WORLD_2_instance;
  var Key_ESCAPE_instance;
  var Key_META_instance;
  var Key_ENTER_instance;
  var Key_TAB_instance;
  var Key_BACKSPACE_instance;
  var Key_INSERT_instance;
  var Key_DELETE_instance;
  var Key_RIGHT_instance;
  var Key_LEFT_instance;
  var Key_DOWN_instance;
  var Key_UP_instance;
  var Key_PAGE_UP_instance;
  var Key_PAGE_DOWN_instance;
  var Key_FUNCTION_instance;
  var Key_HELP_instance;
  var Key_MUTE_instance;
  var Key_VOLUME_DOWN_instance;
  var Key_VOLUME_UP_instance;
  var Key_VOLUME_MUTE_instance;
  var Key_HOME_instance;
  var Key_END_instance;
  var Key_CAPS_LOCK_instance;
  var Key_SCROLL_LOCK_instance;
  var Key_NUM_LOCK_instance;
  var Key_PRINT_SCREEN_instance;
  var Key_PAUSE_instance;
  var Key_F1_instance;
  var Key_F2_instance;
  var Key_F3_instance;
  var Key_F4_instance;
  var Key_F5_instance;
  var Key_F6_instance;
  var Key_F7_instance;
  var Key_F8_instance;
  var Key_F9_instance;
  var Key_F10_instance;
  var Key_F11_instance;
  var Key_F12_instance;
  var Key_F13_instance;
  var Key_F14_instance;
  var Key_F15_instance;
  var Key_F16_instance;
  var Key_F17_instance;
  var Key_F18_instance;
  var Key_F19_instance;
  var Key_F20_instance;
  var Key_F21_instance;
  var Key_F22_instance;
  var Key_F23_instance;
  var Key_F24_instance;
  var Key_F25_instance;
  var Key_KP_0_instance;
  var Key_KP_1_instance;
  var Key_KP_2_instance;
  var Key_KP_3_instance;
  var Key_KP_4_instance;
  var Key_KP_5_instance;
  var Key_KP_6_instance;
  var Key_KP_7_instance;
  var Key_KP_8_instance;
  var Key_KP_9_instance;
  var Key_KP_DECIMAL_instance;
  var Key_KP_DIVIDE_instance;
  var Key_KP_MULTIPLY_instance;
  var Key_KP_SUBTRACT_instance;
  var Key_KP_ADD_instance;
  var Key_KP_COMMA_instance;
  var Key_KP_DOT_instance;
  var Key_KP_ENTER_instance;
  var Key_KP_EQUAL_instance;
  var Key_KP_SEPARATOR_instance;
  var Key_KP_LEFT_PAREN_instance;
  var Key_KP_RIGHT_PAREN_instance;
  var Key_SHIFT_instance;
  var Key_CONTROL_instance;
  var Key_ALT_instance;
  var Key_SUPER_instance;
  var Key_MENU_instance;
  var Key_BACK_instance;
  var Key_BACKQUOTE_instance;
  var Key_QUOTE_instance;
  var Key_KP_UP_instance;
  var Key_KP_DOWN_instance;
  var Key_KP_LEFT_instance;
  var Key_KP_RIGHT_instance;
  var Key_UNDERLINE_instance;
  var Key_SELECT_KEY_instance;
  var Key_CANCEL_instance;
  var Key_CLEAR_instance;
  var Key_OPEN_BRACKET_instance;
  var Key_CLOSE_BRACKET_instance;
  var Key_PLAY_instance;
  var Key_NONAME_instance;
  var Key_FINAL_instance;
  var Key_OEM102_instance;
  var Key_OEM1_instance;
  var Key_OEM2_instance;
  var Key_OEM3_instance;
  var Key_OEM4_instance;
  var Key_OEM5_instance;
  var Key_OEM6_instance;
  var Key_OEM7_instance;
  var Key_OEM8_instance;
  var Key_LEFT_MENU_instance;
  var Key_RIGHT_MENU_instance;
  var Key_SLEEP_instance;
  var Key_SNAPSHOT_instance;
  var Key_INFO_instance;
  var Key_XBUTTON1_instance;
  var Key_XBUTTON2_instance;
  var Key_XBUTTON3_instance;
  var Key_XBUTTON4_instance;
  var Key_XBUTTON5_instance;
  var Key_XBUTTON6_instance;
  var Key_XBUTTON7_instance;
  var Key_XBUTTON8_instance;
  var Key_XBUTTON9_instance;
  var Key_XBUTTON10_instance;
  var Key_XBUTTON11_instance;
  var Key_XBUTTON12_instance;
  var Key_XBUTTON13_instance;
  var Key_XBUTTON14_instance;
  var Key_XBUTTON15_instance;
  var Key_XBUTTON16_instance;
  var Key_XBUTTON_A_instance;
  var Key_XBUTTON_B_instance;
  var Key_XBUTTON_C_instance;
  var Key_XBUTTON_L1_instance;
  var Key_XBUTTON_L2_instance;
  var Key_XBUTTON_MODE_instance;
  var Key_XBUTTON_R1_instance;
  var Key_XBUTTON_R2_instance;
  var Key_XBUTTON_SELECT_instance;
  var Key_XBUTTON_START_instance;
  var Key_XBUTTON_THUMBL_instance;
  var Key_XBUTTON_THUMBR_instance;
  var Key_XBUTTON_X_instance;
  var Key_XBUTTON_Y_instance;
  var Key_XBUTTON_Z_instance;
  var Key_DPAD_CENTER_instance;
  var Key_DPAD_DOWN_instance;
  var Key_DPAD_DOWN_LEFT_instance;
  var Key_DPAD_DOWN_RIGHT_instance;
  var Key_DPAD_LEFT_instance;
  var Key_DPAD_RIGHT_instance;
  var Key_DPAD_UP_instance;
  var Key_DPAD_UP_LEFT_instance;
  var Key_DPAD_UP_RIGHT_instance;
  var Key_DVR_instance;
  var Key_EISU_instance;
  var Key_ENDCALL_instance;
  var Key_ENVELOPE_instance;
  var Key_EXPLORER_instance;
  var Key_FOCUS_instance;
  var Key_FORWARD_instance;
  var Key_GRAVE_instance;
  var Key_GUIDE_instance;
  var Key_HEADSETHOOK_instance;
  var Key_ABNT_C1_instance;
  var Key_ABNT_C2_instance;
  var Key_ATTN_instance;
  var Key_CRSEL_instance;
  var Key_EREOF_instance;
  var Key_EXECUTE_instance;
  var Key_EXSEL_instance;
  var Key_ICO_CLEAR_instance;
  var Key_ICO_HELP_instance;
  var Key_HENKAN_instance;
  var Key_PAIRING_instance;
  var Key_APP_SWITCH_instance;
  var Key_ASSIST_instance;
  var Key_AVR_INPUT_instance;
  var Key_AVR_POWER_instance;
  var Key_BOOKMARK_instance;
  var Key_BREAK_instance;
  var Key_CAPTIONS_instance;
  var Key_CAMERA_instance;
  var Key_CALL_instance;
  var Key_CALENDAR_instance;
  var Key_BRIGHTNESS_DOWN_instance;
  var Key_BRIGHTNESS_UP_instance;
  var Key_CHANNEL_DOWN_instance;
  var Key_CHANNEL_UP_instance;
  var Key_CALCULATOR_instance;
  var Key_CONTACTS_instance;
  var Key_NOTIFICATION_instance;
  var Key_COPY_instance;
  var Key_CUT_instance;
  var Key_PASTE_instance;
  var Key_SEARCH_instance;
  var Key_SETTINGS_instance;
  var Key_SOFT_LEFT_instance;
  var Key_SOFT_RIGHT_instance;
  var Key_SOFT_SLEEP_instance;
  var Key_STAR_instance;
  var Key_STB_INPUT_instance;
  var Key_STB_POWER_instance;
  var Key_STEM_1_instance;
  var Key_STEM_2_instance;
  var Key_STEM_3_instance;
  var Key_STEM_PRIMARY_instance;
  var Key_SWITCH_CHARSET_instance;
  var Key_SYM_instance;
  var Key_SYSRQ_instance;
  var Key_NUM_instance;
  var Key_TV_instance;
  var Key_TV_ANTENNA_CABLE_instance;
  var Key_TV_AUDIO_DESCRIPTION_instance;
  var Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance;
  var Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance;
  var Key_TV_CONTENTS_MENU_instance;
  var Key_TV_DATA_SERVICE_instance;
  var Key_TV_INPUT_instance;
  var Key_TV_INPUT_COMPONENT_1_instance;
  var Key_TV_INPUT_COMPONENT_2_instance;
  var Key_TV_INPUT_COMPOSITE_1_instance;
  var Key_TV_INPUT_COMPOSITE_2_instance;
  var Key_TV_INPUT_HDMI_1_instance;
  var Key_TV_INPUT_HDMI_2_instance;
  var Key_TV_INPUT_HDMI_3_instance;
  var Key_TV_INPUT_HDMI_4_instance;
  var Key_TV_INPUT_VGA_1_instance;
  var Key_TV_MEDIA_CONTEXT_MENU_instance;
  var Key_TV_NETWORK_instance;
  var Key_TV_NUMBER_ENTRY_instance;
  var Key_TV_POWER_instance;
  var Key_TV_RADIO_SERVICE_instance;
  var Key_TV_SATELLITE_instance;
  var Key_TV_SATELLITE_BS_instance;
  var Key_TV_SATELLITE_CS_instance;
  var Key_TV_SATELLITE_SERVICE_instance;
  var Key_TV_TELETEXT_instance;
  var Key_TV_TERRESTRIAL_ANALOG_instance;
  var Key_TV_TERRESTRIAL_DIGITAL_instance;
  var Key_TV_TIMER_PROGRAMMING_instance;
  var Key_TV_ZOOM_MODE_instance;
  var Key_VOICE_ASSIST_instance;
  var Key_WAKEUP_instance;
  var Key_WINDOW_instance;
  var Key_YEN_instance;
  var Key_ZENKAKU_HANKAKU_instance;
  var Key_ZOOM_IN_instance;
  var Key_ZOOM_OUT_instance;
  var Key_SYSTEM_NAVIGATION_DOWN_instance;
  var Key_SYSTEM_NAVIGATION_LEFT_instance;
  var Key_SYSTEM_NAVIGATION_RIGHT_instance;
  var Key_SYSTEM_NAVIGATION_UP_instance;
  var Key_PICTSYMBOLS_instance;
  var Key_POUND_instance;
  var Key_POWER_instance;
  var Key_PROG_BLUE_instance;
  var Key_PROG_GREEN_instance;
  var Key_PROG_RED_instance;
  var Key_PROG_YELLOW_instance;
  var Key_RO_instance;
  var Key_OEM_ATTN_instance;
  var Key_OEM_AUTO_instance;
  var Key_OEM_AX_instance;
  var Key_OEM_BACKTAB_instance;
  var Key_OEM_CLEAR_instance;
  var Key_OEM_COMMA_instance;
  var Key_OEM_COPY_instance;
  var Key_OEM_CUSEL_instance;
  var Key_OEM_ENLW_instance;
  var Key_OEM_FINISH_instance;
  var Key_OEM_FJ_LOYA_instance;
  var Key_OEM_FJ_MASSHOU_instance;
  var Key_OEM_FJ_ROYA_instance;
  var Key_OEM_FJ_TOUROKU_instance;
  var Key_OEM_JUMP_instance;
  var Key_OEM_MINUS_instance;
  var Key_OEM_PA1_instance;
  var Key_OEM_PA2_instance;
  var Key_OEM_PA3_instance;
  var Key_OEM_PERIOD_instance;
  var Key_OEM_PLUS_instance;
  var Key_OEM_RESET_instance;
  var Key_OEM_WSCTRL_instance;
  var Key_PA1_instance;
  var Key_PACKET_instance;
  var Key_PROCESSKEY_instance;
  var Key_ZOOM_instance;
  var Key_NONE_instance;
  var Key_ACCEPT_instance;
  var Key_APPS_instance;
  var Key_BROWSER_BACK_instance;
  var Key_BROWSER_FAVORITES_instance;
  var Key_BROWSER_FORWARD_instance;
  var Key_BROWSER_HOME_instance;
  var Key_BROWSER_REFRESH_instance;
  var Key_BROWSER_SEARCH_instance;
  var Key_BROWSER_STOP_instance;
  var Key_CAPITAL_instance;
  var Key_CONVERT_instance;
  var Key_ICO_00_instance;
  var Key_JUNJA_instance;
  var Key_KANA_instance;
  var Key_KANJI_instance;
  var Key_KATAKANA_HIRAGANA_instance;
  var Key_LANGUAGE_SWITCH_instance;
  var Key_MUHENKAN_instance;
  var Key_LAUNCH_APP1_instance;
  var Key_LAUNCH_APP2_instance;
  var Key_LAUNCH_MAIL_instance;
  var Key_LAUNCH_MEDIA_SELECT_instance;
  var Key_LEFT_BUTTON_instance;
  var Key_MIDDLE_BUTTON_instance;
  var Key_MUSIC_instance;
  var Key_MEDIA_NEXT_TRACK_instance;
  var Key_MEDIA_PLAY_PAUSE_instance;
  var Key_MEDIA_PREV_TRACK_instance;
  var Key_MEDIA_STOP_instance;
  var Key_MEDIA_PLAY_instance;
  var Key_MEDIA_PAUSE_instance;
  var Key_MEDIA_AUDIO_TRACK_instance;
  var Key_MEDIA_CLOSE_instance;
  var Key_MEDIA_EJECT_instance;
  var Key_MEDIA_FAST_FORWARD_instance;
  var Key_MEDIA_RECORD_instance;
  var Key_MEDIA_REWIND_instance;
  var Key_MEDIA_SKIP_BACKWARD_instance;
  var Key_MEDIA_SKIP_FORWARD_instance;
  var Key_MEDIA_STEP_BACKWARD_instance;
  var Key_MEDIA_STEP_FORWARD_instance;
  var Key_MEDIA_TOP_MENU_instance;
  var Key_MODECHANGE_instance;
  var Key_NEXT_instance;
  var Key_NONCONVERT_instance;
  var Key_OEM_FJ_JISHO_instance;
  var Key_PRIOR_instance;
  var Key_RIGHT_BUTTON_instance;
  var Key_LAST_CHANNEL_instance;
  var Key_MANNER_MODE_instance;
  var Key_NAVIGATE_IN_instance;
  var Key_NAVIGATE_NEXT_instance;
  var Key_NAVIGATE_OUT_instance;
  var Key_NAVIGATE_PREVIOUS_instance;
  var Key_HYPHEN_instance;
  var Key_UNDEFINED_instance;
  var Key_UNKNOWN_instance;
  function Companion_20() {
    Companion_instance_34 = this;
    this.f7t_1 = Key_UNKNOWN_getInstance().ka_1 + 1 | 0;
    this.g7t_1 = Key_ENTER_getInstance();
    this.h7t_1 = Key_N0_getInstance();
    this.i7t_1 = Key_N1_getInstance();
    this.j7t_1 = Key_N2_getInstance();
    this.k7t_1 = Key_N3_getInstance();
    this.l7t_1 = Key_N4_getInstance();
    this.m7t_1 = Key_N5_getInstance();
    this.n7t_1 = Key_N6_getInstance();
    this.o7t_1 = Key_N7_getInstance();
    this.p7t_1 = Key_N8_getInstance();
    this.q7t_1 = Key_N9_getInstance();
  }
  protoOf(Companion_20).r7t = function () {
    return Key_CONTROL_getInstance();
  };
  protoOf(Companion_20).s7t = function () {
    return Key_CONTROL_getInstance();
  };
  protoOf(Companion_20).t7t = function () {
    return Key_SHIFT_getInstance();
  };
  protoOf(Companion_20).u7t = function () {
    return Key_SHIFT_getInstance();
  };
  protoOf(Companion_20).v7t = function () {
    return Key_ALT_getInstance();
  };
  protoOf(Companion_20).w7t = function () {
    return Key_ALT_getInstance();
  };
  protoOf(Companion_20).x7t = function () {
    return Key_SUPER_getInstance();
  };
  protoOf(Companion_20).y7t = function () {
    return Key_SUPER_getInstance();
  };
  var Companion_instance_34;
  function Companion_getInstance_46() {
    Key_initEntries();
    if (Companion_instance_34 == null)
      new Companion_20();
    return Companion_instance_34;
  }
  var Key_entriesInitialized;
  function Key_initEntries() {
    if (Key_entriesInitialized)
      return Unit_instance;
    Key_entriesInitialized = true;
    Key_SPACE_instance = new Key('SPACE', 0);
    Key_APOSTROPHE_instance = new Key('APOSTROPHE', 1);
    Key_COMMA_instance = new Key('COMMA', 2);
    Key_MINUS_instance = new Key('MINUS', 3);
    Key_PLUS_instance = new Key('PLUS', 4);
    Key_PERIOD_instance = new Key('PERIOD', 5);
    Key_SLASH_instance = new Key('SLASH', 6);
    Key_N0_instance = new Key('N0', 7);
    Key_N1_instance = new Key('N1', 8);
    Key_N2_instance = new Key('N2', 9);
    Key_N3_instance = new Key('N3', 10);
    Key_N4_instance = new Key('N4', 11);
    Key_N5_instance = new Key('N5', 12);
    Key_N6_instance = new Key('N6', 13);
    Key_N7_instance = new Key('N7', 14);
    Key_N8_instance = new Key('N8', 15);
    Key_N9_instance = new Key('N9', 16);
    Key_N11_instance = new Key('N11', 17);
    Key_N12_instance = new Key('N12', 18);
    Key_N3D_MODE_instance = new Key('N3D_MODE', 19);
    Key_SEMICOLON_instance = new Key('SEMICOLON', 20);
    Key_EQUAL_instance = new Key('EQUAL', 21);
    Key_AT_instance = new Key('AT', 22);
    Key_A_instance = new Key('A', 23);
    Key_B_instance = new Key('B', 24);
    Key_C_instance = new Key('C', 25);
    Key_D_instance = new Key('D', 26);
    Key_E_instance = new Key('E', 27);
    Key_F_instance = new Key('F', 28);
    Key_G_instance = new Key('G', 29);
    Key_H_instance = new Key('H', 30);
    Key_I_instance = new Key('I', 31);
    Key_J_instance = new Key('J', 32);
    Key_K_instance = new Key('K', 33);
    Key_L_instance = new Key('L', 34);
    Key_M_instance = new Key('M', 35);
    Key_N_instance = new Key('N', 36);
    Key_O_instance = new Key('O', 37);
    Key_P_instance = new Key('P', 38);
    Key_Q_instance = new Key('Q', 39);
    Key_R_instance = new Key('R', 40);
    Key_S_instance = new Key('S', 41);
    Key_T_instance = new Key('T', 42);
    Key_U_instance = new Key('U', 43);
    Key_V_instance = new Key('V', 44);
    Key_W_instance = new Key('W', 45);
    Key_X_instance = new Key('X', 46);
    Key_Y_instance = new Key('Y', 47);
    Key_Z_instance = new Key('Z', 48);
    Key_LEFT_BRACKET_instance = new Key('LEFT_BRACKET', 49);
    Key_BACKSLASH_instance = new Key('BACKSLASH', 50);
    Key_RIGHT_BRACKET_instance = new Key('RIGHT_BRACKET', 51);
    Key_GRAVE_ACCENT_instance = new Key('GRAVE_ACCENT', 52);
    Key_WORLD_1_instance = new Key('WORLD_1', 53);
    Key_WORLD_2_instance = new Key('WORLD_2', 54);
    Key_ESCAPE_instance = new Key('ESCAPE', 55);
    Key_META_instance = new Key('META', 56);
    Key_ENTER_instance = new Key('ENTER', 57);
    Key_TAB_instance = new Key('TAB', 58);
    Key_BACKSPACE_instance = new Key('BACKSPACE', 59);
    Key_INSERT_instance = new Key('INSERT', 60);
    Key_DELETE_instance = new Key('DELETE', 61);
    Key_RIGHT_instance = new Key('RIGHT', 62);
    Key_LEFT_instance = new Key('LEFT', 63);
    Key_DOWN_instance = new Key('DOWN', 64);
    Key_UP_instance = new Key('UP', 65);
    Key_PAGE_UP_instance = new Key('PAGE_UP', 66);
    Key_PAGE_DOWN_instance = new Key('PAGE_DOWN', 67);
    Key_FUNCTION_instance = new Key('FUNCTION', 68);
    Key_HELP_instance = new Key('HELP', 69);
    Key_MUTE_instance = new Key('MUTE', 70);
    Key_VOLUME_DOWN_instance = new Key('VOLUME_DOWN', 71);
    Key_VOLUME_UP_instance = new Key('VOLUME_UP', 72);
    Key_VOLUME_MUTE_instance = new Key('VOLUME_MUTE', 73);
    Key_HOME_instance = new Key('HOME', 74);
    Key_END_instance = new Key('END', 75);
    Key_CAPS_LOCK_instance = new Key('CAPS_LOCK', 76);
    Key_SCROLL_LOCK_instance = new Key('SCROLL_LOCK', 77);
    Key_NUM_LOCK_instance = new Key('NUM_LOCK', 78);
    Key_PRINT_SCREEN_instance = new Key('PRINT_SCREEN', 79);
    Key_PAUSE_instance = new Key('PAUSE', 80);
    Key_F1_instance = new Key('F1', 81);
    Key_F2_instance = new Key('F2', 82);
    Key_F3_instance = new Key('F3', 83);
    Key_F4_instance = new Key('F4', 84);
    Key_F5_instance = new Key('F5', 85);
    Key_F6_instance = new Key('F6', 86);
    Key_F7_instance = new Key('F7', 87);
    Key_F8_instance = new Key('F8', 88);
    Key_F9_instance = new Key('F9', 89);
    Key_F10_instance = new Key('F10', 90);
    Key_F11_instance = new Key('F11', 91);
    Key_F12_instance = new Key('F12', 92);
    Key_F13_instance = new Key('F13', 93);
    Key_F14_instance = new Key('F14', 94);
    Key_F15_instance = new Key('F15', 95);
    Key_F16_instance = new Key('F16', 96);
    Key_F17_instance = new Key('F17', 97);
    Key_F18_instance = new Key('F18', 98);
    Key_F19_instance = new Key('F19', 99);
    Key_F20_instance = new Key('F20', 100);
    Key_F21_instance = new Key('F21', 101);
    Key_F22_instance = new Key('F22', 102);
    Key_F23_instance = new Key('F23', 103);
    Key_F24_instance = new Key('F24', 104);
    Key_F25_instance = new Key('F25', 105);
    Key_KP_0_instance = new Key('KP_0', 106);
    Key_KP_1_instance = new Key('KP_1', 107);
    Key_KP_2_instance = new Key('KP_2', 108);
    Key_KP_3_instance = new Key('KP_3', 109);
    Key_KP_4_instance = new Key('KP_4', 110);
    Key_KP_5_instance = new Key('KP_5', 111);
    Key_KP_6_instance = new Key('KP_6', 112);
    Key_KP_7_instance = new Key('KP_7', 113);
    Key_KP_8_instance = new Key('KP_8', 114);
    Key_KP_9_instance = new Key('KP_9', 115);
    Key_KP_DECIMAL_instance = new Key('KP_DECIMAL', 116);
    Key_KP_DIVIDE_instance = new Key('KP_DIVIDE', 117);
    Key_KP_MULTIPLY_instance = new Key('KP_MULTIPLY', 118);
    Key_KP_SUBTRACT_instance = new Key('KP_SUBTRACT', 119);
    Key_KP_ADD_instance = new Key('KP_ADD', 120);
    Key_KP_COMMA_instance = new Key('KP_COMMA', 121);
    Key_KP_DOT_instance = new Key('KP_DOT', 122);
    Key_KP_ENTER_instance = new Key('KP_ENTER', 123);
    Key_KP_EQUAL_instance = new Key('KP_EQUAL', 124);
    Key_KP_SEPARATOR_instance = new Key('KP_SEPARATOR', 125);
    Key_KP_LEFT_PAREN_instance = new Key('KP_LEFT_PAREN', 126);
    Key_KP_RIGHT_PAREN_instance = new Key('KP_RIGHT_PAREN', 127);
    Key_SHIFT_instance = new Key('SHIFT', 128);
    Key_CONTROL_instance = new Key('CONTROL', 129);
    Key_ALT_instance = new Key('ALT', 130);
    Key_SUPER_instance = new Key('SUPER', 131);
    Key_MENU_instance = new Key('MENU', 132);
    Key_BACK_instance = new Key('BACK', 133);
    Key_BACKQUOTE_instance = new Key('BACKQUOTE', 134);
    Key_QUOTE_instance = new Key('QUOTE', 135);
    Key_KP_UP_instance = new Key('KP_UP', 136);
    Key_KP_DOWN_instance = new Key('KP_DOWN', 137);
    Key_KP_LEFT_instance = new Key('KP_LEFT', 138);
    Key_KP_RIGHT_instance = new Key('KP_RIGHT', 139);
    Key_UNDERLINE_instance = new Key('UNDERLINE', 140);
    Key_SELECT_KEY_instance = new Key('SELECT_KEY', 141);
    Key_CANCEL_instance = new Key('CANCEL', 142);
    Key_CLEAR_instance = new Key('CLEAR', 143);
    Key_OPEN_BRACKET_instance = new Key('OPEN_BRACKET', 144);
    Key_CLOSE_BRACKET_instance = new Key('CLOSE_BRACKET', 145);
    Key_PLAY_instance = new Key('PLAY', 146);
    Key_NONAME_instance = new Key('NONAME', 147);
    Key_FINAL_instance = new Key('FINAL', 148);
    Key_OEM102_instance = new Key('OEM102', 149);
    Key_OEM1_instance = new Key('OEM1', 150);
    Key_OEM2_instance = new Key('OEM2', 151);
    Key_OEM3_instance = new Key('OEM3', 152);
    Key_OEM4_instance = new Key('OEM4', 153);
    Key_OEM5_instance = new Key('OEM5', 154);
    Key_OEM6_instance = new Key('OEM6', 155);
    Key_OEM7_instance = new Key('OEM7', 156);
    Key_OEM8_instance = new Key('OEM8', 157);
    Key_LEFT_MENU_instance = new Key('LEFT_MENU', 158);
    Key_RIGHT_MENU_instance = new Key('RIGHT_MENU', 159);
    Key_SLEEP_instance = new Key('SLEEP', 160);
    Key_SNAPSHOT_instance = new Key('SNAPSHOT', 161);
    Key_INFO_instance = new Key('INFO', 162);
    Key_XBUTTON1_instance = new Key('XBUTTON1', 163);
    Key_XBUTTON2_instance = new Key('XBUTTON2', 164);
    Key_XBUTTON3_instance = new Key('XBUTTON3', 165);
    Key_XBUTTON4_instance = new Key('XBUTTON4', 166);
    Key_XBUTTON5_instance = new Key('XBUTTON5', 167);
    Key_XBUTTON6_instance = new Key('XBUTTON6', 168);
    Key_XBUTTON7_instance = new Key('XBUTTON7', 169);
    Key_XBUTTON8_instance = new Key('XBUTTON8', 170);
    Key_XBUTTON9_instance = new Key('XBUTTON9', 171);
    Key_XBUTTON10_instance = new Key('XBUTTON10', 172);
    Key_XBUTTON11_instance = new Key('XBUTTON11', 173);
    Key_XBUTTON12_instance = new Key('XBUTTON12', 174);
    Key_XBUTTON13_instance = new Key('XBUTTON13', 175);
    Key_XBUTTON14_instance = new Key('XBUTTON14', 176);
    Key_XBUTTON15_instance = new Key('XBUTTON15', 177);
    Key_XBUTTON16_instance = new Key('XBUTTON16', 178);
    Key_XBUTTON_A_instance = new Key('XBUTTON_A', 179);
    Key_XBUTTON_B_instance = new Key('XBUTTON_B', 180);
    Key_XBUTTON_C_instance = new Key('XBUTTON_C', 181);
    Key_XBUTTON_L1_instance = new Key('XBUTTON_L1', 182);
    Key_XBUTTON_L2_instance = new Key('XBUTTON_L2', 183);
    Key_XBUTTON_MODE_instance = new Key('XBUTTON_MODE', 184);
    Key_XBUTTON_R1_instance = new Key('XBUTTON_R1', 185);
    Key_XBUTTON_R2_instance = new Key('XBUTTON_R2', 186);
    Key_XBUTTON_SELECT_instance = new Key('XBUTTON_SELECT', 187);
    Key_XBUTTON_START_instance = new Key('XBUTTON_START', 188);
    Key_XBUTTON_THUMBL_instance = new Key('XBUTTON_THUMBL', 189);
    Key_XBUTTON_THUMBR_instance = new Key('XBUTTON_THUMBR', 190);
    Key_XBUTTON_X_instance = new Key('XBUTTON_X', 191);
    Key_XBUTTON_Y_instance = new Key('XBUTTON_Y', 192);
    Key_XBUTTON_Z_instance = new Key('XBUTTON_Z', 193);
    Key_DPAD_CENTER_instance = new Key('DPAD_CENTER', 194);
    Key_DPAD_DOWN_instance = new Key('DPAD_DOWN', 195);
    Key_DPAD_DOWN_LEFT_instance = new Key('DPAD_DOWN_LEFT', 196);
    Key_DPAD_DOWN_RIGHT_instance = new Key('DPAD_DOWN_RIGHT', 197);
    Key_DPAD_LEFT_instance = new Key('DPAD_LEFT', 198);
    Key_DPAD_RIGHT_instance = new Key('DPAD_RIGHT', 199);
    Key_DPAD_UP_instance = new Key('DPAD_UP', 200);
    Key_DPAD_UP_LEFT_instance = new Key('DPAD_UP_LEFT', 201);
    Key_DPAD_UP_RIGHT_instance = new Key('DPAD_UP_RIGHT', 202);
    Key_DVR_instance = new Key('DVR', 203);
    Key_EISU_instance = new Key('EISU', 204);
    Key_ENDCALL_instance = new Key('ENDCALL', 205);
    Key_ENVELOPE_instance = new Key('ENVELOPE', 206);
    Key_EXPLORER_instance = new Key('EXPLORER', 207);
    Key_FOCUS_instance = new Key('FOCUS', 208);
    Key_FORWARD_instance = new Key('FORWARD', 209);
    Key_GRAVE_instance = new Key('GRAVE', 210);
    Key_GUIDE_instance = new Key('GUIDE', 211);
    Key_HEADSETHOOK_instance = new Key('HEADSETHOOK', 212);
    Key_ABNT_C1_instance = new Key('ABNT_C1', 213);
    Key_ABNT_C2_instance = new Key('ABNT_C2', 214);
    Key_ATTN_instance = new Key('ATTN', 215);
    Key_CRSEL_instance = new Key('CRSEL', 216);
    Key_EREOF_instance = new Key('EREOF', 217);
    Key_EXECUTE_instance = new Key('EXECUTE', 218);
    Key_EXSEL_instance = new Key('EXSEL', 219);
    Key_ICO_CLEAR_instance = new Key('ICO_CLEAR', 220);
    Key_ICO_HELP_instance = new Key('ICO_HELP', 221);
    Key_HENKAN_instance = new Key('HENKAN', 222);
    Key_PAIRING_instance = new Key('PAIRING', 223);
    Key_APP_SWITCH_instance = new Key('APP_SWITCH', 224);
    Key_ASSIST_instance = new Key('ASSIST', 225);
    Key_AVR_INPUT_instance = new Key('AVR_INPUT', 226);
    Key_AVR_POWER_instance = new Key('AVR_POWER', 227);
    Key_BOOKMARK_instance = new Key('BOOKMARK', 228);
    Key_BREAK_instance = new Key('BREAK', 229);
    Key_CAPTIONS_instance = new Key('CAPTIONS', 230);
    Key_CAMERA_instance = new Key('CAMERA', 231);
    Key_CALL_instance = new Key('CALL', 232);
    Key_CALENDAR_instance = new Key('CALENDAR', 233);
    Key_BRIGHTNESS_DOWN_instance = new Key('BRIGHTNESS_DOWN', 234);
    Key_BRIGHTNESS_UP_instance = new Key('BRIGHTNESS_UP', 235);
    Key_CHANNEL_DOWN_instance = new Key('CHANNEL_DOWN', 236);
    Key_CHANNEL_UP_instance = new Key('CHANNEL_UP', 237);
    Key_CALCULATOR_instance = new Key('CALCULATOR', 238);
    Key_CONTACTS_instance = new Key('CONTACTS', 239);
    Key_NOTIFICATION_instance = new Key('NOTIFICATION', 240);
    Key_COPY_instance = new Key('COPY', 241);
    Key_CUT_instance = new Key('CUT', 242);
    Key_PASTE_instance = new Key('PASTE', 243);
    Key_SEARCH_instance = new Key('SEARCH', 244);
    Key_SETTINGS_instance = new Key('SETTINGS', 245);
    Key_SOFT_LEFT_instance = new Key('SOFT_LEFT', 246);
    Key_SOFT_RIGHT_instance = new Key('SOFT_RIGHT', 247);
    Key_SOFT_SLEEP_instance = new Key('SOFT_SLEEP', 248);
    Key_STAR_instance = new Key('STAR', 249);
    Key_STB_INPUT_instance = new Key('STB_INPUT', 250);
    Key_STB_POWER_instance = new Key('STB_POWER', 251);
    Key_STEM_1_instance = new Key('STEM_1', 252);
    Key_STEM_2_instance = new Key('STEM_2', 253);
    Key_STEM_3_instance = new Key('STEM_3', 254);
    Key_STEM_PRIMARY_instance = new Key('STEM_PRIMARY', 255);
    Key_SWITCH_CHARSET_instance = new Key('SWITCH_CHARSET', 256);
    Key_SYM_instance = new Key('SYM', 257);
    Key_SYSRQ_instance = new Key('SYSRQ', 258);
    Key_NUM_instance = new Key('NUM', 259);
    Key_TV_instance = new Key('TV', 260);
    Key_TV_ANTENNA_CABLE_instance = new Key('TV_ANTENNA_CABLE', 261);
    Key_TV_AUDIO_DESCRIPTION_instance = new Key('TV_AUDIO_DESCRIPTION', 262);
    Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_DOWN', 263);
    Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_UP', 264);
    Key_TV_CONTENTS_MENU_instance = new Key('TV_CONTENTS_MENU', 265);
    Key_TV_DATA_SERVICE_instance = new Key('TV_DATA_SERVICE', 266);
    Key_TV_INPUT_instance = new Key('TV_INPUT', 267);
    Key_TV_INPUT_COMPONENT_1_instance = new Key('TV_INPUT_COMPONENT_1', 268);
    Key_TV_INPUT_COMPONENT_2_instance = new Key('TV_INPUT_COMPONENT_2', 269);
    Key_TV_INPUT_COMPOSITE_1_instance = new Key('TV_INPUT_COMPOSITE_1', 270);
    Key_TV_INPUT_COMPOSITE_2_instance = new Key('TV_INPUT_COMPOSITE_2', 271);
    Key_TV_INPUT_HDMI_1_instance = new Key('TV_INPUT_HDMI_1', 272);
    Key_TV_INPUT_HDMI_2_instance = new Key('TV_INPUT_HDMI_2', 273);
    Key_TV_INPUT_HDMI_3_instance = new Key('TV_INPUT_HDMI_3', 274);
    Key_TV_INPUT_HDMI_4_instance = new Key('TV_INPUT_HDMI_4', 275);
    Key_TV_INPUT_VGA_1_instance = new Key('TV_INPUT_VGA_1', 276);
    Key_TV_MEDIA_CONTEXT_MENU_instance = new Key('TV_MEDIA_CONTEXT_MENU', 277);
    Key_TV_NETWORK_instance = new Key('TV_NETWORK', 278);
    Key_TV_NUMBER_ENTRY_instance = new Key('TV_NUMBER_ENTRY', 279);
    Key_TV_POWER_instance = new Key('TV_POWER', 280);
    Key_TV_RADIO_SERVICE_instance = new Key('TV_RADIO_SERVICE', 281);
    Key_TV_SATELLITE_instance = new Key('TV_SATELLITE', 282);
    Key_TV_SATELLITE_BS_instance = new Key('TV_SATELLITE_BS', 283);
    Key_TV_SATELLITE_CS_instance = new Key('TV_SATELLITE_CS', 284);
    Key_TV_SATELLITE_SERVICE_instance = new Key('TV_SATELLITE_SERVICE', 285);
    Key_TV_TELETEXT_instance = new Key('TV_TELETEXT', 286);
    Key_TV_TERRESTRIAL_ANALOG_instance = new Key('TV_TERRESTRIAL_ANALOG', 287);
    Key_TV_TERRESTRIAL_DIGITAL_instance = new Key('TV_TERRESTRIAL_DIGITAL', 288);
    Key_TV_TIMER_PROGRAMMING_instance = new Key('TV_TIMER_PROGRAMMING', 289);
    Key_TV_ZOOM_MODE_instance = new Key('TV_ZOOM_MODE', 290);
    Key_VOICE_ASSIST_instance = new Key('VOICE_ASSIST', 291);
    Key_WAKEUP_instance = new Key('WAKEUP', 292);
    Key_WINDOW_instance = new Key('WINDOW', 293);
    Key_YEN_instance = new Key('YEN', 294);
    Key_ZENKAKU_HANKAKU_instance = new Key('ZENKAKU_HANKAKU', 295);
    Key_ZOOM_IN_instance = new Key('ZOOM_IN', 296);
    Key_ZOOM_OUT_instance = new Key('ZOOM_OUT', 297);
    Key_SYSTEM_NAVIGATION_DOWN_instance = new Key('SYSTEM_NAVIGATION_DOWN', 298);
    Key_SYSTEM_NAVIGATION_LEFT_instance = new Key('SYSTEM_NAVIGATION_LEFT', 299);
    Key_SYSTEM_NAVIGATION_RIGHT_instance = new Key('SYSTEM_NAVIGATION_RIGHT', 300);
    Key_SYSTEM_NAVIGATION_UP_instance = new Key('SYSTEM_NAVIGATION_UP', 301);
    Key_PICTSYMBOLS_instance = new Key('PICTSYMBOLS', 302);
    Key_POUND_instance = new Key('POUND', 303);
    Key_POWER_instance = new Key('POWER', 304);
    Key_PROG_BLUE_instance = new Key('PROG_BLUE', 305);
    Key_PROG_GREEN_instance = new Key('PROG_GREEN', 306);
    Key_PROG_RED_instance = new Key('PROG_RED', 307);
    Key_PROG_YELLOW_instance = new Key('PROG_YELLOW', 308);
    Key_RO_instance = new Key('RO', 309);
    Key_OEM_ATTN_instance = new Key('OEM_ATTN', 310);
    Key_OEM_AUTO_instance = new Key('OEM_AUTO', 311);
    Key_OEM_AX_instance = new Key('OEM_AX', 312);
    Key_OEM_BACKTAB_instance = new Key('OEM_BACKTAB', 313);
    Key_OEM_CLEAR_instance = new Key('OEM_CLEAR', 314);
    Key_OEM_COMMA_instance = new Key('OEM_COMMA', 315);
    Key_OEM_COPY_instance = new Key('OEM_COPY', 316);
    Key_OEM_CUSEL_instance = new Key('OEM_CUSEL', 317);
    Key_OEM_ENLW_instance = new Key('OEM_ENLW', 318);
    Key_OEM_FINISH_instance = new Key('OEM_FINISH', 319);
    Key_OEM_FJ_LOYA_instance = new Key('OEM_FJ_LOYA', 320);
    Key_OEM_FJ_MASSHOU_instance = new Key('OEM_FJ_MASSHOU', 321);
    Key_OEM_FJ_ROYA_instance = new Key('OEM_FJ_ROYA', 322);
    Key_OEM_FJ_TOUROKU_instance = new Key('OEM_FJ_TOUROKU', 323);
    Key_OEM_JUMP_instance = new Key('OEM_JUMP', 324);
    Key_OEM_MINUS_instance = new Key('OEM_MINUS', 325);
    Key_OEM_PA1_instance = new Key('OEM_PA1', 326);
    Key_OEM_PA2_instance = new Key('OEM_PA2', 327);
    Key_OEM_PA3_instance = new Key('OEM_PA3', 328);
    Key_OEM_PERIOD_instance = new Key('OEM_PERIOD', 329);
    Key_OEM_PLUS_instance = new Key('OEM_PLUS', 330);
    Key_OEM_RESET_instance = new Key('OEM_RESET', 331);
    Key_OEM_WSCTRL_instance = new Key('OEM_WSCTRL', 332);
    Key_PA1_instance = new Key('PA1', 333);
    Key_PACKET_instance = new Key('PACKET', 334);
    Key_PROCESSKEY_instance = new Key('PROCESSKEY', 335);
    Key_ZOOM_instance = new Key('ZOOM', 336);
    Key_NONE_instance = new Key('NONE', 337);
    Key_ACCEPT_instance = new Key('ACCEPT', 338);
    Key_APPS_instance = new Key('APPS', 339);
    Key_BROWSER_BACK_instance = new Key('BROWSER_BACK', 340);
    Key_BROWSER_FAVORITES_instance = new Key('BROWSER_FAVORITES', 341);
    Key_BROWSER_FORWARD_instance = new Key('BROWSER_FORWARD', 342);
    Key_BROWSER_HOME_instance = new Key('BROWSER_HOME', 343);
    Key_BROWSER_REFRESH_instance = new Key('BROWSER_REFRESH', 344);
    Key_BROWSER_SEARCH_instance = new Key('BROWSER_SEARCH', 345);
    Key_BROWSER_STOP_instance = new Key('BROWSER_STOP', 346);
    Key_CAPITAL_instance = new Key('CAPITAL', 347);
    Key_CONVERT_instance = new Key('CONVERT', 348);
    Key_ICO_00_instance = new Key('ICO_00', 349);
    Key_JUNJA_instance = new Key('JUNJA', 350);
    Key_KANA_instance = new Key('KANA', 351);
    Key_KANJI_instance = new Key('KANJI', 352);
    Key_KATAKANA_HIRAGANA_instance = new Key('KATAKANA_HIRAGANA', 353);
    Key_LANGUAGE_SWITCH_instance = new Key('LANGUAGE_SWITCH', 354);
    Key_MUHENKAN_instance = new Key('MUHENKAN', 355);
    Key_LAUNCH_APP1_instance = new Key('LAUNCH_APP1', 356);
    Key_LAUNCH_APP2_instance = new Key('LAUNCH_APP2', 357);
    Key_LAUNCH_MAIL_instance = new Key('LAUNCH_MAIL', 358);
    Key_LAUNCH_MEDIA_SELECT_instance = new Key('LAUNCH_MEDIA_SELECT', 359);
    Key_LEFT_BUTTON_instance = new Key('LEFT_BUTTON', 360);
    Key_MIDDLE_BUTTON_instance = new Key('MIDDLE_BUTTON', 361);
    Key_MUSIC_instance = new Key('MUSIC', 362);
    Key_MEDIA_NEXT_TRACK_instance = new Key('MEDIA_NEXT_TRACK', 363);
    Key_MEDIA_PLAY_PAUSE_instance = new Key('MEDIA_PLAY_PAUSE', 364);
    Key_MEDIA_PREV_TRACK_instance = new Key('MEDIA_PREV_TRACK', 365);
    Key_MEDIA_STOP_instance = new Key('MEDIA_STOP', 366);
    Key_MEDIA_PLAY_instance = new Key('MEDIA_PLAY', 367);
    Key_MEDIA_PAUSE_instance = new Key('MEDIA_PAUSE', 368);
    Key_MEDIA_AUDIO_TRACK_instance = new Key('MEDIA_AUDIO_TRACK', 369);
    Key_MEDIA_CLOSE_instance = new Key('MEDIA_CLOSE', 370);
    Key_MEDIA_EJECT_instance = new Key('MEDIA_EJECT', 371);
    Key_MEDIA_FAST_FORWARD_instance = new Key('MEDIA_FAST_FORWARD', 372);
    Key_MEDIA_RECORD_instance = new Key('MEDIA_RECORD', 373);
    Key_MEDIA_REWIND_instance = new Key('MEDIA_REWIND', 374);
    Key_MEDIA_SKIP_BACKWARD_instance = new Key('MEDIA_SKIP_BACKWARD', 375);
    Key_MEDIA_SKIP_FORWARD_instance = new Key('MEDIA_SKIP_FORWARD', 376);
    Key_MEDIA_STEP_BACKWARD_instance = new Key('MEDIA_STEP_BACKWARD', 377);
    Key_MEDIA_STEP_FORWARD_instance = new Key('MEDIA_STEP_FORWARD', 378);
    Key_MEDIA_TOP_MENU_instance = new Key('MEDIA_TOP_MENU', 379);
    Key_MODECHANGE_instance = new Key('MODECHANGE', 380);
    Key_NEXT_instance = new Key('NEXT', 381);
    Key_NONCONVERT_instance = new Key('NONCONVERT', 382);
    Key_OEM_FJ_JISHO_instance = new Key('OEM_FJ_JISHO', 383);
    Key_PRIOR_instance = new Key('PRIOR', 384);
    Key_RIGHT_BUTTON_instance = new Key('RIGHT_BUTTON', 385);
    Key_LAST_CHANNEL_instance = new Key('LAST_CHANNEL', 386);
    Key_MANNER_MODE_instance = new Key('MANNER_MODE', 387);
    Key_NAVIGATE_IN_instance = new Key('NAVIGATE_IN', 388);
    Key_NAVIGATE_NEXT_instance = new Key('NAVIGATE_NEXT', 389);
    Key_NAVIGATE_OUT_instance = new Key('NAVIGATE_OUT', 390);
    Key_NAVIGATE_PREVIOUS_instance = new Key('NAVIGATE_PREVIOUS', 391);
    Key_HYPHEN_instance = new Key('HYPHEN', 392);
    Key_UNDEFINED_instance = new Key('UNDEFINED', 393);
    Key_UNKNOWN_instance = new Key('UNKNOWN', 394);
    Companion_getInstance_46();
  }
  function Key(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(Key).b7u = function () {
    switch (this.ka_1) {
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
        return true;
      default:
        return false;
    }
  };
  function Key_SPACE_getInstance() {
    Key_initEntries();
    return Key_SPACE_instance;
  }
  function Key_APOSTROPHE_getInstance() {
    Key_initEntries();
    return Key_APOSTROPHE_instance;
  }
  function Key_COMMA_getInstance() {
    Key_initEntries();
    return Key_COMMA_instance;
  }
  function Key_MINUS_getInstance() {
    Key_initEntries();
    return Key_MINUS_instance;
  }
  function Key_PLUS_getInstance() {
    Key_initEntries();
    return Key_PLUS_instance;
  }
  function Key_PERIOD_getInstance() {
    Key_initEntries();
    return Key_PERIOD_instance;
  }
  function Key_SLASH_getInstance() {
    Key_initEntries();
    return Key_SLASH_instance;
  }
  function Key_N0_getInstance() {
    Key_initEntries();
    return Key_N0_instance;
  }
  function Key_N1_getInstance() {
    Key_initEntries();
    return Key_N1_instance;
  }
  function Key_N2_getInstance() {
    Key_initEntries();
    return Key_N2_instance;
  }
  function Key_N3_getInstance() {
    Key_initEntries();
    return Key_N3_instance;
  }
  function Key_N4_getInstance() {
    Key_initEntries();
    return Key_N4_instance;
  }
  function Key_N5_getInstance() {
    Key_initEntries();
    return Key_N5_instance;
  }
  function Key_N6_getInstance() {
    Key_initEntries();
    return Key_N6_instance;
  }
  function Key_N7_getInstance() {
    Key_initEntries();
    return Key_N7_instance;
  }
  function Key_N8_getInstance() {
    Key_initEntries();
    return Key_N8_instance;
  }
  function Key_N9_getInstance() {
    Key_initEntries();
    return Key_N9_instance;
  }
  function Key_SEMICOLON_getInstance() {
    Key_initEntries();
    return Key_SEMICOLON_instance;
  }
  function Key_A_getInstance() {
    Key_initEntries();
    return Key_A_instance;
  }
  function Key_B_getInstance() {
    Key_initEntries();
    return Key_B_instance;
  }
  function Key_C_getInstance() {
    Key_initEntries();
    return Key_C_instance;
  }
  function Key_D_getInstance() {
    Key_initEntries();
    return Key_D_instance;
  }
  function Key_E_getInstance() {
    Key_initEntries();
    return Key_E_instance;
  }
  function Key_F_getInstance() {
    Key_initEntries();
    return Key_F_instance;
  }
  function Key_G_getInstance() {
    Key_initEntries();
    return Key_G_instance;
  }
  function Key_H_getInstance() {
    Key_initEntries();
    return Key_H_instance;
  }
  function Key_I_getInstance() {
    Key_initEntries();
    return Key_I_instance;
  }
  function Key_J_getInstance() {
    Key_initEntries();
    return Key_J_instance;
  }
  function Key_K_getInstance() {
    Key_initEntries();
    return Key_K_instance;
  }
  function Key_L_getInstance() {
    Key_initEntries();
    return Key_L_instance;
  }
  function Key_M_getInstance() {
    Key_initEntries();
    return Key_M_instance;
  }
  function Key_N_getInstance() {
    Key_initEntries();
    return Key_N_instance;
  }
  function Key_O_getInstance() {
    Key_initEntries();
    return Key_O_instance;
  }
  function Key_P_getInstance() {
    Key_initEntries();
    return Key_P_instance;
  }
  function Key_Q_getInstance() {
    Key_initEntries();
    return Key_Q_instance;
  }
  function Key_R_getInstance() {
    Key_initEntries();
    return Key_R_instance;
  }
  function Key_S_getInstance() {
    Key_initEntries();
    return Key_S_instance;
  }
  function Key_T_getInstance() {
    Key_initEntries();
    return Key_T_instance;
  }
  function Key_U_getInstance() {
    Key_initEntries();
    return Key_U_instance;
  }
  function Key_V_getInstance() {
    Key_initEntries();
    return Key_V_instance;
  }
  function Key_W_getInstance() {
    Key_initEntries();
    return Key_W_instance;
  }
  function Key_X_getInstance() {
    Key_initEntries();
    return Key_X_instance;
  }
  function Key_Y_getInstance() {
    Key_initEntries();
    return Key_Y_instance;
  }
  function Key_Z_getInstance() {
    Key_initEntries();
    return Key_Z_instance;
  }
  function Key_ESCAPE_getInstance() {
    Key_initEntries();
    return Key_ESCAPE_instance;
  }
  function Key_META_getInstance() {
    Key_initEntries();
    return Key_META_instance;
  }
  function Key_ENTER_getInstance() {
    Key_initEntries();
    return Key_ENTER_instance;
  }
  function Key_TAB_getInstance() {
    Key_initEntries();
    return Key_TAB_instance;
  }
  function Key_BACKSPACE_getInstance() {
    Key_initEntries();
    return Key_BACKSPACE_instance;
  }
  function Key_INSERT_getInstance() {
    Key_initEntries();
    return Key_INSERT_instance;
  }
  function Key_DELETE_getInstance() {
    Key_initEntries();
    return Key_DELETE_instance;
  }
  function Key_RIGHT_getInstance() {
    Key_initEntries();
    return Key_RIGHT_instance;
  }
  function Key_LEFT_getInstance() {
    Key_initEntries();
    return Key_LEFT_instance;
  }
  function Key_DOWN_getInstance() {
    Key_initEntries();
    return Key_DOWN_instance;
  }
  function Key_UP_getInstance() {
    Key_initEntries();
    return Key_UP_instance;
  }
  function Key_PAGE_UP_getInstance() {
    Key_initEntries();
    return Key_PAGE_UP_instance;
  }
  function Key_PAGE_DOWN_getInstance() {
    Key_initEntries();
    return Key_PAGE_DOWN_instance;
  }
  function Key_HOME_getInstance() {
    Key_initEntries();
    return Key_HOME_instance;
  }
  function Key_END_getInstance() {
    Key_initEntries();
    return Key_END_instance;
  }
  function Key_F1_getInstance() {
    Key_initEntries();
    return Key_F1_instance;
  }
  function Key_F2_getInstance() {
    Key_initEntries();
    return Key_F2_instance;
  }
  function Key_F3_getInstance() {
    Key_initEntries();
    return Key_F3_instance;
  }
  function Key_F4_getInstance() {
    Key_initEntries();
    return Key_F4_instance;
  }
  function Key_F5_getInstance() {
    Key_initEntries();
    return Key_F5_instance;
  }
  function Key_F6_getInstance() {
    Key_initEntries();
    return Key_F6_instance;
  }
  function Key_F7_getInstance() {
    Key_initEntries();
    return Key_F7_instance;
  }
  function Key_F8_getInstance() {
    Key_initEntries();
    return Key_F8_instance;
  }
  function Key_F9_getInstance() {
    Key_initEntries();
    return Key_F9_instance;
  }
  function Key_F10_getInstance() {
    Key_initEntries();
    return Key_F10_instance;
  }
  function Key_F11_getInstance() {
    Key_initEntries();
    return Key_F11_instance;
  }
  function Key_F12_getInstance() {
    Key_initEntries();
    return Key_F12_instance;
  }
  function Key_F13_getInstance() {
    Key_initEntries();
    return Key_F13_instance;
  }
  function Key_F14_getInstance() {
    Key_initEntries();
    return Key_F14_instance;
  }
  function Key_F15_getInstance() {
    Key_initEntries();
    return Key_F15_instance;
  }
  function Key_F16_getInstance() {
    Key_initEntries();
    return Key_F16_instance;
  }
  function Key_F17_getInstance() {
    Key_initEntries();
    return Key_F17_instance;
  }
  function Key_F18_getInstance() {
    Key_initEntries();
    return Key_F18_instance;
  }
  function Key_F19_getInstance() {
    Key_initEntries();
    return Key_F19_instance;
  }
  function Key_F20_getInstance() {
    Key_initEntries();
    return Key_F20_instance;
  }
  function Key_F21_getInstance() {
    Key_initEntries();
    return Key_F21_instance;
  }
  function Key_F22_getInstance() {
    Key_initEntries();
    return Key_F22_instance;
  }
  function Key_F23_getInstance() {
    Key_initEntries();
    return Key_F23_instance;
  }
  function Key_F24_getInstance() {
    Key_initEntries();
    return Key_F24_instance;
  }
  function Key_F25_getInstance() {
    Key_initEntries();
    return Key_F25_instance;
  }
  function Key_SHIFT_getInstance() {
    Key_initEntries();
    return Key_SHIFT_instance;
  }
  function Key_CONTROL_getInstance() {
    Key_initEntries();
    return Key_CONTROL_instance;
  }
  function Key_ALT_getInstance() {
    Key_initEntries();
    return Key_ALT_instance;
  }
  function Key_SUPER_getInstance() {
    Key_initEntries();
    return Key_SUPER_instance;
  }
  function Key_QUOTE_getInstance() {
    Key_initEntries();
    return Key_QUOTE_instance;
  }
  function Key_UNKNOWN_getInstance() {
    Key_initEntries();
    return Key_UNKNOWN_instance;
  }
  var MouseButton_LEFT_instance;
  var MouseButton_MIDDLE_instance;
  var MouseButton_RIGHT_instance;
  var MouseButton_BUTTON3_instance;
  var MouseButton_BUTTON4_instance;
  var MouseButton_BUTTON5_instance;
  var MouseButton_BUTTON6_instance;
  var MouseButton_BUTTON7_instance;
  var MouseButton_BUTTON_WHEEL_instance;
  var MouseButton_BUTTON_UNKNOWN_instance;
  var MouseButton_NONE_instance;
  function Companion_21() {
    Companion_instance_35 = this;
    this.c7u_1 = MouseButton_NONE_getInstance().ka_1 + 1 | 0;
    this.d7u_1 = values_7();
  }
  protoOf(Companion_21).f1 = function (id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.d7u_1;
    var tmp;
    if (id >= 0 ? id <= get_lastIndex(this_0) : false) {
      tmp = this_0[id];
    } else {
      // Inline function 'korlibs.event.Companion.get.<anonymous>' call
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  };
  var Companion_instance_35;
  function Companion_getInstance_47() {
    MouseButton_initEntries();
    if (Companion_instance_35 == null)
      new Companion_21();
    return Companion_instance_35;
  }
  function values_7() {
    return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance(), MouseButton_NONE_getInstance()];
  }
  var MouseButton_entriesInitialized;
  function MouseButton_initEntries() {
    if (MouseButton_entriesInitialized)
      return Unit_instance;
    MouseButton_entriesInitialized = true;
    MouseButton_LEFT_instance = new MouseButton('LEFT', 0, 0);
    MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 1, 1);
    MouseButton_RIGHT_instance = new MouseButton('RIGHT', 2, 2);
    MouseButton_BUTTON3_instance = new MouseButton('BUTTON3', 3, 3);
    MouseButton_BUTTON4_instance = new MouseButton('BUTTON4', 4, 4);
    MouseButton_BUTTON5_instance = new MouseButton('BUTTON5', 5, 5);
    MouseButton_BUTTON6_instance = new MouseButton('BUTTON6', 6, 6);
    MouseButton_BUTTON7_instance = new MouseButton('BUTTON7', 7, 7);
    MouseButton_BUTTON_WHEEL_instance = new MouseButton('BUTTON_WHEEL', 8, 8);
    MouseButton_BUTTON_UNKNOWN_instance = new MouseButton('BUTTON_UNKNOWN', 9, 10);
    MouseButton_NONE_instance = new MouseButton('NONE', 10, 11, 0);
    Companion_getInstance_47();
  }
  function MouseButton(name, ordinal, id, bits) {
    bits = bits === VOID ? 1 << id : bits;
    Enum.call(this, name, ordinal);
    this.g7u_1 = id;
    this.h7u_1 = bits;
  }
  function MouseButton_LEFT_getInstance() {
    MouseButton_initEntries();
    return MouseButton_LEFT_instance;
  }
  function MouseButton_MIDDLE_getInstance() {
    MouseButton_initEntries();
    return MouseButton_MIDDLE_instance;
  }
  function MouseButton_RIGHT_getInstance() {
    MouseButton_initEntries();
    return MouseButton_RIGHT_instance;
  }
  function MouseButton_BUTTON3_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON3_instance;
  }
  function MouseButton_BUTTON4_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON4_instance;
  }
  function MouseButton_BUTTON5_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON5_instance;
  }
  function MouseButton_BUTTON6_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON6_instance;
  }
  function MouseButton_BUTTON7_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON7_instance;
  }
  function MouseButton_BUTTON_WHEEL_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON_WHEEL_instance;
  }
  function MouseButton_BUTTON_UNKNOWN_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON_UNKNOWN_instance;
  }
  function MouseButton_NONE_getInstance() {
    MouseButton_initEntries();
    return MouseButton_NONE_instance;
  }
  function Companion_22() {
    Companion_instance_36 = this;
    this.i7u_1 = Companion_getInstance_2().r24('AG');
    this.j7u_1 = 96.0;
  }
  var Companion_instance_36;
  function Companion_getInstance_48() {
    if (Companion_instance_36 == null)
      new Companion_22();
    return Companion_instance_36;
  }
  function AG() {
    Companion_getInstance_48();
    this.k7u_1 = new Mixin();
    this.l7u_1 = AGFrameBuffer_init_$Create$(true);
    this.m7u_1 = 0;
    this.n7u_1 = new AGStats();
  }
  protoOf(AG).h23 = function (_set____db54di) {
    this.k7u_1.h23(_set____db54di);
  };
  protoOf(AG).i23 = function () {
    return this.k7u_1.i23();
  };
  protoOf(AG).o7u = function () {
    return this.l7u_1;
  };
  protoOf(AG).p7u = function () {
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_48().i7u_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.f25(level)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      this_0.g25(level, this);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_48().i7u_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.f25(level_0)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      var tmp$ret$2 = 'AG.contextLost()';
      this_1.g25(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    this.m7u_1 = this.m7u_1 + 1 | 0;
  };
  protoOf(AG).q7u = function () {
    return this.r7u(AGFinish_instance);
  };
  protoOf(AG).s7u = function () {
    return Unit_instance;
  };
  protoOf(AG).y7p = function () {
    return Unit_instance;
  };
  protoOf(AG).r7u = function (command) {
    return Unit_instance;
  };
  protoOf(AG).t7u = function (frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    return this.r7u(new AGClear(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil));
  };
  protoOf(AG).u7u = function (frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    return this.r7u(new AGBatch(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances));
  };
  function draw(_this__u8e3s4, frameBuffer, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    indices = indices === VOID ? null : indices;
    indexType = indexType === VOID ? Companion_getInstance_53().a7v_1 : indexType;
    drawOffset = drawOffset === VOID ? 0 : drawOffset;
    blending = blending === VOID ? Companion_getInstance_54().e7v_1 : blending;
    uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_70().i7v_1 : uniformBlocks;
    textureUnits = textureUnits === VOID ? Companion_instance_37.k7v() : textureUnits;
    stencilRef = stencilRef === VOID ? Companion_getInstance_55().m7v_1 : stencilRef;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_56().o7v_1 : stencilOpFunc;
    colorMask = colorMask === VOID ? Companion_getInstance_57().s7v_1 : colorMask;
    depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_62().w7v_1 : depthAndFrontFace;
    scissor = scissor === VOID ? Companion_getInstance_58().a7w_1 : scissor;
    cullFace = cullFace === VOID ? Companion_getInstance_63().c7w_1 : cullFace;
    instances = instances === VOID ? 1 : instances;
    return _this__u8e3s4.u7u(frameBuffer.g7w_1, frameBuffer.t7w(), vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances);
  }
  function Immutable(parentFeatures, graphicExtensions, isInstancedSupported, isUniformBuffersSupported, isVertexArraysSupported, isStorageMultisampleSupported, isFloatTextureSupported) {
    parentFeatures = parentFeatures === VOID ? null : parentFeatures;
    graphicExtensions = graphicExtensions === VOID ? emptySet() : graphicExtensions;
    isInstancedSupported = isInstancedSupported === VOID ? false : isInstancedSupported;
    isUniformBuffersSupported = isUniformBuffersSupported === VOID ? false : isUniformBuffersSupported;
    isVertexArraysSupported = isVertexArraysSupported === VOID ? false : isVertexArraysSupported;
    isStorageMultisampleSupported = isStorageMultisampleSupported === VOID ? false : isStorageMultisampleSupported;
    isFloatTextureSupported = isFloatTextureSupported === VOID ? false : isFloatTextureSupported;
    this.u7w_1 = parentFeatures;
    this.v7w_1 = graphicExtensions;
    this.w7w_1 = isInstancedSupported;
    this.x7w_1 = isUniformBuffersSupported;
    this.y7w_1 = isVertexArraysSupported;
    this.z7w_1 = isStorageMultisampleSupported;
    this.a7x_1 = isFloatTextureSupported;
  }
  protoOf(Immutable).v7u = function () {
    return this.u7w_1;
  };
  protoOf(Immutable).w7u = function () {
    return this.x7w_1;
  };
  protoOf(Immutable).x7u = function () {
    return this.y7w_1;
  };
  protoOf(Immutable).toString = function () {
    return 'Immutable(parentFeatures=' + this.u7w_1 + ', graphicExtensions=' + this.v7w_1 + ', isInstancedSupported=' + this.w7w_1 + ', isUniformBuffersSupported=' + this.x7w_1 + ', isVertexArraysSupported=' + this.y7w_1 + ', isStorageMultisampleSupported=' + this.z7w_1 + ', isFloatTextureSupported=' + this.a7x_1 + ')';
  };
  protoOf(Immutable).hashCode = function () {
    var result = this.u7w_1 == null ? 0 : hashCode(this.u7w_1);
    result = imul(result, 31) + hashCode(this.v7w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w7w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x7w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y7w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z7w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a7x_1) | 0;
    return result;
  };
  protoOf(Immutable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Immutable))
      return false;
    var tmp0_other_with_cast = other instanceof Immutable ? other : THROW_CCE();
    if (!equals(this.u7w_1, tmp0_other_with_cast.u7w_1))
      return false;
    if (!equals(this.v7w_1, tmp0_other_with_cast.v7w_1))
      return false;
    if (!(this.w7w_1 === tmp0_other_with_cast.w7w_1))
      return false;
    if (!(this.x7w_1 === tmp0_other_with_cast.x7w_1))
      return false;
    if (!(this.y7w_1 === tmp0_other_with_cast.y7w_1))
      return false;
    if (!(this.z7w_1 === tmp0_other_with_cast.z7w_1))
      return false;
    if (!(this.a7x_1 === tmp0_other_with_cast.a7x_1))
      return false;
    return true;
  };
  function AGFeatures() {
  }
  function draw_0(_this__u8e3s4, batch) {
    return batch.c7x(_this__u8e3s4);
  }
  function draw_1(_this__u8e3s4, batch) {
    return batch.c7x(_this__u8e3s4);
  }
  function AGBuffer() {
    AGObject.call(this);
    this.a7y_1 = null;
  }
  protoOf(AGBuffer).b7y = function (data, offset, length) {
    return this.c7y(_Int8Buffer___get_buffer__impl__q0gulb(_Int8Buffer___init__impl__e20lvc(data, offset, length)));
  };
  protoOf(AGBuffer).d7y = function (data, offset, length) {
    return this.c7y(sliceWithSize(data, offset, length));
  };
  protoOf(AGBuffer).c7y = function (data) {
    if (data.x36() < 1024) {
      if ((!(this.a7y_1 == null) ? ensureNotNull(this.a7y_1).x36() === data.x36() : false) ? arrayequal(ensureNotNull(this.a7y_1), 0, data, 0, data.x36()) : false)
        return this;
    }
    this.a7y_1 = clone(data);
    this.i7y();
    return this;
  };
  protoOf(AGBuffer).toString = function () {
    var tmp0_safe_receiver = this.a7y_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x36();
    return 'AGBuffer(' + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + ')';
  };
  function Companion_23() {
    this.j7v_1 = 8;
  }
  protoOf(Companion_23).k7v = function () {
    return AGTextureUnits_init_$Create$();
  };
  var Companion_instance_37;
  function Companion_getInstance_49() {
    return Companion_instance_37;
  }
  function AGTextureUnits_init_$Init$(size, $this) {
    size = size === VOID ? Companion_instance_37.j7v_1 : size;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    AGTextureUnits.call($this, tmp$ret$0, _AGTextureUnitInfoArray___init__impl__c77rdb_0(size));
    return $this;
  }
  function AGTextureUnits_init_$Create$(size) {
    return AGTextureUnits_init_$Init$(size, objectCreate(protoOf(AGTextureUnits)));
  }
  function AGTextureUnits(textures, infos) {
    this.k7y_1 = textures;
    this.l7y_1 = infos;
  }
  protoOf(AGTextureUnits).n = function () {
    return this.k7y_1.length;
  };
  protoOf(AGTextureUnits).m7y = function (index, texture, info) {
    this.k7y_1[index] = texture;
    AGTextureUnitInfoArray__set_impl_s95rfh(this.l7y_1, index, info);
  };
  protoOf(AGTextureUnits).n7y = function (sampler, texture, info) {
    this.m7y(sampler.z7y_1, texture, info);
  };
  protoOf(AGTextureUnits).b7z = function (sampler, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_51().d7z_1 : info;
    var tmp;
    if ($super === VOID) {
      this.n7y(sampler, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.n7y.call(this, sampler, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  };
  protoOf(AGTextureUnits).b3 = function () {
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.m7y(n, null, Companion_getInstance_51().d7z_1);
      }
       while (inductionVariable < last);
  };
  protoOf(AGTextureUnits).g1s = function () {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.k7y_1.slice();
    return new AGTextureUnits(tmp$ret$1, AGTextureUnitInfoArray__copyOf_impl_z2w8z3(this.l7y_1));
  };
  protoOf(AGTextureUnits).toString = function () {
    return 'AGTextureUnits(textures=' + toString(this.k7y_1) + ', infos=' + new AGTextureUnitInfoArray(this.l7y_1) + ')';
  };
  protoOf(AGTextureUnits).hashCode = function () {
    var result = hashCode(this.k7y_1);
    result = imul(result, 31) + AGTextureUnitInfoArray__hashCode_impl_siosps(this.l7y_1) | 0;
    return result;
  };
  protoOf(AGTextureUnits).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AGTextureUnits))
      return false;
    var tmp0_other_with_cast = other instanceof AGTextureUnits ? other : THROW_CCE();
    if (!equals(this.k7y_1, tmp0_other_with_cast.k7y_1))
      return false;
    if (!equals(this.l7y_1, tmp0_other_with_cast.l7y_1))
      return false;
    return true;
  };
  function AGFrameBuffer_init_$Init$(isMain, id, $this) {
    isMain = isMain === VOID ? false : isMain;
    id = id === VOID ? -1 : id;
    AGFrameBuffer.call($this, new AGFrameBufferBase(isMain), id);
    return $this;
  }
  function AGFrameBuffer_init_$Create$(isMain, id) {
    return AGFrameBuffer_init_$Init$(isMain, id, objectCreate(protoOf(AGFrameBuffer)));
  }
  function Companion_24() {
    this.e7z_1 = 128;
    this.f7z_1 = 128;
  }
  var Companion_instance_38;
  function Companion_getInstance_50() {
    return Companion_instance_38;
  }
  function markAsDirty($this) {
  }
  function AGFrameBuffer(base, id) {
    id = id === VOID ? -1 : id;
    this.g7w_1 = base;
    this.h7w_1 = id;
    this.i7w_1 = 1;
    this.j7w_1 = true;
    this.k7w_1 = true;
    this.l7w_1 = 0;
    this.m7w_1 = 0;
    this.n7w_1 = 128;
    this.o7w_1 = 128;
    this.p7w_1 = 128;
    this.q7w_1 = 128;
    this.r7w_1 = RectangleI_init_$Create$();
    this.s7w_1 = null;
  }
  protoOf(AGFrameBuffer).g7z = function () {
    return this.g7w_1.g7z();
  };
  protoOf(AGFrameBuffer).o7z = function () {
    return this.g7w_1.l7z_1;
  };
  protoOf(AGFrameBuffer).p7z = function () {
    return this.g7w_1.m7z_1;
  };
  protoOf(AGFrameBuffer).t7w = function () {
    return AGFrameBufferInfo__withHasStencil_impl_nbaemo(AGFrameBufferInfo__withHasDepth_impl_fjgbiv(AGFrameBufferInfo__withSamples_impl_83818f(AGFrameBufferInfo__withBounds_impl_sg0n3x(_AGFrameBufferInfo___init__impl__dbxiro(new Long(0, 0)), this.l7w_1, this.m7w_1, this.n7w_1, this.o7w_1), this.i7w_1), this.k7w_1), this.j7w_1);
  };
  protoOf(AGFrameBuffer).q7z = function (width, height) {
    return this.r7z(0, 0, width, height);
  };
  protoOf(AGFrameBuffer).s7z = function (x, y, width, height, fullWidth, fullHeight) {
    if (((((this.l7w_1 === x ? this.m7w_1 === y : false) ? this.n7w_1 === width : false) ? this.o7w_1 === height : false) ? this.p7w_1 === fullWidth : false) ? this.q7w_1 === fullHeight : false)
      return true;
    this.p7z().h80(new NullBitmap(width, height));
    this.g7w_1.n7z_1 = Companion_getInstance_3().x37(imul(imul(fullWidth, fullHeight), 8));
    this.l7w_1 = x;
    this.m7w_1 = y;
    this.n7w_1 = width;
    this.o7w_1 = height;
    this.p7w_1 = fullWidth;
    this.q7w_1 = fullHeight;
    markAsDirty(this);
    return false;
  };
  protoOf(AGFrameBuffer).r7z = function (x, y, width, height, fullWidth, fullHeight, $super) {
    fullWidth = fullWidth === VOID ? width : fullWidth;
    fullHeight = fullHeight === VOID ? height : fullHeight;
    return $super === VOID ? this.s7z(x, y, width, height, fullWidth, fullHeight) : $super.s7z.call(this, x, y, width, height, fullWidth, fullHeight);
  };
  protoOf(AGFrameBuffer).p21 = function () {
    this.g7w_1.p21();
  };
  protoOf(AGFrameBuffer).i80 = function (samples) {
    if (this.i7w_1 === samples)
      return Unit_instance;
    this.i7w_1 = samples;
    markAsDirty(this);
  };
  protoOf(AGFrameBuffer).j80 = function (hasDepth, hasStencil) {
    if (this.k7w_1 === hasDepth ? this.j7w_1 === hasStencil : false)
      return Unit_instance;
    this.k7w_1 = hasDepth;
    this.j7w_1 = hasStencil;
    markAsDirty(this);
  };
  protoOf(AGFrameBuffer).toString = function () {
    return 'AGFrameBuffer(' + (this.o7z() ? 'main' : '' + this.h7w_1) + ', ' + this.n7w_1 + ', ' + this.o7w_1 + ')';
  };
  function checkBitmaps($this, bmp) {
    if (!bmp.a3a_1) {
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = $this.y7z_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.f25(level)) {
        // Inline function 'korlibs.graphics.AGTexture.checkBitmaps.<anonymous>' call
        var tmp$ret$0 = 'Trying to upload a non-premultiplied bitmap: ' + bmp + '. This will cause rendering artifacts';
        this_0.g25(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
  }
  function AGTexture(targetKind) {
    targetKind = targetKind === VOID ? Companion_getInstance_64().k80_1 : targetKind;
    AGObject.call(this);
    this.x7z_1 = targetKind;
    this.y7z_1 = Companion_getInstance_2().r24('AGTexture');
    this.z7z_1 = false;
    this.a80_1 = false;
    this.b80_1 = null;
    this.c80_1 = null;
    this.d80_1 = null;
    this.e80_1 = false;
    this.f80_1 = null;
    this.g80_1 = Companion_getInstance_3().y37(new Long(0, 0));
  }
  protoOf(AGTexture).o80 = function () {
    var tmp0_safe_receiver = this.f80_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s3o();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.AGTexture.<get-implForcedTexTarget>.<anonymous>' call
      tmp = fromGl(Companion_getInstance_64(), tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp2_elvis_lhs;
    if ((tmp_1 == null ? null : new AGTextureTargetKind(tmp_1)) == null) {
      tmp_0 = this.x7z_1;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(AGTexture).x1q = function () {
    var tmp0_safe_receiver = this.d80_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t39_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(AGTexture).y1q = function () {
    var tmp0_safe_receiver = this.d80_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u39_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(AGTexture).p80 = function () {
    var tmp = this.d80_1;
    var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof MultiBitmap) ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d81_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n();
    return tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs;
  };
  protoOf(AGTexture).e81 = function (bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    if (bmp == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      checkBitmaps(this, bmp);
    }
    var tmp = this;
    tmp.f80_1 = (bmp == null ? true : isInterface(bmp, ForcedTexId)) ? bmp : null;
    this.d80_1 = bmp;
    this.g80_1 = Companion_getInstance_3().x37(imul(imul(imul(this.x1q(), this.y1q()), this.p80()), 4));
    this.i7y();
    this.a80_1 = mipmaps;
    this.b80_1 = baseMipmapLevel;
    this.c80_1 = maxMipmapLevel;
    return this;
  };
  protoOf(AGTexture).h80 = function (bmp, mipmaps, baseMipmapLevel, maxMipmapLevel, $super) {
    mipmaps = mipmaps === VOID ? false : mipmaps;
    baseMipmapLevel = baseMipmapLevel === VOID ? null : baseMipmapLevel;
    maxMipmapLevel = maxMipmapLevel === VOID ? null : maxMipmapLevel;
    return $super === VOID ? this.e81(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) : $super.e81.call(this, bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  };
  protoOf(AGTexture).f81 = function (bitmap, requestMipmaps) {
    var tmp1_elvis_lhs = bitmap == null ? null : bitmap.t39_1;
    var width = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = bitmap == null ? null : bitmap.u39_1;
    var height = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    return (requestMipmaps ? get_isPowerOfTwo(width) : false) ? get_isPowerOfTwo(height) : false;
  };
  protoOf(AGTexture).toString = function () {
    return 'AGTexture(size=' + this.x1q() + ',' + this.y1q() + ')';
  };
  function _AGTextureUnitInfo___init__impl__s1tthu(data) {
    return data;
  }
  function _AGTextureUnitInfo___get_data__impl__oupy3n($this) {
    return $this;
  }
  function Companion_25() {
    Companion_instance_39 = this;
    this.c7z_1 = _AGTextureUnitInfo___init__impl__s1tthu(-1);
    this.d7z_1 = AGTextureUnitInfo__withKind_impl_aa0b04(AGTextureUnitInfo__withWrap_impl_akwb6y(AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(_AGTextureUnitInfo___init__impl__s1tthu(0), true, true), Companion_getInstance_65().g81_1), Companion_getInstance_64().k80_1);
  }
  protoOf(Companion_25).j81 = function (data) {
    return _AGTextureUnitInfo___init__impl__s1tthu(data);
  };
  protoOf(Companion_25).k81 = function (wrap, linear, trilinear) {
    return AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(AGTextureUnitInfo__withWrap_impl_akwb6y(_AGTextureUnitInfo___init__impl__s1tthu(0), wrap), linear, trilinear);
  };
  protoOf(Companion_25).l81 = function (wrap, linear, trilinear, $super) {
    wrap = wrap === VOID ? Companion_getInstance_65().g81_1 : wrap;
    linear = linear === VOID ? true : linear;
    trilinear = trilinear === VOID ? linear : trilinear;
    return $super === VOID ? this.k81(wrap, linear, trilinear) : $super.k81.call(this, new AGWrapMode(wrap), linear, trilinear).m81_1;
  };
  var Companion_instance_39;
  function Companion_getInstance_51() {
    if (Companion_instance_39 == null)
      new Companion_25();
    return Companion_instance_39;
  }
  function _AGTextureUnitInfo___get_wrap__impl__dwp6l($this) {
    // Inline function 'korlibs.memory.extract2' call
    var tmp$ret$0 = (_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 0 | 0) & 3;
    return _AGWrapMode___init__impl__x5wmya(tmp$ret$0);
  }
  function _AGTextureUnitInfo___get_linear__impl__jak6ny($this) {
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 2 | 0) & 1) === 0);
  }
  function _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) {
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 3 | 0) & 1) === 0);
  }
  function _AGTextureUnitInfo___get_kind__impl__6xtjoz($this) {
    return _AGTextureTargetKind___init__impl__4zdmch(extract(_AGTextureUnitInfo___get_data__impl__oupy3n($this), 8, 5));
  }
  function AGTextureUnitInfo__withKind_impl_aa0b04($this, kind) {
    return _AGTextureUnitInfo___init__impl__s1tthu(insert5(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGTextureTargetKind___get_ordinal__impl__gjzc5p(kind), 8));
  }
  function AGTextureUnitInfo__withWrap_impl_akwb6y($this, wrap) {
    return _AGTextureUnitInfo___init__impl__s1tthu(insert2(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGWrapMode___get_ordinal__impl__rc38w2(wrap), 0));
  }
  function AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear) {
    return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), linear, 2));
  }
  function AGTextureUnitInfo__withTrilinear_impl_vhkcy2($this, trilinear) {
    return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), trilinear, 3));
  }
  function AGTextureUnitInfo__withLinearTrilinear_impl_aactvz($this, linear, trilinear) {
    return AGTextureUnitInfo__withTrilinear_impl_vhkcy2(AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear), trilinear);
  }
  function AGTextureUnitInfo__toString_impl_7im6je($this) {
    return 'AGTextureUnitInfo(wrap=' + new AGWrapMode(_AGTextureUnitInfo___get_wrap__impl__dwp6l($this)) + ', linear=' + _AGTextureUnitInfo___get_linear__impl__jak6ny($this) + ', trilinear=' + _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) + ', kind=' + new AGTextureTargetKind(_AGTextureUnitInfo___get_kind__impl__6xtjoz($this)) + ')';
  }
  function AGTextureUnitInfo__hashCode_impl_e8jq9h($this) {
    return $this;
  }
  function AGTextureUnitInfo__equals_impl_j2jlgn($this, other) {
    if (!(other instanceof AGTextureUnitInfo))
      return false;
    if (!($this === (other instanceof AGTextureUnitInfo ? other.m81_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGTextureUnitInfo(data) {
    Companion_getInstance_51();
    this.m81_1 = data;
  }
  protoOf(AGTextureUnitInfo).toString = function () {
    return AGTextureUnitInfo__toString_impl_7im6je(this.m81_1);
  };
  protoOf(AGTextureUnitInfo).hashCode = function () {
    return AGTextureUnitInfo__hashCode_impl_e8jq9h(this.m81_1);
  };
  protoOf(AGTextureUnitInfo).equals = function (other) {
    return AGTextureUnitInfo__equals_impl_j2jlgn(this.m81_1, other);
  };
  function AGFrameBufferBase(isMain) {
    AGObject.call(this);
    this.l7z_1 = isMain;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new AGTexture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGFrameBufferBase.tex.<anonymous>' call
    this_0.z7z_1 = true;
    tmp.m7z_1 = this_0;
    this.n7z_1 = Companion_getInstance_3().x37(0);
  }
  protoOf(AGFrameBufferBase).g7z = function () {
    return !this.l7z_1;
  };
  protoOf(AGFrameBufferBase).p21 = function () {
    this.m7z_1.p21();
  };
  protoOf(AGFrameBufferBase).toString = function () {
    return 'AGFrameBufferBase(isMain=' + this.l7z_1 + ')';
  };
  function _AGTextureUnitInfoArray___init__impl__c77rdb(data) {
    return data;
  }
  function _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this) {
    return $this;
  }
  function _AGTextureUnitInfoArray___init__impl__c77rdb_0(size) {
    var tmp = 0;
    var tmp_0 = new Int32Array(size);
    while (tmp < size) {
      tmp_0[tmp] = _AGTextureUnitInfo___get_data__impl__oupy3n(Companion_getInstance_51().d7z_1);
      tmp = tmp + 1 | 0;
    }
    return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp_0);
  }
  function AGTextureUnitInfoArray__set_impl_s95rfh($this, index, value) {
    _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index] = _AGTextureUnitInfo___get_data__impl__oupy3n(value);
  }
  function AGTextureUnitInfoArray__get_impl_xhvpef($this, index) {
    return Companion_getInstance_51().j81(_AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index]);
  }
  function AGTextureUnitInfoArray__copyOf_impl_z2w8z3($this) {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this).slice();
    return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp$ret$1);
  }
  function AGTextureUnitInfoArray__toString_impl_kr9cgh($this) {
    return 'AGTextureUnitInfoArray(data=' + toString($this) + ')';
  }
  function AGTextureUnitInfoArray__hashCode_impl_siosps($this) {
    return hashCode($this);
  }
  function AGTextureUnitInfoArray__equals_impl_e2lbno($this, other) {
    if (!(other instanceof AGTextureUnitInfoArray))
      return false;
    var tmp0_other_with_cast = other instanceof AGTextureUnitInfoArray ? other.n81_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function AGTextureUnitInfoArray(data) {
    this.n81_1 = data;
  }
  protoOf(AGTextureUnitInfoArray).toString = function () {
    return AGTextureUnitInfoArray__toString_impl_kr9cgh(this.n81_1);
  };
  protoOf(AGTextureUnitInfoArray).hashCode = function () {
    return AGTextureUnitInfoArray__hashCode_impl_siosps(this.n81_1);
  };
  protoOf(AGTextureUnitInfoArray).equals = function (other) {
    return AGTextureUnitInfoArray__equals_impl_e2lbno(this.n81_1, other);
  };
  function AGObject() {
    this.e7y_1 = null;
    this.f7y_1 = -1;
    this.g7y_1 = -2;
    this.h7y_1 = -1;
  }
  protoOf(AGObject).j7y = function () {
    this.i7y();
    this.g7y_1 = this.h7y_1 - 1 | 0;
  };
  protoOf(AGObject).i7y = function () {
    this.h7y_1 = this.h7y_1 + 1 | 0;
  };
  protoOf(AGObject).p21 = function () {
    var tmp0_safe_receiver = this.e7y_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.o81();
    }
    this.e7y_1 = null;
  };
  function AGNativeObject() {
  }
  function BufferCache() {
    this.p81_1 = FastIdentityMap();
  }
  protoOf(BufferCache).n1y = function () {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.p81_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.reset.<anonymous>' call
      ensureNotNull(get(this_0, it)).n1y();
    }
  };
  protoOf(BufferCache).z81 = function () {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.p81_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.uploadUpdatedBuffers.<anonymous>' call
      ensureNotNull(get(this_0, it)).a82();
    }
  };
  protoOf(BufferCache).b82 = function (block) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.p81_1;
      var res = get(this_0, block);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.BufferCache.get.<anonymous>' call
      var out = new UniformBlockBuffer(block);
      set(this_0, block, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    return tmp instanceof UniformBlockBuffer ? tmp : THROW_CCE();
  };
  function AGProgramWithUniforms(program, bufferCache) {
    bufferCache = bufferCache === VOID ? new BufferCache() : bufferCache;
    this.c82_1 = program;
    this.d82_1 = bufferCache;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.c82_1.p82_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformLayouts.<anonymous>' call
      var tmp$ret$0 = item.j83_1;
      destination.r(tmp$ret$0);
    }
    tmp.e82_1 = distinct(destination);
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.e82_1.u();
      if (!iterator.v()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
      var maxValue = iterator.x().l83_1 + 1 | 0;
      while (iterator.v()) {
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
        var v = iterator.x().l83_1 + 1 | 0;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.f82_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_1 = this;
    // Inline function 'kotlin.also' call
    var tmp_2 = 0;
    var tmp_3 = this.f82_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocks.<anonymous>' call
    var tmp0_iterator_0 = this.e82_1.u();
    while (tmp0_iterator_0.v()) {
      var layout = tmp0_iterator_0.x();
      tmp_4[layout.l83_1] = layout;
    }
    tmp_1.g82_1 = tmp_4;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = this.g82_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_8 = fillArrayVal(Array(tmp_7), null);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      var tmp0_safe_receiver = this.g82_1[tmp_9];
      var tmp_10;
      if (tmp0_safe_receiver == null) {
        tmp_10 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocksData.<anonymous>' call
        tmp_10 = this.d82_1.b82(tmp0_safe_receiver);
      }
      tmp_8[tmp_9] = tmp_10;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5.h82_1 = tmp_8;
    var tmp_11 = this;
    var tmp_12 = 0;
    var tmp_13 = this.g82_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(tmp_13), null);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var tmp0_safe_receiver_0 = this.h82_1[tmp_15];
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.q81_1;
      var tmp_16;
      if (tmp1_safe_receiver == null) {
        tmp_16 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.agUniformBlockDatas.<anonymous>' call
        tmp_16 = new UniformBlockBuffer(tmp1_safe_receiver);
      }
      tmp_14[tmp_15] = tmp_16;
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11.i82_1 = tmp_14;
    var tmp_17 = this;
    var tmp_18 = 0;
    var tmp_19 = this.g82_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_20 = fillArrayVal(Array(tmp_19), null);
    while (tmp_18 < tmp_19) {
      var tmp_21 = tmp_18;
      var tmp0_safe_receiver_1 = this.h82_1[tmp_21];
      tmp_20[tmp_21] = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.r81_1;
      tmp_18 = tmp_18 + 1 | 0;
    }
    tmp_17.j82_1 = tmp_20;
    var tmp_22 = this;
    var tmp_23 = 0;
    var tmp_24 = this.g82_1.length;
    var tmp_25 = new Int32Array(tmp_24);
    while (tmp_23 < tmp_24) {
      tmp_25[tmp_23] = 0;
      tmp_23 = tmp_23 + 1 | 0;
    }
    tmp_22.k82_1 = tmp_25;
  }
  protoOf(AGProgramWithUniforms).p83 = function () {
    var inductionVariable = 0;
    var last = this.k82_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_safe_receiver = this.h82_1[n];
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.q83();
        this.k82_1[n] = tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.k82_1.slice();
    return new UniformBlocksBuffersRef(this.i82_1, this.j82_1, tmp$ret$1);
  };
  function AGVertexArrayObject_init_$Init$(datas, isDynamic, $this) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    AGVertexArrayObject.call($this, fastArrayListOf(datas.slice()), isDynamic);
    return $this;
  }
  function AGVertexArrayObject_init_$Create$(datas, isDynamic) {
    return AGVertexArrayObject_init_$Init$(datas, isDynamic, objectCreate(protoOf(AGVertexArrayObject)));
  }
  function AGVertexArrayObject(list, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    this.r83_1 = list;
    this.s83_1 = isDynamic;
    this.t83_1 = new Mixin();
  }
  protoOf(AGVertexArrayObject).h23 = function (_set____db54di) {
    this.t83_1.h23(_set____db54di);
  };
  protoOf(AGVertexArrayObject).i23 = function () {
    return this.t83_1.i23();
  };
  protoOf(AGVertexArrayObject).toString = function () {
    return 'AGVertexArrayObject(list=' + this.r83_1 + ', isDynamic=' + this.s83_1 + ')';
  };
  protoOf(AGVertexArrayObject).hashCode = function () {
    var result = this.r83_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.s83_1) | 0;
    return result;
  };
  protoOf(AGVertexArrayObject).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexArrayObject))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexArrayObject ? other : THROW_CCE();
    if (!this.r83_1.equals(tmp0_other_with_cast.r83_1))
      return false;
    if (!(this.s83_1 === tmp0_other_with_cast.s83_1))
      return false;
    return true;
  };
  function AGVertexData(layout, buffer, baseOffset) {
    layout = layout === VOID ? ProgramLayout_init_$Create$([]) : layout;
    buffer = buffer === VOID ? new AGBuffer() : buffer;
    baseOffset = baseOffset === VOID ? 0 : baseOffset;
    this.u83_1 = layout;
    this.v83_1 = buffer;
    this.w83_1 = baseOffset;
  }
  protoOf(AGVertexData).toString = function () {
    return 'AGVertexData(layout=' + this.u83_1 + ', buffer=' + this.v83_1 + ', baseOffset=' + this.w83_1 + ')';
  };
  protoOf(AGVertexData).hashCode = function () {
    var result = hashCode(this.u83_1);
    result = imul(result, 31) + hashCode(this.v83_1) | 0;
    result = imul(result, 31) + this.w83_1 | 0;
    return result;
  };
  protoOf(AGVertexData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexData))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexData ? other : THROW_CCE();
    if (!equals(this.u83_1, tmp0_other_with_cast.u83_1))
      return false;
    if (!equals(this.v83_1, tmp0_other_with_cast.v83_1))
      return false;
    if (!(this.w83_1 === tmp0_other_with_cast.w83_1))
      return false;
    return true;
  };
  function _AGDrawType___init__impl__emm6mb(ordinal) {
    return ordinal;
  }
  function Companion_26() {
    Companion_instance_40 = this;
    this.x83_1 = _AGDrawType___init__impl__emm6mb(0);
    this.y83_1 = _AGDrawType___init__impl__emm6mb(1);
    this.z83_1 = _AGDrawType___init__impl__emm6mb(2);
    this.a84_1 = _AGDrawType___init__impl__emm6mb(3);
    this.b84_1 = _AGDrawType___init__impl__emm6mb(4);
    this.c84_1 = _AGDrawType___init__impl__emm6mb(5);
    this.d84_1 = _AGDrawType___init__impl__emm6mb(6);
  }
  var Companion_instance_40;
  function Companion_getInstance_52() {
    if (Companion_instance_40 == null)
      new Companion_26();
    return Companion_instance_40;
  }
  function AGDrawType__toString_impl_eonaeb($this) {
    return $this === Companion_getInstance_52().x83_1 ? 'POINTS' : $this === Companion_getInstance_52().y83_1 ? 'LINE_STRIP' : $this === Companion_getInstance_52().z83_1 ? 'LINE_LOOP' : $this === Companion_getInstance_52().a84_1 ? 'LINES' : $this === Companion_getInstance_52().b84_1 ? 'TRIANGLES' : $this === Companion_getInstance_52().c84_1 ? 'TRIANGLE_STRIP' : $this === Companion_getInstance_52().d84_1 ? 'TRIANGLE_FAN' : '-';
  }
  function AGDrawType__hashCode_impl_ylaury($this) {
    return $this;
  }
  function AGDrawType__equals_impl_rtafo6($this, other) {
    if (!(other instanceof AGDrawType))
      return false;
    if (!($this === (other instanceof AGDrawType ? other.e84_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGDrawType(ordinal) {
    Companion_getInstance_52();
    this.e84_1 = ordinal;
  }
  protoOf(AGDrawType).toString = function () {
    return AGDrawType__toString_impl_eonaeb(this.e84_1);
  };
  protoOf(AGDrawType).hashCode = function () {
    return AGDrawType__hashCode_impl_ylaury(this.e84_1);
  };
  protoOf(AGDrawType).equals = function (other) {
    return AGDrawType__equals_impl_rtafo6(this.e84_1, other);
  };
  function _AGIndexType___init__impl__yqnmb7(ordinal) {
    return ordinal;
  }
  function Companion_27() {
    Companion_instance_41 = this;
    this.y7u_1 = _AGIndexType___init__impl__yqnmb7(0);
    this.z7u_1 = _AGIndexType___init__impl__yqnmb7(1);
    this.a7v_1 = _AGIndexType___init__impl__yqnmb7(2);
    this.b7v_1 = _AGIndexType___init__impl__yqnmb7(3);
  }
  var Companion_instance_41;
  function Companion_getInstance_53() {
    if (Companion_instance_41 == null)
      new Companion_27();
    return Companion_instance_41;
  }
  function AGIndexType__toString_impl_hjqwm3($this) {
    return $this === Companion_getInstance_53().y7u_1 ? 'null' : $this === Companion_getInstance_53().z7u_1 ? 'UBYTE' : $this === Companion_getInstance_53().a7v_1 ? 'USHORT' : $this === Companion_getInstance_53().b7v_1 ? 'UINT' : '-';
  }
  function AGIndexType__hashCode_impl_47f06s($this) {
    return $this;
  }
  function AGIndexType__equals_impl_goy6ag($this, other) {
    if (!(other instanceof AGIndexType))
      return false;
    if (!($this === (other instanceof AGIndexType ? other.f84_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGIndexType(ordinal) {
    Companion_getInstance_53();
    this.f84_1 = ordinal;
  }
  protoOf(AGIndexType).toString = function () {
    return AGIndexType__toString_impl_hjqwm3(this.f84_1);
  };
  protoOf(AGIndexType).hashCode = function () {
    return AGIndexType__hashCode_impl_47f06s(this.f84_1);
  };
  protoOf(AGIndexType).equals = function (other) {
    return AGIndexType__equals_impl_goy6ag(this.f84_1, other);
  };
  function _AGBlending___init__impl__upt3bq(data) {
    return data;
  }
  function _AGBlending___get_data__impl__7m3zd1($this) {
    return $this;
  }
  function _AGBlending___get_srcRGB__impl__jvh03e($this) {
    // Inline function 'korlibs.memory.extract4' call
    var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 0 | 0) & 15;
    return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
  }
  function _AGBlending___get_srcA__impl__ftmwxe($this) {
    // Inline function 'korlibs.memory.extract4' call
    var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 4 | 0) & 15;
    return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
  }
  function _AGBlending___get_dstRGB__impl__nz9ogp($this) {
    // Inline function 'korlibs.memory.extract4' call
    var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 8 | 0) & 15;
    return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
  }
  function _AGBlending___get_dstA__impl__l7q6tv($this) {
    // Inline function 'korlibs.memory.extract4' call
    var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 12 | 0) & 15;
    return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
  }
  function _AGBlending___get_eqRGB__impl__7pv8oi($this) {
    // Inline function 'korlibs.memory.extract2' call
    var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 16 | 0) & 3;
    return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
  }
  function _AGBlending___get_eqA__impl__2j4ray($this) {
    // Inline function 'korlibs.memory.extract2' call
    var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 18 | 0) & 3;
    return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
  }
  function AGBlending__withSRC_impl_hh0mjq($this, rgb, a) {
    return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 0), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 4));
  }
  function AGBlending__withSRC$default_impl_uuu5hz($this, rgb, a, $super) {
    a = a === VOID ? rgb : a;
    var tmp;
    if ($super === VOID) {
      tmp = AGBlending__withSRC_impl_hh0mjq($this, rgb, a);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).h84.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).g84_1;
    }
    return tmp;
  }
  function AGBlending__withDST_impl_y1hpet($this, rgb, a) {
    return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 8), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 12));
  }
  function AGBlending__withDST$default_impl_leu6qg($this, rgb, a, $super) {
    a = a === VOID ? rgb : a;
    var tmp;
    if ($super === VOID) {
      tmp = AGBlending__withDST_impl_y1hpet($this, rgb, a);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).i84.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).g84_1;
    }
    return tmp;
  }
  function AGBlending__withEQ_impl_e9gm04($this, rgb, a) {
    return _AGBlending___init__impl__upt3bq(insert2(insert2(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendEquation___get_ordinal__impl__895p3q(rgb), 16), _AGBlendEquation___get_ordinal__impl__895p3q(a), 18));
  }
  function AGBlending__withEQ$default_impl_iltiw7($this, rgb, a, $super) {
    a = a === VOID ? rgb : a;
    var tmp;
    if ($super === VOID) {
      tmp = AGBlending__withEQ_impl_e9gm04($this, rgb, a);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).j84.call(new AGBlending($this), new AGBlendEquation(rgb), new AGBlendEquation(a)).g84_1;
    }
    return tmp;
  }
  function _AGBlending___get_enabled__impl__s7igz6($this) {
    return !($this === Companion_getInstance_54().d7v_1);
  }
  function AGBlending__toString_impl_d5hic6($this) {
    return 'Blending(outRGB = (srcRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcRGB__impl__jvh03e($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqRGB__impl__7pv8oi($this)) + ' (dstRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstRGB__impl__nz9ogp($this)) + '), outA = (srcA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcA__impl__ftmwxe($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqA__impl__2j4ray($this)) + ' (dstA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstA__impl__l7q6tv($this)) + '))';
  }
  function Companion_28() {
    Companion_instance_42 = this;
    this.c7v_1 = _AGBlending___init__impl__upt3bq(-1);
    this.d7v_1 = Companion_getInstance_54().u84(Companion_getInstance_60().m84_1, Companion_getInstance_60().t84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().t84_1);
    this.e7v_1 = Companion_getInstance_54().u84(Companion_getInstance_60().r84_1, Companion_getInstance_60().p84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().p84_1);
    this.f7v_1 = Companion_getInstance_54().v84(Companion_getInstance_60().m84_1, Companion_getInstance_60().p84_1);
    this.g7v_1 = Companion_getInstance_54().u84(Companion_getInstance_60().r84_1, Companion_getInstance_60().k84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1);
    this.h7v_1 = Companion_getInstance_54().u84(Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1);
  }
  protoOf(Companion_28).w84 = function (srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    return AGBlending__withEQ_impl_e9gm04(AGBlending__withDST_impl_y1hpet(AGBlending__withSRC_impl_hh0mjq(_AGBlending___init__impl__upt3bq(0), srcRGB, srcA), dstRGB, dstA), eqRGB, eqA);
  };
  protoOf(Companion_28).u84 = function (srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $super) {
    srcA = srcA === VOID ? srcRGB : srcA;
    dstA = dstA === VOID ? dstRGB : dstA;
    eqRGB = eqRGB === VOID ? Companion_getInstance_61().x84_1 : eqRGB;
    eqA = eqA === VOID ? eqRGB : eqA;
    return $super === VOID ? this.w84(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) : $super.w84.call(this, new AGBlendFactor(srcRGB), new AGBlendFactor(dstRGB), new AGBlendFactor(srcA), new AGBlendFactor(dstA), new AGBlendEquation(eqRGB), new AGBlendEquation(eqA)).g84_1;
  };
  protoOf(Companion_28).a85 = function (src, dst, eq) {
    return AGBlending__withEQ$default_impl_iltiw7(AGBlending__withDST$default_impl_leu6qg(AGBlending__withSRC$default_impl_uuu5hz(_AGBlending___init__impl__upt3bq(0), src), dst), eq);
  };
  protoOf(Companion_28).v84 = function (src, dst, eq, $super) {
    eq = eq === VOID ? Companion_getInstance_61().x84_1 : eq;
    return $super === VOID ? this.a85(src, dst, eq) : $super.a85.call(this, new AGBlendFactor(src), new AGBlendFactor(dst), new AGBlendEquation(eq)).g84_1;
  };
  var Companion_instance_42;
  function Companion_getInstance_54() {
    if (Companion_instance_42 == null)
      new Companion_28();
    return Companion_instance_42;
  }
  function AGBlending__hashCode_impl_ywnf51($this) {
    return $this;
  }
  function AGBlending__equals_impl_rp3dmf($this, other) {
    if (!(other instanceof AGBlending))
      return false;
    if (!($this === (other instanceof AGBlending ? other.g84_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGBlending(data) {
    Companion_getInstance_54();
    this.g84_1 = data;
  }
  protoOf(AGBlending).toString = function () {
    return AGBlending__toString_impl_d5hic6(this.g84_1);
  };
  protoOf(AGBlending).hashCode = function () {
    return AGBlending__hashCode_impl_ywnf51(this.g84_1);
  };
  protoOf(AGBlending).equals = function (other) {
    return AGBlending__equals_impl_rp3dmf(this.g84_1, other);
  };
  function _AGStencilReference___init__impl__rta8vg(data) {
    return data;
  }
  function _AGStencilReference___get_data__impl__j5p6bn($this) {
    return $this;
  }
  function _AGStencilReference___init__impl__rta8vg_0(front, back) {
    return _AGStencilReference___init__impl__rta8vg(fromLowHigh(Companion_getInstance_4(), front, back));
  }
  function Companion_29() {
    Companion_instance_43 = this;
    this.l7v_1 = _AGStencilReference___init__impl__rta8vg(new Long(-1, -1));
    this.m7v_1 = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(AGStencilReference__withReferenceValue$default_impl_2trj0v(_AGStencilReference___init__impl__rta8vg(new Long(0, 0)), 0), 255), 255);
  }
  var Companion_instance_43;
  function Companion_getInstance_55() {
    if (Companion_instance_43 == null)
      new Companion_29();
    return Companion_instance_43;
  }
  function _AGStencilReference___get_front__impl__6ggyy0($this) {
    return get_low(_AGStencilReference___get_data__impl__j5p6bn($this));
  }
  function _AGStencilReference___get_back__impl__mm7fqe($this) {
    return get_high(_AGStencilReference___get_data__impl__j5p6bn($this));
  }
  function _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 0 | 0) & 255;
  }
  function _AGStencilReference___get_readMaskFront__impl__oc0s46($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 8 | 0) & 255;
  }
  function _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 16 | 0) & 255;
  }
  function _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 0 | 0) & 255;
  }
  function _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 8 | 0) & 255;
  }
  function _AGStencilReference___get_writeMaskBack__impl__mths73($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 16 | 0) & 255;
  }
  function AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack) {
    return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), referenceValue, 0), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), referenceValueBack, 0));
  }
  function AGStencilReference__withReferenceValue$default_impl_2trj0v($this, referenceValue, referenceValueBack, $super) {
    referenceValueBack = referenceValueBack === VOID ? referenceValue : referenceValueBack;
    var tmp;
    if ($super === VOID) {
      tmp = AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).c85.call(new AGStencilReference($this), referenceValue, referenceValueBack).b85_1;
    }
    return tmp;
  }
  function AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack) {
    return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), readMask, 8), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), readMaskBack, 8));
  }
  function AGStencilReference__withReadMask$default_impl_7mdffx($this, readMask, readMaskBack, $super) {
    readMaskBack = readMaskBack === VOID ? readMask : readMaskBack;
    var tmp;
    if ($super === VOID) {
      tmp = AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).d85.call(new AGStencilReference($this), readMask, readMaskBack).b85_1;
    }
    return tmp;
  }
  function AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack) {
    return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), writeMask, 16), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), writeMaskBack, 16));
  }
  function AGStencilReference__withWriteMask$default_impl_b7j7b4($this, writeMask, writeMaskBack, $super) {
    writeMaskBack = writeMaskBack === VOID ? writeMask : writeMaskBack;
    var tmp;
    if ($super === VOID) {
      tmp = AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).e85.call(new AGStencilReference($this), writeMask, writeMaskBack).b85_1;
    }
    return tmp;
  }
  function AGStencilReference__toString_impl_qu5r8s($this) {
    return 'AGStencilReference(front=[referenceValue=' + _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) + ', readMask=' + _AGStencilReference___get_readMaskFront__impl__oc0s46($this) + ', writeMask=' + _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) + '], back=[referenceValue=' + _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) + ', readMask=' + _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) + ', writeMask=' + _AGStencilReference___get_writeMaskBack__impl__mths73($this) + '])';
  }
  function AGStencilReference__hashCode_impl_52zufx($this) {
    return $this.hashCode();
  }
  function AGStencilReference__equals_impl_kj05j($this, other) {
    if (!(other instanceof AGStencilReference))
      return false;
    var tmp0_other_with_cast = other instanceof AGStencilReference ? other.b85_1 : THROW_CCE();
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function AGStencilReference(data) {
    Companion_getInstance_55();
    this.b85_1 = data;
  }
  protoOf(AGStencilReference).toString = function () {
    return AGStencilReference__toString_impl_qu5r8s(this.b85_1);
  };
  protoOf(AGStencilReference).hashCode = function () {
    return AGStencilReference__hashCode_impl_52zufx(this.b85_1);
  };
  protoOf(AGStencilReference).equals = function (other) {
    return AGStencilReference__equals_impl_kj05j(this.b85_1, other);
  };
  function _AGStencilOpFunc___init__impl__t3f62q(data) {
    return data;
  }
  function _AGStencilOpFunc___get_data__impl__jitrg1($this) {
    return $this;
  }
  function Companion_30() {
    Companion_instance_44 = this;
    this.n7v_1 = _AGStencilOpFunc___init__impl__t3f62q(-1);
    this.o7v_1 = AGStencilOpFunc__withAction$default_impl_jx9cm1(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(_AGStencilOpFunc___init__impl__t3f62q(0), false), Companion_getInstance_67().f85_1), Companion_getInstance_66().s85_1, Companion_getInstance_66().s85_1, Companion_getInstance_66().s85_1);
  }
  var Companion_instance_44;
  function Companion_getInstance_56() {
    if (Companion_instance_44 == null)
      new Companion_30();
    return Companion_instance_44;
  }
  function _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) {
    // Inline function 'korlibs.memory.extractBool' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 31 | 0) & 1) === 0);
  }
  function _AGStencilOpFunc___get_compareModeFront__impl__uctsey($this) {
    // Inline function 'korlibs.memory.extract3' call
    var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 0 | 0) & 7;
    return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
  }
  function _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this) {
    // Inline function 'korlibs.memory.extract3' call
    var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 3 | 0) & 7;
    return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
  }
  function _AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this) {
    // Inline function 'korlibs.memory.extract3' call
    var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 6 | 0) & 7;
    return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
  }
  function _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this) {
    // Inline function 'korlibs.memory.extract3' call
    var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 9 | 0) & 7;
    return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
  }
  function _AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this) {
    // Inline function 'korlibs.memory.extract3' call
    var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 12 | 0) & 7;
    return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
  }
  function _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this) {
    // Inline function 'korlibs.memory.extract3' call
    var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 15 | 0) & 7;
    return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
  }
  function _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this) {
    // Inline function 'korlibs.memory.extract3' call
    var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 18 | 0) & 7;
    return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
  }
  function _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this) {
    // Inline function 'korlibs.memory.extract3' call
    var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 21 | 0) & 7;
    return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
  }
  function AGStencilOpFunc__withEnabled_impl_mpcwmr($this, enabled) {
    return _AGStencilOpFunc___init__impl__t3f62q(insert(_AGStencilOpFunc___get_data__impl__jitrg1($this), enabled, 31));
  }
  function AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack) {
    return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGCompareMode___get_ordinal__impl__ikvlmz(compareMode), 0), _AGCompareMode___get_ordinal__impl__ikvlmz(compareModeBack), 12));
  }
  function AGStencilOpFunc__withCompareMode$default_impl_rzbauv($this, compareMode, compareModeBack, $super) {
    compareModeBack = compareModeBack === VOID ? compareMode : compareModeBack;
    var tmp;
    if ($super === VOID) {
      tmp = AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).w85.call(new AGStencilOpFunc($this), new AGCompareMode(compareMode), new AGCompareMode(compareModeBack)).v85_1;
    }
    return tmp;
  }
  function AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack) {
    return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPass), 3), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPassBack), 15));
  }
  function AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo($this, actionOnBothPass, actionOnBothPassBack, $super) {
    actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
    var tmp;
    if ($super === VOID) {
      tmp = AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).x85.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnBothPassBack)).v85_1;
    }
    return tmp;
  }
  function AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te($this, actionOnDepthFail, actionOnDepthFailBack) {
    return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFail), 6), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFailBack), 18));
  }
  function AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack) {
    return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFail), 9), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFailBack), 21));
  }
  function AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack) {
    return AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35(AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te(AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack), actionOnDepthFail, actionOnDepthFailBack), actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack);
  }
  function AGStencilOpFunc__withAction$default_impl_jx9cm1($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack, $super) {
    actionOnDepthFail = actionOnDepthFail === VOID ? actionOnBothPass : actionOnDepthFail;
    actionOnDepthPassStencilFail = actionOnDepthPassStencilFail === VOID ? actionOnDepthFail : actionOnDepthPassStencilFail;
    actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
    actionOnDepthFailBack = actionOnDepthFailBack === VOID ? actionOnDepthFail : actionOnDepthFailBack;
    actionOnDepthPassStencilFailBack = actionOnDepthPassStencilFailBack === VOID ? actionOnDepthPassStencilFail : actionOnDepthPassStencilFailBack;
    var tmp;
    if ($super === VOID) {
      tmp = AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).y85.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnDepthFail), new AGStencilOp(actionOnDepthPassStencilFail), new AGStencilOp(actionOnBothPassBack), new AGStencilOp(actionOnDepthFailBack), new AGStencilOp(actionOnDepthPassStencilFailBack)).v85_1;
    }
    return tmp;
  }
  function AGStencilOpFunc__toString_impl_pl8quy($this) {
    if (!_AGStencilOpFunc___get_enabled__impl__hxq8wy($this))
      return 'AGStencilOpFunc(enabled=false)';
    return 'AGStencilOpFunc(enabled=' + _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) + ', front=[compareMode=' + new AGCompareMode(_AGStencilOpFunc___get_compareModeFront__impl__uctsey($this)) + ', actions=[' + new AGStencilOp(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this)) + ', ' + new AGStencilOp(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this)) + ', ' + new AGStencilOp(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this)) + ']], back=[compareMode=' + new AGCompareMode(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this)) + ', actions=[' + new AGStencilOp(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this)) + ', ' + new AGStencilOp(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this)) + ', ' + new AGStencilOp(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this)) + ']])';
  }
  function AGStencilOpFunc__hashCode_impl_nopebb($this) {
    return $this;
  }
  function AGStencilOpFunc__equals_impl_y44i4z($this, other) {
    if (!(other instanceof AGStencilOpFunc))
      return false;
    if (!($this === (other instanceof AGStencilOpFunc ? other.v85_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGStencilOpFunc(data) {
    Companion_getInstance_56();
    this.v85_1 = data;
  }
  protoOf(AGStencilOpFunc).toString = function () {
    return AGStencilOpFunc__toString_impl_pl8quy(this.v85_1);
  };
  protoOf(AGStencilOpFunc).hashCode = function () {
    return AGStencilOpFunc__hashCode_impl_nopebb(this.v85_1);
  };
  protoOf(AGStencilOpFunc).equals = function (other) {
    return AGStencilOpFunc__equals_impl_y44i4z(this.v85_1, other);
  };
  function _AGColorMask___init__impl__j38ai8(data) {
    return data;
  }
  function _AGColorMask___get_data__impl__swj1bz($this) {
    return $this;
  }
  function _AGColorMask___get_red__impl__opo1fo($this) {
    // Inline function 'korlibs.memory.extractBool' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 0 | 0) & 1) === 0);
  }
  function _AGColorMask___get_green__impl__d3m1w2($this) {
    // Inline function 'korlibs.memory.extractBool' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 1 | 0) & 1) === 0);
  }
  function _AGColorMask___get_blue__impl__42l0s1($this) {
    // Inline function 'korlibs.memory.extractBool' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 2 | 0) & 1) === 0);
  }
  function _AGColorMask___get_alpha__impl__xmrqzb($this) {
    // Inline function 'korlibs.memory.extractBool' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 3 | 0) & 1) === 0);
  }
  function _AGColorMask___init__impl__j38ai8_0(red, green, blue, alpha) {
    return _AGColorMask___init__impl__j38ai8(insert(insert(insert(insert(0, red, 0), green, 1), blue, 2), alpha, 3));
  }
  function _AGColorMask___init__impl__j38ai8_1(value) {
    value = value === VOID ? true : value;
    return _AGColorMask___init__impl__j38ai8_0(value, value, value, value);
  }
  function AGColorMask__toString_impl_5i5oqg($this) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGColorMask.toString.<anonymous>' call
    this_0.u5('AGColorMask(');
    this_0.u5(_AGColorMask___get_red__impl__opo1fo($this) ? 'R' : 'r');
    this_0.u5(_AGColorMask___get_green__impl__d3m1w2($this) ? 'G' : 'g');
    this_0.u5(_AGColorMask___get_blue__impl__42l0s1($this) ? 'B' : 'b');
    this_0.u5(_AGColorMask___get_alpha__impl__xmrqzb($this) ? 'A' : 'a');
    this_0.u5(')');
    return this_0.toString();
  }
  function Companion_31() {
    Companion_instance_45 = this;
    this.p7v_1 = _AGColorMask___init__impl__j38ai8(-1);
    this.q7v_1 = _AGColorMask___init__impl__j38ai8_1();
    this.r7v_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.s7v_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.t7v_1 = _AGColorMask___init__impl__j38ai8_0(true, true, true, false);
    this.u7v_1 = _AGColorMask___init__impl__j38ai8_1(false);
  }
  var Companion_instance_45;
  function Companion_getInstance_57() {
    if (Companion_instance_45 == null)
      new Companion_31();
    return Companion_instance_45;
  }
  function AGColorMask__hashCode_impl_g9082f($this) {
    return $this;
  }
  function AGColorMask__equals_impl_mrih8l($this, other) {
    if (!(other instanceof AGColorMask))
      return false;
    if (!($this === (other instanceof AGColorMask ? other.z85_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGColorMask(data) {
    Companion_getInstance_57();
    this.z85_1 = data;
  }
  protoOf(AGColorMask).toString = function () {
    return AGColorMask__toString_impl_5i5oqg(this.z85_1);
  };
  protoOf(AGColorMask).hashCode = function () {
    return AGColorMask__hashCode_impl_g9082f(this.z85_1);
  };
  protoOf(AGColorMask).equals = function (other) {
    return AGColorMask__equals_impl_mrih8l(this.z85_1, other);
  };
  function AGScissor_init_$Init$(x, y, width, height, $this) {
    AGScissor.call($this, toShortClamped(x), toShortClamped(y), toShortClamped(x + width | 0), toShortClamped(y + height | 0));
    return $this;
  }
  function AGScissor_init_$Create$(x, y, width, height) {
    return AGScissor_init_$Init$(x, y, width, height, objectCreate(protoOf(AGScissor)));
  }
  function AGScissor_init_$Init$_0(x, y, width, height, $this) {
    AGScissor_init_$Init$(toIntRound(x), toIntRound(y), toIntRound(width), toIntRound(height), $this);
    return $this;
  }
  function AGScissor_init_$Create$_0(x, y, width, height) {
    return AGScissor_init_$Init$_0(x, y, width, height, objectCreate(protoOf(AGScissor)));
  }
  function AGScissor_init_$Init$_1(x, y, width, height, $this) {
    AGScissor_init_$Init$(toIntRound_0(x), toIntRound_0(y), toIntRound_0(width), toIntRound_0(height), $this);
    return $this;
  }
  function AGScissor_init_$Create$_1(x, y, width, height) {
    return AGScissor_init_$Init$_1(x, y, width, height, objectCreate(protoOf(AGScissor)));
  }
  function Companion_32() {
    Companion_instance_46 = this;
    this.x7v_1 = AGScissor_init_$Create$(0, 0, 0, 0);
    this.y7v_1 = Companion_getInstance_58().u2k(IntCompanionObject_instance.MIN_VALUE, IntCompanionObject_instance.MIN_VALUE, IntCompanionObject_instance.MAX_VALUE, IntCompanionObject_instance.MAX_VALUE);
    this.z7v_1 = Companion_getInstance_58().u2k(ShortCompanionObject_instance.MIN_VALUE + 2 | 0, ShortCompanionObject_instance.MIN_VALUE + 2 | 0, IntCompanionObject_instance.MAX_VALUE, IntCompanionObject_instance.MAX_VALUE);
    this.a7w_1 = Companion_getInstance_58().u2k(ShortCompanionObject_instance.MIN_VALUE + 1 | 0, ShortCompanionObject_instance.MIN_VALUE + 1 | 0, IntCompanionObject_instance.MAX_VALUE, IntCompanionObject_instance.MAX_VALUE);
  }
  protoOf(Companion_32).u2k = function (left, top, right, bottom) {
    return AGScissor_init_$Create$(left, top, right - left | 0, bottom - top | 0);
  };
  protoOf(Companion_32).a86 = function (left, top, right, bottom) {
    return AGScissor_init_$Create$_0(left, top, right - left, bottom - top);
  };
  protoOf(Companion_32).b86 = function (rect) {
    if (rect == null)
      return this.a7w_1;
    if (rect.p2d())
      return this.a7w_1;
    return AGScissor_init_$Create$_1(rect.l2d_1, rect.m2d_1, rect.n2d_1, rect.o2d_1);
  };
  protoOf(Companion_32).c86 = function (prev, next) {
    if (prev.equals(this.a7w_1))
      return next;
    if (next.equals(this.a7w_1))
      return prev;
    var intersectsX = prev.r2d() <= next.s2d() ? prev.s2d() >= next.r2d() : false;
    var intersectsY = prev.t2d() <= next.u2d() ? prev.u2d() >= next.t2d() : false;
    if (!intersectsX ? true : !intersectsY)
      return this.x7v_1;
    // Inline function 'kotlin.math.max' call
    var a = prev.r2d();
    var b = next.r2d();
    var left = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = prev.t2d();
    var b_0 = next.t2d();
    var top = Math.max(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = prev.s2d();
    var b_1 = next.s2d();
    var right = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.min' call
    var a_2 = prev.u2d();
    var b_2 = next.u2d();
    var bottom = Math.min(a_2, b_2);
    return this.u2k(left, top, right, bottom);
  };
  var Companion_instance_46;
  function Companion_getInstance_58() {
    if (Companion_instance_46 == null)
      new Companion_32();
    return Companion_instance_46;
  }
  function AGScissor(_left, _top, _right, _bottom) {
    Companion_getInstance_58();
    this.d86_1 = _left;
    this.e86_1 = _top;
    this.f86_1 = _right;
    this.g86_1 = _bottom;
  }
  protoOf(AGScissor).p2d = function () {
    return this.equals(Companion_getInstance_58().a7w_1);
  };
  protoOf(AGScissor).r2d = function () {
    return this.d86_1;
  };
  protoOf(AGScissor).t2d = function () {
    return this.e86_1;
  };
  protoOf(AGScissor).s2d = function () {
    return this.f86_1;
  };
  protoOf(AGScissor).u2d = function () {
    return this.g86_1;
  };
  protoOf(AGScissor).v4s = function () {
    return this.r2d();
  };
  protoOf(AGScissor).w4s = function () {
    return this.t2d();
  };
  protoOf(AGScissor).x1q = function () {
    return this.s2d() - this.r2d() | 0;
  };
  protoOf(AGScissor).y1q = function () {
    return this.u2d() - this.t2d() | 0;
  };
  protoOf(AGScissor).toString = function () {
    if (this.equals(Companion_getInstance_58().a7w_1))
      return 'null';
    return 'Scissor(x=' + this.v4s() + ', y=' + this.w4s() + ', width=' + this.x1q() + ', height=' + this.y1q() + ')';
  };
  protoOf(AGScissor).h86 = function () {
    return this.p2d() ? Companion_getInstance_5().z2d() : Companion_getInstance_5().p2k(this.v4s(), this.w4s(), this.x1q(), this.y1q());
  };
  protoOf(AGScissor).i86 = function () {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.h86();
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.graphics.AGScissor.toRectOrNull.<anonymous>' call
    if (this_0.q2d()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(AGScissor).hashCode = function () {
    var result = this.d86_1;
    result = imul(result, 31) + this.e86_1 | 0;
    result = imul(result, 31) + this.f86_1 | 0;
    result = imul(result, 31) + this.g86_1 | 0;
    return result;
  };
  protoOf(AGScissor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AGScissor))
      return false;
    var tmp0_other_with_cast = other instanceof AGScissor ? other : THROW_CCE();
    if (!(this.d86_1 === tmp0_other_with_cast.d86_1))
      return false;
    if (!(this.e86_1 === tmp0_other_with_cast.e86_1))
      return false;
    if (!(this.f86_1 === tmp0_other_with_cast.f86_1))
      return false;
    if (!(this.g86_1 === tmp0_other_with_cast.g86_1))
      return false;
    return true;
  };
  function AGBatch(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances) {
    vertexData = vertexData === VOID ? AGVertexArrayObject_init_$Create$([new AGVertexData()], true) : vertexData;
    indices = indices === VOID ? null : indices;
    indexType = indexType === VOID ? Companion_getInstance_53().a7v_1 : indexType;
    program = program === VOID ? DefaultShaders_getInstance().c87_1 : program;
    uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_70().i7v_1 : uniformBlocks;
    textureUnits = textureUnits === VOID ? Companion_instance_37.k7v() : textureUnits;
    blending = blending === VOID ? Companion_getInstance_54().e7v_1 : blending;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_56().o7v_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_55().m7v_1 : stencilRef;
    colorMask = colorMask === VOID ? Companion_getInstance_57().r7v_1 : colorMask;
    depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_62().w7v_1 : depthAndFrontFace;
    scissor = scissor === VOID ? Companion_getInstance_58().a7w_1 : scissor;
    cullFace = cullFace === VOID ? Companion_getInstance_63().c7w_1 : cullFace;
    drawType = drawType === VOID ? Companion_getInstance_52().b84_1 : drawType;
    drawOffset = drawOffset === VOID ? 0 : drawOffset;
    vertexCount = vertexCount === VOID ? 0 : vertexCount;
    instances = instances === VOID ? 1 : instances;
    this.d7x_1 = frameBuffer;
    this.e7x_1 = frameBufferInfo;
    this.f7x_1 = vertexData;
    this.g7x_1 = indices;
    this.h7x_1 = indexType;
    this.i7x_1 = program;
    this.j7x_1 = uniformBlocks;
    this.k7x_1 = textureUnits;
    this.l7x_1 = blending;
    this.m7x_1 = stencilOpFunc;
    this.n7x_1 = stencilRef;
    this.o7x_1 = colorMask;
    this.p7x_1 = depthAndFrontFace;
    this.q7x_1 = scissor;
    this.r7x_1 = cullFace;
    this.s7x_1 = drawType;
    this.t7x_1 = drawOffset;
    this.u7x_1 = vertexCount;
    this.v7x_1 = instances;
  }
  protoOf(AGBatch).c7x = function (ag) {
    ag.u7u(this.d7x_1, this.e7x_1, this.f7x_1, this.i7x_1, this.s7x_1, this.u7x_1, this.g7x_1, this.h7x_1, this.t7x_1, this.l7x_1, this.j7x_1, this.k7x_1, this.n7x_1, this.m7x_1, this.o7x_1, this.p7x_1, this.q7x_1, this.r7x_1, this.v7x_1);
  };
  protoOf(AGBatch).toString = function () {
    return 'AGBatch(frameBuffer=' + this.d7x_1 + ', frameBufferInfo=' + new AGFrameBufferInfo(this.e7x_1) + ', vertexData=' + this.f7x_1 + ', indices=' + this.g7x_1 + ', indexType=' + new AGIndexType(this.h7x_1) + ', program=' + this.i7x_1 + ', uniformBlocks=' + this.j7x_1 + ', textureUnits=' + this.k7x_1 + ', blending=' + new AGBlending(this.l7x_1) + ', stencilOpFunc=' + new AGStencilOpFunc(this.m7x_1) + ', stencilRef=' + new AGStencilReference(this.n7x_1) + ', colorMask=' + new AGColorMask(this.o7x_1) + ', depthAndFrontFace=' + new AGDepthAndFrontFace(this.p7x_1) + ', scissor=' + this.q7x_1 + ', cullFace=' + new AGCullFace(this.r7x_1) + ', drawType=' + new AGDrawType(this.s7x_1) + ', drawOffset=' + this.t7x_1 + ', vertexCount=' + this.u7x_1 + ', instances=' + this.v7x_1 + ')';
  };
  protoOf(AGBatch).hashCode = function () {
    var result = hashCode(this.d7x_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.e7x_1) | 0;
    result = imul(result, 31) + this.f7x_1.hashCode() | 0;
    result = imul(result, 31) + (this.g7x_1 == null ? 0 : hashCode(this.g7x_1)) | 0;
    result = imul(result, 31) + AGIndexType__hashCode_impl_47f06s(this.h7x_1) | 0;
    result = imul(result, 31) + this.i7x_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.j7x_1) | 0;
    result = imul(result, 31) + this.k7x_1.hashCode() | 0;
    result = imul(result, 31) + AGBlending__hashCode_impl_ywnf51(this.l7x_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.m7x_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.n7x_1) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.o7x_1) | 0;
    result = imul(result, 31) + AGDepthAndFrontFace__hashCode_impl_xu62ey(this.p7x_1) | 0;
    result = imul(result, 31) + this.q7x_1.hashCode() | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.r7x_1) | 0;
    result = imul(result, 31) + AGDrawType__hashCode_impl_ylaury(this.s7x_1) | 0;
    result = imul(result, 31) + this.t7x_1 | 0;
    result = imul(result, 31) + this.u7x_1 | 0;
    result = imul(result, 31) + this.v7x_1 | 0;
    return result;
  };
  protoOf(AGBatch).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AGBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGBatch ? other : THROW_CCE();
    if (!equals(this.d7x_1, tmp0_other_with_cast.d7x_1))
      return false;
    if (!equals(this.e7x_1, tmp0_other_with_cast.e7x_1))
      return false;
    if (!this.f7x_1.equals(tmp0_other_with_cast.f7x_1))
      return false;
    if (!equals(this.g7x_1, tmp0_other_with_cast.g7x_1))
      return false;
    if (!(this.h7x_1 === tmp0_other_with_cast.h7x_1))
      return false;
    if (!this.i7x_1.equals(tmp0_other_with_cast.i7x_1))
      return false;
    if (!equals(this.j7x_1, tmp0_other_with_cast.j7x_1))
      return false;
    if (!this.k7x_1.equals(tmp0_other_with_cast.k7x_1))
      return false;
    if (!(this.l7x_1 === tmp0_other_with_cast.l7x_1))
      return false;
    if (!(this.m7x_1 === tmp0_other_with_cast.m7x_1))
      return false;
    if (!equals(this.n7x_1, tmp0_other_with_cast.n7x_1))
      return false;
    if (!(this.o7x_1 === tmp0_other_with_cast.o7x_1))
      return false;
    if (!(this.p7x_1 === tmp0_other_with_cast.p7x_1))
      return false;
    if (!this.q7x_1.equals(tmp0_other_with_cast.q7x_1))
      return false;
    if (!(this.r7x_1 === tmp0_other_with_cast.r7x_1))
      return false;
    if (!(this.s7x_1 === tmp0_other_with_cast.s7x_1))
      return false;
    if (!(this.t7x_1 === tmp0_other_with_cast.t7x_1))
      return false;
    if (!(this.u7x_1 === tmp0_other_with_cast.u7x_1))
      return false;
    if (!(this.v7x_1 === tmp0_other_with_cast.v7x_1))
      return false;
    return true;
  };
  function _AGFrameBufferInfo___init__impl__dbxiro(dataLong) {
    return dataLong;
  }
  function _AGFrameBufferInfo___get_dataLong__impl__7vov5d($this) {
    return $this;
  }
  function _AGFrameBufferInfo___get_data__impl__7q146j($this) {
    return get_low(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
  }
  function _AGFrameBufferInfo___get_data2__impl__rgyo5b($this) {
    return get_high(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
  }
  function _AGFrameBufferInfo___init__impl__dbxiro_0(data, data2) {
    return _AGFrameBufferInfo___init__impl__dbxiro(fromLowHigh(Companion_getInstance_4(), data, data2));
  }
  function _AGFrameBufferInfo___get_width__impl__yhp94z($this) {
    // Inline function 'korlibs.memory.extract14' call
    return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 0 | 0) & 16383;
  }
  function _AGFrameBufferInfo___get_height__impl__yfespa($this) {
    // Inline function 'korlibs.memory.extract14' call
    return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 14 | 0) & 16383;
  }
  function _AGFrameBufferInfo___get_x__impl__6dzfjj($this) {
    // Inline function 'korlibs.memory.extract14' call
    return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 0 | 0) & 16383;
  }
  function _AGFrameBufferInfo___get_y__impl__mfn1io($this) {
    // Inline function 'korlibs.memory.extract14' call
    return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 14 | 0) & 16383;
  }
  function _AGFrameBufferInfo___get_size__impl__uw80y4($this) {
    return Companion_instance_56.e87(_AGFrameBufferInfo___get_width__impl__yhp94z($this), _AGFrameBufferInfo___get_height__impl__yfespa($this));
  }
  function _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) {
    // Inline function 'korlibs.memory.extractBool' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 28 | 0) & 1) === 0);
  }
  function _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) {
    // Inline function 'korlibs.memory.extractBool' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 29 | 0) & 1) === 0);
  }
  function _get_samplesBits__rfaq0u($this) {
    // Inline function 'korlibs.memory.extract2' call
    return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 30 | 0) & 3;
  }
  function _AGFrameBufferInfo___get_samples__impl__7k555s($this) {
    return 1 << _get_samplesBits__rfaq0u($this);
  }
  function _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj($this) {
    return _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) ? _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) : false;
  }
  function AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y) {
    return _AGFrameBufferInfo___init__impl__dbxiro_0(_AGFrameBufferInfo___get_data__impl__7q146j($this), insert14(insert14(_AGFrameBufferInfo___get_data2__impl__rgyo5b($this), x, 0), y, 14));
  }
  function AGFrameBufferInfo__withSize_impl_sc5iep($this, width, height) {
    return _AGFrameBufferInfo___init__impl__dbxiro_0(insert14(insert14(_AGFrameBufferInfo___get_data__impl__7q146j($this), width, 0), height, 14), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
  }
  function AGFrameBufferInfo__withBounds_impl_sg0n3x($this, x, y, width, height) {
    return AGFrameBufferInfo__withSize_impl_sc5iep(AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y), width, height);
  }
  function AGFrameBufferInfo__withHasDepth_impl_fjgbiv($this, hasDepth) {
    return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasDepth, 28), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
  }
  function AGFrameBufferInfo__withHasStencil_impl_nbaemo($this, hasStencil) {
    return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasStencil, 29), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
  }
  function AGFrameBufferInfo__withSamples_impl_83818f($this, samples) {
    return withSamplesBits($this, ilog2(samples));
  }
  function withSamplesBits($this, bits) {
    return _AGFrameBufferInfo___init__impl__dbxiro_0(insert2(_AGFrameBufferInfo___get_data__impl__7q146j($this), bits, 30), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
  }
  function AGFrameBufferInfo__toString_impl_xecyr8($this) {
    return 'AGFrameBufferInfo(width=' + _AGFrameBufferInfo___get_width__impl__yhp94z($this) + ', height=' + _AGFrameBufferInfo___get_height__impl__yfespa($this) + ', hasDepth=' + _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) + ', hasStencil=' + _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) + ', samples=' + _AGFrameBufferInfo___get_samples__impl__7k555s($this) + ')';
  }
  function Companion_33() {
    Companion_instance_47 = this;
    this.f87_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(0, 0);
    this.g87_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(-1, 0);
  }
  var Companion_instance_47;
  function Companion_getInstance_59() {
    if (Companion_instance_47 == null)
      new Companion_33();
    return Companion_instance_47;
  }
  function AGFrameBufferInfo__hashCode_impl_fvl6f1($this) {
    return $this.hashCode();
  }
  function AGFrameBufferInfo__equals_impl_cj6qp3($this, other) {
    if (!(other instanceof AGFrameBufferInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AGFrameBufferInfo ? other.h87_1 : THROW_CCE();
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function AGFrameBufferInfo(dataLong) {
    Companion_getInstance_59();
    this.h87_1 = dataLong;
  }
  protoOf(AGFrameBufferInfo).toString = function () {
    return AGFrameBufferInfo__toString_impl_xecyr8(this.h87_1);
  };
  protoOf(AGFrameBufferInfo).hashCode = function () {
    return AGFrameBufferInfo__hashCode_impl_fvl6f1(this.h87_1);
  };
  protoOf(AGFrameBufferInfo).equals = function (other) {
    return AGFrameBufferInfo__equals_impl_cj6qp3(this.h87_1, other);
  };
  function AGMultiBatch(list) {
    this.b7x_1 = list;
  }
  protoOf(AGMultiBatch).c7x = function (ag) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.b7x_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.graphics.AGMultiBatch.execute.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      this_0.f1(tmp0).c7x(ag);
    }
  };
  protoOf(AGMultiBatch).toString = function () {
    return 'AGMultiBatch(list=' + this.b7x_1 + ')';
  };
  protoOf(AGMultiBatch).hashCode = function () {
    return hashCode(this.b7x_1);
  };
  protoOf(AGMultiBatch).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AGMultiBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGMultiBatch ? other : THROW_CCE();
    if (!equals(this.b7x_1, tmp0_other_with_cast.b7x_1))
      return false;
    return true;
  };
  function _AGBlendFactor___init__impl__iqtmxr(ordinal) {
    return ordinal;
  }
  function _AGBlendFactor___get_ordinal__impl__r9efzn($this) {
    return $this;
  }
  function Companion_34() {
    Companion_instance_48 = this;
    this.k84_1 = _AGBlendFactor___init__impl__iqtmxr(0);
    this.l84_1 = _AGBlendFactor___init__impl__iqtmxr(1);
    this.m84_1 = _AGBlendFactor___init__impl__iqtmxr(2);
    this.n84_1 = _AGBlendFactor___init__impl__iqtmxr(3);
    this.o84_1 = _AGBlendFactor___init__impl__iqtmxr(4);
    this.p84_1 = _AGBlendFactor___init__impl__iqtmxr(5);
    this.q84_1 = _AGBlendFactor___init__impl__iqtmxr(6);
    this.r84_1 = _AGBlendFactor___init__impl__iqtmxr(7);
    this.s84_1 = _AGBlendFactor___init__impl__iqtmxr(8);
    this.t84_1 = _AGBlendFactor___init__impl__iqtmxr(9);
  }
  var Companion_instance_48;
  function Companion_getInstance_60() {
    if (Companion_instance_48 == null)
      new Companion_34();
    return Companion_instance_48;
  }
  function AGBlendFactor__toString_impl_1hr6m1($this) {
    return $this === Companion_getInstance_60().k84_1 ? 'DESTINATION_ALPHA' : $this === Companion_getInstance_60().l84_1 ? 'DESTINATION_COLOR' : $this === Companion_getInstance_60().m84_1 ? 'ONE' : $this === Companion_getInstance_60().n84_1 ? 'ONE_MINUS_DESTINATION_ALPHA' : $this === Companion_getInstance_60().o84_1 ? 'ONE_MINUS_DESTINATION_COLOR' : $this === Companion_getInstance_60().p84_1 ? 'ONE_MINUS_SOURCE_ALPHA' : $this === Companion_getInstance_60().q84_1 ? 'ONE_MINUS_SOURCE_COLOR' : $this === Companion_getInstance_60().r84_1 ? 'SOURCE_ALPHA' : $this === Companion_getInstance_60().s84_1 ? 'SOURCE_COLOR' : $this === Companion_getInstance_60().t84_1 ? 'ZERO' : '-';
  }
  function _AGBlendFactor___get_op__impl__b5pfnd($this) {
    var tmp;
    if ($this === Companion_getInstance_60().k84_1) {
      tmp = 'dstA';
    } else if ($this === Companion_getInstance_60().l84_1) {
      tmp = 'dstRGB';
    } else if ($this === Companion_getInstance_60().m84_1) {
      tmp = '1';
    } else if ($this === Companion_getInstance_60().n84_1) {
      tmp = '(1 - dstA)';
    } else if ($this === Companion_getInstance_60().o84_1) {
      tmp = '(1 - dstRGB)';
    } else if ($this === Companion_getInstance_60().p84_1) {
      tmp = '(1 - srcA)';
    } else if ($this === Companion_getInstance_60().q84_1) {
      tmp = '(1 - srcRGB)';
    } else if ($this === Companion_getInstance_60().r84_1) {
      tmp = 'srcA';
    } else if ($this === Companion_getInstance_60().s84_1) {
      tmp = 'srcRGB';
    } else if ($this === Companion_getInstance_60().t84_1) {
      tmp = '0';
    } else {
      get_unreachable();
    }
    return tmp;
  }
  function AGBlendFactor__hashCode_impl_n8x3ew($this) {
    return $this;
  }
  function AGBlendFactor__equals_impl_dlauac($this, other) {
    if (!(other instanceof AGBlendFactor))
      return false;
    if (!($this === (other instanceof AGBlendFactor ? other.i87_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGBlendFactor(ordinal) {
    Companion_getInstance_60();
    this.i87_1 = ordinal;
  }
  protoOf(AGBlendFactor).toString = function () {
    return AGBlendFactor__toString_impl_1hr6m1(this.i87_1);
  };
  protoOf(AGBlendFactor).hashCode = function () {
    return AGBlendFactor__hashCode_impl_n8x3ew(this.i87_1);
  };
  protoOf(AGBlendFactor).equals = function (other) {
    return AGBlendFactor__equals_impl_dlauac(this.i87_1, other);
  };
  function _AGBlendEquation___init__impl__fpv7c2(ordinal) {
    return ordinal;
  }
  function _AGBlendEquation___get_ordinal__impl__895p3q($this) {
    return $this;
  }
  function Companion_35() {
    Companion_instance_49 = this;
    this.x84_1 = _AGBlendEquation___init__impl__fpv7c2(0);
    this.y84_1 = _AGBlendEquation___init__impl__fpv7c2(1);
    this.z84_1 = _AGBlendEquation___init__impl__fpv7c2(2);
  }
  var Companion_instance_49;
  function Companion_getInstance_61() {
    if (Companion_instance_49 == null)
      new Companion_35();
    return Companion_instance_49;
  }
  function AGBlendEquation__toString_impl_5t2sx6($this) {
    return $this === Companion_getInstance_61().x84_1 ? 'ADD' : $this === Companion_getInstance_61().y84_1 ? 'SUBTRACT' : $this === Companion_getInstance_61().z84_1 ? 'REVERSE_SUBTRACT' : '-';
  }
  function _AGBlendEquation___get_op__impl__7f9os6($this) {
    var tmp;
    if ($this === Companion_getInstance_61().x84_1) {
      tmp = '+';
    } else if ($this === Companion_getInstance_61().y84_1) {
      tmp = '-';
    } else if ($this === Companion_getInstance_61().z84_1) {
      tmp = 'r-';
    } else {
      get_unreachable();
    }
    return tmp;
  }
  function AGBlendEquation__hashCode_impl_fy33vp($this) {
    return $this;
  }
  function AGBlendEquation__equals_impl_yykk3b($this, other) {
    if (!(other instanceof AGBlendEquation))
      return false;
    if (!($this === (other instanceof AGBlendEquation ? other.j87_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGBlendEquation(ordinal) {
    Companion_getInstance_61();
    this.j87_1 = ordinal;
  }
  protoOf(AGBlendEquation).toString = function () {
    return AGBlendEquation__toString_impl_5t2sx6(this.j87_1);
  };
  protoOf(AGBlendEquation).hashCode = function () {
    return AGBlendEquation__hashCode_impl_fy33vp(this.j87_1);
  };
  protoOf(AGBlendEquation).equals = function (other) {
    return AGBlendEquation__equals_impl_yykk3b(this.j87_1, other);
  };
  function AGFinish() {
  }
  var AGFinish_instance;
  function AGFinish_getInstance() {
    return AGFinish_instance;
  }
  function AGClear(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil) {
    this.k87_1 = frameBuffer;
    this.l87_1 = frameBufferInfo;
    this.m87_1 = color;
    this.n87_1 = depth;
    this.o87_1 = stencil;
    this.p87_1 = clearColor;
    this.q87_1 = clearDepth;
    this.r87_1 = clearStencil;
  }
  protoOf(AGClear).toString = function () {
    return 'AGClear(frameBuffer=' + this.k87_1 + ', frameBufferInfo=' + new AGFrameBufferInfo(this.l87_1) + ', color=' + new RGBA(this.m87_1) + ', depth=' + this.n87_1 + ', stencil=' + this.o87_1 + ', clearColor=' + this.p87_1 + ', clearDepth=' + this.q87_1 + ', clearStencil=' + this.r87_1 + ')';
  };
  protoOf(AGClear).hashCode = function () {
    var result = hashCode(this.k87_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.l87_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.m87_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n87_1) | 0;
    result = imul(result, 31) + this.o87_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p87_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q87_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r87_1) | 0;
    return result;
  };
  protoOf(AGClear).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AGClear))
      return false;
    var tmp0_other_with_cast = other instanceof AGClear ? other : THROW_CCE();
    if (!equals(this.k87_1, tmp0_other_with_cast.k87_1))
      return false;
    if (!equals(this.l87_1, tmp0_other_with_cast.l87_1))
      return false;
    if (!(this.m87_1 === tmp0_other_with_cast.m87_1))
      return false;
    if (!equals(this.n87_1, tmp0_other_with_cast.n87_1))
      return false;
    if (!(this.o87_1 === tmp0_other_with_cast.o87_1))
      return false;
    if (!(this.p87_1 === tmp0_other_with_cast.p87_1))
      return false;
    if (!(this.q87_1 === tmp0_other_with_cast.q87_1))
      return false;
    if (!(this.r87_1 === tmp0_other_with_cast.r87_1))
      return false;
    return true;
  };
  function _AGDepthAndFrontFace___init__impl__ra8x65(data) {
    return data;
  }
  function _AGDepthAndFrontFace___get_data__impl__v8zkce($this) {
    return $this;
  }
  function Companion_36() {
    Companion_instance_50 = this;
    this.v7v_1 = _AGDepthAndFrontFace___init__impl__ra8x65(-2);
    this.w7v_1 = AGDepthAndFrontFace__withFrontFace_impl_mwk87t(AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs(AGDepthAndFrontFace__withDepthMask_impl_610nhs(AGDepthAndFrontFace__withDepth_impl_wsx82k(_AGDepthAndFrontFace___init__impl__ra8x65(0), 0.0, 1.0), true), Companion_getInstance_67().f85_1), Companion_getInstance_69().s87_1);
  }
  var Companion_instance_50;
  function Companion_getInstance_62() {
    if (Companion_instance_50 == null)
      new Companion_36();
    return Companion_instance_50;
  }
  function _AGDepthAndFrontFace___get_depthNear__impl__cir3a1($this) {
    return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 0, 12);
  }
  function _AGDepthAndFrontFace___get_depthFar__impl__g0cno8($this) {
    return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 12, 12);
  }
  function _AGDepthAndFrontFace___get_depthMask__impl__ouijn($this) {
    // Inline function 'korlibs.memory.extractBool' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 24 | 0) & 1) === 0);
  }
  function _AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp($this) {
    // Inline function 'korlibs.memory.extract3' call
    var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 26 | 0) & 7;
    return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
  }
  function _AGDepthAndFrontFace___get_frontFace__impl__w07k4s($this) {
    // Inline function 'korlibs.memory.extract2' call
    var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 30 | 0) & 3;
    return _AGFrontFace___init__impl__vsm7rb(tmp$ret$0);
  }
  function AGDepthAndFrontFace__withDepth_impl_wsx82k($this, near, far) {
    return _AGDepthAndFrontFace___init__impl__ra8x65(insertScaledf01(insertScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), near, 0, 12), far, 12, 12));
  }
  function AGDepthAndFrontFace__withDepthMask_impl_610nhs($this, depthMask) {
    return _AGDepthAndFrontFace___init__impl__ra8x65(insert(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), depthMask, 24));
  }
  function AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs($this, depthFunc) {
    return _AGDepthAndFrontFace___init__impl__ra8x65(insert3(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGCompareMode___get_ordinal__impl__ikvlmz(depthFunc), 26));
  }
  function AGDepthAndFrontFace__withFrontFace_impl_mwk87t($this, frontFace) {
    return _AGDepthAndFrontFace___init__impl__ra8x65(insert2(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGFrontFace___get_ordinal__impl__d4iagj(frontFace), 30));
  }
  function AGDepthAndFrontFace__toString_impl_c305m3($this) {
    return 'AGDepthAndFrontFace(data=' + $this + ')';
  }
  function AGDepthAndFrontFace__hashCode_impl_xu62ey($this) {
    return $this;
  }
  function AGDepthAndFrontFace__equals_impl_tycw66($this, other) {
    if (!(other instanceof AGDepthAndFrontFace))
      return false;
    if (!($this === (other instanceof AGDepthAndFrontFace ? other.v87_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGDepthAndFrontFace(data) {
    Companion_getInstance_62();
    this.v87_1 = data;
  }
  protoOf(AGDepthAndFrontFace).toString = function () {
    return AGDepthAndFrontFace__toString_impl_c305m3(this.v87_1);
  };
  protoOf(AGDepthAndFrontFace).hashCode = function () {
    return AGDepthAndFrontFace__hashCode_impl_xu62ey(this.v87_1);
  };
  protoOf(AGDepthAndFrontFace).equals = function (other) {
    return AGDepthAndFrontFace__equals_impl_tycw66(this.v87_1, other);
  };
  function _AGCullFace___init__impl__ckmjdg(ordinal) {
    return ordinal;
  }
  function _AGCullFace___get_ordinal__impl__jd1wps($this) {
    return $this;
  }
  function Companion_37() {
    Companion_instance_51 = this;
    this.b7w_1 = _AGCullFace___init__impl__ckmjdg(-1);
    this.c7w_1 = _AGCullFace___init__impl__ckmjdg(0);
    this.d7w_1 = _AGCullFace___init__impl__ckmjdg(1);
    this.e7w_1 = _AGCullFace___init__impl__ckmjdg(2);
    this.f7w_1 = _AGCullFace___init__impl__ckmjdg(3);
  }
  var Companion_instance_51;
  function Companion_getInstance_63() {
    if (Companion_instance_51 == null)
      new Companion_37();
    return Companion_instance_51;
  }
  function AGCullFace__toString_impl_7d891w($this) {
    return $this === Companion_getInstance_63().c7w_1 ? 'NONE' : $this === Companion_getInstance_63().f7w_1 ? 'BOTH' : $this === Companion_getInstance_63().d7w_1 ? 'FRONT' : $this === Companion_getInstance_63().e7w_1 ? 'BACK' : '-';
  }
  function AGCullFace__hashCode_impl_t4e5ur($this) {
    return $this;
  }
  function AGCullFace__equals_impl_wgngjr($this, other) {
    if (!(other instanceof AGCullFace))
      return false;
    if (!($this === (other instanceof AGCullFace ? other.w87_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGCullFace(ordinal) {
    Companion_getInstance_63();
    this.w87_1 = ordinal;
  }
  protoOf(AGCullFace).toString = function () {
    return AGCullFace__toString_impl_7d891w(this.w87_1);
  };
  protoOf(AGCullFace).hashCode = function () {
    return AGCullFace__hashCode_impl_t4e5ur(this.w87_1);
  };
  protoOf(AGCullFace).equals = function (other) {
    return AGCullFace__equals_impl_wgngjr(this.w87_1, other);
  };
  function _AGTextureTargetKind___init__impl__4zdmch(ordinal) {
    return ordinal;
  }
  function _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) {
    return $this;
  }
  function AGTextureTargetKind__toString_impl_68648p($this) {
    return $this === Companion_getInstance_64().k80_1 ? 'TEXTURE_2D' : $this === Companion_getInstance_64().l80_1 ? 'TEXTURE_3D' : $this === Companion_getInstance_64().m80_1 ? 'TEXTURE_CUBE_MAP' : $this === Companion_getInstance_64().n80_1 ? 'EXTERNAL_TEXTURE' : 'AGTextureTargetKind(' + _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) + ')';
  }
  function _AGTextureTargetKind___get_dims__impl__k3cmhd($this) {
    return $this === Companion_getInstance_64().k80_1 ? 2 : $this === Companion_getInstance_64().l80_1 ? 3 : $this === Companion_getInstance_64().m80_1 ? 3 : $this === Companion_getInstance_64().n80_1 ? 3 : 0;
  }
  function Companion_38() {
    Companion_instance_52 = this;
    this.k80_1 = _AGTextureTargetKind___init__impl__4zdmch(0);
    this.l80_1 = _AGTextureTargetKind___init__impl__4zdmch(1);
    this.m80_1 = _AGTextureTargetKind___init__impl__4zdmch(2);
    this.n80_1 = _AGTextureTargetKind___init__impl__4zdmch(3);
  }
  var Companion_instance_52;
  function Companion_getInstance_64() {
    if (Companion_instance_52 == null)
      new Companion_38();
    return Companion_instance_52;
  }
  function AGTextureTargetKind__hashCode_impl_rzc11k($this) {
    return $this;
  }
  function AGTextureTargetKind__equals_impl_q2tams($this, other) {
    if (!(other instanceof AGTextureTargetKind))
      return false;
    if (!($this === (other instanceof AGTextureTargetKind ? other.x87_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGTextureTargetKind(ordinal) {
    Companion_getInstance_64();
    this.x87_1 = ordinal;
  }
  protoOf(AGTextureTargetKind).toString = function () {
    return AGTextureTargetKind__toString_impl_68648p(this.x87_1);
  };
  protoOf(AGTextureTargetKind).hashCode = function () {
    return AGTextureTargetKind__hashCode_impl_rzc11k(this.x87_1);
  };
  protoOf(AGTextureTargetKind).equals = function (other) {
    return AGTextureTargetKind__equals_impl_q2tams(this.x87_1, other);
  };
  function _AGWrapMode___init__impl__x5wmya(ordinal) {
    return ordinal;
  }
  function _AGWrapMode___get_ordinal__impl__rc38w2($this) {
    return $this;
  }
  function Companion_39() {
    Companion_instance_53 = this;
    this.g81_1 = _AGWrapMode___init__impl__x5wmya(0);
    this.h81_1 = _AGWrapMode___init__impl__x5wmya(1);
    this.i81_1 = _AGWrapMode___init__impl__x5wmya(2);
  }
  var Companion_instance_53;
  function Companion_getInstance_65() {
    if (Companion_instance_53 == null)
      new Companion_39();
    return Companion_instance_53;
  }
  function AGWrapMode__toString_impl_8bjnw2($this) {
    return $this === Companion_getInstance_65().g81_1 ? 'CLAMP_TO_EDGE' : $this === Companion_getInstance_65().h81_1 ? 'REPEAT' : $this === Companion_getInstance_65().i81_1 ? 'MIRRORED_REPEAT' : '<' + _AGWrapMode___get_ordinal__impl__rc38w2($this) + '>';
  }
  function AGWrapMode__hashCode_impl_u2pkox($this) {
    return $this;
  }
  function AGWrapMode__equals_impl_4aw0kl($this, other) {
    if (!(other instanceof AGWrapMode))
      return false;
    if (!($this === (other instanceof AGWrapMode ? other.y87_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGWrapMode(ordinal) {
    Companion_getInstance_65();
    this.y87_1 = ordinal;
  }
  protoOf(AGWrapMode).toString = function () {
    return AGWrapMode__toString_impl_8bjnw2(this.y87_1);
  };
  protoOf(AGWrapMode).hashCode = function () {
    return AGWrapMode__hashCode_impl_u2pkox(this.y87_1);
  };
  protoOf(AGWrapMode).equals = function (other) {
    return AGWrapMode__equals_impl_4aw0kl(this.y87_1, other);
  };
  function _AGStencilOp___init__impl__llpkv6(ordinal) {
    return ordinal;
  }
  function _AGStencilOp___get_ordinal__impl__xkavfu($this) {
    return $this;
  }
  function Companion_40() {
    Companion_instance_54 = this;
    this.n85_1 = _AGStencilOp___init__impl__llpkv6(0);
    this.o85_1 = _AGStencilOp___init__impl__llpkv6(1);
    this.p85_1 = _AGStencilOp___init__impl__llpkv6(2);
    this.q85_1 = _AGStencilOp___init__impl__llpkv6(3);
    this.r85_1 = _AGStencilOp___init__impl__llpkv6(4);
    this.s85_1 = _AGStencilOp___init__impl__llpkv6(5);
    this.t85_1 = _AGStencilOp___init__impl__llpkv6(6);
    this.u85_1 = _AGStencilOp___init__impl__llpkv6(7);
  }
  var Companion_instance_54;
  function Companion_getInstance_66() {
    if (Companion_instance_54 == null)
      new Companion_40();
    return Companion_instance_54;
  }
  function AGStencilOp__toString_impl_1dm6fq($this) {
    return $this === Companion_getInstance_66().n85_1 ? 'DECREMENT_SATURATE' : $this === Companion_getInstance_66().o85_1 ? 'DECREMENT_WRAP' : $this === Companion_getInstance_66().p85_1 ? 'INCREMENT_SATURATE' : $this === Companion_getInstance_66().q85_1 ? 'INCREMENT_WRAP' : $this === Companion_getInstance_66().r85_1 ? 'INVERT' : $this === Companion_getInstance_66().s85_1 ? 'KEEP' : $this === Companion_getInstance_66().t85_1 ? 'SET' : $this === Companion_getInstance_66().u85_1 ? 'ZERO' : '-';
  }
  function AGStencilOp__hashCode_impl_n4s38l($this) {
    return $this;
  }
  function AGStencilOp__equals_impl_rq4p55($this, other) {
    if (!(other instanceof AGStencilOp))
      return false;
    if (!($this === (other instanceof AGStencilOp ? other.z87_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGStencilOp(ordinal) {
    Companion_getInstance_66();
    this.z87_1 = ordinal;
  }
  protoOf(AGStencilOp).toString = function () {
    return AGStencilOp__toString_impl_1dm6fq(this.z87_1);
  };
  protoOf(AGStencilOp).hashCode = function () {
    return AGStencilOp__hashCode_impl_n4s38l(this.z87_1);
  };
  protoOf(AGStencilOp).equals = function (other) {
    return AGStencilOp__equals_impl_rq4p55(this.z87_1, other);
  };
  function _AGCompareMode___init__impl__j8kqbb(ordinal) {
    return ordinal;
  }
  function _AGCompareMode___get_ordinal__impl__ikvlmz($this) {
    return $this;
  }
  function Companion_41() {
    Companion_instance_55 = this;
    this.f85_1 = _AGCompareMode___init__impl__j8kqbb(0);
    this.g85_1 = _AGCompareMode___init__impl__j8kqbb(1);
    this.h85_1 = _AGCompareMode___init__impl__j8kqbb(2);
    this.i85_1 = _AGCompareMode___init__impl__j8kqbb(3);
    this.j85_1 = _AGCompareMode___init__impl__j8kqbb(4);
    this.k85_1 = _AGCompareMode___init__impl__j8kqbb(5);
    this.l85_1 = _AGCompareMode___init__impl__j8kqbb(6);
    this.m85_1 = _AGCompareMode___init__impl__j8kqbb(7);
  }
  var Companion_instance_55;
  function Companion_getInstance_67() {
    if (Companion_instance_55 == null)
      new Companion_41();
    return Companion_instance_55;
  }
  function AGCompareMode__toString_impl_gs33a9($this) {
    return $this === Companion_getInstance_67().f85_1 ? 'ALWAYS' : $this === Companion_getInstance_67().g85_1 ? 'EQUAL' : $this === Companion_getInstance_67().h85_1 ? 'GREATER' : $this === Companion_getInstance_67().i85_1 ? 'GREATER_EQUAL' : $this === Companion_getInstance_67().j85_1 ? 'LESS' : $this === Companion_getInstance_67().k85_1 ? 'LESS_EQUAL' : $this === Companion_getInstance_67().l85_1 ? 'NEVER' : $this === Companion_getInstance_67().m85_1 ? 'NOT_EQUAL' : '-';
  }
  function AGCompareMode__inverted_impl_7xxk8m($this) {
    return $this === Companion_getInstance_67().f85_1 ? Companion_getInstance_67().l85_1 : $this === Companion_getInstance_67().g85_1 ? Companion_getInstance_67().m85_1 : $this === Companion_getInstance_67().h85_1 ? Companion_getInstance_67().k85_1 : $this === Companion_getInstance_67().i85_1 ? Companion_getInstance_67().j85_1 : $this === Companion_getInstance_67().j85_1 ? Companion_getInstance_67().i85_1 : $this === Companion_getInstance_67().k85_1 ? Companion_getInstance_67().h85_1 : $this === Companion_getInstance_67().l85_1 ? Companion_getInstance_67().f85_1 : $this === Companion_getInstance_67().m85_1 ? Companion_getInstance_67().g85_1 : Companion_getInstance_67().l85_1;
  }
  function AGCompareMode__hashCode_impl_whv1w0($this) {
    return $this;
  }
  function AGCompareMode__equals_impl_rbniy4($this, other) {
    if (!(other instanceof AGCompareMode))
      return false;
    if (!($this === (other instanceof AGCompareMode ? other.a88_1 : THROW_CCE())))
      return false;
    return true;
  }
  function AGCompareMode(ordinal) {
    Companion_getInstance_67();
    this.a88_1 = ordinal;
  }
  protoOf(AGCompareMode).toString = function () {
    return AGCompareMode__toString_impl_gs33a9(this.a88_1);
  };
  protoOf(AGCompareMode).hashCode = function () {
    return AGCompareMode__hashCode_impl_whv1w0(this.a88_1);
  };
  protoOf(AGCompareMode).equals = function (other) {
    return AGCompareMode__equals_impl_rbniy4(this.a88_1, other);
  };
  function _AGSize___init__impl__h9blcq(data) {
    return data;
  }
  function AGSize__with_impl_qn6qww($this, width, height) {
    return _AGSize___init__impl__h9blcq(insert_0(insert_0(0, width, 0, 16), height, 16, 16));
  }
  function Companion_42() {
  }
  protoOf(Companion_42).b88 = function () {
    return _AGSize___init__impl__h9blcq(-2);
  };
  protoOf(Companion_42).e87 = function (width, height) {
    return AGSize__with_impl_qn6qww(_AGSize___init__impl__h9blcq(0), width, height);
  };
  var Companion_instance_56;
  function Companion_getInstance_68() {
    return Companion_instance_56;
  }
  function _AGFrontFace___init__impl__vsm7rb(ordinal) {
    return ordinal;
  }
  function _AGFrontFace___get_ordinal__impl__d4iagj($this) {
    return $this;
  }
  function Companion_43() {
    Companion_instance_57 = this;
    this.s87_1 = _AGFrontFace___init__impl__vsm7rb(0);
    this.t87_1 = _AGFrontFace___init__impl__vsm7rb(1);
    this.u87_1 = _AGFrontFace___init__impl__vsm7rb(2);
  }
  var Companion_instance_57;
  function Companion_getInstance_69() {
    if (Companion_instance_57 == null)
      new Companion_43();
    return Companion_instance_57;
  }
  function AGConfig(antialiasHint) {
    antialiasHint = antialiasHint === VOID ? true : antialiasHint;
    this.c88_1 = antialiasHint;
  }
  protoOf(AGConfig).toString = function () {
    return 'AGConfig(antialiasHint=' + this.c88_1 + ')';
  };
  protoOf(AGConfig).hashCode = function () {
    return getBooleanHashCode(this.c88_1);
  };
  protoOf(AGConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this.c88_1 === tmp0_other_with_cast.c88_1))
      return false;
    return true;
  };
  function toAGScissor(_this__u8e3s4) {
    if (_this__u8e3s4 == null)
      return Companion_getInstance_58().a7w_1;
    return AGScissor_init_$Create$(numberToInt(_this__u8e3s4.l2d_1), numberToInt(_this__u8e3s4.m2d_1), numberToInt(_this__u8e3s4.n2d_1), numberToInt(_this__u8e3s4.o2d_1));
  }
  function plus_5(_this__u8e3s4, scissor) {
    return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x(_this__u8e3s4, Vector2D_init_$Create$_0(scissor.r2d(), scissor.t2d())), Vector2D_init_$Create$_0(scissor.s2d(), scissor.u2d()));
  }
  function applyMatrixBounds(_this__u8e3s4, m) {
    var x0 = m.a2g(_this__u8e3s4.r2d(), _this__u8e3s4.t2d());
    var x1 = m.a2g(_this__u8e3s4.s2d(), _this__u8e3s4.t2d());
    var x2 = m.a2g(_this__u8e3s4.r2d(), _this__u8e3s4.u2d());
    var x3 = m.a2g(_this__u8e3s4.s2d(), _this__u8e3s4.u2d());
    var y0 = m.b2g(_this__u8e3s4.r2d(), _this__u8e3s4.t2d());
    var y1 = m.b2g(_this__u8e3s4.s2d(), _this__u8e3s4.t2d());
    var y2 = m.b2g(_this__u8e3s4.r2d(), _this__u8e3s4.u2d());
    var y3 = m.b2g(_this__u8e3s4.s2d(), _this__u8e3s4.u2d());
    return Companion_getInstance_58().u2k(numberToInt(min(x0, x1, x2, x3)), numberToInt(min(y0, y1, y2, y3)), numberToInt(max(x0, x1, x2, x3)), numberToInt(max(y0, y1, y2, y3)));
  }
  var AGBufferKind_INDEX_instance;
  var AGBufferKind_VERTEX_instance;
  var AGBufferKind_UNIFORM_instance;
  var AGBufferKind_entriesInitialized;
  function AGBufferKind_initEntries() {
    if (AGBufferKind_entriesInitialized)
      return Unit_instance;
    AGBufferKind_entriesInitialized = true;
    AGBufferKind_INDEX_instance = new AGBufferKind('INDEX', 0);
    AGBufferKind_VERTEX_instance = new AGBufferKind('VERTEX', 1);
    AGBufferKind_UNIFORM_instance = new AGBufferKind('UNIFORM', 2);
  }
  function AGBufferKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function AGBufferKind_INDEX_getInstance() {
    AGBufferKind_initEntries();
    return AGBufferKind_INDEX_instance;
  }
  function AGBufferKind_VERTEX_getInstance() {
    AGBufferKind_initEntries();
    return AGBufferKind_VERTEX_instance;
  }
  function AGBufferKind_UNIFORM_getInstance() {
    AGBufferKind_initEntries();
    return AGBufferKind_UNIFORM_instance;
  }
  function AGStats(texturesCount, texturesMemory, buffersCount, buffersMemory, frameBuffersCount, frameBuffersMemory, texturesCreated, texturesDeleted, programCount) {
    texturesCount = texturesCount === VOID ? 0 : texturesCount;
    texturesMemory = texturesMemory === VOID ? Companion_getInstance_3().x37(0) : texturesMemory;
    buffersCount = buffersCount === VOID ? 0 : buffersCount;
    buffersMemory = buffersMemory === VOID ? Companion_getInstance_3().x37(0) : buffersMemory;
    frameBuffersCount = frameBuffersCount === VOID ? 0 : frameBuffersCount;
    frameBuffersMemory = frameBuffersMemory === VOID ? Companion_getInstance_3().x37(0) : frameBuffersMemory;
    texturesCreated = texturesCreated === VOID ? 0 : texturesCreated;
    texturesDeleted = texturesDeleted === VOID ? 0 : texturesDeleted;
    programCount = programCount === VOID ? 0 : programCount;
    this.d88_1 = texturesCount;
    this.e88_1 = texturesMemory;
    this.f88_1 = buffersCount;
    this.g88_1 = buffersMemory;
    this.h88_1 = frameBuffersCount;
    this.i88_1 = frameBuffersMemory;
    this.j88_1 = texturesCreated;
    this.k88_1 = texturesDeleted;
    this.l88_1 = programCount;
  }
  protoOf(AGStats).toString = function () {
    return 'AGStats(textures[' + this.d88_1 + '] = ' + new ByteUnits(this.e88_1) + ', buffers[' + this.f88_1 + '] = ' + new ByteUnits(this.g88_1) + ', frameBuffers[' + this.h88_1 + '] = ' + new ByteUnits(this.i88_1) + ', programs[' + this.l88_1 + '])';
  };
  function ProjViewUB() {
    ProjViewUB_instance = this;
    UniformBlock.call(this, 0);
    this.q88_1 = this.s88().c89(this, u_ProjMat$factory());
    this.r88_1 = this.s88().c89(this, u_ViewMat$factory());
  }
  protoOf(ProjViewUB).d89 = function () {
    return this.q88_1.lh(this, u_ProjMat$factory_0());
  };
  protoOf(ProjViewUB).e89 = function () {
    return this.r88_1.lh(this, u_ViewMat$factory_0());
  };
  var ProjViewUB_instance;
  function ProjViewUB_getInstance() {
    if (ProjViewUB_instance == null)
      new ProjViewUB();
    return ProjViewUB_instance;
  }
  function DefaultShaders() {
    DefaultShaders_instance = this;
    this.j86_1 = Sampler_0(1, SamplerVarType_Sampler2D_getInstance()).t89(this, u_Tex$factory());
    this.k86_1 = Sampler_0(2, SamplerVarType_Sampler2D_getInstance()).t89(this, u_TexEx$factory());
    this.l86_1 = Attribute_init_$Create$('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance(), 0);
    this.m86_1 = Attribute_init_$Create$('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance(), 1);
    this.n86_1 = Attribute_init_$Create$('a_Col', VarType_UByte4_getInstance(), true, Precision_LOW_getInstance(), 2);
    this.o86_1 = Varying_init_$Create$('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    this.p86_1 = Varying_init_$Create$('v_Col', VarType_Float4_getInstance());
    this.q86_1 = Temp_init_$Create$(0, VarType_Float4_getInstance());
    this.r86_1 = Temp_init_$Create$(1, VarType_Float4_getInstance());
    this.s86_1 = Temp_init_$Create$(2, VarType_Mat2_getInstance());
    this.t86_1 = ProgramLayout_init_$Create$([this.l86_1, this.m86_1, this.n86_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = new ProgramBuilderDefault();
    // Inline function 'korlibs.graphics.DefaultShaders.VERTEX_DEFAULT.<anonymous>' call
    builder.y89(builder.u89(), builder.v89());
    builder.y89(builder.z89(), builder.a8a());
    builder.y89(builder.b8a(), builder.c8a(builder.c8a(builder.d89(), builder.e89()), builder.f8a([builder.d8a(), builder.e8a(0.0), builder.e8a(1.0)])));
    tmp.u86_1 = VertexShader(builder.g8a());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.DefaultShaders.MERGE_ALPHA_PROGRAM.<anonymous>' call
    var coords = this_0.h8a(this_0.u89(), 'xy');
    this_0.y89(this_0.b8a(), this_0.c8a(this_0.j8a(this_0.i8a(), coords), this_0.l8a(this_0.j8a(DefaultShaders_getInstance().k8a(), coords))));
    var tmp$ret$2 = FragmentShader(this_0.g8a());
    tmp_0.v86_1 = new Program(this.u86_1, tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = new ProgramBuilderDefault();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_DEBUG.<anonymous>' call
    builder_0.y89(builder_0.b8a(), builder_0.f8a([builder_0.e8a(1.0), builder_0.e8a(1.0), builder_0.e8a(0.0), builder_0.e8a(1.0)]));
    tmp_1.w86_1 = FragmentShader(builder_0.g8a());
    var tmp_2 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_1 = new ProgramBuilderDefault();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_SOLID_COLOR.<anonymous>' call
    builder_1.y89(builder_1.b8a(), builder_1.z89());
    tmp_2.x86_1 = FragmentShader(builder_1.g8a());
    var tmp_3 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_2 = new ProgramBuilderDefault();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE.<anonymous>' call
    builder_2.y89(builder_2.b8a(), builder_2.c8a(builder_2.h8a(builder_2.j8a(builder_2.i8a(), builder_2.h8a(builder_2.u89(), 'xy')), 'rgba'), builder_2.z89()));
    var tmp$ret$5 = FragmentShader(builder_2.g8a());
    tmp_3.y86_1 = new Program(this.u86_1, tmp$ret$5, 'PROGRAM_TINTED_TEXTURE');
    var tmp_4 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_3 = new ProgramBuilderDefault();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE_PREMULT.<anonymous>' call
    builder_3.y89(builder_3.m8a(), builder_3.j8a(builder_3.i8a(), builder_3.h8a(builder_3.u89(), 'xy')));
    builder_3.y89(builder_3.h8a(builder_3.m8a(), 'rgb'), builder_3.n8a(builder_3.h8a(builder_3.m8a(), 'rgb'), builder_3.h8a(builder_3.m8a(), 'a')));
    builder_3.y89(builder_3.b8a(), builder_3.c8a(builder_3.h8a(builder_3.m8a(), 'rgba'), builder_3.z89()));
    var tmp$ret$6 = FragmentShader(builder_3.g8a());
    tmp_4.z86_1 = new Program(this.u86_1, tmp$ret$6, 'PROGRAM_TINTED_TEXTURE');
    this.a87_1 = new Program(this.u86_1, this.x86_1, 'PROGRAM_SOLID_COLOR');
    this.b87_1 = ProgramLayout_init_$Create$([this.l86_1]);
    var tmp_5 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_4 = new ProgramBuilderDefault();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_4.y89(builder_4.b8a(), builder_4.f8a([builder_4.d8a(), builder_4.e8a(0.0), builder_4.e8a(1.0)]));
    var tmp_6 = VertexShader(builder_4.g8a());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_5 = new ProgramBuilderDefault();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_5.y89(builder_5.b8a(), builder_5.f8a([builder_5.e8a(1.0), builder_5.e8a(0.0), builder_5.e8a(0.0), builder_5.e8a(1.0)]));
    var tmp$ret$8 = FragmentShader(builder_5.g8a());
    tmp_5.c87_1 = new Program(tmp_6, tmp$ret$8, 'PROGRAM_DEBUG');
    var tmp_7 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_6 = new ProgramBuilderDefault();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_6.y89(builder_6.b8a(), builder_6.c8a(builder_6.c8a(builder_6.d89(), builder_6.e89()), builder_6.f8a([builder_6.d8a(), builder_6.e8a(0.0), builder_6.e8a(1.0)])));
    var tmp_8 = VertexShader(builder_6.g8a());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_7 = new ProgramBuilderDefault();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_7.y89(builder_7.b8a(), builder_7.f8a([builder_7.e8a(1.0), builder_7.e8a(0.0), builder_7.e8a(0.0), builder_7.e8a(1.0)]));
    var tmp$ret$10 = FragmentShader(builder_7.g8a());
    tmp_7.d87_1 = new Program(tmp_8, tmp$ret$10, 'PROGRAM_DEBUG_WITH_PROJ');
  }
  protoOf(DefaultShaders).i8a = function () {
    return this.j86_1.lh(this, u_Tex$factory_0());
  };
  protoOf(DefaultShaders).k8a = function () {
    return this.k86_1.lh(this, u_TexEx$factory_0());
  };
  protoOf(DefaultShaders).d89 = function () {
    return ProjViewUB_getInstance().d89().k83_1;
  };
  protoOf(DefaultShaders).e89 = function () {
    return ProjViewUB_getInstance().e89().k83_1;
  };
  var DefaultShaders_instance;
  function DefaultShaders_getInstance() {
    if (DefaultShaders_instance == null)
      new DefaultShaders();
    return DefaultShaders_instance;
  }
  function ProgramBuilderDefault() {
    Builder.call(this);
  }
  function ShaderIndices() {
    this.d8c_1 = 0;
    this.e8c_1 = 1;
    this.f8c_1 = 2;
    this.g8c_1 = 3;
    this.h8c_1 = 4;
    this.i8c_1 = 5;
    this.j8c_1 = 6;
    this.k8c_1 = 7;
    this.l8c_1 = 8;
    this.m8c_1 = 1;
    this.n8c_1 = 2;
    this.o8c_1 = 3;
  }
  var ShaderIndices_instance;
  function ShaderIndices_getInstance() {
    return ShaderIndices_instance;
  }
  function IDefaultShaders() {
  }
  function u_Tex$factory() {
    return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
      return receiver.i8a();
    }, null);
  }
  function u_TexEx$factory() {
    return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
      return receiver.k8a();
    }, null);
  }
  function u_Tex$factory_0() {
    return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
      return receiver.i8a();
    }, null);
  }
  function u_TexEx$factory_0() {
    return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
      return receiver.k8a();
    }, null);
  }
  function u_ProjMat$factory() {
    return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
      return receiver.d89();
    }, null);
  }
  function u_ViewMat$factory() {
    return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
      return receiver.e89();
    }, null);
  }
  function u_ProjMat$factory_0() {
    return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
      return receiver.d89();
    }, null);
  }
  function u_ViewMat$factory_0() {
    return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
      return receiver.e89();
    }, null);
  }
  function get_ENABLE_UNIFORM_BLOCKS() {
    _init_properties_AGOpengl_kt__dtzqx7();
    return ENABLE_UNIFORM_BLOCKS;
  }
  var ENABLE_UNIFORM_BLOCKS;
  function get_ENABLE_VERTEX_ARRAY_OBJECTS() {
    _init_properties_AGOpengl_kt__dtzqx7();
    return ENABLE_VERTEX_ARRAY_OBJECTS;
  }
  var ENABLE_VERTEX_ARRAY_OBJECTS;
  function set_gl(_this__u8e3s4, _set____db54di) {
    _init_properties_AGOpengl_kt__dtzqx7();
    var this_0 = gl$delegate;
    var property = gl$factory();
    var value = this_0.n23_1(_this__u8e3s4, _set____db54di);
    var tmp0_elvis_lhs = this_0.l23_1;
    setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
    return Unit_instance;
  }
  function get_gl(_this__u8e3s4) {
    _init_properties_AGOpengl_kt__dtzqx7();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var this_0 = gl$delegate;
      var property = gl$factory_0();
      var tmp0_elvis_lhs = this_0.l23_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = this_0.m23_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = this_0.l23_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var gl$delegate;
  function GLVAO(vao, glId, contextVersion) {
    glId = glId === VOID ? -1 : glId;
    contextVersion = contextVersion === VOID ? -1 : contextVersion;
    this.p8c_1 = vao;
    this.q8c_1 = glId;
    this.r8c_1 = contextVersion;
  }
  function ShaderException(str, error, errorInt, gl, debugName, type, shaderReturnInt) {
    RuntimeException_init_$Init$('Error Compiling Shader : ' + debugName + ' type=' + type + ' : ' + get_hex(errorInt) + " : '" + error + "' : source='" + str + "', shaderReturnInt=" + shaderReturnInt + ', gl.versionInt=' + get_versionInt(gl) + ", gl.versionString='" + get_versionString(gl) + "', gl=" + gl, this);
    captureStack(this, ShaderException);
    this.s8c_1 = str;
    this.t8c_1 = error;
    this.u8c_1 = errorInt;
    this.v8c_1 = gl;
    this.w8c_1 = debugName;
    this.x8c_1 = type;
    this.y8c_1 = shaderReturnInt;
  }
  function useProgram($this, program) {
    var gl = $this.d8d_1;
    var map = $this.h8d_1;
    if ($this.i8d_1 == null) {
      var tmp = $this;
      tmp.i8d_1 = gl.m8e(35724);
      // Inline function 'korlibs.logger.Logger.info' call
      var this_0 = Companion_getInstance_48().i7u_1;
      var level = Level_INFO_getInstance();
      var tmp_0;
      if (this_0.f25(level)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
        var tmp$ret$0 = 'GL_VERSION=' + gl.m8e(7938);
        this_0.g25(level, tmp$ret$0);
        tmp_0 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.info' call
      var this_1 = Companion_getInstance_48().i7u_1;
      var level_0 = Level_INFO_getInstance();
      var tmp_1;
      if (this_1.f25(level_0)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
        var tmp$ret$2 = 'GL_SHADING_LANGUAGE_VERSION=' + $this.i8d_1;
        this_1.g25(level_0, tmp$ret$2);
        tmp_1 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.info' call
      var this_2 = Companion_getInstance_48().i7u_1;
      var level_1 = Level_INFO_getInstance();
      var tmp_2;
      if (this_2.f25(level_1)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
        var tmp$ret$4 = 'GL_UNIFORM_BUFFER_OFFSET_ALIGNMENT=' + getInteger(gl, 35380);
        this_2.g25(level_1, tmp$ret$4);
        tmp_2 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.info' call
      var this_3 = Companion_getInstance_48().i7u_1;
      var level_2 = Level_INFO_getInstance();
      var tmp_3;
      if (this_3.f25(level_2)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
        var tmp$ret$6 = 'gl.versionString=' + get_versionString(gl);
        this_3.g25(level_2, tmp$ret$6);
        tmp_3 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.info' call
      var this_4 = Companion_getInstance_48().i7u_1;
      var level_3 = Level_INFO_getInstance();
      var tmp_4;
      if (this_4.f25(level_3)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
        var tmp$ret$8 = 'gl.versionInt=' + get_versionInt(gl);
        this_4.g25(level_3, tmp$ret$8);
        tmp_4 = Unit_instance;
      }
    }
    // Inline function 'kotlin.collections.getOrPut' call
    var value = map.s2(program);
    var tmp_5;
    if (value == null) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_5 = new GLBaseProgram($this.g8d_1, GLShaderCompiler_getInstance().p8e(gl, $this.n8e(), program, program.n82_1));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>' call
      this_5.t8e();
      var programInfo = this_5.s8e_1;
      var programId = programInfo.u8e_1;
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = program.r82_1.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
        var location = programInfo.p8f(gl, element.k8f_1);
        gl.q8f(location, element.z7y_1);
      }
      if (programInfo.y8e_1.x8f()) {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_6 = program.q82_1;
        var n = 0;
        while (n < this_6.n()) {
          // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
          var tmp0 = n;
          n = tmp0 + 1 | 0;
          var it = this_6.f1(tmp0);
          var index = gl.r8f(programId, it.zb());
          gl.s8f(programId, index, it.l83_1);
        }
      }
      var answer = this_5;
      map.i2(program, answer);
      tmp_5 = answer;
    } else {
      tmp_5 = value;
    }
    var nprogram = tmp_5;
    if (!equals($this.r8d_1, nprogram)) {
      $this.r8d_1 = nprogram;
      nprogram.t8e();
    }
  }
  function resetObjects($this) {
    $this.k8d_1 = null;
    $this.v8d_1 = Companion_getInstance_58().z7v_1;
    $this.l8d_1 = Companion_getInstance_54().c7v_1;
    $this.m8d_1 = Companion_getInstance_63().b7w_1;
    $this.n8d_1 = Companion_getInstance_56().n7v_1;
    $this.o8d_1 = Companion_getInstance_55().l7v_1;
    $this.p8d_1 = Companion_getInstance_57().p7v_1;
    $this.q8d_1 = Companion_getInstance_62().v7v_1;
    $this.s8d_1.b3();
    $this.r8d_1 = null;
    $this.f8e_1 = -1;
    $this.d8e_1 = 0;
    $this.e8e_1 = Companion_instance_56.b88();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = $this.b8e_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.resetObjects.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      this_0[tmp0].n1y();
    }
  }
  function deletePendingObjects($this) {
    while (true) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var tmp$ret$3;
      $l$block: {
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var this_0 = $this.g8d_1.m8g_1;
        this_0.y1p_1 = true;
        try {
          // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
          var tmp;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!$this.g8d_1.n8g_1.b1()) {
            // Inline function 'kotlin.also' call
            var this_1 = toList($this.g8d_1.n8g_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>.<anonymous>' call
            $this.g8d_1.n8g_1.b3();
            tmp = this_1;
          } else {
            return Unit_instance;
          }
          tmp$ret$3 = tmp;
          break $l$block;
        }finally {
          this_0.y1p_1 = false;
        }
      }
      var n = 0;
      while (n < tmp$ret$3.n()) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        tmp$ret$3.f1(tmp0).q8g();
      }
    }
  }
  function bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated) {
    var gl = $this.d8d_1;
    if (reallocated != null) {
      reallocated.d1z(false);
    }
    if (updated != null) {
      updated.d1z(false);
    }
    if (buffer == null) {
      gl.r8g(toGl_6(target), 0);
      return null;
    }
    var bufferInfo = _get_gl__ndc1ty(buffer, $this);
    if (!onlyUpdate) {
      gl.r8g(toGl_6(target), bufferInfo.u8g_1);
    }
    $this.x8g(buffer, AGOpengl$bindBuffer$lambda(buffer, bufferInfo, onlyUpdate, gl, target, reallocated, updated));
    return bufferInfo;
  }
  function bindBuffer$default($this, buffer, target, onlyUpdate, reallocated, updated, $super) {
    onlyUpdate = onlyUpdate === VOID ? false : onlyUpdate;
    reallocated = reallocated === VOID ? null : reallocated;
    updated = updated === VOID ? null : updated;
    return bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated);
  }
  function writeUniform($this, uniform, programInfo, data, source) {
    var gl = $this.d8d_1;
    var location = programInfo.p8f(gl, uniform.k8f_1);
    var uniformType = uniform.u2f();
    var arrayCount = uniform.a8h_1;
    if (uniformType.h8h_1.ka_1 === 6) {
      switch (uniformType.ka_1) {
        case 1:
          gl.p8h(location, arrayCount, false, data);
          break;
        case 2:
          var inductionVariable = 0;
          if (inductionVariable < 3)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              arraycopy_0(data, imul(n, 16), $this.a8e_1, imul(n, 12), 12);
            }
             while (inductionVariable < 3);
          gl.q8h(location, arrayCount, false, $this.a8e_1);
          break;
        case 3:
          gl.r8h(location, arrayCount, false, data);
          break;
        default:
          switch (uniformType.i8h_1) {
            case 1:
              gl.s8h(location, arrayCount, data);
              break;
            case 2:
              gl.t8h(location, arrayCount, data);
              break;
            case 3:
              gl.u8h(location, arrayCount, data);
              break;
            case 4:
              gl.v8h(location, arrayCount, data);
              break;
          }

          break;
      }
    } else {
      switch (uniformType.i8h_1) {
        case 1:
          gl.l8h(location, arrayCount, data);
          break;
        case 2:
          gl.m8h(location, arrayCount, data);
          break;
        case 3:
          gl.n8h(location, arrayCount, data);
          break;
        case 4:
          gl.o8h(location, arrayCount, data);
          break;
      }
    }
  }
  function TextureUnitParams(index) {
    this.y8f_1 = index;
    this.z8f_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.a8g_1 = -1;
    this.b8g_1 = -1;
    this.c8g_1 = -1;
    this.d8g_1 = -1;
  }
  protoOf(TextureUnitParams).n1y = function () {
    this.z8f_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.a8g_1 = -1;
    this.b8g_1 = -1;
    this.c8g_1 = -1;
    this.d8g_1 = -1;
  };
  function textureUnitParameters($this, implForcedTexTarget, wrap, minFilter, magFilter, dims) {
    var gl = $this.d8d_1;
    var params = $this.b8e_1[$this.d8e_1];
    var glTarget = toGl_8(implForcedTexTarget);
    params.z8f_1 = wrap;
    var glWrap = toGl_9(wrap);
    gl.w8h(glTarget, 10242, glWrap);
    gl.w8h(glTarget, 10243, glWrap);
    if (dims >= 3) {
      gl.w8h(glTarget, 32882, glWrap);
    }
    params.a8g_1 = minFilter;
    params.b8g_1 = magFilter;
    gl.w8h(glTarget, 10241, minFilter);
    gl.w8h(glTarget, 10240, magFilter);
  }
  function createBufferForBitmap($this, bmp) {
    var tmp;
    if (bmp == null) {
      tmp = null;
    } else {
      if (bmp instanceof NativeImage) {
        unsupported('Should not call createBufferForBitmap with a NativeImage');
      } else {
        if (bmp instanceof Bitmap8) {
          // Inline function 'kotlin.also' call
          var this_0 = Buffer_init_$Create$(bmp.e2m());
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          arraycopy_3(bmp.r3j(), 0, get_i8(this_0), 0, bmp.e2m());
          tmp = this_0;
        } else {
          if (bmp instanceof FloatBitmap32) {
            // Inline function 'kotlin.also' call
            var this_1 = Buffer_init_$Create$(imul(imul(bmp.e2m(), 4), 4));
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
            arraycopy_2(bmp.m3n_1, 0, get_f32(this_1), 0, imul(bmp.e2m(), 4));
            tmp = this_1;
          } else {
            // Inline function 'kotlin.also' call
            var this_2 = Buffer_init_$Create$(imul(bmp.e2m(), 4));
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
            var abmp = bmp.a3a_1 ? bmp.e3i().b3l() : bmp.e3i().c3l();
            arraycopy_1(abmp.v3a_1, 0, get_i32(this_2), 0, abmp.e2m());
            tmp = this_2;
          }
        }
      }
    }
    return tmp;
  }
  function selectTextureUnit($this, index) {
    var old = $this.d8e_1;
    if (!($this.d8e_1 === index)) {
      $this.d8e_1 = index;
      if (index >= 0) {
        $this.d8d_1.x8h(33984 + index | 0);
      }
    }
    return old;
  }
  function _get_gl__ndc1ty(_this__u8e3s4, $this) {
    return gl(_this__u8e3s4, $this.g8d_1);
  }
  function _get_gl__ndc1ty_0(_this__u8e3s4, $this) {
    return gl_0(_this__u8e3s4, $this.g8d_1);
  }
  function _get_gl__ndc1ty_1(_this__u8e3s4, $this) {
    return gl_1(_this__u8e3s4, $this.g8d_1);
  }
  function AGOpengl$glslConfig$delegate$lambda(this$0) {
    return function () {
      return new GlslConfig(this$0.d8d_1.y8h(), this$0.d8d_1);
    };
  }
  function AGOpengl$bindBuffer$lambda($buffer, $bufferInfo, $onlyUpdate, $gl, $target, $reallocated, $updated) {
    return function (it) {
      var tmp0_elvis_lhs = $buffer.a7y_1;
      var mem = tmp0_elvis_lhs == null ? Buffer_init_$Create$(0) : tmp0_elvis_lhs;
      $bufferInfo.z8h(toLong(mem.x36()));
      var tmp;
      if ($onlyUpdate) {
        $gl.r8g(toGl_6($target), $bufferInfo.u8g_1);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($bufferInfo.v8g_1 < mem.x36()) {
        $bufferInfo.v8g_1 = mem.x36();
        var tmp_1 = toGl_6($target);
        var tmp_2 = mem.x36();
        $gl.b8i(tmp_1, tmp_2, mem, 35048);
        var tmp1_safe_receiver = $reallocated;
        var tmp_3;
        if (tmp1_safe_receiver == null) {
          tmp_3 = Unit_instance;
        } else {
          tmp1_safe_receiver.d1z(true);
          tmp_3 = Unit_instance;
        }
        tmp_0 = tmp_3;
      } else {
        $gl.a8i(toGl_6($target), 0, mem.x36(), mem);
        tmp_0 = Unit_instance;
      }
      var tmp2_safe_receiver = $updated;
      var tmp_4;
      if (tmp2_safe_receiver == null) {
        tmp_4 = Unit_instance;
      } else {
        tmp2_safe_receiver.d1z(true);
        tmp_4 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AGOpengl$textureBind$lambda($tex, $target, $gl, this$0, $glTex) {
    return function (it) {
      var rbmp = $tex.d80_1;
      var tmp0_safe_receiver = (rbmp == null ? true : rbmp instanceof MultiBitmap) ? rbmp : null;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d81_1;
      var bmps = tmp1_elvis_lhs == null ? listOf(rbmp) : tmp1_elvis_lhs;
      var requestMipmaps = $tex.a80_1;
      $tex.e80_1 = $tex.f81(rbmp, requestMipmaps);
      var totalSize = new Long(0, 0);
      var iterator = bmps.u();
      var index = 0;
      while (iterator.v()) {
        var index_0 = index;
        index = index + 1 | 0;
        var bmp = iterator.x();
        var isFloat = bmp instanceof FloatBitmap32;
        var tmp;
        if (bmp instanceof Bitmap8) {
          tmp = 6409;
        } else {
          tmp = 6408;
        }
        var type = tmp;
        var tmp_0;
        if ($target === Companion_getInstance_64().m80_1) {
          tmp_0 = 34069 + index_0 | 0;
        } else {
          tmp_0 = toGl_8($target);
        }
        var texTarget = tmp_0;
        var tmp_1;
        if (isFloat ? _GLVariant___get_isWebGL__impl__bbd1dd($gl.y8h()) ? _GLVariant___get_version__impl__9nyfwa($gl.y8h()) >= 2 : false : false) {
          tmp_1 = 34836;
        } else {
          tmp_1 = type;
        }
        var internalFormat = tmp_1;
        var format = type;
        var tmp_2;
        if (isFloat) {
          tmp_2 = 5126;
        } else {
          tmp_2 = 5121;
        }
        var texType = tmp_2;
        if (_GLVariant___get_os__impl__aswhdw($gl.y8h()).j1p()) {
          $gl.c8i(3313, 0);
          $gl.c8i(3312, 1);
        }
        if (bmp == null) {
          var tmp_3 = toGl_8($target);
          var tmp_4 = $tex.x1q();
          var tmp_5 = $tex.y1q();
          $gl.d8i(tmp_3, 0, type, tmp_4, tmp_5, 0, type, 5121, null);
        } else {
          if (bmp instanceof NativeImage) {
            if (!(bmp.e2m() === 0)) {
              $gl.e8i(texTarget, 0, type, type, 5121, bmp);
            }
          } else {
            if (bmp instanceof NullBitmap) {
              $gl.d8i(texTarget, 0, internalFormat, bmp.t39_1, bmp.u39_1, 0, format, texType, null);
            } else {
              var buffer = createBufferForBitmap(this$0, bmp);
              if (((!(buffer == null) ? !(bmp.t39_1 === 0) : false) ? !(bmp.u39_1 === 0) : false) ? !(get_size(buffer) === 0) : false) {
                $gl.d8i(texTarget, 0, internalFormat, bmp.t39_1, bmp.u39_1, 0, format, texType, buffer);
              }
            }
          }
        }
        // Inline function 'kotlin.Long.plus' call
        var this_0 = totalSize;
        var other = imul(imul($tex.x1q(), $tex.y1q()), 4);
        totalSize = this_0.mc(toLong(other));
        if (_GLVariant___get_supportTextureLevel__impl__3yeu62($gl.y8h())) {
          var tmp_6;
          if ($tex.e80_1) {
            var tmp6_elvis_lhs = $tex.b80_1;
            tmp_6 = tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs;
          } else {
            tmp_6 = 0;
          }
          $gl.w8h(3553, 33084, tmp_6);
          var tmp_7;
          if ($tex.e80_1) {
            var tmp7_elvis_lhs = $tex.c80_1;
            tmp_7 = tmp7_elvis_lhs == null ? 1000 : tmp7_elvis_lhs;
          } else {
            tmp_7 = 0;
          }
          $gl.w8h(3553, 33085, tmp_7);
        }
        if ($tex.e80_1) {
          $gl.f8i(texTarget);
        }
      }
      $glTex.z8h(totalSize);
      return Unit_instance;
    };
  }
  function AGOpengl(gl, context) {
    context = context === VOID ? null : context;
    AG.call(this);
    this.d8d_1 = gl;
    this.e8d_1 = context;
    var tmp = this;
    // Inline function 'kotlin.collections.linkedSetOf' call
    tmp.f8d_1 = LinkedHashSet_init_$Create$();
    this.g8d_1 = new GLGlobalState(this.d8d_1, this);
    this.h8d_1 = HashMap_init_$Create$();
    this.i8d_1 = null;
    var tmp_0 = this;
    tmp_0.j8d_1 = lazy(AGOpengl$glslConfig$delegate$lambda(this));
    this.k8d_1 = null;
    this.l8d_1 = Companion_getInstance_54().c7v_1;
    this.m8d_1 = Companion_getInstance_63().b7w_1;
    this.n8d_1 = Companion_getInstance_56().n7v_1;
    this.o8d_1 = Companion_getInstance_55().l7v_1;
    this.p8d_1 = Companion_getInstance_57().p7v_1;
    this.q8d_1 = Companion_getInstance_62().v7v_1;
    this.r8d_1 = null;
    this.s8d_1 = AGTextureUnits_init_$Create$();
    this.t8d_1 = new Int32Array(this.s8d_1.n());
    this.u8d_1 = 0;
    this.v8d_1 = Companion_getInstance_58().z7v_1;
    this.w8d_1 = -1;
    this.x8d_1 = -1;
    this.y8d_1 = get_ENABLE_VERTEX_ARRAY_OBJECTS();
    this.z8d_1 = Ref();
    this.a8e_1 = Buffer_init_$Create$(36);
    var tmp_1 = this;
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(32), null);
    while (tmp_2 < 32) {
      var tmp_4 = tmp_2;
      tmp_3[tmp_4] = new TextureUnitParams(tmp_4);
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.b8e_1 = tmp_3;
    this.c8e_1 = 7;
    this.d8e_1 = 0;
    this.e8e_1 = Companion_instance_56.b88();
    this.f8e_1 = -1;
    this.g8e_1 = new Long(-1, -1);
    this.h8e_1 = null;
  }
  protoOf(AGOpengl).v7u = function () {
    return this.d8d_1;
  };
  protoOf(AGOpengl).p7u = function () {
    var gl = this.d8d_1;
    protoOf(AG).p7u.call(this);
    gl.m8i();
    gl.n8i();
    this.h8d_1.b3();
    resetObjects(this);
    this.w8d_1 = -1;
    this.x8d_1 = -1;
    this.y8d_1 = true;
  };
  protoOf(AGOpengl).t7u = function (frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    var gl = this.d8d_1;
    this.o8i(frameBuffer, frameBufferInfo);
    this.p8i(scissor, frameBuffer, frameBufferInfo);
    var mask = 0;
    if (clearColor) {
      this.q8i(Companion_getInstance_57().s7v_1);
      gl.r8i(_RGBA___get_rf__impl__kvz75k(color), _RGBA___get_gf__impl__5gcu1f(color), _RGBA___get_bf__impl__1xz5yg(color), _RGBA___get_af__impl__vu36qv(color));
      var tmp = mask;
      mask = tmp | 16384;
    }
    if (clearDepth) {
      gl.s8i(true);
      gl.t8i(depth);
      var tmp_0 = mask;
      mask = tmp_0 | 256;
    }
    if (clearStencil) {
      this.n8d_1 = Companion_getInstance_56().n7v_1;
      gl.u8i(-1);
      gl.v8i(stencil);
      var tmp_1 = mask;
      mask = tmp_1 | 1024;
    }
    gl.w8i(mask);
  };
  protoOf(AGOpengl).u7u = function (frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    var gl = this.d8d_1;
    this.o8i(frameBuffer, frameBufferInfo);
    this.p8i(scissor, frameBuffer, frameBufferInfo);
    var tmp0_safe_receiver = this.k8d_1;
    if (!equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r83_1, vertexData.r83_1)) {
      var tmp1_safe_receiver = this.k8d_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.x8i(tmp1_safe_receiver);
      }
      this.k8d_1 = vertexData;
      this.y8i(vertexData);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vertexData.r83_1.y1u_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[tmp0];
        bindBuffer$default(this, entry.v83_1, AGBufferKind_VERTEX_getInstance(), true);
      }
    }
    useProgram(this, program);
    this.z8i(uniformBlocks, textureUnits, program, frameBuffer);
    if (!(this.l8d_1 === blending)) {
      this.l8d_1 = blending;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = _AGBlending___get_enabled__impl__s7igz6(blending);
      if (gl.c8j(3042, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        gl.a8j(toGl(_AGBlending___get_eqRGB__impl__7pv8oi(blending)), toGl(_AGBlending___get_eqA__impl__2j4ray(blending)));
        gl.b8j(toGl_0(_AGBlending___get_srcRGB__impl__jvh03e(blending)), toGl_0(_AGBlending___get_dstRGB__impl__nz9ogp(blending)), toGl_0(_AGBlending___get_srcA__impl__ftmwxe(blending)), toGl_0(_AGBlending___get_dstA__impl__l7q6tv(blending)));
      }
    }
    this.d8j(depthAndFrontFace);
    this.q8i(colorMask);
    if (!(this.m8d_1 === cullFace)) {
      this.m8d_1 = cullFace;
      this.e8j(cullFace);
    }
    if (!(this.n8d_1 === stencilOpFunc) ? true : !equals(this.o8d_1, stencilRef)) {
      this.n8d_1 = stencilOpFunc;
      this.o8d_1 = stencilRef;
      if (_AGStencilOpFunc___get_enabled__impl__hxq8wy(stencilOpFunc)) {
        gl.g8j(2960);
        if ((_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc) === _AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc) ? _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef) === _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef) : false) ? _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef) === _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef) : false) {
          gl.i8j(toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
        } else {
          gl.h8j(1028, toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
          gl.h8j(1029, toGl_1(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc)), _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef), _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef));
        }
        if ((_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc) ? _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc) : false) ? _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc) === _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc) : false) {
          gl.k8j(toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
        } else {
          gl.j8j(1028, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
          gl.j8j(1029, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)));
        }
        if (_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef) === _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef)) {
          gl.u8i(_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
        } else {
          gl.l8j(1028, _AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
          gl.l8j(1029, _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef));
        }
      } else {
        gl.f8j(2960);
        gl.u8i(0);
      }
    }
    if (indices == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
      bindBuffer$default(this, indices, AGBufferKind_INDEX_getInstance());
    }
    var indexType_0 = !(indices == null) ? indexType : Companion_getInstance_53().y7u_1;
    if (!(indexType_0 === Companion_getInstance_53().y7u_1))
      if (!(instances === 1)) {
        gl.p8j(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset, instances);
      } else {
        gl.o8j(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset);
      }
     else if (!(instances === 1)) {
      gl.n8j(toGl_3(drawType), drawOffset, vertexCount, instances);
    } else {
      gl.m8j(toGl_3(drawType), drawOffset, vertexCount);
    }
  };
  protoOf(AGOpengl).n8e = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j8d_1;
    glslConfig$factory();
    return this_0.m2();
  };
  protoOf(AGOpengl).s7u = function () {
    var gl = this.d8d_1;
    var tmp0_safe_receiver = this.e8d_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.t8j();
    }
    gl.u8j(this.m7u_1);
    resetObjects(this);
    var tmp = this;
    tmp.u8d_1 = getIntegerv(gl, 36006);
    gl.x8h(33984);
    if (_GLVariant___get_supportTextureLevel__impl__3yeu62(gl.y8h())) {
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      var tmp_0 = 3553;
      gl.w8h(tmp_0, 33084, 0);
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      var tmp_1 = 3553;
      gl.w8h(tmp_1, 33085, 0);
    }
  };
  protoOf(AGOpengl).y7p = function () {
    var tmp0_safe_receiver = this.k8d_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.x8i(tmp0_safe_receiver);
    }
    this.k8d_1 = null;
    this.o8i(this.o7u().g7w_1, this.o7u().t7w());
    var tmp1_safe_receiver = this.e8d_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.v8j();
    }
  };
  protoOf(AGOpengl).q7u = function () {
    var tmp0_safe_receiver = this.k8d_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.x8i(tmp0_safe_receiver);
    }
    this.k8d_1 = null;
    this.d8d_1.m6();
    deletePendingObjects(this);
  };
  protoOf(AGOpengl).e8j = function (face) {
    if (this.d8d_1.c8j(2884, _AGCullFace___get_ordinal__impl__jd1wps(face) > _AGCullFace___get_ordinal__impl__jd1wps(Companion_getInstance_63().c7w_1))) {
      this.d8d_1.w8j(toGl_5(face));
    }
  };
  protoOf(AGOpengl).x8g = function (_this__u8e3s4, block) {
    if (!(_this__u8e3s4.g7y_1 === _this__u8e3s4.h7y_1)) {
      _this__u8e3s4.g7y_1 = _this__u8e3s4.h7y_1;
      block(_this__u8e3s4);
    }
  };
  protoOf(AGOpengl).x8i = function (vao) {
    if (this.y8d_1 ? this.d8d_1.x7u() : false) {
      this.d8d_1.x8k(0);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.r83_1.y1u_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        // Inline function 'korlibs.graphics.shader.attributes' call
        var this_0 = array[tmp0].u83_1.x8j_1;
        var n_0 = 0;
        while (n_0 < this_0.n()) {
          // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>.<anonymous>' call
          var tmp0_0 = n_0;
          n_0 = tmp0_0 + 1 | 0;
          var att = this_0.f1(tmp0_0);
          if (att.s8k_1) {
            var loc = att.u8k_1;
            if (loc >= 0) {
              if (!(att.t8k_1 === 0)) {
                this.d8d_1.v8k(loc, 0);
              }
              this.d8d_1.w8k(loc);
            }
          }
        }
      }
    }
  };
  protoOf(AGOpengl).y8i = function (vao) {
    var gl = this.d8d_1;
    if (this.y8d_1 ? gl.x7u() : false) {
      var vaoGl = get_gl(vao);
      if (vao.s83_1) {
        if (!(this.x8d_1 === this.m7u_1)) {
          this.w8d_1 = genVertexArray(gl);
          this.x8d_1 = this.m7u_1;
          if (this.w8d_1 <= 0)
            this.y8d_1 = false;
        }
        gl.x8k(this.w8d_1);
        this.y8k(vao);
      } else {
        if (!(vaoGl.r8c_1 === this.m7u_1)) {
          vaoGl.r8c_1 = this.m7u_1;
          vaoGl.q8c_1 = genVertexArray(gl);
          if (vaoGl.q8c_1 <= 0)
            this.y8d_1 = false;
          gl.x8k(vaoGl.q8c_1);
          this.y8k(vao);
        }
        gl.x8k(vaoGl.q8c_1);
        this.z8k(vao, this.y8d_1);
      }
    } else {
      this.y8k(vao);
    }
  };
  protoOf(AGOpengl).z8k = function (vao, updateBuffersOnly) {
    var gl = this.d8d_1;
    if (updateBuffersOnly) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.r83_1.y1u_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[tmp0];
        bindBuffer$default(this, entry.v83_1, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.z8d_1);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = vao.r83_1.y1u_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'get' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var entry_0 = array_0[tmp0_0];
      var vertices = entry_0.v83_1;
      var vertexLayout = entry_0.u83_1;
      // Inline function 'korlibs.graphics.shader.attributes' call
      var vattrs = vertexLayout.x8j_1;
      // Inline function 'korlibs.graphics.shader.attributePositions' call
      var vattrspos = vertexLayout.c8k_1;
      bindBuffer$default(this, vertices, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.z8d_1);
      var totalSize = vertexLayout.e8k_1;
      var inductionVariable = 0;
      var last = vattrspos.n() - 1 | 0;
      if (inductionVariable <= last)
        $l$loop: do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var att = vattrs.f1(n_1);
          if (!att.s8k_1)
            continue $l$loop;
          var off = vattrspos.f1(n_1);
          var loc = att.u8k_1;
          var glElementType = toGl_7(att.u2f());
          var elementCount = att.u2f().i8h_1;
          if (loc >= 0) {
            gl.a8l(loc);
            gl.b8l(loc, elementCount, glElementType, att.r8k_1, totalSize, numberToLong(entry_0.w83_1).mc(toLong(off)));
            if (!(att.t8k_1 === 0)) {
              gl.v8k(loc, att.t8k_1);
            }
          }
        }
         while (inductionVariable <= last);
    }
  };
  protoOf(AGOpengl).y8k = function (vao, updateBuffersOnly, $super) {
    updateBuffersOnly = updateBuffersOnly === VOID ? false : updateBuffersOnly;
    var tmp;
    if ($super === VOID) {
      this.z8k(vao, updateBuffersOnly);
      tmp = Unit_instance;
    } else {
      tmp = $super.z8k.call(this, vao, updateBuffersOnly);
    }
    return tmp;
  };
  protoOf(AGOpengl).z8i = function (uniformBlocks, textureUnits, program, frameBuffer) {
    var tmp0_elvis_lhs = this.r8d_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var glProgram = tmp;
    // Inline function 'korlibs.graphics.AGTextureUnits.fastForEach' call
    var inductionVariable = 0;
    var last = textureUnits.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
        var tex = textureUnits.k7y_1[n];
        var info = AGTextureUnitInfoArray__get_impl_xhvpef(textureUnits.l7y_1, n);
        var tex_0 = tex;
        if (equals(frameBuffer.m7z_1, tex_0)) {
          tex_0 = null;
        }
        var tmp0_safe_receiver = tex_0;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h7y_1;
        var texVersion = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        if ((!(this.s8d_1.k7y_1[n] === tex_0) ? true : !(AGTextureUnitInfoArray__get_impl_xhvpef(this.s8d_1.l7y_1, n) === info)) ? true : !(this.t8d_1[n] === texVersion)) {
          this.s8d_1.m7y(n, tex_0, info);
          this.t8d_1[n] = texVersion;
          selectTextureUnit(this, n);
          if (!(tex_0 == null)) {
            var wrap = _AGTextureUnitInfo___get_wrap__impl__dwp6l(info);
            var linear = _AGTextureUnitInfo___get_linear__impl__jak6ny(info);
            var trilinear = _AGTextureUnitInfo___get_trilinear__impl__hxtqfb(info);
            this.c8l(tex_0, _AGTextureUnitInfo___get_kind__impl__6xtjoz(info));
            textureUnitParameters(this, tex_0.o80(), wrap, this.d8l(tex_0, linear, trilinear), this.e8l(tex_0, linear, trilinear), _AGTextureTargetKind___get_dims__impl__k3cmhd(tex_0.o80()));
          } else {
            this.c8l(null, Companion_getInstance_64().k80_1);
          }
        }
      }
       while (inductionVariable < last);
    var glProgramInfo = glProgram.s8e_1;
    // Inline function 'korlibs.graphics.shader.UniformBlocksBuffersRef.fastForEachBlock' call
    var inductionVariable_0 = 0;
    var last_0 = uniformBlocks.n();
    if (inductionVariable_0 < last_0)
      $l$loop: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp1_elvis_lhs_0 = uniformBlocks.f8l_1[n_0];
        var tmp_0;
        if (tmp1_elvis_lhs_0 == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp1_elvis_lhs_0;
        }
        var block = tmp_0;
        $l$block: {
          // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
          var buffer = uniformBlocks.g8l_1[n_0];
          var valueIndex = uniformBlocks.h8l_1[n_0];
          if (glProgram.s8e_1.y8e_1.x8f()) {
            var buffer_0 = bindBuffer$default(this, buffer, AGBufferKind_UNIFORM_getInstance());
            var tmp1_elvis_lhs_1 = buffer_0 == null ? null : buffer_0.u8g_1;
            this.d8d_1.i8l(35345, block.q81_1.l83_1, tmp1_elvis_lhs_1 == null ? -1 : tmp1_elvis_lhs_1, imul(valueIndex, block.t81_1), block.t81_1);
            break $l$block;
          }
          var tmp2_elvis_lhs = glProgramInfo.b8f_1[block.q81_1.l83_1];
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            var message = "Can't find uniform at " + block.q81_1.l83_1 + ' for program ' + program + ' for block ' + block;
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var ref = tmp_1;
          var bufferMem = ensureNotNull(ensureNotNull(buffer).a7y_1);
          var currentMem = ref.k8l_1;
          var ublock = ref.j8l_1;
          if (valueIndex >= 0) {
            if (!arrayequal(bufferMem, valueIndex, currentMem, 0, ublock.h89())) {
              arraycopy_0(bufferMem, imul(ublock.h89(), valueIndex), currentMem, 0, ublock.h89());
              // Inline function 'korlibs.datastructure.iterators.fastForEach' call
              var this_0 = ublock.f89();
              var n_1 = 0;
              while (n_1 < this_0.n()) {
                // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>.<anonymous>' call
                var tmp0 = n_1;
                n_1 = tmp0 + 1 | 0;
                var uniform = this_0.f1(tmp0);
                writeUniform(this, uniform.k83_1, glProgramInfo, sliceBuffer(currentMem, uniform.h83_1, uniform.h83_1 + uniform.e8h_1 | 0), 'blockUniformSet');
              }
            }
          } else {
            println('ERROR block: ' + block.q81_1 + ' has an invalid valueIndex=' + valueIndex);
          }
        }
      }
       while (inductionVariable_0 < last_0);
  };
  protoOf(AGOpengl).d8l = function (_this__u8e3s4, linear, trilinear) {
    var tmp;
    if ((_this__u8e3s4 == null ? null : _this__u8e3s4.e80_1) === true) {
      var tmp_0;
      if (linear) {
        var tmp_1;
        if (trilinear) {
          tmp_1 = 9987;
        } else {
          tmp_1 = 9985;
        }
        tmp_0 = tmp_1;
      } else {
        var tmp_2;
        if (trilinear) {
          tmp_2 = 9986;
        } else {
          tmp_2 = 9984;
        }
        tmp_0 = tmp_2;
      }
      tmp = tmp_0;
    } else {
      var tmp_3;
      if (linear) {
        tmp_3 = 9729;
      } else {
        tmp_3 = 9728;
      }
      tmp = tmp_3;
    }
    return tmp;
  };
  protoOf(AGOpengl).e8l = function (_this__u8e3s4, linear, trilinear) {
    var tmp;
    if (linear) {
      tmp = 9729;
    } else {
      tmp = 9728;
    }
    return tmp;
  };
  protoOf(AGOpengl).n8l = function (scissor, frameBuffer, frameBufferInfo) {
    return (scissor.equals(Companion_getInstance_58().a7w_1) ? true : scissor.equals(Companion_getInstance_58().y7v_1)) ? scissor : frameBuffer.l7z_1 ? Companion_getInstance_58().u2k(scissor.r2d(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.u2d() | 0, scissor.s2d(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.t2d() | 0) : scissor;
  };
  protoOf(AGOpengl).c8l = function (tex, target) {
    var gl = this.d8d_1;
    var glTex = tex == null ? null : _get_gl__ndc1ty_1(tex, this);
    var tmp = toGl_8(target);
    var tmp2_elvis_lhs = glTex == null ? null : glTex.i8i_1;
    gl.o8l(tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    var texBitmap = tex == null ? null : tex.d80_1;
    if (!(glTex == null) ? !(texBitmap == null) : false) {
      if (!(glTex.j8i_1 === texBitmap.d3a_1) ? true : !(glTex.k8i_1 === this.m7u_1)) {
        glTex.j8i_1 = texBitmap.d3a_1;
        glTex.k8i_1 = this.m7u_1;
        tex.j7y();
      }
      this.x8g(tex, AGOpengl$textureBind$lambda(tex, target, gl, this, glTex));
    }
  };
  protoOf(AGOpengl).o8i = function (frameBuffer, info) {
    var gl = this.d8d_1;
    if (!(this.e8e_1 === _AGFrameBufferInfo___get_size__impl__uw80y4(info))) {
      gl.p8l(_AGFrameBufferInfo___get_x__impl__6dzfjj(info), _AGFrameBufferInfo___get_y__impl__mfn1io(info), _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
    }
    if (frameBuffer.l7z_1) {
      if (!(this.f8e_1 === this.u8d_1)) {
        this.f8e_1 = this.u8d_1;
        gl.q8l(36160, this.u8d_1);
      }
      return Unit_instance;
    }
    var fb = _get_gl__ndc1ty_0(frameBuffer, this);
    var tex = fb.t8l_1.m7z_1;
    var doMsaa = false;
    if (!equals(fb.w8l_1, info)) {
      fb.w8l_1 = info;
      var tmp;
      if (_AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info)) {
        tmp = 34041;
      } else if (_AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info)) {
        tmp = 36168;
      } else if (_AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info)) {
        tmp = 6402;
      } else {
        tmp = 0;
      }
      var internalFormat = tmp;
      var tmp_0;
      if (doMsaa) {
        tmp_0 = 37120;
      } else {
        tmp_0 = 3553;
      }
      var texTarget = tmp_0;
      tex.d80_1 = new NullBitmap(_AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info), false);
      // Inline function 'korlibs.graphics.gl.AGOpengl.selectTextureUnitTemp' call
      var index = this.c8e_1;
      var old = selectTextureUnit(this, index);
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.bindFrameBuffer.<anonymous>' call
        this.c8l(tex, Companion_getInstance_64().k80_1);
        var tmp_1 = Companion_getInstance_64().k80_1;
        var tmp_2 = Companion_getInstance_65().g81_1;
        textureUnitParameters(this, tmp_1, tmp_2, 9729, 9729, 2);
      }finally {
        if (true) {
          this.c8l(null, Companion_getInstance_64().k80_1);
        }
        selectTextureUnit(this, old);
      }
      gl.x8l(36161, fb.u8l_1);
      if (!(internalFormat === 0)) {
        gl.y8l(36161, internalFormat, _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
      }
      gl.x8l(36161, 0);
      gl.q8l(36160, fb.v8l_1);
      gl.z8l(36160, 36064, 3553, _get_gl__ndc1ty_1(fb.t8l_1.m7z_1, this).i8i_1, 0);
      if (!(internalFormat === 0)) {
        var tmp_3;
        if (_AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info)) {
          tmp_3 = 33306;
        } else if (_AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info)) {
          tmp_3 = 36128;
        } else if (_AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info)) {
          tmp_3 = 36096;
        } else {
          tmp_3 = 0;
        }
        var tmp_4 = tmp_3;
        gl.a8m(36160, tmp_4, 36161, fb.u8l_1);
      } else {
        gl.a8m(36160, 36128, 36161, 0);
        gl.a8m(36160, 36096, 36161, 0);
      }
    }
    if (!(this.f8e_1 === fb.v8l_1)) {
      this.f8e_1 = fb.v8l_1;
      gl.q8l(36160, fb.v8l_1);
    }
  };
  protoOf(AGOpengl).d8j = function (renderState) {
    var gl = this.d8d_1;
    if (!(this.q8d_1 === renderState)) {
      this.q8d_1 = renderState;
      gl.b8m(toGl_10(_AGDepthAndFrontFace___get_frontFace__impl__w07k4s(renderState)));
      gl.s8i(_AGDepthAndFrontFace___get_depthMask__impl__ouijn(renderState));
      gl.c8m(_AGDepthAndFrontFace___get_depthNear__impl__cir3a1(renderState), _AGDepthAndFrontFace___get_depthFar__impl__g0cno8(renderState));
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState) === Companion_getInstance_67().f85_1);
      if (gl.c8j(2929, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setDepthAndFrontFace.<anonymous>' call
        gl.d8m(toGl_1(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState)));
      }
    }
  };
  protoOf(AGOpengl).q8i = function (colorMask) {
    var gl = this.d8d_1;
    if (!(this.p8d_1 === colorMask)) {
      this.p8d_1 = colorMask;
      gl.e8m(_AGColorMask___get_red__impl__opo1fo(colorMask), _AGColorMask___get_green__impl__d3m1w2(colorMask), _AGColorMask___get_blue__impl__42l0s1(colorMask), _AGColorMask___get_alpha__impl__xmrqzb(colorMask));
    }
  };
  protoOf(AGOpengl).p8i = function (scissor, frameBuffer, frameBufferInfo) {
    var gl = this.d8d_1;
    var scissor_0 = this.n8l(scissor, frameBuffer, frameBufferInfo);
    if (!this.v8d_1.equals(scissor_0)) {
      this.v8d_1 = scissor_0;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !scissor_0.equals(Companion_getInstance_58().a7w_1);
      if (gl.c8j(3089, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setScissorState.<anonymous>' call
        gl.f8m(scissor_0.v4s(), scissor_0.w4s(), scissor_0.x1q(), scissor_0.y1q());
      }
    }
  };
  function gl$delegate$lambda($this$$receiver) {
    _init_properties_AGOpengl_kt__dtzqx7();
    return new GLVAO($this$$receiver);
  }
  function gl$factory() {
    return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
      return get_gl(receiver);
    }, function (receiver, value) {
      return set_gl(receiver, value);
    });
  }
  function gl$factory_0() {
    return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
      return get_gl(receiver);
    }, function (receiver, value) {
      return set_gl(receiver, value);
    });
  }
  function glslConfig$factory() {
    return getPropertyCallableRef('glslConfig', 1, KProperty1, function (receiver) {
      return receiver.n8e();
    }, null);
  }
  var properties_initialized_AGOpengl_kt_5em8g9;
  function _init_properties_AGOpengl_kt__dtzqx7() {
    if (!properties_initialized_AGOpengl_kt_5em8g9) {
      properties_initialized_AGOpengl_kt_5em8g9 = true;
      ENABLE_UNIFORM_BLOCKS = !(Companion_instance.s13('DISABLE_UNIFORM_BLOCKS') === 'true');
      ENABLE_VERTEX_ARRAY_OBJECTS = !(Companion_instance.s13('DISABLE_VERTEX_ARRAY_OBJECTS') === 'true');
      gl$delegate = new PropertyThis(VOID, gl$delegate$lambda);
    }
  }
  function fromGl(_this__u8e3s4, value) {
    var tmp;
    if (value === 3553) {
      tmp = Companion_getInstance_64().k80_1;
    } else {
      if (value === 32879) {
        tmp = Companion_getInstance_64().l80_1;
      } else {
        if (value === 34067) {
          tmp = Companion_getInstance_64().m80_1;
        } else {
          if (value === 36197) {
            tmp = Companion_getInstance_64().n80_1;
          } else {
            if (value === 34069) {
              tmp = Companion_getInstance_64().m80_1;
            } else {
              if (value === 34070) {
                tmp = Companion_getInstance_64().m80_1;
              } else {
                if (value === 34071) {
                  tmp = Companion_getInstance_64().m80_1;
                } else {
                  if (value === 34072) {
                    tmp = Companion_getInstance_64().m80_1;
                  } else {
                    if (value === 34073) {
                      tmp = Companion_getInstance_64().m80_1;
                    } else {
                      if (value === 34074) {
                        tmp = Companion_getInstance_64().m80_1;
                      } else {
                        var reason = 'Unknown TextureTargetKind: ' + value;
                        throw new NotImplementedError('An operation is not implemented: ' + reason);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  function toGl(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_61().x84_1) {
      tmp = 32774;
    } else if (_this__u8e3s4 === Companion_getInstance_61().y84_1) {
      tmp = 32778;
    } else if (_this__u8e3s4 === Companion_getInstance_61().z84_1) {
      tmp = 32779;
    } else {
      get_unreachable();
    }
    return tmp;
  }
  function toGl_0(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_60().k84_1) {
      tmp = 772;
    } else if (_this__u8e3s4 === Companion_getInstance_60().l84_1) {
      tmp = 774;
    } else if (_this__u8e3s4 === Companion_getInstance_60().m84_1) {
      tmp = 1;
    } else if (_this__u8e3s4 === Companion_getInstance_60().n84_1) {
      tmp = 773;
    } else if (_this__u8e3s4 === Companion_getInstance_60().o84_1) {
      tmp = 775;
    } else if (_this__u8e3s4 === Companion_getInstance_60().p84_1) {
      tmp = 771;
    } else if (_this__u8e3s4 === Companion_getInstance_60().q84_1) {
      tmp = 769;
    } else if (_this__u8e3s4 === Companion_getInstance_60().r84_1) {
      tmp = 770;
    } else if (_this__u8e3s4 === Companion_getInstance_60().s84_1) {
      tmp = 768;
    } else if (_this__u8e3s4 === Companion_getInstance_60().t84_1) {
      tmp = 0;
    } else {
      get_unreachable();
    }
    return tmp;
  }
  function toGl_1(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_67().f85_1) {
      tmp = 519;
    } else if (_this__u8e3s4 === Companion_getInstance_67().g85_1) {
      tmp = 514;
    } else if (_this__u8e3s4 === Companion_getInstance_67().h85_1) {
      tmp = 516;
    } else if (_this__u8e3s4 === Companion_getInstance_67().i85_1) {
      tmp = 518;
    } else if (_this__u8e3s4 === Companion_getInstance_67().j85_1) {
      tmp = 513;
    } else if (_this__u8e3s4 === Companion_getInstance_67().k85_1) {
      tmp = 515;
    } else if (_this__u8e3s4 === Companion_getInstance_67().l85_1) {
      tmp = 512;
    } else if (_this__u8e3s4 === Companion_getInstance_67().m85_1) {
      tmp = 517;
    } else {
      get_unreachable();
    }
    return tmp;
  }
  function toGl_2(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_66().n85_1) {
      tmp = 7683;
    } else if (_this__u8e3s4 === Companion_getInstance_66().o85_1) {
      tmp = 34056;
    } else if (_this__u8e3s4 === Companion_getInstance_66().p85_1) {
      tmp = 7682;
    } else if (_this__u8e3s4 === Companion_getInstance_66().q85_1) {
      tmp = 34055;
    } else if (_this__u8e3s4 === Companion_getInstance_66().r85_1) {
      tmp = 5386;
    } else if (_this__u8e3s4 === Companion_getInstance_66().s85_1) {
      tmp = 7680;
    } else if (_this__u8e3s4 === Companion_getInstance_66().t85_1) {
      tmp = 7681;
    } else if (_this__u8e3s4 === Companion_getInstance_66().u85_1) {
      tmp = 0;
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function toGl_3(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_52().x83_1) {
      tmp = 0;
    } else if (_this__u8e3s4 === Companion_getInstance_52().y83_1) {
      tmp = 3;
    } else if (_this__u8e3s4 === Companion_getInstance_52().z83_1) {
      tmp = 2;
    } else if (_this__u8e3s4 === Companion_getInstance_52().a84_1) {
      tmp = 1;
    } else if (_this__u8e3s4 === Companion_getInstance_52().c84_1) {
      tmp = 5;
    } else if (_this__u8e3s4 === Companion_getInstance_52().d84_1) {
      tmp = 6;
    } else if (_this__u8e3s4 === Companion_getInstance_52().b84_1) {
      tmp = 4;
    } else {
      get_unreachable();
    }
    return tmp;
  }
  function toGl_4(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_53().y7u_1) {
      tmp = 0;
    } else if (_this__u8e3s4 === Companion_getInstance_53().z7u_1) {
      tmp = 5121;
    } else if (_this__u8e3s4 === Companion_getInstance_53().a7v_1) {
      tmp = 5123;
    } else if (_this__u8e3s4 === Companion_getInstance_53().b7v_1) {
      tmp = 5125;
    } else {
      get_unreachable();
    }
    return tmp;
  }
  function toGl_5(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_63().f7w_1) {
      tmp = 1032;
    } else if (_this__u8e3s4 === Companion_getInstance_63().d7w_1) {
      tmp = 1028;
    } else if (_this__u8e3s4 === Companion_getInstance_63().e7w_1) {
      tmp = 1029;
    } else {
      var reason = 'Invalid AGCullFace(' + new AGCullFace(_this__u8e3s4) + ')';
      throw new NotImplementedError('An operation is not implemented: ' + reason);
    }
    return tmp;
  }
  function toGl_6(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.ka_1) {
      case 0:
        tmp = 34963;
        break;
      case 1:
        tmp = 34962;
        break;
      case 2:
        tmp = 35345;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function toGl_7(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.h8h_1.ka_1) {
      case 0:
        tmp = 35670;
        break;
      case 1:
        tmp = 5120;
        break;
      case 2:
        tmp = 5121;
        break;
      case 3:
        tmp = 5122;
        break;
      case 4:
        tmp = 5123;
        break;
      case 5:
        tmp = 5125;
        break;
      case 6:
        tmp = 5126;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function toGl_8(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_64().k80_1) {
      tmp = 3553;
    } else if (_this__u8e3s4 === Companion_getInstance_64().l80_1) {
      tmp = 32879;
    } else if (_this__u8e3s4 === Companion_getInstance_64().m80_1) {
      tmp = 34067;
    } else if (_this__u8e3s4 === Companion_getInstance_64().n80_1) {
      tmp = 36197;
    } else {
      tmp = _AGTextureTargetKind___get_ordinal__impl__gjzc5p(_this__u8e3s4);
    }
    return tmp;
  }
  function toGl_9(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_65().g81_1) {
      tmp = 33071;
    } else if (_this__u8e3s4 === Companion_getInstance_65().h81_1) {
      tmp = 10497;
    } else if (_this__u8e3s4 === Companion_getInstance_65().i81_1) {
      tmp = 33648;
    } else {
      tmp = 33071;
    }
    return tmp;
  }
  function toGl_10(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_69().s87_1) {
      tmp = 2305;
    } else if (_this__u8e3s4 === Companion_getInstance_69().u87_1) {
      tmp = 2304;
    } else if (_this__u8e3s4 === Companion_getInstance_69().t87_1) {
      tmp = 2305;
    } else {
      get_unreachable();
    }
    return tmp;
  }
  function GLGlobalState(gl, ag) {
    this.e8g_1 = gl;
    this.f8g_1 = ag;
    this.g8g_1 = korAtomic(0);
    this.h8g_1 = korAtomic(0);
    this.i8g_1 = korAtomic_0(new Long(0, 0));
    this.j8g_1 = korAtomic(0);
    this.k8g_1 = korAtomic(0);
    this.l8g_1 = korAtomic_0(new Long(0, 0));
    this.m8g_1 = new Lock();
    this.n8g_1 = fastArrayListOf([]);
  }
  function GLBaseProgram(globalState, programInfo) {
    GLBaseObject.call(this, globalState);
    this.s8e_1 = programInfo;
  }
  protoOf(GLBaseProgram).q8g = function () {
    this.s8e_1.g8m(this.p8g_1);
  };
  protoOf(GLBaseProgram).t8e = function () {
    this.s8e_1.h8m(this.p8g_1);
  };
  function GLBuffer(state) {
    GLBaseObject.call(this, state);
    this.u8g_1 = genBuffer(this.p8g_1);
    this.v8g_1 = -1;
    this.w8g_1 = new Long(0, 0);
    incrementAndGet(this.o8g_1.j8g_1);
  }
  protoOf(GLBuffer).z8h = function (value) {
    var tmp = this.o8g_1.l8g_1;
    // Inline function 'kotlin.Long.unaryPlus' call
    tmp.m5z(value.cb(this.w8g_1));
    this.w8g_1 = value;
  };
  protoOf(GLBuffer).q8g = function () {
    incrementAndGet(this.o8g_1.k8g_1);
    deleteBuffer(this.p8g_1, this.u8g_1);
    this.u8g_1 = -1;
    this.v8g_1 = -1;
  };
  protoOf(GLBuffer).toString = function () {
    return 'GLBuffer(' + this.u8g_1 + ')';
  };
  function GLBaseObject(globalState) {
    this.o8g_1 = globalState;
    this.p8g_1 = this.o8g_1.e8g_1;
  }
  protoOf(GLBaseObject).q8g = function () {
  };
  protoOf(GLBaseObject).o81 = function () {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o8g_1.m8g_1;
      this_0.y1p_1 = true;
      try {
        this.o8g_1.n8g_1.r(this);
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
  };
  function GLTexture(state) {
    GLBaseObject.call(this, state);
    this.i8i_1 = genTexture(this.p8g_1);
    this.j8i_1 = -2;
    this.k8i_1 = -2;
    this.l8i_1 = new Long(0, 0);
    incrementAndGet(this.o8g_1.g8g_1);
  }
  protoOf(GLTexture).z8h = function (value) {
    var tmp = this.o8g_1.i8g_1;
    // Inline function 'kotlin.Long.unaryPlus' call
    tmp.m5z(value.cb(this.l8i_1));
    this.l8i_1 = value;
  };
  protoOf(GLTexture).q8g = function () {
    incrementAndGet(this.o8g_1.h8g_1);
    deleteTexture(this.p8g_1, this.i8i_1);
    this.i8i_1 = -1;
  };
  function GLFrameBuffer(state, ag) {
    GLBaseObject.call(this, state);
    this.t8l_1 = ag;
    this.u8l_1 = genRenderbuffer(this.p8g_1);
    this.v8l_1 = genFramebuffer(this.p8g_1);
    this.w8l_1 = Companion_getInstance_59().g87_1;
  }
  protoOf(GLFrameBuffer).q8g = function () {
    deleteRenderbuffer(this.p8g_1, this.u8l_1);
    deleteFramebuffer(this.p8g_1, this.v8l_1);
    this.u8l_1 = -1;
    this.v8l_1 = -1;
  };
  function gl(_this__u8e3s4, state) {
    return createOnce(_this__u8e3s4, state, gl$lambda(state));
  }
  function gl_0(_this__u8e3s4, state) {
    return createOnce(_this__u8e3s4, state, gl$lambda_0(state, _this__u8e3s4));
  }
  function gl_1(_this__u8e3s4, state) {
    return createOnce(_this__u8e3s4, state, gl$lambda_1(state));
  }
  function createOnce(_this__u8e3s4, state, block) {
    if (_this__u8e3s4.e7y_1 == null ? true : !(_this__u8e3s4.f7y_1 === state.f8g_1.m7u_1)) {
      _this__u8e3s4.f7y_1 = state.f8g_1.m7u_1;
      _this__u8e3s4.j7y();
      _this__u8e3s4.e7y_1 = block(_this__u8e3s4);
    }
    var tmp = _this__u8e3s4.e7y_1;
    return (!(tmp == null) ? isInterface(tmp, AGNativeObject) : false) ? tmp : THROW_CCE();
  }
  function gl$lambda($state) {
    return function (it) {
      return new GLBuffer($state);
    };
  }
  function gl$lambda_0($state, $this_gl) {
    return function (it) {
      return new GLFrameBuffer($state, $this_gl);
    };
  }
  function gl$lambda_1($state) {
    return function (it) {
      return new GLTexture($state);
    };
  }
  function get_versionString(_this__u8e3s4) {
    _init_properties_GLShaderCompiler_kt__3td561();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var this_0 = versionString$delegate;
      var property = versionString$factory();
      var tmp0_elvis_lhs = this_0.l23_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = this_0.m23_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = this_0.l23_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var versionString$delegate;
  function get_versionInt(_this__u8e3s4) {
    _init_properties_GLShaderCompiler_kt__3td561();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var this_0 = versionInt$delegate;
      var property = versionInt$factory();
      var tmp0_elvis_lhs = this_0.l23_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = this_0.m23_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = this_0.l23_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var versionInt$delegate;
  function GLProgramInfo(programId, vertexId, fragmentId, blocks, config) {
    this.u8e_1 = programId;
    this.v8e_1 = vertexId;
    this.w8e_1 = fragmentId;
    this.x8e_1 = blocks;
    this.y8e_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.x8e_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.blocksByFixedLocation.<anonymous>' call
      var tmp$ret$0 = element.l83_1;
      destination.i2(tmp$ret$0, element);
    }
    tmp.z8e_1 = destination;
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.x8e_1.u();
      if (!iterator.v()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
      var maxValue = iterator.x().l83_1;
      while (iterator.v()) {
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
        var v = iterator.x().l83_1;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.a8f_1 = (tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs) + 1 | 0;
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = this.a8f_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp0_safe_receiver = this.z8e_1.s2(tmp_5);
      var tmp_6;
      if (tmp0_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.uniforms.<anonymous>' call
        tmp_6 = UniformsRef_init_$Create$(tmp0_safe_receiver);
      }
      tmp_4[tmp_5] = tmp_6;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.b8f_1 = tmp_4;
    this.c8f_1 = FastStringMap();
    this.d8f_1 = FastStringMap();
  }
  protoOf(GLProgramInfo).p8f = function (gl, name) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.d8f_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(name);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.getUniformLocation.<anonymous>' call
      var out = gl.i8m(this.u8e_1, name);
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(name, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  };
  protoOf(GLProgramInfo).h8m = function (gl) {
    gl.j8m(this.u8e_1);
  };
  protoOf(GLProgramInfo).g8m = function (gl) {
    if (!(this.v8e_1 === 0)) {
      gl.k8m(this.v8e_1);
    }
    if (!(this.w8e_1 === 0)) {
      gl.k8m(this.w8e_1);
    }
    if (!(this.u8e_1 === 0)) {
      gl.l8m(this.u8e_1);
    }
    this.v8e_1 = 0;
    this.w8e_1 = 0;
    this.u8e_1 = 0;
  };
  protoOf(GLProgramInfo).toString = function () {
    return 'GLProgramInfo(programId=' + this.u8e_1 + ', vertexId=' + this.v8e_1 + ', fragmentId=' + this.w8e_1 + ', blocks=' + this.x8e_1 + ', config=' + this.y8e_1 + ')';
  };
  protoOf(GLProgramInfo).hashCode = function () {
    var result = this.u8e_1;
    result = imul(result, 31) + this.v8e_1 | 0;
    result = imul(result, 31) + this.w8e_1 | 0;
    result = imul(result, 31) + hashCode(this.x8e_1) | 0;
    result = imul(result, 31) + this.y8e_1.hashCode() | 0;
    return result;
  };
  protoOf(GLProgramInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GLProgramInfo))
      return false;
    var tmp0_other_with_cast = other instanceof GLProgramInfo ? other : THROW_CCE();
    if (!(this.u8e_1 === tmp0_other_with_cast.u8e_1))
      return false;
    if (!(this.v8e_1 === tmp0_other_with_cast.v8e_1))
      return false;
    if (!(this.w8e_1 === tmp0_other_with_cast.w8e_1))
      return false;
    if (!equals(this.x8e_1, tmp0_other_with_cast.x8e_1))
      return false;
    if (!this.y8e_1.equals(tmp0_other_with_cast.y8e_1))
      return false;
    return true;
  };
  function createShader($this, gl, type, str, debugName) {
    var shaderId = gl.m8m(type);
    gl.n8m(shaderId, str);
    gl.o8m(shaderId);
    // Inline function 'korlibs.kgl.KmlGl.COMPILE_STATUS' call
    var out = getShaderiv(gl, shaderId, 35713);
    var errorInt = gl.p8m();
    // Inline function 'korlibs.kgl.KmlGl.GTRUE' call
    if (!(out === 1)) {
      var error = getShaderInfoLog(gl, shaderId);
      throw new ShaderException(str, error, errorInt, gl, debugName, type, out);
    }
    return shaderId;
  }
  function GLShaderCompiler() {
    GLShaderCompiler_instance = this;
    this.o8e_1 = Companion_getInstance_2().r24('GLShaderCompiler');
  }
  protoOf(GLShaderCompiler).p8e = function (gl, config, program, debugName) {
    var id = gl.q8m();
    var guessedGlSlVersion = get_versionInt(gl);
    var tmp0_elvis_lhs = Companion_getInstance_73().s8m();
    var usedGlSlVersion = tmp0_elvis_lhs == null ? guessedGlSlVersion : tmp0_elvis_lhs;
    if (Companion_getInstance_73().t8m()) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = this.o8e_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.f25(level)) {
        // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
        var tmp$ret$0 = 'GLSL version: usedGlSlVersion=' + usedGlSlVersion + ', guessed=' + guessedGlSlVersion + ', forced=' + Companion_getInstance_73().s8m() + '. used=' + usedGlSlVersion;
        this_0.g25(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = listOf_0([false, true]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
      var tmp$ret$2 = config.u8m(VOID, VOID, usedGlSlVersion, item);
      destination.r(tmp$ret$2);
    }
    var tmp1_container = this.v8m(gl, program, debugName, destination);
    var fragmentShaderId = tmp1_container.cg();
    var vertexShaderId = tmp1_container.dg();
    var finalConfig = tmp1_container.wj();
    var tmp2_iterator = program.t82_1.u();
    while (tmp2_iterator.v()) {
      var attr = tmp2_iterator.x();
      var location = attr.u8k_1;
      gl.w8m(id, location, attr.k8f_1);
    }
    gl.x8m(id, fragmentShaderId);
    gl.x8m(id, vertexShaderId);
    gl.y8m(id);
    // Inline function 'korlibs.kgl.KmlGl.LINK_STATUS' call
    var linkStatus = getProgramiv(gl, id, 35714);
    return new GLProgramInfo(id, vertexShaderId, fragmentShaderId, program.q82_1, finalConfig);
  };
  protoOf(GLShaderCompiler).v8m = function (gl, program, debugName, configs) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var errors = ArrayList_init_$Create$();
    var tmp0_iterator = configs.u();
    $l$loop: while (tmp0_iterator.v()) {
      var config = tmp0_iterator.x();
      try {
        var fragmentString = toNewGlslString(program.m82_1, config);
        var vertexString = toNewGlslString(program.l82_1, config);
        var fragmentShaderId = createShader(this, gl, 35632, fragmentString, debugName);
        var vertexShaderId = createShader(this, gl, 35633, vertexString, debugName);
        // Inline function 'korlibs.logger.Logger.debug' call
        var this_0 = this.o8e_1;
        var level = Level_DEBUG_getInstance();
        var tmp;
        if (this_0.f25(level)) {
          // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
          var tmp$ret$1 = '!!! PROGRAM SUCCESSFULLY COMPILED: config=' + config + '\n' + vertexString + '\n' + fragmentString;
          this_0.g25(level, tmp$ret$1);
          tmp = Unit_instance;
        }
        return new Triple(fragmentShaderId, vertexShaderId, config);
      } catch ($p) {
        if ($p instanceof ShaderException) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.debug' call
          var this_1 = this.o8e_1;
          var level_0 = Level_DEBUG_getInstance();
          var tmp_0;
          if (this_1.f25(level_0)) {
            // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
            var tmp$ret$3 = stackTraceToString(e);
            this_1.g25(level_0, tmp$ret$3);
            tmp_0 = Unit_instance;
          }
          // Inline function 'kotlin.collections.plusAssign' call
          errors.r(e);
          continue $l$loop;
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(errors, 10));
    var tmp0_iterator_0 = errors.u();
    while (tmp0_iterator_0.v()) {
      var item = tmp0_iterator_0.x();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
      var tmp$ret$5 = item.message;
      destination.r(tmp$ret$5);
    }
    throw Exception_init_$Create$('Tried several shaders: ' + destination, last(errors));
  };
  var GLShaderCompiler_instance;
  function GLShaderCompiler_getInstance() {
    if (GLShaderCompiler_instance == null)
      new GLShaderCompiler();
    return GLShaderCompiler_instance;
  }
  function versionString$delegate$lambda($this$$receiver) {
    _init_properties_GLShaderCompiler_kt__3td561();
    var tmp;
    if (_GLVariant___get_isWebGL__impl__bbd1dd($this$$receiver.y8h())) {
      tmp = _GLVariant___get_version__impl__9nyfwa($this$$receiver.y8h()) === 1 ? '1.00' : '3.00';
    } else {
      // Inline function 'korlibs.kgl.KmlGl.SHADING_LANGUAGE_VERSION' call
      tmp = $this$$receiver.m8e(35724);
    }
    return tmp;
  }
  function versionInt$delegate$lambda($this$$receiver) {
    _init_properties_GLShaderCompiler_kt__3td561();
    var tmp0_safe_receiver = Regex_init_$Create$('(\\d+\\.\\d+)').b9(get_versionString($this$$receiver));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m2();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : replace(tmp1_safe_receiver, '.', '');
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.trim' call
      tmp = toString(trim(isCharSequence(tmp2_safe_receiver) ? tmp2_safe_receiver : THROW_CCE()));
    }
    var tmp3_safe_receiver = tmp;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toIntOrNull(tmp3_safe_receiver);
    return tmp4_elvis_lhs == null ? 100 : tmp4_elvis_lhs;
  }
  function versionString$factory() {
    return getPropertyCallableRef('versionString', 1, KProperty1, function (receiver) {
      return get_versionString(receiver);
    }, null);
  }
  function versionInt$factory() {
    return getPropertyCallableRef('versionInt', 1, KProperty1, function (receiver) {
      return get_versionInt(receiver);
    }, null);
  }
  var properties_initialized_GLShaderCompiler_kt_k11ei3;
  function _init_properties_GLShaderCompiler_kt__3td561() {
    if (!properties_initialized_GLShaderCompiler_kt_k11ei3) {
      properties_initialized_GLShaderCompiler_kt_k11ei3 = true;
      versionString$delegate = new PropertyThis(VOID, versionString$delegate$lambda);
      versionInt$delegate = new PropertyThis(VOID, versionInt$delegate$lambda);
    }
  }
  function AGDummy(size) {
    size = size === VOID ? Size2D_init_$Create$(640, 480) : size;
    AG.call(this);
    this.o7u().q7z(numberToInt(size.r2k_1), numberToInt(size.s2k_1));
  }
  function AGPrint(size) {
    size = size === VOID ? Size2D_init_$Create$(640, 480) : size;
    AGBaseLog.call(this, size);
  }
  protoOf(AGPrint).i8n = function (str, kind) {
    println('PrintAG: ' + str);
  };
  var Kind_COMMAND_instance;
  var Kind_DRAW_instance;
  var Kind_DRAW_DETAILS_instance;
  var Kind_CLEAR_instance;
  var Kind_METRICS_instance;
  var Kind_FLIP_instance;
  var Kind_READ_instance;
  var Kind_REPAINT_instance;
  var Kind_DISPOSE_instance;
  var Kind_TEXTURE_UPLOAD_instance;
  var Kind_CLOSE_instance;
  var Kind_FRAME_BUFFER_instance;
  var Kind_BUFFER_instance;
  var Kind_TEXTURE_instance;
  var Kind_SHADER_instance;
  var Kind_OTHER_instance;
  var Kind_UNIFORM_instance;
  var Kind_UNIFORM_VALUES_instance;
  var Kind_SCISSORS_instance;
  var Kind_VIEWPORT_instance;
  var Kind_VERTEX_instance;
  var Kind_ENABLE_DISABLE_instance;
  var Kind_CONTEXT_LOST_instance;
  var Kind_FLUSH_instance;
  var Kind_entriesInitialized_0;
  function Kind_initEntries_0() {
    if (Kind_entriesInitialized_0)
      return Unit_instance;
    Kind_entriesInitialized_0 = true;
    Kind_COMMAND_instance = new Kind_0('COMMAND', 0);
    Kind_DRAW_instance = new Kind_0('DRAW', 1);
    Kind_DRAW_DETAILS_instance = new Kind_0('DRAW_DETAILS', 2);
    Kind_CLEAR_instance = new Kind_0('CLEAR', 3);
    Kind_METRICS_instance = new Kind_0('METRICS', 4);
    Kind_FLIP_instance = new Kind_0('FLIP', 5);
    Kind_READ_instance = new Kind_0('READ', 6);
    Kind_REPAINT_instance = new Kind_0('REPAINT', 7);
    Kind_DISPOSE_instance = new Kind_0('DISPOSE', 8);
    Kind_TEXTURE_UPLOAD_instance = new Kind_0('TEXTURE_UPLOAD', 9);
    Kind_CLOSE_instance = new Kind_0('CLOSE', 10);
    Kind_FRAME_BUFFER_instance = new Kind_0('FRAME_BUFFER', 11);
    Kind_BUFFER_instance = new Kind_0('BUFFER', 12);
    Kind_TEXTURE_instance = new Kind_0('TEXTURE', 13);
    Kind_SHADER_instance = new Kind_0('SHADER', 14);
    Kind_OTHER_instance = new Kind_0('OTHER', 15);
    Kind_UNIFORM_instance = new Kind_0('UNIFORM', 16);
    Kind_UNIFORM_VALUES_instance = new Kind_0('UNIFORM_VALUES', 17);
    Kind_SCISSORS_instance = new Kind_0('SCISSORS', 18);
    Kind_VIEWPORT_instance = new Kind_0('VIEWPORT', 19);
    Kind_VERTEX_instance = new Kind_0('VERTEX', 20);
    Kind_ENABLE_DISABLE_instance = new Kind_0('ENABLE_DISABLE', 21);
    Kind_CONTEXT_LOST_instance = new Kind_0('CONTEXT_LOST', 22);
    Kind_FLUSH_instance = new Kind_0('FLUSH', 23);
  }
  function Kind_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Kind_COMMAND_getInstance() {
    Kind_initEntries_0();
    return Kind_COMMAND_instance;
  }
  function Kind_FLIP_getInstance() {
    Kind_initEntries_0();
    return Kind_FLIP_instance;
  }
  function AGBaseLog(size) {
    size = size === VOID ? Size2D_init_$Create$(640, 480) : size;
    AGDummy.call(this, size);
    this.n8n_1 = 0;
    this.o8n_1 = 0;
    this.p8n_1 = 0;
    this.q8n_1 = 0;
    this.r8n_1 = linkedHashMapOf([]);
  }
  protoOf(AGBaseLog).i8n = function (str, kind) {
  };
  protoOf(AGBaseLog).r7u = function (command) {
    this.i8n('' + command, Kind_COMMAND_getInstance());
  };
  protoOf(AGBaseLog).q7u = function () {
    return this.i8n('finish()', Kind_FLIP_getInstance());
  };
  function Companion_44() {
    Companion_instance_58 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    tmp.i7v_1 = new UniformBlocksBuffersRef(tmp_0, tmp$ret$1, new Int32Array(0));
  }
  var Companion_instance_58;
  function Companion_getInstance_70() {
    if (Companion_instance_58 == null)
      new Companion_44();
    return Companion_instance_58;
  }
  function UniformBlocksBuffersRef(blocks, buffers, valueIndices) {
    Companion_getInstance_70();
    this.f8l_1 = blocks;
    this.g8l_1 = buffers;
    this.h8l_1 = valueIndices;
  }
  protoOf(UniformBlocksBuffersRef).n = function () {
    return this.f8l_1.length;
  };
  function UniformBlock$Gen$uniform$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.also' call
      var tmp0_elvis_lhs = this$0.u88_1;
      var this_0 = new TypedUniform(tmp0_elvis_lhs == null ? 'unknown' + this$0.t88_1.i89() : tmp0_elvis_lhs, this$0.v88_1, this$0.w88_1, this$0.t88_1, this$0.x88_1, this$0.y88_1);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.shader.Gen.uniform$delegate.<anonymous>.<anonymous>' call
      this$0.t88_1.n83_1.r(this_0);
      return this_0;
    };
  }
  function Gen(block, name, voffset, vindex, type, arrayCount, size, align) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    this.t88_1 = block;
    this.u88_1 = name;
    this.v88_1 = voffset;
    this.w88_1 = vindex;
    this.x88_1 = type;
    this.y88_1 = arrayCount;
    this.z88_1 = size;
    this.a89_1 = align;
    var tmp = this;
    tmp.b89_1 = lazy(UniformBlock$Gen$uniform$delegate$lambda(this));
  }
  protoOf(Gen).s8n = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b89_1;
    uniform$factory();
    return this_0.m2();
  };
  protoOf(Gen).c89 = function (block, property) {
    var tmp = this;
    var tmp0_elvis_lhs = this.u88_1;
    tmp.u88_1 = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    return this.s8n();
  };
  protoOf(Gen).toString = function () {
    return 'Gen(block=' + this.t88_1 + ', name=' + this.u88_1 + ', voffset=' + this.v88_1 + ', vindex=' + this.w88_1 + ', type=' + this.x88_1 + ', arrayCount=' + this.y88_1 + ', size=' + this.z88_1 + ', align=' + this.a89_1 + ')';
  };
  protoOf(Gen).hashCode = function () {
    var result = hashCode(this.t88_1);
    result = imul(result, 31) + (this.u88_1 == null ? 0 : getStringHashCode(this.u88_1)) | 0;
    result = imul(result, 31) + this.v88_1 | 0;
    result = imul(result, 31) + this.w88_1 | 0;
    result = imul(result, 31) + this.x88_1.hashCode() | 0;
    result = imul(result, 31) + this.y88_1 | 0;
    result = imul(result, 31) + this.z88_1 | 0;
    result = imul(result, 31) + this.a89_1 | 0;
    return result;
  };
  protoOf(Gen).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Gen))
      return false;
    var tmp0_other_with_cast = other instanceof Gen ? other : THROW_CCE();
    if (!equals(this.t88_1, tmp0_other_with_cast.t88_1))
      return false;
    if (!(this.u88_1 == tmp0_other_with_cast.u88_1))
      return false;
    if (!(this.v88_1 === tmp0_other_with_cast.v88_1))
      return false;
    if (!(this.w88_1 === tmp0_other_with_cast.w88_1))
      return false;
    if (!this.x88_1.equals(tmp0_other_with_cast.x88_1))
      return false;
    if (!(this.y88_1 === tmp0_other_with_cast.y88_1))
      return false;
    if (!(this.z88_1 === tmp0_other_with_cast.z88_1))
      return false;
    if (!(this.a89_1 === tmp0_other_with_cast.a89_1))
      return false;
    return true;
  };
  function UniformBlock(fixedLocation) {
    this.l83_1 = fixedLocation;
    this.m83_1 = new UBLayoutBuilder();
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.n83_1 = ArrayList_init_$Create$();
    this.o83_1 = 0;
  }
  protoOf(UniformBlock).zb = function () {
    return get_portableSimpleName(getKClassFromExpression(this));
  };
  protoOf(UniformBlock).f89 = function () {
    return this.n83_1;
  };
  protoOf(UniformBlock).g89 = function () {
    return this.m83_1.n();
  };
  protoOf(UniformBlock).h89 = function () {
    return nextMultipleOf(this.g89(), 256);
  };
  protoOf(UniformBlock).i89 = function () {
    return this.f89().n();
  };
  protoOf(UniformBlock).j89 = function (name) {
    return this.q89(name, VarType_Float1_getInstance(), 4, 4);
  };
  protoOf(UniformBlock).k89 = function (name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.j89(name) : $super.j89.call(this, name);
  };
  protoOf(UniformBlock).l89 = function (name) {
    return this.q89(name, VarType_Float2_getInstance(), 8, 8);
  };
  protoOf(UniformBlock).m89 = function (name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.l89(name) : $super.l89.call(this, name);
  };
  protoOf(UniformBlock).n89 = function (name) {
    return this.q89(name, VarType_Float4_getInstance(), 16, 16);
  };
  protoOf(UniformBlock).o89 = function (name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.n89(name) : $super.n89.call(this, name);
  };
  protoOf(UniformBlock).p89 = function (name) {
    return this.q89(name, VarType_Mat4_getInstance(), 64, 16);
  };
  protoOf(UniformBlock).s88 = function (name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.p89(name) : $super.p89.call(this, name);
  };
  protoOf(UniformBlock).q89 = function (name, type, size, align) {
    var tmp = this.m83_1.w8n(size, align);
    var tmp1 = this.o83_1;
    this.o83_1 = tmp1 + 1 | 0;
    return new Gen(this, name, tmp, tmp1, type, 1, size, align);
  };
  protoOf(UniformBlock).toString = function () {
    return 'UniformBlock[' + get_portableSimpleName(getKClassFromExpression(this)) + '][' + joinToString(this.f89(), ', ') + ', fixedLocation=' + this.l83_1 + ']';
  };
  function TypedUniform(name, voffset, vindex, block, type, arrayCount) {
    VariableWithOffset.call(this, name, type, arrayCount, Precision_DEFAULT_getInstance());
    this.h83_1 = voffset;
    this.i83_1 = vindex;
    this.j83_1 = block;
    this.k83_1 = new Uniform(name, type, arrayCount, VOID, VOID, this);
  }
  protoOf(TypedUniform).lh = function (thisRef, property) {
    return this;
  };
  protoOf(TypedUniform).toString = function () {
    return "TypedUniform(name='" + this.k8f_1 + "', offset=" + this.h83_1 + ', type=' + this.u2f() + ')';
  };
  function Companion_45() {
  }
  var Companion_instance_59;
  function Companion_getInstance_71() {
    return Companion_instance_59;
  }
  function _get_bufferSize__mp12kq($this) {
    return $this.v81_1.x36() / $this.t81_1 | 0;
  }
  function UniformBlockBuffer(block) {
    this.q81_1 = block;
    this.r81_1 = new AGBuffer();
    this.s81_1 = this.q81_1.g89();
    this.t81_1 = this.q81_1.h89();
    this.u81_1 = this.q81_1.f89().n();
    this.v81_1 = Buffer_init_$Create$(imul(this.t81_1, 1));
    this.w81_1 = new UniformsRef(this.q81_1, this.v81_1, -1);
    this.x81_1 = index$factory(this.w81_1);
    this.y81_1 = Buffer_init_$Create$(this.q81_1.h89());
  }
  protoOf(UniformBlockBuffer).toString = function () {
    return 'UniformBlockBuffer(' + this.q81_1 + ')';
  };
  protoOf(UniformBlockBuffer).x8n = function (_set____db54di) {
    var this_0 = this.x81_1;
    currentIndex$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(UniformBlockBuffer).q83 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x81_1;
    currentIndex$factory_0();
    return this_0.get();
  };
  protoOf(UniformBlockBuffer).l1s = function (index) {
    if (index >= (_get_bufferSize__mp12kq(this) - 1 | 0)) {
      // Inline function 'kotlin.math.max' call
      var a = index + 1 | 0;
      var b = imul(index + 2 | 0, 3);
      var newCapacity = Math.max(a, b);
      this.v81_1 = copyOf(this.v81_1, imul(this.t81_1, newCapacity));
      this.w81_1.k8l_1 = this.v81_1;
    }
  };
  protoOf(UniformBlockBuffer).n1y = function () {
    this.x8n(-1);
  };
  protoOf(UniformBlockBuffer).a82 = function () {
    var tmp = this.v81_1;
    // Inline function 'kotlin.math.max' call
    var b = imul(this.q83() + 1 | 0, this.q81_1.h89());
    var tmp$ret$0 = Math.max(0, b);
    this.r81_1.d7y(tmp, 0, tmp$ret$0);
    return this;
  };
  protoOf(UniformBlockBuffer).y8n = function () {
    var tmp1 = this.q83();
    this.x8n(tmp1 - 1 | 0);
  };
  function align($this, size) {
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var a = $this.u8n_1;
    tmp.u8n_1 = Math.max(a, size);
    while (!(($this.t8n_1 % size | 0) === 0)) {
      $this.t8n_1 = $this.t8n_1 + 1 | 0;
    }
    return $this;
  }
  function UBLayoutBuilder$size$delegate$lambda(this$0) {
    return function () {
      align(this$0, this$0.u8n_1);
      return this$0.t8n_1;
    };
  }
  function UBLayoutBuilder() {
    this.t8n_1 = 0;
    this.u8n_1 = 4;
    var tmp = this;
    tmp.v8n_1 = lazy(UBLayoutBuilder$size$delegate$lambda(this));
  }
  protoOf(UBLayoutBuilder).n = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v8n_1;
    size$factory();
    return this_0.m2();
  };
  protoOf(UBLayoutBuilder).w8n = function (size, align_0) {
    // Inline function 'kotlin.also' call
    var this_0 = align(this, align_0).t8n_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UBLayoutBuilder.rawAlloc.<anonymous>' call
    this.t8n_1 = this.t8n_1 + size | 0;
    return this_0;
  };
  function UniformsRef_init_$Init$(block, size, index, $this) {
    size = size === VOID ? 1 : size;
    index = index === VOID ? 0 : index;
    UniformsRef.call($this, block, Buffer_init_$Create$(imul(block.h89(), size)), index);
    return $this;
  }
  function UniformsRef_init_$Create$(block, size, index) {
    return UniformsRef_init_$Init$(block, size, index, objectCreate(protoOf(UniformsRef)));
  }
  function UniformsRef(block, buffer, index) {
    this.j8l_1 = block;
    this.k8l_1 = buffer;
    this.l8l_1 = index;
    this.m8l_1 = this.j8l_1.h89();
  }
  protoOf(UniformsRef).z8n = function (uniform) {
    return imul(this.l8l_1, this.m8l_1) + uniform.h83_1 | 0;
  };
  protoOf(UniformsRef).a8o = function (ref) {
    arraycopy_0(ref.v81_1, 0, this.k8l_1, imul(this.l8l_1, this.m8l_1), this.m8l_1);
  };
  protoOf(UniformsRef).b8o = function (uniform, value) {
    return this.c8o(uniform, value);
  };
  protoOf(UniformsRef).d8o = function (uniform, value) {
    return this.e8o(uniform, value.g28_1, value.h28_1);
  };
  protoOf(UniformsRef).f8o = function (uniform, value) {
    return this.g8o(uniform, _RGBAPremultiplied___get_rf__impl__pt0c4y(value), _RGBAPremultiplied___get_gf__impl__ivron7(value), _RGBAPremultiplied___get_bf__impl__qa3on2(value), _RGBAPremultiplied___get_af__impl__euwcjn(value));
  };
  protoOf(UniformsRef).h8o = function (uniform, value) {
    return this.g8o(uniform, value.e2o_1, value.f2o_1, value.g2o_1, value.h2o_1);
  };
  protoOf(UniformsRef).i8o = function (uniform, value) {
    return this.g8o(uniform, value.n2k_1, value.m2k_1, value.o2k_1, value.l2k_1);
  };
  protoOf(UniformsRef).j8o = function (uniform, value) {
    switch (uniform.u2f().ka_1) {
      case 3:
        this.k8o(uniform, value, Companion_getInstance_6().k2i());
        break;
      case 2:
        this.l8o(uniform, value, Companion_getInstance_6().k2i(), 12);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        throw new NotImplementedError();
    }
  };
  protoOf(UniformsRef).l8o = function (uniform, value, indices, max) {
    // Inline function 'kotlin.also' call
    var this_0 = this.z8n(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloatNIndexed' call
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.memory.setF32' call
        var this_1 = this.k8l_1;
        var byteOffset = this_0 + imul(n, 4) | 0;
        // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>.<anonymous>' call
        var it = indices[n];
        var value_0 = value.c2k(it);
        var tmp;
        if (true) {
          this_1.w36(byteOffset, value_0);
          tmp = Unit_instance;
        } else {
          this_1.v36(byteOffset, value_0);
          tmp = Unit_instance;
        }
      }
       while (inductionVariable < max);
  };
  protoOf(UniformsRef).k8o = function (uniform, value, indices, max, $super) {
    max = max === VOID ? indices.length : max;
    var tmp;
    if ($super === VOID) {
      this.l8o(uniform, value, indices, max);
      tmp = Unit_instance;
    } else {
      tmp = $super.l8o.call(this, uniform, value, indices, max);
    }
    return tmp;
  };
  protoOf(UniformsRef).c8o = function (uniform, value) {
    // Inline function 'kotlin.also' call
    var this_0 = this.z8n(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.k8l_1;
    var byteOffset = this_0 + 0 | 0;
    var tmp;
    if (true) {
      this_1.w36(byteOffset, value);
      tmp = Unit_instance;
    } else {
      this_1.v36(byteOffset, value);
      tmp = Unit_instance;
    }
  };
  protoOf(UniformsRef).e8o = function (uniform, x, y) {
    // Inline function 'kotlin.also' call
    var this_0 = this.z8n(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.m8o(this_0, x, y);
  };
  protoOf(UniformsRef).g8o = function (uniform, x, y, z, w) {
    // Inline function 'kotlin.also' call
    var this_0 = this.z8n(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.n8o(this_0, x, y, z, w);
  };
  protoOf(UniformsRef).m8o = function (index, x, y) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.k8l_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.w36(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.v36(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.k8l_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.w36(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.v36(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
  };
  protoOf(UniformsRef).n8o = function (index, x, y, z, w) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.k8l_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.w36(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.v36(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.k8l_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.w36(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.v36(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_2 = this.k8l_1;
    var byteOffset_1 = index + 8 | 0;
    var tmp_1;
    if (true) {
      this_2.w36(byteOffset_1, z);
      tmp_1 = Unit_instance;
    } else {
      this_2.v36(byteOffset_1, z);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_3 = this.k8l_1;
    var byteOffset_2 = index + 12 | 0;
    var tmp_2;
    if (true) {
      this_3.w36(byteOffset_2, w);
      tmp_2 = Unit_instance;
    } else {
      this_3.v36(byteOffset_2, w);
      tmp_2 = Unit_instance;
    }
  };
  function uniform$factory() {
    return getPropertyCallableRef('uniform', 1, KProperty1, function (receiver) {
      return receiver.s8n();
    }, null);
  }
  function index$factory($b0) {
    return getPropertyCallableRef('index', 0, KMutableProperty0, function () {
      return $b0.l8l_1;
    }, function (value) {
      $b0.l8l_1 = value;
      return Unit_instance;
    });
  }
  function currentIndex$factory() {
    return getPropertyCallableRef('currentIndex', 1, KMutableProperty1, function (receiver) {
      return receiver.q83();
    }, function (receiver, value) {
      return receiver.x8n(value);
    });
  }
  function currentIndex$factory_0() {
    return getPropertyCallableRef('currentIndex', 1, KMutableProperty1, function (receiver) {
      return receiver.q83();
    }, function (receiver, value) {
      return receiver.x8n(value);
    });
  }
  function size$factory() {
    return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
      return receiver.n();
    }, null);
  }
  function _GLVariant___init__impl__cjzpjb(data) {
    return data;
  }
  function _GLVariant___get_data__impl__nn46ye($this) {
    return $this;
  }
  function _GLVariant___get_isES__impl__yezzg8($this) {
    // Inline function 'korlibs.memory.extractBool' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 0 | 0) & 1) === 0);
  }
  function _GLVariant___get_isWebGL__impl__bbd1dd($this) {
    // Inline function 'korlibs.memory.extractBool' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 1 | 0) & 1) === 0);
  }
  function _GLVariant___get_version__impl__9nyfwa($this) {
    // Inline function 'korlibs.memory.extract8' call
    return (_GLVariant___get_data__impl__nn46ye($this) >>> 8 | 0) & 255;
  }
  function _GLVariant___get_os__impl__aswhdw($this) {
    var tmp = Companion_getInstance_7().f1p_1;
    // Inline function 'korlibs.memory.extract8' call
    var tmp$ret$0 = (_GLVariant___get_data__impl__nn46ye($this) >>> 16 | 0) & 255;
    var tmp0_elvis_lhs = getOrNull(tmp, tmp$ret$0);
    return tmp0_elvis_lhs == null ? Os_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
  function _GLVariant___get_supportTextureLevel__impl__3yeu62($this) {
    return !_GLVariant___get_isWebGL__impl__bbd1dd($this) ? !_GLVariant___get_isES__impl__yezzg8($this) : false;
  }
  function Companion_46() {
  }
  protoOf(Companion_46).o8o = function (isES, isWebGL, isCore, version, os) {
    return _GLVariant___init__impl__cjzpjb(insert8(insert8(insert(insert(insert(0, isES, 0), isWebGL, 1), isCore, 2), version, 8), os.ka_1, 16));
  };
  protoOf(Companion_46).p8o = function (isES, isWebGL, isCore, version, os, $super) {
    isES = isES === VOID ? false : isES;
    isWebGL = isWebGL === VOID ? false : isWebGL;
    isCore = isCore === VOID ? false : isCore;
    version = version === VOID ? 0 : version;
    os = os === VOID ? Os_UNKNOWN_getInstance() : os;
    return $super === VOID ? this.o8o(isES, isWebGL, isCore, version, os) : $super.o8o.call(this, isES, isWebGL, isCore, version, os).q8o_1;
  };
  protoOf(Companion_46).r8o = function () {
    return Companion_instance_60.p8o(false, VOID, VOID, 1, Os_UNKNOWN_getInstance());
  };
  protoOf(Companion_46).s8o = function (version) {
    return Companion_instance_60.p8o(true, true, VOID, version);
  };
  var Companion_instance_60;
  function Companion_getInstance_72() {
    return Companion_instance_60;
  }
  function GLVariant__toString_impl_o5yi3l($this) {
    return 'GLVariant(data=' + $this + ')';
  }
  function GLVariant__hashCode_impl_2eslaq($this) {
    return $this;
  }
  function GLVariant__equals_impl_kmlw2($this, other) {
    if (!(other instanceof GLVariant))
      return false;
    if (!($this === (other instanceof GLVariant ? other.q8o_1 : THROW_CCE())))
      return false;
    return true;
  }
  function GLVariant(data) {
    this.q8o_1 = data;
  }
  protoOf(GLVariant).toString = function () {
    return GLVariant__toString_impl_o5yi3l(this.q8o_1);
  };
  protoOf(GLVariant).hashCode = function () {
    return GLVariant__hashCode_impl_2eslaq(this.q8o_1);
  };
  protoOf(GLVariant).equals = function (other) {
    return GLVariant__equals_impl_kmlw2(this.q8o_1, other);
  };
  function toNewGlslString(_this__u8e3s4, config) {
    return toNewGlslStringResult(_this__u8e3s4, config).u8o_1;
  }
  function toNewGlslStringResult(_this__u8e3s4, config) {
    return (new GlslGenerator(_this__u8e3s4.y8o_1, config)).m8p(_this__u8e3s4);
  }
  function GlobalsProgramVisitor() {
    Visitor.call(this, Unit_instance);
    this.o8p_1 = LinkedHashSet_init_$Create$();
    this.p8p_1 = LinkedHashSet_init_$Create$();
    this.q8p_1 = LinkedHashSet_init_$Create$();
    this.r8p_1 = LinkedHashSet_init_$Create$();
    this.s8p_1 = LinkedHashSet_init_$Create$();
    this.t8p_1 = LinkedHashSet_init_$Create$();
    this.u8p_1 = LinkedHashSet_init_$Create$();
  }
  protoOf(GlobalsProgramVisitor).v8p = function (attribute) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.o8p_1.r(attribute);
  };
  protoOf(GlobalsProgramVisitor).w8p = function (attribute) {
    this.v8p(attribute);
    return Unit_instance;
  };
  protoOf(GlobalsProgramVisitor).x8p = function (varying) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.p8p_1.r(varying);
  };
  protoOf(GlobalsProgramVisitor).y8p = function (varying) {
    this.x8p(varying);
    return Unit_instance;
  };
  protoOf(GlobalsProgramVisitor).z8p = function (uniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.q8p_1.r(uniform);
    var tmp1_safe_receiver = uniform.m8q_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.r8p_1.r(tmp1_safe_receiver);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.s8p_1;
    var element = uniform.m8q_1.j83_1;
    this_0.r(element);
  };
  protoOf(GlobalsProgramVisitor).n8q = function (uniform) {
    this.z8p(uniform);
    return Unit_instance;
  };
  protoOf(GlobalsProgramVisitor).o8q = function (typedUniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.q8p_1;
    var element = typedUniform.k83_1;
    this_0.r(element);
    // Inline function 'kotlin.collections.plusAssign' call
    this.r8p_1.r(typedUniform);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.s8p_1;
    var element_0 = typedUniform.j83_1;
    this_1.r(element_0);
  };
  protoOf(GlobalsProgramVisitor).p8q = function (typedUniform) {
    this.o8q(typedUniform);
    return Unit_instance;
  };
  protoOf(GlobalsProgramVisitor).q8q = function (sampler) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.t8p_1.r(sampler);
  };
  protoOf(GlobalsProgramVisitor).r8q = function (sampler) {
    this.q8q(sampler);
    return Unit_instance;
  };
  protoOf(GlobalsProgramVisitor).s8q = function (func) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.u8p_1;
    var element = func.w8q().zb();
    this_0.r(element);
  };
  protoOf(GlobalsProgramVisitor).x8q = function (func) {
    this.s8q(func);
    return Unit_instance;
  };
  function Companion_47() {
    Companion_instance_61 = this;
    this.r8m_1 = Companion_getInstance_2().r24('GlslGenerator');
  }
  protoOf(Companion_47).s8m = function () {
    return Companion_getInstance_74().s8m();
  };
  protoOf(Companion_47).t8m = function () {
    return Companion_getInstance_74().t8m();
  };
  var Companion_instance_61;
  function Companion_getInstance_73() {
    if (Companion_instance_61 == null)
      new Companion_47();
    return Companion_instance_61;
  }
  function Result(generator, result, attributes, uniforms, varyings) {
    this.t8o_1 = generator;
    this.u8o_1 = result;
    this.v8o_1 = attributes;
    this.w8o_1 = uniforms;
    this.x8o_1 = varyings;
  }
  protoOf(Result).toString = function () {
    return 'Result(generator=' + this.t8o_1 + ', result=' + this.u8o_1 + ', attributes=' + this.v8o_1 + ', uniforms=' + this.w8o_1 + ', varyings=' + this.x8o_1 + ')';
  };
  protoOf(Result).hashCode = function () {
    var result = hashCode(this.t8o_1);
    result = imul(result, 31) + getStringHashCode(this.u8o_1) | 0;
    result = imul(result, 31) + hashCode(this.v8o_1) | 0;
    result = imul(result, 31) + hashCode(this.w8o_1) | 0;
    result = imul(result, 31) + hashCode(this.x8o_1) | 0;
    return result;
  };
  protoOf(Result).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.t8o_1, tmp0_other_with_cast.t8o_1))
      return false;
    if (!(this.u8o_1 === tmp0_other_with_cast.u8o_1))
      return false;
    if (!equals(this.v8o_1, tmp0_other_with_cast.v8o_1))
      return false;
    if (!equals(this.w8o_1, tmp0_other_with_cast.w8o_1))
      return false;
    if (!equals(this.x8o_1, tmp0_other_with_cast.x8o_1))
      return false;
    return true;
  };
  function sam$kotlin_Comparator$0(function_0) {
    this.f8s_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).aa = function (a, b) {
    return this.f8s_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.aa(a, b);
  };
  function GlslGenerator$generateResult$lambda$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
    var tmp = a.k8f_1;
    // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
    var tmp$ret$1 = b.k8f_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function GlslGenerator$generateResult$lambda(this$0, $types, $allFuncs) {
    return function ($this$invoke) {
      var tmp;
      if (!this$0.l8p_1.w8f_1) {
        var suffix = _GLVariant___get_isES__impl__yezzg8(this$0.l8p_1.t8f_1) ? ' es' : '';
        $this$invoke.g75('#version ' + this$0.l8p_1.v8f_1 + suffix);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (this$0.k8p_1.equals(ShaderType_FRAGMENT_getInstance())) {
        $this$invoke.g75('#extension GL_OES_standard_derivatives : enable');
        tmp_0 = Unit_instance;
      }
      $this$invoke.g75('#ifdef GL_ES');
      $this$invoke.g75('precision mediump float;');
      $this$invoke.g75('#endif');
      var tmp0_iterator = $types.o8p_1.u();
      while (tmp0_iterator.v()) {
        var it = tmp0_iterator.x();
        var layout = (this$0.l8p_1.g8s() ? this$0.l8p_1.v8f_1 >= 410 : false) ? 'layout(location = ' + it.u8k_1 + ') ' : '';
        $this$invoke.g75(layout + this$0.h8s() + ' ' + this$0.i8s(it.l8f_1) + this$0.j8s(it.u2f()) + ' ' + it.k8f_1 + this$0.k8s(it) + ';');
      }
      var tmp1_iterator = $types.t8p_1.u();
      while (tmp1_iterator.v()) {
        var it_0 = tmp1_iterator.x();
        var layout_0 = this$0.l8p_1.g8s() ? '' : '';
        $this$invoke.g75(layout_0 + this$0.l8s() + ' ' + this$0.i8s(it_0.l8f_1) + this$0.j8s(it_0.u2f()) + ' ' + it_0.k8f_1 + this$0.k8s(it_0) + ';');
      }
      var tmp_1;
      if (this$0.l8p_1.x8f()) {
        var tmp2_iterator = $types.s8p_1.u();
        while (tmp2_iterator.v()) {
          var block = tmp2_iterator.x();
          $this$invoke.g75('layout(std140) uniform ' + block.zb() + ' {');
          var tmp3_iterator = block.f89().u();
          while (tmp3_iterator.v()) {
            var uniform = tmp3_iterator.x();
            $this$invoke.g75('  ' + this$0.i8s(uniform.l8f_1) + this$0.j8s(uniform.u2f()) + ' ' + uniform.k8f_1 + this$0.k8s(uniform) + ';');
          }
          $this$invoke.g75('};');
        }
        tmp_1 = Unit_instance;
      } else {
        var tmp4_iterator = $types.q8p_1.u();
        while (tmp4_iterator.v()) {
          var it_1 = tmp4_iterator.x();
          $this$invoke.g75(this$0.l8s() + ' ' + this$0.i8s(it_1.l8f_1) + this$0.j8s(it_1.u2f()) + ' ' + it_1.k8f_1 + this$0.k8s(it_1) + ';');
        }
        tmp_1 = Unit_instance;
      }
      // Inline function 'kotlin.collections.sortedBy' call
      var this_0 = $types.p8p_1;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_2 = GlslGenerator$generateResult$lambda$lambda;
      var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp_2);
      var iterator = sortedWith(this_0, tmp$ret$0).u();
      var index = 0;
      $l$loop: while (iterator.v()) {
        var index_0 = index;
        index = index + 1 | 0;
        var it_2 = iterator.x();
        if (it_2 instanceof Output)
          continue $l$loop;
        var INOUT = !this$0.l8p_1.g8s() ? this$0.m8s() : (it_2.k8f_1 === this$0.l8p_1.n8s() ? this$0.k8p_1.equals(ShaderType_FRAGMENT_getInstance()) : false) ? this$0.m8s() : this$0.k8p_1.equals(ShaderType_VERTEX_getInstance()) ? this$0.m8s() : this$0.h8s();
        $this$invoke.g75(INOUT + ' ' + this$0.i8s(it_2.l8f_1) + this$0.j8s(it_2.u2f()) + ' ' + it_2.k8f_1 + ';');
      }
      var tmp7_iterator = $allFuncs.u();
      while (tmp7_iterator.v()) {
        var func = tmp7_iterator.x();
        var gen = new GlslBodyGenerator(this$0.k8p_1, this$0.l8p_1);
        gen.z8q(func);
        // Inline function 'kotlin.collections.map' call
        var this_1 = func.q8s_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
        var tmp0_iterator_0 = this_1.u();
        while (tmp0_iterator_0.v()) {
          var item = tmp0_iterator_0.x();
          // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
          var tmp$ret$2 = this$0.j8s(item.bg_1) + ' ' + item.ag_1;
          destination.r(tmp$ret$2);
        }
        var argsStrings = destination;
        // Inline function 'korlibs.io.util.Indenter.line' call
        var str = this$0.j8s(func.p8s_1) + ' ' + func.o8s_1 + '(' + joinToString(argsStrings, ', ') + ')';
        var tmp_3;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(str) === 0) {
          tmp_3 = '{';
        } else {
          tmp_3 = str + ' {';
        }
        $this$invoke.g75(tmp_3);
        // Inline function 'korlibs.io.util.Indenter.indent' call
        $this$invoke.h75();
        try {
          // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
          var tmp0_iterator_1 = gen.w8s_1.u();
          while (tmp0_iterator_1.v()) {
            var temp = tmp0_iterator_1.x();
            $this$invoke.g75(this$0.i8s(temp.l8f_1) + this$0.j8s(temp.u2f()) + ' ' + temp.k8f_1 + ';');
          }
          $this$invoke.f75(gen.x8s_1);
        }finally {
          $this$invoke.i75();
        }
        $this$invoke.g75('}');
      }
      return Unit_instance;
    };
  }
  function GlslGenerator(kind, config) {
    Companion_getInstance_73();
    this.k8p_1 = kind;
    this.l8p_1 = config;
  }
  protoOf(GlslGenerator).y8s = function () {
    return this.l8p_1;
  };
  protoOf(GlslGenerator).m8p = function (shader) {
    return this.z8s(shader.z8o_1, shader.a8p_1);
  };
  protoOf(GlslGenerator).z8s = function (root, funcs) {
    var types = new GlobalsProgramVisitor();
    if (this.k8p_1.equals(ShaderType_FRAGMENT_getInstance()) ? this.l8p_1.g8s() : false) {
      types.p8p_1.r(Varying_init_$Create$(this.l8p_1.n8s(), VarType_Float4_getInstance()));
    }
    var tmp = VarType_TVOID_getInstance();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    var mainFunc = new FuncDecl('main', tmp, tmp$ret$0, root);
    types.z8q(mainFunc);
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = funcs.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      if (types.u8p_1.z(element.s8s_1.zb())) {
        destination.r(element);
      }
    }
    var this_0 = reversed(destination);
    var set = HashSet_init_$Create$();
    var list = ArrayList_init_$Create$();
    var tmp0_iterator_0 = this_0.u();
    while (tmp0_iterator_0.v()) {
      var e = tmp0_iterator_0.x();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      var key = e.s8s_1.zb();
      if (set.r(key)) {
        list.r(e);
      }
    }
    var customFuncs = list;
    var tmp0_iterator_1 = funcs.u();
    while (tmp0_iterator_1.v()) {
      var func = tmp0_iterator_1.x();
      types.z8q(mainFunc);
    }
    var allFuncs = plus(customFuncs, listOf(mainFunc));
    // Inline function 'kotlin.also' call
    var tmp_0 = Companion_getInstance_8();
    var this_1 = tmp_0.n74(GlslGenerator$generateResult$lambda(this, types, allFuncs)).toString();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
    if (Companion_getInstance_74().t8m()) {
      // Inline function 'korlibs.logger.Logger.info' call
      var this_2 = Companion_getInstance_73().r8m_1;
      var level = Level_INFO_getInstance();
      var tmp_1;
      if (this_2.f25(level)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$6 = 'GlSlGenerator.version: ' + this.l8p_1.v8f_1;
        this_2.g25(level, tmp$ret$6);
        tmp_1 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.debug' call
      var this_3 = Companion_getInstance_73().r8m_1;
      var level_0 = Level_DEBUG_getInstance();
      var tmp_2;
      if (this_3.f25(level_0)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$8 = 'GlSlGenerator:\n' + this_1;
        this_3.g25(level_0, tmp$ret$8);
        tmp_2 = Unit_instance;
      }
    }
    var result = this_1;
    var tmp_3;
    if (root instanceof Raw) {
      tmp_3 = root.c8t(Companion_getInstance_74().b8s_1);
    } else {
      tmp_3 = result;
    }
    return new Result(this, tmp_3, toList(types.o8p_1), toList(types.q8p_1), toList(types.p8p_1));
  };
  function Companion_48() {
    Companion_instance_62 = this;
    this.a8s_1 = new GlslConfig(Companion_instance_60.r8o(), new Immutable(VOID, VOID, VOID, true));
    this.b8s_1 = 'GLSL';
    this.c8s_1 = 100;
    this.d8s_1 = 'fragColor';
    this.e8s_1 = 'gl_FragColor';
  }
  protoOf(Companion_48).s8m = function () {
    var tmp0_safe_receiver = Companion_instance.s13('FORCE_GLSL_VERSION');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : replace(tmp0_safe_receiver, '.', '');
    return tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
  };
  protoOf(Companion_48).t8m = function () {
    return Companion_instance.s13('DEBUG_GLSL') === 'true';
  };
  var Companion_instance_62;
  function Companion_getInstance_74() {
    if (Companion_instance_62 == null)
      new Companion_48();
    return Companion_instance_62;
  }
  function GlslConfig(variant, features, glslVersion, compatibility) {
    Companion_getInstance_74();
    glslVersion = glslVersion === VOID ? -1 : glslVersion;
    compatibility = compatibility === VOID ? true : compatibility;
    this.t8f_1 = variant;
    this.u8f_1 = features;
    this.v8f_1 = glslVersion;
    this.w8f_1 = compatibility;
  }
  protoOf(GlslConfig).d8t = function (name) {
    if (this.w8f_1)
      return name;
    return name === 'texture2D' ? 'texture' : name;
  };
  protoOf(GlslConfig).g8s = function () {
    if (_GLVariant___get_isES__impl__yezzg8(this.t8f_1))
      return this.v8f_1 >= 300;
    return !this.w8f_1;
  };
  protoOf(GlslConfig).x8f = function () {
    return (get_ENABLE_UNIFORM_BLOCKS() ? this.g8s() : false) ? this.u8f_1.w7u() : false;
  };
  protoOf(GlslConfig).h8s = function () {
    return this.g8s() ? 'in' : 'attribute';
  };
  protoOf(GlslConfig).m8s = function () {
    return this.g8s() ? 'out' : 'varying';
  };
  protoOf(GlslConfig).l8s = function () {
    return 'uniform';
  };
  protoOf(GlslConfig).n8s = function () {
    return this.g8s() ? Companion_getInstance_74().d8s_1 : Companion_getInstance_74().e8s_1;
  };
  protoOf(GlslConfig).e8t = function (variant, features, glslVersion, compatibility) {
    return new GlslConfig(variant, features, glslVersion, compatibility);
  };
  protoOf(GlslConfig).u8m = function (variant, features, glslVersion, compatibility, $super) {
    variant = variant === VOID ? this.t8f_1 : variant;
    features = features === VOID ? this.u8f_1 : features;
    glslVersion = glslVersion === VOID ? this.v8f_1 : glslVersion;
    compatibility = compatibility === VOID ? this.w8f_1 : compatibility;
    return $super === VOID ? this.e8t(variant, features, glslVersion, compatibility) : $super.e8t.call(this, new GLVariant(variant), features, glslVersion, compatibility);
  };
  protoOf(GlslConfig).toString = function () {
    return 'GlslConfig(variant=' + new GLVariant(this.t8f_1) + ', features=' + this.u8f_1 + ', glslVersion=' + this.v8f_1 + ', compatibility=' + this.w8f_1 + ')';
  };
  protoOf(GlslConfig).hashCode = function () {
    var result = GLVariant__hashCode_impl_2eslaq(this.t8f_1);
    result = imul(result, 31) + hashCode(this.u8f_1) | 0;
    result = imul(result, 31) + this.v8f_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w8f_1) | 0;
    return result;
  };
  protoOf(GlslConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this.t8f_1 === tmp0_other_with_cast.t8f_1))
      return false;
    if (!equals(this.u8f_1, tmp0_other_with_cast.u8f_1))
      return false;
    if (!(this.v8f_1 === tmp0_other_with_cast.v8f_1))
      return false;
    if (!(this.w8f_1 === tmp0_other_with_cast.w8f_1))
      return false;
    return true;
  };
  function errorType($this, type) {
    invalidOp("Don't know how to serialize type " + type);
  }
  function BaseGlslGenerator() {
  }
  function GlslBodyGenerator$visit$lambda(this$0) {
    return function (it) {
      return this$0.k8r(it);
    };
  }
  function GlslBodyGenerator$visit$lambda_0(this$0) {
    return function (it) {
      return this$0.k8r(it);
    };
  }
  function GlslBodyGenerator(kind, config) {
    Visitor.call(this, '');
    this.u8s_1 = kind;
    this.v8s_1 = config;
    this.w8s_1 = LinkedHashSet_init_$Create$();
    this.x8s_1 = new Indenter();
  }
  protoOf(GlslBodyGenerator).y8s = function () {
    return this.v8s_1;
  };
  protoOf(GlslBodyGenerator).b8r = function (stms) {
    var tmp0_iterator = stms.f8t_1.u();
    while (tmp0_iterator.v()) {
      var stm = tmp0_iterator.x();
      this.a8r(stm);
    }
  };
  protoOf(GlslBodyGenerator).e8r = function (stm) {
    this.x8s_1.g75(this.k8r(stm.g8t_1) + ' = ' + this.k8r(stm.h8t_1) + ';');
  };
  protoOf(GlslBodyGenerator).f8r = function (stm) {
    this.x8s_1.g75('discard;');
  };
  protoOf(GlslBodyGenerator).g8r = function (stm) {
    this.x8s_1.g75('break;');
  };
  protoOf(GlslBodyGenerator).h8r = function (stm) {
    this.x8s_1.g75('continue;');
  };
  protoOf(GlslBodyGenerator).j8r = function (stm) {
    var result = stm.i8t_1;
    if (!(result == null)) {
      this.x8s_1.g75('return ' + this.k8r(result) + ';');
    } else {
      this.x8s_1.g75('return;');
    }
  };
  protoOf(GlslBodyGenerator).w8r = function (operand) {
    var tmp = this.j8s(operand.k8t_1) + '(';
    return tmp + joinToString_0(operand.l8t_1, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda(this)) + ')';
  };
  protoOf(GlslBodyGenerator).r8r = function (operand) {
    return '(' + operand.n8t_1 + '(' + this.k8r(operand.o8t_1) + ')' + ')';
  };
  protoOf(GlslBodyGenerator).s8r = function (operand) {
    return '(' + this.k8r(operand.q8t_1) + ' ' + operand.r8t_1 + ' ' + this.k8r(operand.s8t_1) + ')';
  };
  protoOf(GlslBodyGenerator).l8r = function (func) {
    var tmp = this.v8s_1.d8t(func.zb()) + '(';
    var tmp_0 = func.u8t();
    return tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda_0(this)) + ')';
  };
  protoOf(GlslBodyGenerator).t8r = function (ternary) {
    return '((' + this.k8r(ternary.w8t_1) + ') ? (' + this.k8r(ternary.x8t_1) + ') : (' + this.k8r(ternary.y8t_1) + '))';
  };
  protoOf(GlslBodyGenerator).c8r = function (stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.x8s_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'if (' + this.k8r(stm.z8t_1) + ')';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.g75(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.h75();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.a8r(stm.a8u_1);
    }finally {
      this_0.i75();
    }
    this_0.g75('}');
    if (!(stm.b8u_1 == null)) {
      // Inline function 'korlibs.io.util.Indenter.line' call
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('else') === 0) {
        tmp_0 = '{';
      } else {
        tmp_0 = 'else' + ' {';
      }
      this_0.g75(tmp_0);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      this_0.h75();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
        this.a8r(ensureNotNull(stm.b8u_1));
      }finally {
        this_0.i75();
      }
      this_0.g75('}');
    }
  };
  protoOf(GlslBodyGenerator).d8r = function (stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.x8s_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    var varType = this.j8s(stm.c8u_1.u2f());
    var loopVar = this.n8r(stm.c8u_1);
    var min = this.k8r(stm.d8u_1);
    var maxExclusive = this.k8r(stm.e8u_1);
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'for (' + varType + ' ' + loopVar + ' = (' + min + '); ' + loopVar + ' < (' + maxExclusive + '); ' + loopVar + '++)';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.g75(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.h75();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.a8r(stm.f8u_1);
    }finally {
      this_0.i75();
    }
    this_0.g75('}');
  };
  protoOf(GlslBodyGenerator).i8r = function (stm) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    this.x8s_1.g75(stm.c8t(Companion_getInstance_74().b8s_1));
  };
  protoOf(GlslBodyGenerator).n8r = function (operand) {
    protoOf(Visitor).n8r.call(this, operand);
    var tmp;
    if (operand instanceof Output) {
      var tmp_0;
      switch (this.u8s_1.ka_1) {
        case 0:
          tmp_0 = 'gl_Position';
          break;
        case 1:
          tmp_0 = this.v8s_1.n8s();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = operand.k8f_1;
    }
    return tmp;
  };
  protoOf(GlslBodyGenerator).o8r = function (temp) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.w8s_1.r(temp);
    return protoOf(Visitor).o8r.call(this, temp);
  };
  protoOf(GlslBodyGenerator).q8r = function (output) {
    return protoOf(Visitor).q8r.call(this, output);
  };
  protoOf(GlslBodyGenerator).x8r = function (operand) {
    return '' + operand.h8u_1;
  };
  protoOf(GlslBodyGenerator).y8r = function (operand) {
    var str = '' + operand.j8u_1;
    return contains(str, _Char___init__impl__6a9atx(46)) ? str : str + '.0';
  };
  protoOf(GlslBodyGenerator).z8r = function (operand) {
    return '' + operand.l8u_1;
  };
  protoOf(GlslBodyGenerator).u8r = function (operand) {
    return this.k8r(operand.n8u_1) + '.' + operand.o8u_1;
  };
  protoOf(GlslBodyGenerator).v8r = function (operand) {
    return this.k8r(operand.q8u_1) + '[' + this.k8r(operand.r8u_1) + ']';
  };
  function ProgramLayout_init_$Init$(variables, layoutSize, $this) {
    layoutSize = layoutSize === VOID ? null : layoutSize;
    ProgramLayout.call($this, toFastList_0(variables), layoutSize);
    return $this;
  }
  function ProgramLayout_init_$Create$(variables, layoutSize) {
    return ProgramLayout_init_$Init$(variables, layoutSize, objectCreate(protoOf(ProgramLayout)));
  }
  function ProgramLayout$names$lambda(it) {
    return it.k8f_1;
  }
  function ProgramLayout(items, layoutSize, fixedLocation) {
    fixedLocation = fixedLocation === VOID ? -1 : fixedLocation;
    this.x8j_1 = items;
    this.y8j_1 = layoutSize;
    this.z8j_1 = fixedLocation;
    this.a8k_1 = 0;
    var tmp = this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = this.x8j_1;
    // Inline function 'kotlin.also' call
    var this_1 = new IntArrayList();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var v = tmp0_iterator.x();
      // Inline function 'korlibs.graphics.shader.ProgramLayout.alignments.<anonymous>' call
      var a = v.u2f().h8h_1.u8u_1;
      var tmp$ret$0 = a <= 1 ? 1 : a;
      this_1.m1s(tmp$ret$0);
    }
    tmp.b8k_1 = this_1;
    var tmp_0 = this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_2 = this.x8j_1;
    // Inline function 'kotlin.also' call
    var this_3 = new IntArrayList();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var tmp0_iterator_0 = this_2.u();
    while (tmp0_iterator_0.v()) {
      var v_0 = tmp0_iterator_0.x();
      // Inline function 'korlibs.graphics.shader.ProgramLayout._positions.<anonymous>' call
      this.a8k_1 = !(v_0.g8v_1 == null) ? v_0.g8v_1 : nextAlignedTo(this.a8k_1, v_0.u2f().h8h_1.u8u_1);
      var out = this.a8k_1;
      this.a8k_1 = this.a8k_1 + v_0.u2f().k8h_1 | 0;
      this_3.m1s(out);
    }
    tmp_0.c8k_1 = this_3;
    var tmp_1 = this;
    var tmp0_elvis_lhs = maxOrNull(this.b8k_1);
    tmp_1.d8k_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = this;
    var tmp0_elvis_lhs_0 = this.y8j_1;
    tmp_2.e8k_1 = tmp0_elvis_lhs_0 == null ? nextAlignedTo(this.a8k_1, this.d8k_1) : tmp0_elvis_lhs_0;
  }
  protoOf(ProgramLayout).u = function () {
    return this.x8j_1.u();
  };
  protoOf(ProgramLayout).h8v = function () {
    return joinToString(this.x8j_1, ', ', VOID, VOID, VOID, VOID, ProgramLayout$names$lambda);
  };
  protoOf(ProgramLayout).toString = function () {
    return get_portableSimpleName(getKClassFromExpression(this)) + '[' + this.h8v() + ', fixedLocation=' + this.z8j_1 + ']';
  };
  function Attribute_init_$Init$(name, type, normalized, precision, fixedLocation, $this) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    Attribute.call($this, name, type, normalized, null, true, precision, VOID, fixedLocation);
    return $this;
  }
  function Attribute_init_$Create$(name, type, normalized, precision, fixedLocation) {
    return Attribute_init_$Init$(name, type, normalized, precision, fixedLocation, objectCreate(protoOf(Attribute)));
  }
  function Attribute(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    offset = offset === VOID ? null : offset;
    active = active === VOID ? true : active;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    divisor = divisor === VOID ? 0 : divisor;
    VariableWithOffset.call(this, name, type, 1, precision, offset);
    this.r8k_1 = normalized;
    this.s8k_1 = active;
    this.t8k_1 = divisor;
    this.u8k_1 = fixedLocation;
  }
  protoOf(Attribute).toString = function () {
    return 'Attribute(' + this.k8f_1 + ')';
  };
  protoOf(Attribute).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this.n8f_1 === other.n8f_1;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = this.u2f().equals(other.u2f());
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.a8h_1 === other.a8h_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.k8f_1 === other.k8f_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.r8k_1 === (other instanceof Attribute ? other : THROW_CCE()).r8k_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.g8v_1 == other.g8v_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.s8k_1 === other.s8k_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Attribute).hashCode = function () {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    var out = (this.n8f_1 + imul(this.u2f().hashCode(), 7) | 0) + imul(getStringHashCode(this.k8f_1), 11) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.r8k_1) | 0;
    out = imul(out, 7);
    var tmp = out;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.g8v_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.s8k_1) | 0;
    return out;
  };
  function Func_init_$Init$(name, ops, type, $this) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    Func.call($this, name, toList_0(ops), type);
    return $this;
  }
  function Func_init_$Create$(name, ops, type) {
    return Func_init_$Init$(name, ops, type, objectCreate(protoOf(Func)));
  }
  function Stms(stms) {
    Stm.call(this);
    this.f8t_1 = stms;
  }
  protoOf(Stms).toString = function () {
    return 'Stms(stms=' + this.f8t_1 + ')';
  };
  protoOf(Stms).hashCode = function () {
    return hashCode(this.f8t_1);
  };
  protoOf(Stms).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals(this.f8t_1, tmp0_other_with_cast.f8t_1))
      return false;
    return true;
  };
  function Set(to, from) {
    Stm.call(this);
    this.g8t_1 = to;
    this.h8t_1 = from;
  }
  protoOf(Set).toString = function () {
    return 'Set(to=' + this.g8t_1 + ', from=' + this.h8t_1 + ')';
  };
  protoOf(Set).hashCode = function () {
    var result = hashCode(this.g8t_1);
    result = imul(result, 31) + hashCode(this.h8t_1) | 0;
    return result;
  };
  protoOf(Set).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Set))
      return false;
    var tmp0_other_with_cast = other instanceof Set ? other : THROW_CCE();
    if (!equals(this.g8t_1, tmp0_other_with_cast.g8t_1))
      return false;
    if (!equals(this.h8t_1, tmp0_other_with_cast.h8t_1))
      return false;
    return true;
  };
  function Return(result) {
    Stm.call(this);
    this.i8t_1 = result;
  }
  protoOf(Return).toString = function () {
    return 'Return(result=' + this.i8t_1 + ')';
  };
  protoOf(Return).hashCode = function () {
    return this.i8t_1 == null ? 0 : hashCode(this.i8t_1);
  };
  protoOf(Return).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Return))
      return false;
    var tmp0_other_with_cast = other instanceof Return ? other : THROW_CCE();
    if (!equals(this.i8t_1, tmp0_other_with_cast.i8t_1))
      return false;
    return true;
  };
  function Break() {
  }
  function Continue() {
  }
  function Discard() {
    Discard_instance = this;
    Stm.call(this);
  }
  protoOf(Discard).toString = function () {
    return 'Discard';
  };
  var Discard_instance;
  function Discard_getInstance() {
    if (Discard_instance == null)
      new Discard();
    return Discard_instance;
  }
  function If(cond, tbody, fbody) {
    fbody = fbody === VOID ? null : fbody;
    Stm.call(this);
    this.z8t_1 = cond;
    this.a8u_1 = tbody;
    this.b8u_1 = fbody;
  }
  protoOf(If).toString = function () {
    return 'If(cond=' + this.z8t_1 + ', tbody=' + this.a8u_1 + ', fbody=' + this.b8u_1 + ')';
  };
  protoOf(If).hashCode = function () {
    var result = hashCode(this.z8t_1);
    result = imul(result, 31) + hashCode(this.a8u_1) | 0;
    result = imul(result, 31) + (this.b8u_1 == null ? 0 : hashCode(this.b8u_1)) | 0;
    return result;
  };
  protoOf(If).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals(this.z8t_1, tmp0_other_with_cast.z8t_1))
      return false;
    if (!equals(this.a8u_1, tmp0_other_with_cast.a8u_1))
      return false;
    if (!equals(this.b8u_1, tmp0_other_with_cast.b8u_1))
      return false;
    return true;
  };
  function ForSimple() {
  }
  function Raw() {
  }
  protoOf(Raw).i8v = function (name) {
    return this.a8t_1.s2(name);
  };
  protoOf(Raw).j8v = function (name, default_0) {
    var tmp0_elvis_lhs = this.i8v(name);
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  };
  protoOf(Raw).c8t = function (name, default_0, $super) {
    default_0 = default_0 === VOID ? '' : default_0;
    return $super === VOID ? this.j8v(name, default_0) : $super.j8v.call(this, name, default_0);
  };
  function Program$ExpressionBuilder$Companion$INSTANCE$1() {
  }
  function Companion_49() {
    Companion_instance_63 = this;
    var tmp = this;
    tmp.k8v_1 = new Program$ExpressionBuilder$Companion$INSTANCE$1();
  }
  var Companion_instance_63;
  function Companion_getInstance_75() {
    if (Companion_instance_63 == null)
      new Companion_49();
    return Companion_instance_63;
  }
  function Program$Builder$FuncProvider$provideDelegate$lambda(this$0) {
    return function ($this$FUNC) {
      // Inline function 'kotlin.collections.mapIndexed' call
      var this_0 = this$0.m8v_1;
      // Inline function 'kotlin.collections.mapIndexedTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var index = 0;
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.graphics.shader.FuncProvider.provideDelegate.<anonymous>.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var index_0 = checkIndexOverflow(tmp1);
        var tmp$ret$0 = $this$FUNC.s8v('p' + index_0, item);
        destination.r(tmp$ret$0);
      }
      var args = destination;
      this$0.o8v_1($this$FUNC, args);
      return Unit_instance;
    };
  }
  function Builder_init_$Init$(parent, $this) {
    Builder.call($this, parent.w89_1);
    return $this;
  }
  function Builder_init_$Create$(parent) {
    return Builder_init_$Init$(parent, objectCreate(protoOf(Builder)));
  }
  function FuncBuilder(parent) {
    Builder_init_$Init$(parent, this);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.r8v_1 = ArrayList_init_$Create$();
  }
  protoOf(FuncBuilder).s8v = function (name, type) {
    // Inline function 'kotlin.also' call
    var this_0 = new Arg(name, type);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.FuncBuilder.ARG.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.r8v_1.r(this_0);
    return this_0;
  };
  function FuncDeclGetter(decl) {
    this.h8w_1 = decl;
  }
  protoOf(FuncDeclGetter).lh = function (thisRef, property) {
    var tmp = this.h8w_1;
    return isInterface(tmp, FuncRef) ? tmp : THROW_CCE();
  };
  function FuncProvider(rettype, varTypes, builder, block) {
    this.l8v_1 = rettype;
    this.m8v_1 = varTypes;
    this.n8v_1 = builder;
    this.o8v_1 = block;
  }
  protoOf(FuncProvider).t89 = function (thisRef, property) {
    var tmp = property.callableName;
    var tmp_0 = this.n8v_1.s8a(tmp, this.l8v_1, Program$Builder$FuncProvider$provideDelegate$lambda(this));
    return new FuncDeclGetter(tmp_0 instanceof FuncDecl ? tmp_0 : THROW_CCE());
  };
  function Program$Builder$_funcs$1($funcs) {
    this.j8w_1 = $funcs;
    Visitor.call(this, Unit_instance);
  }
  protoOf(Program$Builder$_funcs$1).s8q = function (func) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.j8w_1;
    var key = func.zb();
    var tmp = func.w8q();
    var value = tmp instanceof FuncDecl ? tmp : THROW_CCE();
    this_0.i2(key, value);
  };
  protoOf(Program$Builder$_funcs$1).x8q = function (func) {
    this.s8q(func);
    return Unit_instance;
  };
  function Program$Builder$FUNC$lambda($block) {
    return function ($this$$receiver, it) {
      $block($this$$receiver, it.f1(0));
      return Unit_instance;
    };
  }
  function Program$Builder$FUNC$lambda_0($block) {
    return function ($this$$receiver, it) {
      $block($this$$receiver, it.f1(0), it.f1(1));
      return Unit_instance;
    };
  }
  function Program$Builder$FUNC$lambda_1($block) {
    return function ($this$$receiver, it) {
      $block($this$$receiver, it.f1(0), it.f1(1), it.f1(2));
      return Unit_instance;
    };
  }
  function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda($block, $max) {
    return function ($this$null) {
      $block($this$null, $max);
      return Unit_instance;
    };
  }
  function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0($ref, $middle, $max, $block) {
    return function ($this$null) {
      $this$null.c8b($ref, $middle + 1 | 0, $max, $block);
      return Unit_instance;
    };
  }
  function Program$Builder$IF_ELSE_LIST$lambda($ref, $min, $max, $block) {
    return function ($this$null) {
      $this$null.d8b($ref, $min + 1 | 0, $max, $block);
      return Unit_instance;
    };
  }
  function Ternary(cond, otrue, ofalse) {
    Operand.call(this, otrue.u2f());
    this.w8t_1 = cond;
    this.x8t_1 = otrue;
    this.y8t_1 = ofalse;
  }
  protoOf(Ternary).toString = function () {
    return 'Ternary(cond=' + this.w8t_1 + ', otrue=' + this.x8t_1 + ', ofalse=' + this.y8t_1 + ')';
  };
  protoOf(Ternary).hashCode = function () {
    var result = hashCode(this.w8t_1);
    result = imul(result, 31) + hashCode(this.x8t_1) | 0;
    result = imul(result, 31) + hashCode(this.y8t_1) | 0;
    return result;
  };
  protoOf(Ternary).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ternary))
      return false;
    var tmp0_other_with_cast = other instanceof Ternary ? other : THROW_CCE();
    if (!equals(this.w8t_1, tmp0_other_with_cast.w8t_1))
      return false;
    if (!equals(this.x8t_1, tmp0_other_with_cast.x8t_1))
      return false;
    if (!equals(this.y8t_1, tmp0_other_with_cast.y8t_1))
      return false;
    return true;
  };
  function Unop(op, right) {
    Operand.call(this, right.u2f());
    this.n8t_1 = op;
    this.o8t_1 = right;
  }
  protoOf(Unop).toString = function () {
    return 'Unop(op=' + this.n8t_1 + ', right=' + this.o8t_1 + ')';
  };
  protoOf(Unop).hashCode = function () {
    var result = getStringHashCode(this.n8t_1);
    result = imul(result, 31) + hashCode(this.o8t_1) | 0;
    return result;
  };
  protoOf(Unop).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Unop))
      return false;
    var tmp0_other_with_cast = other instanceof Unop ? other : THROW_CCE();
    if (!(this.n8t_1 === tmp0_other_with_cast.n8t_1))
      return false;
    if (!equals(this.o8t_1, tmp0_other_with_cast.o8t_1))
      return false;
    return true;
  };
  function Binop(left, op, right) {
    Operand.call(this, left.u2f());
    this.q8t_1 = left;
    this.r8t_1 = op;
    this.s8t_1 = right;
  }
  protoOf(Binop).toString = function () {
    return 'Binop(left=' + this.q8t_1 + ', op=' + this.r8t_1 + ', right=' + this.s8t_1 + ')';
  };
  protoOf(Binop).hashCode = function () {
    var result = hashCode(this.q8t_1);
    result = imul(result, 31) + getStringHashCode(this.r8t_1) | 0;
    result = imul(result, 31) + hashCode(this.s8t_1) | 0;
    return result;
  };
  protoOf(Binop).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals(this.q8t_1, tmp0_other_with_cast.q8t_1))
      return false;
    if (!(this.r8t_1 === tmp0_other_with_cast.r8t_1))
      return false;
    if (!equals(this.s8t_1, tmp0_other_with_cast.s8t_1))
      return false;
    return true;
  };
  function IntLiteral() {
  }
  function FloatLiteral(value) {
    Operand.call(this, VarType_Float1_getInstance());
    this.j8u_1 = value;
  }
  protoOf(FloatLiteral).toString = function () {
    return 'FloatLiteral(value=' + this.j8u_1 + ')';
  };
  protoOf(FloatLiteral).hashCode = function () {
    return getNumberHashCode(this.j8u_1);
  };
  protoOf(FloatLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals(this.j8u_1, tmp0_other_with_cast.j8u_1))
      return false;
    return true;
  };
  function BoolLiteral() {
  }
  function Vector(type, ops) {
    Operand.call(this, type);
    this.k8t_1 = type;
    this.l8t_1 = ops;
  }
  protoOf(Vector).u2f = function () {
    return this.k8t_1;
  };
  protoOf(Vector).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this.k8t_1.equals(other.k8t_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.l8t_1, other.l8t_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Vector).hashCode = function () {
    return imul(this.k8t_1.hashCode(), 7) + contentHashCode(this.l8t_1) | 0;
  };
  protoOf(Vector).toString = function () {
    return 'Vector(type=' + this.k8t_1 + ', ops=' + toString(this.l8t_1) + ')';
  };
  function Swizzle(left, swizzle) {
    Operand.call(this, left.u2f().l8w(swizzle.length));
    this.n8u_1 = left;
    this.o8u_1 = swizzle;
  }
  protoOf(Swizzle).toString = function () {
    return 'Swizzle(left=' + this.n8u_1 + ', swizzle=' + this.o8u_1 + ')';
  };
  protoOf(Swizzle).hashCode = function () {
    var result = hashCode(this.n8u_1);
    result = imul(result, 31) + getStringHashCode(this.o8u_1) | 0;
    return result;
  };
  protoOf(Swizzle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals(this.n8u_1, tmp0_other_with_cast.n8u_1))
      return false;
    if (!(this.o8u_1 === tmp0_other_with_cast.o8u_1))
      return false;
    return true;
  };
  function ArrayAccess() {
  }
  function BaseFunc(type) {
    Operand.call(this, type);
  }
  function Func(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    BaseFunc.call(this, type);
    this.n8w_1 = name;
    this.o8w_1 = ops;
    this.p8w_1 = type;
  }
  protoOf(Func).zb = function () {
    return this.n8w_1;
  };
  protoOf(Func).u8t = function () {
    return this.o8w_1;
  };
  protoOf(Func).u2f = function () {
    return this.p8w_1;
  };
  protoOf(Func).toString = function () {
    return 'Func(name=' + this.n8w_1 + ', ops=' + this.o8w_1 + ', type=' + this.p8w_1 + ')';
  };
  protoOf(Func).hashCode = function () {
    var result = getStringHashCode(this.n8w_1);
    result = imul(result, 31) + hashCode(this.o8w_1) | 0;
    result = imul(result, 31) + this.p8w_1.hashCode() | 0;
    return result;
  };
  protoOf(Func).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this.n8w_1 === tmp0_other_with_cast.n8w_1))
      return false;
    if (!equals(this.o8w_1, tmp0_other_with_cast.o8w_1))
      return false;
    if (!this.p8w_1.equals(tmp0_other_with_cast.p8w_1))
      return false;
    return true;
  };
  function CustomFunc(ref, ops) {
    BaseFunc.call(this, ref.q8w());
    this.u8q_1 = ref;
    this.v8q_1 = ops;
  }
  protoOf(CustomFunc).w8q = function () {
    return this.u8q_1;
  };
  protoOf(CustomFunc).u8t = function () {
    return this.v8q_1;
  };
  protoOf(CustomFunc).zb = function () {
    return this.w8q().zb();
  };
  function FuncRef() {
  }
  function Stm() {
  }
  function BuilderContext() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.r8w_1 = ArrayList_init_$Create$();
    this.s8w_1 = 3;
  }
  function ExpressionBuilder() {
  }
  function Builder(context) {
    context = context === VOID ? new BuilderContext() : context;
    this.w89_1 = context;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.x89_1 = ArrayList_init_$Create$();
  }
  protoOf(Builder).o8a = function () {
    return Builder_init_$Create$(this);
  };
  protoOf(Builder).p8a = function () {
    return new FuncBuilder(this);
  };
  protoOf(Builder).q8a = function () {
    return new Stms(toList(this.x89_1));
  };
  protoOf(Builder).r8a = function () {
    var funcs = LinkedHashMap_init_$Create$_0();
    (new Program$Builder$_funcs$1(funcs)).k8w(this.x89_1);
    var tmp0_iterator = this.w89_1.r8w_1.u();
    while (tmp0_iterator.v()) {
      var func = tmp0_iterator.x();
      // Inline function 'kotlin.collections.set' call
      var key = func.o8s_1;
      funcs.i2(key, func);
    }
    return toList(funcs.h2());
  };
  protoOf(Builder).g8a = function () {
    return to(this.q8a(), this.r8a());
  };
  protoOf(Builder).s8a = function (name, rettype, block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.p8a();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var funcBuild = this_0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = funcBuild.r8v_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
      var tmp$ret$1 = to(item.k8f_1, item.u2f());
      destination.r(tmp$ret$1);
    }
    var this_2 = new FuncDecl(name, rettype, destination, funcBuild.q8a());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.w89_1.r8w_1.r(this_2);
    return this_2;
  };
  protoOf(Builder).t8a = function (p0, dummy, returns, block) {
    var tmp = listOf(p0);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda(block));
  };
  protoOf(Builder).u8a = function (p0, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.t8a(p0, dummy, returns, block);
    } else {
      var tmp_0 = $super.t8a;
      tmp = tmp_0.call(this, p0, Unit_instance, returns, block);
    }
    return tmp;
  };
  protoOf(Builder).v8a = function (p0, p1, dummy, returns, block) {
    var tmp = listOf_0([p0, p1]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_0(block));
  };
  protoOf(Builder).w8a = function (p0, p1, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.v8a(p0, p1, dummy, returns, block);
    } else {
      var tmp_0 = $super.v8a;
      tmp = tmp_0.call(this, p0, p1, Unit_instance, returns, block);
    }
    return tmp;
  };
  protoOf(Builder).x8a = function (p0, p1, p2, dummy, returns, block) {
    var tmp = listOf_0([p0, p1, p2]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_1(block));
  };
  protoOf(Builder).y8a = function (p0, p1, p2, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.x8a(p0, p1, p2, dummy, returns, block);
    } else {
      var tmp_0 = $super.x8a;
      tmp = tmp_0.call(this, p0, p1, p2, Unit_instance, returns, block);
    }
    return tmp;
  };
  protoOf(Builder).t8v = function (type) {
    var tmp0_this = this.w89_1;
    var tmp1 = tmp0_this.s8w_1;
    tmp0_this.s8w_1 = tmp1 + 1 | 0;
    return Temp_init_$Create$(tmp1, type);
  };
  protoOf(Builder).z8a = function (_this__u8e3s4, p0) {
    return new CustomFunc(_this__u8e3s4, listOf(p0));
  };
  protoOf(Builder).a8b = function (_this__u8e3s4, p0, p1, p2) {
    return new CustomFunc(_this__u8e3s4, listOf_0([p0, p1, p2]));
  };
  protoOf(Builder).b8b = function (_this__u8e3s4, callback) {
    var body = this.o8a();
    callback(body);
    _this__u8e3s4.b8u_1 = body.q8a();
  };
  protoOf(Builder).c8b = function (ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else if ((max - min | 0) <= 1) {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.y8b(ref, this.e8a(min));
      var body = this.o8a();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.q8a());
      // Inline function 'kotlin.collections.plusAssign' call
      this.x89_1.r(stmIf);
      var tmp = stmIf;
      this.b8b(tmp, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda(block, max));
    } else {
      var middle = (min + max | 0) / 2 | 0;
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond_0 = this.a8c(ref, this.e8a(middle));
      var body_0 = this.o8a();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      body_0.c8b(ref, min, middle, block);
      var stmIf_0 = new If(cond_0, body_0.q8a());
      // Inline function 'kotlin.collections.plusAssign' call
      this.x89_1.r(stmIf_0);
      var tmp_0 = stmIf_0;
      this.b8b(tmp_0, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0(ref, middle, max, block));
    }
  };
  protoOf(Builder).d8b = function (ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.y8b(ref, this.e8a(min));
      var body = this.o8a();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_LIST.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.q8a());
      // Inline function 'kotlin.collections.plusAssign' call
      this.x89_1.r(stmIf);
      var tmp = stmIf;
      this.b8b(tmp, Program$Builder$IF_ELSE_LIST$lambda(ref, min, max, block));
    }
  };
  protoOf(Builder).y89 = function (target, expr) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.x89_1;
    var element = new Set(target, expr);
    this_0.r(element);
  };
  protoOf(Builder).e8b = function () {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.x89_1;
    var element = Discard_getInstance();
    this_0.r(element);
  };
  protoOf(Builder).f8b = function (operand) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.x89_1;
    var element = new Return(operand);
    this_0.r(element);
  };
  protoOf(Builder).g8b = function (operand, $super) {
    operand = operand === VOID ? null : operand;
    var tmp;
    if ($super === VOID) {
      this.f8b(operand);
      tmp = Unit_instance;
    } else {
      tmp = $super.f8b.call(this, operand);
    }
    return tmp;
  };
  protoOf(Builder).h8b = function (type) {
    var tmp0_this = this.w89_1;
    var tmp1 = tmp0_this.s8w_1;
    tmp0_this.s8w_1 = tmp1 + 1 | 0;
    return new Temp(tmp1, type, 1);
  };
  function Visitor(default_0) {
    this.y8q_1 = default_0;
  }
  protoOf(Visitor).z8q = function (func) {
    this.a8r(func.r8s_1);
  };
  protoOf(Visitor).k8w = function (stms) {
    var tmp0_iterator = stms.u();
    while (tmp0_iterator.v()) {
      var stm = tmp0_iterator.x();
      this.a8r(stm);
    }
  };
  protoOf(Visitor).a8r = function (stm) {
    var tmp;
    if (stm == null) {
      tmp = Unit_instance;
    } else {
      if (stm instanceof Stms) {
        this.b8r(stm);
        tmp = Unit_instance;
      } else {
        if (stm instanceof Set) {
          this.e8r(stm);
          tmp = Unit_instance;
        } else {
          if (stm instanceof If) {
            this.c8r(stm);
            tmp = Unit_instance;
          } else {
            if (stm instanceof ForSimple) {
              this.d8r(stm);
              tmp = Unit_instance;
            } else {
              if (stm instanceof Discard) {
                this.f8r(stm);
                tmp = Unit_instance;
              } else {
                if (stm instanceof Continue) {
                  this.h8r(stm);
                  tmp = Unit_instance;
                } else {
                  if (stm instanceof Break) {
                    this.g8r(stm);
                    tmp = Unit_instance;
                  } else {
                    if (stm instanceof Raw) {
                      this.i8r(stm);
                      tmp = Unit_instance;
                    } else {
                      if (stm instanceof Return) {
                        this.j8r(stm);
                        tmp = Unit_instance;
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  protoOf(Visitor).b8r = function (stms) {
    var tmp0_iterator = stms.f8t_1.u();
    while (tmp0_iterator.v()) {
      var stm = tmp0_iterator.x();
      this.a8r(stm);
    }
  };
  protoOf(Visitor).c8r = function (stm) {
    this.k8r(stm.z8t_1);
    this.a8r(stm.a8u_1);
    this.a8r(stm.b8u_1);
  };
  protoOf(Visitor).d8r = function (stm) {
    this.n8r(stm.c8u_1);
    this.k8r(stm.d8u_1);
    this.a8r(stm.f8u_1);
  };
  protoOf(Visitor).e8r = function (stm) {
    this.k8r(stm.h8t_1);
    this.k8r(stm.g8t_1);
  };
  protoOf(Visitor).f8r = function (stm) {
  };
  protoOf(Visitor).g8r = function (stm) {
  };
  protoOf(Visitor).h8r = function (stm) {
  };
  protoOf(Visitor).i8r = function (stm) {
    this.a8r(stm.b8t_1);
  };
  protoOf(Visitor).j8r = function (stm) {
    var tmp0_safe_receiver = stm.i8t_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.shader.Visitor.visit.<anonymous>' call
      this.k8r(tmp0_safe_receiver);
    }
  };
  protoOf(Visitor).k8r = function (operand) {
    var tmp;
    if (operand instanceof Variable) {
      tmp = this.n8r(operand);
    } else {
      if (operand instanceof Unop) {
        tmp = this.r8r(operand);
      } else {
        if (operand instanceof Binop) {
          tmp = this.s8r(operand);
        } else {
          if (operand instanceof Ternary) {
            tmp = this.t8r(operand);
          } else {
            if (operand instanceof BoolLiteral) {
              tmp = this.z8r(operand);
            } else {
              if (operand instanceof IntLiteral) {
                tmp = this.x8r(operand);
              } else {
                if (operand instanceof FloatLiteral) {
                  tmp = this.y8r(operand);
                } else {
                  if (operand instanceof Vector) {
                    tmp = this.w8r(operand);
                  } else {
                    if (operand instanceof Swizzle) {
                      tmp = this.u8r(operand);
                    } else {
                      if (operand instanceof ArrayAccess) {
                        tmp = this.v8r(operand);
                      } else {
                        if (operand instanceof BaseFunc) {
                          tmp = this.l8r(operand);
                        } else {
                          invalidOp("Don't know how to visit operand " + operand);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  protoOf(Visitor).l8r = function (func) {
    var tmp0_iterator = func.u8t().u();
    while (tmp0_iterator.v()) {
      var op = tmp0_iterator.x();
      this.k8r(op);
    }
    var tmp;
    if (func instanceof Func) {
      tmp = this.m8r(func);
    } else {
      if (func instanceof CustomFunc) {
        tmp = this.x8q(func);
      } else {
        invalidOp("Don't know how to visit func " + func);
      }
    }
    return tmp;
  };
  protoOf(Visitor).m8r = function (func) {
    return this.y8q_1;
  };
  protoOf(Visitor).x8q = function (func) {
    return this.y8q_1;
  };
  protoOf(Visitor).n8r = function (operand) {
    var tmp;
    if (operand instanceof Attribute) {
      tmp = this.w8p(operand);
    } else {
      if (operand instanceof Varying) {
        tmp = this.y8p(operand);
      } else {
        if (operand instanceof Sampler) {
          tmp = this.r8q(operand);
        } else {
          if (operand instanceof Uniform) {
            tmp = this.n8q(operand);
          } else {
            if (operand instanceof TypedUniform) {
              tmp = this.p8q(operand);
            } else {
              if (operand instanceof Output) {
                tmp = this.q8r(operand);
              } else {
                if (operand instanceof Temp) {
                  tmp = this.o8r(operand);
                } else {
                  if (operand instanceof Arg) {
                    tmp = this.p8r(operand);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  protoOf(Visitor).o8r = function (temp) {
    return this.y8q_1;
  };
  protoOf(Visitor).p8r = function (arg) {
    return this.y8q_1;
  };
  protoOf(Visitor).w8p = function (attribute) {
    return this.y8q_1;
  };
  protoOf(Visitor).y8p = function (varying) {
    return this.y8q_1;
  };
  protoOf(Visitor).n8q = function (uniform) {
    return this.y8q_1;
  };
  protoOf(Visitor).r8q = function (sampler) {
    return this.y8q_1;
  };
  protoOf(Visitor).p8q = function (typedUniform) {
    return this.n8q(typedUniform.k83_1);
  };
  protoOf(Visitor).q8r = function (output) {
    return this.y8q_1;
  };
  protoOf(Visitor).r8r = function (operand) {
    this.k8r(operand.o8t_1);
    return this.y8q_1;
  };
  protoOf(Visitor).s8r = function (operand) {
    this.k8r(operand.q8t_1);
    this.k8r(operand.s8t_1);
    return this.y8q_1;
  };
  protoOf(Visitor).t8r = function (operand) {
    this.k8r(operand.w8t_1);
    this.k8r(operand.x8t_1);
    this.k8r(operand.y8t_1);
    return this.y8q_1;
  };
  protoOf(Visitor).u8r = function (operand) {
    this.k8r(operand.n8u_1);
    return this.y8q_1;
  };
  protoOf(Visitor).v8r = function (operand) {
    this.k8r(operand.q8u_1);
    this.k8r(operand.r8u_1);
    return this.y8q_1;
  };
  protoOf(Visitor).w8r = function (operand) {
    var indexedObject = operand.l8t_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.k8r(op);
    }
    return this.y8q_1;
  };
  protoOf(Visitor).x8r = function (operand) {
    return this.y8q_1;
  };
  protoOf(Visitor).y8r = function (operand) {
    return this.y8q_1;
  };
  protoOf(Visitor).z8r = function (operand) {
    return this.y8q_1;
  };
  function Program(vertex, fragment, name) {
    name = name === VOID ? 'program-' + vertex.b8p_1 + '-' + fragment.b8p_1 : name;
    this.l82_1 = vertex;
    this.m82_1 = fragment;
    this.n82_1 = name;
    this.o82_1 = plus_0(this.l82_1.g8p_1, this.m82_1.g8p_1);
    this.p82_1 = plus_0(this.l82_1.h8p_1, this.m82_1.h8p_1);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.p82_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.graphics.shader.Program.uniformBlocks.<anonymous>' call
      var tmp$ret$0 = item.j83_1;
      destination.r(tmp$ret$0);
    }
    tmp.q82_1 = distinct(destination);
    this.r82_1 = plus_0(this.l82_1.j8p_1, this.m82_1.j8p_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = withIndex(this.o82_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator_0 = this_1.u();
    while (tmp0_iterator_0.v()) {
      var element = tmp0_iterator_0.x();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.graphics.shader.Program.uniformsToIndex.<anonymous>' call
      var pair = to(element.sf_1, new UniformInProgram(element.sf_1, element.rf_1));
      destination_0.i2(pair.ag_1, pair.bg_1);
    }
    tmp_0.s82_1 = destination_0;
    this.t82_1 = plus_0(this.l82_1.i8p_1, this.m82_1.i8p_1);
    this.u82_1 = (imul(this.l82_1.hashCode(), 11) + imul(this.m82_1.hashCode(), 7) | 0) + getStringHashCode(this.n82_1) | 0;
  }
  protoOf(Program).hashCode = function () {
    return this.u82_1;
  };
  protoOf(Program).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof Program) {
        tmp_2 = this.l82_1.equals(other.l82_1);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = this.m82_1.equals(other.m82_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.n82_1 === other.n82_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(Program).p21 = function () {
  };
  protoOf(Program).toString = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.t82_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$0 = item.k8f_1;
      destination.r(tmp$ret$0);
    }
    var tmp = destination;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.o82_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.u();
    while (tmp0_iterator_0.v()) {
      var item_0 = tmp0_iterator_0.x();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$3 = item_0.k8f_1;
      destination_0.r(tmp$ret$3);
    }
    return 'Program(name=' + this.n82_1 + ', attributes=' + tmp + ', uniforms=' + destination_0 + ')';
  };
  protoOf(Program).u8w = function (vertex, fragment, name) {
    return new Program(vertex, fragment, name);
  };
  protoOf(Program).v8w = function (vertex, fragment, name, $super) {
    vertex = vertex === VOID ? this.l82_1 : vertex;
    fragment = fragment === VOID ? this.m82_1 : fragment;
    name = name === VOID ? this.n82_1 : name;
    return $super === VOID ? this.u8w(vertex, fragment, name) : $super.u8w.call(this, vertex, fragment, name);
  };
  function Shader(type, stm, functions, name) {
    name = name === VOID ? null : name;
    this.y8o_1 = type;
    this.z8o_1 = stm;
    this.a8p_1 = functions;
    this.b8p_1 = name;
    this.c8p_1 = hashCode(this.z8o_1);
    this.d8p_1 = hashCode(this.a8p_1);
    this.e8p_1 = (imul(this.y8o_1.hashCode(), 17) + this.c8p_1 | 0) + imul(this.d8p_1, 53) | 0;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new GlobalsProgramVisitor();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Shader.globals.<anonymous>' call
    this_0.a8r(this.z8o_1);
    tmp.f8p_1 = this_0;
    this.g8p_1 = this.f8p_1.q8p_1;
    this.h8p_1 = this.f8p_1.r8p_1;
    this.i8p_1 = this.f8p_1.o8p_1;
    this.j8p_1 = this.f8p_1.t8p_1;
  }
  protoOf(Shader).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      if (other instanceof Shader) {
        tmp_3 = this.y8o_1.equals(other.y8o_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = this.e8p_1 === other.e8p_1;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(this.z8o_1, other.z8o_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(this.a8p_1, other.a8p_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(Shader).hashCode = function () {
    return this.e8p_1;
  };
  protoOf(Shader).toString = function () {
    return 'Shader(type=' + this.y8o_1 + ', stm=' + this.z8o_1 + ', functions=' + this.a8p_1 + ', name=' + this.b8p_1 + ')';
  };
  function Varying_init_$Init$(name, type, precision, $this) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    Varying.call($this, name, type, 1, precision);
    return $this;
  }
  function Varying_init_$Create$(name, type, precision) {
    return Varying_init_$Init$(name, type, precision, objectCreate(protoOf(Varying)));
  }
  function Varying(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    Variable.call(this, name, type, arrayCount, precision);
  }
  protoOf(Varying).toString = function () {
    return 'Varying(' + this.k8f_1 + ')';
  };
  protoOf(Varying).equals = function (other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this.n8f_1 === other.n8f_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.u2f().equals(other.u2f());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.a8h_1 === other.a8h_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.k8f_1 === other.k8f_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Varying).hashCode = function () {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.n8f_1 + imul(this.u2f().hashCode(), 7) | 0) + imul(getStringHashCode(this.k8f_1), 11) | 0;
  };
  function Output() {
    Output_instance = this;
    Varying_init_$Init$('out', VarType_Float4_getInstance(), VOID, this);
  }
  protoOf(Output).toString = function () {
    return 'Output';
  };
  protoOf(Output).equals = function (other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output) {
      tmp_2 = this.n8f_1 === other.n8f_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.u2f().equals(other.u2f());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.a8h_1 === other.a8h_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.k8f_1 === other.k8f_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Output).hashCode = function () {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.n8f_1 + imul(this.u2f().hashCode(), 7) | 0) + imul(getStringHashCode(this.k8f_1), 11) | 0;
  };
  var Output_instance;
  function Output_getInstance() {
    if (Output_instance == null)
      new Output();
    return Output_instance;
  }
  function Operand(type) {
    this.y8g_1 = type;
  }
  protoOf(Operand).u2f = function () {
    return this.y8g_1;
  };
  function Provider(index, stype) {
    this.r89_1 = index;
    this.s89_1 = stype;
  }
  protoOf(Provider).t89 = function (thisRef, property) {
    return new Sampler(property.callableName, this.r89_1, this.s89_1);
  };
  function Sampler(name, index, stype) {
    Variable_init_$Init$(name, stype.y8w_1, VOID, this);
    this.z7y_1 = index;
    this.a7z_1 = stype;
  }
  protoOf(Sampler).toString = function () {
    return 'Sampler(' + this.k8f_1 + ', ' + this.z7y_1 + ', ' + this.a7z_1 + ')';
  };
  protoOf(Sampler).equals = function (other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Sampler) {
      tmp_2 = this.n8f_1 === other.n8f_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.u2f().equals(other.u2f());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.a8h_1 === other.a8h_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.k8f_1 === other.k8f_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Sampler).hashCode = function () {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.n8f_1 + imul(this.u2f().hashCode(), 7) | 0) + imul(getStringHashCode(this.k8f_1), 11) | 0;
  };
  protoOf(Sampler).lh = function (thisRef, property) {
    return this;
  };
  function Sampler_0(index, stype) {
    return new Provider(index, stype);
  }
  var SamplerVarType_Sampler1D_instance;
  var SamplerVarType_Sampler2D_instance;
  var SamplerVarType_Sampler3D_instance;
  var SamplerVarType_SamplerCube_instance;
  var SamplerVarType_entriesInitialized;
  function SamplerVarType_initEntries() {
    if (SamplerVarType_entriesInitialized)
      return Unit_instance;
    SamplerVarType_entriesInitialized = true;
    SamplerVarType_Sampler1D_instance = new SamplerVarType('Sampler1D', 0, VarType_Sampler1D_getInstance());
    SamplerVarType_Sampler2D_instance = new SamplerVarType('Sampler2D', 1, VarType_Sampler2D_getInstance());
    SamplerVarType_Sampler3D_instance = new SamplerVarType('Sampler3D', 2, VarType_Sampler3D_getInstance());
    SamplerVarType_SamplerCube_instance = new SamplerVarType('SamplerCube', 3, VarType_SamplerCube_getInstance());
  }
  function SamplerVarType(name, ordinal, vtype) {
    Enum.call(this, name, ordinal);
    this.y8w_1 = vtype;
  }
  function Uniform(name, type, arrayCount, precision, offset, typedUniform) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    VariableWithOffset.call(this, name, type, arrayCount, precision, offset);
    this.m8q_1 = typedUniform;
    if (type.z8w()) {
      // Inline function 'kotlin.error' call
      var message = "Can't create uniform '" + name + "' with a sampler type '" + type + "', please use `Sampler` class instead";
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  protoOf(Uniform).toString = function () {
    return 'Uniform(' + this.k8f_1 + ')';
  };
  protoOf(Uniform).equals = function (other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this.n8f_1 === other.n8f_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.u2f().equals(other.u2f());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.a8h_1 === other.a8h_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.k8f_1 === other.k8f_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Uniform).hashCode = function () {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.n8f_1 + imul(this.u2f().hashCode(), 7) | 0) + imul(getStringHashCode(this.k8f_1), 11) | 0;
  };
  var VarType_TVOID_instance;
  var VarType_Mat2_instance;
  var VarType_Mat3_instance;
  var VarType_Mat4_instance;
  var VarType_Sampler1D_instance;
  var VarType_Sampler2D_instance;
  var VarType_Sampler3D_instance;
  var VarType_SamplerCube_instance;
  var VarType_Int1_instance;
  var VarType_Float1_instance;
  var VarType_Float2_instance;
  var VarType_Float3_instance;
  var VarType_Float4_instance;
  var VarType_Short1_instance;
  var VarType_Short2_instance;
  var VarType_Short3_instance;
  var VarType_Short4_instance;
  var VarType_Bool1_instance;
  var VarType_Bool2_instance;
  var VarType_Bool3_instance;
  var VarType_Bool4_instance;
  var VarType_Byte4_instance;
  var VarType_SByte1_instance;
  var VarType_SByte2_instance;
  var VarType_SByte3_instance;
  var VarType_SByte4_instance;
  var VarType_UByte1_instance;
  var VarType_UByte2_instance;
  var VarType_UByte3_instance;
  var VarType_UByte4_instance;
  var VarType_SShort1_instance;
  var VarType_SShort2_instance;
  var VarType_SShort3_instance;
  var VarType_SShort4_instance;
  var VarType_UShort1_instance;
  var VarType_UShort2_instance;
  var VarType_UShort3_instance;
  var VarType_UShort4_instance;
  var VarType_SInt1_instance;
  var VarType_SInt2_instance;
  var VarType_SInt3_instance;
  var VarType_SInt4_instance;
  function Companion_50() {
  }
  protoOf(Companion_50).a8x = function (count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SByte1_getInstance();
        break;
      case 2:
        tmp = VarType_SByte2_getInstance();
        break;
      case 3:
        tmp = VarType_SByte3_getInstance();
        break;
      case 4:
        tmp = VarType_SByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  };
  protoOf(Companion_50).b8x = function (count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UByte1_getInstance();
        break;
      case 2:
        tmp = VarType_UByte2_getInstance();
        break;
      case 3:
        tmp = VarType_UByte3_getInstance();
        break;
      case 4:
        tmp = VarType_UByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  };
  protoOf(Companion_50).c8x = function (count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SShort1_getInstance();
        break;
      case 2:
        tmp = VarType_SShort2_getInstance();
        break;
      case 3:
        tmp = VarType_SShort3_getInstance();
        break;
      case 4:
        tmp = VarType_SShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  };
  protoOf(Companion_50).d8x = function (count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UShort1_getInstance();
        break;
      case 2:
        tmp = VarType_UShort2_getInstance();
        break;
      case 3:
        tmp = VarType_UShort3_getInstance();
        break;
      case 4:
        tmp = VarType_UShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  };
  protoOf(Companion_50).e8x = function (count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SInt1_getInstance();
        break;
      case 2:
        tmp = VarType_SInt2_getInstance();
        break;
      case 3:
        tmp = VarType_SInt3_getInstance();
        break;
      case 4:
        tmp = VarType_SInt4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  };
  protoOf(Companion_50).f8x = function (count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Float1_getInstance();
        break;
      case 2:
        tmp = VarType_Float2_getInstance();
        break;
      case 3:
        tmp = VarType_Float3_getInstance();
        break;
      case 4:
        tmp = VarType_Float4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  };
  var Companion_instance_64;
  function Companion_getInstance_76() {
    return Companion_instance_64;
  }
  var VarType_entriesInitialized;
  function VarType_initEntries() {
    if (VarType_entriesInitialized)
      return Unit_instance;
    VarType_entriesInitialized = true;
    VarType_TVOID_instance = new VarType('TVOID', 0, VarKind_TBYTE_getInstance(), 0);
    VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
    VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
    VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
    VarType_Sampler1D_instance = new VarType('Sampler1D', 4, VarKind_TINT_getInstance(), 1);
    VarType_Sampler2D_instance = new VarType('Sampler2D', 5, VarKind_TINT_getInstance(), 1);
    VarType_Sampler3D_instance = new VarType('Sampler3D', 6, VarKind_TINT_getInstance(), 1);
    VarType_SamplerCube_instance = new VarType('SamplerCube', 7, VarKind_TINT_getInstance(), 1);
    VarType_Int1_instance = new VarType('Int1', 8, VarKind_TINT_getInstance(), 1);
    VarType_Float1_instance = new VarType('Float1', 9, VarKind_TFLOAT_getInstance(), 1);
    VarType_Float2_instance = new VarType('Float2', 10, VarKind_TFLOAT_getInstance(), 2);
    VarType_Float3_instance = new VarType('Float3', 11, VarKind_TFLOAT_getInstance(), 3);
    VarType_Float4_instance = new VarType('Float4', 12, VarKind_TFLOAT_getInstance(), 4);
    VarType_Short1_instance = new VarType('Short1', 13, VarKind_TSHORT_getInstance(), 1);
    VarType_Short2_instance = new VarType('Short2', 14, VarKind_TSHORT_getInstance(), 2);
    VarType_Short3_instance = new VarType('Short3', 15, VarKind_TSHORT_getInstance(), 3);
    VarType_Short4_instance = new VarType('Short4', 16, VarKind_TSHORT_getInstance(), 4);
    VarType_Bool1_instance = new VarType('Bool1', 17, VarKind_TBOOL_getInstance(), 1);
    VarType_Bool2_instance = new VarType('Bool2', 18, VarKind_TBOOL_getInstance(), 2);
    VarType_Bool3_instance = new VarType('Bool3', 19, VarKind_TBOOL_getInstance(), 3);
    VarType_Bool4_instance = new VarType('Bool4', 20, VarKind_TBOOL_getInstance(), 4);
    VarType_Byte4_instance = new VarType('Byte4', 21, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
    VarType_SByte1_instance = new VarType('SByte1', 22, VarKind_TBYTE_getInstance(), 1);
    VarType_SByte2_instance = new VarType('SByte2', 23, VarKind_TBYTE_getInstance(), 2);
    VarType_SByte3_instance = new VarType('SByte3', 24, VarKind_TBYTE_getInstance(), 3);
    VarType_SByte4_instance = new VarType('SByte4', 25, VarKind_TBYTE_getInstance(), 4);
    VarType_UByte1_instance = new VarType('UByte1', 26, VarKind_TUNSIGNED_BYTE_getInstance(), 1);
    VarType_UByte2_instance = new VarType('UByte2', 27, VarKind_TUNSIGNED_BYTE_getInstance(), 2);
    VarType_UByte3_instance = new VarType('UByte3', 28, VarKind_TUNSIGNED_BYTE_getInstance(), 3);
    VarType_UByte4_instance = new VarType('UByte4', 29, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
    VarType_SShort1_instance = new VarType('SShort1', 30, VarKind_TSHORT_getInstance(), 1);
    VarType_SShort2_instance = new VarType('SShort2', 31, VarKind_TSHORT_getInstance(), 2);
    VarType_SShort3_instance = new VarType('SShort3', 32, VarKind_TSHORT_getInstance(), 3);
    VarType_SShort4_instance = new VarType('SShort4', 33, VarKind_TSHORT_getInstance(), 4);
    VarType_UShort1_instance = new VarType('UShort1', 34, VarKind_TUNSIGNED_SHORT_getInstance(), 1);
    VarType_UShort2_instance = new VarType('UShort2', 35, VarKind_TUNSIGNED_SHORT_getInstance(), 2);
    VarType_UShort3_instance = new VarType('UShort3', 36, VarKind_TUNSIGNED_SHORT_getInstance(), 3);
    VarType_UShort4_instance = new VarType('UShort4', 37, VarKind_TUNSIGNED_SHORT_getInstance(), 4);
    VarType_SInt1_instance = new VarType('SInt1', 38, VarKind_TINT_getInstance(), 1);
    VarType_SInt2_instance = new VarType('SInt2', 39, VarKind_TINT_getInstance(), 2);
    VarType_SInt3_instance = new VarType('SInt3', 40, VarKind_TINT_getInstance(), 3);
    VarType_SInt4_instance = new VarType('SInt4', 41, VarKind_TINT_getInstance(), 4);
  }
  function VarType(name, ordinal, kind, elementCount, isMatrix) {
    isMatrix = isMatrix === VOID ? false : isMatrix;
    Enum.call(this, name, ordinal);
    this.h8h_1 = kind;
    this.i8h_1 = elementCount;
    this.j8h_1 = isMatrix;
    this.k8h_1 = imul(this.h8h_1.u8u_1, this.i8h_1);
  }
  protoOf(VarType).l8w = function (length) {
    var tmp;
    switch (this.h8h_1.ka_1) {
      case 1:
        tmp = Companion_instance_64.a8x(length);
        break;
      case 2:
        tmp = Companion_instance_64.b8x(length);
        break;
      case 3:
        tmp = Companion_instance_64.c8x(length);
        break;
      case 4:
        tmp = Companion_instance_64.d8x(length);
        break;
      case 5:
        tmp = Companion_instance_64.e8x(length);
        break;
      case 6:
        tmp = Companion_instance_64.f8x(length);
        break;
      default:
        throw new NotImplementedError();
    }
    return tmp;
  };
  protoOf(VarType).z8w = function () {
    return ((this.equals(VarType_Sampler1D_getInstance()) ? true : this.equals(VarType_Sampler2D_getInstance())) ? true : this.equals(VarType_Sampler3D_getInstance())) ? true : this.equals(VarType_SamplerCube_getInstance());
  };
  var Precision_DEFAULT_instance;
  var Precision_LOW_instance;
  var Precision_MEDIUM_instance;
  var Precision_HIGH_instance;
  var Precision_entriesInitialized;
  function Precision_initEntries() {
    if (Precision_entriesInitialized)
      return Unit_instance;
    Precision_entriesInitialized = true;
    Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
    Precision_LOW_instance = new Precision('LOW', 1);
    Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
    Precision_HIGH_instance = new Precision('HIGH', 3);
  }
  function Precision(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Temp_init_$Init$(id, type, precision, $this) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    Temp.call($this, id, type, 1, precision);
    return $this;
  }
  function Temp_init_$Create$(id, type, precision) {
    return Temp_init_$Init$(id, type, precision, objectCreate(protoOf(Temp)));
  }
  function Temp(id, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    Variable.call(this, 'temp' + id, type, arrayCount, precision);
  }
  protoOf(Temp).toString = function () {
    return 'Temp(' + this.k8f_1 + ')';
  };
  protoOf(Temp).equals = function (other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp) {
      tmp_2 = this.n8f_1 === other.n8f_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.u2f().equals(other.u2f());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.a8h_1 === other.a8h_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.k8f_1 === other.k8f_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Temp).hashCode = function () {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.n8f_1 + imul(this.u2f().hashCode(), 7) | 0) + imul(getStringHashCode(this.k8f_1), 11) | 0;
  };
  function FragmentShader(info) {
    return FragmentShader_0(info.ag_1, info.bg_1);
  }
  function FuncDecl(name, rettype, args, stm) {
    this.o8s_1 = name;
    this.p8s_1 = rettype;
    this.q8s_1 = args;
    this.r8s_1 = stm;
    this.s8s_1 = this;
  }
  protoOf(FuncDecl).zb = function () {
    return this.o8s_1;
  };
  protoOf(FuncDecl).q8w = function () {
    return this.p8s_1;
  };
  protoOf(FuncDecl).toString = function () {
    return 'FuncDecl(name=' + this.o8s_1 + ', rettype=' + this.p8s_1 + ', args=' + this.q8s_1 + ', stm=' + this.r8s_1 + ')';
  };
  protoOf(FuncDecl).hashCode = function () {
    var result = getStringHashCode(this.o8s_1);
    result = imul(result, 31) + this.p8s_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.q8s_1) | 0;
    result = imul(result, 31) + hashCode(this.r8s_1) | 0;
    return result;
  };
  protoOf(FuncDecl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FuncDecl))
      return false;
    var tmp0_other_with_cast = other instanceof FuncDecl ? other : THROW_CCE();
    if (!(this.o8s_1 === tmp0_other_with_cast.o8s_1))
      return false;
    if (!this.p8s_1.equals(tmp0_other_with_cast.p8s_1))
      return false;
    if (!equals(this.q8s_1, tmp0_other_with_cast.q8s_1))
      return false;
    if (!equals(this.r8s_1, tmp0_other_with_cast.r8s_1))
      return false;
    return true;
  };
  function VariableWithOffset(name, type, arrayCount, precision, offset) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    Variable.call(this, name, type, arrayCount, precision);
    this.g8v_1 = offset;
  }
  var VarKind_TBOOL_instance;
  var VarKind_TBYTE_instance;
  var VarKind_TUNSIGNED_BYTE_instance;
  var VarKind_TSHORT_instance;
  var VarKind_TUNSIGNED_SHORT_instance;
  var VarKind_TINT_instance;
  var VarKind_TFLOAT_instance;
  var VarKind_entriesInitialized;
  function VarKind_initEntries() {
    if (VarKind_entriesInitialized)
      return Unit_instance;
    VarKind_entriesInitialized = true;
    VarKind_TBOOL_instance = new VarKind('TBOOL', 0, 1);
    VarKind_TBYTE_instance = new VarKind('TBYTE', 1, 1);
    VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 2, 1);
    VarKind_TSHORT_instance = new VarKind('TSHORT', 3, 2);
    VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 4, 2);
    VarKind_TINT_instance = new VarKind('TINT', 5, 4);
    VarKind_TFLOAT_instance = new VarKind('TFLOAT', 6, 4);
  }
  function VarKind(name, ordinal, bytesSize) {
    Enum.call(this, name, ordinal);
    this.u8u_1 = bytesSize;
  }
  function UniformInProgram(uniform, index) {
    this.g8x_1 = uniform;
    this.h8x_1 = index;
  }
  protoOf(UniformInProgram).toString = function () {
    return 'UniformInProgram(uniform=' + this.g8x_1 + ', index=' + this.h8x_1 + ')';
  };
  protoOf(UniformInProgram).hashCode = function () {
    var result = this.g8x_1.hashCode();
    result = imul(result, 31) + this.h8x_1 | 0;
    return result;
  };
  protoOf(UniformInProgram).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UniformInProgram))
      return false;
    var tmp0_other_with_cast = other instanceof UniformInProgram ? other : THROW_CCE();
    if (!this.g8x_1.equals(tmp0_other_with_cast.g8x_1))
      return false;
    if (!(this.h8x_1 === tmp0_other_with_cast.h8x_1))
      return false;
    return true;
  };
  function Variable_init_$Init$(name, type, precision, $this) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    Variable.call($this, name, type, 1, precision);
    return $this;
  }
  function Variable(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    OperandWithArray.call(this, type, arrayCount);
    this.k8f_1 = name;
    this.l8f_1 = precision;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(arrayCount), null);
    while (tmp_0 < arrayCount) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = this.k8f_1 + '[' + tmp_2 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.m8f_1 = tmp_1;
    this.n8f_1 = 0;
    this.o8f_1 = null;
  }
  protoOf(Variable).equals = function (other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this.n8f_1 === other.n8f_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.u2f().equals(other.u2f());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.a8h_1 === other.a8h_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.k8f_1 === other.k8f_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Variable).hashCode = function () {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.n8f_1 + imul(this.u2f().hashCode(), 7) | 0) + imul(getStringHashCode(this.k8f_1), 11) | 0;
  };
  function OperandWithArray(type, arrayCount) {
    Operand.call(this, type);
    this.a8h_1 = arrayCount;
    this.b8h_1 = type.h8h_1;
    this.c8h_1 = type.i8h_1;
    this.d8h_1 = imul(this.c8h_1, this.a8h_1);
    this.e8h_1 = imul(type.k8h_1, this.a8h_1);
  }
  function VarTypeAccessor() {
  }
  function Arg(name, type, arrayCount, precision) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    Variable.call(this, name, type, arrayCount, precision);
  }
  protoOf(Arg).toString = function () {
    return 'Arg(' + this.k8f_1 + ')';
  };
  protoOf(Arg).equals = function (other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Arg) {
      tmp_2 = this.n8f_1 === other.n8f_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.u2f().equals(other.u2f());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.a8h_1 === other.a8h_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.k8f_1 === other.k8f_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Arg).hashCode = function () {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.n8f_1 + imul(this.u2f().hashCode(), 7) | 0) + imul(getStringHashCode(this.k8f_1), 11) | 0;
  };
  var ShaderType_VERTEX_instance;
  var ShaderType_FRAGMENT_instance;
  var ShaderType_entriesInitialized;
  function ShaderType_initEntries() {
    if (ShaderType_entriesInitialized)
      return Unit_instance;
    ShaderType_entriesInitialized = true;
    ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
    ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
  }
  function ShaderType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function VertexShader(info) {
    return VertexShader_0(info.ag_1, info.bg_1);
  }
  function FragmentShader_0(stm, funcs) {
    var tmp;
    if (funcs === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = funcs;
    }
    funcs = tmp;
    return new Shader(ShaderType_FRAGMENT_getInstance(), stm, funcs);
  }
  function VertexShader_0(stm, funcs) {
    var tmp;
    if (funcs === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = funcs;
    }
    funcs = tmp;
    return new Shader(ShaderType_VERTEX_getInstance(), stm, funcs);
  }
  function SamplerVarType_Sampler2D_getInstance() {
    SamplerVarType_initEntries();
    return SamplerVarType_Sampler2D_instance;
  }
  function VarType_TVOID_getInstance() {
    VarType_initEntries();
    return VarType_TVOID_instance;
  }
  function VarType_Mat2_getInstance() {
    VarType_initEntries();
    return VarType_Mat2_instance;
  }
  function VarType_Mat4_getInstance() {
    VarType_initEntries();
    return VarType_Mat4_instance;
  }
  function VarType_Sampler1D_getInstance() {
    VarType_initEntries();
    return VarType_Sampler1D_instance;
  }
  function VarType_Sampler2D_getInstance() {
    VarType_initEntries();
    return VarType_Sampler2D_instance;
  }
  function VarType_Sampler3D_getInstance() {
    VarType_initEntries();
    return VarType_Sampler3D_instance;
  }
  function VarType_SamplerCube_getInstance() {
    VarType_initEntries();
    return VarType_SamplerCube_instance;
  }
  function VarType_Float1_getInstance() {
    VarType_initEntries();
    return VarType_Float1_instance;
  }
  function VarType_Float2_getInstance() {
    VarType_initEntries();
    return VarType_Float2_instance;
  }
  function VarType_Float3_getInstance() {
    VarType_initEntries();
    return VarType_Float3_instance;
  }
  function VarType_Float4_getInstance() {
    VarType_initEntries();
    return VarType_Float4_instance;
  }
  function VarType_SByte1_getInstance() {
    VarType_initEntries();
    return VarType_SByte1_instance;
  }
  function VarType_SByte2_getInstance() {
    VarType_initEntries();
    return VarType_SByte2_instance;
  }
  function VarType_SByte3_getInstance() {
    VarType_initEntries();
    return VarType_SByte3_instance;
  }
  function VarType_SByte4_getInstance() {
    VarType_initEntries();
    return VarType_SByte4_instance;
  }
  function VarType_UByte1_getInstance() {
    VarType_initEntries();
    return VarType_UByte1_instance;
  }
  function VarType_UByte2_getInstance() {
    VarType_initEntries();
    return VarType_UByte2_instance;
  }
  function VarType_UByte3_getInstance() {
    VarType_initEntries();
    return VarType_UByte3_instance;
  }
  function VarType_UByte4_getInstance() {
    VarType_initEntries();
    return VarType_UByte4_instance;
  }
  function VarType_SShort1_getInstance() {
    VarType_initEntries();
    return VarType_SShort1_instance;
  }
  function VarType_SShort2_getInstance() {
    VarType_initEntries();
    return VarType_SShort2_instance;
  }
  function VarType_SShort3_getInstance() {
    VarType_initEntries();
    return VarType_SShort3_instance;
  }
  function VarType_SShort4_getInstance() {
    VarType_initEntries();
    return VarType_SShort4_instance;
  }
  function VarType_UShort1_getInstance() {
    VarType_initEntries();
    return VarType_UShort1_instance;
  }
  function VarType_UShort2_getInstance() {
    VarType_initEntries();
    return VarType_UShort2_instance;
  }
  function VarType_UShort3_getInstance() {
    VarType_initEntries();
    return VarType_UShort3_instance;
  }
  function VarType_UShort4_getInstance() {
    VarType_initEntries();
    return VarType_UShort4_instance;
  }
  function VarType_SInt1_getInstance() {
    VarType_initEntries();
    return VarType_SInt1_instance;
  }
  function VarType_SInt2_getInstance() {
    VarType_initEntries();
    return VarType_SInt2_instance;
  }
  function VarType_SInt3_getInstance() {
    VarType_initEntries();
    return VarType_SInt3_instance;
  }
  function VarType_SInt4_getInstance() {
    VarType_initEntries();
    return VarType_SInt4_instance;
  }
  function Precision_DEFAULT_getInstance() {
    Precision_initEntries();
    return Precision_DEFAULT_instance;
  }
  function Precision_LOW_getInstance() {
    Precision_initEntries();
    return Precision_LOW_instance;
  }
  function Precision_MEDIUM_getInstance() {
    Precision_initEntries();
    return Precision_MEDIUM_instance;
  }
  function Precision_HIGH_getInstance() {
    Precision_initEntries();
    return Precision_HIGH_instance;
  }
  function VarKind_TBOOL_getInstance() {
    VarKind_initEntries();
    return VarKind_TBOOL_instance;
  }
  function VarKind_TBYTE_getInstance() {
    VarKind_initEntries();
    return VarKind_TBYTE_instance;
  }
  function VarKind_TUNSIGNED_BYTE_getInstance() {
    VarKind_initEntries();
    return VarKind_TUNSIGNED_BYTE_instance;
  }
  function VarKind_TSHORT_getInstance() {
    VarKind_initEntries();
    return VarKind_TSHORT_instance;
  }
  function VarKind_TUNSIGNED_SHORT_getInstance() {
    VarKind_initEntries();
    return VarKind_TUNSIGNED_SHORT_instance;
  }
  function VarKind_TINT_getInstance() {
    VarKind_initEntries();
    return VarKind_TINT_instance;
  }
  function VarKind_TFLOAT_getInstance() {
    VarKind_initEntries();
    return VarKind_TFLOAT_instance;
  }
  function ShaderType_VERTEX_getInstance() {
    ShaderType_initEntries();
    return ShaderType_VERTEX_instance;
  }
  function ShaderType_FRAGMENT_getInstance() {
    ShaderType_initEntries();
    return ShaderType_FRAGMENT_instance;
  }
  function putAsciiString(_this__u8e3s4, str) {
    var n = 0;
    var inductionVariable = 0;
    var last = str.length;
    while (inductionVariable < last) {
      var c = charSequenceGet(str, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (get_size(_this__u8e3s4) >= n) {
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        // Inline function 'kotlin.code' call
        var tmp$ret$0 = Char__toInt_impl_vasixd(c);
        setInt8(_this__u8e3s4, tmp1, tmp$ret$0);
      }
    }
    if (get_size(_this__u8e3s4) >= n) {
      var tmp2 = n;
      n = tmp2 + 1 | 0;
      setInt8(_this__u8e3s4, tmp2, 0);
    }
    return _this__u8e3s4;
  }
  function toAsciiString(_this__u8e3s4) {
    var out = '';
    var inductionVariable = 0;
    var last = get_size(_this__u8e3s4);
    if (inductionVariable < last)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b = getInt8(_this__u8e3s4, n);
        if (b === 0)
          break $l$loop;
        out = out + toString_0(numberToChar(b));
      }
       while (inductionVariable < last);
    return out;
  }
  function KmlGl$ContextInfo$current$lambda() {
    return null;
  }
  function ContextInfo() {
    var tmp = this;
    tmp.i8x_1 = KmlGl$ContextInfo$current$lambda;
  }
  protoOf(ContextInfo).toString = function () {
    return 'current=' + toString_1(this.i8x_1());
  };
  function Companion_51() {
    this.j8x_1 = 33309;
    this.k8x_1 = 33084;
    this.l8x_1 = 33085;
    this.m8x_1 = 256;
    this.n8x_1 = 1024;
    this.o8x_1 = 16384;
    this.p8x_1 = 0;
    this.q8x_1 = 1;
    this.r8x_1 = 0;
    this.s8x_1 = 1;
    this.t8x_1 = 2;
    this.u8x_1 = 3;
    this.v8x_1 = 4;
    this.w8x_1 = 5;
    this.x8x_1 = 6;
    this.y8x_1 = 0;
    this.z8x_1 = 1;
    this.a8y_1 = 768;
    this.b8y_1 = 769;
    this.c8y_1 = 770;
    this.d8y_1 = 771;
    this.e8y_1 = 772;
    this.f8y_1 = 773;
    this.g8y_1 = 774;
    this.h8y_1 = 775;
    this.i8y_1 = 776;
    this.j8y_1 = 32774;
    this.k8y_1 = 32777;
    this.l8y_1 = 32777;
    this.m8y_1 = 34877;
    this.n8y_1 = 32778;
    this.o8y_1 = 32779;
    this.p8y_1 = 32968;
    this.q8y_1 = 32969;
    this.r8y_1 = 32970;
    this.s8y_1 = 32971;
    this.t8y_1 = 32769;
    this.u8y_1 = 32770;
    this.v8y_1 = 32771;
    this.w8y_1 = 32772;
    this.x8y_1 = 32773;
    this.y8y_1 = 34962;
    this.z8y_1 = 34963;
    this.a8z_1 = 34964;
    this.b8z_1 = 34965;
    this.c8z_1 = 35040;
    this.d8z_1 = 35044;
    this.e8z_1 = 35048;
    this.f8z_1 = 34660;
    this.g8z_1 = 34661;
    this.h8z_1 = 34342;
    this.i8z_1 = 1028;
    this.j8z_1 = 1029;
    this.k8z_1 = 1032;
    this.l8z_1 = 3553;
    this.m8z_1 = 32879;
    this.n8z_1 = 2884;
    this.o8z_1 = 3042;
    this.p8z_1 = 3024;
    this.q8z_1 = 2960;
    this.r8z_1 = 2929;
    this.s8z_1 = 3089;
    this.t8z_1 = 32823;
    this.u8z_1 = 32926;
    this.v8z_1 = 32928;
    this.w8z_1 = 0;
    this.x8z_1 = 1280;
    this.y8z_1 = 1281;
    this.z8z_1 = 1282;
    this.a90_1 = 1285;
    this.b90_1 = 2304;
    this.c90_1 = 2305;
    this.d90_1 = 2849;
    this.e90_1 = 33901;
    this.f90_1 = 33902;
    this.g90_1 = 2885;
    this.h90_1 = 2886;
    this.i90_1 = 2928;
    this.j90_1 = 2930;
    this.k90_1 = 2931;
    this.l90_1 = 2932;
    this.m90_1 = 2961;
    this.n90_1 = 2962;
    this.o90_1 = 2964;
    this.p90_1 = 2965;
    this.q90_1 = 2966;
    this.r90_1 = 2967;
    this.s90_1 = 2963;
    this.t90_1 = 2968;
    this.u90_1 = 34816;
    this.v90_1 = 34817;
    this.w90_1 = 34818;
    this.x90_1 = 34819;
    this.y90_1 = 36003;
    this.z90_1 = 36004;
    this.a91_1 = 36005;
    this.b91_1 = 2978;
    this.c91_1 = 3088;
    this.d91_1 = 3106;
    this.e91_1 = 3107;
    this.f91_1 = 3317;
    this.g91_1 = 3333;
    this.h91_1 = 3379;
    this.i91_1 = 3386;
    this.j91_1 = 3408;
    this.k91_1 = 3410;
    this.l91_1 = 3411;
    this.m91_1 = 3412;
    this.n91_1 = 3413;
    this.o91_1 = 3414;
    this.p91_1 = 3415;
    this.q91_1 = 10752;
    this.r91_1 = 32824;
    this.s91_1 = 32873;
    this.t91_1 = 32936;
    this.u91_1 = 32937;
    this.v91_1 = 32938;
    this.w91_1 = 32939;
    this.x91_1 = 34466;
    this.y91_1 = 34467;
    this.z91_1 = 4352;
    this.a92_1 = 4353;
    this.b92_1 = 4354;
    this.c92_1 = 33170;
    this.d92_1 = 5120;
    this.e92_1 = 5121;
    this.f92_1 = 5122;
    this.g92_1 = 5123;
    this.h92_1 = 5124;
    this.i92_1 = 5125;
    this.j92_1 = 5126;
    this.k92_1 = 5132;
    this.l92_1 = 6402;
    this.m92_1 = 6406;
    this.n92_1 = 6407;
    this.o92_1 = 6408;
    this.p92_1 = 6409;
    this.q92_1 = 6410;
    this.r92_1 = 32819;
    this.s92_1 = 32820;
    this.t92_1 = 33635;
    this.u92_1 = 35632;
    this.v92_1 = 35633;
    this.w92_1 = 34921;
    this.x92_1 = 36347;
    this.y92_1 = 36348;
    this.z92_1 = 35661;
    this.a93_1 = 35660;
    this.b93_1 = 34930;
    this.c93_1 = 36349;
    this.d93_1 = 35663;
    this.e93_1 = 35712;
    this.f93_1 = 35714;
    this.g93_1 = 35715;
    this.h93_1 = 35717;
    this.i93_1 = 35718;
    this.j93_1 = 35719;
    this.k93_1 = 35721;
    this.l93_1 = 35722;
    this.m93_1 = 35724;
    this.n93_1 = 35725;
    this.o93_1 = 512;
    this.p93_1 = 513;
    this.q93_1 = 514;
    this.r93_1 = 515;
    this.s93_1 = 516;
    this.t93_1 = 517;
    this.u93_1 = 518;
    this.v93_1 = 519;
    this.w93_1 = 7680;
    this.x93_1 = 7681;
    this.y93_1 = 7682;
    this.z93_1 = 7683;
    this.a94_1 = 5386;
    this.b94_1 = 34055;
    this.c94_1 = 34056;
    this.d94_1 = 7936;
    this.e94_1 = 7937;
    this.f94_1 = 7938;
    this.g94_1 = 7939;
    this.h94_1 = 9728;
    this.i94_1 = 9729;
    this.j94_1 = 9984;
    this.k94_1 = 9985;
    this.l94_1 = 9986;
    this.m94_1 = 9987;
    this.n94_1 = 10240;
    this.o94_1 = 10241;
    this.p94_1 = 10242;
    this.q94_1 = 10243;
    this.r94_1 = 32882;
    this.s94_1 = 5890;
    this.t94_1 = 34067;
    this.u94_1 = 34068;
    this.v94_1 = 34069;
    this.w94_1 = 34070;
    this.x94_1 = 34071;
    this.y94_1 = 34072;
    this.z94_1 = 34073;
    this.a95_1 = 34074;
    this.b95_1 = 34076;
    this.c95_1 = 33984;
    this.d95_1 = 33985;
    this.e95_1 = 33986;
    this.f95_1 = 33987;
    this.g95_1 = 33988;
    this.h95_1 = 33989;
    this.i95_1 = 33990;
    this.j95_1 = 33991;
    this.k95_1 = 33992;
    this.l95_1 = 33993;
    this.m95_1 = 33994;
    this.n95_1 = 33995;
    this.o95_1 = 33996;
    this.p95_1 = 33997;
    this.q95_1 = 33998;
    this.r95_1 = 33999;
    this.s95_1 = 34000;
    this.t95_1 = 34001;
    this.u95_1 = 34002;
    this.v95_1 = 34003;
    this.w95_1 = 34004;
    this.x95_1 = 34005;
    this.y95_1 = 34006;
    this.z95_1 = 34007;
    this.a96_1 = 34008;
    this.b96_1 = 34009;
    this.c96_1 = 34010;
    this.d96_1 = 34011;
    this.e96_1 = 34012;
    this.f96_1 = 34013;
    this.g96_1 = 34014;
    this.h96_1 = 34015;
    this.i96_1 = 34016;
    this.j96_1 = 10497;
    this.k96_1 = 33071;
    this.l96_1 = 33648;
    this.m96_1 = 35664;
    this.n96_1 = 35665;
    this.o96_1 = 35666;
    this.p96_1 = 35667;
    this.q96_1 = 35668;
    this.r96_1 = 35669;
    this.s96_1 = 35670;
    this.t96_1 = 35671;
    this.u96_1 = 35672;
    this.v96_1 = 35673;
    this.w96_1 = 35674;
    this.x96_1 = 35675;
    this.y96_1 = 35676;
    this.z96_1 = 35678;
    this.a97_1 = 35680;
    this.b97_1 = 34338;
    this.c97_1 = 34339;
    this.d97_1 = 34340;
    this.e97_1 = 34341;
    this.f97_1 = 34922;
    this.g97_1 = 34373;
    this.h97_1 = 34975;
    this.i97_1 = 35738;
    this.j97_1 = 35739;
    this.k97_1 = 35713;
    this.l97_1 = 35716;
    this.m97_1 = 35720;
    this.n97_1 = 36346;
    this.o97_1 = 36344;
    this.p97_1 = 36345;
    this.q97_1 = 36336;
    this.r97_1 = 36337;
    this.s97_1 = 36338;
    this.t97_1 = 36339;
    this.u97_1 = 36340;
    this.v97_1 = 36341;
    this.w97_1 = 36160;
    this.x97_1 = 36161;
    this.y97_1 = 32854;
    this.z97_1 = 32855;
    this.a98_1 = 36194;
    this.b98_1 = 33189;
    this.c98_1 = 6401;
    this.d98_1 = 36168;
    this.e98_1 = 36162;
    this.f98_1 = 36163;
    this.g98_1 = 36164;
    this.h98_1 = 36176;
    this.i98_1 = 36177;
    this.j98_1 = 36178;
    this.k98_1 = 36179;
    this.l98_1 = 36180;
    this.m98_1 = 36181;
    this.n98_1 = 36048;
    this.o98_1 = 36049;
    this.p98_1 = 36050;
    this.q98_1 = 36051;
    this.r98_1 = 36064;
    this.s98_1 = 36096;
    this.t98_1 = 33306;
    this.u98_1 = 34041;
    this.v98_1 = 36128;
    this.w98_1 = 0;
    this.x98_1 = 36053;
    this.y98_1 = 36054;
    this.z98_1 = 36055;
    this.a99_1 = 36057;
    this.b99_1 = 36061;
    this.c99_1 = 36006;
    this.d99_1 = 36007;
    this.e99_1 = 34024;
    this.f99_1 = 1286;
    this.g99_1 = 37120;
    this.h99_1 = 34836;
    this.i99_1 = 3313;
    this.j99_1 = 3314;
    this.k99_1 = 3316;
    this.l99_1 = 3315;
    this.m99_1 = 3312;
    this.n99_1 = 37441;
    this.o99_1 = 36197;
    this.p99_1 = 35345;
    this.q99_1 = 35368;
    this.r99_1 = 35380;
  }
  var Companion_instance_65;
  function Companion_getInstance_77() {
    return Companion_instance_65;
  }
  function KmlGl$isFloatTextureSupported$delegate$lambda(this$0) {
    return function () {
      return this$0.q38().z('GL_OES_texture_float') ? true : this$0.q38().z('GL_ARB_texture_float');
    };
  }
  function KmlGl() {
    this.i8e_1 = new Mixin();
    this.j8e_1 = new ContextInfo();
    this.k8e_1 = null;
    var tmp = this;
    tmp.l8e_1 = lazy(KmlGl$isFloatTextureSupported$delegate$lambda(this));
  }
  protoOf(KmlGl).h23 = function (_set____db54di) {
    this.i8e_1.h23(_set____db54di);
  };
  protoOf(KmlGl).i23 = function () {
    return this.i8e_1.i23();
  };
  protoOf(KmlGl).x8h = function (texture) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).x8m = function (program, shader) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).w8m = function (program, index, name) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).r8g = function (target, buffer) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).q8l = function (target, framebuffer) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).x8l = function (target, renderbuffer) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).o8l = function (target, texture) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).a8j = function (modeRGB, modeAlpha) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).b8j = function (sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).b8i = function (target, size, data, usage) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).a8i = function (target, offset, size, data) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).w8i = function (mask) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).r8i = function (red, green, blue, alpha) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).t8i = function (d) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).v8i = function (s) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).e8m = function (red, green, blue, alpha) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).o8m = function (shader) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).q8m = function () {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).m8m = function (type) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).w8j = function (mode) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).s99 = function (n, items) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).t99 = function (n, items) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).l8m = function (program) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).u99 = function (n, items) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).k8m = function (shader) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).v99 = function (n, items) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).d8m = function (func) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).s8i = function (flag) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).c8m = function (n, f) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).f8j = function (cap) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).w8k = function (index) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).m8j = function (mode, first, count) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).o8j = function (mode, count, type, indices) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).g8j = function (cap) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).a8l = function (index) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).m6 = function () {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).a8m = function (target, attachment, renderbuffertarget, renderbuffer) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).z8l = function (target, attachment, textarget, texture, level) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).b8m = function (mode) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).w99 = function (n, buffers) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).f8i = function (target) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).x99 = function (n, framebuffers) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).y99 = function (n, renderbuffers) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).z99 = function (n, textures) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).i8m = function (program, name) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).p8m = function () {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).a9a = function (pname, data) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).b9a = function (program, pname, params) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).c9a = function (shader, pname, params) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).d9a = function (shader, bufSize, length, infoLog) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).m8e = function (name) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).y8m = function (program) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).c8i = function (pname, param) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).y8l = function (target, internalformat, width, height) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).f8m = function (x, y, width, height) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).n8m = function (shader, string) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).i8j = function (func, ref, mask) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).h8j = function (face, func, ref, mask) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).u8i = function (mask) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).l8j = function (face, mask) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).k8j = function (fail, zfail, zpass) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).j8j = function (face, sfail, dpfail, dppass) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).d8i = function (target, level, internalformat, width, height, border, format, type, pixels) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).e8i = function (target, level, internalformat, format, type, data) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).w8h = function (target, pname, param) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).s8h = function (location, count, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).q8f = function (location, v0) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).l8h = function (location, count, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).t8h = function (location, count, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).m8h = function (location, count, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).u8h = function (location, count, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).n8h = function (location, count, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).v8h = function (location, count, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).o8h = function (location, count, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).p8h = function (location, count, transpose, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).q8h = function (location, count, transpose, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).r8h = function (location, count, transpose, value) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).j8m = function (program) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).b8l = function (index, size, type, normalized, stride, pointer) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).p8l = function (x, y, width, height) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).c8j = function (cap, enable) {
    if (enable) {
      this.g8j(cap);
    } else {
      this.f8j(cap);
    }
    return enable;
  };
  protoOf(KmlGl).n8j = function (mode, first, count, instancecount) {
    unsupported('Not supported instanced drawing');
  };
  protoOf(KmlGl).p8j = function (mode, count, type, indices, instancecount) {
    unsupported('Not supported instanced drawing');
  };
  protoOf(KmlGl).v8k = function (index, divisor) {
    unsupported();
  };
  protoOf(KmlGl).i8l = function (target, index, buffer, offset, size) {
    unsupported('Not supported uniform buffers ' + getKClassFromExpression(this));
  };
  protoOf(KmlGl).r8f = function (program, name) {
    unsupported('Not supported uniform buffers ' + getKClassFromExpression(this));
  };
  protoOf(KmlGl).s8f = function (program, uniformBlockIndex, uniformBlockBinding) {
    unsupported('Not supported uniform buffers ' + getKClassFromExpression(this));
  };
  protoOf(KmlGl).e9a = function (n, arrays) {
    unsupported('Not supported vertex arrays ' + getKClassFromExpression(this));
  };
  protoOf(KmlGl).x8k = function (array) {
    unsupported('Not supported vertex arrays ' + getKClassFromExpression(this));
  };
  protoOf(KmlGl).y8h = function () {
    return Companion_instance_60.r8o();
  };
  protoOf(KmlGl).m8i = function () {
    return Unit_instance;
  };
  protoOf(KmlGl).u8j = function (contextVersion) {
    return Unit_instance;
  };
  protoOf(KmlGl).f9a = function (name, index) {
    throw new NotImplementedError();
  };
  protoOf(KmlGl).q38 = function () {
    if (this.k8e_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        var numExtensions = getIntegerv(this, 33309);
        if (numExtensions <= 0) {
          // Inline function 'kotlin.TODO' call
          throw new NotImplementedError();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = until(0, numExtensions);
        var destination = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = this_0.u();
        while (tmp0_iterator.v()) {
          var element = tmp0_iterator.x();
          // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
          // Inline function 'korlibs.kgl.KmlGl.<get-extensions>.<anonymous>' call
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          var tmp0_safe_receiver = this.f9a(7939, element);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.r(tmp0_safe_receiver);
          }
        }
        tmp_0 = toSet(destination);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          tmp_1 = toSet(split(this.m8e(7939), [' ']));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp.k8e_1 = tmp_0;
    }
    return ensureNotNull(this.k8e_1);
  };
  protoOf(KmlGl).n8i = function () {
    return this.q38();
  };
  var logger;
  var tempNBufferByte;
  function get_tempNBuffer1() {
    _init_properties_KmlGlExt_kt__r5nfv2();
    return tempNBuffer1;
  }
  var tempNBuffer1;
  var tempNBuffer4;
  function getIntegerv(_this__u8e3s4, pname) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, 0);
    // Inline function 'korlibs.kgl.getIntegerv.<anonymous>' call
    _this__u8e3s4.a9a(pname, it);
    return getInt32(it, 0);
  }
  function getInteger(_this__u8e3s4, pname) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    return getIntegerv(_this__u8e3s4, pname);
  }
  function genVertexArray(_this__u8e3s4) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, 0);
    // Inline function 'korlibs.kgl.genVertexArray.<anonymous>' call
    _this__u8e3s4.e9a(1, it);
    return getInt32(it, 0);
  }
  function getProgramiv(_this__u8e3s4, program, type) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, 0);
    // Inline function 'korlibs.kgl.getProgramiv.<anonymous>' call
    _this__u8e3s4.b9a(program, type, it);
    return getInt32(it, 0);
  }
  function getShaderiv(_this__u8e3s4, shader, type) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, 0);
    // Inline function 'korlibs.kgl.getShaderiv.<anonymous>' call
    _this__u8e3s4.c9a(shader, type, it);
    return getInt32(it, 0);
  }
  function getShaderInfoLog(_this__u8e3s4, shader) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.getInfoLog' call
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    var size = getShaderiv(_this__u8e3s4, shader, 35716);
    // Inline function 'korlibs.memory.BufferTemp' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.getInfoLog.<anonymous>' call
    var sizev = allocDirect(Companion_instance_0, 4);
    // Inline function 'korlibs.memory.BufferTemp' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.getInfoLog.<anonymous>.<anonymous>' call
    var mbuffer = allocDirect(Companion_instance_0, size);
    _this__u8e3s4.d9a(shader, size, sizev, mbuffer);
    return toAsciiString(mbuffer);
  }
  function genBuffer(_this__u8e3s4) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, 0);
    // Inline function 'korlibs.kgl.genBuffer.<anonymous>' call
    _this__u8e3s4.w99(1, it);
    return getInt32(it, 0);
  }
  function deleteBuffer(_this__u8e3s4, id) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, id);
    // Inline function 'korlibs.kgl.deleteBuffer.<anonymous>' call
    _this__u8e3s4.s99(1, it);
    getInt32(it, 0);
  }
  function genTexture(_this__u8e3s4) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, 0);
    // Inline function 'korlibs.kgl.genTexture.<anonymous>' call
    _this__u8e3s4.z99(1, it);
    return getInt32(it, 0);
  }
  function deleteTexture(_this__u8e3s4, id) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, id);
    // Inline function 'korlibs.kgl.deleteTexture.<anonymous>' call
    _this__u8e3s4.v99(1, it);
    getInt32(it, 0);
  }
  function genRenderbuffer(_this__u8e3s4) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, 0);
    // Inline function 'korlibs.kgl.genRenderbuffer.<anonymous>' call
    _this__u8e3s4.y99(1, it);
    return getInt32(it, 0);
  }
  function genFramebuffer(_this__u8e3s4) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, 0);
    // Inline function 'korlibs.kgl.genFramebuffer.<anonymous>' call
    _this__u8e3s4.x99(1, it);
    return getInt32(it, 0);
  }
  function deleteRenderbuffer(_this__u8e3s4, id) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, id);
    // Inline function 'korlibs.kgl.deleteRenderbuffer.<anonymous>' call
    _this__u8e3s4.u99(1, it);
    getInt32(it, 0);
  }
  function deleteFramebuffer(_this__u8e3s4, id) {
    _init_properties_KmlGlExt_kt__r5nfv2();
    // Inline function 'korlibs.kgl.tempInt1Buffer' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
    var it = _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s();
    setInt32(it, 0, id);
    // Inline function 'korlibs.kgl.deleteFramebuffer.<anonymous>' call
    _this__u8e3s4.t99(1, it);
    getInt32(it, 0);
  }
  function _get_tempNBuffer1_$accessor$1h5vdb3_hfrs5s() {
    _init_properties_KmlGlExt_kt__r5nfv2();
    return get_tempNBuffer1();
  }
  var properties_initialized_KmlGlExt_kt_yrhd4c;
  function _init_properties_KmlGlExt_kt__r5nfv2() {
    if (!properties_initialized_KmlGlExt_kt_yrhd4c) {
      properties_initialized_KmlGlExt_kt_yrhd4c = true;
      logger = Companion_getInstance_2().r24('KmlGlException');
      tempNBufferByte = Buffer_init_$Create$(1, true);
      tempNBuffer1 = Buffer_init_$Create$(4, true);
      tempNBuffer4 = Buffer_init_$Create$(16, true);
    }
  }
  function Companion_52() {
    Companion_instance_66 = this;
    this.g9a_1 = Companion_getInstance_2().r24('Korge');
    this.h9a_1 = 'korlibs.korge.unknown';
  }
  var Companion_instance_66;
  function Companion_getInstance_78() {
    if (Companion_instance_66 == null)
      new Companion_52();
    return Companion_instance_66;
  }
  function Korge$_init_$lambda_95dffl($this$null) {
    return Unit_instance;
  }
  function Korge$_init_$slambda_ys8r4w(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Korge$_init_$slambda_ys8r4w).r9a = function ($this$null, $completion) {
    var tmp = this.s9a($this$null, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Korge$_init_$slambda_ys8r4w).ne = function (p1, $completion) {
    return this.r9a(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Korge$_init_$slambda_ys8r4w).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        if (tmp === 0) {
          this.gd_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(Korge$_init_$slambda_ys8r4w).s9a = function ($this$null, completion) {
    var i = new Korge$_init_$slambda_ys8r4w(completion);
    i.q9a_1 = $this$null;
    return i;
  };
  function Korge$_init_$slambda_ys8r4w_0(resultContinuation) {
    var i = new Korge$_init_$slambda_ys8r4w(resultContinuation);
    var l = function ($this$null, $completion) {
      return i.r9a($this$null, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function Korge$_init_$lambda_95dffl_0(it) {
    return new Stage(it);
  }
  function Korge$start$slambda(this$0, $entry, resultContinuation) {
    this.b9b_1 = this$0;
    this.c9b_1 = $entry;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Korge$start$slambda).e5m = function ($this$withContext, $completion) {
    var tmp = this.t5l($this$withContext, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Korge$start$slambda).ne = function (p1, $completion) {
    return this.e5m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Korge$start$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = KorgeRunner_instance.m9c(this.b9b_1.l9c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.c9b_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(Korge$start$slambda).t5l = function ($this$withContext, completion) {
    var i = new Korge$start$slambda(this.b9b_1, this.c9b_1, completion);
    i.d9b_1 = $this$withContext;
    return i;
  };
  function Korge$start$slambda_0(this$0, $entry, resultContinuation) {
    var i = new Korge$start$slambda(this$0, $entry, resultContinuation);
    var l = function ($this$withContext, $completion) {
      return i.e5m($this$withContext, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit) {
    Companion_getInstance_78();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_1 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_78().h9a_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_85().p9c_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().z9c_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_79().f34() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().m3b_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0(null);
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().l3b_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    unit = unit === VOID ? Unit_instance : unit;
    this.e9b_1 = args;
    this.f9b_1 = imageFormats;
    this.g9b_1 = gameWindow;
    this.h9b_1 = mainSceneClass;
    this.i9b_1 = timeProvider;
    this.j9b_1 = injector;
    this.k9b_1 = configInjector;
    this.l9b_1 = debug;
    this.m9b_1 = trace;
    this.n9b_1 = context;
    this.o9b_1 = fullscreen;
    this.p9b_1 = blocking;
    this.q9b_1 = gameId;
    this.r9b_1 = settingsFolder;
    this.s9b_1 = batchMaxQuads;
    this.t9b_1 = windowSize;
    this.u9b_1 = virtualSize;
    this.v9b_1 = displayMode;
    this.w9b_1 = title;
    this.x9b_1 = backgroundColor;
    this.y9b_1 = quality;
    this.z9b_1 = icon;
    this.a9c_1 = multithreaded;
    this.b9c_1 = forceRenderEveryFrame;
    this.c9c_1 = windowCreationConfig;
    this.d9c_1 = main;
    this.e9c_1 = debugAg;
    this.f9c_1 = debugFontExtraScale;
    this.g9c_1 = debugFontColor;
    this.h9c_1 = stageBuilder;
    this.i9c_1 = targetFps;
    this.j9c_1 = preferSyncIo;
    this.k9c_1 = unit;
  }
  protoOf(Korge).e9d = function (entry, $completion) {
    var tmp = Companion_getInstance_9().k5n(this.j9c_1);
    return withContext(tmp, Korge$start$slambda_0(this, entry, null), $completion);
  };
  protoOf(Korge).f9d = function (args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit);
  };
  protoOf(Korge).l9c = function (args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit, $super) {
    args = args === VOID ? this.e9b_1 : args;
    imageFormats = imageFormats === VOID ? this.f9b_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.g9b_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.h9b_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.i9b_1 : timeProvider;
    injector = injector === VOID ? this.j9b_1 : injector;
    configInjector = configInjector === VOID ? this.k9b_1 : configInjector;
    debug = debug === VOID ? this.l9b_1 : debug;
    trace = trace === VOID ? this.m9b_1 : trace;
    context = context === VOID ? this.n9b_1 : context;
    fullscreen = fullscreen === VOID ? this.o9b_1 : fullscreen;
    blocking = blocking === VOID ? this.p9b_1 : blocking;
    gameId = gameId === VOID ? this.q9b_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.r9b_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.s9b_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.t9b_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.u9b_1 : virtualSize;
    displayMode = displayMode === VOID ? this.v9b_1 : displayMode;
    title = title === VOID ? this.w9b_1 : title;
    backgroundColor = backgroundColor === VOID ? this.x9b_1 : backgroundColor;
    quality = quality === VOID ? this.y9b_1 : quality;
    icon = icon === VOID ? this.z9b_1 : icon;
    multithreaded = multithreaded === VOID ? this.a9c_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.b9c_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.c9c_1 : windowCreationConfig;
    main = main === VOID ? this.d9c_1 : main;
    debugAg = debugAg === VOID ? this.e9c_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.f9c_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.g9c_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.h9c_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.i9c_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.j9c_1 : preferSyncIo;
    unit = unit === VOID ? this.k9c_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.f9d(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, unit);
    } else {
      var tmp_0 = $super.f9d;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, Unit_instance);
    }
    return tmp;
  };
  protoOf(Korge).toString = function () {
    var tmp = toString(this.e9b_1);
    var tmp_0 = toString_1(this.n9b_1);
    var tmp_1 = this.x9b_1;
    var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
    return 'Korge(args=' + tmp + ', imageFormats=' + this.f9b_1 + ', gameWindow=' + this.g9b_1 + ', mainSceneClass=' + this.h9b_1 + ', timeProvider=' + this.i9b_1 + ', injector=' + this.j9b_1 + ', configInjector=' + this.k9b_1 + ', debug=' + this.l9b_1 + ', trace=' + this.m9b_1 + ', context=' + tmp_0 + ', fullscreen=' + this.o9b_1 + ', blocking=' + this.p9b_1 + ', gameId=' + this.q9b_1 + ', settingsFolder=' + this.r9b_1 + ', batchMaxQuads=' + this.s9b_1 + ', windowSize=' + this.t9b_1 + ', virtualSize=' + this.u9b_1 + ', displayMode=' + this.v9b_1 + ', title=' + this.w9b_1 + ', backgroundColor=' + tmp_2 + ', quality=' + this.y9b_1 + ', icon=' + this.z9b_1 + ', multithreaded=' + this.a9c_1 + ', forceRenderEveryFrame=' + this.b9c_1 + ', windowCreationConfig=' + this.c9c_1 + ', main=' + this.d9c_1 + ', debugAg=' + this.e9c_1 + ', debugFontExtraScale=' + this.f9c_1 + ', debugFontColor=' + new RGBA(this.g9c_1) + ', stageBuilder=' + this.h9c_1 + ', targetFps=' + this.i9c_1 + ', preferSyncIo=' + this.j9c_1 + ', unit=' + Unit_instance + ')';
  };
  protoOf(Korge).hashCode = function () {
    var result = hashCode(this.e9b_1);
    result = imul(result, 31) + hashCode(this.f9b_1) | 0;
    result = imul(result, 31) + (this.g9b_1 == null ? 0 : hashCode(this.g9b_1)) | 0;
    result = imul(result, 31) + (this.h9b_1 == null ? 0 : this.h9b_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.i9b_1) | 0;
    result = imul(result, 31) + hashCode(this.j9b_1) | 0;
    result = imul(result, 31) + hashCode(this.k9b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l9b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m9b_1) | 0;
    result = imul(result, 31) + (this.n9b_1 == null ? 0 : hashCode(this.n9b_1)) | 0;
    result = imul(result, 31) + (this.o9b_1 == null ? 0 : getBooleanHashCode(this.o9b_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p9b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q9b_1) | 0;
    result = imul(result, 31) + (this.r9b_1 == null ? 0 : getStringHashCode(this.r9b_1)) | 0;
    result = imul(result, 31) + this.s9b_1 | 0;
    result = imul(result, 31) + this.t9b_1.hashCode() | 0;
    result = imul(result, 31) + this.u9b_1.hashCode() | 0;
    result = imul(result, 31) + this.v9b_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.w9b_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.x9b_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.x9b_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.y9b_1.hashCode() | 0;
    result = imul(result, 31) + (this.z9b_1 == null ? 0 : getStringHashCode(this.z9b_1)) | 0;
    result = imul(result, 31) + (this.a9c_1 == null ? 0 : getBooleanHashCode(this.a9c_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b9c_1) | 0;
    result = imul(result, 31) + this.c9c_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.d9c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e9c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f9c_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.g9c_1) | 0;
    result = imul(result, 31) + hashCode(this.h9c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i9c_1) | 0;
    result = imul(result, 31) + (this.j9c_1 == null ? 0 : getBooleanHashCode(this.j9c_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  };
  protoOf(Korge).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.e9b_1, tmp0_other_with_cast.e9b_1))
      return false;
    if (!equals(this.f9b_1, tmp0_other_with_cast.f9b_1))
      return false;
    if (!equals(this.g9b_1, tmp0_other_with_cast.g9b_1))
      return false;
    if (!equals(this.h9b_1, tmp0_other_with_cast.h9b_1))
      return false;
    if (!equals(this.i9b_1, tmp0_other_with_cast.i9b_1))
      return false;
    if (!equals(this.j9b_1, tmp0_other_with_cast.j9b_1))
      return false;
    if (!equals(this.k9b_1, tmp0_other_with_cast.k9b_1))
      return false;
    if (!(this.l9b_1 === tmp0_other_with_cast.l9b_1))
      return false;
    if (!(this.m9b_1 === tmp0_other_with_cast.m9b_1))
      return false;
    if (!equals(this.n9b_1, tmp0_other_with_cast.n9b_1))
      return false;
    if (!(this.o9b_1 == tmp0_other_with_cast.o9b_1))
      return false;
    if (!(this.p9b_1 === tmp0_other_with_cast.p9b_1))
      return false;
    if (!(this.q9b_1 === tmp0_other_with_cast.q9b_1))
      return false;
    if (!(this.r9b_1 == tmp0_other_with_cast.r9b_1))
      return false;
    if (!(this.s9b_1 === tmp0_other_with_cast.s9b_1))
      return false;
    if (!this.t9b_1.equals(tmp0_other_with_cast.t9b_1))
      return false;
    if (!this.u9b_1.equals(tmp0_other_with_cast.u9b_1))
      return false;
    if (!this.v9b_1.equals(tmp0_other_with_cast.v9b_1))
      return false;
    if (!(this.w9b_1 === tmp0_other_with_cast.w9b_1))
      return false;
    var tmp = this.x9b_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.x9b_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.y9b_1.equals(tmp0_other_with_cast.y9b_1))
      return false;
    if (!(this.z9b_1 == tmp0_other_with_cast.z9b_1))
      return false;
    if (!(this.a9c_1 == tmp0_other_with_cast.a9c_1))
      return false;
    if (!(this.b9c_1 === tmp0_other_with_cast.b9c_1))
      return false;
    if (!this.c9c_1.equals(tmp0_other_with_cast.c9c_1))
      return false;
    if (!equals(this.d9c_1, tmp0_other_with_cast.d9c_1))
      return false;
    if (!(this.e9c_1 === tmp0_other_with_cast.e9c_1))
      return false;
    if (!equals(this.f9c_1, tmp0_other_with_cast.f9c_1))
      return false;
    if (!(this.g9c_1 === tmp0_other_with_cast.g9c_1))
      return false;
    if (!equals(this.h9c_1, tmp0_other_with_cast.h9c_1))
      return false;
    if (!equals(this.i9c_1, tmp0_other_with_cast.i9c_1))
      return false;
    if (!(this.j9c_1 == tmp0_other_with_cast.j9c_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  };
  function Companion_53() {
    Companion_instance_67 = this;
    this.a9d_1 = new KorgeDisplayMode(Companion_getInstance_10().l2m_1, Companion_getInstance_11().o2c(), true);
    this.b9d_1 = new KorgeDisplayMode(Companion_getInstance_10().l2m_1, Companion_getInstance_11().o2c(), false);
    this.c9d_1 = new KorgeDisplayMode(Companion_getInstance_10().l2m_1, Companion_getInstance_11().f2c_1, false);
    this.d9d_1 = new KorgeDisplayMode(Companion_getInstance_10().n2m_1, Companion_getInstance_11().f2c_1, false);
  }
  protoOf(Companion_53).f34 = function () {
    return this.a9d_1;
  };
  var Companion_instance_67;
  function Companion_getInstance_79() {
    if (Companion_instance_67 == null)
      new Companion_53();
    return Companion_instance_67;
  }
  function KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_79();
    this.g9d_1 = scaleMode;
    this.h9d_1 = scaleAnchor;
    this.i9d_1 = clipBorders;
  }
  protoOf(KorgeDisplayMode).toString = function () {
    return 'KorgeDisplayMode(scaleMode=' + this.g9d_1 + ', scaleAnchor=' + this.h9d_1 + ', clipBorders=' + this.i9d_1 + ')';
  };
  protoOf(KorgeDisplayMode).hashCode = function () {
    var result = hashCode(this.g9d_1);
    result = imul(result, 31) + this.h9d_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i9d_1) | 0;
    return result;
  };
  protoOf(KorgeDisplayMode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.g9d_1, tmp0_other_with_cast.g9d_1))
      return false;
    if (!this.h9d_1.equals(tmp0_other_with_cast.h9d_1))
      return false;
    if (!(this.i9d_1 === tmp0_other_with_cast.i9d_1))
      return false;
    return true;
  };
  function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
    return it instanceof FixedSizeContainer;
  }
  function KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow, resultContinuation) {
    this.r9d_1 = $config;
    this.s9d_1 = $views;
    this.t9d_1 = $entry;
    this.u9d_1 = $gameWindow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KorgeRunner$invoke$slambda$slambda$slambda).e5m = function ($this$coroutineScope, $completion) {
    var tmp = this.t5l($this$coroutineScope, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(KorgeRunner$invoke$slambda$slambda$slambda).ne = function (p1, $completion) {
    return this.e5m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KorgeRunner$invoke$slambda$slambda$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 7;
            if (!(this.r9d_1.h9b_1 == null)) {
              var tmp_0 = this;
              tmp_0.w9d_1 = this.s9d_1.c9g_1;
              var tmp_1 = this;
              tmp_1.x9d_1 = withEasing(get_AlphaTransition(), Companion_getInstance_12().m28());
              var tmp_2 = this;
              tmp_2.y9d_1 = 'sceneContainer';
              var tmp_3 = this;
              tmp_3.z9d_1 = Companion_getInstance_13().t2m_1;
              var tmp_4 = this;
              tmp_4.a9e_1 = this.w9d_1;
              this.fd_1 = 1;
              suspendResult = views(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 3;
              continue $sm;
            }

          case 1:
            this.b9e_1 = suspendResult;
            var tmp_5 = this;
            tmp_5.c9e_1 = this.x9d_1;
            var tmp_6 = this;
            tmp_6.d9e_1 = this.y9d_1;
            var tmp_7 = this;
            tmp_7.e9e_1 = this.z9d_1;
            this.f9e_1 = this.e9e_1;
            this.g9e_1 = this.f9e_1.cg();
            this.h9e_1 = this.f9e_1.dg();
            this.i9e_1 = this.g9e_1;
            this.j9e_1 = this.h9e_1;
            if (this.g9e_1 === 0.0 ? this.h9e_1 === 0.0 : false) {
              var tmp_8 = findFirstAscendant(this.a9e_1, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
              var base = (tmp_8 == null ? true : tmp_8 instanceof FixedSizeContainer) ? tmp_8 : null;
              var tmp_9 = this;
              var tmp2_elvis_lhs = base == null ? null : base.x1q();
              tmp_9.i9e_1 = tmp2_elvis_lhs == null ? this.b9e_1.c9g_1.x1q() : tmp2_elvis_lhs;
              var tmp_10 = this;
              var tmp4_elvis_lhs = base == null ? null : base.y1q();
              tmp_10.j9e_1 = tmp4_elvis_lhs == null ? this.b9e_1.c9g_1.y1q() : tmp4_elvis_lhs;
            }

            var tmp_11 = this;
            var this_0 = new SceneContainer(this.b9e_1, this.c9e_1, this.d9e_1, new Size2D(this.i9e_1, this.j9e_1));
            var instance = this.a9e_1;
            tmp_11.k9e_1 = addTo(this_0, instance);
            this.fd_1 = 2;
            suspendResult = this.k9e_1.z9l(this.r9d_1.h9b_1, [], VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.fd_1 = 3;
            continue $sm;
          case 3:
            this.fd_1 = 4;
            suspendResult = this.t9d_1(this.s9d_1.c9g_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            if (this.r9d_1.p9b_1) {
              this.fd_1 = 5;
              suspendResult = this.u9d_1.l9o(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 6;
              continue $sm;
            }

          case 5:
            this.fd_1 = 6;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 7) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(KorgeRunner$invoke$slambda$slambda$slambda).t5l = function ($this$coroutineScope, completion) {
    var i = new KorgeRunner$invoke$slambda$slambda$slambda(this.r9d_1, this.s9d_1, this.t9d_1, this.u9d_1, completion);
    i.v9d_1 = $this$coroutineScope;
    return i;
  };
  function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow, resultContinuation) {
    var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.e5m($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow, resultContinuation) {
    this.u9o_1 = $config;
    this.v9o_1 = $views;
    this.w9o_1 = $entry;
    this.x9o_1 = $gameWindow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KorgeRunner$invoke$slambda$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(KorgeRunner$invoke$slambda$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(KorgeRunner$invoke$slambda$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0(this.u9o_1, this.v9o_1, this.w9o_1, this.x9o_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(KorgeRunner$invoke$slambda$slambda).g5a = function (completion) {
    return new KorgeRunner$invoke$slambda$slambda(this.u9o_1, this.v9o_1, this.w9o_1, this.x9o_1, completion);
  };
  function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow, resultContinuation) {
    var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
    return $views.y9o(new Vector2D(x, y));
  }
  function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
    input.v9p(button, true);
    input.w9p(p, false);
    input.w9p(p, true);
    $views.x9p();
    downPos._v = input.y9p();
    downTime._v = new DateTime(Companion_getInstance_1().e1q());
    input.j9p_1 = true;
  }
  function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
    input.v9p(button, false);
    input.w9p(p, false);
    $views.x9p();
    upPos._v = $views.s9e_1.y9p();
  }
  function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
    $views.s9e_1.w9p(p, false);
    $views.s9e_1.j9p_1 = inside;
    if (!inside) {
      moveMouseOutsideInNextFrame._v = true;
    }
    $views.x9p();
    moveTime._v = new DateTime(Companion_getInstance_1().e1q());
  }
  function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
    $views.s9e_1.w9p(p, false);
    $views.x9p();
    moveTime._v = new DateTime(Companion_getInstance_1().e1q());
  }
  function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
    mouseTouchEvent.m7p_1 = 0;
    mouseTouchEvent.p7p_1 = true;
    mouseTouchEvent.n7p_1 = Companion_getInstance_1().e1q();
    mouseTouchEvent.o7p_1 = false;
    mouseTouchEvent.x7p(type);
    mouseTouchEvent.c7q(button.g7u_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
    mouseTouchEvent.y7p();
    $views.s7m(mouseTouchEvent);
  }
  function prepareViewsBase$gamepadUpdated(input, e) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = e.m7r_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var gamepad = this_0[tmp0];
      input.t9p_1[gamepad.o7r_1].v7r(gamepad);
    }
    input.z9p();
  }
  function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
    try {
      $views.b9q($fixedSizeStep, $views.a9q(), event.r7q_1, event.s7q_1);
      $views.s9e_1.i9p_1 = false;
      if (moveMouseOutsideInNextFrame._v) {
        moveMouseOutsideInNextFrame._v = false;
        $views.s9e_1.i9p_1 = true;
        $views.s9e_1.j9p_1 = false;
        $views.x9p();
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'korlibs.logger.Logger.error' call
        var this_0 = Companion_getInstance_78().g9a_1;
        var level = Level_ERROR_getInstance();
        var tmp;
        if (this_0.f25(level)) {
          // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
          var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
          this_0.g25(level, tmp$ret$0);
          tmp = Unit_instance;
        }
        printStackTrace(e);
        if ($views.e9f_1)
          throw e;
      } else {
        throw $p;
      }
    }
  }
  function KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry, resultContinuation) {
    this.k9q_1 = $realGameWindow;
    this.l9q_1 = $windowSize;
    this.m9q_1 = $config;
    this.n9q_1 = $iconPath;
    this.o9q_1 = $imageFormats;
    this.p9q_1 = $entry;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KorgeRunner$invoke$slambda).k9r = function ($this$loop, $completion) {
    var tmp = this.l9r($this$loop, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(KorgeRunner$invoke$slambda).ne = function (p1, $completion) {
    return this.k9r(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KorgeRunner$invoke$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 23;
            this.r9q_1 = this.q9q_1;
            if (Companion_instance_2.q1p()) {
              println('Korui[0]');
            }

            l$ret$5: do {
              var this_0 = this.r9q_1;
              var name = 'configureGameWindow';
              var start = PerformanceCounter_instance.l1q();
              l$ret$3: do {
                l$ret$1: do {
                  try {
                    var tmp0_elvis_lhs = this.m9q_1.x9b_1;
                    var tmp_0;
                    var tmp_1 = tmp0_elvis_lhs;
                    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
                      tmp_0 = Colors_getInstance().m3b_1;
                    } else {
                      tmp_0 = tmp0_elvis_lhs;
                    }
                    configure(this.k9q_1, this.l9q_1, this.m9q_1.w9b_1, null, this.m9q_1.o9b_1, tmp_0);
                    break l$ret$1;
                  } catch ($p) {
                    var t = $p;
                    var end = PerformanceCounter_instance.l1q();
                    var this_1 = end - start;
                    this_0.m9r(name, toDuration(this_1, DurationUnit_MICROSECONDS_getInstance()));
                    throw t;
                  }
                }
                 while (false);
                var end_0 = PerformanceCounter_instance.l1q();
                var this_2 = end_0 - start;
                this_0.m9r(name, toDuration(this_2, DurationUnit_MICROSECONDS_getInstance()));
                break l$ret$5;
              }
               while (false);
              var end_1 = PerformanceCounter_instance.l1q();
              var this_3 = end_1 - start;
              this_0.m9r(name, toDuration(this_3, DurationUnit_MICROSECONDS_getInstance()));
            }
             while (false);
            this.fd_1 = 1;
            continue $sm;
          case 1:
            var tmp_2 = this;
            tmp_2.t9q_1 = this.r9q_1;
            var tmp_3 = this;
            tmp_3.u9q_1 = 'setIcon';
            this.v9q_1 = PerformanceCounter_instance.l1q();
            this.fd_1 = 2;
            continue $sm;
          case 2:
            this.fd_1 = 3;
            continue $sm;
          case 3:
            this.gd_1 = 8;
            this.gd_1 = 6;
            if (!(this.n9q_1 == null)) {
              this.fd_1 = 4;
              suspendResult = readBitmap(get_resourcesVfs().s13(this.n9q_1), this.o9q_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 5;
              continue $sm;
            }

          case 4:
            this.x9q_1 = suspendResult;
            this.q9q_1.n9r(this.x9q_1);
            this.fd_1 = 5;
            continue $sm;
          case 5:
            this.gd_1 = 8;
            this.fd_1 = 7;
            continue $sm;
          case 6:
            this.gd_1 = 8;
            var tmp_4 = this.id_1;
            if (tmp_4 instanceof Error) {
              this.y9q_1 = this.id_1;
              var this_4 = Companion_getInstance_78().g9a_1;
              var level = Level_ERROR_getInstance();
              if (this_4.f25(level)) {
                this_4.g25(level, "Couldn't get the application icon");
              }
              printStackTrace(this.y9q_1);
              this.fd_1 = 7;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 7:
            var tmp_5 = this;
            this.gd_1 = 8;
            tmp_5.w9q_1 = Unit_instance;
            this.gd_1 = 23;
            this.fd_1 = 9;
            var tmp_6 = this;
            continue $sm;
          case 8:
            this.gd_1 = 23;
            this.z9q_1 = this.id_1;
            var end_2 = PerformanceCounter_instance.l1q();
            var this_5 = end_2 - this.v9q_1;
            this.t9q_1.m9r(this.u9q_1, toDuration(this_5, DurationUnit_MICROSECONDS_getInstance()));
            throw this.z9q_1;
          case 9:
            this.gd_1 = 23;
            var tmp_7 = this;
            var end_3 = PerformanceCounter_instance.l1q();
            var this_6 = end_3 - this.v9q_1;
            this.t9q_1.m9r(this.u9q_1, toDuration(this_6, DurationUnit_MICROSECONDS_getInstance()));
            tmp_7.s9q_1 = Unit_instance;
            this.fd_1 = 11;
            continue $sm;
          case 10:
            this.gd_1 = 23;
            var end_4 = PerformanceCounter_instance.l1q();
            var this_7 = end_4 - this.v9q_1;
            this.t9q_1.m9r(this.u9q_1, toDuration(this_7, DurationUnit_MICROSECONDS_getInstance()));
            if (false) {
              this.fd_1 = 1;
              continue $sm;
            }

            this.fd_1 = 11;
            continue $sm;
          case 11:
            this.q9q_1.p9r(this.q9q_1.o9r());
            if (Companion_instance_2.q1p()) {
              println('CanvasApplicationEx.IN[0]');
            }

            this.a9r_1 = new Input();
            this.b9r_1 = new Stats();
            var tmp_8 = this;
            tmp_8.c9r_1 = new Views(this.q6().dh(this.r9q_1.q9r()).dh(new InjectorContext(this.m9q_1.j9b_1)).dh(SupervisorJob()), this.m9q_1.e9c_1 ? new AGPrint() : this.q9q_1.r9r(), this.m9q_1.j9b_1, this.a9r_1, this.m9q_1.i9b_1, this.b9r_1, this.r9q_1, this.m9q_1.q9b_1, this.m9q_1.r9b_1, this.m9q_1.s9b_1, VOID, this.m9q_1.h9c_1);
            var tmp_9 = this;
            tmp_9.d9r_1 = this.c9r_1;
            this.fd_1 = 12;
            suspendResult = this.d9r_1.l60(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            if (Companion_instance_2.s1p()) {
              Dyn__set_impl_2ozvx8(Companion_instance_3.r5z(), 'views', this.d9r_1);
            }

            this.e9r_1 = this.c9r_1;
            this.m9q_1.j9b_1.h27(getKClass(GameWindow), this.r9q_1);
            this.m9q_1.j9b_1.h27(getKClass(Korge), this.m9q_1);
            this.e9r_1.f9g_1 = this.q9q_1.s9r();
            this.e9r_1.t9r(this.m9q_1.f9c_1);
            this.e9r_1.u9r(this.m9q_1.g9c_1);
            this.e9r_1.w9f_1 = numberToInt(this.m9q_1.u9b_1.r2k_1);
            this.e9r_1.x9f_1 = numberToInt(this.m9q_1.u9b_1.s2k_1);
            this.e9r_1.a9g_1 = this.m9q_1.v9b_1.h9d_1;
            this.e9r_1.z9f_1 = this.m9q_1.v9b_1.g9d_1;
            this.e9r_1.b9g_1 = this.m9q_1.v9b_1.i9d_1;
            this.e9r_1.q9g_1 = this.m9q_1.i9c_1;
            this.fd_1 = 13;
            continue $sm;
          case 13:
            var tmp_10 = this;
            tmp_10.g9r_1 = this.r9q_1;
            var tmp_11 = this;
            tmp_11.h9r_1 = 'prepareViews';
            this.i9r_1 = PerformanceCounter_instance.l1q();
            this.fd_1 = 14;
            continue $sm;
          case 14:
            this.fd_1 = 15;
            continue $sm;
          case 15:
            this.gd_1 = 22;
            KorgeReload_getInstance().x9r(this.r9q_1);
            this.fd_1 = 16;
            suspendResult = KorgeRunner_instance.z9r(this.e9r_1, this.r9q_1, true, this.q9q_1.y9r(), get_NIL(Companion_getInstance()), this.m9q_1.b9c_1, this.m9q_1.k9b_1).q1d(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 16:
            this.j9r_1 = suspendResult;
            this.gd_1 = 23;
            this.fd_1 = 17;
            var tmp_12 = this;
            continue $sm;
          case 17:
            this.gd_1 = 23;
            var tmp_13 = this;
            var end_5 = PerformanceCounter_instance.l1q();
            var this_8 = end_5 - this.i9r_1;
            this.g9r_1.m9r(this.h9r_1, toDuration(this_8, DurationUnit_MICROSECONDS_getInstance()));
            tmp_13.f9r_1 = Unit_instance;
            this.fd_1 = 19;
            continue $sm;
          case 18:
            this.gd_1 = 23;
            var end_6 = PerformanceCounter_instance.l1q();
            var this_9 = end_6 - this.i9r_1;
            this.g9r_1.m9r(this.h9r_1, toDuration(this_9, DurationUnit_MICROSECONDS_getInstance()));
            if (false) {
              this.fd_1 = 13;
              continue $sm;
            }

            this.fd_1 = 19;
            continue $sm;
          case 19:
            l$ret$23: do {
              var this_10 = this.r9q_1;
              var name_0 = 'completeViews';
              var start_0 = PerformanceCounter_instance.l1q();
              l$ret$21: do {
                l$ret$19: do {
                  try {
                    completeViews(this.e9r_1);
                    break l$ret$19;
                  } catch ($p) {
                    var t_0 = $p;
                    var end_7 = PerformanceCounter_instance.l1q();
                    var this_11 = end_7 - start_0;
                    this_10.m9r(name_0, toDuration(this_11, DurationUnit_MICROSECONDS_getInstance()));
                    throw t_0;
                  }
                }
                 while (false);
                var end_8 = PerformanceCounter_instance.l1q();
                var this_12 = end_8 - start_0;
                this_10.m9r(name_0, toDuration(this_12, DurationUnit_MICROSECONDS_getInstance()));
                break l$ret$23;
              }
               while (false);
              var end_9 = PerformanceCounter_instance.l1q();
              var this_13 = end_9 - start_0;
              this_10.m9r(name_0, toDuration(this_13, DurationUnit_MICROSECONDS_getInstance()));
            }
             while (false);
            launchImmediately(this.e9r_1, KorgeRunner$invoke$slambda$slambda_0(this.m9q_1, this.e9r_1, this.p9q_1, this.r9q_1, null));
            if (this.m9q_1.p9b_1) {
              this.fd_1 = 20;
              suspendResult = this.r9q_1.l9o(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 21;
              continue $sm;
            }

          case 20:
            this.r9q_1.a9s();
            this.fd_1 = 21;
            continue $sm;
          case 21:
            return Unit_instance;
          case 22:
            this.gd_1 = 23;
            var t_1 = this.id_1;
            var end_10 = PerformanceCounter_instance.l1q();
            var this_14 = end_10 - this.i9r_1;
            this.g9r_1.m9r(this.h9r_1, toDuration(this_14, DurationUnit_MICROSECONDS_getInstance()));
            throw t_1;
          case 23:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 23) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(KorgeRunner$invoke$slambda).l9r = function ($this$loop, completion) {
    var i = new KorgeRunner$invoke$slambda(this.k9q_1, this.l9q_1, this.m9q_1, this.n9q_1, this.o9q_1, this.p9q_1, completion);
    i.q9q_1 = $this$loop;
    return i;
  };
  function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry, resultContinuation) {
    var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry, resultContinuation);
    var l = function ($this$loop, $completion) {
      return i.k9r($this$loop, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
    return new ResourcesRoot();
  }
  function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
    return new EmptyScene();
  }
  function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
    return function (e) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = Companion_getInstance_78().g9a_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.f25(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e;
        this_0.g25(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      var p = prepareViewsBase$getRealXY($views, e.g7o_1, e.h7o_1, e.r7o_1);
      var tmp_0;
      switch (e.e7o_1.ka_1) {
        case 3:
          prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.i7o_1);
          prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.i7o_1, Type_START_getInstance(), Status_ADD_getInstance());
          tmp_0 = Unit_instance;
          break;
        case 2:
          prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.i7o_1);
          prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.i7o_1, Type_END_getInstance(), Status_REMOVE_getInstance());
          tmp_0 = Unit_instance;
          break;
        case 1:
          prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
          prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.i7o_1, Type_MOVE_getInstance_0(), Status_KEEP_getInstance());
          tmp_0 = Unit_instance;
          break;
        case 0:
          prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
          tmp_0 = Unit_instance;
          break;
        case 4:
          tmp_0 = Unit_instance;
          break;
        case 5:
          prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
          tmp_0 = Unit_instance;
          break;
        case 6:
          prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
          tmp_0 = Unit_instance;
          break;
        case 7:
          tmp_0 = Unit_instance;
          break;
      }
      $views.s7m(e);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_2($views) {
    return function (e) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = Companion_getInstance_78().g9a_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.f25(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e;
        this_0.g25(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      $views.s7m(e);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_3($views) {
    return function (e) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = Companion_getInstance_78().g9a_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.f25(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e;
        this_0.g25(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      $views.s7m(e);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_4($views) {
    return function (e) {
      $views.s7m(e);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_5($views) {
    return function (e) {
      $views.s7m(e);
      get_nativeSoundProvider().f23(false);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_6($views) {
    return function (e) {
      $views.s7m(e);
      get_nativeSoundProvider().f23(true);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_7($views) {
    return function (e) {
      $views.s7m(e);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda$slambda($views, resultContinuation) {
    this.j9s_1 = $views;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KorgeRunner$prepareViewsBase$lambda$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(KorgeRunner$prepareViewsBase$lambda$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(KorgeRunner$prepareViewsBase$lambda$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        if (tmp === 0) {
          this.gd_1 = 1;
          this.j9s_1.p21();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(KorgeRunner$prepareViewsBase$lambda$slambda).g5a = function (completion) {
    return new KorgeRunner$prepareViewsBase$lambda$slambda(this.j9s_1, completion);
  };
  function KorgeRunner$prepareViewsBase$lambda$slambda_0($views, resultContinuation) {
    var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function KorgeRunner$prepareViewsBase$lambda_8($views) {
    return function (e) {
      var tmp;
      try {
        $views.s7m(e);
        tmp = Unit_instance;
      }finally {
        launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views, null));
      }
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
    return function (e) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = Companion_getInstance_78().g9a_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.f25(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e;
        this_0.g25(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      $input.k9s(e);
      var ee = $input.b9p_1;
      var tmp0_iterator = ee.u7p().u();
      while (tmp0_iterator.v()) {
        var t = tmp0_iterator.x();
        t.a7p_1 = prepareViewsBase$getRealXY($views, t.v4s(), t.w4s(), e.o7p_1);
      }
      $views.s7m(ee);
      var tmp_0;
      if (ee.v7p() === 1) {
        var start = ee.f7q();
        var end = ee.g7q();
        var t_0 = first(ee.u7p());
        var p = t_0.a7p_1;
        var x = t_0.v4s();
        var y = t_0.w4s();
        var button = MouseButton_LEFT_getInstance();
        if (start) {
          prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
        } else if (end) {
          prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
        } else {
          prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
        }
        // Inline function 'kotlin.also' call
        var this_1 = $touchMouseEvent;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        this_1.f7o_1 = 0;
        this_1.i7o_1 = button;
        this_1.j7o_1 = end ? 0 : 1 << button.g7u_1;
        this_1.g7o_1 = numberToInt(x);
        this_1.h7o_1 = numberToInt(y);
        this_1.r7o_1 = false;
        this_1.s7o_1 = true;
        this_1.e7o_1 = start ? Type_DOWN_getInstance_0() : end ? Type_UP_getInstance_0() : Type_DRAG_getInstance();
        $views.s7m(this_1);
        var tmp_1;
        if (end) {
          $moveMouseOutsideInNextFrame._v = true;
          tmp_1 = Unit_instance;
        }
        tmp_0 = tmp_1;
      }
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_10($views) {
    return function (e) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = Companion_getInstance_78().g9a_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.f25(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
        var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e;
        this_0.g25(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      $views.s7m(e);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
    return function (e) {
      prepareViewsBase$gamepadUpdated($input, e);
      $views.s7m(e);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
    return function (e) {
      $views.l9s($ag.o7u().n7w_1, $ag.o7u().o7w_1);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_13($views) {
    return function (it) {
      $views.s7m(it);
      return Unit_instance;
    };
  }
  function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
    return function (event) {
      var tmp;
      if (!event.s7q_1) {
        prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
        tmp = Unit_instance;
      } else {
        var this_0 = $views.p9f_1;
        var frameBuffer = this_0.o7u();
        this_0.u9s_1.n1y();
        this_0.m9s_1.s7u();
        var tmp_0;
        try {
          this_0.w9t(frameBuffer);
          var tmp_1;
          try {
            if (!$renderShown._v) {
              $renderShown._v = true;
              $firstRenderDeferred.d1g(Unit_instance);
            }
            prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
            tmp_1 = Unit_instance;
          }finally {
            this_0.x9t();
          }
          tmp_0 = tmp_1;
        }finally {
          this_0.m9s_1.y7p();
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function $invokeCOROUTINE$0(_this__u8e3s4, config, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g9u_1 = _this__u8e3s4;
    this.h9u_1 = config;
  }
  protoOf($invokeCOROUTINE$0).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 7;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.j9u_1 = Companion_instance_4;
            get_workerImpl().i78();
            if (get_workerImpl().j78()) {
              if (get_DEBUG_WORKER()) {
                println('INSIDE WORKER');
              }
              this.i9u_1 = Unit_instance;
              this.fd_1 = 6;
              continue $sm;
            } else {
              if (get_DEBUG_WORKER()) {
                println('**NOT** INSIDE WORKER');
              }
              this.fd_1 = 2;
              continue $sm;
            }

          case 2:
            get_nativeSoundProvider();
            get_RegisteredImageFormats().g53([this.h9u_1.f9b_1]);
            this.k9u_1 = this.h9u_1.z9b_1;
            this.l9u_1 = this.h9u_1.f9b_1;
            this.m9u_1 = this.h9u_1.d9c_1;
            this.n9u_1 = this.h9u_1.t9b_1;
            if (!Companion_instance_2.s1p()) {
              this.fd_1 = 3;
              suspendResult = configureLoggerFromProperties(get_localCurrentDirVfs().s13('klogger.properties'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 4;
              continue $sm;
            }

          case 3:
            this.fd_1 = 4;
            continue $sm;
          case 4:
            var tmp_1 = this;
            var tmp0_elvis_lhs = this.h9u_1.g9b_1;
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              tmp_2 = this.q6().md(CoroutineKey_getInstance());
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            var tmp1_elvis_lhs = tmp_2;
            tmp_1.o9u_1 = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(this.h9u_1.c9c_1) : tmp1_elvis_lhs;
            var tmp2_elvis_lhs = this.h9u_1.x9b_1;
            var tmp_3;
            var tmp_4 = tmp2_elvis_lhs;
            if ((tmp_4 == null ? null : new RGBA(tmp_4)) == null) {
              tmp_3 = Colors_getInstance().m3b_1;
            } else {
              tmp_3 = tmp2_elvis_lhs;
            }

            this.o9u_1.p9u(tmp_3);
            this.fd_1 = 5;
            suspendResult = this.o9u_1.q9u(KorgeRunner$invoke$slambda_0(this.o9u_1, this.n9u_1, this.h9u_1, this.k9u_1, this.l9u_1, this.m9u_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (false) {
              this.fd_1 = 1;
              continue $sm;
            }

            this.fd_1 = 6;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 7) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function KorgeRunner() {
  }
  protoOf(KorgeRunner).m9c = function (config, $completion) {
    var tmp = new $invokeCOROUTINE$0(this, config, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(KorgeRunner).z9r = function (views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.r9e_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.h27(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.q9e_1;
    injector.h27(getKClass(AG), instance);
    injector.h27(getKClass(Resources), views.r9u());
    var tmp = getKClass(ResourcesRoot);
    injector.k27(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.s9e_1;
    injector.h27(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.u9e_1;
    injector.h27(getKClass(Stats), instance_1);
    injector.h27(getKClass(CoroutineContext), views.p9e_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.l27(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.h27(getKClass(TimeProvider), views.t9e_1);
    configInjector(injector);
    var input = views.s9e_1;
    var ag = views.q9e_1;
    var downPos = {_v: Companion_getInstance_0().d2d_1};
    var upPos = {_v: Companion_getInstance_0().d2d_1};
    var downTime = {_v: new DateTime(Companion_getInstance_1().a1q_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_1().a1q_1)};
    var upTime = Companion_getInstance_1().a1q_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.s9u(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_27().y7n_1.slice();
    eventDispatcher.t7m(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_26().k7n_1.slice();
    eventDispatcher.t7m(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_25().d7n_1.slice();
    eventDispatcher.t7m(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_40().x7q_1.slice();
    eventDispatcher.t7m(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_21;
    eventDispatcher.h7m(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_20;
    eventDispatcher.h7m(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_22;
    eventDispatcher.h7m(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_23;
    eventDispatcher.h7m(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_29().h7p_1.slice();
    eventDispatcher.t7m(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_43().l7s_1.slice();
    eventDispatcher.t7m(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_29;
    eventDispatcher.h7m(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_19;
    eventDispatcher.h7m(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.s7m(new ReshapeEvent(0, 0, views.t9u(), views.u9u()));
    var tmp_13 = Companion_instance_68;
    eventDispatcher.h7m(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.q9f_1 = clearEachFrame;
    views.r9f_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.v9e_1.v9u(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  };
  var KorgeRunner_instance;
  function KorgeRunner_getInstance() {
    return KorgeRunner_instance;
  }
  function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, entry, $completion) {
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_1 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$lambda;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_78().h9a_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_85().p9c_1 : batchMaxQuads;
    windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().z9c_1.r2k_1) : windowWidth;
    windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().z9c_1.s2k_1) : windowHeight;
    windowSize = windowSize === VOID ? Size2D_init_$Create$(windowWidth, windowHeight) : windowSize;
    virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.r2k_1) : virtualWidth;
    virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.s2k_1) : virtualHeight;
    virtualSize = virtualSize === VOID ? Size2D_init_$Create$(virtualWidth, virtualHeight) : virtualSize;
    scaleMode = scaleMode === VOID ? Companion_getInstance_10().l2m_1 : scaleMode;
    scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_11().o2c() : scaleAnchor;
    clipBorders = clipBorders === VOID ? true : clipBorders;
    displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
    title = title === VOID ? 'Game' : title;
    bgcolor = bgcolor === VOID ? Colors_getInstance().m3b_1 : bgcolor;
    backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$slambda_0(null);
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().l3b_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$lambda_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    var tmp_3;
    if (entry === VOID) {
      tmp_3 = Korge$slambda_2(null);
    } else {
      tmp_3 = entry;
    }
    entry = tmp_3;
    return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, Unit_instance)).e9d(entry, $completion);
  }
  function Korge$lambda($this$null) {
    return Unit_instance;
  }
  function Korge$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Korge$slambda).r9a = function ($this$null, $completion) {
    var tmp = this.s9a($this$null, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Korge$slambda).ne = function (p1, $completion) {
    return this.r9a(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Korge$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        if (tmp === 0) {
          this.gd_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(Korge$slambda).s9a = function ($this$null, completion) {
    var i = new Korge$slambda(completion);
    i.e9v_1 = $this$null;
    return i;
  };
  function Korge$slambda_0(resultContinuation) {
    var i = new Korge$slambda(resultContinuation);
    var l = function ($this$null, $completion) {
      return i.r9a($this$null, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function Korge$lambda_0(it) {
    return new Stage(it);
  }
  function Korge$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Korge$slambda_1).r9a = function ($this$null, $completion) {
    var tmp = this.s9a($this$null, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Korge$slambda_1).ne = function (p1, $completion) {
    return this.r9a(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Korge$slambda_1).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        if (tmp === 0) {
          this.gd_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(Korge$slambda_1).s9a = function ($this$null, completion) {
    var i = new Korge$slambda_1(completion);
    i.n9v_1 = $this$null;
    return i;
  };
  function Korge$slambda_2(resultContinuation) {
    var i = new Korge$slambda_1(resultContinuation);
    var l = function ($this$null, $completion) {
      return i.r9a($this$null, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KorgeReload() {
    KorgeReload_instance = this;
    this.v9r_1 = null;
    this.w9r_1 = Companion_getInstance_2().r24('KorgeReload');
  }
  protoOf(KorgeReload).x9r = function (eventDispatcher) {
    if (!Companion_instance_2.o1p().v1p() ? true : !(Companion_instance.s13('KORGE_AUTORELOAD') === 'true'))
      return Unit_instance;
    this.v9r_1 = eventDispatcher;
  };
  protoOf(KorgeReload).o9v = function () {
    if (!Companion_instance_2.o1p().v1p())
      return Unit_instance;
    if (!(this.v9r_1 == null))
      this.v9r_1 = null;
  };
  var KorgeReload_instance;
  function KorgeReload_getInstance() {
    if (KorgeReload_instance == null)
      new KorgeReload();
    return KorgeReload_instance;
  }
  function KorgeReloadInternalImpl() {
  }
  protoOf(KorgeReloadInternalImpl).p9v = function (clazz, context) {
    return clazz;
  };
  protoOf(KorgeReloadInternalImpl).q9v = function (old, new_0) {
    return Unit_instance;
  };
  function Companion_54() {
  }
  var Companion_instance_68;
  function Companion_getInstance_80() {
    return Companion_instance_68;
  }
  function ReloadClassContext(injector, refreshedClasses, rootFolders) {
    this.r9v_1 = injector;
    this.s9v_1 = refreshedClasses;
    this.t9v_1 = rootFolders;
  }
  var simpleAnimator$delegate;
  function _get_totalTime__xgts5c($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.b9w_1;
    totalTime$factory();
    return this_0.m2().aj_1;
  }
  function Animator$TweenNode$computedVs$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.v9v_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(tmp0_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.korge.animate.TweenNode.computedVs$delegate.<anonymous>.<anonymous>' call
          var tmp$ret$0 = item();
          destination.r(tmp$ret$0);
        }
        tmp = destination;
      }
      var tmp1_elvis_lhs = tmp;
      return toMutableList(tmp1_elvis_lhs == null ? toList_0(this$0.u9v_1) : tmp1_elvis_lhs);
    };
  }
  function Animator$TweenNode$totalTime$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.x9v_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp_0 = tmp0_safe_receiver();
        tmp = tmp_0 == null ? null : tmp_0.aj_1;
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_1;
      var tmp_2 = tmp1_elvis_lhs;
      if ((tmp_2 == null ? null : new Duration(tmp_2)) == null) {
        tmp_1 = this$0.w9v_1;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      return new Duration(tmp_1);
    };
  }
  function Companion_55() {
    Companion_instance_69 = this;
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp.d9w_1 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    this.e9w_1 = 128.0;
    this.f9w_1 = Companion_getInstance_12().k28();
    this.g9w_1 = true;
  }
  var Companion_instance_69;
  function Companion_getInstance_81() {
    if (Companion_instance_69 == null)
      new Companion_55();
    return Companion_instance_69;
  }
  function ensure($this) {
    if (!($this.n9w_1 == null))
      return ensure($this.n9w_1);
    if (!($this.y9w().u9w_1 == null))
      return Unit_instance;
    var tmp = $this.y9w();
    var tmp_0 = $this.y9w().q9w_1;
    tmp.u9w_1 = addUpdater($this.h9w_1, tmp_0, VOID, Animator$ensure$lambda($this));
  }
  function ensureInit($this) {
    var tmp0_elvis_lhs = $this.o9w_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var linit = tmp;
    $this.o9w_1 = null;
    linit($this);
  }
  function RootAnimationNode($outer) {
    this.b9x_1 = $outer;
    this.z9w_1 = null;
    this.a9x_1 = fastArrayListOf([]);
  }
  protoOf(RootAnimationNode).n1y = function () {
    this.z9w_1 = null;
  };
  protoOf(RootAnimationNode).c9x = function (dt) {
    var dt_0 = !(this.b9x_1.t9w_1 === 1.0) ? Duration__times_impl_sfuzvp(dt, this.b9x_1.t9w_1) : dt;
    ensureInit(this.b9x_1);
    if (this.b9x_1.l9w_1) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      var completedTime = toDuration(0, DurationUnit_SECONDS_getInstance());
      this.a9x_1.b3();
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var tmp0_iterator = this.b9x_1.s9w_1.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.korge.animate.RootAnimationNode.update.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var index_0 = checkIndexOverflow(tmp1);
        var result = item.c9x(dt_0);
        // Inline function 'korlibs.time.seconds' call
        // Inline function 'korlibs.time.seconds' call
        var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
        if (Duration__compareTo_impl_pchp0f(result, tmp$ret$3) >= 0) {
          this.a9x_1.r(item);
        }
        completedTime = index_0 === 0 ? result : min_0(completedTime, result);
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.a9x_1.b1()) {
        this.b9x_1.s9w_1.j1u(this.a9x_1);
      }
      this.a9x_1.b3();
      this.b9x_1.w9w_1 = true;
      return completedTime;
    }
    $l$loop: while (true) {
      if (this.z9w_1 == null) {
        var tmp = this;
        var tmp_0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.b9x_1.s9w_1.b1()) {
          tmp_0 = this.b9x_1.s9w_1.hf();
        } else {
          tmp_0 = null;
        }
        tmp.z9w_1 = tmp_0;
        var tmp0_safe_receiver = this.z9w_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.n1y();
        }
        if (this.b9x_1.m9w_1) {
          var tmp1_safe_receiver = this.z9w_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            this.b9x_1.s9w_1.a1u(tmp1_safe_receiver);
          }
        }
      }
      if (!(this.z9w_1 == null)) {
        var node = ensureNotNull(this.z9w_1);
        var extraTime = node.c9x(dt_0);
        if (Duration__compareTo_impl_pchp0f(extraTime, Companion_getInstance().va_1) >= 0) {
          this.z9w_1 = null;
          dt_0 = extraTime;
        }
        if (Duration__compareTo_impl_pchp0f(extraTime, Companion_getInstance().va_1) > 0) {
          continue $l$loop;
        }
      }
      var tmp_1;
      var tmp_2;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.b9x_1.s9w_1.b1()) {
        tmp_2 = true;
      } else {
        tmp_2 = !(this.z9w_1 == null);
      }
      if (tmp_2) {
        // Inline function 'korlibs.time.seconds' call
        // Inline function 'korlibs.time.seconds' call
        tmp_1 = toDuration(-1, DurationUnit_SECONDS_getInstance());
      } else {
        tmp_1 = Companion_getInstance().va_1;
      }
      return tmp_1;
    }
  };
  protoOf(RootAnimationNode).toString = function () {
    return 'RootAnimationNode(' + this.b9x_1 + ')';
  };
  function TweenNode(vs, lazyVs, time, lazyTime, easing, name) {
    lazyVs = lazyVs === VOID ? null : lazyVs;
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    lazyTime = lazyTime === VOID ? null : lazyTime;
    name = name === VOID ? null : name;
    this.u9v_1 = vs;
    this.v9v_1 = lazyVs;
    this.w9v_1 = time;
    this.x9v_1 = lazyTime;
    this.y9v_1 = easing;
    this.z9v_1 = name;
    var tmp_0 = this;
    tmp_0.a9w_1 = lazy(Animator$TweenNode$computedVs$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.b9w_1 = lazy(Animator$TweenNode$totalTime$delegate$lambda(this));
    this.c9w_1 = Companion_getInstance().va_1;
  }
  protoOf(TweenNode).d9x = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a9w_1;
    computedVs$factory();
    return this_0.m2();
  };
  protoOf(TweenNode).toString = function () {
    return 'TweenNode(totalTime=' + new Duration(_get_totalTime__xgts5c(this)) + ', name=' + this.z9v_1 + ', ' + toList(this.d9x()) + ')';
  };
  protoOf(TweenNode).n1y = function () {
    this.c9w_1 = Companion_getInstance().va_1;
  };
  protoOf(TweenNode).c9x = function (dt) {
    if (equals(this.c9w_1, Companion_getInstance().va_1)) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.d9x();
      var n = 0;
      while (n < this_0.n()) {
        // Inline function 'korlibs.korge.animate.TweenNode.update.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        this_0.f1(tmp0).i78();
      }
    }
    this.c9w_1 = Duration__plus_impl_yu9v8f(this.c9w_1, dt);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.d9x();
    var n_0 = 0;
    while (n_0 < this_1.n()) {
      // Inline function 'korlibs.korge.animate.TweenNode.update.<anonymous>' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      var it = this_1.f1(tmp0_0);
      var ratio = equals(_get_totalTime__xgts5c(this), Companion_getInstance().va_1) ? 1.0 : convertRange(get_seconds(this.c9w_1), get_seconds(it.j9x_1), get_seconds(it.n9x(_get_totalTime__xgts5c(this))), 0.0, 1.0);
      if (ratio >= 0.0) {
        it.o9x(toRatio(this.y9v_1.o28(clamp01(ratio))));
      }
    }
    return Duration__minus_impl_q5cfm7(this.c9w_1, _get_totalTime__xgts5c(this));
  };
  function BlockNode(name, callback) {
    name = name === VOID ? null : name;
    this.p9x_1 = name;
    this.q9x_1 = callback;
    this.r9x_1 = false;
  }
  protoOf(BlockNode).toString = function () {
    return 'BlockNode(name=' + this.p9x_1 + ')';
  };
  protoOf(BlockNode).n1y = function () {
    this.r9x_1 = false;
  };
  protoOf(BlockNode).c9x = function (dt) {
    this.s9x();
    return dt;
  };
  protoOf(BlockNode).s9x = function () {
    if (this.r9x_1)
      return Unit_instance;
    this.r9x_1 = true;
    this.q9x_1();
  };
  function Animator$removeProps$lambda($props) {
    return function (it) {
      return !$props.z(it.e9x_1);
    };
  }
  function Animator$ensure$lambda(this$0) {
    return function ($this$addUpdater, dt) {
      var tmp;
      if (this$0.v9w_1) {
        this$0.h9w_1.t9x();
        tmp = Unit_instance;
      }
      var tmp_0;
      if (Duration__compareTo_impl_pchp0f(this$0.x9w_1.c9x(dt.aj_1), Companion_getInstance().va_1) >= 0) {
        var tmp_1;
        if (this$0.m9w_1) {
          invoke(this$0.r9w_1);
          tmp_1 = Unit_instance;
        } else {
          this$0.u9x();
          tmp_1 = Unit_instance;
        }
        tmp_0 = tmp_1;
      }
      return Unit_instance;
    };
  }
  function Animator(root, defaultTime, defaultSpeed, defaultEasing, parallel, looped, parent, lazyInit, level, startImmediately) {
    Companion_getInstance_81();
    parallel = parallel === VOID ? false : parallel;
    looped = looped === VOID ? false : looped;
    lazyInit = lazyInit === VOID ? null : lazyInit;
    this.h9w_1 = root;
    this.i9w_1 = defaultTime;
    this.j9w_1 = defaultSpeed;
    this.k9w_1 = defaultEasing;
    this.l9w_1 = parallel;
    this.m9w_1 = looped;
    this.n9w_1 = parent;
    this.o9w_1 = lazyInit;
    this.p9w_1 = level;
    this.q9w_1 = startImmediately;
    this.r9w_1 = new Signal();
    this.s9w_1 = TGenDeque_init_$Create$();
    this.t9w_1 = 1.0;
    this.u9w_1 = null;
    this.v9w_1 = false;
    this.w9w_1 = false;
    this.x9w_1 = new RootAnimationNode(this);
  }
  protoOf(Animator).y9w = function () {
    var tmp0_safe_receiver = this.n9w_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9w();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  };
  protoOf(Animator).v9x = function (props) {
    var tmp0_iterator = this.s9w_1.u();
    while (tmp0_iterator.v()) {
      var node = tmp0_iterator.x();
      if (node instanceof TweenNode) {
        var tmp = node.d9x();
        retainAll(tmp, Animator$removeProps$lambda(props));
      }
    }
  };
  protoOf(Animator).w9x = function (node) {
    this.s9w_1.g1u(node);
    ensure(this);
  };
  protoOf(Animator).p21 = function () {
    this.u9x();
  };
  protoOf(Animator).x6g = function (e) {
    this.u9x();
  };
  protoOf(Animator).u9x = function () {
    this.x9w_1.n1y();
    this.s9w_1.b3();
    var tmp0_safe_receiver = this.y9w().u9w_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancel_0(tmp0_safe_receiver);
    }
    this.y9w().u9w_1 = null;
    this.w9w_1 = false;
    invoke(this.r9w_1);
    return this;
  };
  protoOf(Animator).x9x = function (vs, lazyVs, time, lazyTime, easing, name, replace) {
    if (replace ? this.l9w_1 : false) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(vs.length);
      var inductionVariable = 0;
      var last = vs.length;
      while (inductionVariable < last) {
        var item = vs[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.animate.Animator.__tween.<anonymous>' call
        var tmp$ret$0 = item.e9x_1;
        destination.r(tmp$ret$0);
      }
      this.v9x(toSet(destination));
    }
    this.w9x(new TweenNode(vs.slice(), lazyVs, time, lazyTime, easing, name));
  };
  protoOf(Animator).y9x = function (vs, lazyVs, time, lazyTime, easing, name, replace, $super) {
    lazyVs = lazyVs === VOID ? null : lazyVs;
    time = time === VOID ? this.i9w_1 : time;
    lazyTime = lazyTime === VOID ? null : lazyTime;
    easing = easing === VOID ? this.k9w_1 : easing;
    replace = replace === VOID ? true : replace;
    var tmp;
    if ($super === VOID) {
      this.x9x(vs, lazyVs, time, lazyTime, easing, name, replace);
      tmp = Unit_instance;
    } else {
      tmp = $super.x9x.call(this, vs, lazyVs, new Duration(time), lazyTime, easing, name, replace);
    }
    return tmp;
  };
  function animator(_this__u8e3s4, defaultTime, defaultSpeed, defaultEasing, parallel, looped, startImmediately, block) {
    defaultTime = defaultTime === VOID ? Companion_getInstance_81().d9w_1 : defaultTime;
    defaultSpeed = defaultSpeed === VOID ? Companion_getInstance_81().e9w_1 : defaultSpeed;
    defaultEasing = defaultEasing === VOID ? Companion_getInstance_81().f9w_1 : defaultEasing;
    parallel = parallel === VOID ? false : parallel;
    looped = looped === VOID ? false : looped;
    startImmediately = startImmediately === VOID ? Companion_getInstance_81().g9w_1 : startImmediately;
    var tmp;
    if (block === VOID) {
      tmp = animator$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    _init_properties_Animator_kt__gicf47();
    // Inline function 'kotlin.apply' call
    var this_0 = new Animator(_this__u8e3s4, defaultTime, defaultSpeed, defaultEasing, parallel, looped, null, VOID, 0, startImmediately);
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    return this_0;
  }
  function tween(_this__u8e3s4, vs, time, easing, name, replace) {
    time = time === VOID ? _this__u8e3s4.i9w_1 : time;
    easing = easing === VOID ? _this__u8e3s4.k9w_1 : easing;
    name = name === VOID ? null : name;
    replace = replace === VOID ? true : replace;
    _init_properties_Animator_kt__gicf47();
    return _this__u8e3s4.y9x(vs.slice(), VOID, time, VOID, easing, name, replace);
  }
  function block(_this__u8e3s4, name, callback) {
    name = name === VOID ? null : name;
    _init_properties_Animator_kt__gicf47();
    _this__u8e3s4.w9x(new BlockNode(name, callback));
  }
  function simpleAnimator$delegate$lambda($this$$receiver) {
    _init_properties_Animator_kt__gicf47();
    // Inline function 'kotlin.also' call
    var this_0 = animator($this$$receiver, VOID, VOID, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.animate.simpleAnimator$delegate.<anonymous>.<anonymous>' call
    this_0.v9w_1 = true;
    return this_0;
  }
  function animator$lambda($this$null) {
    _init_properties_Animator_kt__gicf47();
    return Unit_instance;
  }
  function computedVs$factory() {
    return getPropertyCallableRef('computedVs', 1, KProperty1, function (receiver) {
      return receiver.d9x();
    }, null);
  }
  function totalTime$factory() {
    return getPropertyCallableRef('totalTime', 1, KProperty1, function (receiver) {
      return new Duration(_get_totalTime__xgts5c(receiver));
    }, null);
  }
  var properties_initialized_Animator_kt_opr5o7;
  function _init_properties_Animator_kt__gicf47() {
    if (!properties_initialized_Animator_kt_opr5o7) {
      properties_initialized_Animator_kt_opr5o7 = true;
      simpleAnimator$delegate = new PropertyThis(VOID, simpleAnimator$delegate$lambda);
    }
  }
  function drawText(_this__u8e3s4, font, textSize, str, x, y, m, colMul, blendMode, filtering) {
    m = m === VOID ? Companion_getInstance_14().e2f_1 : m;
    colMul = colMul === VOID ? Colors_getInstance().l3b_1 : colMul;
    blendMode = blendMode === VOID ? Companion_getInstance_90().a9y_1 : blendMode;
    filtering = filtering === VOID ? true : filtering;
    drawText_0(font, _this__u8e3s4, textSize, str, x, y, m, colMul, blendMode, filtering);
  }
  function drawText_0(_this__u8e3s4, ctx, textSize, str, x, y, m, colMul, blendMode, filtering) {
    m = m === VOID ? Companion_getInstance_14().e2f_1 : m;
    colMul = colMul === VOID ? Colors_getInstance().l3b_1 : colMul;
    blendMode = blendMode === VOID ? Companion_getInstance_90().a9y_1 : blendMode;
    filtering = filtering === VOID ? true : filtering;
    var scale = textSize / _this__u8e3s4.k3t();
    var m2 = m.s2g(x, y).k2g(scale, scale);
    var dx = 0.0;
    var dy = 0.0;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.n9t_1;
    var this_1 = this_0.t9y_1;
    if (!(this_1.r9t_1 === this_0)) {
      this_1.r9t_1 = this_0;
      this_1.y9z();
    }
    var inductionVariable = 0;
    var last = charSequenceLength(str) - 1 | 0;
    var tmp;
    if (inductionVariable <= last) {
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1 = Char__toInt_impl_vasixd(charSequenceGet(str, n));
        if (c1 === 10) {
          dx = 0.0;
          dy = dy + _this__u8e3s4.k3t();
          continue $l$loop;
        }
        // Inline function 'kotlin.text.getOrElse' call
        var index = n + 1 | 0;
        var tmp_0;
        if (index >= 0 ? index <= get_lastIndex_0(str) : false) {
          tmp_0 = charSequenceGet(str, index);
        } else {
          // Inline function 'korlibs.korge.bitmapfont.drawText.<anonymous>.<anonymous>' call
          tmp_0 = _Char___init__impl__6a9atx(32);
        }
        var tmp$ret$1 = tmp_0;
        var c2 = Char__toInt_impl_vasixd(tmp$ret$1);
        var glyph = _this__u8e3s4.f1(c1);
        var tex = glyph.a3t_1;
        var tmp1_tex = ctx.z9z(tex);
        var tmp2_x = dx + glyph.b3t_1;
        var tmp3_y = dy + glyph.c3t_1;
        var tmp4_width = tex.v2w_1;
        var tmp5_height = tex.w2w_1;
        var tmp6_m = get_immutable(m2);
        this_0.aa0(tmp1_tex, tmp2_x, tmp3_y, tmp4_width, tmp5_height, tmp6_m, filtering, colMul, blendMode);
        var tmp7_safe_receiver = _this__u8e3s4.o3t().f1(Companion_instance_5.x3s(c1, c2));
        var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.i3t_1;
        var kerningOffset = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
        dx = dx + (glyph.d3t_1 + kerningOffset | 0);
      }
       while (inductionVariable <= last);
      tmp = Unit_instance;
    }
  }
  var debugBmpFontOrNull;
  function debugBmpFont($completion) {
    var tmp = new $debugBmpFontCOROUTINE$2($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function debugBmpFont_0(tex) {
    var fntAdvance = 7.0;
    var fntWidth = 8.0;
    var fntHeight = 8.0;
    var fntBlockX = 2.0;
    var fntBlockY = 2.0;
    var fntBlockWidth = 12.0;
    var fntBlockHeight = 12.0;
    // Inline function 'korlibs.image.font.Companion.invoke' call
    var base = fntHeight - 1.0;
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = until(0, 256);
    var result = LinkedHashMap_init_$Create$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.korge.bitmapfont.debugBmpFont.<anonymous>' call
      var x = element % 16 | 0;
      var y = element / 16 | 0;
      var tmp$ret$0 = new Glyph(fntHeight, element, tex.d2y(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
      result.i2(element, tmp$ret$0);
    }
    var glyphs = toIntMap(result);
    var kernings = IntMap_init_$Create$();
    var name = 'BitmapFont';
    return new BitmapFontImpl(numberToDouble(fntHeight), numberToDouble(fntHeight), numberToDouble(base), glyphs, kernings, name, null);
  }
  function get_DEBUG_FONT_BYTES() {
    return fromBase64('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');
  }
  function $debugBmpFontCOROUTINE$2(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($debugBmpFontCOROUTINE$2).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            if (debugBmpFontOrNull == null) {
              this.fd_1 = 1;
              suspendResult = readBitmap_0(openAsync(get_DEBUG_FONT_BYTES()), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = slice(ARGUMENT);
            var ARGUMENT_1 = debugBmpFont_0(ARGUMENT_0);
            debugBmpFontOrNull = ARGUMENT_1;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            return ensureNotNull(debugBmpFontOrNull);
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function get_gamepad(_this__u8e3s4) {
    _init_properties_GamepadEvents_kt__kfzyw8();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var this_0 = gamepad$delegate;
      var property = gamepad$factory();
      var tmp0_elvis_lhs = this_0.l23_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = this_0.m23_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = this_0.l23_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var gamepad$delegate;
  function GamePadEvents$lambda(this$0) {
    return function (event) {
      var tmp = this$0;
      var tmp_0 = event.z7m_1;
      tmp.ka0_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
      this$0.la0_1.n7r(event);
      var gamepadsUpdated = false;
      var inductionVariable = 0;
      var last = event.l7r_1;
      var tmp_1;
      if (inductionVariable < last) {
        do {
          var gamepadIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var gamepad = event.m7r_1[gamepadIndex];
          var oldGamepad = this$0.ra0_1.m7r_1[gamepadIndex];
          var updateCount = 0;
          // Inline function 'korlibs.datastructure.iterators.fastForEach' call
          var this_0 = Companion_getInstance_45().v7s_1;
          var n = 0;
          while (n < this_0.length) {
            // Inline function 'korlibs.korge.input.GamePadEvents.<anonymous>.<anonymous>' call
            var tmp0 = n;
            n = tmp0 + 1 | 0;
            var button = this_0[tmp0];
            if (!(gamepad.d7s(button) === oldGamepad.d7s(button))) {
              updateCount = updateCount + 1 | 0;
              // Inline function 'kotlin.apply' call
              var this_1 = this$0.ta0_1;
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.input.GamePadEvents.<anonymous>.<anonymous>.<anonymous>' call
              this_1.xa0_1 = gamepad.o7r_1;
              this_1.wa0_1 = !(gamepad.d7s(button) === 0.0) ? Type_DOWN_getInstance_1() : Type_UP_getInstance_1();
              this_1.ya0_1 = button;
              this_1.za0_1 = gamepad.d7s(button);
              this$0.pa0_1.x5n(this_1);
            }
          }
          // Inline function 'korlibs.datastructure.iterators.fastForEach' call
          var this_2 = Companion_getInstance_44().r7s_1;
          var n_0 = 0;
          while (n_0 < this_2.length) {
            // Inline function 'korlibs.korge.input.GamePadEvents.<anonymous>.<anonymous>' call
            var tmp0_0 = n_0;
            n_0 = tmp0_0 + 1 | 0;
            var stick = this_2[tmp0_0];
            var vector = gamepad.h7s(stick);
            if (!vector.equals(oldGamepad.h7s(stick))) {
              updateCount = updateCount + 1 | 0;
              // Inline function 'kotlin.apply' call
              var this_3 = this$0.sa0_1;
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.input.GamePadEvents.<anonymous>.<anonymous>.<anonymous>' call
              this_3.da1_1 = gamepad.o7r_1;
              this_3.ea1_1 = stick;
              this_3.fa1_1 = vector;
              this$0.oa0_1.x5n(this_3);
            }
          }
          if (updateCount > 0) {
            this$0.na0_1.x5n(gamepad);
            gamepadsUpdated = true;
          }
        }
         while (inductionVariable < last);
        tmp_1 = Unit_instance;
      }
      this$0.ra0_1.n7r(event);
      var tmp_2;
      if (gamepadsUpdated) {
        this$0.ma0_1.x5n(event);
        tmp_2 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function GamePadEvents$lambda_0(this$0) {
    return function (event) {
      var tmp = this$0;
      var tmp_0 = event.z7m_1;
      tmp.ka0_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
      this$0.qa0_1.x5n(event);
      return Unit_instance;
    };
  }
  function GamePadEvents(view) {
    this.ja0_1 = view;
    this.la0_1 = new GamePadUpdateEvent();
    this.ma0_1 = new Signal();
    this.na0_1 = new Signal();
    this.oa0_1 = new Signal();
    this.pa0_1 = new Signal();
    this.qa0_1 = new Signal();
    this.ra0_1 = new GamePadUpdateEvent();
    this.sa0_1 = new GamePadStickEvent();
    this.ta0_1 = new GamePadButtonEvent();
    var tmp = Companion_instance_29;
    this.ja0_1.h7m(tmp, GamePadEvents$lambda(this));
    var tmp_0 = Companion_getInstance_43().l7s_1.slice();
    this.ja0_1.t7m(tmp_0, GamePadEvents$lambda_0(this));
  }
  protoOf(GamePadEvents).ga1 = function (callback) {
    this.na0_1.q5n(callback);
  };
  function Companion_56() {
  }
  var Companion_instance_70;
  function Companion_getInstance_82() {
    return Companion_instance_70;
  }
  function GamePadStickEvent(gamepad, stick, pos) {
    gamepad = gamepad === VOID ? 0 : gamepad;
    stick = stick === VOID ? GameStick_LEFT_getInstance() : stick;
    pos = pos === VOID ? Companion_getInstance_0().d2d_1 : pos;
    TypedEvent.call(this, Companion_instance_70);
    this.da1_1 = gamepad;
    this.ea1_1 = stick;
    this.fa1_1 = pos;
  }
  protoOf(GamePadStickEvent).toString = function () {
    return 'GamePadStickEvent(gamepad=' + this.da1_1 + ', stick=' + this.ea1_1 + ', pos=' + this.fa1_1 + ')';
  };
  protoOf(GamePadStickEvent).hashCode = function () {
    var result = this.da1_1;
    result = imul(result, 31) + this.ea1_1.hashCode() | 0;
    result = imul(result, 31) + this.fa1_1.hashCode() | 0;
    return result;
  };
  protoOf(GamePadStickEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadStickEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadStickEvent ? other : THROW_CCE();
    if (!(this.da1_1 === tmp0_other_with_cast.da1_1))
      return false;
    if (!this.ea1_1.equals(tmp0_other_with_cast.ea1_1))
      return false;
    if (!this.fa1_1.equals(tmp0_other_with_cast.fa1_1))
      return false;
    return true;
  };
  var Type_UP_instance_1;
  var Type_DOWN_instance_1;
  var Type_entriesInitialized_5;
  function Type_initEntries_5() {
    if (Type_entriesInitialized_5)
      return Unit_instance;
    Type_entriesInitialized_5 = true;
    Type_UP_instance_1 = new Type_5('UP', 0);
    Type_DOWN_instance_1 = new Type_5('DOWN', 1);
  }
  function Type_5(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Type_UP_getInstance_1() {
    Type_initEntries_5();
    return Type_UP_instance_1;
  }
  function Type_DOWN_getInstance_1() {
    Type_initEntries_5();
    return Type_DOWN_instance_1;
  }
  function GamePadButtonEvent(type, gamepad, button, value) {
    type = type === VOID ? Type_DOWN_getInstance_1() : type;
    gamepad = gamepad === VOID ? 0 : gamepad;
    button = button === VOID ? GameButton_BUTTON_SOUTH_getInstance() : button;
    value = value === VOID ? 0.0 : value;
    Event.call(this);
    this.wa0_1 = type;
    this.xa0_1 = gamepad;
    this.ya0_1 = button;
    this.za0_1 = value;
  }
  protoOf(GamePadButtonEvent).u2f = function () {
    return this.wa0_1;
  };
  protoOf(GamePadButtonEvent).toString = function () {
    return 'GamePadButtonEvent(type=' + this.wa0_1 + ', gamepad=' + this.xa0_1 + ', button=' + this.ya0_1 + ', value=' + this.za0_1 + ')';
  };
  protoOf(GamePadButtonEvent).hashCode = function () {
    var result = this.wa0_1.hashCode();
    result = imul(result, 31) + this.xa0_1 | 0;
    result = imul(result, 31) + this.ya0_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.za0_1) | 0;
    return result;
  };
  protoOf(GamePadButtonEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadButtonEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadButtonEvent ? other : THROW_CCE();
    if (!this.wa0_1.equals(tmp0_other_with_cast.wa0_1))
      return false;
    if (!(this.xa0_1 === tmp0_other_with_cast.xa0_1))
      return false;
    if (!this.ya0_1.equals(tmp0_other_with_cast.ya0_1))
      return false;
    if (!equals(this.za0_1, tmp0_other_with_cast.za0_1))
      return false;
    return true;
  };
  function gamepad$delegate$lambda($this$$receiver) {
    _init_properties_GamepadEvents_kt__kfzyw8();
    return new GamePadEvents($this$$receiver);
  }
  function gamepad$factory() {
    return getPropertyCallableRef('gamepad', 1, KProperty1, function (receiver) {
      return get_gamepad(receiver);
    }, null);
  }
  var properties_initialized_GamepadEvents_kt_whzq2e;
  function _init_properties_GamepadEvents_kt__kfzyw8() {
    if (!properties_initialized_GamepadEvents_kt_whzq2e) {
      properties_initialized_GamepadEvents_kt_whzq2e = true;
      gamepad$delegate = new PropertyThis(VOID, gamepad$delegate$lambda);
    }
  }
  function InputKeys() {
    this.ha1_1 = booleanArray(Companion_getInstance_46().f7t_1);
    this.ia1_1 = booleanArray(Companion_getInstance_46().f7t_1);
    this.ja1_1 = false;
    this.ka1_1 = false;
    this.la1_1 = false;
    this.ma1_1 = false;
  }
  protoOf(InputKeys).na1 = function (key) {
    return this.oa1(key);
  };
  protoOf(InputKeys).oa1 = function (key) {
    return this.ha1_1[key.ka_1];
  };
  protoOf(InputKeys).pa1 = function (key, up, shift, ctrl, alt, meta) {
    if (up === true) {
      this.ha1_1[key.ka_1] = false;
    } else if (up === false) {
      this.ha1_1[key.ka_1] = true;
    }
    this.ja1_1 = (shift ? true : this.na1(Companion_getInstance_46().t7t())) ? true : this.na1(Companion_getInstance_46().u7t());
    this.ka1_1 = (ctrl ? true : this.na1(Companion_getInstance_46().r7t())) ? true : this.na1(Companion_getInstance_46().s7t());
    this.la1_1 = (alt ? true : this.na1(Companion_getInstance_46().v7t())) ? true : this.na1(Companion_getInstance_46().w7t());
    this.ma1_1 = meta ? true : this.na1(Key_META_getInstance());
  };
  protoOf(InputKeys).qa1 = function (e) {
    switch (e.n7n_1.ka_1) {
      case 0:
      case 1:
        this.pa1(e.p7n_1, e.n7n_1.equals(Type_UP_getInstance()), this.ja1_1, this.ka1_1, this.la1_1, this.ma1_1);
        break;
      default:
        break;
    }
  };
  protoOf(InputKeys).ra1 = function (delta) {
  };
  protoOf(InputKeys).sa1 = function (delta) {
    arraycopy_4(this.ha1_1, 0, this.ia1_1, 0, this.ha1_1.length);
  };
  function Companion_57() {
    this.ta1_1 = 256;
  }
  var Companion_instance_71;
  function Companion_getInstance_83() {
    return Companion_instance_71;
  }
  function endFrameOldKeys($this, delta) {
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var prev = $this.n9p_1[n];
        var curr = $this.m9p_1[n];
        $this.s9p_1[n] = prev ? !curr : false;
        $this.r9p_1[n] = !prev ? curr : false;
        if (curr) {
          var tmp1_array = $this.o9p_1;
          tmp1_array[n] = tmp1_array[n] + get_nanoseconds(delta);
        } else {
          $this.o9p_1[n] = 0.0;
          $this.p9p_1[n] = 0.0;
        }
        var triggerPress = false;
        // Inline function 'korlibs.time.nanoseconds' call
        var this_0 = $this.o9p_1[n];
        var pressingTime = toDuration(this_0, DurationUnit_NANOSECONDS_getInstance());
        if ($this.o9p_1[n] > 0.0) {
          var tmp3_subject = get_milliseconds(pressingTime);
          var tmp;
          if (0.0 <= tmp3_subject ? tmp3_subject <= 1.0 : false) {
            // Inline function 'korlibs.time.milliseconds' call
            tmp = toDuration(0.0, DurationUnit_MILLISECONDS_getInstance());
          } else if (1.0 <= tmp3_subject ? tmp3_subject <= 300.0 : false) {
            // Inline function 'korlibs.time.milliseconds' call
            tmp = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
          } else if (300.0 <= tmp3_subject ? tmp3_subject <= 1000.0 : false) {
            // Inline function 'korlibs.time.milliseconds' call
            tmp = toDuration(50.0, DurationUnit_MILLISECONDS_getInstance());
          } else {
            // Inline function 'korlibs.time.milliseconds' call
            tmp = toDuration(20.0, DurationUnit_MILLISECONDS_getInstance());
          }
          var timeBarrier = tmp;
          // Inline function 'korlibs.time.nanoseconds' call
          var this_1 = $this.p9p_1[n];
          var tmp$ret$5 = toDuration(this_1, DurationUnit_NANOSECONDS_getInstance());
          var elapsedTime = Duration__minus_impl_q5cfm7(pressingTime, tmp$ret$5);
          if (Duration__compareTo_impl_pchp0f(elapsedTime, timeBarrier) >= 0) {
            triggerPress = true;
          }
        }
        if (triggerPress) {
          $this.p9p_1[n] = $this.o9p_1[n];
        }
        $this.q9p_1[n] = triggerPress;
      }
       while (inductionVariable < 256);
    arraycopy_4($this.m9p_1, 0, $this.n9p_1, 0, 256);
  }
  function Input$_isTouchDeviceGen$lambda() {
    return AGOpenglFactory_instance.ua1();
  }
  function Input() {
    this.z9o_1 = new Mixin();
    this.a9p_1 = Companion_getInstance_28().x7o_1;
    this.b9p_1 = new TouchEvent();
    var tmp = this;
    tmp.c9p_1 = Input$_isTouchDeviceGen$lambda;
    var tmp_0 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_0.d9p_1 = toDuration(400, DurationUnit_MILLISECONDS_getInstance());
    this.e9p_1 = 20.0;
    this.f9p_1 = new Vector2D(-1000.0, -1000.0);
    this.g9p_1 = new Vector2D(-1000.0, -1000.0);
    this.h9p_1 = 0;
    this.i9p_1 = false;
    this.j9p_1 = true;
    this.k9p_1 = false;
    this.l9p_1 = new InputKeys();
    this.m9p_1 = booleanArray(256);
    this.n9p_1 = booleanArray(256);
    this.o9p_1 = new Float64Array(256);
    this.p9p_1 = new Float64Array(256);
    this.q9p_1 = booleanArray(256);
    this.r9p_1 = booleanArray(256);
    this.s9p_1 = booleanArray(256);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.korge.input.Input.gamepads.<anonymous>' call
      var tmp$ret$2 = new GamepadInfo(item);
      destination.r(tmp$ret$2);
    }
    tmp_1.t9p_1 = copyToArray(destination);
    var tmp_2 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_2.u9p_1 = ArrayList_init_$Create$();
  }
  protoOf(Input).h23 = function (_set____db54di) {
    this.z9o_1.h23(_set____db54di);
  };
  protoOf(Input).i23 = function () {
    return this.z9o_1.i23();
  };
  protoOf(Input).k9s = function (touchEvent) {
    this.b9p_1.e7q(touchEvent);
  };
  protoOf(Input).y9p = function () {
    return this.f9p_1;
  };
  protoOf(Input).w9p = function (p, down) {
    if (down)
      this.g9p_1 = p;
    else
      this.f9p_1 = p;
  };
  protoOf(Input).v9p = function (button, down) {
    this.h9p_1 = setBits(this.h9p_1, button.h7u_1, down);
  };
  protoOf(Input).z9p = function () {
    this.u9p_1.b3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.t9p_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.input.Input.updateConnectedGamepads.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var gamepad = this_0[tmp0];
      if (gamepad.p7r_1) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.u9p_1.r(gamepad);
      }
    }
  };
  protoOf(Input).va1 = function (keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this.m9p_1.length - 1 | 0) : false) {
      this.m9p_1[pKeyCode] = b;
    }
  };
  protoOf(Input).ra1 = function (delta) {
    var tmp0_safe_receiver = this.i23();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b3();
    }
    this.l9p_1.ra1(delta);
  };
  protoOf(Input).sa1 = function (delta) {
    this.k9p_1 = false;
    this.l9p_1.sa1(delta);
    endFrameOldKeys(this, delta);
  };
  protoOf(Input).wa1 = function (e) {
    switch (e.n7n_1.ka_1) {
      case 1:
        this.va1(e.q7n_1, true);
        break;
      case 0:
        this.va1(e.q7n_1, false);
        break;
      case 2:
        break;
    }
  };
  function get_keys_0(_this__u8e3s4) {
    _init_properties_KeysEvents_kt__ekyd0z();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var this_0 = keys$delegate;
      var property = keys$factory();
      var tmp0_elvis_lhs = this_0.l23_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = this_0.m23_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = this_0.l23_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var keys$delegate;
  function KeysEvents$lambda$slambda(this$0, $event, resultContinuation) {
    this.fa2_1 = this$0;
    this.ga2_1 = $event;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KeysEvents$lambda$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(KeysEvents$lambda$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(KeysEvents$lambda$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.fa2_1.la2_1.a5p(this.ga2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(KeysEvents$lambda$slambda).g5a = function (completion) {
    return new KeysEvents$lambda$slambda(this.fa2_1, this.ga2_1, completion);
  };
  function KeysEvents$lambda$slambda_0(this$0, $event, resultContinuation) {
    var i = new KeysEvents$lambda$slambda(this$0, $event, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function KeysEvents$lambda(this$0) {
    return function (event) {
      var tmp = this$0;
      var tmp_0 = event.z7m_1;
      tmp.ia2_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
      var tmp_1 = this$0.na2().p9e_1;
      launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_0(this$0, event, null));
      return Unit_instance;
    };
  }
  function KeysEvents$lambda$slambda_1(this$0, $event, resultContinuation) {
    this.wa2_1 = this$0;
    this.xa2_1 = $event;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KeysEvents$lambda$slambda_1).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(KeysEvents$lambda$slambda_1).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(KeysEvents$lambda$slambda_1).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.wa2_1.ja2_1.a5p(this.xa2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(KeysEvents$lambda$slambda_1).g5a = function (completion) {
    return new KeysEvents$lambda$slambda_1(this.wa2_1, this.xa2_1, completion);
  };
  function KeysEvents$lambda$slambda_2(this$0, $event, resultContinuation) {
    var i = new KeysEvents$lambda$slambda_1(this$0, $event, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function KeysEvents$lambda_0(this$0) {
    return function (event) {
      var tmp = this$0;
      var tmp_0 = event.z7m_1;
      tmp.ia2_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
      var tmp_1 = this$0.na2().p9e_1;
      launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event, null));
      return Unit_instance;
    };
  }
  function KeysEvents$lambda$slambda_3(this$0, $event, resultContinuation) {
    this.ga3_1 = this$0;
    this.ha3_1 = $event;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KeysEvents$lambda$slambda_3).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(KeysEvents$lambda$slambda_3).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(KeysEvents$lambda$slambda_3).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.ga3_1.ka2_1.a5p(this.ha3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(KeysEvents$lambda$slambda_3).g5a = function (completion) {
    return new KeysEvents$lambda$slambda_3(this.ga3_1, this.ha3_1, completion);
  };
  function KeysEvents$lambda$slambda_4(this$0, $event, resultContinuation) {
    var i = new KeysEvents$lambda$slambda_3(this$0, $event, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function KeysEvents$lambda_1(this$0) {
    return function (event) {
      var tmp = this$0;
      var tmp_0 = event.z7m_1;
      tmp.ia2_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
      var tmp_1 = this$0.na2().p9e_1;
      launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event, null));
      return Unit_instance;
    };
  }
  function KeysEvents(view) {
    this.ha2_1 = view;
    this.ja2_1 = new AsyncSignal();
    this.ka2_1 = new AsyncSignal();
    this.la2_1 = new AsyncSignal();
    this.ma2_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.ha2_1.h7m(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance();
    this.ha2_1.h7m(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance();
    this.ha2_1.h7m(tmp_1, KeysEvents$lambda_1(this));
  }
  protoOf(KeysEvents).na2 = function () {
    var tmp = this.ia2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  protoOf(KeysEvents).p21 = function () {
    this.ma2_1.p21();
  };
  function keys$delegate$lambda($this$$receiver) {
    _init_properties_KeysEvents_kt__ekyd0z();
    return new KeysEvents($this$$receiver);
  }
  function keys$factory() {
    return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
      return get_keys_0(receiver);
    }, null);
  }
  var properties_initialized_KeysEvents_kt_1mffin;
  function _init_properties_KeysEvents_kt__ekyd0z() {
    if (!properties_initialized_KeysEvents_kt_1mffin) {
      properties_initialized_KeysEvents_kt_1mffin = true;
      keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
    }
  }
  function get_touch(_this__u8e3s4) {
    _init_properties_TouchEvents_kt__159jsq();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var this_0 = touch$delegate;
      var property = touch$factory();
      var tmp0_elvis_lhs = this_0.l23_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = this_0.m23_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = this_0.l23_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var touch$delegate;
  function Info(index, id, local, startLocal, startTime, global, startGlobal, time) {
    index = index === VOID ? -1 : index;
    id = id === VOID ? 0 : id;
    local = local === VOID ? Vector2D_init_$Create$_1() : local;
    startLocal = startLocal === VOID ? Vector2D_init_$Create$_1() : startLocal;
    startTime = startTime === VOID ? Companion_getInstance_1().a1q_1 : startTime;
    global = global === VOID ? Vector2D_init_$Create$_1() : global;
    startGlobal = startGlobal === VOID ? Vector2D_init_$Create$_1() : startGlobal;
    time = time === VOID ? Companion_getInstance_1().a1q_1 : time;
    this.ia3_1 = index;
    this.ja3_1 = id;
    this.ka3_1 = local;
    this.la3_1 = startLocal;
    this.ma3_1 = startTime;
    this.na3_1 = global;
    this.oa3_1 = startGlobal;
    this.pa3_1 = time;
    this.qa3_1 = new Mixin();
  }
  protoOf(Info).h23 = function (_set____db54di) {
    this.qa3_1.h23(_set____db54di);
  };
  protoOf(Info).i23 = function () {
    return this.qa3_1.i23();
  };
  protoOf(Info).sa3 = function () {
    return DateTime__minus_impl_10njw8(this.pa3_1, this.ma3_1);
  };
  protoOf(Info).na2 = function () {
    var tmp = this.ra3_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  protoOf(Info).ta3 = function () {
    return this.ka3_1.g28_1;
  };
  protoOf(Info).ua3 = function () {
    return this.ka3_1.h28_1;
  };
  protoOf(Info).toString = function () {
    return 'Touch[' + this.ja3_1 + '](' + numberToInt(this.ta3()) + ', ' + numberToInt(this.ua3()) + ')';
  };
  protoOf(Info).hashCode = function () {
    var result = this.ia3_1;
    result = imul(result, 31) + this.ja3_1 | 0;
    result = imul(result, 31) + this.ka3_1.hashCode() | 0;
    result = imul(result, 31) + this.la3_1.hashCode() | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.ma3_1) | 0;
    result = imul(result, 31) + this.na3_1.hashCode() | 0;
    result = imul(result, 31) + this.oa3_1.hashCode() | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.pa3_1) | 0;
    return result;
  };
  protoOf(Info).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Info))
      return false;
    var tmp0_other_with_cast = other instanceof Info ? other : THROW_CCE();
    if (!(this.ia3_1 === tmp0_other_with_cast.ia3_1))
      return false;
    if (!(this.ja3_1 === tmp0_other_with_cast.ja3_1))
      return false;
    if (!this.ka3_1.equals(tmp0_other_with_cast.ka3_1))
      return false;
    if (!this.la3_1.equals(tmp0_other_with_cast.la3_1))
      return false;
    if (!equals(this.ma3_1, tmp0_other_with_cast.ma3_1))
      return false;
    if (!this.na3_1.equals(tmp0_other_with_cast.na3_1))
      return false;
    if (!this.oa3_1.equals(tmp0_other_with_cast.oa3_1))
      return false;
    if (!equals(this.pa3_1, tmp0_other_with_cast.pa3_1))
      return false;
    return true;
  };
  function onTouchEvent($this, views, e) {
    $this.fa4_1.b3();
    var now = views.t9e_1.e1q();
    if (e.l7p_1.equals(Type_START_getInstance())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = e.u7p();
      var n = 0;
      while (n < this_0.n()) {
        // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var it = this_0.f1(tmp0);
        if (!it.c7p_1.equals(Status_KEEP_getInstance())) {
          var info = $this.ha4($this.ga4($this.da4_1.z1x(), it));
          info.ma3_1 = now;
          info.ra3_1 = views;
          // Inline function 'korlibs.datastructure.set' call
          var this_1 = $this.ea4_1;
          var key = info.ja3_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_1.set(key, info);
          $this.wa3_1.x5n(info);
        }
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = e.u7p();
    var n_0 = 0;
    while (n_0 < this_2.n()) {
      // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      var it_0 = this_2.f1(tmp0_0);
      // Inline function 'korlibs.datastructure.get' call
      var this_3 = $this.ea4_1;
      var key_0 = it_0.z7o_1;
      // Inline function 'kotlin.js.asDynamic' call
      var info_0 = this_3.get(key_0);
      if (!(info_0 == null)) {
        info_0.pa3_1 = now;
        $this.fa4_1.r($this.ga4(info_0, it_0));
      }
    }
    if (e.l7p_1.equals(Type_START_getInstance())) {
      $this.ya3_1.x5n($this);
    }
    if (e.l7p_1.equals(Type_MOVE_getInstance_0())) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = $this.fa4_1.y1u_1;
      var n_1 = 0;
      while (n_1 < array.length) {
        // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0_1 = n_1;
        n_1 = tmp0_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var it_1 = array[tmp0_1];
        $this.xa3_1.x5n(it_1);
      }
      $this.za3_1.x5n($this);
    }
    if (e.l7p_1.equals(Type_END_getInstance())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_4 = e.u7p();
      var n_2 = 0;
      while (n_2 < this_4.n()) {
        // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
        var tmp0_2 = n_2;
        n_2 = tmp0_2 + 1 | 0;
        var it_2 = this_4.f1(tmp0_2);
        if (!it_2.c7p_1.equals(Status_KEEP_getInstance())) {
          // Inline function 'korlibs.datastructure.get' call
          var this_5 = $this.ea4_1;
          var key_1 = it_2.z7o_1;
          // Inline function 'kotlin.js.asDynamic' call
          var info_1 = this_5.get(key_1);
          if (!(info_1 == null)) {
            $this.ca4_1.x5n($this.ga4(info_1, it_2));
            $this.aa4_1.x5n($this);
            // Inline function 'korlibs.datastructure.remove' call
            var this_6 = $this.ea4_1;
            var key_2 = info_1.ja3_1;
            // Inline function 'kotlin.js.asDynamic' call
            this_6.delete(key_2);
            $this.da4_1.e1y(info_1);
          }
        }
      }
    }
    $this.ba4_1.x5n($this);
  }
  function TouchEvents$infoPool$lambda(it) {
    return new Info(it);
  }
  function TouchEvents$lambda(this$0) {
    return function (e) {
      var tmp = e.z7m_1;
      onTouchEvent(this$0, tmp instanceof Views ? tmp : THROW_CCE(), e);
      return Unit_instance;
    };
  }
  function TouchEvents(view) {
    this.va3_1 = view;
    this.wa3_1 = new Signal();
    this.xa3_1 = new Signal();
    this.ya3_1 = new Signal();
    this.za3_1 = new Signal();
    this.aa4_1 = new Signal();
    this.ba4_1 = new Signal();
    this.ca4_1 = new Signal();
    var tmp = this;
    tmp.da4_1 = Pool_init_$Create$(VOID, TouchEvents$infoPool$lambda);
    this.ea4_1 = FastIntMap();
    this.fa4_1 = FastArrayList_init_$Create$();
    var tmp_0 = Companion_getInstance_29().h7p_1.slice();
    this.va3_1.t7m(tmp_0, TouchEvents$lambda(this));
  }
  protoOf(TouchEvents).ga4 = function (_this__u8e3s4, touch) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.TouchEvents.copyFrom.<anonymous>' call
    _this__u8e3s4.ja3_1 = touch.z7o_1;
    _this__u8e3s4.na3_1 = touch.a7p_1;
    _this__u8e3s4.ka3_1 = this.va3_1.ia4(touch.a7p_1);
    return _this__u8e3s4;
  };
  protoOf(TouchEvents).ha4 = function (_this__u8e3s4) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.TouchEvents.start.<anonymous>' call
    _this__u8e3s4.la3_1 = _this__u8e3s4.ka3_1;
    _this__u8e3s4.oa3_1 = _this__u8e3s4.na3_1;
    return _this__u8e3s4;
  };
  function singleTouch(_this__u8e3s4, removeTouch, supportStartAnywhere, block) {
    removeTouch = removeTouch === VOID ? false : removeTouch;
    supportStartAnywhere = supportStartAnywhere === VOID ? false : supportStartAnywhere;
    _init_properties_TouchEvents_kt__159jsq();
    var ids = FastIntMap();
    touch(_this__u8e3s4, singleTouch$lambda(_this__u8e3s4, supportStartAnywhere, ids, block, removeTouch));
  }
  function SingleTouchHandler() {
    this.ja4_1 = new Signal();
    this.ka4_1 = new Signal();
    this.la4_1 = new Signal();
    this.ma4_1 = new Signal();
    this.na4_1 = new Signal();
    this.oa4_1 = new Signal();
    this.pa4_1 = new Signal();
    this.qa4_1 = new Signal();
  }
  function touch(_this__u8e3s4, block) {
    _init_properties_TouchEvents_kt__159jsq();
    return block(get_touch(_this__u8e3s4));
  }
  function singleTouch$getById(ids, $block, id) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = ids.get(id);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.input.singleTouch.getById.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_0 = new singleTouch$SingleTouchInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.input.singleTouch.getById.<anonymous>.<anonymous>' call
      $block(this_0.ra4_1, id);
      var out = this_0;
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.js.asDynamic' call
      ids.set(id, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  function touch$delegate$lambda($this$$receiver) {
    _init_properties_TouchEvents_kt__159jsq();
    return new TouchEvents($this$$receiver);
  }
  function singleTouch$SingleTouchInfo(handler, startedInside) {
    handler = handler === VOID ? new SingleTouchHandler() : handler;
    startedInside = startedInside === VOID ? false : startedInside;
    this.ra4_1 = handler;
    this.sa4_1 = startedInside;
  }
  protoOf(singleTouch$SingleTouchInfo).toString = function () {
    return 'SingleTouchInfo(handler=' + this.ra4_1 + ', startedInside=' + this.sa4_1 + ')';
  };
  protoOf(singleTouch$SingleTouchInfo).hashCode = function () {
    var result = hashCode(this.ra4_1);
    result = imul(result, 31) + getBooleanHashCode(this.sa4_1) | 0;
    return result;
  };
  protoOf(singleTouch$SingleTouchInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof singleTouch$SingleTouchInfo))
      return false;
    var tmp0_other_with_cast = other instanceof singleTouch$SingleTouchInfo ? other : THROW_CCE();
    if (!equals(this.ra4_1, tmp0_other_with_cast.ra4_1))
      return false;
    if (!(this.sa4_1 === tmp0_other_with_cast.sa4_1))
      return false;
    return true;
  };
  function singleTouch$lambda$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block) {
    return function (it) {
      var info = singleTouch$getById($ids, $block, it.ja3_1);
      var handler = info.ra4_1;
      info.sa4_1 = !($this_singleTouch.ta4(it.na3_1) == null);
      var tmp;
      if (handler.ja4_1.c5o() ? info.sa4_1 : false) {
        handler.ja4_1.x5n(it);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($supportStartAnywhere) {
        handler.ka4_1.x5n(it);
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function singleTouch$lambda$lambda_0($supportStartAnywhere, $this_singleTouch, $ids, $block) {
    return function (it) {
      var info = singleTouch$getById($ids, $block, it.ja3_1);
      var tmp;
      if (!$supportStartAnywhere ? !info.sa4_1 : false) {
        return Unit_instance;
      }
      var handler = info.ra4_1;
      var tmp_0;
      if (handler.la4_1.c5o() ? !($this_singleTouch.ta4(it.na3_1) == null) : false) {
        handler.la4_1.x5n(it);
        tmp_0 = Unit_instance;
      }
      handler.ma4_1.x5n(it);
      return Unit_instance;
    };
  }
  function singleTouch$lambda$lambda_1($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block) {
    return function (it) {
      var info = singleTouch$getById($ids, $block, it.ja3_1);
      var tmp;
      if (!$supportStartAnywhere ? !info.sa4_1 : false) {
        return Unit_instance;
      }
      var handler = info.ra4_1;
      var hitTest = (handler.na4_1.c5o() ? true : handler.pa4_1.c5o()) ? !($this_singleTouch.ta4(it.na3_1) == null) : false;
      var tmp_0;
      if (hitTest) {
        handler.na4_1.x5n(it);
        tmp_0 = Unit_instance;
      }
      handler.oa4_1.x5n(it);
      var tmp_1;
      if (Companion_getInstance_0().c2n(it.oa3_1, it.na3_1) <= it.na2().s9e_1.e9p_1 ? Duration__compareTo_impl_pchp0f(it.sa3(), it.na2().s9e_1.d9p_1) <= 0 : false) {
        if (info.sa4_1 ? hitTest : false) {
          handler.pa4_1.x5n(it);
        }
        handler.qa4_1.x5n(it);
        tmp_1 = Unit_instance;
      }
      var tmp_2;
      if ($removeTouch) {
        var this_0 = $ids;
        var key = it.ja3_1;
        // Inline function 'kotlin.js.asDynamic' call
        tmp_2 = this_0.delete(key);
      }
      return Unit_instance;
    };
  }
  function singleTouch$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block, $removeTouch) {
    return function ($this$touch) {
      $this$touch.wa3_1.w5n(singleTouch$lambda$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block));
      $this$touch.xa3_1.w5n(singleTouch$lambda$lambda_0($supportStartAnywhere, $this_singleTouch, $ids, $block));
      $this$touch.ca4_1.w5n(singleTouch$lambda$lambda_1($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block));
      return Unit_instance;
    };
  }
  function touch$factory() {
    return getPropertyCallableRef('touch', 1, KProperty1, function (receiver) {
      return get_touch(receiver);
    }, null);
  }
  var properties_initialized_TouchEvents_kt_a232zc;
  function _init_properties_TouchEvents_kt__159jsq() {
    if (!properties_initialized_TouchEvents_kt_a232zc) {
      properties_initialized_TouchEvents_kt_a232zc = true;
      touch$delegate = new PropertyThis(VOID, touch$delegate$lambda);
    }
  }
  function DefaultViewport() {
    DefaultViewport_instance = this;
    this.x9c_1 = 1280;
    this.y9c_1 = 720;
    this.z9c_1 = Size2D_init_$Create$(1280, 720);
  }
  var DefaultViewport_instance;
  function DefaultViewport_getInstance() {
    if (DefaultViewport_instance == null)
      new DefaultViewport();
    return DefaultViewport_instance;
  }
  function configureLoggerFromProperties(file, $completion) {
    var tmp = new $configureLoggerFromPropertiesCOROUTINE$3(file, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function configureLoggerFromProperties_0(str) {
    var props = Companion_instance_72.da5(str);
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = props.k2().u();
    while (tmp0_iterator.v()) {
      var tmp1_loop_parameter = tmp0_iterator.x();
      // Inline function 'kotlin.collections.component1' call
      var key = tmp1_loop_parameter.l2();
      // Inline function 'kotlin.collections.component2' call
      var value = tmp1_loop_parameter.m2();
      try {
        var tmp = Companion_getInstance_2().r24(key);
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$4 = value.toUpperCase();
        tmp.y24(valueOf(tmp$ret$4));
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
    }
  }
  function Companion_58() {
  }
  protoOf(Companion_58).da5 = function (str) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Props();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.logger.Companion.load.<anonymous>' call
    this_0.fa5(str);
    return this_0;
  };
  var Companion_instance_72;
  function Companion_getInstance_84() {
    return Companion_instance_72;
  }
  function Props(props) {
    props = props === VOID ? LinkedHashMap_init_$Create$_0() : props;
    this.ea5_1 = props;
  }
  protoOf(Props).k2 = function () {
    return this.ea5_1.k2();
  };
  protoOf(Props).g2 = function () {
    return this.ea5_1.g2();
  };
  protoOf(Props).n = function () {
    return this.ea5_1.n();
  };
  protoOf(Props).h2 = function () {
    return this.ea5_1.h2();
  };
  protoOf(Props).b3 = function () {
    this.ea5_1.b3();
  };
  protoOf(Props).r13 = function (key) {
    return this.ea5_1.p2(key);
  };
  protoOf(Props).p2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.r13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(Props).s13 = function (key) {
    return this.ea5_1.s2(key);
  };
  protoOf(Props).s2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.s13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(Props).b1 = function () {
    return this.ea5_1.b1();
  };
  protoOf(Props).ga5 = function (key, value) {
    return this.ea5_1.i2(key, value);
  };
  protoOf(Props).i2 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.ga5(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(Props).r1t = function (key) {
    return this.ea5_1.j2(key);
  };
  protoOf(Props).j2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.r1t((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(Props).ha5 = function (str) {
    var tmp0_iterator = split(str, ['\n']).u();
    $l$loop_0: while (tmp0_iterator.v()) {
      var line = tmp0_iterator.x();
      if (startsWith(line, _Char___init__impl__6a9atx(35)))
        continue $l$loop_0;
      if (isBlank(line))
        continue $l$loop_0;
      var parts = split_0(line, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      // Inline function 'kotlin.text.trim' call
      var this_0 = parts.f1(0);
      var key = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.collections.getOrElse' call
      var tmp;
      if (1 >= 0 ? 1 <= get_lastIndex_1(parts) : false) {
        tmp = parts.f1(1);
      } else {
        // Inline function 'korlibs.korge.logger.Props.deserializeAdd.<anonymous>' call
        tmp = ' ';
      }
      var this_1 = tmp;
      var value = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.set' call
      this.ea5_1.i2(key, value);
    }
  };
  protoOf(Props).fa5 = function (str) {
    this.b3();
    this.ha5(str);
  };
  function $configureLoggerFromPropertiesCOROUTINE$3(file, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ca5_1 = file;
  }
  protoOf($configureLoggerFromPropertiesCOROUTINE$3).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.ca5_1.f40(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            configureLoggerFromProperties_0(ARGUMENT);
            this.gd_1 = 3;
            this.fd_1 = 4;
            continue $sm;
          case 2:
            this.gd_1 = 3;
            var tmp_0 = this.id_1;
            if (tmp_0 instanceof Error) {
              var e = this.id_1;
              this.fd_1 = 4;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 3:
            throw this.id_1;
          case 4:
            this.gd_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 3) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  function Entry_0(closeable) {
    closeable = closeable === VOID ? null : closeable;
    this.ia5_1 = closeable;
  }
  protoOf(Entry_0).ja5 = function () {
    var tmp0_safe_receiver = this.ia5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p21();
    }
    this.ia5_1 = null;
  };
  protoOf(Entry_0).n1y = function () {
    this.ia5_1 = null;
  };
  function AgAutoFreeManager$entryPool$lambda(it) {
    it.n1y();
    return Unit_instance;
  }
  function AgAutoFreeManager$entryPool$lambda_0(it) {
    return new Entry_0();
  }
  function AgAutoFreeManager() {
    var tmp = this;
    var tmp_0 = AgAutoFreeManager$entryPool$lambda;
    tmp.ka5_1 = new Pool(tmp_0, VOID, AgAutoFreeManager$entryPool$lambda_0);
    this.la5_1 = FastIdentityMap();
    this.ma5_1 = fastArrayListOf([]);
    this.na5_1 = 0;
    this.oa5_1 = 60;
  }
  protoOf(AgAutoFreeManager).pa5 = function (closeable) {
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.la5_1;
      var res = get(this_0, closeable);
      if (!(res == null)) {
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.ka5_1.z1x();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>.<anonymous>' call
      this_1.ia5_1 = closeable;
      var out = this_1;
      set(this_0, closeable, out);
    }
  };
  protoOf(AgAutoFreeManager).qa5 = function () {
    this.na5_1 = this.na5_1 + 1 | 0;
    if (this.na5_1 >= this.oa5_1) {
      this.na5_1 = 0;
      this.ra5();
    }
  };
  protoOf(AgAutoFreeManager).ra5 = function () {
    var tmp0_iterator = this.ma5_1.u();
    while (tmp0_iterator.v()) {
      var entry = tmp0_iterator.x();
      if (!contains_0(this.la5_1, entry.ia5_1)) {
        var tmp1_safe_receiver = entry.ia5_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.p21();
        }
        this.ka5_1.e1y(entry);
      }
    }
    this.ma5_1.b3();
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.la5_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.gc.<anonymous>' call
      var it_0 = ensureNotNull(get(this_0, it));
      this.ma5_1.r(it_0);
    }
    clear(this.la5_1);
  };
  protoOf(AgAutoFreeManager).p21 = function () {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.ma5_1.y1u_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      array[tmp0].ja5();
    }
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.la5_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      ensureNotNull(get(this_0, it)).ja5();
    }
    this.ma5_1.b3();
    this.ka5_1.b3();
    clear(this.la5_1);
  };
  function BitmapTextureInfo() {
    this.sa5_1 = 0;
    this.ta5_1 = TextureBase_init_$Create$(null, 0, 0);
    this.ua5_1 = FastIdentityMap();
  }
  protoOf(BitmapTextureInfo).n1y = function () {
    this.sa5_1 = 0;
    this.ta5_1.va5_1 = null;
    this.ta5_1.xa5_1 = -1;
    this.ta5_1.ya5(0);
    this.ta5_1.za5(0);
    clear(this.ua5_1);
  };
  protoOf(BitmapTextureInfo).toString = function () {
    return 'BitmapTextureInfo(textureBase=' + this.ta5_1 + ', usedMemory=' + this.sa5_1 + ', slices=' + get_size_0(this.ua5_1) + ')';
  };
  function getTextureInfo($this, bitmap) {
    if ($this.ja6_1 === bitmap ? ensureNotNull($this.ka6_1).ta5_1.xa5_1 === bitmap.d3a_1 : false)
      return ensureNotNull($this.ka6_1);
    if ($this.la6_1 === bitmap ? ensureNotNull($this.ma6_1).ta5_1.xa5_1 === bitmap.d3a_1 : false)
      return ensureNotNull($this.ma6_1);
    $this.da6_1.p1v(bitmap);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = $this.ia6_1;
      var res = get(this_0, bitmap);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = $this.ha6_1.z1x();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>.<anonymous>' call
      var base = this_1.ta5_1;
      base.xa5_1 = -1;
      var tmp = base;
      var tmp_0;
      if (bitmap instanceof MultiBitmap) {
        tmp_0 = Companion_getInstance_64().m80_1;
      } else {
        tmp_0 = Companion_getInstance_64().k80_1;
      }
      tmp.va5_1 = new AGTexture(tmp_0);
      base.ya5(bitmap.t39_1);
      base.za5(bitmap.u39_1);
      var out = this_1;
      set(this_0, bitmap, out);
      tmp$ret$0 = out;
    }
    var textureInfo = tmp$ret$0;
    $this.la6_1 = $this.ja6_1;
    $this.ma6_1 = $this.ka6_1;
    var base_0 = textureInfo.ta5_1;
    $this.ja6_1 = bitmap;
    $this.ka6_1 = textureInfo;
    if (!(bitmap.d3a_1 === base_0.xa5_1)) {
      base_0.xa5_1 = bitmap.d3a_1;
      var tmp_1 = $this;
      // Inline function 'kotlin.Long.minus' call
      var this_2 = $this.ga6_1;
      var other = textureInfo.sa5_1;
      tmp_1.ga6_1 = this_2.cb(toLong(other));
      try {
        base_0.sa6(bitmap, bitmap.f3a_1, get_baseMipmapLevel(bitmap), get_maxMipmapLevel(bitmap));
      }finally {
        textureInfo.sa5_1 = _get_estimateSizeInBytes__tshb4c(bitmap, $this);
        var tmp_2 = $this;
        // Inline function 'kotlin.Long.plus' call
        var this_3 = $this.ga6_1;
        var other_0 = textureInfo.sa5_1;
        tmp_2.ga6_1 = this_3.mc(toLong(other_0));
      }
      bitmap.f3b();
    }
    return textureInfo;
  }
  function _get_estimateSizeInBytes__tshb4c(_this__u8e3s4, $this) {
    return imul(_this__u8e3s4.u39_1, imul(_this__u8e3s4.t39_1, _this__u8e3s4.v39_1) / 8 | 0);
  }
  function _getTexture($this, slice) {
    if ($this.na6_1 === slice)
      return ensureNotNull($this.oa6_1);
    if ($this.pa6_1 === slice)
      return ensureNotNull($this.qa6_1);
    var info = getTextureInfo($this, slice.v2x());
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = info.ua5_1;
      var res = get(this_0, slice);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager._getTexture.<anonymous>' call
      var tmp;
      if (slice instanceof RectSlice) {
        tmp = Texture_1(info.ta5_1).f2y(new RectangleI(slice.r2d(), slice.t2d(), slice.x1q(), slice.y1q()));
      } else {
        tmp = Companion_instance_7.t2y(info.ta5_1, slice);
      }
      var out = tmp;
      set(this_0, slice, out);
      tmp$ret$0 = out;
    }
    var texture = tmp$ret$0;
    $this.pa6_1 = $this.na6_1;
    $this.qa6_1 = $this.oa6_1;
    $this.na6_1 = slice;
    $this.oa6_1 = texture;
    return texture;
  }
  function clearFastCacheAccess($this) {
    $this.ja6_1 = null;
    $this.ka6_1 = null;
    $this.la6_1 = null;
    $this.ma6_1 = null;
    $this.na6_1 = null;
    $this.oa6_1 = null;
    $this.pa6_1 = null;
    $this.qa6_1 = null;
  }
  function AgBitmapTextureManager$textureInfoPool$lambda(it) {
    it.n1y();
    return Unit_instance;
  }
  function AgBitmapTextureManager$textureInfoPool$lambda_0(it) {
    return new BitmapTextureInfo();
  }
  function AgBitmapTextureManager(ag) {
    this.aa6_1 = ag;
    this.ba6_1 = new Long(0, 0);
    this.ca6_1 = new FastSmallSet();
    this.da6_1 = new FastSmallSet();
    this.ea6_1 = FastArrayList_init_$Create$();
    this.fa6_1 = 60;
    this.ga6_1 = new Long(0, 0);
    var tmp = this;
    var tmp_0 = AgBitmapTextureManager$textureInfoPool$lambda;
    tmp.ha6_1 = new Pool(tmp_0, VOID, AgBitmapTextureManager$textureInfoPool$lambda_0);
    this.ia6_1 = FastIdentityMap();
    this.ja6_1 = null;
    this.ka6_1 = null;
    this.la6_1 = null;
    this.ma6_1 = null;
    this.na6_1 = null;
    this.oa6_1 = null;
    this.pa6_1 = null;
    this.qa6_1 = null;
    this.ra6_1 = 0;
  }
  protoOf(AgBitmapTextureManager).ta6 = function () {
    return this.ca6_1.n();
  };
  protoOf(AgBitmapTextureManager).ua6 = function () {
    return this.da6_1.n();
  };
  protoOf(AgBitmapTextureManager).va6 = function () {
    return this.ea6_1.n();
  };
  protoOf(AgBitmapTextureManager).toString = function () {
    return this.wa6();
  };
  protoOf(AgBitmapTextureManager).wa6 = function () {
    return 'AgBitmapTextureManager(numCachedBitmaps=' + this.ta6() + ', numReferencedBitmapsSinceGC=' + this.ua6() + ', numReferencedBitmaps=' + this.va6() + ', maxCachedMemory=' + new ByteUnits(Companion_getInstance_3().y37(this.ba6_1)) + ', managedTextureMemory=' + new ByteUnits(Companion_getInstance_3().y37(this.ga6_1)) + ')';
  };
  protoOf(AgBitmapTextureManager).xa6 = function (bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap).ta5_1);
  };
  protoOf(AgBitmapTextureManager).ya6 = function (slice) {
    var tmp = _getTexture(this, slice);
    return tmp instanceof RectSlice ? tmp : THROW_CCE();
  };
  protoOf(AgBitmapTextureManager).za6 = function (slice) {
    return _getTexture(this, slice);
  };
  protoOf(AgBitmapTextureManager).qa5 = function () {
    clearFastCacheAccess(this);
    this.ra6_1 = this.ra6_1 + 1 | 0;
    if (this.ra6_1 >= this.fa6_1) {
      this.ra6_1 = 0;
      this.ra5();
    }
  };
  protoOf(AgBitmapTextureManager).ra5 = function () {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.ea6_1.y1u_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var bmp = array[tmp0];
      if (!this.da6_1.pf(bmp))
        if (this.ba6_1.t6(this.ga6_1) < 0 ? true : this.ga6_1.t6(new Long(0, 0)) < 0) {
          this.aa7(bmp, 'GC');
        } else {
          this.ca6_1.p1v(bmp);
        }
    }
    this.ea6_1.b3();
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.da6_1.l1v_1.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.ea6_1.r(element);
    }
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.ca6_1.l1v_1.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.x();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.ea6_1.r(element_0);
    }
    this.da6_1.b3();
  };
  protoOf(AgBitmapTextureManager).aa7 = function (bmp, reason) {
    var tmp0_elvis_lhs = getAndRemove(this.ia6_1, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp_0 = this;
    // Inline function 'kotlin.Long.minus' call
    var this_0 = this.ga6_1;
    var other = info.sa5_1;
    tmp_0.ga6_1 = this_0.cb(toLong(other));
    this.da6_1.q1v(bmp);
    if (this.ka6_1 === info ? true : this.ma6_1 === info) {
      clearFastCacheAccess(this);
    }
    info.ta5_1.p21();
    this.ha6_1.e1y(info);
    this.ca6_1.q1v(bmp);
  };
  protoOf(AgBitmapTextureManager).p21 = function () {
    clearFastCacheAccess(this);
    var tmp0_iterator = toList(get_keys(this.ia6_1)).u();
    while (tmp0_iterator.v()) {
      var bmp = tmp0_iterator.x();
      this.aa7(bmp, 'close');
    }
    clear(this.ia6_1);
    this.ea6_1.b3();
    this.da6_1.b3();
    this.ca6_1.b3();
    this.ha6_1.b3();
  };
  function removeCache($this) {
  }
  function AgBufferManager$bufferPool$lambda(it) {
    return new AGBuffer();
  }
  function AgBufferManager(ag) {
    this.ba7_1 = ag;
    this.ca7_1 = FastIdentityMap();
    this.da7_1 = new FastSmallSet();
    var tmp = this;
    tmp.ea7_1 = Pool_init_$Create$(VOID, AgBufferManager$bufferPool$lambda);
    this.fa7_1 = 0;
    this.ga7_1 = 60;
    this.ha7_1 = Buffer_init_$Create$(0);
  }
  protoOf(AgBufferManager).ia7 = function (cached) {
    this.da7_1.p1v(cached);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.ca7_1;
      var res = get(this_0, cached);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.ea7_1.z1x();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>.<anonymous>' call
      this_1.c7y(cached.ja7_1);
      var out = this_1;
      set(this_0, cached, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  };
  protoOf(AgBufferManager).qa5 = function () {
    removeCache(this);
    this.fa7_1 = this.fa7_1 + 1 | 0;
    if (this.fa7_1 >= this.ga7_1) {
      this.fa7_1 = 0;
      this.ra5();
    }
  };
  protoOf(AgBufferManager).ra5 = function () {
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.da7_1.l1v_1.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBufferManager.gc.<anonymous>' call
      this.ka7(element);
    }
    this.da7_1.b3();
  };
  protoOf(AgBufferManager).la7 = function (buffer) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < buffer.n()) {
      // Inline function 'korlibs.korge.render.AgBufferManager.delete.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = buffer.f1(tmp0);
      this.ka7(it);
    }
  };
  protoOf(AgBufferManager).ka7 = function (buffer) {
    var buf = getAndRemove(this.ca7_1, buffer);
    if (buf == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      buf.c7y(this.ha7_1);
      this.ea7_1.e1y(buf);
    }
  };
  function AgCachedBuffer(data) {
    this.ja7_1 = data;
  }
  function get_logger() {
    _init_properties_BatchBuilder2D_kt__vdn94j();
    return logger_0;
  }
  var logger_0;
  function get_BB_MAX_TEXTURES() {
    _init_properties_BatchBuilder2D_kt__vdn94j();
    return BB_MAX_TEXTURES;
  }
  var BB_MAX_TEXTURES;
  function BatchBuilder2D$Companion$createTextureLookup$lambda($$this$apply) {
    return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
      $this$IF_ELSE_BINARY_LOOKUP.y89($this$IF_ELSE_BINARY_LOOKUP.b8a(), $this$IF_ELSE_BINARY_LOOKUP.j8a(Companion_getInstance_85().n9c_1[n], $this$IF_ELSE_BINARY_LOOKUP.h8a($$this$apply.u89(), 'xy')));
      return Unit_instance;
    };
  }
  function BatchBuffers() {
    this.ma7_1 = new AGBuffer();
    this.na7_1 = new AGBuffer();
    this.oa7_1 = new AGBuffer();
    this.pa7_1 = AGVertexArrayObject_init_$Create$([new AGVertexData(Companion_getInstance_85().u9c_1, this.ma7_1), new AGVertexData(Companion_getInstance_85().v9c_1, this.na7_1)], false);
  }
  function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 0 | 0, i0);
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 1 | 0, i1);
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 2 | 0, i2);
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 3 | 0, i3);
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 4 | 0, i4);
    Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 5 | 0, i5);
    return 6;
  }
  function applyMatrix($this, matrix, idx, vcount) {
    var f32 = get_f32($this.b9z_1);
    var idx_0 = idx;
    var ma = matrix.j2f_1;
    var mb = matrix.k2f_1;
    var mc = matrix.l2f_1;
    var md = matrix.m2f_1;
    var mtx = matrix.n2f_1;
    var mty = matrix.o2f_1;
    var inductionVariable = 0;
    if (inductionVariable < vcount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var p = Vector2D_init_$Create$(Float32Buffer__get_impl_659lhu(f32, idx_0 + 0 | 0), Float32Buffer__get_impl_659lhu(f32, idx_0 + 1 | 0));
        var pt = Companion_getInstance_14().r2f(ma, mb, mc, md, mtx, mty, p);
        Float32Buffer__set_impl_34szne(f32, idx_0 + 0 | 0, pt.g28_1);
        Float32Buffer__set_impl_34szne(f32, idx_0 + 1 | 0, pt.h28_1);
        idx_0 = idx_0 + get_VERTEX_INDEX_SIZE() | 0;
      }
       while (inductionVariable < vcount);
  }
  function checkAvailable($this, indices, vertices) {
    return ($this.h9z_1 + indices | 0) < $this.a9z_1 ? ($this.g9z_1 + vertices | 0) < $this.z9y_1 : false;
  }
  function Companion_59() {
    Companion_instance_73 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = get_BB_MAX_TEXTURES();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var tmp_4 = 'u_Tex' + tmp_3;
      tmp_2[tmp_3] = new Sampler(tmp_4, 3 + tmp_3 | 0, SamplerVarType_Sampler2D_getInstance());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.n9c_1 = tmp_2;
    this.o9c_1 = 16383;
    this.p9c_1 = 8192;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_5;
    if (this_0.f25(level)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$2 = 'BatchBuilder2D.Companion[0]';
      this_0.g25(level, tmp$ret$2);
      tmp_5 = Unit_instance;
    }
    this.q9c_1 = Attribute_init_$Create$('a_Col2', VarType_UByte4_getInstance(), true, VOID, 3);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_6;
    if (this_1.f25(level_0)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$4 = 'BatchBuilder2D.Companion[1]';
      this_1.g25(level_0, tmp$ret$4);
      tmp_6 = Unit_instance;
    }
    this.r9c_1 = Varying_init_$Create$('v_Col2', VarType_Float4_getInstance());
    this.s9c_1 = Attribute_init_$Create$('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance(), 4);
    this.t9c_1 = Varying_init_$Create$('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_2.f25(level_1)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$6 = 'BatchBuilder2D.Companion[2]';
      this_2.g25(level_1, tmp$ret$6);
      tmp_7 = Unit_instance;
    }
    this.u9c_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l86_1, DefaultShaders_getInstance().m86_1, this.qa7(), this.q9c_1]);
    this.v9c_1 = ProgramLayout_init_$Create$([this.s9c_1]);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_8;
    if (this_3.f25(level_2)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$8 = 'BatchBuilder2D.Companion[3]';
      this_3.g25(level_2, tmp$ret$8);
      tmp_8 = Unit_instance;
    }
    var tmp_9 = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_4 = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    this_4.y89(this_4.u89(), this_4.v89());
    this_4.y89(Companion_getInstance_85().t9c_1, Companion_getInstance_85().s9c_1);
    this_4.y89(Companion_getInstance_85().ra7(), this_4.f8a([this_4.c8a(this_4.h8a(Companion_getInstance_85().qa7(), 'rgb'), this_4.h8a(Companion_getInstance_85().qa7(), 'a')), this_4.h8a(Companion_getInstance_85().qa7(), 'a')]));
    this_4.y89(Companion_getInstance_85().r9c_1, Companion_getInstance_85().q9c_1);
    this_4.y89(this_4.b8a(), this_4.c8a(this_4.c8a(this_4.d89(), this_4.e89()), this_4.f8a([this_4.d8a(), this_4.e8a(0.0), this_4.e8a(1.0)])));
    var tmp_10 = VertexShader(this_4.g8a());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_5 = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    Companion_getInstance_85().sa7(this_5);
    this_5.y89(this_5.b8a(), this_5.c8a(this_5.b8a(), Companion_getInstance_85().ra7()));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_5.a8c(this_5.h8a(this_5.b8a(), 'a'), this_5.e8a(0.0));
    var body = this_5.o8a();
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>.<anonymous>' call
    body.e8b();
    var stmIf = new If(cond, body.q8a());
    // Inline function 'kotlin.collections.plusAssign' call
    this_5.x89_1.r(stmIf);
    var tmp$ret$14 = FragmentShader(this_5.g8a());
    tmp_9.w9c_1 = new Program(tmp_10, tmp$ret$14, 'BatchBuilder2D.Tinted');
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_11;
    if (this_6.f25(level_3)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D.Companion[4]';
      this_6.g25(level_3, tmp$ret$15);
      tmp_11 = Unit_instance;
    }
  }
  protoOf(Companion_59).qa7 = function () {
    return DefaultShaders_getInstance().n86_1;
  };
  protoOf(Companion_59).ra7 = function () {
    return DefaultShaders_getInstance().p86_1;
  };
  protoOf(Companion_59).sa7 = function (builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.createTextureLookup.<anonymous>' call
    var tmp = Companion_getInstance_85().t9c_1;
    var tmp_0 = get_BB_MAX_TEXTURES() - 1 | 0;
    builder.c8b(tmp, 0, tmp_0, BatchBuilder2D$Companion$createTextureLookup$lambda(builder));
  };
  var Companion_instance_73;
  function Companion_getInstance_85() {
    if (Companion_instance_73 == null)
      new Companion_59();
    return Companion_instance_73;
  }
  function BatchBuilder2D$lambda(this$0) {
    return function (it) {
      var tmp0 = it.ka_1;
      var tmp;
      if (tmp0 === 0) {
        this$0.ua7();
        tmp = Unit_instance;
      } else if (tmp0 === 1) {
        this$0.ta7();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BatchBuilder2D$buffers$lambda(it) {
    return new BatchBuffers();
  }
  function BatchBuilder2D(ctx, reqMaxQuads) {
    Companion_getInstance_85();
    reqMaxQuads = reqMaxQuads === VOID ? Companion_getInstance_85().p9c_1 : reqMaxQuads;
    this.t9y_1 = ctx;
    this.u9y_1 = reqMaxQuads;
    this.v9y_1 = get_BB_MAX_TEXTURES();
    var tmp = this;
    // Inline function 'kotlin.math.min' call
    var a = this.u9y_1;
    var b = Companion_getInstance_85().o9c_1;
    tmp.w9y_1 = Math.min(a, b);
    this.x9y_1 = this.t9y_1.g9t_1;
    this.y9y_1 = this.t9y_1.m9s_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_0;
    if (this_0.f25(level)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$1 = 'BatchBuilder2D[0]';
      this_0.g25(level, tmp$ret$1);
      tmp_0 = Unit_instance;
    }
    this.t9y_1.i9t_1.q5n(BatchBuilder2D$lambda(this));
    this.z9y_1 = imul(this.w9y_1, 4);
    this.a9z_1 = imul(this.w9y_1, 6);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.f25(level_0)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$3 = 'BatchBuilder2D[1]';
      this_1.g25(level_0, tmp$ret$3);
      tmp_1 = Unit_instance;
    }
    this.b9z_1 = Buffer_init_$Create$(imul(24, this.z9y_1));
    this.c9z_1 = new Int8Array(this.z9y_1);
    this.d9z_1 = Buffer_init_$Create$(imul(2, this.a9z_1));
    this.e9z_1 = get_u16(this.d9z_1);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.f25(level_1)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$5 = 'BatchBuilder2D[2]';
      this_2.g25(level_1, tmp$ret$5);
      tmp_2 = Unit_instance;
    }
    this.f9z_1 = 0;
    this.g9z_1 = 0;
    this.h9z_1 = 0;
    this.i9z_1 = 0;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = this.v9y_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_6 = fillArrayVal(Array(tmp_5), null);
    while (tmp_4 < tmp_5) {
      tmp_6[tmp_4] = null;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.j9z_1 = tmp_6;
    this.k9z_1 = false;
    this.l9z_1 = Companion_getInstance_90().z9x_1;
    this.m9z_1 = Companion_getInstance_85().w9c_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.f25(level_2)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$9 = 'BatchBuilder2D[3]';
      this_3.g25(level_2, tmp$ret$9);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    tmp_8.n9z_1 = new ReturnablePool(VOID, BatchBuilder2D$buffers$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_4 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_9;
    if (this_4.f25(level_3)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$11 = 'BatchBuilder2D[4]';
      this_4.g25(level_3, tmp$ret$11);
      tmp_9 = Unit_instance;
    }
    this.o9z_1 = Companion_getInstance_55().m7v_1;
    this.p9z_1 = Companion_getInstance_56().o7v_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_5 = get_logger();
    var level_4 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_5.f25(level_4)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$13 = 'BatchBuilder2D[5]';
      this_5.g25(level_4, tmp$ret$13);
      tmp_10 = Unit_instance;
    }
    this.q9z_1 = _AGColorMask___init__impl__j38ai8_1();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_5 = Level_TRACE_getInstance();
    var tmp_11;
    if (this_6.f25(level_5)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D[6]';
      this_6.g25(level_5, tmp$ret$15);
      tmp_11 = Unit_instance;
    }
    this.r9z_1 = Companion_getInstance_58().a7w_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_7 = get_logger();
    var level_6 = Level_TRACE_getInstance();
    var tmp_12;
    if (this_7.f25(level_6)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$17 = 'BatchBuilder2D[7]';
      this_7.g25(level_6, tmp$ret$17);
      tmp_12 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_8 = get_logger();
    var level_7 = Level_TRACE_getInstance();
    var tmp_13;
    if (this_8.f25(level_7)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$19 = 'BatchBuilder2D[11]';
      this_8.g25(level_7, tmp$ret$19);
      tmp_13 = Unit_instance;
    }
    this.s9z_1 = new Signal();
    this.t9z_1 = new Signal();
    this.u9z_1 = fastArrayListOf([]);
    this.v9z_1 = 0;
    this.w9z_1 = 0;
    this.x9z_1 = 0;
  }
  protoOf(BatchBuilder2D).va7 = function () {
    return this.t9y_1.b9t_1;
  };
  protoOf(BatchBuilder2D).wa7 = function (value) {
    this.f9z_1 = value;
  };
  protoOf(BatchBuilder2D).xa7 = function () {
    return this.f9z_1;
  };
  protoOf(BatchBuilder2D).ya7 = function () {
    var inductionVariable = 0;
    var last = this.v9y_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.j9z_1[n] = null;
      }
       while (inductionVariable < last);
    this.i9z_1 = 0;
  };
  protoOf(BatchBuilder2D).qa5 = function () {
    this.n9z_1.n1y();
  };
  protoOf(BatchBuilder2D).za7 = function () {
    return this.r9z_1;
  };
  protoOf(BatchBuilder2D).aa8 = function (vd, vp, x, y, u, v, colorMul, texIndex) {
    setFloat32(vd, vp + 0 | 0, x);
    setFloat32(vd, vp + 1 | 0, y);
    setFloat32(vd, vp + 2 | 0, u);
    setFloat32(vd, vp + 3 | 0, v);
    setInt32(vd, vp + 4 | 0, colorMul);
    setInt32(vd, vp + 5 | 0, 0);
    this.c9z_1[vp / 6 | 0] = toByte(texIndex);
    return get_TEXTURED_ARRAY_COMPONENTS_PER_VERTEX();
  };
  protoOf(BatchBuilder2D).ba8 = function (x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex) {
    this.ca8(6, 4);
    this.da8();
    var vp = this.g9z_1;
    var vd = this.b9z_1;
    vp = vp + this.aa8(vd, vp, x0, y0, tex.g2y(), tex.h2y(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.aa8(vd, vp, x1, y1, tex.i2y(), tex.j2y(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.aa8(vd, vp, x2, y2, tex.k2y(), tex.l2y(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.aa8(vd, vp, x3, y3, tex.m2y(), tex.n2y(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    this.g9z_1 = vp;
    this.wa7(this.xa7() + 4 | 0);
  };
  protoOf(BatchBuilder2D).ea8 = function (x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.i9z_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.ba8(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.ba8.call(this, x0, y0, x1, y1, x2, y2, x3, y3, tex, new RGBA(colorMul), texIndex);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).fa8 = function (vc) {
    this.h9z_1 = this.h9z_1 + _addIndices(this, this.e9z_1, this.h9z_1, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  };
  protoOf(BatchBuilder2D).da8 = function (vc, $super) {
    vc = vc === VOID ? this.xa7() : vc;
    var tmp;
    if ($super === VOID) {
      this.fa8(vc);
      tmp = Unit_instance;
    } else {
      tmp = $super.fa8.call(this, vc);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).ga8 = function (array, matrix, vcount, icount, texIndex) {
    this.ca8(icount, vcount);
    var i16 = this.e9z_1;
    var ip = this.h9z_1;
    var vc = this.xa7();
    var arrayIndices = array.ha8_1;
    // Inline function 'kotlin.math.min' call
    var b = array.ka8_1;
    var icount_0 = Math.min(icount, b);
    arraycopy_5(asUShortArrayInt(arrayIndices), 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this.g9z_1;
    var src = get_i32(array.la8_1);
    var dst = get_i32(this.b9z_1);
    arraycopy_6(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this.g9z_1 / 6 | 0;
    arrayfill(this.c9z_1, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (matrix.q2d()) {
      applyMatrix(this, matrix, this.g9z_1, vcount);
    }
    this.f9z_1 = this.f9z_1 + vcount | 0;
    this.g9z_1 = this.g9z_1 + imul(vcount, 6) | 0;
    this.h9z_1 = this.h9z_1 + icount_0 | 0;
  };
  protoOf(BatchBuilder2D).oa8 = function (array, matrix, vcount, icount, texIndex, $super) {
    vcount = vcount === VOID ? array.ja8_1 : vcount;
    icount = icount === VOID ? array.ka8_1 : icount;
    texIndex = texIndex === VOID ? this.i9z_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.ga8(array, matrix, vcount, icount, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.ga8.call(this, array, matrix, vcount, icount, texIndex);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).ca8 = function (indices, vertices) {
    if (indices === 0 ? vertices === 0 : false)
      return false;
    var doFlush = !checkAvailable(this, indices, vertices);
    if (doFlush) {
      this.pa8();
    }
    if (!checkAvailable(this, indices, vertices)) {
      // Inline function 'kotlin.error' call
      var message = 'Too much vertices: indices=' + indices + ', vertices=' + vertices;
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return doFlush;
  };
  protoOf(BatchBuilder2D).qa8 = function (tex, smoothing, blendMode, program, icount, vcount) {
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.va5_1;
      this.ca8(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_85().w9c_1 : program;
      if (this.ra8(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this.ua7();
      if (!contains_1(this.j9z_1, tex_0)) {
        this.i9z_1 = 0;
        this.j9z_1[0] = tex_0;
      }
      this.k9z_1 = smoothing;
      this.l9z_1 = blendMode;
      this.m9z_1 = pprogram;
    }
  };
  protoOf(BatchBuilder2D).sa8 = function (tex) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.j9z_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.hasTex.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      if (this_0[tmp0] === tex)
        return true;
    }
    return false;
  };
  protoOf(BatchBuilder2D).ra8 = function (tex, smoothing, blendMode, program) {
    var hasTex = this.sa8(tex);
    if (!(this.j9z_1[0] === null) ? !hasTex : false) {
      var inductionVariable = 1;
      var last = this.j9z_1.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.j9z_1[n] === null) {
            this.j9z_1[n] = tex;
            hasTex = true;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
    }
    var inductionVariable_0 = 0;
    var last_0 = this.j9z_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      $l$loop_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this.j9z_1[n_0]) {
          this.i9z_1 = n_0;
          break $l$loop_0;
        }
      }
       while (inductionVariable_0 <= last_0);
    return ((hasTex ? this.k9z_1 === smoothing : false) ? this.l9z_1 === blendMode : false) ? this.m9z_1 === program : false;
  };
  protoOf(BatchBuilder2D).ta8 = function (tex, smoothing, blendMode, program, icount, vcount) {
    this.qa8(this.x9y_1.xa6(tex), smoothing, blendMode, program, icount, vcount);
  };
  protoOf(BatchBuilder2D).ua8 = function (tex, x, y, width, height, m, filtering, colorMul, blendMode, program) {
    return this.va8(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, Unit_instance);
  };
  protoOf(BatchBuilder2D).aa0 = function (tex, x, y, width, height, m, filtering, colorMul, blendMode, program, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    width = width === VOID ? tex.x1q() : width;
    height = height === VOID ? tex.y1q() : height;
    m = m === VOID ? Companion_getInstance_14().e2f_1 : m;
    filtering = filtering === VOID ? true : filtering;
    colorMul = colorMul === VOID ? Colors_getInstance().l3b_1 : colorMul;
    blendMode = blendMode === VOID ? Companion_getInstance_90().z9x_1 : blendMode;
    program = program === VOID ? null : program;
    var tmp;
    if ($super === VOID) {
      this.ua8(tex, x, y, width, height, m, filtering, colorMul, blendMode, program);
      tmp = Unit_instance;
    } else {
      tmp = $super.ua8.call(this, tex, x, y, width, height, m, filtering, new RGBA(colorMul), blendMode, program);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).va8 = function (tex, x, y, width, height, m, filtering, colorMul, blendMode, program, unit) {
    this.qa8(tex.v2x(), filtering, blendMode, program, 6, 4);
    this.wa8(x, y, width, height, m, tex, colorMul);
  };
  protoOf(BatchBuilder2D).wa8 = function (x, y, width, height, m, tex, colorMul) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.ea8(m.x2f(x0, y0), m.y2f(x0, y0), m.x2f(x1, y0), m.y2f(x1, y0), m.x2f(x1, y1), m.y2f(x1, y1), m.x2f(x0, y1), m.y2f(x0, y1), tex, colorMul);
  };
  protoOf(BatchBuilder2D).xa8 = function () {
    this.n9z_1.m1y_1.oa7_1.d7y(this.d9z_1, 0, imul(this.h9z_1, 2));
  };
  protoOf(BatchBuilder2D).ya8 = function () {
    this.t9y_1.ya8();
    var inductionVariable = 0;
    var last = this.v9y_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var info = Companion_getInstance_51().l81(VOID, this.k9z_1);
        this.t9y_1.w9s_1.n7y(Companion_getInstance_85().n9c_1[n], this.j9z_1[n], info);
      }
       while (inductionVariable < last);
  };
  protoOf(BatchBuilder2D).ua7 = function () {
    if (this.v9z_1 === this.h9z_1)
      return Unit_instance;
    this.ya8();
    this.w9z_1 = this.w9z_1 + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.u9z_1;
    var tmp3_frameBuffer = this.t9y_1.s9t_1.g7w_1;
    var tmp4_frameBufferInfo = this.t9y_1.s9t_1.t7w();
    var tmp5_vertexData = this.n9z_1.m1y_1.pa7_1;
    var tmp6_indices = this.n9z_1.m1y_1.oa7_1;
    var tmp7_program = this.m9z_1;
    var tmp8_drawType = Companion_getInstance_52().b84_1;
    var tmp9_blending = this.l9z_1.za8_1;
    var tmp10_uniformBlocks = this.t9y_1.ca9(this.m9z_1, false);
    var tmp11_textureUnits = this.t9y_1.w9s_1.g1s();
    var tmp12_stencilOpFunc = this.p9z_1;
    var tmp13_stencilRef = this.o9z_1;
    var tmp14_colorMask = this.q9z_1;
    var tmp15_scissor = this.r9z_1;
    var tmp16_drawOffset = imul(this.v9z_1, 2);
    var tmp17_vertexCount = this.h9z_1 - this.v9z_1 | 0;
    var element = new AGBatch(tmp3_frameBuffer, tmp4_frameBufferInfo, tmp5_vertexData, tmp6_indices, VOID, tmp7_program, tmp10_uniformBlocks, tmp11_textureUnits, tmp9_blending, tmp12_stencilOpFunc, tmp13_stencilRef, tmp14_colorMask, VOID, tmp15_scissor, VOID, tmp8_drawType, tmp16_drawOffset, tmp17_vertexCount);
    this_0.r(element);
    this.v9z_1 = this.h9z_1;
  };
  protoOf(BatchBuilder2D).da9 = function (uploadVertices, uploadIndices) {
    this.ea9(uploadVertices, uploadIndices);
    var inductionVariable = 0;
    var last = this.v9y_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.j9z_1[n] = null;
      }
       while (inductionVariable < last);
    this.i9z_1 = 0;
  };
  protoOf(BatchBuilder2D).ta7 = function (uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.da9(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.da9.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).ea9 = function (uploadVertices, uploadIndices) {
    this.ua7();
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.u9z_1.b1()) {
      if (uploadVertices) {
        this.n9z_1.m1y_1.ma7_1.d7y(this.b9z_1, 0, imul(this.g9z_1, 4));
        this.n9z_1.m1y_1.na7_1.b7y(this.c9z_1, 0, this.g9z_1 / 6 | 0);
      }
      if (uploadIndices) {
        this.xa8();
      }
      this.t9y_1.fa9();
      draw_0(this.y9y_1, new AGMultiBatch(toList(this.u9z_1)));
      this.u9z_1.b3();
      this.s9z_1.x5n(this);
      this.x9z_1 = this.x9z_1 + 1 | 0;
      this.t9y_1.ga9();
      this.n9z_1.x();
    }
    this.wa7(0);
    this.g9z_1 = 0;
    this.v9z_1 = 0;
    this.h9z_1 = 0;
  };
  protoOf(BatchBuilder2D).pa8 = function (uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.ea9(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.ea9.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  };
  protoOf(BatchBuilder2D).ha9 = function (vertexCount) {
    var oldVertexCount = this.xa7();
    this.wa7(vertexCount);
    try {
      this.s9z_1.x5n(this);
    }finally {
      this.wa7(oldVertexCount);
    }
  };
  var properties_initialized_BatchBuilder2D_kt_532b2j;
  function _init_properties_BatchBuilder2D_kt__vdn94j() {
    if (!properties_initialized_BatchBuilder2D_kt_532b2j) {
      properties_initialized_BatchBuilder2D_kt_532b2j = true;
      logger_0 = Companion_getInstance_2().r24('BatchBuilder2D');
      BB_MAX_TEXTURES = ((Companion_instance_2.j1p() ? Companion_instance_2.m1p().v1o_1 : false) ? Companion_instance_2.m1p().a1p() : false) ? 1 : 4;
    }
  }
  function get_debugLineRenderContext(_this__u8e3s4) {
    _init_properties_LineRenderBatcher_kt__ezqewb();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var this_0 = debugLineRenderContext$delegate;
      var property = debugLineRenderContext$factory();
      var tmp0_elvis_lhs = this_0.l23_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = this_0.m23_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = this_0.l23_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var debugLineRenderContext$delegate;
  function Companion_60() {
    Companion_instance_74 = this;
    this.ia9_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l86_1, DefaultShaders_getInstance().n86_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = new ProgramBuilderDefault();
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_0 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>.<anonymous>' call
    builder.y89(builder.b8a(), builder.c8a(builder.c8a(this_0.d89(), this_0.e89()), builder.f8a([this_0.l86_1, builder.e8a(0.0), builder.e8a(1.0)])));
    builder.y89(this_0.p86_1, this_0.n86_1);
    tmp.ja9_1 = VertexShader(builder.g8a());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = new ProgramBuilderDefault();
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_1 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>.<anonymous>' call
    builder_0.y89(builder_0.b8a(), this_1.p86_1);
    tmp_0.ka9_1 = FragmentShader(builder_0.g8a());
    this.la9_1 = new Program(this.ja9_1, this.ka9_1);
  }
  var Companion_instance_74;
  function Companion_getInstance_86() {
    if (Companion_instance_74 == null)
      new Companion_60();
    return Companion_instance_74;
  }
  function addVertex($this, x, y, color, m) {
    setFloat32($this.ta9_1, $this.wa9_1 + 0 | 0, m.x2f(x, y));
    setFloat32($this.ta9_1, $this.wa9_1 + 1 | 0, m.y2f(x, y));
    setInt32($this.ta9_1, $this.wa9_1 + 2 | 0, _RGBA___get_value__impl__hhco8v(color));
    var tmp = $this;
    var tmp_0 = $this.wa9_1;
    var tmp_1 = Companion_getInstance_86().ia9_1.e8k_1;
    tmp.wa9_1 = tmp_0 + (tmp_1 / 4 | 0) | 0;
    $this.va9_1 = $this.va9_1 + 1 | 0;
  }
  function LineRenderBatcher$lambda(this$0) {
    return function (it) {
      this$0.m6();
      return Unit_instance;
    };
  }
  function LineRenderBatcher(ctx) {
    Companion_getInstance_86();
    this.ma9_1 = ctx;
    this.na9_1 = new Signal();
    this.ma9_1.i9t_1.q5n(LineRenderBatcher$lambda(this));
    this.oa9_1 = this.ma9_1.m9s_1;
    this.pa9_1 = Colors_getInstance().b3h_1;
    this.qa9_1 = new AGBuffer();
    this.ra9_1 = AGVertexArrayObject_init_$Create$([new AGVertexData(Companion_getInstance_86().ia9_1, this.qa9_1)], false);
    this.sa9_1 = 1024;
    this.ta9_1 = allocDirect(Companion_instance_0, imul(24, this.sa9_1));
    this.ua9_1 = Matrix4_init_$Create$();
    this.va9_1 = 0;
    this.wa9_1 = 0;
    this.xa9_1 = Companion_getInstance_90().z9x_1;
    this.ya9_1 = Companion_getInstance_14().h2f();
  }
  protoOf(LineRenderBatcher).za9 = function (p0, p1, color0, color1, m) {
    return this.aaa(p0.g28_1, p0.h28_1, p1.g28_1, p1.h28_1, this.pa9_1, color1, m);
  };
  protoOf(LineRenderBatcher).baa = function (p0, p1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.pa9_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.ya9_1 : m;
    var tmp;
    if ($super === VOID) {
      this.za9(p0, p1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.za9.call(this, p0, p1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  };
  protoOf(LineRenderBatcher).caa = function (x0, y0, x1, y1, color0, color1, m) {
    if (this.va9_1 >= (this.sa9_1 - 2 | 0)) {
      this.m6();
    }
    addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  };
  protoOf(LineRenderBatcher).daa = function (x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.pa9_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.ya9_1 : m;
    var tmp;
    if ($super === VOID) {
      this.caa(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.caa.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  };
  protoOf(LineRenderBatcher).aaa = function (x0, y0, x1, y1, color0, color1, m) {
    return this.caa(x0, y0, x1, y1, color0, color1, m);
  };
  protoOf(LineRenderBatcher).eaa = function (path, m) {
    var lastPos = {_v: Vector2D_init_$Create$_1()};
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D_init_$Create$_1();
    var l = Vector2D_init_$Create$_1();
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.u2u_1;
    var n_0 = 0;
    while (n_0 < this_0.n()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var tmp0 = n_0;
      n_0 = tmp0 + 1 | 0;
      var tmp0_subject = this_0.b1r(tmp0);
      if (tmp0_subject === 0) {
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp = path.v2u_1.f1(tmp1);
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var it = new Vector2D(tmp, path.v2u_1.f1(tmp2));
        i = it;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
        if (!true) {
          this.baa(lastPos._v, it, VOID, VOID, m);
        }
        lastPos._v = it;
        l = it;
      } else {
        if (tmp0_subject === 1) {
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          var tmp3 = n;
          n = tmp3 + 1 | 0;
          var tmp_0 = path.v2u_1.f1(tmp3);
          var tmp4 = n;
          n = tmp4 + 1 | 0;
          var it_0 = new Vector2D(tmp_0, path.v2u_1.f1(tmp4));
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          if (!false) {
            this.baa(lastPos._v, it_0, VOID, VOID, m);
          }
          lastPos._v = it_0;
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
        } else {
          if (tmp0_subject === 2) {
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            var tmp5 = n;
            n = tmp5 + 1 | 0;
            var tmp_1 = path.v2u_1.f1(tmp5);
            var tmp6 = n;
            n = tmp6 + 1 | 0;
            var c = new Vector2D(tmp_1, path.v2u_1.f1(tmp6));
            var tmp7 = n;
            n = tmp7 + 1 | 0;
            var tmp_2 = path.v2u_1.f1(tmp7);
            var tmp8 = n;
            n = tmp8 + 1 | 0;
            var a = new Vector2D(tmp_2, path.v2u_1.f1(tmp8));
            var sum = Companion_getInstance_0().c2n(l, c) + Companion_getInstance_0().c2n(c, a);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call
            // Inline function 'kotlin.math.max' call
            var a_0 = numberToInt(sum);
            var rcurveSteps = Math.max(a_0, 20);
            var dt = 1.0 / rcurveSteps;
            var lastPos_0 = {_v: Vector2D_init_$Create$_1()};
            var prevPos = {_v: Vector2D_init_$Create$_1()};
            var emittedCount = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            var ratio = Companion_getInstance_15().a28_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            lastPos_0._v = Companion_getInstance_16().d2t(l, c, a, ratio);
            var nStart = false ? 0 : 1;
            var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_0 = _Ratio___init__impl__9mwvn2(n_1 * dt);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_1 = Companion_getInstance_16().d2t(l, c, a, ratio_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                if (!false) {
                  this.baa(lastPos._v, it_1, VOID, VOID, m);
                }
                lastPos._v = it_1;
                emittedCount._v = emittedCount._v + 1 | 0;
                lastPos_0._v = prevPos._v;
                prevPos._v = it_1;
              }
               while (!(n_1 === nEnd));
            l = a;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
          } else {
            if (tmp0_subject === 3) {
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              var tmp9 = n;
              n = tmp9 + 1 | 0;
              var tmp_3 = path.v2u_1.f1(tmp9);
              var tmp10 = n;
              n = tmp10 + 1 | 0;
              var c0 = new Vector2D(tmp_3, path.v2u_1.f1(tmp10));
              var tmp11 = n;
              n = tmp11 + 1 | 0;
              var tmp_4 = path.v2u_1.f1(tmp11);
              var tmp12 = n;
              n = tmp12 + 1 | 0;
              var c1 = new Vector2D(tmp_4, path.v2u_1.f1(tmp12));
              var tmp13 = n;
              n = tmp13 + 1 | 0;
              var tmp_5 = path.v2u_1.f1(tmp13);
              var tmp14 = n;
              n = tmp14 + 1 | 0;
              var a_1 = new Vector2D(tmp_5, path.v2u_1.f1(tmp14));
              var sum_0 = Companion_getInstance_0().c2n(l, c0) + Companion_getInstance_0().c2n(c0, c1) + Companion_getInstance_0().c2n(c1, a_1);
              // Inline function 'korlibs.math.geom.shape.approximateCurve' call
              // Inline function 'kotlin.math.max' call
              var a_2 = numberToInt(sum_0);
              var rcurveSteps_0 = Math.max(a_2, 20);
              var dt_0 = 1.0 / rcurveSteps_0;
              var lastPos_1 = {_v: Vector2D_init_$Create$_1()};
              var prevPos_0 = {_v: Vector2D_init_$Create$_1()};
              var emittedCount_0 = {_v: 0};
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              var ratio_1 = Companion_getInstance_15().a28_1;
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              lastPos_1._v = Companion_getInstance_16().c2t(l, c0, c1, a_1, ratio_1);
              var nStart_0 = false ? 0 : 1;
              var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
              var inductionVariable_0 = nStart_0;
              if (inductionVariable_0 <= nEnd_0)
                do {
                  var n_2 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var ratio_2 = _Ratio___init__impl__9mwvn2(n_2 * dt_0);
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                  var it_2 = Companion_getInstance_16().c2t(l, c0, c1, a_1, ratio_2);
                  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                  if (!false) {
                    this.baa(lastPos._v, it_2, VOID, VOID, m);
                  }
                  lastPos._v = it_2;
                  emittedCount_0._v = emittedCount_0._v + 1 | 0;
                  lastPos_1._v = prevPos_0._v;
                  prevPos_0._v = it_2;
                }
                 while (!(n_2 === nEnd_0));
              l = a_1;
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
            } else {
              if (tmp0_subject === 4) {
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                var p = i;
                if (!false) {
                  this.baa(lastPos._v, p, VOID, VOID, m);
                }
                lastPos._v = p;
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
              }
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  };
  protoOf(LineRenderBatcher).m6 = function () {
    if (this.va9_1 > 0) {
      this.na9_1.x5n(this);
      this.qa9_1.d7y(this.ta9_1, 0, imul(this.wa9_1, 4));
      this.ma9_1.ya8();
      var tmp0_$receiver = this.oa9_1;
      var tmp1_frameBuffer = this.ma9_1.s9t_1;
      var tmp2_vertexData = this.ra9_1;
      var tmp3_program = Companion_getInstance_86().la9_1;
      var tmp4_drawType = Companion_getInstance_52().a84_1;
      var tmp5_vertexCount = this.va9_1;
      var tmp6_uniformBlocks = this.ma9_1.faa(Companion_getInstance_86().la9_1);
      var tmp7_blending = this.xa9_1.za8_1;
      draw(tmp0_$receiver, tmp1_frameBuffer, tmp2_vertexData, tmp3_program, tmp4_drawType, tmp5_vertexCount, VOID, VOID, VOID, tmp7_blending, tmp6_uniformBlocks);
    }
    this.va9_1 = 0;
    this.wa9_1 = 0;
  };
  function debugLineRenderContext$delegate$lambda($this$$receiver) {
    _init_properties_LineRenderBatcher_kt__ezqewb();
    return new LineRenderBatcher($this$$receiver);
  }
  function debugLineRenderContext$factory() {
    return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
      return get_debugLineRenderContext(receiver);
    }, null);
  }
  var properties_initialized_LineRenderBatcher_kt_urwcod;
  function _init_properties_LineRenderBatcher_kt__ezqewb() {
    if (!properties_initialized_LineRenderBatcher_kt_urwcod) {
      properties_initialized_LineRenderBatcher_kt_urwcod = true;
      debugLineRenderContext$delegate = new PropertyThis(VOID, debugLineRenderContext$delegate$lambda);
    }
  }
  var FlushKind_STATE_instance;
  var FlushKind_FULL_instance;
  var FlushKind_entriesInitialized;
  function FlushKind_initEntries() {
    if (FlushKind_entriesInitialized)
      return Unit_instance;
    FlushKind_entriesInitialized = true;
    FlushKind_STATE_instance = new FlushKind('STATE', 0);
    FlushKind_FULL_instance = new FlushKind('FULL', 1);
  }
  function FlushKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RenderContext$tempTexturePool$lambda(it) {
    return new AGTexture();
  }
  function RenderContext$projViewMatUB$delegate$lambda(this$0) {
    return function () {
      return this$0.b82(ProjViewUB_getInstance());
    };
  }
  function RenderContext$dynamicVertexBufferPool$lambda(it) {
    return new AGBuffer();
  }
  function RenderContext$frameBuffers$lambda(it) {
    return AGFrameBuffer_init_$Create$(VOID, it);
  }
  function FlushKind_FULL_getInstance() {
    FlushKind_initEntries();
    return FlushKind_FULL_instance;
  }
  function RenderContext(ag, bp, deviceDimensionsProvider, stats, coroutineContext, batchMaxQuads, windowConfig) {
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (deviceDimensionsProvider === VOID) {
      var tmp0_elvis_lhs = isInterface(bp, DeviceDimensionsProvider) ? bp : null;
      tmp = tmp0_elvis_lhs == null ? DEFAULT_instance : tmp0_elvis_lhs;
    } else {
      tmp = deviceDimensionsProvider;
    }
    deviceDimensionsProvider = tmp;
    stats = stats === VOID ? new Stats() : stats;
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_85().p9c_1 : batchMaxQuads;
    windowConfig = windowConfig === VOID ? new Impl() : windowConfig;
    this.m9s_1 = ag;
    this.n9s_1 = bp;
    this.o9s_1 = deviceDimensionsProvider;
    this.p9s_1 = stats;
    this.q9s_1 = coroutineContext;
    this.r9s_1 = batchMaxQuads;
    this.s9s_1 = windowConfig;
    this.t9s_1 = new Mixin();
    this.u9s_1 = new BufferCache();
    this.v9s_1 = FastIdentityMap();
    this.w9s_1 = AGTextureUnits_init_$Create$();
    this.x9s_1 = Companion_getInstance_14().h2f();
    this.y9s_1 = Companion_getInstance_14().h2f();
    this.z9s_1 = Matrix4_init_$Create$();
    this.a9t_1 = Matrix4_init_$Create$();
    this.b9t_1 = Companion_getInstance_14().h2f();
    this.c9t_1 = true;
    var tmp_0 = this;
    tmp_0.d9t_1 = Pool_init_$Create$(VOID, RenderContext$tempTexturePool$lambda);
    var tmp_1 = this;
    tmp_1.e9t_1 = lazy(RenderContext$projViewMatUB$delegate$lambda(this));
    this.f9t_1 = new AgAutoFreeManager();
    this.g9t_1 = new AgBitmapTextureManager(this.m9s_1);
    this.h9t_1 = new AgBufferManager(this.m9s_1);
    this.i9t_1 = new Signal();
    var tmp_2 = this;
    var tmp_3 = this.n9s_1;
    tmp_2.j9t_1 = tmp_3 instanceof Views ? tmp_3 : null;
    this.k9t_1 = null;
    this.l9t_1 = 1.0;
    this.m9t_1 = Colors_getInstance().l3b_1;
    this.n9t_1 = new BatchBuilder2D(this, this.r9s_1);
    var tmp_4 = this;
    tmp_4.o9t_1 = Pool_init_$Create$(VOID, RenderContext$dynamicVertexBufferPool$lambda);
    this.p9t_1 = new RenderContext2D(this.n9t_1, this.g9t_1);
    this.q9t_1 = true;
    this.r9t_1 = null;
    this.s9t_1 = this.m9s_1.o7u();
    this.t9t_1 = LinkedHashSet_init_$Create$();
    var tmp_5 = this;
    tmp_5.u9t_1 = Pool_init_$Create$(VOID, RenderContext$frameBuffers$lambda);
    this.v9t_1 = FastArrayList_init_$Create$();
  }
  protoOf(RenderContext).h23 = function (_set____db54di) {
    this.t9s_1.h23(_set____db54di);
  };
  protoOf(RenderContext).i23 = function () {
    return this.t9s_1.i23();
  };
  protoOf(RenderContext).gaa = function (_set____db54di) {
    this.n9s_1.gaa(_set____db54di);
  };
  protoOf(RenderContext).haa = function () {
    return this.n9s_1.haa();
  };
  protoOf(RenderContext).iaa = function () {
    return this.n9s_1.iaa();
  };
  protoOf(RenderContext).jaa = function () {
    return this.n9s_1.jaa();
  };
  protoOf(RenderContext).kaa = function (_set____db54di) {
    this.n9s_1.kaa(_set____db54di);
  };
  protoOf(RenderContext).laa = function () {
    return this.n9s_1.laa();
  };
  protoOf(RenderContext).maa = function () {
    return this.n9s_1.maa();
  };
  protoOf(RenderContext).naa = function (_set____db54di) {
    this.n9s_1.naa(_set____db54di);
  };
  protoOf(RenderContext).oaa = function () {
    return this.n9s_1.oaa();
  };
  protoOf(RenderContext).paa = function () {
    return this.n9s_1.paa();
  };
  protoOf(RenderContext).qaa = function () {
    return this.n9s_1.qaa();
  };
  protoOf(RenderContext).raa = function () {
    return this.n9s_1.raa();
  };
  protoOf(RenderContext).saa = function () {
    return this.n9s_1.saa();
  };
  protoOf(RenderContext).taa = function (_set____db54di) {
    this.n9s_1.taa(_set____db54di);
  };
  protoOf(RenderContext).uaa = function () {
    return this.n9s_1.uaa();
  };
  protoOf(RenderContext).vaa = function () {
    return this.n9s_1.vaa();
  };
  protoOf(RenderContext).waa = function (_set____db54di) {
    this.n9s_1.waa(_set____db54di);
  };
  protoOf(RenderContext).xaa = function () {
    return this.n9s_1.xaa();
  };
  protoOf(RenderContext).y9o = function (pos) {
    return this.n9s_1.y9o(pos);
  };
  protoOf(RenderContext).w7u = function () {
    return this.m9s_1.w7u();
  };
  protoOf(RenderContext).x7u = function () {
    return this.m9s_1.x7u();
  };
  protoOf(RenderContext).v7u = function () {
    return this.m9s_1.v7u();
  };
  protoOf(RenderContext).yaa = function () {
    return this.o9s_1.yaa();
  };
  protoOf(RenderContext).zaa = function () {
    return this.o9s_1.zaa();
  };
  protoOf(RenderContext).aab = function () {
    return this.o9s_1.aab();
  };
  protoOf(RenderContext).bab = function () {
    return this.o9s_1.bab();
  };
  protoOf(RenderContext).o9r = function () {
    return this.s9s_1.o9r();
  };
  protoOf(RenderContext).ga9 = function () {
  };
  protoOf(RenderContext).cab = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e9t_1;
    projViewMatUB$factory();
    return this_0.m2();
  };
  protoOf(RenderContext).ya8 = function () {
    if (this.c9t_1 ? this.s9t_1.g7z() : false) {
      this.z9s_1 = Companion_getInstance_6().a2k(Companion_getInstance_5().u2k(0, this.s9t_1.o7w_1, this.s9t_1.n7w_1, 0), -1.0, 1.0);
    } else {
      this.z9s_1 = Companion_getInstance_6().a2k(Companion_getInstance_5().u2k(0, 0, this.s9t_1.n7w_1, this.s9t_1.o7w_1), -1.0, 1.0);
      this.z9s_1 = this.z9s_1.b2k(toMatrix4(this.x9s_1));
    }
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = this.cab();
      var tmp1 = this_0.q83();
      this_0.x8n(tmp1 + 1 | 0);
      this_0.l1s(this_0.q83() + 1 | 0);
      var blockSize = this_0.t81_1;
      var index0 = imul(this_0.q83() - 1 | 0, blockSize);
      var index1 = imul(this_0.q83(), blockSize);
      var texBlockSize = this_0.q81_1.f89().n();
      var texIndex0 = imul(this_0.q83() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.q83(), texBlockSize);
      if (this_0.q83() > 0) {
        arraycopy_0(this_0.v81_1, index0, this_0.v81_1, index1, blockSize);
      } else {
        arrayfill_0(this_0.v81_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.updateStandardUniforms.<anonymous>' call
      var $this$push = this_0.q81_1;
      var it = this_0.w81_1;
      it.j8o($this$push.d89(), this.z9s_1);
      it.j8o($this$push.e89(), this.a9t_1);
      if (true ? this_0.q83() >= 1 : false) {
        var equals = arrayequal(this_0.v81_1, index0, this_0.v81_1, index1, blockSize);
        if (equals) {
          var tmp3 = this_0.q83();
          this_0.x8n(tmp3 - 1 | 0);
          break $l$block;
        }
      }
    }
  };
  protoOf(RenderContext).dab = function () {
    return coerceAtLeast_0(round(this.yaa() * this.l9t_1), 1.0);
  };
  protoOf(RenderContext).eab = function (kind) {
    this.i9t_1.x5n(kind);
  };
  protoOf(RenderContext).y9z = function (kind, $super) {
    kind = kind === VOID ? FlushKind_FULL_getInstance() : kind;
    var tmp;
    if ($super === VOID) {
      this.eab(kind);
      tmp = Unit_instance;
    } else {
      tmp = $super.eab.call(this, kind);
    }
    return tmp;
  };
  protoOf(RenderContext).fab = function () {
    var tmp0_elvis_lhs = this.s9t_1;
    return tmp0_elvis_lhs == null ? this.o7u() : tmp0_elvis_lhs;
  };
  protoOf(RenderContext).gab = function () {
    return this.fab() === this.o7u();
  };
  protoOf(RenderContext).o7u = function () {
    return this.m9s_1.o7u();
  };
  protoOf(RenderContext).hab = function (color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    this.m9s_1.t7u(this.s9t_1.g7w_1, this.s9t_1.t7w(), color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
  };
  protoOf(RenderContext).iab = function (color, depth, stencil, clearColor, clearDepth, clearStencil, scissor, $super) {
    color = color === VOID ? Colors_getInstance().q3b_1 : color;
    depth = depth === VOID ? 1.0 : depth;
    stencil = stencil === VOID ? 0 : stencil;
    clearColor = clearColor === VOID ? true : clearColor;
    clearDepth = clearDepth === VOID ? true : clearDepth;
    clearStencil = clearStencil === VOID ? true : clearStencil;
    scissor = scissor === VOID ? Companion_getInstance_58().a7w_1 : scissor;
    var tmp;
    if ($super === VOID) {
      this.hab(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
      tmp = Unit_instance;
    } else {
      tmp = $super.hab.call(this, new RGBA(color), depth, stencil, clearColor, clearDepth, clearStencil, scissor);
    }
    return tmp;
  };
  protoOf(RenderContext).q7u = function () {
    this.m9s_1.q7u();
    this.u9t_1.g1y(this.t9t_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.t9t_1.b1()) {
      this.t9t_1.b3();
    }
  };
  protoOf(RenderContext).z9z = function (bmp) {
    return this.g9t_1.ya6(bmp);
  };
  protoOf(RenderContext).jab = function (bmp) {
    return this.g9t_1.za6(bmp);
  };
  protoOf(RenderContext).ia7 = function (buffer) {
    return this.h9t_1.ia7(buffer);
  };
  protoOf(RenderContext).kab = function (bmp) {
    return this.g9t_1.xa6(bmp);
  };
  protoOf(RenderContext).lab = function (closeable) {
    return this.f9t_1.pa5(closeable);
  };
  protoOf(RenderContext).ya7 = function () {
    this.n9t_1.ya7();
  };
  protoOf(RenderContext).qa5 = function () {
    this.y9z();
    this.q7u();
    this.n9t_1.qa5();
    this.f9t_1.qa5();
    this.g9t_1.qa5();
    this.h9t_1.qa5();
  };
  protoOf(RenderContext).p21 = function () {
    this.g9t_1.p21();
    this.f9t_1.p21();
  };
  protoOf(RenderContext).mab = function (width, height, hasDepth, hasStencil, msamples, onlyThisFrame) {
    // Inline function 'kotlin.math.max' call
    var realWidth = Math.max(width, 64);
    // Inline function 'kotlin.math.max' call
    var realHeight = Math.max(height, 64);
    var rb = this.u9t_1.z1x();
    if (onlyThisFrame) {
      // Inline function 'kotlin.collections.plusAssign' call
      this.t9t_1.r(rb);
    }
    rb.s7z(0, 0, realWidth, realHeight, realWidth, realHeight);
    rb.j80(hasDepth, hasStencil);
    rb.i80(msamples);
    return rb;
  };
  protoOf(RenderContext).nab = function (width, height, hasDepth, hasStencil, msamples, onlyThisFrame, $super) {
    hasDepth = hasDepth === VOID ? false : hasDepth;
    hasStencil = hasStencil === VOID ? true : hasStencil;
    msamples = msamples === VOID ? 1 : msamples;
    onlyThisFrame = onlyThisFrame === VOID ? true : onlyThisFrame;
    return $super === VOID ? this.mab(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) : $super.mab.call(this, width, height, hasDepth, hasStencil, msamples, onlyThisFrame);
  };
  protoOf(RenderContext).oab = function (rb) {
    this.t9t_1.s(rb);
    this.u9t_1.e1y(rb);
  };
  protoOf(RenderContext).w9t = function (frameBuffer) {
    this.v9t_1.r(this.s9t_1);
    this.s9t_1 = frameBuffer;
  };
  protoOf(RenderContext).x9t = function () {
    this.s9t_1 = this.v9t_1.h1(this.v9t_1.n() - 1 | 0);
  };
  protoOf(RenderContext).b82 = function (uniformBlock) {
    return this.u9s_1.b82(uniformBlock);
  };
  protoOf(RenderContext).pab = function (program) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.v9s_1;
      var res = get(this_0, program);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.RenderContext.get.<anonymous>' call
      var out = new AGProgramWithUniforms(program, this.u9s_1);
      set(this_0, program, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  };
  protoOf(RenderContext).ca9 = function (program, autoUpload) {
    if (autoUpload) {
      this.fa9();
    }
    return this.pab(program).p83();
  };
  protoOf(RenderContext).faa = function (program, autoUpload, $super) {
    autoUpload = autoUpload === VOID ? true : autoUpload;
    return $super === VOID ? this.ca9(program, autoUpload) : $super.ca9.call(this, program, autoUpload);
  };
  protoOf(RenderContext).fa9 = function () {
    this.u9s_1.z81();
  };
  function projViewMatUB$factory() {
    return getPropertyCallableRef('projViewMatUB', 1, KProperty1, function (receiver) {
      return receiver.cab();
    }, null);
  }
  function get_logger_0() {
    _init_properties_RenderContext2D_kt__7o43tz();
    return logger_1;
  }
  var logger_1;
  function RenderContext2D$mpool$lambda(it) {
    return new MMatrix();
  }
  function RenderContext2D(batch, agBitmapTextureManager) {
    this.qab_1 = batch;
    this.rab_1 = agBitmapTextureManager;
    this.sab_1 = new Mixin();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger_0();
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.f25(level)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$0 = 'RenderContext2D[0]';
      this_0.g25(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.tab_1 = Size2D_init_$Create$(0, 0);
    var tmp_0 = this;
    tmp_0.uab_1 = Pool_init_$Create$(VOID, RenderContext2D$mpool$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger_0();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.f25(level_0)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$2 = 'RenderContext2D[1]';
      this_1.g25(level_0, tmp$ret$2);
      tmp_1 = Unit_instance;
    }
    this.vab_1 = Companion_getInstance_14().e2f_1;
    this.wab_1 = Companion_getInstance_90().z9x_1;
    this.xab_1 = Colors_getInstance().l3b_1;
    this.yab_1 = true;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger_0();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.f25(level_1)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$4 = 'RenderContext2D[2]';
      this_2.g25(level_1, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
  }
  protoOf(RenderContext2D).h23 = function (_set____db54di) {
    this.sab_1.h23(_set____db54di);
  };
  protoOf(RenderContext2D).i23 = function () {
    return this.sab_1.i23();
  };
  protoOf(RenderContext2D).zab = function (scissor) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.vab_1;
      var p = Vector2D_init_$Create$_0(scissor.r2d(), scissor.t2d());
      if (this_0.p2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = new Vector2D(this_0.w2f(p.g28_1, p.h28_1), this_0.z2f(p.g28_1, p.h28_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_1 = this.vab_1;
      var p_0 = Vector2D_init_$Create$_0(scissor.s2d(), scissor.u2d());
      if (this_1.p2d()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = new Vector2D(this_1.w2f(p_0.g28_1, p_0.h28_1), this_1.z2f(p_0.g28_1, p_0.h28_1));
    }
    var br = tmp$ret$1;
    return Companion_getInstance_58().a86(tl.g28_1, tl.h28_1, br.g28_1, br.h28_1);
  };
  var properties_initialized_RenderContext2D_kt_ica10b;
  function _init_properties_RenderContext2D_kt__7o43tz() {
    if (!properties_initialized_RenderContext2D_kt_ica10b) {
      properties_initialized_RenderContext2D_kt_ica10b = true;
      logger_1 = Companion_getInstance_2().r24('RenderContext2D');
    }
  }
  function SDFShaders$opInterpolate$delegate$lambda($this$FUNC, a, b, c) {
    $this$FUNC.f8b($this$FUNC.a8w(a, b, c));
    return Unit_instance;
  }
  function SDFShaders$opUnion$delegate$lambda($this$FUNC, a, b) {
    $this$FUNC.f8b($this$FUNC.x8v(a, b));
    return Unit_instance;
  }
  function SDFShaders$opIntersect$delegate$lambda($this$FUNC, a, b) {
    $this$FUNC.f8b($this$FUNC.y8v(a, b));
    return Unit_instance;
  }
  function SDFShaders$opSubtract$delegate$lambda($this$FUNC, a, b) {
    $this$FUNC.f8b($this$FUNC.y8v(a, $this$FUNC.v8b(b)));
    return Unit_instance;
  }
  function SDFShaders$opRound$delegate$lambda($this$FUNC, d, r) {
    $this$FUNC.f8b($this$FUNC.w8b(d, r));
    return Unit_instance;
  }
  function SDFShaders$opBorder$delegate$lambda($this$FUNC, d, r) {
    $this$FUNC.f8b($this$FUNC.w8b($this$FUNC.m8b(d), r));
    return Unit_instance;
  }
  function SDFShaders$opBorderInner$delegate$lambda($this$FUNC, d, r) {
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = $this$FUNC.g8w(d, 0.0);
    var body = $this$FUNC.o8a();
    // Inline function 'korlibs.korge.render.SDFShaders.opBorderInner$delegate.<anonymous>.<anonymous>' call
    body.f8b(d);
    var stmIf = new If(cond, body.q8a());
    // Inline function 'kotlin.collections.plusAssign' call
    $this$FUNC.x89_1.r(stmIf);
    var tmp = stmIf;
    $this$FUNC.b8b(tmp, SDFShaders$opBorderInner$delegate$lambda$lambda(d, r));
    return Unit_instance;
  }
  function SDFShaders$opBorderInner$delegate$lambda$lambda($d, $r) {
    return function ($this$null) {
      $this$null.f8b($this$null.w8b($this$null.m8b($d), $r));
      return Unit_instance;
    };
  }
  function SDFShaders$opAA$delegate$lambda($this$FUNC, d) {
    $this$FUNC.f8b($this$FUNC.c8w(1.0, $this$FUNC.w8v($this$FUNC.e8w($this$FUNC.n8a(d, $this$FUNC.z8v(d)), 0.5), $this$FUNC.e8a(0.0), $this$FUNC.e8a(1.0))));
    return Unit_instance;
  }
  function SDFShaders$opAARev$delegate$lambda($this$FUNC, d) {
    $this$FUNC.f8b($this$FUNC.w8v($this$FUNC.e8w($this$FUNC.n8a(d, $this$FUNC.z8v(d)), 0.5), $this$FUNC.e8a(0.0), $this$FUNC.e8a(1.0)));
    return Unit_instance;
  }
  function SDFShaders$opSmoothUnion$delegate$lambda($this$FUNC, d1, d2, k) {
    var h = $this$FUNC.t8v($this$FUNC.i8b());
    $this$FUNC.y89(h, $this$FUNC.w8v($this$FUNC.d8w(0.5, $this$FUNC.n8a($this$FUNC.f8w(0.5, $this$FUNC.w8b(d2, d1)), k)), $this$FUNC.e8a(0.0), $this$FUNC.e8a(1.0)));
    $this$FUNC.f8b($this$FUNC.w8b($this$FUNC.a8w(d2, d1, h), $this$FUNC.c8a($this$FUNC.c8a(k, h), $this$FUNC.c8w(1.0, h))));
    return Unit_instance;
  }
  function SDFShaders$opSmoothSubtraction$delegate$lambda($this$FUNC, d1, d2, k) {
    var h = $this$FUNC.t8v($this$FUNC.i8b());
    $this$FUNC.y89(h, $this$FUNC.w8v($this$FUNC.c8w(0.5, $this$FUNC.n8a($this$FUNC.f8w(0.5, $this$FUNC.x8b(d2, d1)), k)), $this$FUNC.e8a(0.0), $this$FUNC.e8a(1.0)));
    $this$FUNC.f8b($this$FUNC.x8b($this$FUNC.a8w(d2, $this$FUNC.v8b(d1), h), $this$FUNC.c8a($this$FUNC.c8a(k, h), $this$FUNC.c8w(1.0, h))));
    return Unit_instance;
  }
  function SDFShaders$opSmoothIntersection$delegate$lambda($this$FUNC, d1, d2, k) {
    var h = $this$FUNC.t8v($this$FUNC.i8b());
    $this$FUNC.y89(h, $this$FUNC.w8v($this$FUNC.c8w(0.5, $this$FUNC.n8a($this$FUNC.f8w(0.5, $this$FUNC.w8b(d2, d1)), k)), $this$FUNC.e8a(0.0), $this$FUNC.e8a(1.0)));
    $this$FUNC.f8b($this$FUNC.x8b($this$FUNC.a8w(d2, d1, h), $this$FUNC.c8a($this$FUNC.c8a(k, h), $this$FUNC.c8w(1.0, h))));
    return Unit_instance;
  }
  function SDFShaders$circle$delegate$lambda($this$FUNC, p, r) {
    $this$FUNC.f8b($this$FUNC.w8b($this$FUNC.b8w(p), r));
    return Unit_instance;
  }
  function SDFShaders$roundedBox$delegate$lambda($this$FUNC, p, b, r) {
    var q = $this$FUNC.t8v($this$FUNC.u8v());
    $this$FUNC.y89($this$FUNC.h8a(r, 'xy'), $this$FUNC.v8v($this$FUNC.g8w($this$FUNC.r8b(p), 0.0), $this$FUNC.h8a(r, 'xy'), $this$FUNC.h8a(r, 'zw')));
    $this$FUNC.y89($this$FUNC.r8b(r), $this$FUNC.v8v($this$FUNC.g8w($this$FUNC.s8b(p), 0.0), $this$FUNC.r8b(r), $this$FUNC.s8b(r)));
    $this$FUNC.y89(q, $this$FUNC.x8b($this$FUNC.w8b($this$FUNC.m8b(p), b), $this$FUNC.r8b(r)));
    $this$FUNC.f8b($this$FUNC.w8b($this$FUNC.x8b($this$FUNC.x8v($this$FUNC.y8v($this$FUNC.r8b(q), $this$FUNC.s8b(q)), $this$FUNC.e8a(0.0)), $this$FUNC.b8w($this$FUNC.y8v(q, $this$FUNC.e8a(0.0)))), $this$FUNC.r8b(r)));
    return Unit_instance;
  }
  function SDFShaders$box$delegate$lambda($this$FUNC, p, b) {
    var d = $this$FUNC.t8v($this$FUNC.u8v());
    $this$FUNC.y89(d, $this$FUNC.w8b($this$FUNC.m8b(p), b));
    $this$FUNC.f8b($this$FUNC.x8b($this$FUNC.b8w($this$FUNC.y8v(d, $this$FUNC.e8a(0.0))), $this$FUNC.x8v($this$FUNC.y8v($this$FUNC.r8b(d), $this$FUNC.s8b(d)), $this$FUNC.e8a(0.0))));
    return Unit_instance;
  }
  function SDFShaders$opCombinePremultipliedColors$delegate$lambda($this$FUNC, dst, src) {
    $this$FUNC.f8b($this$FUNC.x8b(src, $this$FUNC.c8a(dst, $this$FUNC.c8w(1.0, $this$FUNC.l8a(src)))));
    return Unit_instance;
  }
  function SDFShaders() {
    SDFShaders_instance = this;
    Builder.call(this);
    var tmp = this;
    var tmp_0 = this.i8b();
    var tmp_1 = this.i8b();
    var tmp_2 = this.i8b();
    var tmp_3 = this.i8b();
    tmp.cac_1 = this.y8a(tmp_0, tmp_1, tmp_2, VOID, tmp_3, SDFShaders$opInterpolate$delegate$lambda).t89(this, opInterpolate$factory());
    var tmp_4 = this;
    var tmp_5 = this.i8b();
    var tmp_6 = this.i8b();
    var tmp_7 = this.i8b();
    tmp_4.dac_1 = this.w8a(tmp_5, tmp_6, VOID, tmp_7, SDFShaders$opUnion$delegate$lambda).t89(this, opUnion$factory());
    var tmp_8 = this;
    var tmp_9 = this.i8b();
    var tmp_10 = this.i8b();
    var tmp_11 = this.i8b();
    tmp_8.eac_1 = this.w8a(tmp_9, tmp_10, VOID, tmp_11, SDFShaders$opIntersect$delegate$lambda).t89(this, opIntersect$factory());
    var tmp_12 = this;
    var tmp_13 = this.i8b();
    var tmp_14 = this.i8b();
    var tmp_15 = this.i8b();
    tmp_12.fac_1 = this.w8a(tmp_13, tmp_14, VOID, tmp_15, SDFShaders$opSubtract$delegate$lambda).t89(this, opSubtract$factory());
    var tmp_16 = this;
    var tmp_17 = this.i8b();
    var tmp_18 = this.i8b();
    var tmp_19 = this.i8b();
    tmp_16.gac_1 = this.w8a(tmp_17, tmp_18, VOID, tmp_19, SDFShaders$opRound$delegate$lambda).t89(this, opRound$factory());
    var tmp_20 = this;
    var tmp_21 = this.i8b();
    var tmp_22 = this.i8b();
    var tmp_23 = this.i8b();
    tmp_20.hac_1 = this.w8a(tmp_21, tmp_22, VOID, tmp_23, SDFShaders$opBorder$delegate$lambda).t89(this, opBorder$factory());
    var tmp_24 = this;
    var tmp_25 = this.i8b();
    var tmp_26 = this.i8b();
    var tmp_27 = this.i8b();
    tmp_24.iac_1 = this.w8a(tmp_25, tmp_26, VOID, tmp_27, SDFShaders$opBorderInner$delegate$lambda).t89(this, opBorderInner$factory());
    var tmp_28 = this;
    var tmp_29 = this.i8b();
    var tmp_30 = this.i8b();
    tmp_28.jac_1 = this.u8a(tmp_29, VOID, tmp_30, SDFShaders$opAA$delegate$lambda).t89(this, opAA$factory());
    var tmp_31 = this;
    var tmp_32 = this.i8b();
    var tmp_33 = this.i8b();
    tmp_31.kac_1 = this.u8a(tmp_32, VOID, tmp_33, SDFShaders$opAARev$delegate$lambda).t89(this, opAARev$factory());
    var tmp_34 = this;
    var tmp_35 = this.i8b();
    var tmp_36 = this.i8b();
    var tmp_37 = this.i8b();
    var tmp_38 = this.i8b();
    tmp_34.lac_1 = this.y8a(tmp_35, tmp_36, tmp_37, VOID, tmp_38, SDFShaders$opSmoothUnion$delegate$lambda).t89(this, opSmoothUnion$factory());
    var tmp_39 = this;
    var tmp_40 = this.i8b();
    var tmp_41 = this.i8b();
    var tmp_42 = this.i8b();
    var tmp_43 = this.i8b();
    tmp_39.mac_1 = this.y8a(tmp_40, tmp_41, tmp_42, VOID, tmp_43, SDFShaders$opSmoothSubtraction$delegate$lambda).t89(this, opSmoothSubtraction$factory());
    var tmp_44 = this;
    var tmp_45 = this.i8b();
    var tmp_46 = this.i8b();
    var tmp_47 = this.i8b();
    var tmp_48 = this.i8b();
    tmp_44.nac_1 = this.y8a(tmp_45, tmp_46, tmp_47, VOID, tmp_48, SDFShaders$opSmoothIntersection$delegate$lambda).t89(this, opSmoothIntersection$factory());
    var tmp_49 = this;
    var tmp_50 = this.u8v();
    var tmp_51 = this.i8b();
    var tmp_52 = this.i8b();
    tmp_49.oac_1 = this.w8a(tmp_50, tmp_51, VOID, tmp_52, SDFShaders$circle$delegate$lambda).t89(this, circle$factory());
    var tmp_53 = this;
    var tmp_54 = this.u8v();
    var tmp_55 = this.u8v();
    var tmp_56 = this.t8w();
    var tmp_57 = this.i8b();
    tmp_53.pac_1 = this.y8a(tmp_54, tmp_55, tmp_56, VOID, tmp_57, SDFShaders$roundedBox$delegate$lambda).t89(this, roundedBox$factory());
    var tmp_58 = this;
    var tmp_59 = this.u8v();
    var tmp_60 = this.u8v();
    var tmp_61 = this.i8b();
    tmp_58.qac_1 = this.w8a(tmp_59, tmp_60, VOID, tmp_61, SDFShaders$box$delegate$lambda).t89(this, box$factory());
    var tmp_62 = this;
    var tmp_63 = this.t8w();
    var tmp_64 = this.t8w();
    var tmp_65 = this.t8w();
    tmp_62.rac_1 = this.w8a(tmp_63, tmp_64, VOID, tmp_65, SDFShaders$opCombinePremultipliedColors$delegate$lambda).t89(this, opCombinePremultipliedColors$factory());
  }
  protoOf(SDFShaders).sac = function () {
    return this.cac_1.lh(this, opInterpolate$factory_0());
  };
  protoOf(SDFShaders).tac = function () {
    return this.dac_1.lh(this, opUnion$factory_0());
  };
  protoOf(SDFShaders).uac = function () {
    return this.eac_1.lh(this, opIntersect$factory_0());
  };
  protoOf(SDFShaders).vac = function () {
    return this.fac_1.lh(this, opSubtract$factory_0());
  };
  protoOf(SDFShaders).wac = function () {
    return this.gac_1.lh(this, opRound$factory_0());
  };
  protoOf(SDFShaders).xac = function () {
    return this.hac_1.lh(this, opBorder$factory_0());
  };
  protoOf(SDFShaders).yac = function () {
    return this.iac_1.lh(this, opBorderInner$factory_0());
  };
  protoOf(SDFShaders).zac = function () {
    return this.jac_1.lh(this, opAA$factory_0());
  };
  protoOf(SDFShaders).aad = function () {
    return this.kac_1.lh(this, opAARev$factory_0());
  };
  protoOf(SDFShaders).bad = function () {
    return this.lac_1.lh(this, opSmoothUnion$factory_0());
  };
  protoOf(SDFShaders).cad = function () {
    return this.mac_1.lh(this, opSmoothSubtraction$factory_0());
  };
  protoOf(SDFShaders).dad = function () {
    return this.nac_1.lh(this, opSmoothIntersection$factory_0());
  };
  protoOf(SDFShaders).ead = function () {
    return this.oac_1.lh(this, circle$factory_0());
  };
  protoOf(SDFShaders).fad = function () {
    return this.pac_1.lh(this, roundedBox$factory_0());
  };
  protoOf(SDFShaders).gad = function () {
    return this.qac_1.lh(this, box$factory_0());
  };
  protoOf(SDFShaders).had = function () {
    return this.rac_1.lh(this, opCombinePremultipliedColors$factory_0());
  };
  var SDFShaders_instance;
  function SDFShaders_getInstance() {
    if (SDFShaders_instance == null)
      new SDFShaders();
    return SDFShaders_instance;
  }
  function opInterpolate$factory() {
    return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
      return receiver.sac();
    }, null);
  }
  function opUnion$factory() {
    return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
      return receiver.tac();
    }, null);
  }
  function opIntersect$factory() {
    return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
      return receiver.uac();
    }, null);
  }
  function opSubtract$factory() {
    return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
      return receiver.vac();
    }, null);
  }
  function opRound$factory() {
    return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
      return receiver.wac();
    }, null);
  }
  function opBorder$factory() {
    return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
      return receiver.xac();
    }, null);
  }
  function opBorderInner$factory() {
    return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
      return receiver.yac();
    }, null);
  }
  function opAA$factory() {
    return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
      return receiver.zac();
    }, null);
  }
  function opAARev$factory() {
    return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
      return receiver.aad();
    }, null);
  }
  function opSmoothUnion$factory() {
    return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
      return receiver.bad();
    }, null);
  }
  function opSmoothSubtraction$factory() {
    return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
      return receiver.cad();
    }, null);
  }
  function opSmoothIntersection$factory() {
    return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
      return receiver.dad();
    }, null);
  }
  function circle$factory() {
    return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
      return receiver.ead();
    }, null);
  }
  function roundedBox$factory() {
    return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
      return receiver.fad();
    }, null);
  }
  function box$factory() {
    return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
      return receiver.gad();
    }, null);
  }
  function opCombinePremultipliedColors$factory() {
    return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
      return receiver.had();
    }, null);
  }
  function opInterpolate$factory_0() {
    return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
      return receiver.sac();
    }, null);
  }
  function opUnion$factory_0() {
    return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
      return receiver.tac();
    }, null);
  }
  function opIntersect$factory_0() {
    return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
      return receiver.uac();
    }, null);
  }
  function opSubtract$factory_0() {
    return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
      return receiver.vac();
    }, null);
  }
  function opRound$factory_0() {
    return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
      return receiver.wac();
    }, null);
  }
  function opBorder$factory_0() {
    return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
      return receiver.xac();
    }, null);
  }
  function opBorderInner$factory_0() {
    return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
      return receiver.yac();
    }, null);
  }
  function opAA$factory_0() {
    return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
      return receiver.zac();
    }, null);
  }
  function opAARev$factory_0() {
    return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
      return receiver.aad();
    }, null);
  }
  function opSmoothUnion$factory_0() {
    return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
      return receiver.bad();
    }, null);
  }
  function opSmoothSubtraction$factory_0() {
    return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
      return receiver.cad();
    }, null);
  }
  function opSmoothIntersection$factory_0() {
    return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
      return receiver.dad();
    }, null);
  }
  function circle$factory_0() {
    return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
      return receiver.ead();
    }, null);
  }
  function roundedBox$factory_0() {
    return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
      return receiver.fad();
    }, null);
  }
  function box$factory_0() {
    return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
      return receiver.gad();
    }, null);
  }
  function opCombinePremultipliedColors$factory_0() {
    return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
      return receiver.had();
    }, null);
  }
  function TextureBase_init_$Init$(base, width, height, $this) {
    TextureBase.call($this, base, new SizeInt(width, height));
    return $this;
  }
  function TextureBase_init_$Create$(base, width, height) {
    return TextureBase_init_$Init$(base, width, height, objectCreate(protoOf(TextureBase)));
  }
  function TextureBase(base, size) {
    this.va5_1 = base;
    this.wa5_1 = size;
    this.xa5_1 = -1;
  }
  protoOf(TextureBase).n = function () {
    return this.wa5_1;
  };
  protoOf(TextureBase).ya5 = function (width) {
    this.wa5_1 = new SizeInt(width, this.y1q());
  };
  protoOf(TextureBase).x1q = function () {
    return this.wa5_1.u2l_1;
  };
  protoOf(TextureBase).za5 = function (height) {
    this.wa5_1 = new SizeInt(this.x1q(), height);
  };
  protoOf(TextureBase).y1q = function () {
    return this.wa5_1.v2l_1;
  };
  protoOf(TextureBase).p21 = function () {
    var tmp0_safe_receiver = this.va5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p21();
    }
    this.va5_1 = null;
  };
  protoOf(TextureBase).sa6 = function (bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    var tmp0_safe_receiver = this.va5_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.e81(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  };
  protoOf(TextureBase).toString = function () {
    return 'TextureBase(' + this.va5_1 + ')';
  };
  function Texture(frameBuffer) {
    return Texture_0(frameBuffer.p7z(), frameBuffer.n7w_1, frameBuffer.o7w_1);
  }
  function Texture_0(agBase, width, height) {
    return new RectSlice(new TextureBase(agBase, new SizeInt(width, height)), new RectangleI(0, 0, width, height));
  }
  function Texture_1(base, left, top, right, bottom) {
    left = left === VOID ? 0 : left;
    top = top === VOID ? 0 : top;
    right = right === VOID ? base.x1q() : right;
    bottom = bottom === VOID ? base.y1q() : bottom;
    return new RectSlice(base, Companion_instance_8.u2k(left, top, right, bottom));
  }
  function get_TEXTURED_ARRAY_QUAD_INDICES() {
    _init_properties_TexturedVertexArray_kt__kev7cq();
    return TEXTURED_ARRAY_QUAD_INDICES;
  }
  var TEXTURED_ARRAY_QUAD_INDICES;
  var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
  function get_TEXTURED_ARRAY_EMPTY_SHORT_ARRAY() {
    _init_properties_TexturedVertexArray_kt__kev7cq();
    return TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
  }
  var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
  function get_TEXTURED_ARRAY_COMPONENTS_PER_VERTEX() {
    return TEXTURED_ARRAY_COMPONENTS_PER_VERTEX;
  }
  var TEXTURED_ARRAY_COMPONENTS_PER_VERTEX;
  function Companion_61() {
    Companion_instance_75 = this;
    this.iad_1 = new TexturedVertexArray(0, new Int16Array(0));
  }
  var Companion_instance_75;
  function Companion_getInstance_87() {
    if (Companion_instance_75 == null)
      new Companion_61();
    return Companion_instance_75;
  }
  function TexturedVertexArray(vcount, indices, icount) {
    Companion_getInstance_87();
    icount = icount === VOID ? indices.length : icount;
    this.ha8_1 = indices;
    this.ia8_1 = vcount;
    this.ja8_1 = vcount;
    this.ka8_1 = icount;
    this.la8_1 = allocNoDirect(Companion_instance_0, imul(imul(6, this.ia8_1), 4));
    this.ma8_1 = this.la8_1;
    this.na8_1 = 0;
  }
  protoOf(TexturedVertexArray).jad = function (index, x, y, u, v, colMul) {
    this.kad(this.ma8_1, imul(index, 6), x, y, u, v, _RGBA___get_value__impl__hhco8v(colMul));
  };
  protoOf(TexturedVertexArray).kad = function (fast, pos, x, y, u, v, colMul) {
    setFloat32(fast, pos + 0 | 0, x);
    setFloat32(fast, pos + 1 | 0, y);
    setFloat32(fast, pos + 2 | 0, u);
    setFloat32(fast, pos + 3 | 0, v);
    setInt32(fast, pos + 4 | 0, colMul);
    setInt32(fast, pos + 5 | 0, 0);
    return 6;
  };
  protoOf(TexturedVertexArray).lad = function (index, x, y, width, height, matrix, bmp, colMul) {
    this.mad(index, x, y, width, height, matrix, bmp.g2y(), bmp.h2y(), bmp.i2y(), bmp.j2y(), bmp.m2y(), bmp.n2y(), bmp.k2y(), bmp.l2y(), colMul);
  };
  protoOf(TexturedVertexArray).mad = function (index, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix.j2f_1;
    var cf = matrix.l2f_1;
    var txf = matrix.n2f_1;
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix.m2f_1;
    var bf = matrix.k2f_1;
    var tyf = matrix.o2f_1;
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this.ma8_1;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl__hhco8v(colMul);
    pos = pos + this.kad(fast, pos, x0, y0, tl_x, tl_y, cm) | 0;
    pos = pos + this.kad(fast, pos, x1, y1, tr_x, tr_y, cm) | 0;
    pos = pos + this.kad(fast, pos, x2, y2, br_x, br_y, cm) | 0;
    pos = pos + this.kad(fast, pos, x3, y3, bl_x, bl_y, cm) | 0;
  };
  function get_VERTEX_INDEX_SIZE() {
    return VERTEX_INDEX_SIZE;
  }
  var VERTEX_INDEX_SIZE;
  function TEXTURED_ARRAY_quadIndices(quadCount) {
    _init_properties_TexturedVertexArray_kt__kev7cq();
    if (quadCount === 0)
      return get_TEXTURED_ARRAY_EMPTY_SHORT_ARRAY();
    var out = new Int16Array(imul(quadCount, 6));
    var m = 0;
    var base = 0;
    var inductionVariable = 0;
    if (inductionVariable < quadCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1 = m;
        m = tmp1 + 1 | 0;
        out[tmp1] = toShort(base + 0 | 0);
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        out[tmp2] = toShort(base + 1 | 0);
        var tmp3 = m;
        m = tmp3 + 1 | 0;
        out[tmp3] = toShort(base + 2 | 0);
        var tmp4 = m;
        m = tmp4 + 1 | 0;
        out[tmp4] = toShort(base + 3 | 0);
        var tmp5 = m;
        m = tmp5 + 1 | 0;
        out[tmp5] = toShort(base + 0 | 0);
        var tmp6 = m;
        m = tmp6 + 1 | 0;
        out[tmp6] = toShort(base + 2 | 0);
        base = base + 4 | 0;
      }
       while (inductionVariable < quadCount);
    return out;
  }
  function ShrinkableTexturedVertexArray(vertices, vcount, icount) {
    vcount = vcount === VOID ? 0 : vcount;
    icount = icount === VOID ? 0 : icount;
    this.nad_1 = vertices;
    this.oad_1 = vcount;
    this.pad_1 = icount;
  }
  protoOf(ShrinkableTexturedVertexArray).qad = function (x, y, u, v, colMul) {
    var tmp1 = this.oad_1;
    this.oad_1 = tmp1 + 1 | 0;
    this.nad_1.jad(tmp1, x, y, u, v, colMul);
  };
  protoOf(ShrinkableTexturedVertexArray).n1y = function () {
    this.oad_1 = 0;
    this.pad_1 = 0;
  };
  protoOf(ShrinkableTexturedVertexArray).toString = function () {
    return 'GrowableTexturedVertexArray(vcount=' + this.oad_1 + ', icount=' + this.pad_1 + ')';
  };
  var properties_initialized_TexturedVertexArray_kt_ouua70;
  function _init_properties_TexturedVertexArray_kt__kev7cq() {
    if (!properties_initialized_TexturedVertexArray_kt_ouua70) {
      properties_initialized_TexturedVertexArray_kt_ouua70 = true;
      // Inline function 'kotlin.shortArrayOf' call
      TEXTURED_ARRAY_QUAD_INDICES = new Int16Array([0, 1, 2, 3, 0, 2]);
      TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
      TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
    }
  }
  function _get_root__dd8asp($this) {
    var tmp = $this.rad_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('root');
    }
  }
  function _get_mountable__707cy($this) {
    var tmp = $this.sad_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('mountable');
    }
  }
  function ResourcesRoot() {
  }
  protoOf(ResourcesRoot).tad = function (path, file) {
    _get_mountable__707cy(this).g6b(path, file);
  };
  protoOf(ResourcesRoot).s27 = function (injector) {
    var tmp = this;
    // Inline function 'korlibs.io.file.std.MountableVfs' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync' call
    // Inline function 'kotlin.also' call
    var this_0 = new MountableVfs(false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync.<anonymous>' call
    // Inline function 'korlibs.io.file.std.MountableVfs.<anonymous>' call
    // Inline function 'korlibs.korge.resources.ResourcesRoot.init.<anonymous>' call
    this.sad_1 = this_0;
    tmp.rad_1 = this_0.v63();
    this.tad('/', get_resourcesVfs());
  };
  protoOf(ResourcesRoot).toString = function () {
    return 'ResourcesRoot[' + _get_root__dd8asp(this) + ']';
  };
  function Scene$coroutineContext$delegate$lambda(this$0) {
    return function () {
      return this$0.na2().p9e_1.dh(new InjectorContext(this$0.eae())).dh(Job(this$0.na2().p9e_1.md(Key_instance)));
    };
  }
  function Scene$sceneView$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.apply' call
      var this_0 = this$0.gae(this$0.fae().n());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
      this$0.zad_1.pag(this_0);
      return this_0;
    };
  }
  function Scene$resources$delegate$lambda(this$0) {
    return function () {
      // Inline function 'korlibs.inject.Injector.getSync' call
      return this$0.eae().q27(getKClass(Resources));
    };
  }
  function $sceneAfterDestroyInternalCOROUTINE$6(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yag_1 = _this__u8e3s4;
  }
  protoOf($sceneAfterDestroyInternalCOROUTINE$6).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.fd_1 = 1;
            suspendResult = this.yag_1.zag(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gd_1 = 2;
            cancel_1(this.yag_1.w1a());
            this.gd_1 = 4;
            this.fd_1 = 3;
            continue $sm;
          case 2:
            this.gd_1 = 4;
            var tmp_0 = this.id_1;
            if (tmp_0 instanceof Error) {
              var e = this.id_1;
              if (e instanceof CancellationException)
                throw e;
              printStackTrace(e);
              this.fd_1 = 3;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 3:
            this.gd_1 = 4;
            return Unit_instance;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 4) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  function Scene() {
    this.uad_1 = new Mixin();
    this.zad_1 = new Container();
    this.aae_1 = new CancellableGroup();
    var tmp = this;
    tmp.bae_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.cae_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.dae_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  protoOf(Scene).h23 = function (_set____db54di) {
    this.uad_1.h23(_set____db54di);
  };
  protoOf(Scene).i23 = function () {
    return this.uad_1.i23();
  };
  protoOf(Scene).eae = function () {
    var tmp = this.vad_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  };
  protoOf(Scene).aah = function (_set____db54di) {
    this.wad_1 = _set____db54di;
  };
  protoOf(Scene).na2 = function () {
    var tmp = this.wad_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  protoOf(Scene).fae = function () {
    var tmp = this.xad_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  };
  protoOf(Scene).w1a = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.bae_1;
    coroutineContext$factory();
    return this_0.m2();
  };
  protoOf(Scene).bah = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.cae_1;
    sceneView$factory();
    return this_0.m2();
  };
  protoOf(Scene).gae = function (size) {
    return new SContainer(size);
  };
  protoOf(Scene).s27 = function (injector) {
    this.vad_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.q27(getKClass(Views));
    this.aah(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.xad_1 = injector.q27(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.yad_1 = injector.q27(getKClass(ResourcesRoot));
  };
  protoOf(Scene).cah = function (_this__u8e3s4, $completion) {
    return Unit_instance;
  };
  protoOf(Scene).dah = function (_this__u8e3s4, $completion) {
    return Unit_instance;
  };
  protoOf(Scene).eah = function ($completion) {
    return Unit_instance;
  };
  protoOf(Scene).fah = function ($completion) {
    return Unit_instance;
  };
  protoOf(Scene).gah = function ($completion) {
    return Unit_instance;
  };
  protoOf(Scene).hah = function ($completion) {
    cancel_0(this.aae_1);
    this.eae().t27();
    return Unit_instance;
  };
  protoOf(Scene).zag = function ($completion) {
    return Unit_instance;
  };
  protoOf(Scene).iah = function ($completion) {
    var tmp = new $sceneAfterDestroyInternalCOROUTINE$6(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Scene).jah = function (size_0) {
    size(this.bah(), size_0);
  };
  function EmptyScene() {
    Scene.call(this);
  }
  protoOf(EmptyScene).dah = function (_this__u8e3s4, $completion) {
    return Unit_instance;
  };
  function coroutineContext$factory() {
    return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
      return receiver.w1a();
    }, null);
  }
  function sceneView$factory() {
    return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
      return receiver.bah();
    }, null);
  }
  function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
    return function ($this$mapPrototype) {
      // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_0 = $sceneInjector.q27($sceneClass);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      try {
        $event.q9v($scene, this_0);
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      return this_0;
    };
  }
  function _changeTo($this, clazz, injects, time, transition, $completion) {
    var tmp = new $_changeToCOROUTINE$8($this, clazz, injects, time, transition, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function VisitEntry(clazz, injects) {
    this.vai_1 = clazz;
    this.wai_1 = injects;
  }
  protoOf(VisitEntry).toString = function () {
    return 'VisitEntry(clazz=' + this.vai_1 + ', injects=' + this.wai_1 + ')';
  };
  protoOf(VisitEntry).hashCode = function () {
    var result = this.vai_1.hashCode();
    result = imul(result, 31) + hashCode(this.wai_1) | 0;
    return result;
  };
  protoOf(VisitEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.vai_1.equals(tmp0_other_with_cast.vai_1))
      return false;
    if (!equals(this.wai_1, tmp0_other_with_cast.wai_1))
      return false;
    return true;
  };
  function Companion_62() {
    Companion_instance_76 = this;
    this.xai_1 = Companion_getInstance_2().r24('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.yai_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
  var Companion_instance_76;
  function Companion_getInstance_88() {
    if (Companion_instance_76 == null)
      new Companion_62();
    return Companion_instance_76;
  }
  function SceneContainer$lambda$lambda(this$0) {
    return function (it) {
      var tmp;
      if (it instanceof SceneContainer) {
        tmp = !equals(it, this$0);
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function SceneContainer$lambda$slambda(this$0, $event, resultContinuation) {
    this.haj_1 = this$0;
    this.iaj_1 = $event;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$lambda$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(SceneContainer$lambda$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(SceneContainer$lambda$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.jaj_1 = this.haj_1.w9l_1;
            if (!(this.jaj_1 == null)) {
              println('[ReloadEvent] Reloading ' + this.haj_1.w9l_1 + ' . doFullReload=' + this.iaj_1.taj());
              var tmp_0 = this;
              var tmp_1;
              if (this.iaj_1.taj()) {
                tmp_1 = this.iaj_1.uaj(getKClassFromExpression(this.jaj_1), this.jaj_1.eae());
              } else {
                tmp_1 = getKClassFromExpression(this.jaj_1);
              }
              var tmp_2 = tmp_1;
              tmp_0.kaj_1 = isInterface(tmp_2, KClass) ? tmp_2 : THROW_CCE();
              var tmp_3 = this;
              tmp_3.laj_1 = this.haj_1;
              var tmp_4 = this;
              tmp_4.maj_1 = this.kaj_1;
              var tmp_5 = this;
              tmp_5.naj_1 = [];
              var tmp_6 = this;
              tmp_6.oaj_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
              var tmp_7 = this;
              tmp_7.paj_1 = this.laj_1.u9l_1;
              var tmp_8 = this;
              tmp_8.qaj_1 = false;
              this.raj_1 = this.laj_1.t9l_1.r9e_1.j27().h27(getKClass(SceneContainer), this.laj_1).h27(getKClass(Resources), new Resources(this.laj_1.w1a(), this.laj_1.t9l_1.r9u().a6n_1, this.laj_1.t9l_1.r9u()));
              var this_0 = this.naj_1;
              var n = 0;
              while (n < this_0.length) {
                var tmp0 = n;
                n = tmp0 + 1 | 0;
                var inject = this_0[tmp0];
                var tmp_9 = getKClassFromExpression(inject);
                this.raj_1.h27(isInterface(tmp_9, KClass) ? tmp_9 : THROW_CCE(), inject);
              }
              var tmp_10 = this;
              var this_1 = this.raj_1.q27(this.kaj_1);
              try {
                this.iaj_1.q9v(this.jaj_1, this_1);
              } catch ($p) {
                if ($p instanceof Error) {
                  var e = $p;
                  printStackTrace(e);
                } else {
                  throw $p;
                }
              }
              tmp_10.saj_1 = this_1;
              var this_2 = Companion_getInstance_88().xai_1;
              var level = Level_INFO_getInstance();
              if (this_2.f25(level)) {
                this_2.g25(level, 'Changing scene to... ' + this.maj_1 + ' ... ' + this.saj_1);
              }
              if (this.qaj_1) {
                this.saj_1.s27(this.raj_1);
                var tmp_11 = getKClassFromExpression(this.saj_1);
                var tmp_12 = isInterface(tmp_11, KClass) ? tmp_11 : THROW_CCE();
                this.laj_1.t9l_1.r9e_1.l27(tmp_12, SceneContainer$lambda$slambda$lambda(this.raj_1, this.kaj_1, this.iaj_1, this.jaj_1));
              }
              this.fd_1 = 1;
              suspendResult = this.laj_1.vaj(this.saj_1, this.oaj_1, this.paj_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            var scene = suspendResult;
            scene.na2().waj(scene.bah());
            this.fd_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 3) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$lambda$slambda).g5a = function (completion) {
    return new SceneContainer$lambda$slambda(this.haj_1, this.iaj_1, completion);
  };
  function SceneContainer$lambda$slambda_0(this$0, $event, resultContinuation) {
    var i = new SceneContainer$lambda$slambda(this$0, $event, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function SceneContainer$lambda(this$0) {
    return function (event) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).b1();
      var tmp;
      if (hasChildScenes) {
        println('[ReloadEvent] Scene ' + this$0.w9l_1 + ' not reloaded because has child scenes...');
        return Unit_instance;
      }
      launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event, null));
      return Unit_instance;
    };
  }
  function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
    return function ($this$mapPrototype) {
      // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
      return $sceneInjector.q27($clazz);
    };
  }
  function SceneContainer$_changeTo$slambda($newScene, resultContinuation) {
    this.fak_1 = $newScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda).kak = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(SceneContainer$_changeTo$slambda).be = function ($completion) {
    return this.kak($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            var tmp_0 = this;
            tmp_0.gak_1 = this.fak_1.bah();
            var tmp_1 = this;
            tmp_1.hak_1 = this.gak_1;
            var tmp_2 = this;
            tmp_2.iak_1 = this.fak_1;
            var tmp_3 = this;
            tmp_3.jak_1 = this.iak_1;
            this.fd_1 = 1;
            suspendResult = this.jak_1.cah(this.hak_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.gak_1;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda).g5a = function (completion) {
    return new SceneContainer$_changeTo$slambda(this.fak_1, completion);
  };
  function SceneContainer$_changeTo$slambda_0($newScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda($newScene, resultContinuation);
    var l = function ($completion) {
      return i.kak($completion);
    };
    l.$arity = 0;
    return l;
  }
  function SceneContainer$_changeTo$slambda_1($newScene, resultContinuation) {
    this.tak_1 = $newScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_1).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(SceneContainer$_changeTo$slambda_1).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_1).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            var tmp_0 = this;
            tmp_0.uak_1 = this.tak_1.bah();
            var tmp_1 = this;
            tmp_1.vak_1 = this.uak_1;
            var tmp_2 = this;
            tmp_2.wak_1 = this.tak_1;
            var tmp_3 = this;
            tmp_3.xak_1 = this.wak_1;
            this.fd_1 = 1;
            suspendResult = this.xak_1.dah(this.vak_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_1).g5a = function (completion) {
    return new SceneContainer$_changeTo$slambda_1(this.tak_1, completion);
  };
  function SceneContainer$_changeTo$slambda_2($newScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_1($newScene, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function SceneContainer$_changeTo$slambda_3($oldScene, resultContinuation) {
    this.gal_1 = $oldScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_3).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(SceneContainer$_changeTo$slambda_3).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_3).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.gal_1.fah(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_3).g5a = function (completion) {
    return new SceneContainer$_changeTo$slambda_3(this.gal_1, completion);
  };
  function SceneContainer$_changeTo$slambda_4($oldScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_3($oldScene, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function _interpolateRatio$ref() {
    var l = function (p0, p1, p2) {
      return new Ratio(_interpolateRatio(p0.z27_1, p1.z27_1, p2.z27_1));
    };
    l.callableName = '_interpolateRatio';
    return l;
  }
  function SceneContainer$_changeTo$slambda_5($oldScene, resultContinuation) {
    this.pal_1 = $oldScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_5).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(SceneContainer$_changeTo$slambda_5).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_5).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.fd_1 = 1;
            suspendResult = this.pal_1.gah(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.fd_1 = 2;
            suspendResult = this.pal_1.hah(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_5).g5a = function (completion) {
    return new SceneContainer$_changeTo$slambda_5(this.pal_1, completion);
  };
  function SceneContainer$_changeTo$slambda_6($oldScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_5($oldScene, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function SceneContainer$_changeTo$slambda_7($oldScene, resultContinuation) {
    this.yal_1 = $oldScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_7).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(SceneContainer$_changeTo$slambda_7).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_7).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.yal_1.iah(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_7).g5a = function (completion) {
    return new SceneContainer$_changeTo$slambda_7(this.yal_1, completion);
  };
  function SceneContainer$_changeTo$slambda_8($oldScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_7($oldScene, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function SceneContainer$_changeTo$slambda_9($newScene, resultContinuation) {
    this.ham_1 = $newScene;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SceneContainer$_changeTo$slambda_9).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(SceneContainer$_changeTo$slambda_9).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(SceneContainer$_changeTo$slambda_9).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.ham_1.eah(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(SceneContainer$_changeTo$slambda_9).g5a = function (completion) {
    return new SceneContainer$_changeTo$slambda_9(this.ham_1, completion);
  };
  function SceneContainer$_changeTo$slambda_10($newScene, resultContinuation) {
    var i = new SceneContainer$_changeTo$slambda_9($newScene, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $_changeToCOROUTINE$8(_this__u8e3s4, clazz, injects, time, transition, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.iai_1 = _this__u8e3s4;
    this.jai_1 = clazz;
    this.kai_1 = injects;
    this.lai_1 = time;
    this.mai_1 = transition;
  }
  protoOf($_changeToCOROUTINE$8).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            var tmp_0 = this;
            tmp_0.nai_1 = this.iai_1;
            var tmp_1 = this;
            tmp_1.oai_1 = this.jai_1;
            var tmp_2 = this;
            tmp_2.pai_1 = this.kai_1.slice();
            var tmp_3 = this;
            tmp_3.qai_1 = this.lai_1;
            var tmp_4 = this;
            tmp_4.rai_1 = this.mai_1;
            var tmp_5 = this;
            tmp_5.sai_1 = false;
            this.tai_1 = this.nai_1.t9l_1.r9e_1.j27().h27(getKClass(SceneContainer), this.nai_1).h27(getKClass(Resources), new Resources(this.nai_1.w1a(), this.nai_1.t9l_1.r9u().a6n_1, this.nai_1.t9l_1.r9u()));
            var this_0 = this.pai_1;
            var n = 0;
            while (n < this_0.length) {
              var tmp0 = n;
              n = tmp0 + 1 | 0;
              var inject = this_0[tmp0];
              var tmp_6 = getKClassFromExpression(inject);
              this.tai_1.h27(isInterface(tmp_6, KClass) ? tmp_6 : THROW_CCE(), inject);
            }

            var tmp_7 = this;
            tmp_7.uai_1 = this.tai_1.q27(this.jai_1);
            var this_1 = Companion_getInstance_88().xai_1;
            var level = Level_INFO_getInstance();
            if (this_1.f25(level)) {
              this_1.g25(level, 'Changing scene to... ' + this.oai_1 + ' ... ' + this.uai_1);
            }

            if (this.sai_1) {
              this.uai_1.s27(this.tai_1);
              var tmp_8 = getKClassFromExpression(this.uai_1);
              var tmp_9 = isInterface(tmp_8, KClass) ? tmp_8 : THROW_CCE();
              this.nai_1.t9l_1.r9e_1.l27(tmp_9, SceneContainer$_changeTo$lambda(this.tai_1, this.jai_1));
            }

            this.fd_1 = 1;
            suspendResult = this.nai_1.vaj(this.uai_1, this.qai_1, this.rai_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $_changeToCOROUTINE$9(_this__u8e3s4, newScene, time, transition, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qam_1 = _this__u8e3s4;
    this.ram_1 = newScene;
    this.sam_1 = time;
    this.tam_1 = transition;
  }
  protoOf($_changeToCOROUTINE$9).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 10;
            this.uam_1 = this.qam_1.w9l_1;
            this.qam_1.w9l_1 = this.ram_1;
            this.qam_1.v9l_1.hap(this.ram_1.zad_1, this.tam_1);
            this.gd_1 = 2;
            this.fd_1 = 1;
            var tmp_0 = this.ram_1.w1a();
            suspendResult = launchUnscopedAndWait(tmp_0, SceneContainer$_changeTo$slambda_0(this.ram_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gd_1 = 10;
            this.fd_1 = 3;
            continue $sm;
          case 2:
            this.gd_1 = 10;
            var tmp_1 = this.id_1;
            if (tmp_1 instanceof Error) {
              this.vam_1 = this.id_1;
              var tmp_2 = this.vam_1;
              if (tmp_2 instanceof CancellationException)
                throw this.vam_1;
              printStackTrace(this.vam_1);
              this.fd_1 = 3;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 3:
            this.gd_1 = 10;
            launchUnscoped(this.ram_1, SceneContainer$_changeTo$slambda_2(this.ram_1, null));
            if (!(this.uam_1 == null)) {
              this.fd_1 = 4;
              var tmp_3 = this.uam_1.w1a();
              suspendResult = launchUnscopedAndWait(tmp_3, SceneContainer$_changeTo$slambda_4(this.uam_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 5;
              continue $sm;
            }

          case 4:
            this.fd_1 = 5;
            continue $sm;
          case 5:
            if (Duration__compareTo_impl_pchp0f(this.sam_1, toDuration(0, DurationUnit_SECONDS_getInstance())) > 0) {
              this.fd_1 = 6;
              var this_0 = ratio$factory(this.qam_1.v9l_1);
              var initial = Companion_getInstance_15().a28_1;
              var end = Companion_getInstance_15().d28_1;
              suspendResult = tween_0(this.qam_1.v9l_1, [new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true)], this.sam_1, VOID, VOID, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.qam_1.v9l_1.eap_1 = Companion_getInstance_15().d28_1;
              this.fd_1 = 7;
              continue $sm;
            }

          case 6:
            this.fd_1 = 7;
            continue $sm;
          case 7:
            this.qam_1.v9l_1.iap();
            if (!(this.uam_1 == null)) {
              this.fd_1 = 8;
              var tmp_4 = this.uam_1.w1a();
              suspendResult = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_6(this.uam_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 9;
              continue $sm;
            }

          case 8:
            launchUnscoped(this.uam_1, SceneContainer$_changeTo$slambda_8(this.uam_1, null));
            this.fd_1 = 9;
            continue $sm;
          case 9:
            var tmp_5 = this.ram_1.w1a();
            launchUnscoped_0(tmp_5, SceneContainer$_changeTo$slambda_10(this.ram_1, null));
            return this.ram_1;
          case 10:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 10) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function SceneContainer(views, defaultTransition, name, size) {
    Companion_getInstance_88();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), Companion_getInstance_12().m28()) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.c9g_1.n() : size;
    UIView.call(this, size);
    this.t9l_1 = views;
    this.u9l_1 = defaultTransition;
    this.o9h_1 = name;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new TransitionView();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    this.pag(this_0);
    tmp.v9l_1 = this_0;
    this.w9l_1 = null;
    var tmp_0 = Companion_instance_68;
    this.h7m(tmp_0, SceneContainer$lambda(this));
    this.x9l_1 = arrayListOf([Companion_getInstance_88().yai_1]);
    this.y9l_1 = 0;
  }
  protoOf(SceneContainer).w1a = function () {
    return this.t9l_1.p9e_1;
  };
  protoOf(SceneContainer).jap = function () {
    var tmp0_safe_receiver = this.w9l_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jah(new Size2D(this.x1q(), this.y1q()));
    }
  };
  protoOf(SceneContainer).kap = function (clazz, injects, time, transition, $completion) {
    this.lap(new VisitEntry(clazz, toList_0(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  };
  protoOf(SceneContainer).z9l = function (clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.u9l_1 : transition;
    return $super === VOID ? this.kap(clazz, injects, time, transition, $completion) : $super.kap.call(this, clazz, injects, new Duration(time), transition, $completion);
  };
  protoOf(SceneContainer).vaj = function (newScene, time, transition, $completion) {
    var tmp = new $_changeToCOROUTINE$9(this, newScene, time, transition, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(SceneContainer).lap = function (entry) {
    while (this.x9l_1.n() <= this.y9l_1) {
      this.x9l_1.r(Companion_getInstance_88().yai_1);
    }
    this.x9l_1.o(this.y9l_1, entry);
  };
  function ratio$factory($b0) {
    return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
      return new Ratio($b0.eap_1);
    }, function (value) {
      $b0.eap_1 = value.z27_1;
      return Unit_instance;
    });
  }
  function get_AlphaTransition() {
    _init_properties_Transition_kt__s6zoln();
    return AlphaTransition;
  }
  var AlphaTransition;
  function Transition(name, render) {
    name = name === VOID ? 'Transition' : name;
    _init_properties_Transition_kt__s6zoln();
    return new Transition$1(render, name);
  }
  function TransitionProcess() {
  }
  function withEasing(_this__u8e3s4, easing) {
    _init_properties_Transition_kt__s6zoln();
    return new withEasing$1(_this__u8e3s4, easing);
  }
  function _get_transitionProcess__5hlux5($this) {
    var tmp = $this.gap_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('transitionProcess');
    }
  }
  function TransitionView() {
    Container.call(this);
    dummyView(this);
    dummyView(this);
    this.eap_1 = Companion_getInstance_15().a28_1;
    this.fap_1 = get_AlphaTransition();
  }
  protoOf(TransitionView).qay = function () {
    return this.f1(0);
  };
  protoOf(TransitionView).ray = function () {
    return this.f1(1);
  };
  protoOf(TransitionView).hap = function (next, transition) {
    this.fap_1 = transition;
    this.eap_1 = Companion_getInstance_15().a28_1;
    this.gap_1 = transition.say();
    this.tay(this.ray(), next);
    _get_transitionProcess__5hlux5(this).nay(this.qay(), this.ray());
  };
  protoOf(TransitionView).toString = function () {
    return protoOf(Container).toString.call(this) + (':ratio=' + new Ratio(this.eap_1) + ':transition=' + this.fap_1);
  };
  protoOf(TransitionView).iap = function () {
    this.eap_1 = Companion_getInstance_15().d28_1;
    _get_transitionProcess__5hlux5(this).oay(this.qay(), this.ray());
    this.tay(dummyView(this), this.ray());
  };
  protoOf(TransitionView).tay = function (prev, next) {
    this.oav();
    this.pav(prev);
    this.pav(next);
  };
  protoOf(TransitionView).mas = function (ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.eap_1, Companion_getInstance_15().a28_1) <= 0) {
      this.qay().ias(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.eap_1, Companion_getInstance_15().d28_1) >= 0) {
      this.ray().ias(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).pay(ctx, this.qay(), this.ray(), this.eap_1);
    }
  };
  function AlphaTransition$lambda(ctx, prev, next, ratio) {
    _init_properties_Transition_kt__s6zoln();
    var prevAlpha = prev.zaw();
    var nextAlpha = next.zaw();
    try {
      prev.yaw(1.0 - Ratio__toFloat_impl_1ftup5(ratio.z27_1));
      next.yaw(Ratio__toFloat_impl_1ftup5(ratio.z27_1));
      prev.ias(ctx);
      next.ias(ctx);
    }finally {
      prev.yaw(prevAlpha);
      next.yaw(nextAlpha);
    }
    return Unit_instance;
  }
  function Transition$1($render, $name) {
    this.uay_1 = $render;
    this.vay_1 = $name;
  }
  protoOf(Transition$1).say = function () {
    return this;
  };
  protoOf(Transition$1).pay = function (ctx, prev, next, ratio) {
    return this.uay_1(ctx, prev, next, new Ratio(ratio));
  };
  protoOf(Transition$1).toString = function () {
    return this.vay_1;
  };
  function withEasing$1$create$1($process, $easing) {
    this.way_1 = $process;
    this.xay_1 = $easing;
  }
  protoOf(withEasing$1$create$1).nay = function (prev, next) {
    return this.way_1.nay(prev, next);
  };
  protoOf(withEasing$1$create$1).oay = function (prev, next) {
    return this.way_1.oay(prev, next);
  };
  protoOf(withEasing$1$create$1).pay = function (ctx, prev, next, ratio) {
    return this.way_1.pay(ctx, prev, next, this.xay_1.p28(ratio));
  };
  function withEasing$1($this_withEasing, $easing) {
    this.yay_1 = $this_withEasing;
    this.zay_1 = $easing;
  }
  protoOf(withEasing$1).toString = function () {
    return '' + this.yay_1 + '.withEasing';
  };
  protoOf(withEasing$1).say = function () {
    var process = this.yay_1.say();
    return new withEasing$1$create$1(process, this.zay_1);
  };
  var properties_initialized_Transition_kt_wb2qvd;
  function _init_properties_Transition_kt__s6zoln() {
    if (!properties_initialized_Transition_kt_wb2qvd) {
      properties_initialized_Transition_kt_wb2qvd = true;
      AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
    }
  }
  function Counter(name) {
    this.aaz_1 = name;
    this.baz_1 = 0.0;
    this.caz_1 = 0;
    this.daz_1 = 0.0;
  }
  protoOf(Counter).eaz = function () {
    return this.daz_1 / this.baz_1;
  };
  protoOf(Counter).faz = function (count) {
    this.caz_1 = this.caz_1 + count | 0;
  };
  protoOf(Counter).s7u = function () {
    this.daz_1 = this.daz_1 + this.caz_1;
    this.baz_1 = this.baz_1 + 1;
    this.caz_1 = 0;
  };
  protoOf(Counter).toString = function () {
    return 'Counter(' + this.aaz_1 + '): [frames=' + this.baz_1 + ', totalCount=' + this.daz_1 + ', countThisFrame=' + this.caz_1 + ', avgCountPerFrame=' + this.eaz() + ']';
  };
  function RCollection() {
    this.gaz_1 = ArrayList_init_$Create$();
    this.haz_1 = LinkedHashMap_init_$Create$_0();
  }
  function Stats() {
    this.iaz_1 = new RCollection();
    this.jaz_1 = new RCollection();
  }
  protoOf(Stats).s7u = function () {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.iaz_1.gaz_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      this_0.f1(tmp0).s7u();
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.jaz_1.gaz_1;
    var n_0 = 0;
    while (n_0 < this_1.n()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      this_1.f1(tmp0_0).s7u();
    }
  };
  protoOf(Stats).naz = function (name) {
    // Inline function 'korlibs.korge.stat.RCollection.getOrPut' call
    var this_0 = this.iaz_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var this_1 = this_0.haz_1;
    var value = this_1.s2(name);
    var tmp;
    if (value == null) {
      // Inline function 'korlibs.korge.stat.RCollection.getOrPut.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'korlibs.korge.stat.Stats.counter.<anonymous>' call
      var this_2 = new Counter(name);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.stat.RCollection.getOrPut.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      this_0.gaz_1.r(this_2);
      var answer = this_2;
      this_1.i2(name, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  };
  function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
    return $median$delegate.lh(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
  }
  function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
    $this$FUNC.f8b($this$FUNC.y8v($this$FUNC.x8v(a, b), $this$FUNC.x8v($this$FUNC.y8v(a, b), c)));
    return Unit_instance;
  }
  function MsdfRender$createProgram$lambda_0($$this$buildShader) {
    return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
      $this$IF_ELSE_BINARY_LOOKUP.y89($this$IF_ELSE_BINARY_LOOKUP.b8a(), $this$IF_ELSE_BINARY_LOOKUP.j8a(Companion_getInstance_85().n9c_1[n], $this$IF_ELSE_BINARY_LOOKUP.h8a($$this$buildShader.u89(), 'xy')));
      return Unit_instance;
    };
  }
  function MsdfRender() {
    MsdfRender_instance = this;
    this.oaz_1 = this.saz(true, VOID, false);
    this.paz_1 = this.saz(true, VOID, true);
    this.qaz_1 = this.taz(false, 'r', false);
    this.raz_1 = this.taz(false, 'a', false);
  }
  protoOf(MsdfRender).taz = function (msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_85().w9c_1;
    var tmp2_name = name == null ? Companion_getInstance_85().w9c_1.n82_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = this_0.i8b();
    var tmp_0 = this_0.i8b();
    var tmp_1 = this_0.i8b();
    var tmp_2 = this_0.i8b();
    var median$delegate = this_0.y8a(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).t89(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_85().t9c_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.c8b(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.r8b(this_0.m8a());
    var alpha = this_0.s8b(this_0.m8a());
    this_0.y89(this_0.b8a(), this_0.w8b(this_0.b8a(), this_0.f8a([this_0.e8a(0.5)])));
    if (msdf) {
      this_0.y89(d, this_0.a8b(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), this_0.h8a(this_0.b8a(), 'r'), this_0.h8a(this_0.b8a(), 'g'), this_0.h8a(this_0.b8a(), 'b')));
    } else {
      this_0.y89(d, this_0.h8a(this_0.b8a(), sdf));
    }
    this_0.y89(alpha, this_0.z8a(SDFShaders_getInstance().aad(), d));
    if (inverted) {
      this_0.y89(alpha, this_0.w8b(this_0.e8a(1.0), alpha));
    }
    this_0.y89(this_0.b8a(), this_0.c8a(this_0.z89(), alpha));
    var tmp3_fragment = FragmentShader(this_0.g8a());
    return tmp1_$this.v8w(VOID, tmp3_fragment, tmp2_name);
  };
  protoOf(MsdfRender).saz = function (msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.taz(msdf, sdf, inverted) : $super.taz.call(this, msdf, sdf, inverted);
  };
  var MsdfRender_instance;
  function MsdfRender_getInstance() {
    if (MsdfRender_instance == null)
      new MsdfRender();
    return MsdfRender_instance;
  }
  function get_DEFAULT_EASING() {
    _init_properties_tween_kt__1g7sex();
    return DEFAULT_EASING;
  }
  var DEFAULT_EASING;
  function get_DEFAULT_TIME() {
    _init_properties_tween_kt__1g7sex();
    return DEFAULT_TIME;
  }
  var DEFAULT_TIME;
  function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
    time = time === VOID ? get_DEFAULT_TIME() : time;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    waitTime = waitTime === VOID ? get_NIL(Companion_getInstance()) : waitTime;
    timeout = timeout === VOID ? false : timeout;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    var tmp;
    if (callback === VOID) {
      tmp = tween$lambda;
    } else {
      tmp = callback;
    }
    callback = tmp;
    var tmp_0 = new $tweenCOROUTINE$12(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion);
    tmp_0.hd_1 = Unit_instance;
    tmp_0.id_1 = null;
    return tmp_0.qd();
  }
  function _update($this, dt) {
    if ($this.sb0_1) {
      $this.lb0_1.t9x();
    }
    if ($this.vb0_1) {
      return $this.db1();
    }
    $this.tb0_1 = Duration__plus_impl_yu9v8f($this.tb0_1, dt);
    var ratio = clamp(Duration__div_impl_dknbf4($this.tb0_1, $this.ub0_1), 0.0, 1.0);
    $this.eb1($this.tb0_1);
    $this.pb0_1($this.ob0_1.n28(ratio));
    if (!equals($this.rb0_1, get_NIL(Companion_getInstance())) ? Duration__compareTo_impl_pchp0f($this.tb0_1, $this.rb0_1) >= 0 : false) {
      $this.fb1();
    }
    if (ratio >= 1.0) {
      return $this.db1();
    }
  }
  function TweenComponent$updater$lambda(this$0) {
    return function (it) {
      _update(this$0, it.ib1_1);
      return Unit_instance;
    };
  }
  function TweenComponent$lambda(this$0) {
    return function (it) {
      this$0.vb0_1 = true;
      return Unit_instance;
    };
  }
  function TweenComponent(view, vs, time, easing, callback, c, waitTime, autoInvalidate) {
    time = time === VOID ? get_NIL(Companion_getInstance()) : time;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    waitTime = waitTime === VOID ? get_NIL(Companion_getInstance()) : waitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.lb0_1 = view;
    this.mb0_1 = vs;
    this.nb0_1 = time;
    this.ob0_1 = easing;
    this.pb0_1 = callback;
    this.qb0_1 = c;
    this.rb0_1 = waitTime;
    this.sb0_1 = autoInvalidate;
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp.tb0_1 = toDuration(0.0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_0 = this;
    var tmp_1;
    if (!equals(this.nb0_1, get_NIL(Companion_getInstance()))) {
      tmp_1 = this.nb0_1;
    } else {
      // Inline function 'korlibs.time.nanoseconds' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.mb0_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$1 = get_nanoseconds(item.m9x_1);
        destination.r(tmp$ret$1);
      }
      var tmp0_elvis_lhs = maxOrNull_0(destination);
      var this_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
      tmp_1 = toDuration(this_1, DurationUnit_NANOSECONDS_getInstance());
    }
    tmp_0.ub0_1 = tmp_1;
    this.vb0_1 = false;
    this.wb0_1 = false;
    this.xb0_1 = false;
    var tmp_2 = this;
    var tmp_3 = Companion_instance_85;
    tmp_2.yb0_1 = this.lb0_1.h7m(tmp_3, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.qb0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c1e(TweenComponent$lambda(this));
    }
    _update(this, Companion_getInstance().va_1);
  }
  protoOf(TweenComponent).fb1 = function () {
    if (this.xb0_1)
      return Unit_instance;
    this.xb0_1 = true;
    var tmp0_safe_receiver = this.qb0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.s6(tmp$ret$0);
    }
  };
  protoOf(TweenComponent).db1 = function () {
    if (this.wb0_1)
      return Unit_instance;
    this.wb0_1 = true;
    var tmp0_safe_receiver = this.yb0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p21();
    }
    this.yb0_1 = null;
    this.fb1();
  };
  protoOf(TweenComponent).eb1 = function (elapsed) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    if (equals(elapsed, tmp$ret$1)) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.mb0_1;
      var n = 0;
      while (n < this_0.n()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        this_0.f1(tmp0).i78();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.mb0_1;
    var n_0 = 0;
    while (n_0 < this_1.n()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      var v = this_1.f1(tmp0_0);
      // Inline function 'korlibs.time.coalesce' call
      var this_2 = v.k9x_1;
      var tmp;
      if (!equals(this_2, get_NIL(Companion_getInstance()))) {
        tmp = this_2;
      } else {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>.<anonymous>' call
        tmp = Duration__minus_impl_q5cfm7(this.ub0_1, v.j9x_1);
      }
      var durationInTween = tmp;
      var tmp_0 = Duration__minus_impl_q5cfm7(elapsed, v.j9x_1);
      // Inline function 'korlibs.time.milliseconds' call
      var tmp$ret$4 = toDuration(0.0, DurationUnit_MILLISECONDS_getInstance());
      var elapsedInTween = clamp_0(tmp_0, tmp$ret$4, durationInTween);
      var ratioInTween = (Duration__compareTo_impl_pchp0f(durationInTween, Companion_getInstance().va_1) <= 0 ? true : Duration__compareTo_impl_pchp0f(elapsedInTween, durationInTween) >= 0) ? 1.0 : Duration__div_impl_dknbf4(elapsedInTween, durationInTween);
      var easedRatioInTween = this.ob0_1.o28(ratioInTween);
      v.o9x(toRatio(easedRatioInTween));
    }
  };
  protoOf(TweenComponent).toString = function () {
    return 'TweenComponent(' + this.lb0_1 + ')';
  };
  function tween$lambda(it) {
    _init_properties_tween_kt__1g7sex();
    return Unit_instance;
  }
  function tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate, resultContinuation) {
    this.rb1_1 = $this_tween;
    this.sb1_1 = $tc;
    this.tb1_1 = $vs;
    this.ub1_1 = $time;
    this.vb1_1 = $easing;
    this.wb1_1 = $callback;
    this.xb1_1 = $waitTime;
    this.yb1_1 = $autoInvalidate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(tween$slambda).e5m = function ($this$withTimeoutNullable, $completion) {
    var tmp = this.t5l($this$withTimeoutNullable, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(tween$slambda).ne = function (p1, $completion) {
    return this.e5m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(tween$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            var cancellable = new CancellableContinuationImpl(intercepted(this), get_MODE_CANCELLABLE());
            cancellable.m1f();
            var view = this.rb1_1;
            this.sb1_1._v = new TweenComponent(view, toList_0(this.tb1_1), this.ub1_1, this.vb1_1, this.wb1_1, cancellable, this.xb1_1, this.yb1_1);
            suspendResult = returnIfSuspended(cancellable.y1c(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(tween$slambda).t5l = function ($this$withTimeoutNullable, completion) {
    var i = new tween$slambda(this.rb1_1, this.sb1_1, this.tb1_1, this.ub1_1, this.vb1_1, this.wb1_1, this.xb1_1, this.yb1_1, completion);
    i.zb1_1 = $this$withTimeoutNullable;
    return i;
  };
  function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate, resultContinuation) {
    var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate, resultContinuation);
    var l = function ($this$withTimeoutNullable, $completion) {
      return i.e5m($this$withTimeoutNullable, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $tweenCOROUTINE$12(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cb0_1 = _this__u8e3s4;
    this.db0_1 = vs;
    this.eb0_1 = time;
    this.fb0_1 = easing;
    this.gb0_1 = waitTime;
    this.hb0_1 = timeout;
    this.ib0_1 = autoInvalidate;
    this.jb0_1 = callback;
  }
  protoOf($tweenCOROUTINE$12).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 5;
            if (!(this.cb0_1 == null)) {
              this.kb0_1 = {_v: null};
              this.gd_1 = 2;
              this.fd_1 = 1;
              var tmp_0;
              if (this.hb0_1) {
                var tmp_1 = Duration__times_impl_sfuzvp_0(this.eb0_1, 2);
                Companion_getInstance();
                tmp_0 = Duration__plus_impl_yu9v8f(tmp_1, toDuration(300, DurationUnit_MILLISECONDS_getInstance()));
              } else {
                tmp_0 = get_NIL(Companion_getInstance());
              }
              var tmp_2 = tmp_0;
              suspendResult = withTimeoutNullable(tmp_2, tween$slambda_0(this.cb0_1, this.kb0_1, this.db0_1, this.eb0_1, this.fb0_1, this.jb0_1, this.gb0_1, this.ib0_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 4;
              continue $sm;
            }

          case 1:
            this.gd_1 = 5;
            this.fd_1 = 3;
            continue $sm;
          case 2:
            this.gd_1 = 5;
            var tmp_3 = this.id_1;
            if (tmp_3 instanceof TimeoutCancellationException) {
              var e = this.id_1;
              var tmp0_safe_receiver = this.kb0_1._v;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.eb1(this.eb0_1);
              }
              this.fd_1 = 3;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 3:
            this.gd_1 = 5;
            this.fd_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.id_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 5) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  var properties_initialized_tween_kt_p0n8nv;
  function _init_properties_tween_kt__1g7sex() {
    if (!properties_initialized_tween_kt_p0n8nv) {
      properties_initialized_tween_kt_p0n8nv = true;
      DEFAULT_EASING = Companion_getInstance_12().m28();
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    }
  }
  function V2(key, initial, end, interpolator, includeStart, startTime, duration, initialization) {
    var tmp;
    if (startTime === VOID) {
      // Inline function 'korlibs.time.nanoseconds' call
      // Inline function 'korlibs.time.nanoseconds' call
      tmp = toDuration(0, DurationUnit_NANOSECONDS_getInstance());
    } else {
      tmp = startTime;
    }
    startTime = tmp;
    duration = duration === VOID ? get_NIL(Companion_getInstance()) : duration;
    initialization = initialization === VOID ? null : initialization;
    this.e9x_1 = key;
    this.f9x_1 = initial;
    this.g9x_1 = end;
    this.h9x_1 = interpolator;
    this.i9x_1 = includeStart;
    this.j9x_1 = startTime;
    this.k9x_1 = duration;
    this.l9x_1 = initialization;
    var tmp_0 = this;
    // Inline function 'korlibs.time.coalesce' call
    var this_0 = this.k9x_1;
    var tmp_1;
    if (!equals(this_0, get_NIL(Companion_getInstance()))) {
      tmp_1 = this_0;
    } else {
      // Inline function 'korlibs.korge.tween.V2.endTime.<anonymous>' call
      // Inline function 'korlibs.time.nanoseconds' call
      // Inline function 'korlibs.time.nanoseconds' call
      tmp_1 = toDuration(0, DurationUnit_NANOSECONDS_getInstance());
    }
    var tmp$ret$5 = tmp_1;
    tmp_0.m9x_1 = Duration__plus_impl_yu9v8f(this.j9x_1, tmp$ret$5);
  }
  protoOf(V2).n9x = function (default_0) {
    return get_isNil(this.k9x_1) ? default_0 : this.m9x_1;
  };
  protoOf(V2).i78 = function () {
    if (!this.i9x_1) {
      this.f9x_1 = this.e9x_1.get();
    }
    var tmp0_safe_receiver = this.l9x_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  };
  protoOf(V2).o9x = function (ratio) {
    this.e9x_1.set(this.h9x_1(new Ratio(ratio), this.f9x_1, this.g9x_1));
  };
  protoOf(V2).toString = function () {
    return 'V2(key=' + this.e9x_1.callableName + ', range=[' + this.f9x_1 + '-' + this.g9x_1 + '], startTime=' + new Duration(this.j9x_1) + ', duration=' + new Duration(this.k9x_1) + ')';
  };
  protoOf(V2).hashCode = function () {
    var result = hashCode(this.e9x_1);
    result = imul(result, 31) + (this.f9x_1 == null ? 0 : hashCode(this.f9x_1)) | 0;
    result = imul(result, 31) + (this.g9x_1 == null ? 0 : hashCode(this.g9x_1)) | 0;
    result = imul(result, 31) + hashCode(this.h9x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i9x_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.j9x_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.k9x_1) | 0;
    result = imul(result, 31) + (this.l9x_1 == null ? 0 : hashCode(this.l9x_1)) | 0;
    return result;
  };
  protoOf(V2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals(this.e9x_1, tmp0_other_with_cast.e9x_1))
      return false;
    if (!equals(this.f9x_1, tmp0_other_with_cast.f9x_1))
      return false;
    if (!equals(this.g9x_1, tmp0_other_with_cast.g9x_1))
      return false;
    if (!equals(this.h9x_1, tmp0_other_with_cast.h9x_1))
      return false;
    if (!(this.i9x_1 === tmp0_other_with_cast.i9x_1))
      return false;
    if (!equals(this.j9x_1, tmp0_other_with_cast.j9x_1))
      return false;
    if (!equals(this.k9x_1, tmp0_other_with_cast.k9x_1))
      return false;
    if (!equals(this.l9x_1, tmp0_other_with_cast.l9x_1))
      return false;
    return true;
  };
  function _interpolateRatio(ratio, l, r) {
    return interpolate(ratio, l, r);
  }
  function registerUISupportOnce($this) {
    if ($this.fas_1)
      return Unit_instance;
    var tmp0_elvis_lhs = $this.bax();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stage = tmp;
    $this.fas_1 = true;
    if (equals(getExtra(stage, 'uiSupport'), true))
      return Unit_instance;
    setExtra(stage, 'uiSupport', true);
    // Inline function 'korlibs.korge.input.keys' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
    get_keys_0(stage);
  }
  function Companion_63() {
    Companion_instance_77 = this;
    this.ab2_1 = 90.0;
    this.bb2_1 = 32.0;
    this.cb2_1 = Size2D_init_$Create$_0(90.0, 32.0);
  }
  var Companion_instance_77;
  function Companion_getInstance_89() {
    if (Companion_instance_77 == null)
      new Companion_63();
    return Companion_instance_77;
  }
  function UIView(size, cache) {
    Companion_getInstance_89();
    size = size === VOID ? Companion_getInstance_89().cb2_1 : size;
    cache = cache === VOID ? false : cache;
    FixedSizeCachedContainer.call(this, size, cache, false);
    this.eas_1 = size;
    this.fas_1 = false;
  }
  protoOf(UIView).gas = function (value) {
    if (!this.eas_1.equals(value)) {
      this.eas_1 = value;
      this.jap();
    }
  };
  protoOf(UIView).has = function () {
    return this.eas_1;
  };
  protoOf(UIView).jas = function () {
    return new RectangleD(0.0, 0.0, this.x1q(), this.y1q());
  };
  protoOf(UIView).jap = function () {
    var tmp0_safe_receiver = this.r40();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.kav(this);
    }
  };
  protoOf(UIView).kas = function () {
    protoOf(FixedSizeCachedContainer).kas.call(this);
    this.las();
  };
  protoOf(UIView).las = function () {
    this.fav();
  };
  protoOf(UIView).mas = function (ctx) {
    registerUISupportOnce(this);
    protoOf(FixedSizeCachedContainer).mas.call(this, ctx);
  };
  function anchor(_this__u8e3s4, anchor) {
    _this__u8e3s4.vb4(anchor);
    return _this__u8e3s4;
  }
  function clearBitmaps($this, onParentChanged) {
    if ($this.ib7_1.b1())
      return Unit_instance;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = $this.ib7_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.korge.view.BaseGraphics.clearBitmaps.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = this_0.f1(tmp0);
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(it, get_bmp(tmp$ret$0))) {
        var tmp0_safe_receiver = $this.nb7_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g9t_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.aa7(it, 'BaseGraphics');
        }
      }
    }
    $this.ib7_1.b3();
  }
  function _get_bitmapWidth__ndy7bu($this) {
    return $this.m50().x1q();
  }
  function _get_bitmapHeight__5t1vx1($this) {
    return $this.m50().y1q();
  }
  function _getLocalBoundsInternal($this, strokes) {
    var bounds = boundsUnsafe($this, strokes);
    return new RectangleD(bounds.l2d_1 - $this.yav(), bounds.m2d_1 - $this.zav(), bounds.n2d_1, bounds.o2d_1);
  }
  function _getLocalBoundsInternal$default($this, strokes, $super) {
    strokes = strokes === VOID ? $this.rb7_1 : strokes;
    return _getLocalBoundsInternal($this, strokes);
  }
  function boundsUnsafe($this, strokes) {
    if ($this.mb7_1) {
      $this.mb7_1 = false;
      $this.tb7_1 = $this.cba(false);
      $this.sb7_1 = $this.cba(true);
    }
    return strokes ? $this.sb7_1 : $this.tb7_1;
  }
  function InternalViewAutoscaling() {
    this.dba_1 = 1.0;
    this.eba_1 = 1.0;
    this.fba_1 = 1.0;
    this.gba_1 = 1.0;
    this.hba_1 = 1.0;
    this.iba_1 = MatrixTransform_init_$Create$();
  }
  protoOf(InternalViewAutoscaling).jba = function (autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.iba_1 = globalMatrix.v2g();
      // Inline function 'kotlin.math.abs' call
      var x = this.iba_1.l2h_1;
      var sx = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = this.iba_1.m2h_1;
      var sy = Math.abs(x_0);
      // Inline function 'kotlin.math.max' call
      var sxy = Math.max(sx, sy);
      // Inline function 'kotlin.math.abs' call
      var x_1 = sx / this.fba_1 - 1.0;
      var diffX = Math.abs(x_1);
      // Inline function 'kotlin.math.abs' call
      var x_2 = sy / this.gba_1 - 1.0;
      var diffY = Math.abs(x_2);
      var tmp;
      switch (autoScalingPrecise) {
        case true:
          tmp = diffX > 0.0 ? true : diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 ? true : diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.fba_1 = sx;
        this.gba_1 = sy;
        this.hba_1 = sxy;
        this.dba_1 = 1.0 / sx;
        this.eba_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.fba_1 = 1.0;
      this.gba_1 = 1.0;
      this.hba_1 = 1.0;
      this.dba_1 = 1.0;
      this.eba_1 = 1.0;
    }
    return false;
  };
  function BaseGraphics(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    BaseImage_init_$Init$(tmp$ret$0, VOID, VOID, VOID, this);
    this.eb7_1 = autoScaling;
    this.fb7_1 = true;
    this.gb7_1 = false;
    this.hb7_1 = false;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.ib7_1 = ArrayList_init_$Create$();
    this.jb7_1 = new InternalViewAutoscaling();
    this.kb7_1 = 1;
    this.lb7_1 = true;
    this.mb7_1 = true;
    this.nb7_1 = null;
    this.ob7_1 = 1.0;
    this.pb7_1 = 1.0;
    this.qb7_1 = true;
    this.rb7_1 = true;
    this.sb7_1 = Companion_getInstance_5().h2f();
    this.tb7_1 = Companion_getInstance_5().h2f();
  }
  protoOf(BaseGraphics).kba = function (value) {
    this.fb7_1 = value;
    this.lba();
  };
  protoOf(BaseGraphics).lba = function () {
    this.lb7_1 = true;
    this.mb7_1 = true;
    this.max();
  };
  protoOf(BaseGraphics).kas = function () {
    protoOf(BaseImage).kas.call(this);
    if (this.r40() == null ? true : this.bax() == null) {
      var tmp = this.m50().v2x();
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp, get_bmp(tmp$ret$0))) {
        this.ib7_1.r(this.m50().v2x());
      }
      clearBitmaps(this, true);
    }
  };
  protoOf(BaseGraphics).mas = function (ctx) {
    this.nb7_1 = ctx;
    clearBitmaps(this, false);
    this.mba();
    protoOf(BaseImage).mas.call(this, ctx);
  };
  protoOf(BaseGraphics).mba = function () {
    if (this.jb7_1.jba(this.eb7_1, this.gb7_1, this.gax())) {
      this.lb7_1 = true;
    }
    if (!this.lb7_1)
      return false;
    this.lb7_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>' call
    this.ib7_1.r(this.m50().v2x());
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var imageWidth = coerceAtLeast(toIntCeil(boundsWithShapes.n2d_1 * this.jb7_1.fba_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(boundsWithShapes.o2d_1 * this.jb7_1.gba_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.kb7_1 | 0, imageHeight + this.kb7_1 | 0, this.fb7_1, true);
    this.ob7_1 = this.jb7_1.fba_1;
    this.pb7_1 = this.jb7_1.gba_1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.y39_1;
    if (true) {
      image.h3a();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.d3i(true);
      try {
        // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>.<anonymous>' call
        ctx.k4r(this.ob7_1, this.pb7_1);
        ctx.o46(-boundsWithShapes.l2d_1, -boundsWithShapes.m2d_1);
        this.nba(ctx);
      }finally {
        ctx.f1e();
      }
    }finally {
      result = true ? image.z3a(rect) : 0;
    }
    this.oba(slice(image));
    return true;
  };
  protoOf(BaseGraphics).pba = function () {
    return _get_bitmapWidth__ndy7bu(this) / this.ob7_1;
  };
  protoOf(BaseGraphics).qba = function () {
    return _get_bitmapHeight__5t1vx1(this) / this.pb7_1;
  };
  protoOf(BaseGraphics).y2x = function () {
    return this.pba();
  };
  protoOf(BaseGraphics).z2x = function () {
    return this.qba();
  };
  protoOf(BaseGraphics).yav = function () {
    return this.xbc().p2c_1 * this.pba();
  };
  protoOf(BaseGraphics).zav = function () {
    return this.xbc().q2c_1 * this.qba();
  };
  protoOf(BaseGraphics).ybc = function () {
    return _getLocalBoundsInternal(this, this.qb7_1).l2d_1;
  };
  protoOf(BaseGraphics).zbc = function () {
    return _getLocalBoundsInternal(this, this.qb7_1).m2d_1;
  };
  protoOf(BaseGraphics).jas = function () {
    return _getLocalBoundsInternal$default(this);
  };
  function BaseView() {
    BaseEventListener.call(this);
  }
  protoOf(BaseView).t9x = function () {
  };
  function Companion_64() {
    Companion_instance_78 = this;
    var tmp = this;
    var tmp0_factors = Companion_getInstance_54().f7v_1;
    tmp.z9x_1 = new BlendMode(tmp0_factors, 'NORMAL');
    this.a9y_1 = this.z9x_1.hbd(VOID, 'INHERIT');
    var tmp_0 = this;
    var tmp0_factors_0 = Companion_getInstance_54().v84(Companion_getInstance_60().m84_1, Companion_getInstance_60().t84_1);
    tmp_0.b9y_1 = new BlendMode(tmp0_factors_0, 'NONE');
    var tmp_1 = this;
    var tmp0_factors_1 = Companion_getInstance_54().h7v_1;
    tmp_1.c9y_1 = new BlendMode(tmp0_factors_1, 'ADD');
    var tmp_2 = this;
    var tmp0_factors_2 = Companion_getInstance_54().v84(Companion_getInstance_60().l84_1, Companion_getInstance_60().p84_1);
    tmp_2.d9y_1 = new BlendMode(tmp0_factors_2, 'MULTIPLY');
    var tmp_3 = this;
    var tmp0_factors_3 = Companion_getInstance_54().v84(Companion_getInstance_60().m84_1, Companion_getInstance_60().q84_1);
    tmp_3.e9y_1 = new BlendMode(tmp0_factors_3, 'SCREEN');
    var tmp_4 = this;
    var tmp0_factors_4 = Companion_getInstance_54().v84(Companion_getInstance_60().t84_1, Companion_getInstance_60().p84_1);
    tmp_4.f9y_1 = new BlendMode(tmp0_factors_4, 'ERASE');
    var tmp_5 = this;
    var tmp0_factors_5 = Companion_getInstance_54().v84(Companion_getInstance_60().t84_1, Companion_getInstance_60().r84_1);
    tmp_5.g9y_1 = new BlendMode(tmp0_factors_5, 'MASK');
    var tmp_6 = this;
    var tmp0_factors_6 = Companion_getInstance_54().v84(Companion_getInstance_60().n84_1, Companion_getInstance_60().k84_1);
    tmp_6.h9y_1 = new BlendMode(tmp0_factors_6, 'BELOW');
    var tmp_7 = this;
    var tmp0_factors_7 = Companion_getInstance_54().u84(Companion_getInstance_60().r84_1, Companion_getInstance_60().k84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1, Companion_getInstance_61().z84_1);
    tmp_7.i9y_1 = new BlendMode(tmp0_factors_7, 'SUBTRACT');
    var tmp_8 = this;
    var tmp0_factors_8 = Companion_getInstance_54().u84(Companion_getInstance_60().o84_1, Companion_getInstance_60().t84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1);
    tmp_8.j9y_1 = new BlendMode(tmp0_factors_8, 'INVERT');
    var tmp_9 = this;
    var tmp0_factors_9 = Companion_getInstance_54().u84(Companion_getInstance_60().r84_1, Companion_getInstance_60().k84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1);
    tmp_9.k9y_1 = new BlendMode(tmp0_factors_9, 'LIGHTEN');
    var tmp_10 = this;
    var tmp0_factors_10 = Companion_getInstance_54().u84(Companion_getInstance_60().r84_1, Companion_getInstance_60().k84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1);
    tmp_10.l9y_1 = new BlendMode(tmp0_factors_10, 'DARKEN');
    var tmp_11 = this;
    var tmp0_factors_11 = Companion_getInstance_54().u84(Companion_getInstance_60().r84_1, Companion_getInstance_60().k84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1);
    tmp_11.m9y_1 = new BlendMode(tmp0_factors_11, 'DIFFERENCE');
    var tmp_12 = this;
    var tmp0_factors_12 = Companion_getInstance_54().u84(Companion_getInstance_60().r84_1, Companion_getInstance_60().k84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1);
    tmp_12.n9y_1 = new BlendMode(tmp0_factors_12, 'ALPHA');
    var tmp_13 = this;
    var tmp0_factors_13 = Companion_getInstance_54().u84(Companion_getInstance_60().r84_1, Companion_getInstance_60().k84_1, Companion_getInstance_60().m84_1, Companion_getInstance_60().m84_1);
    tmp_13.o9y_1 = new BlendMode(tmp0_factors_13, 'HARDLIGHT');
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.p9y_1 = [this.a9y_1, this.b9y_1, this.z9x_1, this.c9y_1, this.d9y_1, this.e9y_1, this.f9y_1, this.g9y_1, this.h9y_1, this.i9y_1, this.j9y_1, this.k9y_1, this.l9y_1, this.m9y_1, this.n9y_1, this.o9y_1];
    var tmp_15 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.p9y_1;
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.view.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$3 = ensureNotNull(element.aa9_1);
      destination.i2(tmp$ret$3, element);
    }
    tmp_15.q9y_1 = destination;
    this.r9y_1 = toList_0(this.p9y_1);
    var tmp_16 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = get_indices(this.p9y_1);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap_init_$Create$(capacity_0);
    var tmp0_iterator = this_1.u();
    while (tmp0_iterator.v()) {
      var element_0 = tmp0_iterator.x();
      // Inline function 'korlibs.korge.view.Companion.TO_ORDINAL.<anonymous>' call
      var tmp$ret$6 = Companion_getInstance_90().p9y_1[element_0];
      destination_0.i2(tmp$ret$6, element_0);
    }
    tmp_16.s9y_1 = destination_0;
  }
  var Companion_instance_78;
  function Companion_getInstance_90() {
    if (Companion_instance_78 == null)
      new Companion_64();
    return Companion_instance_78;
  }
  function BlendMode(factors, name) {
    Companion_getInstance_90();
    name = name === VOID ? null : name;
    this.za8_1 = factors;
    this.aa9_1 = name;
    var tmp = this;
    var tmp_0 = AGBlending__hashCode_impl_ywnf51(this.za8_1);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.aa9_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.ba9_1 = tmp_0 + imul(tmp$ret$0, 7) | 0;
  }
  protoOf(BlendMode).hashCode = function () {
    return this.ba9_1;
  };
  protoOf(BlendMode).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof BlendMode) {
        tmp_1 = this.za8_1 === other.za8_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.aa9_1 == other.aa9_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(BlendMode).toString = function () {
    var tmp0_elvis_lhs = this.aa9_1;
    return tmp0_elvis_lhs == null ? anyToString(this) : tmp0_elvis_lhs;
  };
  protoOf(BlendMode).ibd = function (factors, name) {
    return new BlendMode(factors, name);
  };
  protoOf(BlendMode).hbd = function (factors, name, $super) {
    factors = factors === VOID ? this.za8_1 : factors;
    name = name === VOID ? this.aa9_1 : name;
    return $super === VOID ? this.ibd(factors, name) : $super.ibd.call(this, new AGBlending(factors), name);
  };
  function FixedSizeCachedContainer(size, cache, clip) {
    size = size === VOID ? Size2D_init_$Create$(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    CachedContainer.call(this, cache);
    this.sb4_1 = clip;
    this.tb4_1 = size;
    this.ub4_1 = Ref_0(false);
  }
  protoOf(FixedSizeCachedContainer).gas = function (_set____db54di) {
    this.tb4_1 = _set____db54di;
  };
  protoOf(FixedSizeCachedContainer).has = function () {
    return this.tb4_1;
  };
  protoOf(FixedSizeCachedContainer).jas = function () {
    return new RectangleD(0.0, 0.0, this.x1q(), this.y1q());
  };
  protoOf(FixedSizeCachedContainer).mas = function (ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.sb4_1;
      var renderingInternalRef = this.ub4_1;
      if (renderingInternalRef.m2()) {
        protoOf(CachedContainer).mas.call(this, ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.gax();
        var hasRotation = !(m.k2f_1 === 0.0) ? true : !(m.l2f_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.m2();
          try {
            renderingInternalRef.d1z(true);
            renderFiltered(this, ctx, Companion_getInstance_102());
          }finally {
            renderingInternalRef.d1z(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.n9t_1;
        if (!(ctx.r9t_1 === batcher)) {
          ctx.r9t_1 = batcher;
          ctx.y9z();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.p9t_1;
        var bounds = this.eay(ctx).p2l(ctx.b9t_1).q2l();
        var rect = c2d.qab_1.za7().i86();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.j2l(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_58().b86(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.qab_1;
            var scissor_0 = c2d.zab(scissor);
            var temp = this_0.r9z_1;
            this_0.pa8();
            this_0.r9z_1 = scissor_0;
            try {
              protoOf(CachedContainer).mas.call(this, ctx);
              break $l$block_1;
            }finally {
              this_0.pa8();
              this_0.r9z_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          protoOf(CachedContainer).mas.call(this, ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        protoOf(CachedContainer).mas.call(this, ctx);
      }
    }
  };
  function CacheTexture($outer, ctx) {
    this.nbd_1 = $outer;
    this.jbd_1 = ctx;
    this.kbd_1 = this.jbd_1.nab(16, 16, VOID, VOID, VOID, false);
    this.lbd_1 = TextureBase_init_$Create$(this.kbd_1.p7z(), 16, 16);
    this.mbd_1 = Texture_1(this.lbd_1);
  }
  protoOf(CacheTexture).obd = function (width, height) {
    this.kbd_1.r7z(0, 0, width, height);
    this.lbd_1.ya5(width);
    this.lbd_1.za5(height);
    this.mbd_1 = Texture_1(this.lbd_1);
  };
  protoOf(CacheTexture).p21 = function () {
    this.nbd_1.xau_1 = null;
    this.jbd_1.oab(this.kbd_1);
  };
  function CachedContainer(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    Container.call(this);
    this.vau_1 = cache;
    this.wau_1 = renderQuality;
    this.xau_1 = null;
    this.yau_1 = true;
    this.zau_1 = -1.0;
    this.aav_1 = Companion_getInstance_5().h2f();
    this.bav_1 = Scale_init_$Create$(1);
  }
  protoOf(CachedContainer).t9x = function () {
    protoOf(Container).t9x.call(this);
    this.yau_1 = true;
  };
  protoOf(CachedContainer).mas = function (ctx) {
    if (!this.dax())
      return Unit_instance;
    if (!this.vau_1) {
      return protoOf(Container).mas.call(this, ctx);
    }
    if (this.xau_1 == null) {
      this.xau_1 = new CacheTexture(this, ctx);
      this.yau_1 = true;
    }
    var cache = ensureNotNull(this.xau_1);
    ctx.lab(cache);
    var renderScale = ctx.o9r().ka_1 === 0 ? 1.0 : ctx.zaa();
    var tmp1_elvis_lhs = this.wau_1;
    var doExpensiveScaling = !get_isLow(tmp1_elvis_lhs == null ? ctx.o9r() : tmp1_elvis_lhs);
    if (this.yau_1 ? true : !(this.zau_1 === renderScale)) {
      this.zau_1 = renderScale;
      this.aav_1 = this.may(VOID, false);
      this.bav_1 = doExpensiveScaling ? this.aay().n().h2m(this.aav_1.n()) : Scale_init_$Create$(1);
      this.yau_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.aav_1.n2d_1 * renderScale * this.bav_1.e2g_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.aav_1.o2d_1 * renderScale * this.bav_1.f2g_1), 1);
      cache.obd(texWidth, texHeight);
      ctx.y9z();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.kbd_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.w9t(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.n9t_1;
        var this_1 = this_0.t9y_1;
        if (!(this_1.r9t_1 === this_0)) {
          this_1.r9t_1 = this_0;
          this_1.y9z();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor_init_$Create$(0, 0, frameBuffer.n7w_1, frameBuffer.o7w_1);
          var temp = this_0.r9z_1;
          this_0.pa8();
          this_0.r9z_1 = scissor;
          try {
            if (true) {
              ctx.iab(Colors_getInstance().q3b_1);
            }
            var matrix = this.hax().o2g(-this.aav_1.l2d_1, -this.aav_1.m2d_1).h2g(renderScale * this.bav_1.e2g_1, renderScale * this.bav_1.f2g_1);
            ctx.y9z();
            var temp4 = ctx.a9t_1;
            var temp2d = ctx.b9t_1;
            ctx.b9t_1 = matrix;
            ctx.a9t_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.b82(ProjViewUB_getInstance());
              var tmp1 = this_2.q83();
              this_2.x8n(tmp1 + 1 | 0);
              this_2.l1s(this_2.q83() + 1 | 0);
              var blockSize = this_2.t81_1;
              var index0 = imul(this_2.q83() - 1 | 0, blockSize);
              var index1 = imul(this_2.q83(), blockSize);
              var texBlockSize = this_2.q81_1.f89().n();
              var texIndex0 = imul(this_2.q83() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.q83(), texBlockSize);
              if (this_2.q83() > 0) {
                arraycopy_0(this_2.v81_1, index0, this_2.v81_1, index1, blockSize);
              } else {
                arrayfill_0(this_2.v81_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.q81_1;
              this_2.w81_1.j8o($this$push.e89(), ctx.a9t_1);
              if (true ? this_2.q83() >= 1 : false) {
                var equals = arrayequal(this_2.v81_1, index0, this_2.v81_1, index1, blockSize);
                if (equals) {
                  var tmp3 = this_2.q83();
                  this_2.x8n(tmp3 - 1 | 0);
                  break $l$block;
                }
              }
            }
            var tmp;
            try {
              protoOf(Container).mas.call(this, ctx);
              tmp = Unit_instance;
            }finally {
              ctx.y9z();
              ctx.a9t_1 = temp4;
              ctx.b9t_1 = temp2d;
              ctx.b82(ProjViewUB_getInstance()).y8n();
            }
            break $l$block_0;
          }finally {
            this_0.pa8();
            this_0.r9z_1 = temp;
          }
        }
      }finally {
        ctx.x9t();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.n9t_1;
    var this_4 = this_3.t9y_1;
    if (!(this_4.r9t_1 === this_3)) {
      this_4.r9t_1 = this_3;
      this_4.y9z();
    }
    this_3.aa0(cache.mbd_1, VOID, VOID, VOID, VOID, this.gax().s2g(this.aav_1.l2d_1, this.aav_1.m2d_1).k2g(1.0 / (renderScale * this.bav_1.e2g_1), 1.0 / (renderScale * this.bav_1.f2g_1)), VOID, this.kax(), this.p9h_1);
  };
  protoOf(CachedContainer).cav = function () {
    return this;
  };
  protoOf(CachedContainer).dav = function (view) {
    this.yau_1 = true;
    var tmp0_safe_receiver = this.r40();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n9h_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.dav(view);
    }
  };
  function Camera() {
    Container.call(this);
  }
  protoOf(Camera).gas = function (_anonymous_parameter_0__qggqh8) {
    return Unit_instance;
  };
  protoOf(Camera).has = function () {
    var tmp0_safe_receiver = this.iav();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1q();
    var tmp = tmp1_elvis_lhs == null ? 100.0 : tmp1_elvis_lhs;
    var tmp2_safe_receiver = this.iav();
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.y1q();
    return new Size2D(tmp, tmp3_elvis_lhs == null ? 100.0 : tmp3_elvis_lhs);
  };
  protoOf(Camera).jas = function () {
    return new RectangleD(0.0, 0.0, this.x1q(), this.y1q());
  };
  protoOf(Camera).xbf = function (rect) {
    var destinationBounds = rect;
    var tmp0_safe_receiver = this.r40();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gax();
    return (tmp1_elvis_lhs == null ? Companion_getInstance_14().h2f() : tmp1_elvis_lhs).o2g(-destinationBounds.l2d_1, -destinationBounds.m2d_1).h2g(this.x1q() / destinationBounds.n2d_1, this.y1q() / destinationBounds.o2d_1);
  };
  protoOf(Camera).ybf = function (rect) {
    this.zbf(this.xbf(rect));
  };
  function ZIndexComparator() {
  }
  protoOf(ZIndexComparator).abg = function (a, b) {
    return compareTo(a.jaw(), b.jaw());
  };
  protoOf(ZIndexComparator).compare = function (a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.abg(tmp, b instanceof View ? b : THROW_CCE());
  };
  var ZIndexComparator_instance;
  function ZIndexComparator_getInstance() {
    return ZIndexComparator_instance;
  }
  function Container$renderChildrenInternal$lambda(it) {
    var tmp;
    if (it instanceof FixedSizeContainer) {
      tmp = it.y5j();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function Container(cull) {
    cull = cull === VOID ? false : cull;
    View.call(this, true);
    this.hag_1 = cull;
    this.iag_1 = FastArrayList_init_$Create$();
    this.jag_1 = new ContainerCollection(this, this.iag_1);
    this.kag_1 = null;
    this.lag_1 = new MMatrix();
    this.mag_1 = false;
    this.nag_1 = false;
    this.oag_1 = FastArrayList_init_$Create$();
  }
  protoOf(Container).eav = function () {
    return this.iag_1;
  };
  protoOf(Container).fav = function () {
    protoOf(View).fav.call(this);
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.jag_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.f1(tmp0);
      if (child.r9i_1) {
        child.fav();
      }
    }
  };
  protoOf(Container).gav = function () {
    protoOf(View).gav.call(this);
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.jag_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.f1(tmp0);
      if (child.s9i_1) {
        child.gav();
      }
    }
  };
  protoOf(Container).hav = function () {
    return this.iag_1.n();
  };
  protoOf(Container).iav = function () {
    var tmp = this.r40();
    if (!(tmp == null) ? isInterface(tmp, Reference) : false)
      return this.r40();
    var tmp0_safe_receiver = this.r40();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.iav();
  };
  protoOf(Container).jav = function (view) {
  };
  protoOf(Container).kav = function (view) {
  };
  protoOf(Container).kas = function () {
    protoOf(View).kas.call(this);
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.eav();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.n()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        tmp0_safe_receiver.f1(tmp0).oax();
      }
      tmp = Unit_instance;
    }
  };
  protoOf(Container).lav = function (index) {
    return this.iag_1.f1(index);
  };
  protoOf(Container).mav = function (index) {
    return getOrNull_0(this.iag_1, index);
  };
  protoOf(Container).nav = function (index) {
    return this.xav(this.mav(index));
  };
  protoOf(Container).oav = function () {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.jag_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.f1(tmp0);
      child.gaw(null);
      child.caw(-1);
    }
    this.iag_1.b3();
    this.tav();
  };
  protoOf(Container).pav = function (view) {
    return this.wav(view, this.hav());
  };
  protoOf(Container).pag = function (view) {
    this.wav(view, this.hav());
  };
  protoOf(Container).f1 = function (index) {
    return this.lav(index);
  };
  protoOf(Container).mas = function (ctx) {
    if (!this.dax())
      return Unit_instance;
    this.qav(ctx);
  };
  protoOf(Container).qav = function (ctx) {
    if (!this.hag_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.mag_1) {
        this.mag_1 = true;
        this.oag_1.b3();
        this.oag_1.y(this.jag_1);
        if (this.sav())
          this.nag_1 = false;
      }
      if (!this.nag_1) {
        this.nag_1 = true;
        sortWith(this.oag_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.oag_1.y1u_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[tmp0].ias(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp1_elvis_lhs = clippingContainer == null ? null : clippingContainer.hay();
    var bounds = tmp1_elvis_lhs == null ? Companion_getInstance_5().z2d() : tmp1_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.mag_1) {
      this.mag_1 = true;
      this.oag_1.b3();
      this.oag_1.y(this.jag_1);
      if (this.sav())
        this.nag_1 = false;
    }
    if (!this.nag_1) {
      this.nag_1 = true;
      sortWith(this.oag_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.oag_1.y1u_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'get' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[tmp0_0];
      if (bounds.p2d() ? true : bounds.j2l(child.gay(true))) {
        child.ias(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  };
  protoOf(Container).rav = function (ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.mag_1) {
      this.mag_1 = true;
      this.oag_1.b3();
      this.oag_1.y(this.jag_1);
      if (this.sav())
        this.nag_1 = false;
    }
    if (!this.nag_1) {
      this.nag_1 = true;
      sortWith(this.oag_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.oag_1.y1u_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[tmp0].rav(ctx);
    }
    protoOf(View).rav.call(this, ctx);
  };
  protoOf(Container).jas = function () {
    var bb = Companion_getInstance_17().a2e();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.jag_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.f1(tmp0);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, child.kay(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  };
  protoOf(Container).sav = function () {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.iag_1.y1u_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[tmp0].jaw() === 0.0)) {
        return true;
      }
    }
    return false;
  };
  protoOf(Container).tav = function () {
    this.mag_1 = false;
    this.uav();
  };
  protoOf(Container).uav = function () {
    var tmp0_safe_receiver = this.bax();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.na2();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.dav(this);
    }
  };
  protoOf(Container).vav = function (child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  };
  protoOf(Container).wav = function (view, index) {
    this.vav(view);
    var tmp0_safe_receiver = view.r40();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.tav();
    }
    view.yax();
    var aindex = clamp_1(index, 0, this.hav());
    view.caw(aindex);
    var children = this.iag_1;
    children.t1(aindex, view);
    var inductionVariable = aindex + 1 | 0;
    var last = children.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.f1(n).caw(n);
      }
       while (inductionVariable < last);
    view.gaw(this);
    view.fav();
    this.jav(view);
    this.tav();
    this.uav();
    this.max();
  };
  protoOf(Container).xav = function (view) {
    if (!((view == null ? null : view.r40()) === this))
      return false;
    var inductionVariable = view.g7s() + 1 | 0;
    var last = this.hav();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2_this = this.iag_1.f1(i);
        var tmp3 = tmp2_this.g7s();
        tmp2_this.caw(tmp3 - 1 | 0);
      }
       while (inductionVariable < last);
    this.iag_1.h1(view.g7s());
    view.gaw(null);
    view.caw(-1);
    this.tav();
    this.uav();
    this.max();
    return true;
  };
  protoOf(Container).l7m = function (type, event, result) {
    if (this.kag_1 == null)
      this.kag_1 = FastArrayList_init_$Create$_0(this.jag_1.n());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.iag_1;
    var temp = ensureNotNull(this.kag_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.y1u_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[tmp0].u7m(type, event, result);
      }
    }finally {
      temp.b3();
    }
  };
  function addTo(_this__u8e3s4, parent) {
    parent.pag(_this__u8e3s4);
    return _this__u8e3s4;
  }
  function ContainerCollection$iterator$1(this$0) {
    this.ebl_1 = this$0;
    this.dbl_1 = 0;
  }
  protoOf(ContainerCollection$iterator$1).v = function () {
    return this.dbl_1 < this.ebl_1.bbl_1.hav();
  };
  protoOf(ContainerCollection$iterator$1).x = function () {
    var tmp1 = this.dbl_1;
    this.dbl_1 = tmp1 + 1 | 0;
    return this.ebl_1.bbl_1.lav(tmp1);
  };
  protoOf(ContainerCollection$iterator$1).w = function () {
    this.dbl_1 = this.dbl_1 - 1 | 0;
    this.ebl_1.bbl_1.nav(this.dbl_1);
  };
  function ContainerCollection(container, children) {
    this.bbl_1 = container;
    this.cbl_1 = children;
  }
  protoOf(ContainerCollection).f1 = function (index) {
    return this.cbl_1.f1(index);
  };
  protoOf(ContainerCollection).w1 = function (index) {
    return this.cbl_1.w1(index);
  };
  protoOf(ContainerCollection).x1 = function (fromIndex, toIndex) {
    return this.cbl_1.x1(fromIndex, toIndex);
  };
  protoOf(ContainerCollection).n = function () {
    return this.bbl_1.hav();
  };
  protoOf(ContainerCollection).fbl = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.b1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.r40() === this.bbl_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(ContainerCollection).a1 = function (elements) {
    return this.fbl(elements);
  };
  protoOf(ContainerCollection).b1 = function () {
    return this.bbl_1.hav() === 0;
  };
  protoOf(ContainerCollection).gbl = function (element) {
    this.bbl_1.pav(element);
    return true;
  };
  protoOf(ContainerCollection).r = function (element) {
    return this.gbl(element instanceof View ? element : THROW_CCE());
  };
  protoOf(ContainerCollection).hbl = function (elements) {
    if (elements.b1())
      return false;
    var tmp0_iterator = elements.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      this.bbl_1.pav(element);
    }
    return true;
  };
  protoOf(ContainerCollection).y = function (elements) {
    return this.hbl(elements);
  };
  protoOf(ContainerCollection).u = function () {
    return new ContainerCollection$iterator$1(this);
  };
  protoOf(ContainerCollection).ibl = function (element) {
    return this.bbl_1.xav(element);
  };
  protoOf(ContainerCollection).s = function (element) {
    if (!(element instanceof View))
      return false;
    return this.ibl(element instanceof View ? element : THROW_CCE());
  };
  function CpuGraphics(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    BaseGraphics.call(this, autoScaling);
    this.hbo_1 = 0;
    this.ibo_1 = null;
    this.jbo_1 = true;
    this.kbo_1 = -1;
    this.lbo_1 = -1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.mbo_1 = ArrayList_init_$Create$();
    this.nbo_1 = null;
    this.obo_1 = null;
    this.y9i_1 = true;
  }
  protoOf(CpuGraphics).pbo = function (value) {
    this.ibo_1 = value;
    this.hbo_1 = this.hbo_1 + 1 | 0;
    this.lba();
  };
  protoOf(CpuGraphics).gbd = function (value) {
    var tmp = this;
    var tmp_0;
    if (value == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.<set-hitShape>.<anonymous>' call
      tmp_0 = listOf(value);
    }
    tmp.obo_1 = tmp_0;
  };
  protoOf(CpuGraphics).aaw = function () {
    var tmp0_safe_receiver = this.baw();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  };
  protoOf(CpuGraphics).baw = function () {
    if (!(this.obo_1 == null))
      return this.obo_1;
    if (!(this.kbo_1 === this.hbo_1)) {
      this.kbo_1 = this.hbo_1;
      this.mbo_1.b3();
      var tmp = this.mbo_1;
      var tmp0_safe_receiver = this.ibo_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q48();
      tmp.r(tmp1_elvis_lhs == null ? new VectorPath() : tmp1_elvis_lhs);
    }
    return this.mbo_1;
  };
  protoOf(CpuGraphics).nba = function (ctx) {
    var tmp0_safe_receiver = this.ibo_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.x47(ctx);
    }
  };
  protoOf(CpuGraphics).cba = function (includeStrokes) {
    var tmp0_safe_receiver = this.ibo_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q5j(includeStrokes);
    return tmp1_elvis_lhs == null ? Companion_getInstance_5().w2d_1 : tmp1_elvis_lhs;
  };
  function DummyView() {
    View_init_$Init$(this);
  }
  protoOf(DummyView).mas = function (ctx) {
    return Unit_instance;
  };
  function dummyView(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    var this_0 = new DummyView();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
    _this__u8e3s4.pav(this_0);
    return this_0;
  }
  function FastEllipse(size) {
    size = size === VOID ? Size2D_init_$Create$_0(100.0, 100.0) : size;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_18();
    var tmp$ret$0 = new RectCorners(numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0));
    FastRoundRectBase.call(this, size, tmp$ret$0, false);
  }
  protoOf(FastEllipse).bbt = function (value) {
    size(this, value.w2m(2.0));
  };
  protoOf(FastEllipse).cbt = function () {
    return (new Size2D(this.x1q(), this.y1q())).x2m(2.0);
  };
  protoOf(FastEllipse).dbt = function (value) {
    this.bbt(new Size2D(value, value));
  };
  protoOf(FastEllipse).ebt = function () {
    return this.cbt().u2m();
  };
  function SDFUB() {
    SDFUB_instance = this;
    UniformBlock.call(this, 6);
    this.fby_1 = this.o89().c89(this, u_Corners$factory());
    this.gby_1 = this.m89().c89(this, u_Scale$factory());
  }
  protoOf(SDFUB).hby = function () {
    return this.fby_1.lh(this, u_Corners$factory_0());
  };
  protoOf(SDFUB).iby = function () {
    return this.gby_1.lh(this, u_Scale$factory_0());
  };
  var SDFUB_instance;
  function SDFUB_getInstance() {
    if (SDFUB_instance == null)
      new SDFUB();
    return SDFUB_instance;
  }
  function Companion_65() {
    Companion_instance_79 = this;
    var tmp = this;
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var tmp1_$this = Companion_getInstance_85().w9c_1;
    var tmp2_name = null == null ? Companion_getInstance_85().w9c_1.n82_1 : null;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.view.Companion.PROGRAM.<anonymous>' call
    var SDF = SDFShaders_getInstance();
    this_0.y89(this_0.b8a(), this_0.c8a(this_0.z89(), this_0.z8a(SDF.zac(), this_0.a8b(SDF.fad(), this_0.c8a(this_0.w8b(this_0.u89(), this_0.q8b(new Float32Array([0.5, 0.5]))), SDFUB_getInstance().iby()), this_0.c8a(this_0.q8b(new Float32Array([0.5, 0.5])), SDFUB_getInstance().iby()), this_0.c8a(SDFUB_getInstance().hby(), this_0.e8a(0.5))))));
    var tmp3_fragment = FragmentShader(this_0.g8a());
    tmp.jby_1 = tmp1_$this.v8w(VOID, tmp3_fragment, tmp2_name);
  }
  var Companion_instance_79;
  function Companion_getInstance_91() {
    if (Companion_instance_79 == null)
      new Companion_65();
    return Companion_instance_79;
  }
  function FastRoundRectBase(size, cornersRatio, doScale) {
    Companion_getInstance_91();
    size = size === VOID ? Size2D_init_$Create$_0(100.0, 100.0) : size;
    var tmp;
    if (cornersRatio === VOID) {
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance_18();
      tmp = new RectCorners(numberToDouble(0.0), numberToDouble(0.0), numberToDouble(0.0), numberToDouble(0.0));
    } else {
      tmp = cornersRatio;
    }
    cornersRatio = tmp;
    doScale = doScale === VOID ? true : doScale;
    ShadedView.call(this, Companion_getInstance_91().jby_1, size);
    this.obv_1 = cornersRatio;
    this.pbv_1 = doScale;
  }
  protoOf(FastRoundRectBase).mas = function (ctx) {
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = ctx.b82(SDFUB_getInstance());
      var tmp1 = this_0.q83();
      this_0.x8n(tmp1 + 1 | 0);
      this_0.l1s(this_0.q83() + 1 | 0);
      var blockSize = this_0.t81_1;
      var index0 = imul(this_0.q83() - 1 | 0, blockSize);
      var index1 = imul(this_0.q83(), blockSize);
      var texBlockSize = this_0.q81_1.f89().n();
      var texIndex0 = imul(this_0.q83() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.q83(), texBlockSize);
      if (this_0.q83() > 0) {
        arraycopy_0(this_0.v81_1, index0, this_0.v81_1, index1, blockSize);
      } else {
        arrayfill_0(this_0.v81_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.view.FastRoundRectBase.renderInternal.<anonymous>' call
      var $this$push = this_0.q81_1;
      var it = this_0.w81_1;
      it.i8o($this$push.hby(), this.obv_1);
      it.d8o($this$push.iby(), (!this.pbv_1 ? true : this.x1q() === this.y1q()) ? new Vector2D(1.0, 1.0) : this.x1q() > this.y1q() ? new Vector2D(this.x1q() / this.y1q(), 1.0) : new Vector2D(1.0, this.y1q() / this.x1q()));
      if (true ? this_0.q83() >= 1 : false) {
        var equals = arrayequal(this_0.v81_1, index0, this_0.v81_1, index1, blockSize);
        if (equals) {
          var tmp3 = this_0.q83();
          this_0.x8n(tmp3 - 1 | 0);
          break $l$block;
        }
      }
    }
    protoOf(ShadedView).mas.call(this, ctx);
  };
  function u_Corners$factory() {
    return getPropertyCallableRef('u_Corners', 1, KProperty1, function (receiver) {
      return receiver.hby();
    }, null);
  }
  function u_Scale$factory() {
    return getPropertyCallableRef('u_Scale', 1, KProperty1, function (receiver) {
      return receiver.iby();
    }, null);
  }
  function u_Corners$factory_0() {
    return getPropertyCallableRef('u_Corners', 1, KProperty1, function (receiver) {
      return receiver.hby();
    }, null);
  }
  function u_Scale$factory_0() {
    return getPropertyCallableRef('u_Scale', 1, KProperty1, function (receiver) {
      return receiver.iby();
    }, null);
  }
  function Companion_66() {
  }
  var Companion_instance_80;
  function Companion_getInstance_92() {
    return Companion_instance_80;
  }
  function FixedSizeContainer(size, clip) {
    size = size === VOID ? Size2D_init_$Create$(100, 100) : size;
    clip = clip === VOID ? false : clip;
    Container.call(this);
    this.jbi_1 = clip;
    this.kbi_1 = size;
    this.lbi_1 = Ref_0(false);
  }
  protoOf(FixedSizeContainer).y5j = function () {
    return this.jbi_1;
  };
  protoOf(FixedSizeContainer).gas = function (_set____db54di) {
    this.kbi_1 = _set____db54di;
  };
  protoOf(FixedSizeContainer).has = function () {
    return this.kbi_1;
  };
  protoOf(FixedSizeContainer).jas = function () {
    return new RectangleD(0.0, 0.0, this.x1q(), this.y1q());
  };
  protoOf(FixedSizeContainer).toString = function () {
    var out = protoOf(Container).toString.call(this);
    out = out + (':size=(' + get_niceStr_0(this.x1q()) + 'x' + get_niceStr_0(this.y1q()) + ')');
    return out;
  };
  protoOf(FixedSizeContainer).mas = function (ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.y5j();
      var renderingInternalRef = this.lbi_1;
      if (renderingInternalRef.m2()) {
        protoOf(Container).mas.call(this, ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.gax();
        var hasRotation = !(m.k2f_1 === 0.0) ? true : !(m.l2f_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.m2();
          try {
            renderingInternalRef.d1z(true);
            renderFiltered(this, ctx, Companion_getInstance_102());
          }finally {
            renderingInternalRef.d1z(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.n9t_1;
        if (!(ctx.r9t_1 === batcher)) {
          ctx.r9t_1 = batcher;
          ctx.y9z();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.p9t_1;
        var bounds = this.eay(ctx).p2l(ctx.b9t_1).q2l();
        var rect = c2d.qab_1.za7().i86();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.j2l(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_58().b86(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.qab_1;
            var scissor_0 = c2d.zab(scissor);
            var temp = this_0.r9z_1;
            this_0.pa8();
            this_0.r9z_1 = scissor_0;
            try {
              protoOf(Container).mas.call(this, ctx);
              break $l$block_1;
            }finally {
              this_0.pa8();
              this_0.r9z_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          protoOf(Container).mas.call(this, ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        protoOf(Container).mas.call(this, ctx);
      }
    }
  };
  function SContainer(size, clip) {
    size = size === VOID ? Size2D_init_$Create$(100, 100) : size;
    clip = clip === VOID ? false : clip;
    FixedSizeContainer.call(this, size, clip);
  }
  function installFpsDebugOverlay(_this__u8e3s4) {
    var longWindow = new TimeSlidingWindow(240);
    var shortWindow = new TimeSlidingWindow(10);
    var previousTime = {_v: new Duration(PerformanceCounter_instance.n1q())};
    var frames = {_v: 0};
    var batchCount = {_v: 0};
    var vertexCount = {_v: 0};
    var instanceCount = {_v: 0};
    var tmp = _this__u8e3s4.na2().o9g_1;
    tmp.w5n(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
    var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.na2().p9f_1).na9_1;
    tmp_0.w5n(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
    var tmp_1 = _this__u8e3s4.na2().p9f_1.n9t_1.s9z_1;
    tmp_1.w5n(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
    var tmp_2 = _this__u8e3s4.na2().p9f_1.n9t_1.t9z_1;
    tmp_2.w5n(installFpsDebugOverlay$lambda_2(instanceCount));
    var tmp_3 = _this__u8e3s4.na2();
    tmp_3.kby(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
  }
  function TimeSlidingWindow(capacity) {
    this.lby_1 = capacity;
    this.mby_1 = new IntDeque(this.lby_1);
    this.nby_1 = 0;
  }
  protoOf(TimeSlidingWindow).n = function () {
    return this.mby_1.n();
  };
  protoOf(TimeSlidingWindow).oby = function () {
    var tmp;
    if (this.mby_1.n() === 0) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = this.nby_1 / this.mby_1.n();
      tmp = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
    }
    return tmp;
  };
  protoOf(TimeSlidingWindow).pby = function () {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return Duration__div_impl_dknbf4(tmp$ret$1, this.oby());
  };
  protoOf(TimeSlidingWindow).qby = function (index) {
    // Inline function 'korlibs.time.microseconds' call
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = this.mby_1.f1(index);
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  };
  protoOf(TimeSlidingWindow).rby = function (value) {
    var intValue = get_microsecondsInt(value);
    this.mby_1.u1u(intValue);
    this.nby_1 = this.nby_1 + intValue | 0;
    if (this.mby_1.n() > this.lby_1) {
      this.nby_1 = this.nby_1 - this.mby_1.hf() | 0;
    }
  };
  function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
    return function (it) {
      $batchCount._v = 0;
      $vertexCount._v = 0;
      $instanceCount._v = 0;
      return Unit_instance;
    };
  }
  function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
    return function (it) {
      var tmp0 = $batchCount._v;
      $batchCount._v = tmp0 + 1 | 0;
      $vertexCount._v = $vertexCount._v + it.va9_1 | 0;
      return Unit_instance;
    };
  }
  function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
    return function (it) {
      var tmp0 = $batchCount._v;
      $batchCount._v = tmp0 + 1 | 0;
      $vertexCount._v = $vertexCount._v + it.xa7() | 0;
      return Unit_instance;
    };
  }
  function installFpsDebugOverlay$lambda_2($instanceCount) {
    return function (it) {
      $instanceCount._v = $instanceCount._v + it | 0;
      return Unit_instance;
    };
  }
  function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
    var tmp0_font = $this_addDebugRenderer.sby();
    var tmp1_colMul = $ctx.m9t_1;
    var tmp2_blendMode = Companion_getInstance_90().j9y_1;
    drawText($ctx, tmp0_font, fontSize, text, x, y, matrix, tmp1_colMul, tmp2_blendMode, false);
  }
  function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
    return function ($this$addDebugRenderer, ctx) {
      var scale = ctx.dab();
      var fontSize = 8.0 * scale;
      var currentTime = PerformanceCounter_instance.n1q();
      var elapsedTime = Duration__minus_impl_q5cfm7(currentTime, $previousTime._v.aj_1);
      var tmp;
      if ($frames._v > 3) {
        var tmp_0;
        // Inline function 'korlibs.time.milliseconds' call
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
        if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) > 0) {
          $longWindow.rby(elapsedTime);
          $shortWindow.rby(elapsedTime);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      var tmp0 = $frames._v;
      $frames._v = tmp0 + 1 | 0;
      $previousTime._v = new Duration(currentTime);
      var matrix = $this$addDebugRenderer.d9f_1.uaa();
      invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.pby(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_instance_2.p1p() + ')'), 0, 0);
      var graphLeft = 1.0;
      var graphTop = fontSize * 2;
      var overlayLines = 60;
      var overlayWidth = 120.0 * scale;
      var overlayHeight = 30 * scale;
      var overlayHeightGap = 5.0;
      // Inline function 'korlibs.korge.render.useLineBatcher' call
      var this_0 = $this$addDebugRenderer.p9f_1;
      // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
      var this_1 = get_debugLineRenderContext(this_0);
      var this_2 = this_1.ma9_1;
      if (!(this_2.r9t_1 === this_1)) {
        this_2.r9t_1 = this_1;
        this_2.y9z();
      }
      // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
      var this_3 = get_debugLineRenderContext(this_0);
      $l$block_0: {
        // Inline function 'korlibs.datastructure.keep' call
        var mut = currentMatrix$factory(this_3);
        var temp = mut.get();
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
          if (!(matrix == null))
            this_3.ya9_1 = matrix;
          $l$block: {
            // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
            var blending = Companion_getInstance_90().j9y_1;
            var doUpdate = !(this_1.xa9_1 === blending);
            var old = this_1.xa9_1;
            try {
              if (doUpdate) {
                this_1.ma9_1.y9z();
                this_1.xa9_1 = blending;
              }
              // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
              var color = Colors_getInstance().b3h_1;
              var oldColor = this_1.pa9_1;
              this_1.pa9_1 = color;
              try {
                // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                this_1.daa(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
                this_1.daa(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
              }finally {
                this_1.pa9_1 = oldColor;
              }
              var inductionVariable = 0;
              var tmp_1;
              if (inductionVariable <= 0) {
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var color_0 = index === 0 ? Colors_getInstance().l3b_1 : Colors_getInstance().m3b_1;
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                  var oldColor_0 = this_1.pa9_1;
                  this_1.pa9_1 = color_0;
                  try {
                    // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ratio = $longWindow.n() / $longWindow.lby_1;
                    var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                    if ($longWindow.n() > 0) {
                      var previousX = 0.0;
                      var previousY = 0.0;
                      var minFps = 0.0;
                      var maxFps = 150.0;
                      var inductionVariable_0 = 0;
                      if (inductionVariable_0 < totalOverlayLines)
                        do {
                          var n = inductionVariable_0;
                          inductionVariable_0 = inductionVariable_0 + 1 | 0;
                          // Inline function 'kotlin.run' call
                          // Inline function 'kotlin.contracts.contract' call
                          // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                          var p0 = convertRange_0(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.n(), 1));
                          var p1 = convertRange_0(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.n(), 1));
                          var plen = 0;
                          // Inline function 'korlibs.time.milliseconds' call
                          // Inline function 'kotlin.time.Companion.milliseconds' call
                          Companion_getInstance();
                          var timeSum = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
                          var inductionVariable_1 = p0;
                          var last = coerceAtMost(p1, $longWindow.n());
                          if (inductionVariable_1 < last)
                            do {
                              var m = inductionVariable_1;
                              inductionVariable_1 = inductionVariable_1 + 1 | 0;
                              timeSum = Duration__plus_impl_yu9v8f(timeSum, $longWindow.qby(m));
                              plen = plen + 1 | 0;
                            }
                             while (inductionVariable_1 < last);
                          if (plen === 0) {
                            timeSum = Duration__plus_impl_yu9v8f(timeSum, $longWindow.qby(p0));
                            plen = plen + 1 | 0;
                          }
                          var time = Duration__div_impl_dknbf4_0(timeSum, plen);
                          var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                          var fps_0 = fps;
                          var scaledFreq = convertRange(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                          var y = graphTop + overlayHeight - scaledFreq;
                          var x = graphLeft + n * overlayWidth / overlayLines;
                          if (n > 0) {
                            this_1.daa(previousX, previousY + index, x, y + index);
                          }
                          previousY = y;
                          previousX = x;
                        }
                         while (inductionVariable_0 < totalOverlayLines);
                    }
                  }finally {
                    this_1.pa9_1 = oldColor_0;
                  }
                }
                 while (inductionVariable <= 0);
                tmp_1 = Unit_instance;
              }
              break $l$block;
            }finally {
              if (doUpdate) {
                this_1.ma9_1.y9z();
              }
              this_1.xa9_1 = old;
            }
          }
          break $l$block_0;
        }finally {
          mut.set(temp);
        }
      }
      return Unit_instance;
    };
  }
  function currentMatrix$factory($b0) {
    return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
      return $b0.ya9_1;
    }, function (value) {
      $b0.ya9_1 = value;
      return Unit_instance;
    });
  }
  var GraphicsRenderer_SYSTEM_instance;
  var GraphicsRenderer_CPU_instance;
  var GraphicsRenderer_GPU_instance;
  var GraphicsRenderer_entriesInitialized;
  function GraphicsRenderer_initEntries() {
    if (GraphicsRenderer_entriesInitialized)
      return Unit_instance;
    GraphicsRenderer_entriesInitialized = true;
    GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
    GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
    GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
  }
  function GraphicsRenderer(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function _get_anchorable__ebfoik($this) {
    var tmp0_elvis_lhs = $this.bc1_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? $this.cc1_1 : tmp0_elvis_lhs);
  }
  function ensure_0($this) {
    if ($this.ic1_1.ka_1 === 2) {
      if (!($this.bc1_1 == null)) {
        var tmp1_safe_receiver = $this.bc1_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.yax();
        }
        $this.bc1_1 = null;
      }
      if ($this.cc1_1 == null) {
        var tmp = $this;
        // Inline function 'kotlin.also' call
        // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
        // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
        // Inline function 'kotlin.also' call
        var this_0 = new GpuShapeView(EmptyShape_instance, true);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>' call
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
        // Inline function 'korlibs.image.vector.buildShape' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape.<anonymous>' call
        // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>.<anonymous>' call
        // Inline function 'korlibs.korge.view.vector.gpuGraphics.<anonymous>' call
        var tmp$ret$2 = (new ShapeBuilder(null, null)).k41();
        this_0.ic4(tmp$ret$2);
        var this_1 = addTo(this_0, $this);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
        this_1.jc4($this.dc1_1);
        this_1.jc3_1 = $this.gc1_1;
        this_1.lc3_1 = $this.fc1_1;
        this_1.ic4($this.hc1_1);
        tmp.cc1_1 = this_1;
      }
    } else {
      if (!($this.cc1_1 == null)) {
        var tmp2_safe_receiver = $this.cc1_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.yax();
        }
        $this.cc1_1 = null;
      }
      if ($this.bc1_1 == null) {
        var tmp_0 = $this;
        // Inline function 'kotlin.also' call
        // Inline function 'korlibs.korge.view.cpuGraphics' call
        // Inline function 'kotlin.also' call
        var this_2 = addTo(new CpuGraphics(false), $this);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
        // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
        // Inline function 'korlibs.image.vector.buildShape' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.CpuGraphics.updateShape.<anonymous>' call
        // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>.<anonymous>' call
        // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
        var tmp$ret$9 = (new ShapeBuilder(null, null)).k41();
        this_2.pbo(tmp$ret$9);
        if (false) {
          this_2.mba();
        }
        this_2.mb7_1 = true;
        this_2.max();
        this_2.mba();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
        this_2.jbo_1 = $this.dc1_1;
        this_2.eb7_1 = $this.gc1_1;
        this_2.rbc_1 = $this.fc1_1;
        this_2.pbo($this.hc1_1);
        tmp_0.bc1_1 = this_2;
      }
      var tmp3_safe_receiver = $this.bc1_1;
      if (tmp3_safe_receiver != null) {
        tmp3_safe_receiver.kba($this.ic1_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
      }
    }
  }
  function Graphics(shape, renderer) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    Container.call(this);
    this.bc1_1 = null;
    this.cc1_1 = null;
    this.dc1_1 = true;
    this.ec1_1 = false;
    this.fc1_1 = true;
    this.gc1_1 = true;
    this.hc1_1 = EmptyShape_instance;
    this.ic1_1 = renderer;
    this.ic4(shape);
  }
  protoOf(Graphics).kc4 = function () {
    var tmp0_elvis_lhs = this.bc1_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.cc1_1 : tmp0_elvis_lhs);
  };
  protoOf(Graphics).vb4 = function (value) {
    _get_anchorable__ebfoik(this).vb4(value);
    this.t9x();
  };
  protoOf(Graphics).yav = function () {
    return this.kc4().yav();
  };
  protoOf(Graphics).zav = function () {
    return this.kc4().zav();
  };
  protoOf(Graphics).lc4 = function (value) {
    if (this.fc1_1 === value)
      return Unit_instance;
    this.fc1_1 = value;
    var tmp0_safe_receiver = this.bc1_1;
    if (tmp0_safe_receiver != null)
      tmp0_safe_receiver.rbc_1 = value;
    var tmp1_safe_receiver = this.cc1_1;
    if (tmp1_safe_receiver != null)
      tmp1_safe_receiver.lc3_1 = value;
    this.t9x();
  };
  protoOf(Graphics).mc4 = function (value) {
    if (this.gc1_1 === value)
      return Unit_instance;
    this.gc1_1 = value;
    var tmp0_safe_receiver = this.bc1_1;
    if (tmp0_safe_receiver != null)
      tmp0_safe_receiver.eb7_1 = value;
    var tmp1_safe_receiver = this.cc1_1;
    if (tmp1_safe_receiver != null)
      tmp1_safe_receiver.jc3_1 = value;
    this.t9x();
  };
  protoOf(Graphics).ic4 = function (value) {
    if (this.hc1_1 === value)
      return Unit_instance;
    this.hc1_1 = value;
    ensure_0(this);
    var tmp0_safe_receiver = this.bc1_1;
    if (tmp0_safe_receiver != null) {
      tmp0_safe_receiver.pbo(value);
    }
    var tmp1_safe_receiver = this.cc1_1;
    if (tmp1_safe_receiver != null) {
      tmp1_safe_receiver.ic4(value);
    }
    this.t9x();
  };
  protoOf(Graphics).nc4 = function () {
    ensure_0(this);
    var tmp0_safe_receiver = this.bc1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.lba();
    }
    var tmp1_safe_receiver = this.bc1_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.mba();
  };
  function GraphicsRenderer_SYSTEM_getInstance() {
    GraphicsRenderer_initEntries();
    return GraphicsRenderer_SYSTEM_instance;
  }
  function GraphicsRenderer_GPU_getInstance() {
    GraphicsRenderer_initEntries();
    return GraphicsRenderer_GPU_instance;
  }
  function Image_init_$Init$(bitmap, anchor, hitShape, smoothing, $this) {
    anchor = anchor === VOID ? Companion_getInstance_11().f2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    Image.call($this, Resourceable(bitmap), anchor, hitShape, smoothing);
    return $this;
  }
  function Image_init_$Create$(bitmap, anchor, hitShape, smoothing) {
    return Image_init_$Init$(bitmap, anchor, hitShape, smoothing, objectCreate(protoOf(Image)));
  }
  function $forceLoadSourceFileCOROUTINE$13(_this__u8e3s4, views, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wc4_1 = _this__u8e3s4;
    this.xc4_1 = views;
    this.yc4_1 = currentVfs;
    this.zc4_1 = sourceFile;
  }
  protoOf($forceLoadSourceFileCOROUTINE$13).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 5;
            this.fd_1 = 1;
            suspendResult = this.wc4_1.kc7(this.wc4_1, this.xc4_1, this.yc4_1, this.zc4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gd_1 = 3;
            this.fd_1 = 2;
            suspendResult = readBitmapSlice(this.yc4_1.s13('' + this.zc4_1), VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.wc4_1.oba(ARGUMENT);
            this.wc4_1.kaw(1.0);
            this.gd_1 = 5;
            this.fd_1 = 4;
            continue $sm;
          case 3:
            this.gd_1 = 5;
            var tmp_0 = this.id_1;
            if (tmp_0 instanceof Error) {
              var e = this.id_1;
              this.wc4_1.oba(get_Bitmaps_white());
              this.wc4_1.kaw(100.0);
              this.fd_1 = 4;
              continue $sm;
            } else {
              throw this.id_1;
            }

          case 4:
            this.gd_1 = 5;
            return Unit_instance;
          case 5:
            throw this.id_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.gd_1 === 5) {
          throw e_0;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e_0;
        }
      }
     while (true);
  };
  function Image(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_11().f2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    BaseImage.call(this, bitmap, anchor, hitShape, smoothing);
    this.ic7_1 = new Mixin_0();
    this.jc7_1 = sourceFile$factory(this);
  }
  protoOf(Image).lc7 = function (_set____db54di) {
    this.ic7_1.lc7(_set____db54di);
  };
  protoOf(Image).oc7 = function () {
    return this.ic7_1.nc7_1;
  };
  protoOf(Image).pc7 = function (_set____db54di) {
    this.ic7_1.mc7_1 = _set____db54di;
  };
  protoOf(Image).qc7 = function (ctx, view) {
    this.ic7_1.qc7(ctx, view);
  };
  protoOf(Image).kc7 = function (_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return this.ic7_1.kc7(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  };
  protoOf(Image).mas = function (ctx) {
    this.qc7(ctx, this);
    protoOf(BaseImage).mas.call(this, ctx);
  };
  protoOf(Image).rc7 = function (views, currentVfs, sourceFile, $completion) {
    var tmp = new $forceLoadSourceFileCOROUTINE$13(this, views, currentVfs, sourceFile, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function BaseImage_init_$Init$(bmpCoords, anchor, hitShape, smoothing, $this) {
    anchor = anchor === VOID ? Companion_getInstance_11().f2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    BaseImage.call($this, Resourceable(bmpCoords), anchor, hitShape, smoothing);
    return $this;
  }
  function trySetSourceActually($this) {
    var source = $this.bba_1.t3v();
    if (!(source == null)) {
      $this.aba_1 = true;
      $this.dbd(source);
    }
  }
  function BaseImage(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_11().f2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    RectBase.call(this, anchor, hitShape, smoothing);
    this.aba_1 = false;
    this.bba_1 = bitmap;
    this.abd();
  }
  protoOf(BaseImage).oba = function (value) {
    if (equals(this.sbc_1, value))
      return Unit_instance;
    this.aba_1 = true;
    this.dbd(value);
  };
  protoOf(BaseImage).m50 = function () {
    return this.sbc_1;
  };
  protoOf(BaseImage).abd = function () {
    if (this.aba_1)
      return Unit_instance;
    trySetSourceActually(this);
  };
  protoOf(BaseImage).mas = function (ctx) {
    this.abd();
    protoOf(RectBase).mas.call(this, ctx);
  };
  protoOf(BaseImage).pba = function () {
    return this.sbc_1.x1q();
  };
  protoOf(BaseImage).qba = function () {
    return this.sbc_1.y1q();
  };
  protoOf(BaseImage).o2y = function () {
    return this.sbc_1.o2y();
  };
  protoOf(BaseImage).p2y = function () {
    return this.sbc_1.p2y();
  };
  protoOf(BaseImage).y2x = function () {
    return this.sbc_1.y2x();
  };
  protoOf(BaseImage).z2x = function () {
    return this.sbc_1.z2x();
  };
  protoOf(BaseImage).bbd = function () {
    return this.xbc().p2c_1 * this.y2x();
  };
  protoOf(BaseImage).cbd = function () {
    return this.xbc().q2c_1 * this.z2x();
  };
  protoOf(BaseImage).yav = function () {
    return this.bbd() - this.o2y();
  };
  protoOf(BaseImage).zav = function () {
    return this.cbd() - this.p2y();
  };
  protoOf(BaseImage).jas = function () {
    return Companion_getInstance_5().q2k(-this.bbd(), -this.cbd(), this.y2x(), this.z2x());
  };
  protoOf(BaseImage).toString = function () {
    return protoOf(RectBase).toString.call(this) + (':bitmap=' + this.m50());
  };
  function SmoothedBmpSlice() {
  }
  function sourceFile$factory($b0) {
    return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
      return $b0.oc7();
    }, function (value) {
      return $b0.lc7(value);
    });
  }
  function RectBase(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_11().f2c_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    View_init_$Init$(this);
    this.rbc_1 = smoothing;
    this.gbd(hitShape);
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.sbc_1 = get_Bitmaps_white();
    this.tbc_1 = anchor;
    var tmp_0 = this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_87();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.ubc_1 = new TexturedVertexArray(4, tmp$ret$1);
    this.vbc_1 = null;
    this.wbc_1 = null;
  }
  protoOf(RectBase).lc4 = function (_set____db54di) {
    this.rbc_1 = _set____db54di;
  };
  protoOf(RectBase).dbd = function (v) {
    if (!(this.sbc_1 === v)) {
      this.sbc_1 = v;
      this.o9i_1 = true;
      this.t9x();
    }
  };
  protoOf(RectBase).vb4 = function (v) {
    if (!this.tbc_1.equals(v)) {
      this.tbc_1 = v;
      this.o9i_1 = true;
      this.t9x();
    }
  };
  protoOf(RectBase).xbc = function () {
    return this.tbc_1;
  };
  protoOf(RectBase).pba = function () {
    return 0.0;
  };
  protoOf(RectBase).qba = function () {
    return 0.0;
  };
  protoOf(RectBase).yav = function () {
    return this.xbc().p2c_1 * this.pba();
  };
  protoOf(RectBase).zav = function () {
    return this.xbc().q2c_1 * this.qba();
  };
  protoOf(RectBase).ybc = function () {
    return -this.yav();
  };
  protoOf(RectBase).zbc = function () {
    return -this.zav();
  };
  protoOf(RectBase).mas = function (ctx) {
    if (!this.dax())
      return Unit_instance;
    var tmp = this.sbc_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.o9i_1) {
      this.o9i_1 = false;
      this.fbd();
    }
    this.ebd(ctx);
  };
  protoOf(RectBase).ebd = function (ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.n9t_1;
    var this_1 = this_0.t9y_1;
    if (!(this_1.r9t_1 === this_0)) {
      this_1.r9t_1 = this_0;
      this_1.y9z();
    }
    var tmp0_safe_receiver = this.wbc_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var array = this.ubc_1;
    var tex = ctx.jab(this.sbc_1).v2x();
    var smoothing = this.rbc_1;
    var blendMode = this.jax();
    var program = this.vbc_1;
    var vcount = array.ja8_1;
    var icount = array.ka8_1;
    var matrix = Companion_getInstance_14().f2f_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.va5_1;
      this_0.ca8(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_85().w9c_1 : program;
      if (this_0.ra8(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.ua7();
      if (!contains_1(this_0.j9z_1, tex_0)) {
        this_0.i9z_1 = 0;
        this_0.j9z_1[0] = tex_0;
      }
      this_0.k9z_1 = smoothing;
      this_0.l9z_1 = blendMode;
      this_0.m9z_1 = pprogram;
    }
    this_0.oa8(array, matrix, vcount, icount);
  };
  protoOf(RectBase).fbd = function () {
    this.ubc_1.lad(0, this.ybc(), this.zbc(), this.pba(), this.qba(), this.gax(), this.sbc_1, this.kax());
  };
  protoOf(RectBase).jas = function () {
    return Companion_getInstance_5().q2k(this.ybc(), this.zbc(), this.pba(), this.qba());
  };
  protoOf(RectBase).toString = function () {
    var out = protoOf(View).toString.call(this);
    if (!this.xbc().equals(Companion_getInstance_11().f2c_1))
      out = out + (':anchor=(' + this.tax(this.xbc().p2c_1) + ', ' + this.tax(this.xbc().q2c_1) + ')');
    return out;
  };
  var CoordsType_D_0_1_instance;
  var CoordsType_D_M1_1_instance;
  var CoordsType_D_W_H_instance;
  var CoordsType_entriesInitialized;
  function CoordsType_initEntries() {
    if (CoordsType_entriesInitialized)
      return Unit_instance;
    CoordsType_entriesInitialized = true;
    CoordsType_D_0_1_instance = new CoordsType('D_0_1', 0);
    CoordsType_D_M1_1_instance = new CoordsType('D_M1_1', 1);
    CoordsType_D_W_H_instance = new CoordsType('D_W_H', 2);
  }
  function CoordsType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_67() {
  }
  var Companion_instance_81;
  function Companion_getInstance_93() {
    return Companion_instance_81;
  }
  function CoordsType_D_0_1_getInstance() {
    CoordsType_initEntries();
    return CoordsType_D_0_1_instance;
  }
  function ShadedView(program, size, coordsType) {
    size = size === VOID ? Size2D_init_$Create$_0(100.0, 100.0) : size;
    coordsType = coordsType === VOID ? CoordsType_D_0_1_getInstance() : coordsType;
    RectBase.call(this, Companion_getInstance_11().f2c_1);
    this.wbx_1 = size;
    this.vbc_1 = program;
    this.xbx_1 = Companion_getInstance_19().q2e_1;
    this.ybx_1 = coordsType;
  }
  protoOf(ShadedView).gas = function (value) {
    if (this.wbx_1.equals(value))
      return Unit_instance;
    this.wbx_1 = value;
    this.o9i_1 = true;
  };
  protoOf(ShadedView).has = function () {
    return this.wbx_1;
  };
  protoOf(ShadedView).pba = function () {
    return this.x1q();
  };
  protoOf(ShadedView).qba = function () {
    return this.y1q();
  };
  protoOf(ShadedView).fbd = function () {
    var L = this.ybc() - this.xbx_1.u2e_1;
    var T = this.zbc() - this.xbx_1.r2e_1;
    var R = this.pba() + this.xbx_1.w2e();
    var B = this.qba() + this.xbx_1.x2e();
    var l = -this.xbx_1.u2e_1;
    var t = -this.xbx_1.r2e_1;
    var r = this.pba() + this.xbx_1.s2e_1;
    var b = this.qba() + this.xbx_1.t2e_1;
    var tmp;
    switch (this.ybx_1.ka_1) {
      case 0:
        tmp = 0.0;
        break;
      case 1:
        tmp = -1.0;
        break;
      case 2:
        tmp = 0.0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var lmin = tmp;
    var lmax = 1.0;
    switch (this.ybx_1.ka_1) {
      case 0:
      case 1:
        l = convertRange_1(l, 0.0, this.pba(), lmin, lmax);
        r = convertRange_1(r, 0.0, this.pba(), lmin, lmax);
        t = convertRange_1(t, 0.0, this.qba(), lmin, lmax);
        b = convertRange_1(b, 0.0, this.qba(), lmin, lmax);
        break;
      default:
        break;
    }
    this.ubc_1.mad(0, L, T, R, B, this.gax(), l, t, r, t, l, b, r, b, this.kax());
  };
  protoOf(ShadedView).zbx = function (ctx) {
  };
  protoOf(ShadedView).mas = function (ctx) {
    if (!this.dax())
      return Unit_instance;
    this.zbx(ctx);
    protoOf(RectBase).mas.call(this, ctx);
  };
  function Companion_68() {
  }
  var Companion_instance_82;
  function Companion_getInstance_94() {
    return Companion_instance_82;
  }
  function SolidRect(size, color) {
    color = color === VOID ? Colors_getInstance().l3b_1 : color;
    RectBase.call(this);
    this.aca_1 = size;
    this.t3r(color);
  }
  protoOf(SolidRect).gas = function (value) {
    if (this.aca_1.equals(value))
      return Unit_instance;
    this.aca_1 = value;
    this.o9i_1 = true;
    this.t9x();
  };
  protoOf(SolidRect).has = function () {
    return this.aca_1;
  };
  protoOf(SolidRect).pba = function () {
    return this.x1q();
  };
  protoOf(SolidRect).qba = function () {
    return this.y1q();
  };
  function Stage(views) {
    FixedSizeContainer.call(this);
    this.xbk_1 = views;
    this.ybk_1 = views.z9e_1;
    this.zbk_1 = clipBorders$factory(this.na2());
    this.abl_1 = virtualSizeDouble$factory(this.na2());
    this.daw(this);
    this.eaw(this);
  }
  protoOf(Stage).na2 = function () {
    return this.xbk_1;
  };
  protoOf(Stage).w1a = function () {
    return this.xbk_1.p9e_1;
  };
  protoOf(Stage).gaa = function (_set____db54di) {
    this.ybk_1.gaa(_set____db54di);
  };
  protoOf(Stage).haa = function () {
    return this.ybk_1.haa();
  };
  protoOf(Stage).iaa = function () {
    return this.ybk_1.iaa();
  };
  protoOf(Stage).jaa = function () {
    return this.ybk_1.jaa();
  };
  protoOf(Stage).kaa = function (_set____db54di) {
    this.ybk_1.kaa(_set____db54di);
  };
  protoOf(Stage).laa = function () {
    return this.ybk_1.laa();
  };
  protoOf(Stage).maa = function () {
    return this.ybk_1.maa();
  };
  protoOf(Stage).naa = function (_set____db54di) {
    this.ybk_1.naa(_set____db54di);
  };
  protoOf(Stage).oaa = function () {
    return this.ybk_1.oaa();
  };
  protoOf(Stage).paa = function () {
    return this.ybk_1.paa();
  };
  protoOf(Stage).qaa = function () {
    return this.ybk_1.qaa();
  };
  protoOf(Stage).raa = function () {
    return this.ybk_1.raa();
  };
  protoOf(Stage).saa = function () {
    return this.ybk_1.saa();
  };
  protoOf(Stage).taa = function (_set____db54di) {
    this.ybk_1.taa(_set____db54di);
  };
  protoOf(Stage).uaa = function () {
    return this.ybk_1.uaa();
  };
  protoOf(Stage).vaa = function () {
    return this.ybk_1.vaa();
  };
  protoOf(Stage).waa = function (_set____db54di) {
    this.ybk_1.waa(_set____db54di);
  };
  protoOf(Stage).xaa = function () {
    return this.ybk_1.xaa();
  };
  protoOf(Stage).y9o = function (pos) {
    return this.ybk_1.y9o(pos);
  };
  protoOf(Stage).bca = function (_set____db54di) {
    var this_0 = this.zbk_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(Stage).y5j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.zbk_1;
    clip$factory_0();
    return this_0.get();
  };
  protoOf(Stage).gas = function (_set____db54di) {
    var this_0 = this.abl_1;
    unscaledSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(Stage).has = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.abl_1;
    unscaledSize$factory_0();
    return this_0.get();
  };
  protoOf(Stage).cca = function () {
    return this.na2().s9e_1;
  };
  protoOf(Stage).bax = function () {
    return this;
  };
  protoOf(Stage).cav = function () {
    return this;
  };
  protoOf(Stage).dav = function (view) {
    this.na2().dav(view);
  };
  protoOf(Stage).toString = function () {
    return 'Stage';
  };
  function clipBorders$factory($b0) {
    return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
      return $b0.b9g_1;
    }, function (value) {
      $b0.b9g_1 = value;
      return Unit_instance;
    });
  }
  function virtualSizeDouble$factory($b0) {
    return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
      return $b0.dca();
    }, function (value) {
      return $b0.eca(value);
    });
  }
  function clip$factory() {
    return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
      return receiver.y5j();
    }, function (receiver, value) {
      return receiver.bca(value);
    });
  }
  function clip$factory_0() {
    return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
      return receiver.y5j();
    }, function (receiver, value) {
      return receiver.bca(value);
    });
  }
  function unscaledSize$factory() {
    return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
      return receiver.has();
    }, function (receiver, value) {
      return receiver.gas(value);
    });
  }
  function unscaledSize$factory_0() {
    return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
      return receiver.has();
    }, function (receiver, value) {
      return receiver.gas(value);
    });
  }
  function get_agProgram(_this__u8e3s4) {
    switch (_this__u8e3s4.m3t()) {
      case 'msdf':
        return MsdfRender_getInstance().oaz_1;
      case 'psdf':
        return MsdfRender_getInstance().raz_1;
      case 'sdf':
        return MsdfRender_getInstance().raz_1;
      default:
        return null;
    }
  }
  function Companion_69() {
    this.fca_1 = 16.0;
    this.gca_1 = true;
  }
  var Companion_instance_83;
  function Companion_getInstance_95() {
    return Companion_instance_83;
  }
  function updateLineCount($this) {
    var tmp = $this;
    // Inline function 'kotlin.text.count' call
    var count = 0;
    var indexedObject = $this.cce();
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(indexedObject)) {
      var element = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.view.Text.updateLineCount.<anonymous>' call
      if (element === _Char___init__impl__6a9atx(10)) {
        count = count + 1 | 0;
      }
    }
    tmp.tcc_1 = count + 1 | 0;
  }
  function setContainerPosition($this, pos, baseline) {
    var x = pos.cg();
    var y = pos.dg();
    if ($this.lcd_1) {
      setRealContainerPosition($this, x, y);
    } else {
      setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.dcd_1.a44_1, $this.kcd_1.n2d_1), y - VerticalAlign__getOffsetY_impl_iso0y6($this.dcd_1.b44_1, $this.kcd_1.o2d_1, baseline));
    }
  }
  function setRealContainerPosition($this, x, y) {
    position($this.ecd_1, x, y);
  }
  function Text$_renderInternal$slambda(this$0, $ctx, $fontSource, resultContinuation) {
    this.lce_1 = this$0;
    this.mce_1 = $ctx;
    this.nce_1 = $fontSource;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Text$_renderInternal$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Text$_renderInternal$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(Text$_renderInternal$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.lce_1.oce(ensureNotNull(this.mce_1.j9t_1).n9f_1, this.nce_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(Text$_renderInternal$slambda).g5a = function (completion) {
    return new Text$_renderInternal$slambda(this.lce_1, this.mce_1, this.nce_1, completion);
  };
  function Text$_renderInternal$slambda_0(this$0, $ctx, $fontSource, resultContinuation) {
    var i = new Text$_renderInternal$slambda(this$0, $ctx, $fontSource, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $forceLoadFontSourceCOROUTINE$14(_this__u8e3s4, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xce_1 = _this__u8e3s4;
    this.yce_1 = currentVfs;
    this.zce_1 = sourceFile;
  }
  protoOf($forceLoadFontSourceCOROUTINE$14).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.xce_1.acf(this.zce_1);
            this.xce_1.gcd_1 = true;
            if (!(this.zce_1 == null)) {
              this.fd_1 = 1;
              suspendResult = readFont(this.yce_1.s13('' + this.zce_1), VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 2;
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult;
            this.xce_1.bcf(ARGUMENT);
            this.fd_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function Text(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    textSize = textSize === VOID ? Companion_instance_83.fca_1 : textSize;
    color = color === VOID ? Colors_getInstance().l3b_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_20().i42_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_instance_83.gca_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    Container.call(this);
    this.pcc_1 = true;
    this.qcc_1 = -1;
    this.rcc_1 = -1;
    this.scc_1 = 0;
    this.tcc_1 = 0;
    this.ucc_1 = text;
    updateLineCount(this);
    var tmp = this;
    tmp.vcc_1 = fill == null ? new RGBA(color) : fill;
    this.wcc_1 = stroke;
    this.xcc_1 = font;
    this.ycc_1 = numberToDouble(textSize);
    this.zcc_1 = textSize$factory(this);
    this.acd_1 = 0;
    this.bcd_1 = IntCompanionObject_instance.MAX_VALUE;
    this.ccd_1 = renderer;
    this.dcd_1 = alignment;
    var tmp_0 = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = new Container(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp_0.ecd_1 = addTo(this_0, this);
    this.fcd_1 = new Text2TextRendererActions();
    this.gcd_1 = false;
    this.hcd_1 = autoScaling;
    this.icd_1 = false;
    this.jcd_1 = null;
    this.kcd_1 = Companion_getInstance_5().p2k(0, 0, 2048, 2048);
    this.lcd_1 = true;
    this.mcd_1 = -1;
    this.ncd_1 = new MMatrix();
    this.ocd_1 = -1;
    this.pcd_1 = null;
    this.qcd_1 = new Entry();
    this.rcd_1 = new FontMetrics();
    this.scd_1 = new TextMetrics();
    this.tcd_1 = null;
    this.ucd_1 = null;
    this.vcd_1 = null;
    this.wcd_1 = null;
    this.xcd_1 = new MMatrix();
    this.ycd_1 = GraphicsRenderer_SYSTEM_getInstance();
    this.zcd_1 = true;
    this.ace_1 = null;
    this.bce_1 = fontSource$factory(this);
  }
  protoOf(Text).cce = function () {
    return this.ucc_1;
  };
  protoOf(Text).v4n = function () {
    var tmp = this.vcc_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.b3s_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().l3b_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  };
  protoOf(Text).bcf = function (value) {
    if (!equals(this.xcc_1, value)) {
      this.xcc_1 = value;
      this.fav();
    }
  };
  protoOf(Text).ccf = function (value) {
    if (!(this.ycc_1 === value)) {
      this.ycc_1 = value;
      this.fav();
    }
  };
  protoOf(Text).dcf = function (_set____db54di) {
    var this_0 = this.zcc_1;
    fontSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(Text).k3t = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.zcc_1;
    fontSize$factory_0();
    return this_0.get();
  };
  protoOf(Text).fav = function () {
    this.scc_1 = this.scc_1 + 1 | 0;
    protoOf(Container).fav.call(this);
  };
  protoOf(Text).w5d = function () {
    return this.dcd_1.b44_1;
  };
  protoOf(Text).acf = function (value) {
    this.jcd_1 = value;
    this.gcd_1 = false;
    this.fav();
  };
  protoOf(Text).oce = function (currentVfs, sourceFile, $completion) {
    var tmp = new $forceLoadFontSourceCOROUTINE$14(this, currentVfs, sourceFile, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Text).jas = function () {
    this.ecf(null);
    if (!(get_filter(this) == null) ? true : !(get_backdropFilter(this) == null)) {
      return protoOf(Container).jas.call(this);
    } else {
      return this.kcd_1;
    }
  };
  protoOf(Text).mas = function (ctx) {
    this.ecf(ctx);
    var tva = this.wcd_1;
    if (!(tva == null)) {
      this.ncd_1.o35(this.gax());
      this.ncd_1.p35(this.ecd_1.v4s(), this.ecd_1.w4s());
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.n9t_1;
      var this_1 = this_0.t9y_1;
      if (!(this_1.r9t_1 === this_0)) {
        this_1.r9t_1 = this_0;
        this_1.y9z();
      }
      var tmp = this.xcc_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.p3t();
      this_0.ta8(tex, this.pcc_1, this.jax(), get_agProgram(bmpfont), tva.ka8_1, tva.ja8_1);
      this_0.oa8(tva, this.ncd_1.m35());
    } else {
      protoOf(Container).mas.call(this, ctx);
    }
  };
  protoOf(Text).ecf = function (ctx) {
    if (!(ctx == null)) {
      var fontSource = this.jcd_1;
      if (!this.gcd_1 ? !(fontSource == null) : false) {
        this.gcd_1 = true;
        launchImmediately_0(ctx.q9s_1, Text$_renderInternal$slambda_0(this, ctx, fontSource, null));
      }
    }
    var font = this.xcc_1.t3v();
    var tmp;
    var tmp_0;
    if (this.lcd_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.mcd_1 === this.scc_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.mcd_1 = this.scc_1;
      var metrics = getTextBounds(font, this.ycc_1, this.cce(), this.scd_1, this.ccd_1, this.dcd_1);
      this.kcd_1 = new RectangleD(metrics.r2d(), VerticalAlign__getOffsetY_impl_iso0y6(this.dcd_1.b44_1, metrics.y1q(), -metrics.i44()), metrics.x1q(), font.t3t(this.ycc_1, this.rcd_1).l3t() * this.tcc_1);
    }
    if (font != null) {
      if (!(font == null) ? isInterface(font, BitmapFont) : false) {
        var rversion = this.ccd_1.p5c();
        if ((!(this.ucd_1 === this.pcc_1) ? true : !(this.qcc_1 === this.scc_1)) ? true : !(this.rcc_1 === rversion)) {
          this.ucd_1 = this.pcc_1;
          this.rcc_1 = rversion;
          this.qcc_1 = this.scc_1;
          if (!(this.ace_1 == null)) {
            this.ace_1 = null;
            this.ecd_1.oav();
          }
          this.fcd_1.a5e();
          this.fcd_1.n5d_1 = Companion_getInstance_20().m42_1;
          invoke_0(this.ccd_1, this.fcd_1, this.cce(), this.ycc_1, font);
          while (this.ecd_1.hav() < this.fcd_1.n()) {
            // Inline function 'korlibs.korge.view.image' call
            var this_0 = this.ecd_1;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            var texture = get_Bitmaps_transparent();
            var anchor_0 = Companion_getInstance_11().f2c_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_1 = Image_init_$Create$(texture, anchor_0);
            // Inline function 'kotlin.apply' call
            addTo(this_1, this_0);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
          }
          while (this.ecd_1.hav() > this.fcd_1.n()) {
            this.ecd_1.f1(this.ecd_1.hav() - 1 | 0).yax();
          }
          var bounds = this.fcd_1.u2r();
          var firstBounds = this.fcd_1.y5d(0);
          var lineInfos = this.fcd_1.x5d();
          var tmp1_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp1_elvis_lhs == null ? new LineInfo() : tmp1_elvis_lhs;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0.0;
          var tmp0_iterator = lineInfos.u();
          while (tmp0_iterator.v()) {
            var element = tmp0_iterator.x();
            var tmp_1 = sum;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            sum = tmp_1 + element.w5c_1;
          }
          var totalHeight = sum;
          var textWidth = bounds.n2d_1;
          var textHeight = bounds.o2d_1;
          var dx = this.kcd_1.l2d_1;
          var tmp2_subject = this.w5d();
          var dy = equals(tmp2_subject, Companion_getInstance_21().d5c_1) ? 0.0 : equals(tmp2_subject, Companion_getInstance_21().a5c_1) ? firstLineInfos.u5c_1 : firstLineInfos.u5c_1 - totalHeight * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.w5d());
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.fcd_1.n();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.fcd_1.z5d(n, this.qcd_1);
              var tmp_2 = this.ecd_1.f1(n);
              var it = tmp_2 instanceof Image ? tmp_2 : THROW_CCE();
              it.vbc_1 = program;
              it.t3r(this.v4n());
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(it, new Anchor2D(numberToDouble(0), numberToDouble(0)));
              it.rbc_1 = this.pcc_1;
              it.oba(entry.x5c_1);
              it.u46(new Vector2D(entry.y5c_1 + dx, entry.z5c_1 + dy));
              it.paw(new Scale(entry.a5d_1, entry.b5d_1));
              it.tc7(entry.c5d_1);
              var containsLower = this.acd_1;
              it.cax(n < this.bcd_1 ? containsLower <= n : false);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.ucd_1 === this.pcc_1) ? true : !(this.vcd_1 === this.zcd_1)) {
          this.scc_1 = this.scc_1 + 1 | 0;
          this.vcd_1 = this.zcd_1;
          this.tcd_1 = this.hcd_1;
          this.ucd_1 = this.pcc_1;
        }
        if (!(this.qcc_1 === this.scc_1)) {
          this.qcc_1 = this.scc_1;
          var realTextSize = this.ycc_1;
          if (this.ace_1 == null) {
            this.ecd_1.oav();
            var tmp_3 = this;
            // Inline function 'korlibs.korge.view.graphics' call
            var this_2 = this.ecd_1;
            var renderer = this.ycd_1;
            // Inline function 'kotlin.also' call
            var this_3 = addTo(new Graphics(EmptyShape_instance, renderer), this_2);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            result = Unit_instance;
            var tmp$ret$10 = (new ShapeBuilder(null, null)).k41();
            this_3.ic4(tmp$ret$10);
            this_3.nc4();
            tmp_3.ace_1 = this_3;
            var tmp6_safe_receiver = this.ace_1;
            if (tmp6_safe_receiver != null) {
              tmp6_safe_receiver.mc4(true);
            }
          }
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var this_4 = ensureNotNull(this.ace_1);
          var result_0;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.apply' call
          var this_5 = new ShapeBuilder(null, null);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
          // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
          var tmp0_text = this.cce();
          var tmp1_pos = Companion_getInstance_0().d2d_1;
          var tmp2_paint = this.v4n();
          var tmp3_renderer = this.ccd_1;
          var tmp4_align = this.dcd_1;
          var tmp5_outMetrics = new TextMetricsResult();
          var tmp6_fillStyle = this.vcc_1;
          var tmp7_stroke = this.wcc_1;
          var tmp8_textRangeStart = this.acd_1;
          var tmp9_textRangeEnd = this.bcd_1;
          result_0 = this_5.r5i(tmp0_text, tmp1_pos, VOID, new RGBA(tmp2_paint), font, realTextSize, tmp3_renderer, tmp4_align, tmp5_outMetrics, tmp6_fillStyle, tmp7_stroke, tmp8_textRangeStart, tmp9_textRangeEnd);
          var tmp$ret$16 = this_5.k41();
          this_4.ic4(tmp$ret$16);
          var metrics_0 = result_0;
          this.ocd_1 = this.scc_1;
          this.pcd_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_0().d2d_1, font.t3t(this.k3t(), this.rcd_1).x3t_1);
        }
        var tmp7_safe_receiver = this.ace_1;
        if (tmp7_safe_receiver != null) {
          tmp7_safe_receiver.lc4(this.pcc_1);
        }
      }
    }
  };
  function textSize$factory($b0) {
    return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
      return $b0.ycc_1;
    }, function (value) {
      return $b0.ccf(value);
    });
  }
  function fontSource$factory($b0) {
    return getPropertyCallableRef('fontSource', 0, KMutableProperty0, function () {
      return $b0.jcd_1;
    }, function (value) {
      return $b0.acf(value);
    });
  }
  function fontSize$factory() {
    return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
      return receiver.k3t();
    }, function (receiver, value) {
      return receiver.dcf(value);
    });
  }
  function fontSize$factory_0() {
    return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
      return receiver.k3t();
    }, function (receiver, value) {
      return receiver.dcf(value);
    });
  }
  function View_init_$Init$($this) {
    View.call($this, false);
    return $this;
  }
  function Reference() {
  }
  function ColorReference() {
  }
  function Companion_70() {
  }
  protoOf(Companion_70).fcf = function (left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 ? true : rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp1_safe_receiver = l;
        l = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r40();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp3_safe_receiver = r;
        r = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.r40();
      }
    }
    return null;
  };
  var Companion_instance_84;
  function Companion_getInstance_96() {
    return Companion_instance_84;
  }
  function updateRenderColorTransform($this) {
    $this.l9i_1 = $this.q9i_1;
    $this.s9i_1 = true;
    var parent = $this.r40();
    if (!((parent == null ? null : get_filter(parent)) == null)) {
      $this.k9i_1.w3r($this.j9i_1);
    } else {
      var tmp;
      if (!(parent == null)) {
        tmp = !isInterface($this, ColorReference);
      } else {
        tmp = false;
      }
      if (tmp) {
        $this.k9i_1.x3r($this.j9i_1, parent.iax());
      } else {
        $this.k9i_1.w3r($this.j9i_1);
      }
    }
  }
  function updateRenderColorTransformIfRequired($this) {
    if ($this.l9i_1 === $this.q9i_1)
      return Unit_instance;
    updateRenderColorTransform($this);
  }
  function updateRenderBlendMode($this) {
    $this.n9i_1 = $this.p9i_1;
    $this.r9i_1 = true;
    var tmp = $this;
    var tmp_0;
    if ($this.p9h_1.equals(Companion_getInstance_90().a9y_1)) {
      var tmp1_safe_receiver = $this.r40();
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.jax();
      tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_90().z9x_1 : tmp2_elvis_lhs;
    } else {
      tmp_0 = $this.p9h_1;
    }
    tmp.m9i_1 = tmp_0;
  }
  function updateRenderBlendModeIfRequired($this) {
    if ($this.n9i_1 === $this.p9i_1)
      return Unit_instance;
    updateRenderBlendMode($this);
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.gcf_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).aa = function (a, b) {
    return this.gcf_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.aa(a, b);
  };
  function View$bviewAll$delegate$lambda(this$0) {
    return function () {
      return listOf(this$0);
    };
  }
  function View$addRenderPhase$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'korlibs.korge.view.View.addRenderPhase.<anonymous>' call
    var tmp = a.hcf();
    // Inline function 'korlibs.korge.view.View.addRenderPhase.<anonymous>' call
    var tmp$ret$1 = b.hcf();
    return compareValues(tmp, tmp$ret$1);
  }
  function View(isContainer) {
    BaseView.call(this);
    this.d9h_1 = isContainer;
    var tmp = this;
    tmp.e9h_1 = lazy(View$bviewAll$delegate$lambda(this));
    this.f9h_1 = true;
    this.g9h_1 = null;
    this.h9h_1 = null;
    this.i9h_1 = null;
    this.j9h_1 = 0;
    this.k9h_1 = null;
    this.l9h_1 = 1.0;
    this.m9h_1 = null;
    this.n9h_1 = null;
    this.o9h_1 = null;
    this.p9h_1 = Companion_getInstance_90().a9y_1;
    this.q9h_1 = 0.0;
    this.r9h_1 = 0.0;
    this.s9h_1 = 1.0;
    this.t9h_1 = 1.0;
    this.u9h_1 = Companion_getInstance_22().u2c_1;
    this.v9h_1 = Companion_getInstance_22().u2c_1;
    this.w9h_1 = Companion_getInstance_22().u2c_1;
    this.x9h_1 = 0.0;
    this.y9h_1 = scale$factory(this);
    this.z9h_1 = false;
    this.a9i_1 = true;
    this.b9i_1 = true;
    this.c9i_1 = true;
    this.d9i_1 = true;
    this.e9i_1 = Companion_getInstance_14().e2f_1;
    this.f9i_1 = Companion_getInstance_14().e2f_1;
    this.g9i_1 = -1;
    this.h9i_1 = Companion_getInstance_14().e2f_1;
    this.i9i_1 = -1;
    this.j9i_1 = new ColorTransformMul();
    this.k9i_1 = new ColorTransformMul();
    this.l9i_1 = -1;
    this.m9i_1 = Companion_getInstance_90().a9y_1;
    this.n9i_1 = -1;
    this.o9i_1 = true;
    this.p9i_1 = 0;
    this.q9i_1 = 0;
    this.r9i_1 = false;
    this.s9i_1 = false;
    this.t9i_1 = null;
    this.u9i_1 = false;
    this.v9i_1 = null;
    this.w9i_1 = 0;
    this.x9i_1 = true;
    this.y9i_1 = null;
  }
  protoOf(View).yav = function () {
    return 0.0;
  };
  protoOf(View).zav = function () {
    return 0.0;
  };
  protoOf(View).eav = function () {
    return null;
  };
  protoOf(View).gbd = function (_set____db54di) {
    this.h9h_1 = _set____db54di;
  };
  protoOf(View).aaw = function () {
    return this.h9h_1;
  };
  protoOf(View).baw = function () {
    return this.i9h_1;
  };
  protoOf(View).caw = function (value) {
    this.j9h_1 = value;
  };
  protoOf(View).g7s = function () {
    return this.j9h_1;
  };
  protoOf(View).daw = function (value) {
    if (this.m9h_1 === value)
      return Unit_instance;
    this.m9h_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.eav();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.n()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        tmp0_safe_receiver.f1(tmp0).daw(value);
      }
      tmp = Unit_instance;
    }
  };
  protoOf(View).eaw = function (value) {
    if (this.n9h_1 === value)
      return Unit_instance;
    this.n9h_1 = value;
    var parent = this.cav();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.eav();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.n()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        tmp0_safe_receiver.f1(tmp0).eaw(parent);
      }
      tmp = Unit_instance;
    }
  };
  protoOf(View).cav = function () {
    return this.n9h_1;
  };
  protoOf(View).faw = function () {
    var tmp0_safe_receiver = this.k9h_1;
    this.eaw(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cav());
  };
  protoOf(View).gaw = function (value) {
    if (this.k9h_1 === value)
      return Unit_instance;
    this.k9h_1 = value;
    var tmp0_safe_receiver = this.k9h_1;
    this.daw(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m9h_1);
    this.faw();
    this.nax();
    this.g7m(value);
  };
  protoOf(View).r40 = function () {
    return this.k9h_1;
  };
  protoOf(View).haw = function () {
    return !(this.r40() == null) ? ensureNotNull(this.r40()).haw() * this.l9h_1 : this.l9h_1;
  };
  protoOf(View).iaw = function (x, y) {
    this.aax();
    if (!(this.q9h_1 === x) ? true : !(this.r9h_1 === y)) {
      this.q9h_1 = x;
      this.r9h_1 = y;
      this.lax();
    }
  };
  protoOf(View).u46 = function (value) {
    return this.iaw(value.g28_1, value.h28_1);
  };
  protoOf(View).n46 = function () {
    return new Vector2D(this.v4s(), this.w4s());
  };
  protoOf(View).v4s = function () {
    this.aax();
    return this.q9h_1;
  };
  protoOf(View).w4s = function () {
    this.aax();
    return this.r9h_1;
  };
  protoOf(View).jaw = function () {
    return this.x9h_1;
  };
  protoOf(View).kaw = function (v) {
    this.paw(new Scale(v, v));
  };
  protoOf(View).q2h = function () {
    return this.qaw().s2h();
  };
  protoOf(View).law = function (v) {
    this.aax();
    if (!(this.s9h_1 === v)) {
      this.s9h_1 = v;
      this.lax();
    }
  };
  protoOf(View).maw = function () {
    this.aax();
    return this.s9h_1;
  };
  protoOf(View).naw = function (v) {
    this.aax();
    if (!(this.t9h_1 === v)) {
      this.t9h_1 = v;
      this.lax();
    }
  };
  protoOf(View).oaw = function () {
    this.aax();
    return this.t9h_1;
  };
  protoOf(View).paw = function (value) {
    this.law(value.e2g_1);
    this.naw(value.f2g_1);
  };
  protoOf(View).qaw = function () {
    return new Scale(this.maw(), this.oaw());
  };
  protoOf(View).raw = function () {
    this.aax();
    return this.u9h_1;
  };
  protoOf(View).saw = function () {
    this.aax();
    return this.v9h_1;
  };
  protoOf(View).tc7 = function (v) {
    this.aax();
    if (!equals(this.w9h_1, v)) {
      this.w9h_1 = v;
      this.lax();
    }
  };
  protoOf(View).taw = function () {
    this.aax();
    return this.w9h_1;
  };
  protoOf(View).uaw = function () {
    var tmp0_safe_receiver = this.r40();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.uax(new Vector2D(this.v4s(), this.w4s()));
    return tmp1_elvis_lhs == null ? new Vector2D(this.v4s(), this.w4s()) : tmp1_elvis_lhs;
  };
  protoOf(View).vaw = function (value) {
    this.gas(value);
  };
  protoOf(View).n = function () {
    return this.has();
  };
  protoOf(View).gas = function (value) {
    var size = this.n();
    this.paw(new Scale((this.maw() === 0.0 ? 1.0 : this.maw()) * (value.r2k_1 / size.r2k_1), (this.oaw() === 0.0 ? 1.0 : this.oaw()) * (value.s2k_1 / size.s2k_1)));
  };
  protoOf(View).has = function () {
    return this.may().n();
  };
  protoOf(View).waw = function () {
    return this.has().r2k_1;
  };
  protoOf(View).xaw = function () {
    return this.has().s2k_1;
  };
  protoOf(View).x1q = function () {
    return this.waw();
  };
  protoOf(View).y1q = function () {
    return this.xaw();
  };
  protoOf(View).t3r = function (v) {
    if (!(v === this.j9i_1.v3r())) {
      this.j9i_1.t3r(v);
      this.gav();
    }
  };
  protoOf(View).v3r = function () {
    return this.j9i_1.v3r();
  };
  protoOf(View).aby = function (v) {
    this.yaw(v);
  };
  protoOf(View).yaw = function (v) {
    if (!(this.j9i_1.s3r() === v)) {
      this.j9i_1.r3r(v);
      this.gav();
    }
  };
  protoOf(View).zaw = function () {
    return this.j9i_1.s3r();
  };
  protoOf(View).aax = function () {
    if (this.c9i_1)
      return Unit_instance;
    this.c9i_1 = true;
    var t = this.e9i_1.v2g();
    this.q9h_1 = t.j2h_1;
    this.r9h_1 = t.k2h_1;
    this.s9h_1 = t.l2h_1;
    this.t9h_1 = t.m2h_1;
    this.u9h_1 = t.n2h_1;
    this.v9h_1 = t.o2h_1;
    this.w9h_1 = t.p2h_1;
  };
  protoOf(View).v63 = function () {
    var tmp0_safe_receiver = this.r40();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v63();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  };
  protoOf(View).bax = function () {
    return this.m9h_1;
  };
  protoOf(View).cax = function (value) {
    if (!(this.b9i_1 === value)) {
      this.b9i_1 = value;
      this.fav();
    }
  };
  protoOf(View).dax = function () {
    return this.b9i_1;
  };
  protoOf(View).eax = function (matrix) {
    this.e9i_1 = matrix;
    this.c9i_1 = false;
    this.fav();
    this.max();
  };
  protoOf(View).zbf = function (value) {
    this.eax(value);
    this.fav();
    this.max();
  };
  protoOf(View).fax = function () {
    if (!this.d9i_1) {
      this.d9i_1 = true;
      this.r9i_1 = true;
      this.e9i_1 = Companion_getInstance_14().q2f(this.v4s(), this.w4s(), this.taw(), this.maw(), this.oaw(), this.raw(), this.saw(), 0.0, 0.0);
    }
    return this.e9i_1;
  };
  protoOf(View).gax = function () {
    if (!(this.g9i_1 === this.p9i_1)) {
      this.g9i_1 = this.p9i_1;
      this.r9i_1 = true;
      this.f9i_1 = !(this.r40() == null) ? this.fax().s2f(ensureNotNull(this.r40()).gax()) : this.fax();
    }
    return this.f9i_1;
  };
  protoOf(View).hax = function () {
    if (!(this.i9i_1 === this.p9i_1)) {
      this.i9i_1 = this.p9i_1;
      this.r9i_1 = true;
      this.h9i_1 = this.gax().u2g();
    }
    return this.h9i_1;
  };
  protoOf(View).iax = function () {
    updateRenderColorTransformIfRequired(this);
    return this.k9i_1;
  };
  protoOf(View).jax = function () {
    updateRenderBlendModeIfRequired(this);
    return this.m9i_1;
  };
  protoOf(View).kax = function () {
    updateRenderColorTransformIfRequired(this);
    return this.k9i_1.v3r();
  };
  protoOf(View).lax = function () {
    this.d9i_1 = false;
    this.fav();
  };
  protoOf(View).fav = function () {
    this.p9i_1 = this.p9i_1 + 1 | 0;
    this.r9i_1 = false;
    this.o9i_1 = true;
    this.t9x();
  };
  protoOf(View).max = function () {
    if (!(this.t9i_1 == null)) {
      this.t9i_1 = null;
      var tmp0_safe_receiver = this.r40();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.max();
      }
    }
  };
  protoOf(View).nax = function () {
    this.kas();
  };
  protoOf(View).oax = function () {
    this.kas();
  };
  protoOf(View).kas = function () {
  };
  protoOf(View).t9x = function () {
    var tmp0_safe_receiver = this.n9h_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dav(this);
    }
    this.max();
  };
  protoOf(View).gav = function () {
    this.q9i_1 = this.q9i_1 + 1 | 0;
    this.s9i_1 = false;
    this.o9i_1 = true;
    this.t9x();
  };
  protoOf(View).pax = function (phase) {
    if (this.v9i_1 == null)
      this.v9i_1 = fastArrayListOf([]);
    var tmp0_safe_receiver = this.v9i_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.r(phase);
    var tmp1_safe_receiver = this.v9i_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.sortBy' call
      if (tmp1_safe_receiver.n() > 1) {
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp = View$addRenderPhase$lambda;
        var tmp$ret$0 = new sam$kotlin_Comparator$0_0(tmp);
        sortWith(tmp1_safe_receiver, tmp$ret$0);
      }
    }
  };
  protoOf(View).ias = function (ctx) {
    if (!this.dax())
      return Unit_instance;
    var tmp0_safe_receiver = this.v9i_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp0_safe_receiver.y1u_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[tmp0].icf(this, ctx);
      }
    }
    try {
      this.qax(ctx);
    }finally {
      var tmp1_safe_receiver = this.v9i_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp1_safe_receiver.y1u_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp1_safe_receiver.n() - n_0 | 0) - 1 | 0].jcf(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  };
  protoOf(View).qax = function (ctx) {
    var oldPhase = this.w9i_1;
    try {
      this.w9i_1 = 0;
      this.rax(ctx);
    }finally {
      this.w9i_1 = oldPhase;
    }
  };
  protoOf(View).rax = function (ctx) {
    var stages = this.v9i_1;
    if (!(stages == null) ? this.w9i_1 < stages.n() : false) {
      var tmp1 = this.w9i_1;
      this.w9i_1 = tmp1 + 1 | 0;
      stages.f1(tmp1).kcf(this, ctx);
    } else {
      var tmp = this.w9i_1;
      var tmp3_elvis_lhs = stages == null ? null : stages.n();
      if (tmp === (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs)) {
        this.mas(ctx);
        this.w9i_1 = this.w9i_1 + 1 | 0;
      }
    }
  };
  protoOf(View).rav = function (ctx) {
    if (this.u9i_1 ? true : this === ctx.k9t_1) {
      this.sax(ctx);
    }
  };
  protoOf(View).sax = function (ctx) {
    var local = this.may();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.ma9_1;
    if (!(this_1.r9t_1 === this_0)) {
      this_1.r9t_1 = this_0;
      this_1.y9z();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.ya9_1 = null;
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_90().j9y_1;
          var doUpdate = !(this_0.xa9_1 === blending);
          var old = this_0.xa9_1;
          try {
            if (doUpdate) {
              this_0.ma9_1.y9z();
              this_0.xa9_1 = blending;
            }
            var color = Colors_getInstance().n3b_1;
            var m = this_0.ya9_1;
            var oldColor = this_0.pa9_1;
            this_0.pa9_1 = color;
            var tmp;
            try {
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.r33(this.fay());
              this_0.eaa(this_3, m);
              tmp = Unit_instance;
            }finally {
              this_0.pa9_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.ma9_1.y9z();
            }
            this_0.xa9_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().n3b_1;
        var m_0 = this_0.ya9_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.pa9_1;
        this_0.pa9_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.s2u(this.uax(new Vector2D(local.r2d(), local.t2d())));
          this_4.f2v(this.uax(new Vector2D(local.s2d(), local.t2d())));
          this_4.f2v(this.uax(new Vector2D(local.s2d(), local.u2d())));
          this_4.f2v(this.uax(new Vector2D(local.r2d(), local.u2d())));
          this_4.p21();
          this_0.eaa(this_4, m_0);
        }finally {
          this_0.pa9_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().b3h_1;
        var m_1 = this_0.ya9_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.pa9_1;
        this_0.pa9_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(ctx.j9t_1).vaa();
          this_5.w33(this.uax(local.g2e()), anchorSize);
          this_5.w33(this.uax(local.c2l()), anchorSize);
          this_5.w33(this.uax(local.i2e()), anchorSize);
          this_5.w33(this.uax(local.d2l()), anchorSize);
          this_5.w33(this.uax(interpolate_0(Companion_getInstance_15().c28_1, local.g2e(), local.c2l())), anchorSize);
          this_5.w33(this.uax(interpolate_0(Companion_getInstance_15().c28_1, local.c2l(), local.i2e())), anchorSize);
          this_5.w33(this.uax(interpolate_0(Companion_getInstance_15().c28_1, local.i2e(), local.d2l())), anchorSize);
          this_5.w33(this.uax(interpolate_0(Companion_getInstance_15().c28_1, local.d2l(), local.g2e())), anchorSize);
          this_0.eaa(this_5, m_1);
        }finally {
          this_0.pa9_1 = oldColor_1;
        }
        var color_2 = Colors_getInstance().p3b_1;
        var m_2 = this_0.ya9_1;
        var oldColor_2 = this_0.pa9_1;
        this_0.pa9_1 = color_2;
        var tmp_0;
        try {
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.uaw();
          this_6.q33(new Vector2D(center.g28_1, center.h28_1 - 5), new Vector2D(center.g28_1, center.h28_1 + 5));
          this_6.q33(new Vector2D(center.g28_1 - 5, center.h28_1), new Vector2D(center.g28_1 + 5, center.h28_1));
          this_0.eaa(this_6, m_2);
          tmp_0 = Unit_instance;
        }finally {
          this_0.pa9_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  };
  protoOf(View).toString = function () {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.v4s() === 0.0) ? true : !(this.w4s() === 0.0))
      out = out + (':pos=(' + this.tax(this.v4s()) + ',' + this.tax(this.w4s()) + ')');
    if (!(this.maw() === 1.0) ? true : !(this.oaw() === 1.0))
      out = out + (':scale=(' + this.tax(this.maw()) + ',' + this.tax(this.oaw()) + ')');
    if (!equals(this.raw(), Companion_getInstance_22().u2c_1) ? true : !equals(this.saw(), Companion_getInstance_22().u2c_1))
      out = out + (':skew=(' + this.tax(_Angle___get_degrees__impl__qg56vw(this.raw())) + ',' + this.tax(_Angle___get_degrees__impl__qg56vw(this.saw())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.taw()), Companion_getInstance_22().u2c_1))
      out = out + (':rotation=(' + this.tax(_Angle___get_degrees__impl__qg56vw(this.taw())) + '\xBA)');
    if (!(this.o9h_1 == null))
      out = out + (':name=(' + this.o9h_1 + ')');
    if (!this.p9h_1.equals(Companion_getInstance_90().a9y_1))
      out = out + (':blendMode=(' + this.p9h_1 + ')');
    if (!this.dax())
      out = out + (':visible=' + this.dax());
    if (!(this.zaw() === 1.0))
      out = out + (':alpha=' + niceStr(this.zaw(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.v3r()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().l3b_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.v3r()));
    return out;
  };
  protoOf(View).tax = function (_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  };
  protoOf(View).ia4 = function (p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.hax();
      if (this_0.p2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = new Vector2D(this_0.w2f(p.g28_1, p.h28_1), this_0.z2f(p.g28_1, p.h28_1));
    }
    return tmp$ret$0;
  };
  protoOf(View).uax = function (p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.gax();
      if (this_0.p2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = new Vector2D(this_0.w2f(p.g28_1, p.h28_1), this_0.z2f(p.g28_1, p.h28_1));
    }
    return tmp$ret$0;
  };
  protoOf(View).vax = function (globalPos, direction) {
    if (!this.x9i_1)
      return null;
    if (!this.dax())
      return null;
    var tmp0_safe_receiver = this.eav();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
      var n = 0;
      while (n < tmp0_safe_receiver.n()) {
        // Inline function 'korlibs.korge.view.View.hitTest.<anonymous>' call
        var tmp0_safe_receiver_0 = tmp0_safe_receiver.f1((tmp0_safe_receiver.n() - n | 0) - 1 | 0).vax(globalPos, direction);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          return tmp0_safe_receiver_0;
        }
        n = n + 1 | 0;
      }
    }
    var res = this.xax(globalPos);
    if (!(res == null))
      return res;
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(View).ta4 = function (globalPos, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.vax(globalPos, direction) : $super.vax.call(this, globalPos, direction);
  };
  protoOf(View).wax = function (p, direction) {
    if (!this.x9i_1)
      return null;
    var ll = this.ia4(p);
    var bounds = this.may();
    if (!bounds.a2l(ll)) {
      return null;
    }
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D_init_$Create$(this.yav(), this.zav());
    var l = new Vector2D(ll.g28_1 + that.g28_1, ll.h28_1 + that.h28_1);
    if (this.y9i_1 === false)
      return this;
    var hitShape = this.aaw();
    var hitShapes = this.baw();
    if (this.y9i_1 == null ? !(hitShape == null) ? true : !(hitShapes == null) : false) {
      if (hitShapes == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < hitShapes.n()) {
          // Inline function 'korlibs.korge.view.View.hitTestInternal.<anonymous>' call
          var tmp0 = n;
          n = tmp0 + 1 | 0;
          if (hitShapes.f1(tmp0).i34(l))
            return this;
        }
      }
      if (!(hitShape == null) ? hitShape.i34(l) : false)
        return this;
      return null;
    } else {
      return this;
    }
  };
  protoOf(View).xax = function (p, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.wax(p, direction) : $super.wax.call(this, p, direction);
  };
  protoOf(View).yax = function () {
    var tmp0_safe_receiver = this.r40();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.xav(this);
  };
  protoOf(View).zax = function (target, inclusive) {
    var tmp;
    if (target === this.r40()) {
      tmp = this.fax();
    } else if (target === this) {
      tmp = Companion_getInstance_14().e2f_1;
    } else {
      var commonAncestor = Companion_instance_84.fcf(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.r40() == null ? inclusive : false) {
          return this.gax();
        }
        tmp_0 = this.gax().s2f(target.hax());
      } else {
        tmp_0 = Companion_getInstance_14().e2f_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.s2f(target.fax());
    }
    return out;
  };
  protoOf(View).aay = function () {
    var tmp0_elvis_lhs = this.bay();
    return tmp0_elvis_lhs == null ? this.hay() : tmp0_elvis_lhs;
  };
  protoOf(View).bay = function () {
    var stage = this.v63();
    if (!(stage instanceof Stage))
      return null;
    return this.cay(stage);
  };
  protoOf(View).cay = function (bp) {
    return this.hay().p2l(bp.laa());
  };
  protoOf(View).day = function (ctx) {
    return ctx.gab() ? this.cay(ctx) : this.hay();
  };
  protoOf(View).eay = function (ctx) {
    return this.day(ctx);
  };
  protoOf(View).fay = function () {
    return this.hay();
  };
  protoOf(View).gay = function (includeFilters) {
    return this.kay(this.v63(), VOID, true, includeFilters);
  };
  protoOf(View).hay = function (includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.gay(includeFilters) : $super.gay.call(this, includeFilters);
  };
  protoOf(View).iay = function (concat, doAnchoring, includeFilters) {
    var out = this.lay(doAnchoring, includeFilters);
    if (concat.q2d() ? !concat.t2f() : false) {
      var tmp = Companion_getInstance_17();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.g2e();
        if (concat.p2d()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = new Vector2D(concat.w2f(p.g28_1, p.h28_1), concat.z2f(p.g28_1, p.h28_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.c2l();
        if (concat.p2d()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = new Vector2D(concat.w2f(p_0.g28_1, p_0.h28_1), concat.z2f(p_0.g28_1, p_0.h28_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.i2e();
        if (concat.p2d()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = new Vector2D(concat.w2f(p_1.g28_1, p_1.h28_1), concat.z2f(p_1.g28_1, p_1.h28_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.d2l();
        if (concat.p2d()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = new Vector2D(concat.w2f(p_2.g28_1, p_2.h28_1), concat.z2f(p_2.g28_1, p_2.h28_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.b2e(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  };
  protoOf(View).jay = function (target, doAnchoring, inclusive, includeFilters) {
    return this.iay(this.zax(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  };
  protoOf(View).kay = function (target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.jay(target, doAnchoring, inclusive, includeFilters) : $super.jay.call(this, target, doAnchoring, inclusive, includeFilters);
  };
  protoOf(View).lay = function (doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.t9i_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.jas();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.t9i_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.m2g(Vector2D_init_$Create$(this.yav(), this.zav()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
      }
    }
    return out;
  };
  protoOf(View).may = function (doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.lay(doAnchoring, includeFilters) : $super.lay.call(this, doAnchoring, includeFilters);
  };
  protoOf(View).jas = function () {
    return Companion_getInstance_5().z2d();
  };
  protoOf(View).o7m = function (type, event, result) {
    var tmp0_safe_receiver = this.r40();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.v7m(type, event, result);
  };
  function addUpdater(_this__u8e3s4, first, firstTime, updatable) {
    first = first === VOID ? true : first;
    firstTime = firstTime === VOID ? Companion_getInstance().va_1 : firstTime;
    if (first)
      updatable(_this__u8e3s4, new Duration(firstTime));
    var tmp = Companion_instance_85;
    return _this__u8e3s4.h7m(tmp, addUpdater$lambda(updatable, _this__u8e3s4));
  }
  function addUpdater_0(_this__u8e3s4, updatable) {
    return addUpdater(_this__u8e3s4, true, VOID, updatable);
  }
  function addUpdaterWithViews(_this__u8e3s4, updatable) {
    var tmp = Companion_instance_86;
    return _this__u8e3s4.h7m(tmp, addUpdaterWithViews$lambda(updatable, _this__u8e3s4));
  }
  function hasAncestor(_this__u8e3s4, ancestor) {
    var tmp;
    if (equals(_this__u8e3s4, ancestor)) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = _this__u8e3s4.r40();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
      tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    }
    return tmp;
  }
  function position(_this__u8e3s4, x, y) {
    return xy(_this__u8e3s4, new Vector2D(x, y));
  }
  function descendantsWith(_this__u8e3s4, out, check) {
    var tmp;
    if (out === VOID) {
      // Inline function 'kotlin.collections.arrayListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = out;
    }
    out = tmp;
    if (!(_this__u8e3s4 == null)) {
      if (check(_this__u8e3s4)) {
        // Inline function 'kotlin.collections.plusAssign' call
        out.r(_this__u8e3s4);
      }
      if (_this__u8e3s4.d9h_1) {
        // Inline function 'korlibs.korge.view.View.forEachChild' call
        var tmp0_safe_receiver = _this__u8e3s4.eav();
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'korlibs.datastructure.iterators.fastForEach' call
          var n = 0;
          while (n < tmp0_safe_receiver.n()) {
            // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
            var tmp0 = n;
            n = tmp0 + 1 | 0;
            var child = tmp0_safe_receiver.f1(tmp0);
            descendantsWith(child, out, check);
          }
          tmp_0 = Unit_instance;
        }
      }
    }
    return out;
  }
  function addFixedUpdater(_this__u8e3s4, time, first, limitCallsPerFrame, updatable) {
    first = first === VOID ? true : first;
    limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
    // Inline function 'korlibs.time.milliseconds' call
    var tmp$ret$0 = toDuration(0.0, DurationUnit_MILLISECONDS_getInstance());
    var accum = {_v: new Duration(tmp$ret$0)};
    return addUpdater(_this__u8e3s4, first, time, addFixedUpdater$lambda(accum, time, updatable, _this__u8e3s4, limitCallsPerFrame));
  }
  function findFirstAscendant(_this__u8e3s4, cond) {
    var current = _this__u8e3s4;
    while (!(current == null)) {
      if (cond(current))
        return current;
      current = current.r40();
    }
    return null;
  }
  function get_ancestorCount(_this__u8e3s4) {
    var count = 0;
    var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.r40();
    while (!(parent == null)) {
      count = count + 1 | 0;
      parent = parent.r40();
    }
    return count;
  }
  function ViewRenderPhase() {
  }
  function xy(_this__u8e3s4, p) {
    _this__u8e3s4.u46(p);
    return _this__u8e3s4;
  }
  function size(_this__u8e3s4, size) {
    _this__u8e3s4.vaw(size);
    return _this__u8e3s4;
  }
  function onStageResized(_this__u8e3s4, firstTrigger, block) {
    firstTrigger = firstTrigger === VOID ? true : firstTrigger;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.onStageResized.<anonymous>' call
    if (firstTrigger) {
      deferWithViews(_this__u8e3s4, VOID, VOID, onStageResized$lambda(block));
    }
    var tmp = Companion_instance_87;
    _this__u8e3s4.h7m(tmp, onStageResized$lambda_0(block));
    return _this__u8e3s4;
  }
  function alpha(_this__u8e3s4, alpha) {
    _this__u8e3s4.yaw(alpha);
    return _this__u8e3s4;
  }
  function addFixedUpdater_0(_this__u8e3s4, timesPerSecond, initial, limitCallsPerFrame, updatable) {
    initial = initial === VOID ? true : initial;
    limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
    return addFixedUpdater(_this__u8e3s4, _Frequency___get_timeSpan__impl__f9mrmt(timesPerSecond), initial, limitCallsPerFrame, updatable);
  }
  function xy_0(_this__u8e3s4, x, y) {
    _this__u8e3s4.iaw(x, y);
    return _this__u8e3s4;
  }
  function deferWithViews(_this__u8e3s4, views, tryImmediate, block) {
    views = views === VOID ? null : views;
    tryImmediate = tryImmediate === VOID ? true : tryImmediate;
    if (tryImmediate) {
      var tmp;
      if (views == null) {
        var tmp0_safe_receiver = _this__u8e3s4.bax();
        tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.na2();
      } else {
        tmp = views;
      }
      var tmp2_safe_receiver = tmp;
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        block(tmp2_safe_receiver);
        return _this__u8e3s4;
      }
    }
    onNextFrame(_this__u8e3s4, deferWithViews$lambda(block));
    return _this__u8e3s4;
  }
  function onNextFrame(_this__u8e3s4, block) {
    var closeable = {_v: null};
    closeable._v = addUpdaterWithViews(_this__u8e3s4, onNextFrame$lambda(block, closeable));
    return closeable._v;
  }
  function colorMul(_this__u8e3s4, color) {
    _this__u8e3s4.t3r(color);
    return _this__u8e3s4;
  }
  function addUpdater$lambda($updatable, $this_addUpdater) {
    return function (it) {
      $updatable($this_addUpdater, new Duration(Duration__times_impl_sfuzvp(it.ib1_1, $this_addUpdater.haw())));
      return Unit_instance;
    };
  }
  function addUpdaterWithViews$lambda($updatable, $this_addUpdaterWithViews) {
    return function (it) {
      $updatable($this_addUpdaterWithViews, it.ncf_1, new Duration(Duration__times_impl_sfuzvp(it.ocf_1, $this_addUpdaterWithViews.haw())));
      return Unit_instance;
    };
  }
  function addFixedUpdater$lambda($accum, $time, $updatable, $this_addFixedUpdater, $limitCallsPerFrame) {
    return function ($this$addUpdater, dt) {
      $accum._v = new Duration(Duration__plus_impl_yu9v8f($accum._v.aj_1, dt.aj_1));
      var calls = 0;
      $l$loop: while (Duration__compareTo_impl_pchp0f($accum._v.aj_1, Duration__times_impl_sfuzvp($time, 0.75)) >= 0) {
        $accum._v = new Duration(Duration__minus_impl_q5cfm7($accum._v.aj_1, $time));
        $updatable($this_addFixedUpdater);
        calls = calls + 1 | 0;
        if (calls >= $limitCallsPerFrame) {
          // Inline function 'korlibs.time.milliseconds' call
          var tmp$ret$0 = toDuration(0.0, DurationUnit_MILLISECONDS_getInstance());
          $accum._v = new Duration(tmp$ret$0);
          break $l$loop;
        }
      }
      var tmp;
      if (calls > 0) {
        var tmp_0;
        if (Duration__compareTo_impl_pchp0f($accum._v.aj_1, Duration__times_impl_sfuzvp($time, 0.25)) < 0) {
          // Inline function 'korlibs.time.milliseconds' call
          var tmp$ret$1 = toDuration(0.0, DurationUnit_MILLISECONDS_getInstance());
          $accum._v = new Duration(tmp$ret$1);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function onStageResized$lambda($block) {
    return function (views) {
      $block(views, views.jaa(), views.iaa());
      return Unit_instance;
    };
  }
  function onStageResized$lambda_0($block) {
    return function (it) {
      $block(it.rcf_1, it.rcf_1.jaa(), it.rcf_1.iaa());
      return Unit_instance;
    };
  }
  function deferWithViews$lambda($block) {
    return function ($this$onNextFrame, it) {
      $block(it);
      return Unit_instance;
    };
  }
  function onNextFrame$lambda($block, $closeable) {
    return function ($this$addUpdaterWithViews, views, _anonymous_parameter_1__qggqgd) {
      $block($this$addUpdaterWithViews, views);
      var tmp0_safe_receiver = $closeable._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.p21();
      }
      return Unit_instance;
    };
  }
  function scale$factory($b0) {
    return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
      return $b0.q2h();
    }, function (value) {
      return $b0.kaw(value);
    });
  }
  function currentMatrix$factory_0($b0) {
    return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
      return $b0.ya9_1;
    }, function (value) {
      $b0.ya9_1 = value;
      return Unit_instance;
    });
  }
  function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0, resultContinuation) {
    this.bcg_1 = $view;
    this.ccg_1 = $ctx;
    this.dcg_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.bcg_1.sc7(ensureNotNull(this.ccg_1.j9t_1), VOID, this.dcg_1.nc7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda).g5a = function (completion) {
    return new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda(this.bcg_1, this.ccg_1, this.dcg_1, completion);
  };
  function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0, resultContinuation) {
    var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function Mixin_0() {
    this.mc7_1 = true;
    this.nc7_1 = null;
  }
  protoOf(Mixin_0).pc7 = function (_set____db54di) {
    this.mc7_1 = _set____db54di;
  };
  protoOf(Mixin_0).lc7 = function (value) {
    this.mc7_1 = false;
    this.nc7_1 = value;
  };
  protoOf(Mixin_0).kc7 = function (_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.lc7(sourceFile);
    _this__u8e3s4.pc7(true);
    return Unit_instance;
  };
  protoOf(Mixin_0).rc7 = function (views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw new NotImplementedError('An operation is not implemented: ' + reason);
  };
  protoOf(Mixin_0).qc7 = function (ctx, view) {
    if (this.mc7_1)
      return Unit_instance;
    this.ecg(ctx, view);
  };
  protoOf(Mixin_0).ecg = function (ctx, view) {
    if (!this.mc7_1 ? !(this.nc7_1 == null) : false) {
      this.mc7_1 = true;
      launchImmediately_0(ctx.q9s_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this, null));
    }
  };
  function ViewFileRef() {
  }
  function Views$_init_$lambda_jivasj(it) {
    return new Stage(it);
  }
  function Views$realSettingsFolder$delegate$lambda(this$0) {
    return function () {
      return !(this$0.x9e_1 == null) ? ensureNotNull(this$0.x9e_1) : StandardPaths_instance.h6b(this$0.fcg());
    };
  }
  function Views$close$slambda(this$0, resultContinuation) {
    this.ocg_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Views$close$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Views$close$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(Views$close$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.ocg_1.pcg(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(Views$close$slambda).g5a = function (completion) {
    return new Views$close$slambda(this.ocg_1, completion);
  };
  function Views$close$slambda_0(this$0, resultContinuation) {
    var i = new Views$close$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function Views$tempViewsPool$lambda(it) {
    return FastArrayList_init_$Create$();
  }
  function Views$lambda(this$0) {
    return function (it) {
      this$0.p9f_1.qa5();
      return Unit_instance;
    };
  }
  function Views$lambda_0(this$0) {
    return function (it) {
      this$0.p9f_1.ya7();
      return Unit_instance;
    };
  }
  function $initCOROUTINE$15(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ycg_1 = _this__u8e3s4;
  }
  protoOf($initCOROUTINE$15).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = debugBmpFont(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.ycg_1.l9f_1 = ARGUMENT;
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $closeSuspendCOROUTINE$16(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hch_1 = _this__u8e3s4;
  }
  protoOf($closeSuspendCOROUTINE$16).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            KorgeReload_getInstance().o9v();
            var tmp_0 = this;
            tmp_0.ich_1 = this.hch_1.y9f_1;
            this.jch_1 = 0;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!(this.jch_1 < this.ich_1.n())) {
              this.fd_1 = 3;
              continue $sm;
            }

            var tmp_1 = this;
            var tmp0 = this.jch_1;
            this.jch_1 = tmp0 + 1 | 0;
            tmp_1.kch_1 = this.ich_1.f1(tmp0);
            this.fd_1 = 2;
            suspendResult = this.kch_1.x5u(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.fd_1 = 1;
            continue $sm;
          case 3:
            this.hch_1.y9f_1.b3();
            cancel_1(this.hch_1.p9e_1);
            this.hch_1.v9e_1.lch();
            return Unit_instance;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function Views(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_1 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_85().p9c_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    BaseEventListener.call(this);
    this.p9e_1 = coroutineContext;
    this.q9e_1 = ag;
    this.r9e_1 = injector;
    this.s9e_1 = input;
    this.t9e_1 = timeProvider;
    this.u9e_1 = stats;
    this.v9e_1 = gameWindow;
    this.w9e_1 = gameId;
    this.x9e_1 = settingsFolder;
    this.y9e_1 = batchMaxQuads;
    this.z9e_1 = bp;
    this.a9f_1 = stageBuilder;
    this.b9f_1 = new Mixin();
    this.c9f_1 = quality$factory(this.v9e_1);
    this.d9f_1 = this;
    this.e9f_1 = false;
    this.f9f_1 = continuousRenderMode$factory(this.v9e_1);
    this.g9f_1 = new ReshapeEvent(0, 0);
    this.h9f_1 = new UpdateEvent();
    this.i9f_1 = new ViewsUpdateEvent(this);
    this.j9f_1 = new ViewsResizedEvent(this);
    var tmp_0 = this;
    tmp_0.k9f_1 = lazy(Views$realSettingsFolder$delegate$lambda(this));
    this.m9f_1 = null;
    this.n9f_1 = get_resourcesVfs();
    this.o9f_1 = get_RegisteredImageFormats();
    this.p9f_1 = new RenderContext(this.q9e_1, this, this.v9e_1, this.u9e_1, this.p9e_1, this.y9e_1, this.v9e_1);
    this.q9f_1 = true;
    this.r9f_1 = Colors_getInstance().m3b_1;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.s9f_1 = HashMap_init_$Create$();
    var tmp_2 = this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.t9f_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    this.u9f_1 = new Resources(this.p9e_1, this.n9f_1);
    this.v9f_1 = false;
    var tmp_3 = this;
    DefaultViewport_getInstance();
    tmp_3.w9f_1 = 1280;
    var tmp_4 = this;
    DefaultViewport_getInstance();
    tmp_4.x9f_1 = 720;
    var tmp_5 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_5.y9f_1 = ArrayList_init_$Create$();
    this.z9f_1 = Companion_getInstance_10().l2m_1;
    this.a9g_1 = Companion_getInstance_11().j2c_1;
    this.b9g_1 = true;
    this.c9g_1 = this.a9f_1(this);
    this.d9g_1 = this.c9g_1;
    this.e9g_1 = true;
    this.f9g_1 = false;
    this.g9g_1 = debugExtraFontScale$factory(this.p9f_1);
    this.h9g_1 = debugExtraFontColor$factory(this.p9f_1);
    this.i9g_1 = FastArrayList_init_$Create$();
    this.j9g_1 = this.t9e_1.e1q();
    var tmp_6 = this;
    tmp_6.k9g_1 = Pool_init_$Create$(VOID, Views$tempViewsPool$lambda);
    this.l9g_1 = SizeInt_init_$Create$();
    this.m9g_1 = SizeInt_init_$Create$();
    this.n9g_1 = SizeInt_init_$Create$();
    this.o9g_1 = new Signal();
    this.p9g_1 = new Signal();
    this.q9g_1 = -1.0;
    this.r9e_1.h27(getKClass(CoroutineContext), this.p9e_1);
    this.r9e_1.h27(getKClass(AG), this.q9e_1);
    this.r9e_1.h27(getKClass(Views), this);
    this.p9g_1.w5n(Views$lambda(this));
    this.o9g_1.w5n(Views$lambda_0(this));
    installFpsDebugOverlay(this);
    this.r9g_1 = Companion_instance.s13('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    this.s9g_1 = new EventResult();
    this.t9g_1 = new Signal();
    this.u9g_1 = Companion_getInstance_2().r24('debugHightlightView');
    this.v9g_1 = new Signal();
    this.w9g_1 = new Signal();
    this.x9g_1 = ArrayList_init_$Create$();
    this.y9g_1 = updatedSinceFrame$factory(this.v9e_1);
  }
  protoOf(Views).w1a = function () {
    return this.p9e_1;
  };
  protoOf(Views).h23 = function (_set____db54di) {
    this.b9f_1.h23(_set____db54di);
  };
  protoOf(Views).i23 = function () {
    return this.b9f_1.i23();
  };
  protoOf(Views).gaa = function (_set____db54di) {
    this.z9e_1.gaa(_set____db54di);
  };
  protoOf(Views).haa = function () {
    return this.z9e_1.haa();
  };
  protoOf(Views).iaa = function () {
    return this.z9e_1.iaa();
  };
  protoOf(Views).jaa = function () {
    return this.z9e_1.jaa();
  };
  protoOf(Views).kaa = function (_set____db54di) {
    this.z9e_1.kaa(_set____db54di);
  };
  protoOf(Views).laa = function () {
    return this.z9e_1.laa();
  };
  protoOf(Views).maa = function () {
    return this.z9e_1.maa();
  };
  protoOf(Views).naa = function (_set____db54di) {
    this.z9e_1.naa(_set____db54di);
  };
  protoOf(Views).oaa = function () {
    return this.z9e_1.oaa();
  };
  protoOf(Views).paa = function () {
    return this.z9e_1.paa();
  };
  protoOf(Views).qaa = function () {
    return this.z9e_1.qaa();
  };
  protoOf(Views).raa = function () {
    return this.z9e_1.raa();
  };
  protoOf(Views).saa = function () {
    return this.z9e_1.saa();
  };
  protoOf(Views).taa = function (_set____db54di) {
    this.z9e_1.taa(_set____db54di);
  };
  protoOf(Views).uaa = function () {
    return this.z9e_1.uaa();
  };
  protoOf(Views).vaa = function () {
    return this.z9e_1.vaa();
  };
  protoOf(Views).waa = function (_set____db54di) {
    this.z9e_1.waa(_set____db54di);
  };
  protoOf(Views).xaa = function () {
    return this.z9e_1.xaa();
  };
  protoOf(Views).y9o = function (pos) {
    return this.z9e_1.y9o(pos);
  };
  protoOf(Views).yaa = function () {
    return this.v9e_1.yaa();
  };
  protoOf(Views).zaa = function () {
    return this.v9e_1.zaa();
  };
  protoOf(Views).aab = function () {
    return this.v9e_1.aab();
  };
  protoOf(Views).bab = function () {
    return this.v9e_1.bab();
  };
  protoOf(Views).na2 = function () {
    return this.d9f_1;
  };
  protoOf(Views).s9u = function (_set____db54di) {
    var this_0 = this.f9f_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(Views).a9q = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f9f_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  };
  protoOf(Views).fcg = function () {
    return replace(replace(replace(this.w9e_1, '\\', ''), '/', ''), '..', '');
  };
  protoOf(Views).sby = function () {
    var tmp = this.l9f_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  };
  protoOf(Views).l60 = function ($completion) {
    var tmp = new $initCOROUTINE$15(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Views).r9u = function () {
    return this.u9f_1;
  };
  protoOf(Views).t9u = function () {
    return this.q9e_1.o7u().n7w_1;
  };
  protoOf(Views).u9u = function () {
    return this.q9e_1.o7u().o7w_1;
  };
  protoOf(Views).mch = function (value) {
    this.w9f_1 = numberToInt(value);
  };
  protoOf(Views).nch = function () {
    return this.w9f_1;
  };
  protoOf(Views).och = function (value) {
    this.x9f_1 = numberToInt(value);
  };
  protoOf(Views).pch = function () {
    return this.x9f_1;
  };
  protoOf(Views).eca = function (value) {
    this.mch(value.r2k_1);
    this.och(value.s2k_1);
  };
  protoOf(Views).dca = function () {
    return new Size2D(this.nch(), this.pch());
  };
  protoOf(Views).p21 = function () {
    launchImmediately(this, Views$close$slambda_0(this, null));
  };
  protoOf(Views).pcg = function ($completion) {
    var tmp = new $closeSuspendCOROUTINE$16(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(Views).t9r = function (_set____db54di) {
    var this_0 = this.g9g_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(Views).qch = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g9g_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  };
  protoOf(Views).u9r = function (_set____db54di) {
    var this_0 = this.h9g_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  };
  protoOf(Views).rch = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h9g_1;
    debugFontColor$factory_0();
    return this_0.get().b3s_1;
  };
  protoOf(Views).kby = function (block) {
    this.i9g_1.r(block);
  };
  protoOf(Views).j7m = function (type, event, result, up, down) {
    event.c7n(false);
    var result_0 = protoOf(BaseEventListener).j7m.call(this, type, event, result, up, down);
    var e = event;
    e.b7n(this.d9f_1);
    if (e instanceof KeyEvent) {
      this.s9e_1.wa1(e);
      this.s9e_1.l9p_1.qa1(e);
      if ((e.n7n_1.equals(Type_UP_getInstance()) ? this.e9g_1 : false) ? e.p7n_1.equals(Key_F12_getInstance()) ? true : e.p7n_1.equals(Key_F7_getInstance()) : false) {
        this.f9g_1 = !this.f9g_1;
        this.v9e_1.sch(this.f9g_1);
        this.dav(this.c9g_1);
      }
    }
    try {
      return this.c9g_1.s7m(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  };
  protoOf(Views).tch = function (frameBuffer) {
    this.p9f_1.s9t_1 = frameBuffer;
    if (this.q9f_1) {
      var tmp0_$this = this.p9f_1;
      var tmp1_color = this.r9f_1;
      tmp0_$this.iab(tmp1_color, 1.0, 0, true, true, true);
    }
    this.o9g_1.x5n(this.p9f_1);
    this.p9f_1.y9z();
    this.c9g_1.ias(this.p9f_1);
    this.p9f_1.y9z();
    this.c9g_1.rav(this.p9f_1);
    if (this.f9g_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.i9g_1.y1u_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[tmp0](this, this.p9f_1);
      }
    }
    this.p9g_1.x5n(this.p9f_1);
    this.p9f_1.y9z();
  };
  protoOf(Views).uch = function (frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.q9e_1.o7u() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.tch(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.tch.call(this, frameBuffer);
    }
    return tmp;
  };
  protoOf(Views).vch = function () {
    this.q9e_1.s7u();
    this.uch();
  };
  protoOf(Views).b9q = function (fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.t9e_1.e1q();
    this.d9f_1.u9e_1.s7u();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_78().g9a_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.f25(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.g25(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.j9g_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.d9f_1.t9f_1) > 0 ? this.d9f_1.t9f_1 : delta;
    this.j9g_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, get_NIL(Companion_getInstance()))) {
        this.wch(fixedSizeStep);
      } else {
        this.wch(adelta);
      }
    }
    var doRender2 = doRender ? forceRender ? true : this.xch() > 0 : false;
    if (doRender2) {
      if (this.r9g_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_1().g1q().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.xch() + ']');
      }
      this.vch();
      this.s7u();
    }
  };
  protoOf(Views).wch = function (elapsed) {
    this.s9e_1.ra1(elapsed);
    this.s9g_1.n1y();
    updateSingleViewWithViewsAll(this.c9g_1, this, elapsed);
    this.s9e_1.sa1(elapsed);
  };
  protoOf(Views).x9p = function () {
  };
  protoOf(Views).l9s = function (width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.m9g_1 = new SizeInt(actualWidth, actualHeight);
    this.ych();
  };
  protoOf(Views).ych = function () {
    setBoundsInfo(this.z9e_1, Size2D_init_$Create$(this.w9f_1, this.x9f_1), toFloat(this.m9g_1), this.z9f_1, this.a9g_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.p9f_1.x9s_1 = this.z9e_1.laa();
    this.p9f_1.y9s_1 = this.z9e_1.uaa();
    // Inline function 'kotlin.also' call
    var this_0 = this.g9f_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.m7q_1 = this.m9g_1.u2l_1;
    this_0.n7q_1 = this.m9g_1.v2l_1;
    this.s7m(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.j9f_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.scf_1 = this.l9g_1;
    this.s7m(this_1);
    this.c9g_1.fav();
  };
  protoOf(Views).zch = function (viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened ? !this.v9e_1.s9r() : false)
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.u9g_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.f25(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + viewToHightlight;
      this_0.g25(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.t9g_1.x5n(viewToHightlight);
  };
  protoOf(Views).waj = function (viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.zch(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.zch.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  };
  protoOf(Views).aci = function (_set____db54di) {
    var this_0 = this.y9g_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(Views).xch = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y9g_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  };
  protoOf(Views).s7u = function () {
    this.v9e_1.s7u();
  };
  protoOf(Views).dav = function (view) {
    this.v9e_1.bci();
  };
  function Base() {
    this.cci_1 = Companion_getInstance_14().h2f();
    this.dci_1 = MatrixTransform_init_$Create$();
    this.eci_1 = Companion_getInstance_14().h2f();
    this.fci_1 = MatrixTransform_init_$Create$();
    var tmp = this;
    var tmp_0 = Companion_getInstance_5();
    DefaultViewport_getInstance();
    DefaultViewport_getInstance();
    tmp.gci_1 = tmp_0.p2k(0, 0, 1280, 720);
  }
  protoOf(Base).taa = function (_set____db54di) {
    this.cci_1 = _set____db54di;
  };
  protoOf(Base).uaa = function () {
    return this.cci_1;
  };
  protoOf(Base).waa = function (_set____db54di) {
    this.dci_1 = _set____db54di;
  };
  protoOf(Base).xaa = function () {
    return this.dci_1;
  };
  protoOf(Base).kaa = function (_set____db54di) {
    this.eci_1 = _set____db54di;
  };
  protoOf(Base).laa = function () {
    return this.eci_1;
  };
  protoOf(Base).naa = function (_set____db54di) {
    this.fci_1 = _set____db54di;
  };
  protoOf(Base).oaa = function () {
    return this.fci_1;
  };
  protoOf(Base).gaa = function (_set____db54di) {
    this.gci_1 = _set____db54di;
  };
  protoOf(Base).haa = function () {
    return this.gci_1;
  };
  function BoundsProvider() {
  }
  function Companion_71() {
  }
  var Companion_instance_85;
  function Companion_getInstance_97() {
    return Companion_instance_85;
  }
  function UpdateEvent(deltaTime) {
    deltaTime = deltaTime === VOID ? Companion_getInstance().va_1 : deltaTime;
    Event.call(this);
    this.ib1_1 = deltaTime;
  }
  protoOf(UpdateEvent).u2f = function () {
    return Companion_instance_85;
  };
  protoOf(UpdateEvent).toString = function () {
    return 'UpdateEvent(time=' + new Duration(this.ib1_1) + ')';
  };
  function Companion_72() {
  }
  var Companion_instance_86;
  function Companion_getInstance_98() {
    return Companion_instance_86;
  }
  function ViewsUpdateEvent(views, delta) {
    delta = delta === VOID ? Companion_getInstance().va_1 : delta;
    Event.call(this);
    this.ncf_1 = views;
    this.ocf_1 = delta;
  }
  protoOf(ViewsUpdateEvent).u2f = function () {
    return Companion_instance_86;
  };
  protoOf(ViewsUpdateEvent).toString = function () {
    return 'ViewsUpdateEvent(time=' + new Duration(this.ocf_1) + ')';
  };
  function Companion_73() {
  }
  var Companion_instance_87;
  function Companion_getInstance_99() {
    return Companion_instance_87;
  }
  function ViewsResizedEvent(views, size) {
    size = size === VOID ? new SizeInt(0, 0) : size;
    Event.call(this);
    this.rcf_1 = views;
    this.scf_1 = size;
  }
  protoOf(ViewsResizedEvent).u2f = function () {
    return Companion_instance_87;
  };
  protoOf(ViewsResizedEvent).toString = function () {
    return 'ViewsResizedEvent(size=' + this.scf_1 + ')';
  };
  function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
    // Inline function 'kotlin.also' call
    var this_0 = views.h9f_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
    this_0.ib1_1 = delta;
    _this__u8e3s4.s7m(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = views.i9f_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
    this_1.ocf_1 = delta;
    _this__u8e3s4.s7m(this_1);
  }
  function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
    scaleMode = scaleMode === VOID ? Companion_getInstance_10().o2m() : scaleMode;
    anchor = anchor === VOID ? Companion_getInstance_11().o2c() : anchor;
    virtualSize = virtualSize === VOID ? Ref() : virtualSize;
    targetSize = targetSize === VOID ? Ref() : targetSize;
    var reqVirtualSize_0 = toInt(reqVirtualSize);
    var actualSize_0 = toInt(actualSize);
    virtualSize.d1z(reqVirtualSize_0);
    targetSize.d1z(scaleMode.s2m(virtualSize.m2(), actualSize_0));
    var ratioX = targetSize.m2().u2l_1 / reqVirtualSize_0.u2l_1;
    var ratioY = targetSize.m2().v2l_1 / reqVirtualSize_0.v2l_1;
    var actualVirtualWidth = toIntRound_0(actualSize_0.u2l_1 / ratioX);
    var actualVirtualHeight = toIntRound_0(actualSize_0.v2l_1 / ratioY);
    _this__u8e3s4.kaa(Companion_getInstance_14().e2f_1.k2g(ratioX, ratioY).s2g(toIntRound_0((actualVirtualWidth - reqVirtualSize_0.u2l_1 | 0) * anchor.p2c_1), toIntRound_0((actualVirtualHeight - reqVirtualSize_0.v2l_1 | 0) * anchor.q2c_1)));
    _this__u8e3s4.taa(_this__u8e3s4.laa().u2g());
    _this__u8e3s4.naa(_this__u8e3s4.laa().v2g());
    _this__u8e3s4.waa(_this__u8e3s4.uaa().v2g());
    var tl = _this__u8e3s4.y9o(Vector2D_init_$Create$_0(0, 0));
    var br = _this__u8e3s4.y9o(new Vector2D(actualSize_0.u2l_1, actualSize_0.v2l_1));
    _this__u8e3s4.gaa(Companion_getInstance_5().t2k(tl.g28_1, tl.h28_1, br.g28_1, br.h28_1));
  }
  function views($completion) {
    var tmp = new $viewsCOROUTINE$17($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function $viewsCOROUTINE$17(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($viewsCOROUTINE$17).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = injector(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult.q27(getKClass(Views));
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function quality$factory($b0) {
    return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
      return $b0.o9r();
    }, function (value) {
      return $b0.p9r(value);
    });
  }
  function continuousRenderMode$factory($b0) {
    return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
      return $b0.pci();
    }, function (value) {
      return $b0.qci(value);
    });
  }
  function debugExtraFontScale$factory($b0) {
    return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
      return $b0.l9t_1;
    }, function (value) {
      $b0.l9t_1 = value;
      return Unit_instance;
    });
  }
  function debugExtraFontColor$factory($b0) {
    return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
      return new RGBA($b0.m9t_1);
    }, function (value) {
      $b0.m9t_1 = value.b3s_1;
      return Unit_instance;
    });
  }
  function updatedSinceFrame$factory($b0) {
    return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
      return $b0.b9o_1;
    }, function (value) {
      $b0.b9o_1 = value;
      return Unit_instance;
    });
  }
  function forceRenderEveryFrame$factory() {
    return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
      return receiver.a9q();
    }, function (receiver, value) {
      return receiver.s9u(value);
    });
  }
  function forceRenderEveryFrame$factory_0() {
    return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
      return receiver.a9q();
    }, function (receiver, value) {
      return receiver.s9u(value);
    });
  }
  function debugFontExtraScale$factory() {
    return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
      return receiver.qch();
    }, function (receiver, value) {
      return receiver.t9r(value);
    });
  }
  function debugFontExtraScale$factory_0() {
    return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
      return receiver.qch();
    }, function (receiver, value) {
      return receiver.t9r(value);
    });
  }
  function debugFontColor$factory() {
    return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(receiver.rch());
    }, function (receiver, value) {
      return receiver.u9r(value.b3s_1);
    });
  }
  function debugFontColor$factory_0() {
    return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(receiver.rch());
    }, function (receiver, value) {
      return receiver.u9r(value.b3s_1);
    });
  }
  function virtualSize$factory($b0) {
    return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
      return $b0.l9g_1;
    }, function (value) {
      $b0.l9g_1 = value;
      return Unit_instance;
    });
  }
  function targetSize$factory($b0) {
    return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
      return $b0.n9g_1;
    }, function (value) {
      $b0.n9g_1 = value;
      return Unit_instance;
    });
  }
  function updatedSinceFrame$factory_0() {
    return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
      return receiver.xch();
    }, function (receiver, value) {
      return receiver.aci(value);
    });
  }
  function updatedSinceFrame$factory_1() {
    return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
      return receiver.xch();
    }, function (receiver, value) {
      return receiver.aci(value);
    });
  }
  function _get_computedDirection__2w15cx($this) {
    var tmp1_elvis_lhs = $this.fcl_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = $this.ecl_1;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f50_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? Direction_FORWARD_getInstance() : tmp2_elvis_lhs;
  }
  function setFrame($this, frameIndex) {
    var tmp;
    var tmp0_safe_receiver = $this.ecl_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e50_1;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !tmp1_safe_receiver.b1();
    }
    if (tmp_0 === true) {
      var tmp2_safe_receiver = $this.ecl_1;
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.e50_1;
      tmp = tmp3_safe_receiver == null ? null : getCyclicOrNull(tmp3_safe_receiver, frameIndex);
    } else {
      tmp = null;
    }
    var frame = tmp;
    if (!(frame == null)) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = frame.b50_1;
      var n = 0;
      while (n < this_0.n()) {
        // Inline function 'korlibs.korge.view.animation.ImageAnimationView.setFrame.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var it = this_0.f1(tmp0);
        var image = $this.pcl().f1(it.k4x_1.h4x_1);
        if (it.k4x_1.j4x_1.ka_1 === 0) {
          (isInterface(image, SmoothedBmpSlice) ? image : THROW_CCE()).oba(it.t4x_1);
        } else {
          if (!(image instanceof TileMap))
            THROW_CCE();
          var tilemap = it.p4x_1;
          if (tilemap == null) {
            var tmp_1 = image;
            var tmp_2 = Companion_instance_10;
            // Inline function 'korlibs.datastructure.Companion.invoke' call
            var tmp_3 = 0;
            var tmp_4 = imul(1, 1);
            var tmp_5 = new Int32Array(tmp_4);
            while (tmp_3 < tmp_4) {
              tmp_5[tmp_3] = 0;
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp_6 = tmp_5;
            var tmp$ret$2 = new IntArray2(1, 1, isIntArray(tmp_6) ? tmp_6 : THROW_CCE());
            tmp_1.qcn_1 = tmp_2.l21([tmp$ret$2]);
            image.mco(Companion_getInstance_23().n5e_1);
          } else {
            image.qcn_1 = Companion_instance_10.l21([tilemap.h5e_1]);
            var tmp1_elvis_lhs = tilemap.i5e_1;
            image.mco(tmp1_elvis_lhs == null ? Companion_getInstance_23().n5e_1 : tmp1_elvis_lhs);
          }
        }
        // Inline function 'korlibs.korge.view.xy' call
        var x = it.l4x_1;
        var y = it.m4x_1;
        xy_0(image, numberToDouble(x), numberToDouble(y));
      }
      $this.jcl_1 = frame.l53();
      var tmp_7 = $this;
      var tmp_8;
      switch (_get_computedDirection__2w15cx($this).ka_1) {
        case 2:
          tmp_8 = 1;
          break;
        case 3:
          tmp_8 = -1;
          break;
        case 4:
          var tmp_9;
          var containsUpper = $this.acl_1;
          var containsArg = frameIndex + $this.lcl_1 | 0;
          if (!(0 <= containsArg ? containsArg < containsUpper : false)) {
            tmp_9 = -$this.lcl_1 | 0;
          } else {
            tmp_9 = $this.lcl_1;
          }

          tmp_8 = tmp_9;
          break;
        case 0:
          tmp_8 = frameIndex < ($this.acl_1 - 1 | 0) ? 1 : 0;
          break;
        case 1:
          tmp_8 = frameIndex === 0 ? 0 : -1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp_7.lcl_1 = tmp_8;
      $this.kcl_1 = umod(frameIndex + $this.lcl_1 | 0, $this.acl_1);
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = $this.pcl();
      var n_0 = 0;
      while (n_0 < this_1.n()) {
        // Inline function 'korlibs.korge.view.animation.ImageAnimationView.setFrame.<anonymous>' call
        var tmp0_0 = n_0;
        n_0 = tmp0_0 + 1 | 0;
        var it_0 = this_1.f1(tmp0_0);
        if (isInterface(it_0, SmoothedBmpSlice)) {
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$4 = get_Bitmaps_transparent();
          it_0.oba(tmp$ret$4);
        }
      }
    }
  }
  function setFirstFrame($this) {
    if (_get_computedDirection__2w15cx($this).equals(Direction_REVERSE_getInstance()) ? true : _get_computedDirection__2w15cx($this).equals(Direction_ONCE_REVERSE_getInstance())) {
      setFrame($this, $this.acl_1 - 1 | 0);
    } else {
      setFrame($this, 0);
    }
  }
  function didSetAnimation($this) {
    var tmp = $this;
    var tmp0_safe_receiver = $this.ecl_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e50_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n();
    tmp.acl_1 = tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs;
    var tmp3_iterator = $this.pcl().u();
    while (tmp3_iterator.v()) {
      var layer = tmp3_iterator.x();
      if (layer instanceof TileMap) {
        var tmp4_safe_receiver = $this.dcl_1;
        if (tmp4_safe_receiver == null)
          null;
        else
          tmp4_safe_receiver(layer);
      } else {
        var tmp5_safe_receiver = $this.ccl_1;
        if (tmp5_safe_receiver == null)
          null;
        else {
          tmp5_safe_receiver(isInterface(layer, SmoothedBmpSlice) ? layer : THROW_CCE());
        }
      }
    }
    $this.hcl_1.b3();
    $this.gcl_1.oav();
    $this.lcl_1 = 1;
    var animation = $this.ecl_1;
    if (!(animation == null)) {
      var tmp6_iterator = animation.h50_1.u();
      while (tmp6_iterator.v()) {
        var layer_0 = tmp6_iterator.x();
        var tmp_0;
        switch (layer_0.j4x_1.ka_1) {
          case 0:
            // Inline function 'kotlin.also' call

            var this_0 = $this.zck_1();
            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'korlibs.korge.view.animation.ImageAnimationView.didSetAnimation.<anonymous>' call

            this_0.lc4($this.ncl_1);
            var tmp_1 = this_0;
            tmp_0 = tmp_1 instanceof View ? tmp_1 : THROW_CCE();
            break;
          case 2:
            tmp_0 = $this.nco();
            break;
          case 1:
            throw new NotImplementedError();
          default:
            noWhenBranchMatchedException();
            break;
        }
        var image = tmp_0;
        $this.hcl_1.r(image);
        // Inline function 'korlibs.datastructure.set' call
        var this_1 = $this.icl_1;
        var tmp8_elvis_lhs = layer_0.i4x_1;
        var key = tmp8_elvis_lhs == null ? 'default' : tmp8_elvis_lhs;
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.js.asDynamic' call
        this_1.set(key, image);
        $this.gcl_1.pav(image instanceof View ? image : THROW_CCE());
      }
    }
    setFirstFrame($this);
  }
  function ImageAnimationView$lambda($this$addUpdater, it) {
    if ($this$addUpdater.ocl_1) {
      $this$addUpdater.jcl_1 = Duration__minus_impl_q5cfm7($this$addUpdater.jcl_1, it.aj_1);
      var tmp = $this$addUpdater.jcl_1;
      // Inline function 'korlibs.time.milliseconds' call
      var tmp$ret$0 = toDuration(0.0, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(tmp, tmp$ret$0) <= 0) {
        setFrame($this$addUpdater, $this$addUpdater.kcl_1);
        if ($this$addUpdater.lcl_1 === 0) {
          $this$addUpdater.ocl_1 = false;
          var tmp1_safe_receiver = $this$addUpdater.bcl_1;
          if (tmp1_safe_receiver == null)
            null;
          else
            tmp1_safe_receiver();
        }
      }
    }
    return Unit_instance;
  }
  function ImageAnimationView(animation, direction, createImage) {
    animation = animation === VOID ? null : animation;
    direction = direction === VOID ? null : direction;
    Container.call(this);
    this.zck_1 = createImage;
    this.acl_1 = 1;
    this.bcl_1 = null;
    this.ccl_1 = null;
    this.dcl_1 = null;
    this.ecl_1 = animation;
    this.fcl_1 = direction;
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = new Container(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.gcl_1 = addTo(this_0, this);
    this.hcl_1 = fastArrayListOf([]);
    this.icl_1 = FastStringMap();
    var tmp_0 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_0.jcl_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    this.kcl_1 = 0;
    this.lcl_1 = 1;
    this.mcl_1 = Companion_getInstance_0().d2d_1;
    this.ncl_1 = true;
    this.ocl_1 = true;
    didSetAnimation(this);
    addUpdater_0(this, ImageAnimationView$lambda);
  }
  protoOf(ImageAnimationView).nco = function () {
    return new TileMap();
  };
  protoOf(ImageAnimationView).oco = function (value) {
    if (!(this.ecl_1 === value)) {
      this.ecl_1 = value;
      didSetAnimation(this);
    }
  };
  protoOf(ImageAnimationView).pcl = function () {
    return this.hcl_1;
  };
  protoOf(ImageAnimationView).pco = function (value) {
    this.mcl_1 = value;
    // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
    var tmp$ret$0 = new Vector2D(-value.g28_1, -value.h28_1);
    this.gcl_1.u46(tmp$ret$0);
  };
  protoOf(ImageAnimationView).qco = function () {
    return this.mcl_1;
  };
  protoOf(ImageAnimationView).vb4 = function (value) {
    this.pco(new Vector2D(value.p2c_1 * this.x1q(), value.q2c_1 * this.y1q()));
  };
  protoOf(ImageAnimationView).xbc = function () {
    return new Anchor2D(this.qco().g28_1 / this.x1q(), this.qco().h28_1 / this.y1q());
  };
  protoOf(ImageAnimationView).lc4 = function (value) {
    if (!(this.ncl_1 === value)) {
      this.ncl_1 = value;
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.hcl_1.y1u_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.animation.ImageAnimationView.<set-smoothing>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var it = array[tmp0];
        if (isInterface(it, SmoothedBmpSlice)) {
          it.lc4(value);
        }
      }
    }
  };
  protoOf(ImageAnimationView).rco = function () {
    this.ocl_1 = true;
  };
  protoOf(ImageAnimationView).sco = function () {
    this.ocl_1 = false;
  };
  function updatedDataAnimation($this) {
    var tmp = $this.hcr();
    var tmp_0;
    if (!($this.gcr_1 == null)) {
      var tmp0_safe_receiver = $this.fcr_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x50_1;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.get' call
        var key = $this.gcr_1;
        tmp_1 = (isInterface(tmp1_safe_receiver, Map) ? tmp1_safe_receiver : THROW_CCE()).s2(key);
      }
      tmp_0 = tmp_1;
    } else {
      var tmp2_safe_receiver = $this.fcr_1;
      tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w50_1;
    }
    tmp.oco(tmp_0);
  }
  function ImageDataView$createAnimationView$lambda() {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return Image_init_$Create$(tmp$ret$0);
  }
  function ImageDataView(data, animation, playing, smoothing) {
    data = data === VOID ? null : data;
    animation = animation === VOID ? null : animation;
    playing = playing === VOID ? false : playing;
    smoothing = smoothing === VOID ? true : smoothing;
    Container.call(this);
    this.bcr_1 = this.icr();
    this.ccr_1 = anchorPixel$factory(this.hcr());
    this.dcr_1 = anchor$factory(this.hcr());
    this.ecr_1 = true;
    this.fcr_1 = data;
    this.gcr_1 = animation;
    updatedDataAnimation(this);
    if (playing) {
      this.rco();
    } else {
      this.sco();
    }
    this.lc4(smoothing);
  }
  protoOf(ImageDataView).icr = function () {
    // Inline function 'korlibs.korge.view.animation.imageAnimationView' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = new ImageAnimationView(null, null, ImageDataView$createAnimationView$lambda);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.animation.imageAnimationView.<anonymous>' call
    return addTo(this_0, this);
  };
  protoOf(ImageDataView).hcr = function () {
    return this.bcr_1;
  };
  protoOf(ImageDataView).vb4 = function (_set____db54di) {
    var this_0 = this.dcr_1;
    anchor$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(ImageDataView).xbc = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.dcr_1;
    anchor$factory_1();
    return this_0.get();
  };
  protoOf(ImageDataView).lc4 = function (value) {
    if (!(this.ecr_1 === value)) {
      this.ecr_1 = value;
      this.hcr().lc4(value);
    }
  };
  protoOf(ImageDataView).jcr = function (value) {
    if (!(this.gcr_1 === value)) {
      this.gcr_1 = value;
      updatedDataAnimation(this);
    }
  };
  protoOf(ImageDataView).rco = function () {
    this.hcr().rco();
  };
  protoOf(ImageDataView).sco = function () {
    this.hcr().sco();
  };
  function anchorPixel$factory($b0) {
    return getPropertyCallableRef('anchorPixel', 0, KMutableProperty0, function () {
      return $b0.qco();
    }, function (value) {
      return $b0.pco(value);
    });
  }
  function anchor$factory($b0) {
    return getPropertyCallableRef('anchor', 0, KMutableProperty0, function () {
      return $b0.xbc();
    }, function (value) {
      return $b0.vb4(value);
    });
  }
  function anchor$factory_0() {
    return getPropertyCallableRef('anchor', 1, KMutableProperty1, function (receiver) {
      return receiver.xbc();
    }, function (receiver, value) {
      return receiver.vb4(value);
    });
  }
  function anchor$factory_1() {
    return getPropertyCallableRef('anchor', 1, KMutableProperty1, function (receiver) {
      return receiver.xbc();
    }, function (receiver, value) {
      return receiver.vb4(value);
    });
  }
  function Companion_74() {
  }
  protoOf(Companion_74).kcr = function (left, right) {
    var tmp;
    if (left == null) {
      tmp = right.b1() ? null : right.n() === 1 ? first(right) : ComposedFilter_init_$Create$_0(right);
    } else {
      if (left instanceof ComposedFilter) {
        tmp = ComposedFilter_init_$Create$_0(plus(left.lcr_1, right));
      } else {
        tmp = ComposedFilter_init_$Create$_0(plus(listOf(left), right));
      }
    }
    return tmp;
  };
  var Companion_instance_88;
  function Companion_getInstance_100() {
    return Companion_instance_88;
  }
  function ComposedFilter_init_$Init$($this) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tmp$ret$0 = ArrayList_init_$Create$();
    ComposedFilter_init_$Init$_0(tmp$ret$0, $this);
    return $this;
  }
  function ComposedFilter_init_$Create$() {
    return ComposedFilter_init_$Init$(objectCreate(protoOf(ComposedFilter)));
  }
  function ComposedFilter_init_$Init$_0(filters, $this) {
    var tmp;
    if (filters instanceof FastArrayList) {
      tmp = filters;
    } else {
      tmp = FastArrayList_init_$Create$_1(filters);
    }
    ComposedFilter.call($this, tmp);
    return $this;
  }
  function ComposedFilter_init_$Create$_0(filters) {
    return ComposedFilter_init_$Init$_0(filters, objectCreate(protoOf(ComposedFilter)));
  }
  function ComposedFilter(filters, unit) {
    unit = unit === VOID ? Unit_instance : unit;
    this.lcr_1 = filters;
  }
  protoOf(ComposedFilter).mcr = function () {
    var out = 1.0;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.lcr_1.y1u_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.filter.ComposedFilter.<get-recommendedFilterScale>.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      out = out * array[tmp0].mcr();
    }
    return out;
  };
  protoOf(ComposedFilter).ncr = function (texWidth, texHeight) {
    var sumLeft = 0;
    var sumTop = 0;
    var sumRight = 0;
    var sumBottom = 0;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.lcr_1.y1u_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.filter.ComposedFilter.computeBorder.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var out = array[tmp0].ncr(texWidth, texHeight);
      sumLeft = sumLeft + out.c2f_1 | 0;
      sumRight = sumRight + out.a2f_1 | 0;
      sumTop = sumTop + out.z2e_1 | 0;
      sumBottom = sumBottom + out.b2f_1 | 0;
    }
    return new MarginInt(sumTop, sumRight, sumBottom, sumLeft);
  };
  protoOf(ComposedFilter).t2f = function () {
    return false;
  };
  protoOf(ComposedFilter).ocr = function (ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    var mat = matrix;
    var tex = texture;
    var last = null;
    var texWidth_0 = texWidth;
    var texHeight_0 = texHeight;
    var filterScale_0 = filterScale;
    var resultPool = get_renderToTextureResultPool(ctx);
    if (!this.t2f()) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.lcr_1.y1u_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.filter.ComposedFilter.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var filter = array[tmp0];
        var result = resultPool.z1x();
        this.pcr();
        renderToTextureWithBorderUnsafe(filter, ctx, mat, tex, texWidth_0, texHeight_0, filterScale_0, result);
        result.vch();
        ctx.y9z();
        resultPool.h1y(last);
        last = result;
        mat = result.wcr_1;
        tex = ensureNotNull(result.zcr_1);
        texWidth_0 = result.rcr_1;
        texHeight_0 = result.scr_1;
      }
    }
    Companion_getInstance_102().ocr(ctx, mat, tex, texWidth_0, texHeight_0, renderColorMul, blendMode, filterScale_0);
    resultPool.h1y(last);
  };
  protoOf(ComposedFilter).pcr = function () {
  };
  function get_renderToTextureResultPool(_this__u8e3s4) {
    _init_properties_Filter_kt__xu8pbc();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'korlibs.datastructure.Property.getValue' call
      var this_0 = renderToTextureResultPool$delegate;
      var property = renderToTextureResultPool$factory();
      // Inline function 'korlibs.datastructure.fastCastTo' call
      var tmp1_safe_receiver = _this__u8e3s4.i23();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs = this_0.j23_1;
        tmp = tmp1_safe_receiver.s13(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      }
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = tmp;
      if (res == null) {
        var r = this_0.k23_1();
        var tmp_0;
        if (!(r == null)) {
          tmp_0 = true;
        } else {
          var tmp2_elvis_lhs = this_0.j23_1;
          tmp_0 = hasExtra(_this__u8e3s4, tmp2_elvis_lhs == null ? property.callableName : tmp2_elvis_lhs);
        }
        if (tmp_0) {
          // Inline function 'korlibs.datastructure.Property.setValue' call
          var tmp0_elvis_lhs_0 = this_0.j23_1;
          var tmp_1 = tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0;
          // Inline function 'korlibs.datastructure.fastCastTo' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          setExtra(_this__u8e3s4, tmp_1, r);
        }
        tmp$ret$6 = r;
        break $l$block;
      }
      tmp$ret$6 = res;
    }
    return tmp$ret$6;
  }
  var renderToTextureResultPool$delegate;
  function Companion_75() {
    Companion_instance_89 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.ccs_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  protoOf(Companion_75).dcs = function (scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.ccs_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex_2(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  };
  var Companion_instance_89;
  function Companion_getInstance_101() {
    if (Companion_instance_89 == null)
      new Companion_75();
    return Companion_instance_89;
  }
  function Filter() {
  }
  function expandedBorderRectangle(_this__u8e3s4, inp) {
    _init_properties_Filter_kt__xu8pbc();
    return inp.n2l(getBorder(_this__u8e3s4, toIntCeil(inp.n2d_1), toIntCeil(inp.o2d_1)));
  }
  function RenderToTextureResult() {
    this.qcr_1 = null;
    this.rcr_1 = 0;
    this.scr_1 = 0;
    this.tcr_1 = 0;
    this.ucr_1 = 0;
    this.vcr_1 = 1.0;
    this.wcr_1 = Companion_getInstance_14().e2f_1;
    this.xcr_1 = null;
    this.ycr_1 = null;
    this.zcr_1 = null;
    this.acs_1 = null;
  }
  protoOf(RenderToTextureResult).vch = function () {
    var tmp0_elvis_lhs = this.ycr_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var fb = tmp;
    var tmp1_elvis_lhs = this.acs_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var ctx = tmp_0;
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.w9t(fb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.n9t_1;
      var this_1 = this_0.t9y_1;
      if (!(this_1.r9t_1 === this_0)) {
        this_1.r9t_1 = this_0;
        this_1.y9z();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor_init_$Create$(0, 0, fb.n7w_1, fb.o7w_1);
        var temp = this_0.r9z_1;
        this_0.pa8();
        this_0.r9z_1 = scissor;
        try {
          if (true) {
            ctx.iab(Colors_getInstance().q3b_1);
          }
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.n9t_1;
          var matrix = Companion_getInstance_14().e2f_1;
          var this_3 = this_2.t9y_1;
          this_3.y9z();
          var temp4 = this_3.a9t_1;
          var temp2d = this_3.b9t_1;
          this_3.b9t_1 = matrix;
          this_3.a9t_1 = toMatrix4(matrix);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_4 = this_3.b82(ProjViewUB_getInstance());
            var tmp1 = this_4.q83();
            this_4.x8n(tmp1 + 1 | 0);
            this_4.l1s(this_4.q83() + 1 | 0);
            var blockSize = this_4.t81_1;
            var index0 = imul(this_4.q83() - 1 | 0, blockSize);
            var index1 = imul(this_4.q83(), blockSize);
            var texBlockSize = this_4.q81_1.f89().n();
            var texIndex0 = imul(this_4.q83() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_4.q83(), texBlockSize);
            if (this_4.q83() > 0) {
              arraycopy_0(this_4.v81_1, index0, this_4.v81_1, index1, blockSize);
            } else {
              arrayfill_0(this_4.v81_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_4.q81_1;
            this_4.w81_1.j8o($this$push.e89(), this_3.a9t_1);
            if (true ? this_4.q83() >= 1 : false) {
              var equals = arrayequal(this_4.v81_1, index0, this_4.v81_1, index1, blockSize);
              if (equals) {
                var tmp3 = this_4.q83();
                this_4.x8n(tmp3 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp0_safe_receiver = this.xcr_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              var tmp0_safe_receiver_0 = this.qcr_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.ocr(ctx, Companion_getInstance_14().e2f_1.n2g(this.tcr_1, this.ucr_1), tmp0_safe_receiver, this.rcr_1, this.scr_1, Colors_getInstance().l3b_1, Companion_getInstance_90().z9x_1, this.vcr_1);
              }
            }
            tmp_1 = Unit_instance;
          }finally {
            this_3.y9z();
            this_3.a9t_1 = temp4;
            this_3.b9t_1 = temp2d;
            this_3.b82(ProjViewUB_getInstance()).y8n();
          }
          break $l$block_0;
        }finally {
          this_0.pa8();
          this_0.r9z_1 = temp;
        }
      }
    }finally {
      ctx.x9t();
    }
    this.zcr_1 = Texture(fb).d2y(0, 0, this.rcr_1, this.scr_1);
  };
  protoOf(RenderToTextureResult).f1e = function () {
    if (this.ycr_1 == null ? true : this.acs_1 == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.ycr_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp0_safe_receiver_0 = this.acs_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.oab(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.qcr_1 = null;
    this.xcr_1 = null;
    this.ycr_1 = null;
    this.acs_1 = null;
    this.zcr_1 = null;
  };
  function getBorder(_this__u8e3s4, texWidth, texHeight) {
    _init_properties_Filter_kt__xu8pbc();
    return _this__u8e3s4.ncr(texWidth, texHeight);
  }
  function renderToTextureWithBorderUnsafe(_this__u8e3s4, ctx, matrix, texture, texWidth, texHeight, filterScale, result) {
    result = result === VOID ? new RenderToTextureResult() : result;
    _init_properties_Filter_kt__xu8pbc();
    var filter = _this__u8e3s4;
    var margin = getBorder(filter, texWidth, texHeight);
    var borderLeft = toIntCeil(margin.c2f_1 * filterScale);
    var borderTop = toIntCeil(margin.z2e_1 * filterScale);
    var newTexWidth = texWidth + toIntCeil(margin.w2e() * filterScale) | 0;
    var newTexHeight = texHeight + toIntCeil(margin.x2e() * filterScale) | 0;
    ctx.y9z();
    var fb = ctx.nab(newTexWidth, newTexHeight);
    result.tcr_1 = borderLeft;
    result.ucr_1 = borderTop;
    result.rcr_1 = newTexWidth;
    result.scr_1 = newTexHeight;
    result.xcr_1 = texture;
    result.qcr_1 = filter;
    result.vcr_1 = filterScale;
    result.wcr_1 = matrix.q2g(-borderLeft | 0, -borderTop | 0);
    result.acs_1 = ctx;
    result.ycr_1 = fb;
    return result;
  }
  function renderToTextureResultPool$delegate$lambda() {
    _init_properties_Filter_kt__xu8pbc();
    var tmp = renderToTextureResultPool$delegate$lambda$lambda;
    return new Pool(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
  }
  function renderToTextureResultPool$delegate$lambda$lambda(it) {
    _init_properties_Filter_kt__xu8pbc();
    it.f1e();
    return Unit_instance;
  }
  function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
    _init_properties_Filter_kt__xu8pbc();
    return new RenderToTextureResult();
  }
  function renderToTextureResultPool$factory() {
    return getPropertyCallableRef('renderToTextureResultPool', 1, KProperty1, function (receiver) {
      return get_renderToTextureResultPool(receiver);
    }, null);
  }
  var properties_initialized_Filter_kt_lkm0w6;
  function _init_properties_Filter_kt__xu8pbc() {
    if (!properties_initialized_Filter_kt_lkm0w6) {
      properties_initialized_Filter_kt_lkm0w6 = true;
      renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
    }
  }
  function Companion_76() {
    Companion_instance_90 = this;
    IdentityFilter.call(this, true);
  }
  var Companion_instance_90;
  function Companion_getInstance_102() {
    if (Companion_instance_90 == null)
      new Companion_76();
    return Companion_instance_90;
  }
  function Nearest() {
    Nearest_instance = this;
    IdentityFilter.call(this, false);
  }
  var Nearest_instance;
  function Nearest_getInstance() {
    if (Nearest_instance == null)
      new Nearest();
    return Nearest_instance;
  }
  function IdentityFilter(smoothing) {
    Companion_getInstance_102();
    this.bcs_1 = smoothing;
  }
  protoOf(IdentityFilter).ocr = function (ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.n9t_1;
    var this_1 = this_0.t9y_1;
    if (!(this_1.r9t_1 === this_0)) {
      this_1.r9t_1 = this_0;
      this_1.y9z();
    }
    this_0.aa0(texture, VOID, VOID, VOID, VOID, matrix, this.bcs_1, renderColorMul, blendMode, Companion_getInstance_85().w9c_1);
  };
  function get_backdropFilter(_this__u8e3s4) {
    // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
    var tmp0_safe_receiver = _this__u8e3s4.v9i_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp0_safe_receiver.u();
        while (tmp0_iterator.v()) {
          var element = tmp0_iterator.x();
          // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
          if (element instanceof ViewRenderPhaseBackdropFilter) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    var tmp_0 = tmp;
    var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
    return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ecs_1;
  }
  function ViewRenderPhaseBackdropFilter() {
  }
  function set_filterScale(_this__u8e3s4, _set____db54di) {
    _init_properties_ViewFilter_kt__pd9xp9();
    var this_0 = filterScale$delegate;
    var property = filterScale$factory();
    var value = this_0.n23_1(_this__u8e3s4, _set____db54di);
    var tmp0_elvis_lhs = this_0.l23_1;
    setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
    return Unit_instance;
  }
  function get_filterScale(_this__u8e3s4) {
    _init_properties_ViewFilter_kt__pd9xp9();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
      var this_0 = filterScale$delegate;
      var property = filterScale$factory_0();
      var tmp0_elvis_lhs = this_0.l23_1;
      var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
      if (res == null) {
        var r = this_0.m23_1(_this__u8e3s4);
        // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
        var tmp0_elvis_lhs_0 = this_0.l23_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
        tmp$ret$0 = r;
        break $l$block;
      }
      tmp$ret$0 = res;
    }
    return tmp$ret$0;
  }
  var filterScale$delegate;
  function renderFiltered(_this__u8e3s4, ctx, filter, first) {
    first = first === VOID ? true : first;
    _init_properties_ViewFilter_kt__pd9xp9();
    var bounds = _this__u8e3s4.may(VOID, false);
    if (bounds.n2d_1 <= 0.0 ? true : bounds.o2d_1 <= 0.0)
      return Unit_instance;
    var tmp = Companion_getInstance_101();
    // Inline function 'kotlin.math.min' call
    var a = get_filterScale(_this__u8e3s4);
    var b = filter.mcr();
    var tmp$ret$0 = Math.min(a, b);
    var tryFilterScale = tmp.dcs(tmp$ret$0);
    var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.n2d_1 * tryFilterScale), 1);
    var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.o2d_1 * tryFilterScale), 1);
    var realFilterScale = clamp_2(texWidthNoBorder / bounds.n2d_1, 0.03125, 1.0);
    var tmp_0;
    switch (false) {
      case true:
        tmp_0 = clamp_1(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
        break;
      case false:
        tmp_0 = 0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var edgeSize = tmp_0;
    var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
    var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
    var addx = -bounds.l2d_1 + edgeSize;
    var addy = -bounds.m2d_1 + edgeSize;
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
    ctx.y9z();
    // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
    var rb = ctx.nab(texWidth, texHeight, false, true, 1);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.w9t(rb);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.n9t_1;
        var this_1 = this_0.t9y_1;
        if (!(this_1.r9t_1 === this_0)) {
          this_1.r9t_1 = this_0;
          this_1.y9z();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor_init_$Create$(0, 0, rb.n7w_1, rb.o7w_1);
          var temp = this_0.r9z_1;
          this_0.pa8();
          this_0.r9z_1 = scissor;
          try {
            if (true) {
              ctx.iab(Colors_getInstance().q3b_1);
            }
            var mat = _this__u8e3s4.hax().o2g(addx, addy).i2g(realFilterScale);
            // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
            var this_2 = ctx.n9t_1.t9y_1;
            this_2.y9z();
            var temp4 = this_2.a9t_1;
            var temp2d = this_2.b9t_1;
            this_2.b9t_1 = mat;
            this_2.a9t_1 = toMatrix4(mat);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_3 = this_2.b82(ProjViewUB_getInstance());
              var tmp1 = this_3.q83();
              this_3.x8n(tmp1 + 1 | 0);
              this_3.l1s(this_3.q83() + 1 | 0);
              var blockSize = this_3.t81_1;
              var index0 = imul(this_3.q83() - 1 | 0, blockSize);
              var index1 = imul(this_3.q83(), blockSize);
              var texBlockSize = this_3.q81_1.f89().n();
              var texIndex0 = imul(this_3.q83() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_3.q83(), texBlockSize);
              if (this_3.q83() > 0) {
                arraycopy_0(this_3.v81_1, index0, this_3.v81_1, index1, blockSize);
              } else {
                arrayfill_0(this_3.v81_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_3.q81_1;
              this_3.w81_1.j8o($this$push.e89(), this_2.a9t_1);
              if (true ? this_3.q83() >= 1 : false) {
                var equals = arrayequal(this_3.v81_1, index0, this_3.v81_1, index1, blockSize);
                if (equals) {
                  var tmp3 = this_3.q83();
                  this_3.x8n(tmp3 - 1 | 0);
                  break $l$block;
                }
              }
            }
            var tmp_1;
            try {
              var tmp_2;
              if (first) {
                _this__u8e3s4.qax(ctx);
                tmp_2 = Unit_instance;
              } else {
                _this__u8e3s4.rax(ctx);
                tmp_2 = Unit_instance;
              }
              tmp_1 = tmp_2;
            }finally {
              this_2.y9z();
              this_2.a9t_1 = temp4;
              this_2.b9t_1 = temp2d;
              this_2.b82(ProjViewUB_getInstance()).y8n();
            }
            break $l$block_0;
          }finally {
            this_0.pa8();
            this_0.r9z_1 = temp;
          }
        }
      }finally {
        ctx.x9t();
      }
      // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
      var texture = Texture(rb).d2y(0, 0, texWidth, texHeight);
      var mat_0 = _this__u8e3s4.gax().s2g(-addx, -addy).l2g(1.0 / realFilterScale);
      filter.ocr(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.kax(), _this__u8e3s4.p9h_1, realFilterScale);
      ctx.y9z();
    }finally {
      ctx.oab(rb);
    }
  }
  function set_filter(_this__u8e3s4, value) {
    _init_properties_ViewFilter_kt__pd9xp9();
    var enabled = !(value == null);
    if (enabled) {
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'korlibs.korge.view.View.getOrCreateAndAddRenderPhase' call
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
        var tmp0_safe_receiver = _this__u8e3s4.v9i_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = tmp0_safe_receiver.u();
            while (tmp0_iterator.v()) {
              var element = tmp0_iterator.x();
              // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
              if (element instanceof ViewRenderPhaseFilter) {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          tmp = tmp$ret$1;
        }
        var tmp_0 = tmp;
        var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          tmp$ret$3 = tmp0_safe_receiver_0;
          break $l$block_0;
        }
        // Inline function 'kotlin.also' call
        // Inline function 'korlibs.korge.view.filter.<set-filter>.<anonymous>' call
        var this_0 = new ViewRenderPhaseFilter(value);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.View.getOrCreateAndAddRenderPhase.<anonymous>' call
        _this__u8e3s4.pax(this_0);
        tmp$ret$3 = this_0;
      }
      tmp$ret$3.fcs_1 = value;
    } else {
      // Inline function 'korlibs.korge.view.View.removeRenderPhaseOfType' call
      var tmp0_safe_receiver_1 = _this__u8e3s4.v9i_1;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        removeAll(tmp0_safe_receiver_1, _set_filter_$lambda_rgmh04);
      }
    }
    _this__u8e3s4.fav();
  }
  function get_filter(_this__u8e3s4) {
    _init_properties_ViewFilter_kt__pd9xp9();
    // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
    var tmp0_safe_receiver = _this__u8e3s4.v9i_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp0_safe_receiver.u();
        while (tmp0_iterator.v()) {
          var element = tmp0_iterator.x();
          // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
          if (element instanceof ViewRenderPhaseFilter) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    var tmp_0 = tmp;
    var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
    return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.fcs_1;
  }
  function Companion_77() {
    this.gcs_1 = -200;
  }
  var Companion_instance_91;
  function Companion_getInstance_103() {
    return Companion_instance_91;
  }
  function ViewRenderPhaseFilter(filter) {
    filter = filter === VOID ? null : filter;
    this.fcs_1 = filter;
  }
  protoOf(ViewRenderPhaseFilter).hcf = function () {
    return -200;
  };
  protoOf(ViewRenderPhaseFilter).kcf = function (view, ctx) {
    if (!(this.fcs_1 == null)) {
      renderFiltered(view, ctx, ensureNotNull(this.fcs_1), false);
    } else {
      render_0.call(this, view, ctx);
    }
  };
  function filterScale$delegate$lambda($this$extraPropertyThis, it) {
    _init_properties_ViewFilter_kt__pd9xp9();
    return Companion_getInstance_101().dcs(it);
  }
  function filterScale$delegate$lambda_0($this$extraPropertyThis) {
    _init_properties_ViewFilter_kt__pd9xp9();
    return 1.0;
  }
  function _set_filter_$lambda_rgmh04(it) {
    _init_properties_ViewFilter_kt__pd9xp9();
    return it instanceof ViewRenderPhaseFilter;
  }
  function filterScale$factory() {
    return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
      return get_filterScale(receiver);
    }, function (receiver, value) {
      return set_filterScale(receiver, value);
    });
  }
  function filterScale$factory_0() {
    return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
      return get_filterScale(receiver);
    }, function (receiver, value) {
      return set_filterScale(receiver, value);
    });
  }
  var properties_initialized_ViewFilter_kt_mku9up;
  function _init_properties_ViewFilter_kt__pd9xp9() {
    if (!properties_initialized_ViewFilter_kt_mku9up) {
      properties_initialized_ViewFilter_kt_mku9up = true;
      // Inline function 'korlibs.datastructure.extraPropertyThis' call
      var transform = filterScale$delegate$lambda;
      var default_0 = filterScale$delegate$lambda_0;
      // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
      var this_0 = new PropertyThis(null, default_0);
      this_0.n23_1 = transform;
      filterScale$delegate = this_0;
    }
  }
  function _TileInfo___init__impl__kuhpkr(data) {
    return data;
  }
  function _TileInfo___get_data__impl__56jsba($this) {
    return $this;
  }
  function _TileInfo___get_isInvalid__impl__7yoppf($this) {
    return _TileInfo___get_data__impl__56jsba($this) === -1;
  }
  function _TileInfo___get_tile__impl__a6nst6($this) {
    return extract(_TileInfo___get_data__impl__56jsba($this), 0, 18);
  }
  function _TileInfo___get_offsetX__impl__o9ubxh($this) {
    // Inline function 'korlibs.memory.extract5' call
    return (_TileInfo___get_data__impl__56jsba($this) >>> 18 | 0) & 31;
  }
  function _TileInfo___get_offsetY__impl__hxn8zg($this) {
    // Inline function 'korlibs.memory.extract5' call
    return (_TileInfo___get_data__impl__56jsba($this) >>> 23 | 0) & 31;
  }
  function _TileInfo___get_rotate__impl__2ycqmx($this) {
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_TileInfo___get_data__impl__56jsba($this) >>> 29 | 0) & 1) === 0);
  }
  function _TileInfo___get_flipY__impl__wc2mhq($this) {
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_TileInfo___get_data__impl__56jsba($this) >>> 30 | 0) & 1) === 0);
  }
  function _TileInfo___get_flipX__impl__3ig5fj($this) {
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    return !(((_TileInfo___get_data__impl__56jsba($this) >>> 31 | 0) & 1) === 0);
  }
  function _TileInfo___init__impl__kuhpkr_0(tile, offsetX, offsetY, flipX, flipY, rotate) {
    offsetX = offsetX === VOID ? 0 : offsetX;
    offsetY = offsetY === VOID ? 0 : offsetY;
    flipX = flipX === VOID ? false : flipX;
    flipY = flipY === VOID ? false : flipY;
    rotate = rotate === VOID ? false : rotate;
    return _TileInfo___init__impl__kuhpkr(insert(insert(insert(insert_0(insert_0(insert_0(0, tile, 0, 18), offsetX, 18, 5), offsetY, 23, 5), rotate, 29), flipY, 30), flipX, 31));
  }
  function transformIndex($this, flipX, flipY, rotate) {
    return insert(insert(insert(0, flipX, 0), flipY, 1), rotate, 2);
  }
  function computeIndices($this, flipX, flipY, rotate, indices) {
    indices[0] = 0;
    indices[1] = 1;
    indices[2] = 2;
    indices[3] = 3;
    if (rotate) {
      swap(indices, $this, 1, 3);
    }
    if (flipY) {
      swap(indices, $this, 0, 3);
      swap(indices, $this, 1, 2);
    }
    if (flipX) {
      swap(indices, $this, 0, 1);
      swap(indices, $this, 3, 2);
    }
    return indices;
  }
  function computeIndices$default($this, flipX, flipY, rotate, indices, $super) {
    indices = indices === VOID ? new Int32Array(4) : indices;
    return computeIndices($this, flipX, flipY, rotate, indices);
  }
  function swap(_this__u8e3s4, $this, a, b) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.tiles.Companion.swap.<anonymous>' call
    var t = _this__u8e3s4[a];
    _this__u8e3s4[a] = _this__u8e3s4[b];
    _this__u8e3s4[b] = t;
    return _this__u8e3s4;
  }
  function Info_0(tex, vertices) {
    this.hcs_1 = tex;
    this.ics_1 = vertices;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = FastArrayList_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.tiles.Info.verticesList.<anonymous>' call
    this_0.r(this.ics_1);
    tmp.jcs_1 = this_0;
  }
  protoOf(Info_0).kcs = function (vertices) {
    vertices.n1y();
    this.ics_1 = vertices;
    this.jcs_1.r(vertices);
  };
  protoOf(Info_0).n1y = function () {
    this.ics_1.pad_1 = 0;
    this.ics_1.oad_1 = 0;
  };
  function Companion_78() {
    Companion_instance_92 = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(8), null);
    while (tmp_0 < 8) {
      var tmp_2 = tmp_0;
      var tmp_3 = Companion_getInstance_104();
      // Inline function 'korlibs.memory.extract' call
      // Inline function 'korlibs.memory.extract1' call
      var tmp_4 = !(((tmp_2 >>> 0 | 0) & 1) === 0);
      // Inline function 'korlibs.memory.extract' call
      // Inline function 'korlibs.memory.extract1' call
      var tmp_5 = !(((tmp_2 >>> 1 | 0) & 1) === 0);
      // Inline function 'korlibs.memory.extract' call
      // Inline function 'korlibs.memory.extract1' call
      var tmp$ret$6 = !(((tmp_2 >>> 2 | 0) & 1) === 0);
      tmp_1[tmp_2] = computeIndices$default(tmp_3, tmp_4, tmp_5, tmp$ret$6);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.lcs_1 = tmp_1;
  }
  var Companion_instance_92;
  function Companion_getInstance_104() {
    if (Companion_instance_92 == null)
      new Companion_78();
    return Companion_instance_92;
  }
  function computeVertexIfRequired($this, ctx) {
    $this.dco_1 = new RectangleD(ctx.qaa(), ctx.saa(), ctx.raa(), ctx.paa());
    if (!$this.dco_1.equals($this.cco_1)) {
      $this.o9i_1 = true;
      $this.cco_1 = $this.dco_1;
    }
    if (!$this.o9i_1 ? $this.ycn_1 === $this.xcn_1 : false)
      return Unit_instance;
    $this.ycn_1 = $this.xcn_1;
    $this.o9i_1 = false;
    var m = $this.gax();
    var renderTilesCounter = ctx.p9s_1.naz('renderedTiles');
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = Companion_getInstance_0().d2d_1;
      if (m.p2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = new Vector2D(m.w2f(p.g28_1, p.h28_1), m.z2f(p.g28_1, p.h28_1));
    }
    var tmp0_container = tmp$ret$0;
    var posX = tmp0_container.cg();
    var posY = tmp0_container.dg();
    var dUX = m.x2f($this.tcn_1, 0.0) - posX;
    var dUY = m.y2f($this.tcn_1, 0.0) - posY;
    var dVX = m.x2f(0.0, $this.ucn_1) - posX;
    var dVY = m.y2f(0.0, $this.ucn_1) - posY;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
    var width = $this.scn_1.u2l_1;
    // Inline function 'kotlin.math.min' call
    var a = m.w2f(width, 0.0) - posX;
    var b = m.z2f(0.0, width) - posY;
    var nextTileX = Math.min(a, b);
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
    var height = $this.scn_1.v2l_1;
    // Inline function 'kotlin.math.min' call
    var a_0 = m.w2f(height, 0.0) - posX;
    var b_0 = m.z2f(0.0, height) - posY;
    var nextTileY = Math.min(a_0, b_0);
    var colMul = $this.kax();
    var pp0 = $this.ia4(new Vector2D($this.dco_1.r2d(), $this.dco_1.t2d()));
    var pp1 = $this.ia4(new Vector2D($this.dco_1.s2d(), $this.dco_1.u2d()));
    var pp2 = $this.ia4(new Vector2D($this.dco_1.s2d(), $this.dco_1.t2d()));
    var pp3 = $this.ia4(new Vector2D($this.dco_1.r2d(), $this.dco_1.u2d()));
    var mapTileWidth = $this.scn_1.u2l_1;
    var mapTileHeight = $this.scn_1.v2l_1;
    var mx0 = toIntCeil(pp0.g28_1 / mapTileWidth);
    var mx1 = toIntCeil(pp1.g28_1 / mapTileWidth);
    var mx2 = toIntCeil(pp2.g28_1 / mapTileWidth);
    var mx3 = toIntCeil(pp3.g28_1 / mapTileWidth);
    var my0 = toIntCeil(pp0.h28_1 / mapTileHeight);
    var my1 = toIntCeil(pp1.h28_1 / mapTileHeight);
    var my2 = toIntCeil(pp2.h28_1 / mapTileHeight);
    var my3 = toIntCeil(pp3.h28_1 / mapTileHeight);
    var ymin = min_1(my0, my1, my2, my3);
    var ymax = max_0(my0, my1, my2, my3);
    var xmin = min_1(mx0, mx1, mx2, mx3);
    var xmax = max_0(mx0, mx1, mx2, mx3);
    var doRepeatX = !$this.vcn_1.equals(TileMapRepeat_NONE_getInstance());
    var doRepeatY = !$this.wcn_1.equals(TileMapRepeat_NONE_getInstance());
    var doRepeatAny = doRepeatX ? true : doRepeatY;
    var ymin2 = ((doRepeatAny ? ymin : clamp_1(ymin, $this.qcn_1.b20(), get_endY($this.qcn_1))) - 1 | 0) - $this.gco_1 | 0;
    var ymax2 = ((doRepeatAny ? ymax : clamp_1(ymax, $this.qcn_1.b20(), get_endY($this.qcn_1))) + 1 | 0) + $this.gco_1 | 0;
    var xmin2 = ((doRepeatAny ? xmin : clamp_1(xmin, $this.qcn_1.a20(), get_endX($this.qcn_1))) - 1 | 0) - $this.gco_1 | 0;
    var xmax2 = ((doRepeatAny ? xmax : clamp_1(xmax, $this.qcn_1.a20(), get_endX($this.qcn_1))) + 1 | 0) + $this.gco_1 | 0;
    var yheight = ymax2 - ymin2 | 0;
    var xwidth = xmax2 - xmin2 | 0;
    var ntiles = imul(imul(xwidth, yheight), $this.qcn_1.n20());
    var allocTiles = get_nextPowerOfTwo(ntiles);
    var MAX_TILES = 16368;
    // Inline function 'kotlin.math.min' call
    var allocTilesClamped = Math.min(allocTiles, MAX_TILES);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = $this.aco_1;
    var n = 0;
    while (n < this_0.n()) {
      // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = this_0.f1(tmp0);
      $this.bco_1.e1y(it);
    }
    $this.zcn_1.b3();
    $this.aco_1.b3();
    var iterationCount = 0;
    var count = 0;
    var nblocks = 0;
    // Inline function 'korlibs.korge.render.Companion.quadIndices' call
    Companion_getInstance_87();
    var quadIndexData = TEXTURED_ARRAY_quadIndices(allocTilesClamped);
    var invTileWidth = 1.0 / $this.tcn_1;
    var invTileHeight = 1.0 / $this.ucn_1;
    var inductionVariable = ymin2;
    if (inductionVariable < ymax2)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = xmin2;
        if (inductionVariable_0 < xmax2)
          $l$loop_0: do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            iterationCount = iterationCount + 1 | 0;
            var rx = $this.vcn_1.ocs_1(x, $this.qcn_1.x1q());
            var ry = $this.wcn_1.ocs_1(y, $this.qcn_1.y1q());
            if (rx < $this.qcn_1.a20() ? true : rx >= get_endX($this.qcn_1))
              continue $l$loop_0;
            if (ry < $this.qcn_1.b20() ? true : ry >= get_endY($this.qcn_1))
              continue $l$loop_0;
            var inductionVariable_1 = 0;
            var last = $this.qcn_1.a21(rx, ry);
            if (inductionVariable_1 < last)
              $l$loop_2: do {
                var level = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var cell = _TileInfo___init__impl__kuhpkr($this.qcn_1.z20(rx, ry, level));
                if (_TileInfo___get_isInvalid__impl__7yoppf(cell))
                  continue $l$loop_2;
                var cellData = _TileInfo___get_tile__impl__a6nst6(cell);
                var flipX = _TileInfo___get_flipX__impl__3ig5fj(cell);
                var flipY = _TileInfo___get_flipY__impl__wc2mhq(cell);
                var rotate = _TileInfo___get_rotate__impl__2ycqmx(cell);
                var offsetX = _TileInfo___get_offsetX__impl__o9ubxh(cell);
                var offsetY = _TileInfo___get_offsetY__impl__hxn8zg(cell);
                var rationalOffsetX = offsetX * invTileWidth;
                var rationalOffsetY = offsetY * invTileHeight;
                var tmp5_elvis_lhs = getOrNull($this.ico_1, cellData);
                var tmp;
                if (tmp5_elvis_lhs == null) {
                  continue $l$loop_2;
                } else {
                  tmp = tmp5_elvis_lhs;
                }
                var tex = tmp;
                count = count + 1 | 0;
                var tmp$ret$9;
                $l$block_1: {
                  // Inline function 'korlibs.datastructure.FastIdentityCacheMap.getOrPut' call
                  var this_1 = $this.zcn_1;
                  var key = tex.v2x();
                  if (key === this_1.f1v_1) {
                    tmp$ret$9 = ensureNotNull(this_1.g1v_1);
                    break $l$block_1;
                  }
                  if (key === this_1.h1v_1) {
                    tmp$ret$9 = ensureNotNull(this_1.i1v_1);
                    break $l$block_1;
                  }
                  var tmp$ret$10;
                  $l$block_2: {
                    // Inline function 'korlibs.datastructure.getOrPut' call
                    var this_2 = this_1.j1v_1;
                    var res = get(this_2, key);
                    if (!(res == null)) {
                      tmp$ret$10 = res;
                      break $l$block_2;
                    }
                    // Inline function 'korlibs.datastructure.FastIdentityCacheMap.getOrPut.<anonymous>' call
                    // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
                    // Inline function 'kotlin.also' call
                    var this_3 = $this.bco_1.z1x();
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>.<anonymous>' call
                    this_3.hcs_1 = tex.v2x();
                    this_3.jcs_1.b3();
                    this_3.kcs(new ShrinkableTexturedVertexArray(new TexturedVertexArray(imul(allocTilesClamped, 4), quadIndexData)));
                    // Inline function 'kotlin.collections.plusAssign' call
                    $this.aco_1.r(this_3);
                    nblocks = nblocks + 1 | 0;
                    var out = this_3;
                    set(this_2, key, out);
                    tmp$ret$10 = out;
                  }
                  var value = tmp$ret$10;
                  this_1.h1v_1 = this_1.f1v_1;
                  this_1.i1v_1 = this_1.g1v_1;
                  this_1.f1v_1 = key;
                  this_1.g1v_1 = value;
                  tmp$ret$9 = value;
                }
                var info = tmp$ret$9;
                // Inline function 'kotlin.run' call
                // Inline function 'kotlin.contracts.contract' call
                var px = x + rationalOffsetX;
                var py = y + rationalOffsetY;
                var p0X = posX + nextTileX * px + dVX * py;
                var p0Y = posY + dUY * px + nextTileY * py;
                var p1X = p0X + dUX;
                var p1Y = p0Y + dUY;
                var p2X = p0X + dUX + dVX;
                var p2Y = p0Y + dUY + dVY;
                var p3X = p0X + dVX;
                var p3Y = p0Y + dVY;
                $this.eco_1[0] = tex.g2y();
                $this.eco_1[1] = tex.i2y();
                $this.eco_1[2] = tex.k2y();
                $this.eco_1[3] = tex.m2y();
                $this.fco_1[0] = tex.h2y();
                $this.fco_1[1] = tex.j2y();
                $this.fco_1[2] = tex.l2y();
                $this.fco_1[3] = tex.n2y();
                var indices = Companion_getInstance_104().lcs_1[transformIndex(Companion_getInstance_104(), flipX, flipY, rotate)];
                info.ics_1.qad(p0X, p0Y, $this.eco_1[indices[0]], $this.fco_1[indices[0]], colMul);
                info.ics_1.qad(p1X, p1Y, $this.eco_1[indices[1]], $this.fco_1[indices[1]], colMul);
                info.ics_1.qad(p2X, p2Y, $this.eco_1[indices[2]], $this.fco_1[indices[2]], colMul);
                info.ics_1.qad(p3X, p3Y, $this.eco_1[indices[3]], $this.fco_1[indices[3]], colMul);
                var tmp7_this = info.ics_1;
                tmp7_this.pad_1 = tmp7_this.pad_1 + 6 | 0;
                if (info.ics_1.pad_1 >= (MAX_TILES - 1 | 0)) {
                  info.kcs(new ShrinkableTexturedVertexArray(new TexturedVertexArray(imul(allocTilesClamped, 4), quadIndexData)));
                  nblocks = nblocks + 1 | 0;
                }
              }
               while (inductionVariable_1 < last);
          }
           while (inductionVariable_0 < xmax2);
      }
       while (inductionVariable < ymax2);
    renderTilesCounter.faz(count);
    $this.hco_1 = iterationCount;
  }
  function updatedTileSet($this) {
    var tmp = $this;
    var tmp_0 = 0;
    var tmp_1 = $this.lco_1.h5f().length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = $this.lco_1.h5f()[tmp_3];
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.ico_1 = tmp_2;
    var tmp_4 = $this;
    var tmp_5 = 0;
    var tmp_6 = $this.lco_1.h5f().length;
    var tmp_7 = new Int32Array(tmp_6);
    while (tmp_5 < tmp_6) {
      tmp_7[tmp_5] = 0;
      tmp_5 = tmp_5 + 1 | 0;
    }
    tmp_4.jco_1 = tmp_7;
    var tmp_8 = $this;
    var tmp_9 = 0;
    var tmp_10 = $this.lco_1.h5f().length;
    var tmp_11 = new Float64Array(tmp_10);
    while (tmp_9 < tmp_10) {
      tmp_11[tmp_9] = 0.0;
      tmp_9 = tmp_9 + 1 | 0;
    }
    tmp_8.kco_1 = tmp_11;
    $this.scn_1 = $this.lco_1.g5f();
    $this.tcn_1 = $this.lco_1.a5f_1;
    $this.ucn_1 = $this.lco_1.b5f_1;
  }
  function TileMap_init_$Init$(map, tileset, smoothing, tileSize, $this) {
    smoothing = smoothing === VOID ? true : smoothing;
    tileSize = tileSize === VOID ? tileset.g5f() : tileSize;
    TileMap.call($this, toStacked(map), tileset, smoothing, tileSize);
    return $this;
  }
  function TileMap_init_$Create$(map, tileset, smoothing, tileSize) {
    return TileMap_init_$Init$(map, tileset, smoothing, tileSize, objectCreate(protoOf(TileMap)));
  }
  function TileMap$infosPool$lambda(it) {
    it.n1y();
    return Unit_instance;
  }
  function TileMap$infosPool$lambda_0(it) {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Info_0(get_bmp(tmp$ret$0), new ShrinkableTexturedVertexArray(Companion_getInstance_87().iad_1));
  }
  function TileMap$lambda($tileset) {
    return function ($this$addUpdater, dt) {
      var this_0 = $tileset.v2r();
      var n = 0;
      while (n < this_0.length) {
        // Inline function 'korlibs.korge.view.tiles.TileMap.<anonymous>.<anonymous>' call
        var tileIndex = n;
        var info = this_0[n];
        var tmp;
        if (!(info == null)) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp = !info.s5e_1.b1();
        } else {
          tmp = false;
        }
        if (tmp) {
          var aindex = $this$addUpdater.jco_1[tileIndex];
          var currentFrame = info.s5e_1.f1(aindex);
          var tmp0_array = $this$addUpdater.kco_1;
          tmp0_array[tileIndex] = tmp0_array[tileIndex] + get_milliseconds(dt.aj_1);
          // Inline function 'korlibs.time.milliseconds' call
          var this_1 = $this$addUpdater.kco_1[tileIndex];
          var tmp$ret$1 = toDuration(this_1, DurationUnit_MILLISECONDS_getInstance());
          if (Duration__compareTo_impl_pchp0f(tmp$ret$1, currentFrame.qcs_1) >= 0) {
            var nextIndex = (aindex + 1 | 0) % info.s5e_1.n() | 0;
            var tmp2_array = $this$addUpdater.kco_1;
            tmp2_array[tileIndex] = tmp2_array[tileIndex] - get_milliseconds(currentFrame.qcs_1);
            $this$addUpdater.jco_1[tileIndex] = nextIndex;
            $this$addUpdater.ico_1[tileIndex] = $tileset.h5f()[info.s5e_1.f1(nextIndex).pcs_1];
            $this$addUpdater.xcn_1 = $this$addUpdater.xcn_1 + 1 | 0;
          }
        }
        n = n + 1 | 0;
      }
      return Unit_instance;
    };
  }
  function TileMap(stackedIntMap, tileset, smoothing, tileSize) {
    Companion_getInstance_104();
    stackedIntMap = stackedIntMap === VOID ? new StackedIntArray2(1, 1, 0) : stackedIntMap;
    tileset = tileset === VOID ? Companion_getInstance_23().n5e_1 : tileset;
    smoothing = smoothing === VOID ? true : smoothing;
    tileSize = tileSize === VOID ? tileset.g5f() : tileSize;
    View_init_$Init$(this);
    this.qcn_1 = stackedIntMap;
    this.rcn_1 = smoothing;
    this.scn_1 = tileSize;
    this.tcn_1 = 0.0;
    this.ucn_1 = 0.0;
    this.vcn_1 = TileMapRepeat_NONE_getInstance();
    this.wcn_1 = TileMapRepeat_NONE_getInstance();
    this.xcn_1 = 0;
    this.ycn_1 = 0;
    this.zcn_1 = new FastIdentityCacheMap();
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.aco_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    var tmp_1 = TileMap$infosPool$lambda;
    tmp_0.bco_1 = new Pool(tmp_1, VOID, TileMap$infosPool$lambda_0);
    this.cco_1 = Companion_getInstance_5().p2k(-1, -1, -1, -1);
    this.dco_1 = Companion_getInstance_5().p2k(-1, -1, -1, -1);
    this.eco_1 = new Float32Array(4);
    this.fco_1 = new Float32Array(4);
    this.gco_1 = 0;
    this.hco_1 = 0;
    var tmp_2 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_2.ico_1 = [];
    this.jco_1 = new Int32Array(0);
    this.kco_1 = new Float64Array(0);
    this.lco_1 = tileset;
    updatedTileSet(this);
    addUpdater_0(this, TileMap$lambda(tileset));
  }
  protoOf(TileMap).h3a = function () {
  };
  protoOf(TileMap).rcs = function () {
    this.xcn_1 = this.xcn_1 + 1 | 0;
  };
  protoOf(TileMap).mas = function (ctx) {
    if (!this.dax())
      return Unit_instance;
    computeVertexIfRequired(this, ctx);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.n9t_1;
    var this_1 = this_0.t9y_1;
    if (!(this_1.r9t_1 === this_0)) {
      this_1.r9t_1 = this_0;
      this_1.y9z();
    }
    var this_2 = this.aco_1;
    var n = 0;
    while (n < this_2.n()) {
      // Inline function 'korlibs.korge.view.tiles.TileMap.renderInternal.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var info = this_2.f1(tmp0);
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = info.jcs_1.y1u_1;
      var n_0 = 0;
      while (n_0 < array.length) {
        // Inline function 'korlibs.korge.view.tiles.TileMap.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0_0 = n_0;
        n_0 = tmp0_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var vertices = array[tmp0_0];
        // Inline function 'korlibs.korge.render.BatchBuilder2D.drawVertices' call
        var array_0 = vertices.nad_1;
        var tex = ctx.kab(info.hcs_1);
        var smoothing = this.rcn_1;
        var blendMode = this.jax();
        var vcount = vertices.oad_1;
        var icount = vertices.pad_1;
        var matrix = Companion_getInstance_14().f2f_1;
        $l$block: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
          var tex_0 = tex.va5_1;
          this_0.ca8(icount, vcount);
          var pprogram = null == null ? Companion_getInstance_85().w9c_1 : null;
          if (this_0.ra8(tex_0, smoothing, blendMode, pprogram)) {
            break $l$block;
          }
          this_0.ua7();
          if (!contains_1(this_0.j9z_1, tex_0)) {
            this_0.i9z_1 = 0;
            this_0.j9z_1[0] = tex_0;
          }
          this_0.k9z_1 = smoothing;
          this_0.l9z_1 = blendMode;
          this_0.m9z_1 = pprogram;
        }
        this_0.oa8(array_0, matrix, vcount, icount);
      }
    }
  };
  protoOf(TileMap).mco = function (value) {
    if (this.lco_1 === value)
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.korge.view.tiles.TileMap.lock' call
      this.h3a();
      try {
        this.lco_1 = value;
        updatedTileSet(this);
        break $l$block;
      }finally {
        this.rcs();
      }
    }
  };
  protoOf(TileMap).jas = function () {
    return Companion_getInstance_5().q2k(0.0, 0.0, this.tcn_1 * this.qcn_1.x1q(), this.ucn_1 * this.qcn_1.y1q());
  };
  protoOf(TileMap).scs = function (repeatX, repeatY) {
    this.vcn_1 = repeatX;
    this.wcn_1 = repeatY;
    return this;
  };
  var TileMapRepeat_NONE_instance;
  var TileMapRepeat_REPEAT_instance;
  var TileMapRepeat_MIRROR_instance;
  function TileMapRepeat$lambda(v, max) {
    return v;
  }
  function TileMapRepeat$lambda_0(v, max) {
    return umod(v, max);
  }
  function TileMapRepeat$lambda_1(v, max) {
    var r = umod(v, max);
    return ((v / max | 0) % 2 | 0) === 0 ? r : (max - 1 | 0) - r | 0;
  }
  var TileMapRepeat_entriesInitialized;
  function TileMapRepeat_initEntries() {
    if (TileMapRepeat_entriesInitialized)
      return Unit_instance;
    TileMapRepeat_entriesInitialized = true;
    TileMapRepeat_NONE_instance = new TileMapRepeat('NONE', 0, TileMapRepeat$lambda);
    TileMapRepeat_REPEAT_instance = new TileMapRepeat('REPEAT', 1, TileMapRepeat$lambda_0);
    TileMapRepeat_MIRROR_instance = new TileMapRepeat('MIRROR', 2, TileMapRepeat$lambda_1);
  }
  function TileMapRepeat(name, ordinal, get) {
    Enum.call(this, name, ordinal);
    this.ocs_1 = get;
  }
  function TileMapRepeat_NONE_getInstance() {
    TileMapRepeat_initEntries();
    return TileMapRepeat_NONE_instance;
  }
  function _get_shapeBounds__actvvf($this) {
    var valid = $this.mc3_1 ? $this.xc3_1 : $this.wc3_1;
    if (!valid) {
      if ($this.mc3_1)
        $this.xc3_1 = true;
      else
        $this.wc3_1 = true;
      var result = $this.uc3_1.q5j($this.mc3_1);
      if ($this.mc3_1)
        $this.ac4_1 = result;
      else
        $this.zc3_1 = result;
      return result;
    }
    return $this.mc3_1 ? $this.ac4_1 : $this.zc3_1;
  }
  function invalidateShape($this) {
    $this.yc3_1 = 0;
    $this.vc3_1 = false;
    $this.wc3_1 = false;
    $this.xc3_1 = false;
    $this.t9x();
  }
  function requireShape($this) {
    if ($this.vc3_1)
      return Unit_instance;
    $this.vc3_1 = true;
    $this.nc3_1.b3();
    $this.nc3_1.dct();
    $this.nc3_1.ect(Companion_getInstance_58().a7w_1);
    $this.bc4_1 = true;
    renderShape($this, $this.uc3_1);
    $this.nc3_1.q7u();
    $this.dc4_1 = $this.cc4_1;
  }
  function renderCommands($this, ctx, doRequireTexture) {
    var mat = doRequireTexture ? $this.gax().s2f(get_immutable(ctx.n9s_1.laa())) : $this.gax();
    $this.ec4_1 = mat.r2g(-$this.yav(), -$this.zav());
    requireShape($this);
    $this.nc3_1.fct(ctx, $this.ec4_1, $this.fax(), $this.rc3_1, $this.kax(), doRequireTexture);
  }
  function renderShape($this, shape) {
    if (!equals(shape, EmptyShape_instance)) {
      if (shape instanceof CompoundShape) {
        var tmp1_iterator = shape.d5k_1.u();
        while (tmp1_iterator.v()) {
          var v = tmp1_iterator.x();
          renderShape($this, v);
        }
      } else {
        if (shape instanceof TextShape) {
          renderShape($this, shape.w5k());
        } else {
          if (shape instanceof FillShape) {
            $this.yc3_1 = $this.yc3_1 + 1 | 0;
            if ($this.yc3_1 > $this.fc4_1)
              return Unit_instance;
            renderFill($this, shape);
          } else {
            if (shape instanceof PolylineShape) {
              $this.yc3_1 = $this.yc3_1 + 1 | 0;
              if ($this.yc3_1 > $this.fc4_1)
                return Unit_instance;
              renderStroke$default($this, shape.i5k_1, shape.f5k_1, shape.h5k_1, shape.k5k_1, shape.j5k_1);
            } else {
              var reason = 'shape=' + shape;
              throw new NotImplementedError('An operation is not implemented: ' + reason);
            }
          }
        }
      }
    }
  }
  function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
    var gpuShapeViewCommands = $this.nc3_1;
    var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
    gpuShapeViewCommands.ect(Companion_getInstance_58().a7w_1);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < pointsList.n()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var points = pointsList.f1(tmp0);
      var startIndex = gpuShapeViewCommands.gct();
      var vector = points.p2q();
      // Inline function 'korlibs.math.geom.fastForEachGeneric' call
      var inductionVariable = 0;
      var last = vector.n();
      if (inductionVariable < last)
        do {
          var n_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>.<anonymous>' call
          var x = vector.c1r(n_0, 0);
          var y = vector.c1r(n_0, 1);
          var dx = vector.c1r(n_0, 2);
          var dy = vector.c1r(n_0, 3);
          var len = vector.c1r(n_0, 4);
          // Inline function 'kotlin.math.absoluteValue' call
          var this_0 = vector.c1r(n_0, 5);
          var maxLen = Math.abs(this_0);
          var px = x + dx * len;
          var py = y + dy * len;
          gpuShapeViewCommands.hct(px, py, $this.tc3_1 ? len : 0.0, $this.tc3_1 ? maxLen : $this.hc4_1);
        }
         while (inductionVariable < last);
      var endIndex = gpuShapeViewCommands.ict();
      var info = GpuShapeViewPrograms_getInstance().bcu(stateTransform, paint, globalAlpha, strokeInfo.y2p_1);
      var tmp0_drawType = Companion_getInstance_52().c84_1;
      var tmp1_blendMode = Companion_getInstance_90().z9x_1;
      gpuShapeViewCommands.ccu(tmp0_drawType, info, VOID, stencilOpFunc, stencilRef, tmp1_blendMode, VOID, startIndex, endIndex);
    }
  }
  function renderStroke$default($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef, $super) {
    forceClosed = forceClosed === VOID ? null : forceClosed;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_56().o7v_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_55().m7v_1 : stencilRef;
    return renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef);
  }
  function PointsResult(bounds, vertexCount, vertexStart, vertexEnd) {
    this.dcu_1 = bounds;
    this.ecu_1 = vertexCount;
    this.fcu_1 = vertexStart;
    this.gcu_1 = vertexEnd;
  }
  function getPointsForPath($this, points, type) {
    if (points.n() < 3)
      return null;
    var vertexStart = $this.nc3_1.gct();
    var bb = BoundsBuilder__plus_impl_cz7f7x_1(Companion_getInstance_17().a2e(), points);
    var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
    var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
    var pMid = new Vector2D(xMid, yMid);
    var isStrip = type === Companion_getInstance_52().c84_1;
    var antialiased = $this.tc3_1;
    var isStripAndAntialiased = antialiased ? isStrip : false;
    if (!isStrip) {
      $this.nc3_1.hct(xMid, yMid, 0.0, $this.hc4_1);
    }
    var inductionVariable = 0;
    var last = points.n() + 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var p = points.f1(n % points.n() | 0);
        var x = p.cg();
        var y = p.dg();
        var len = isStripAndAntialiased ? Companion_getInstance_0().c2n(p, pMid) : 0.0;
        var maxLen = isStripAndAntialiased ? len : $this.hc4_1;
        if (isStrip) {
          $this.nc3_1.hct(xMid, yMid, 0.0, maxLen);
        }
        $this.nc3_1.hct(x, y, len, maxLen);
      }
       while (inductionVariable < last);
    var vertexEnd = $this.nc3_1.ict();
    return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.n() + 2 | 0, vertexStart, vertexEnd);
  }
  function getPointsForPath_0($this, path, type) {
    return getPointsForPath($this, get_cachedPoints(path), type);
  }
  function getPointsForPathList($this, path, type) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = getPoints2List(path);
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.getPointsForPathList.<anonymous>' call
      var tmp0_safe_receiver = getPointsForPath($this, element, type);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.r(tmp0_safe_receiver);
      }
    }
    return destination;
  }
  function renderFill($this, shape) {
    var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().bcu(shape.u5j_1, shape.t5j_1, shape.v5j_1, 1.0E7);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var paintShader = tmp;
    var drawFill = !$this.gc4_1;
    var drawAntialiasingBorder = $this.gc4_1 ? true : $this.tc3_1;
    var shapeIsConvex = shape.b5k();
    var isSimpleDraw = (shapeIsConvex ? shape.s5j_1 == null : false) ? !$this.gc4_1 : false;
    var pathDataList = getPointsForPathList($this, shape.r5j_1, isSimpleDraw ? Companion_getInstance_52().c84_1 : Companion_getInstance_52().d84_1);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
    var bb = Companion_getInstance_17().a2e();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < pathDataList.n()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = pathDataList.f1(tmp0);
      bb = plus_5(bb, it.dcu_1);
    }
    var pathBoundsNoExpanded = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
    var pathBounds = toAGScissor(pathBoundsNoExpanded.n2l(MarginInt_init_$Create$(2)));
    var clipDataStart = $this.nc3_1.gct();
    var tmp1_safe_receiver = shape.s5j_1;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
      tmp_0 = getPointsForPath_0($this, tmp1_safe_receiver, Companion_getInstance_52().d84_1);
    }
    var clipData = tmp_0;
    var clipDataEnd = $this.nc3_1.ict();
    var tmp3_elvis_lhs = clipData == null ? null : clipData.dcu_1;
    var clipBounds = tmp3_elvis_lhs == null ? Companion_getInstance_58().a7w_1 : tmp3_elvis_lhs;
    if (!isSimpleDraw ? true : $this.bc4_1) {
      $this.bc4_1 = true;
      $this.nc3_1.ect(isSimpleDraw ? Companion_getInstance_58().a7w_1 : !clipBounds.equals(Companion_getInstance_58().a7w_1) ? Companion_getInstance_58().c86(pathBounds, clipBounds) : pathBounds);
    }
    if (isSimpleDraw) {
      $this.bc4_1 = false;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < pathDataList.n()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
        var tmp0_0 = n_0;
        n_0 = tmp0_0 + 1 | 0;
        var pathData = pathDataList.f1(tmp0_0);
        var tmp0_$this = $this.nc3_1;
        var tmp1_drawType = Companion_getInstance_52().c84_1;
        var tmp2_startIndex = pathData.fcu_1;
        var tmp3_endIndex = pathData.gcu_1;
        var tmp4_colorMask = _AGColorMask___init__impl__j38ai8_1(true);
        var tmp5_blendMode = $this.jax();
        tmp0_$this.ccu(tmp1_drawType, paintShader, tmp4_colorMask, VOID, VOID, tmp5_blendMode, VOID, tmp2_startIndex, tmp3_endIndex);
      }
      return Unit_instance;
    }
    var winding = shape.r5j_1.w2u_1;
    var stencilReferenceValue = 1;
    var stencilCompare = Companion_getInstance_67().g85_1;
    if (drawFill) {
      var tmp0_1 = winding.ka_1;
      if (tmp0_1 === 0) {
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_67().g85_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_56().o7v_1, true), Companion_getInstance_67().f85_1), Companion_getInstance_66().r85_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_55().m7v_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n_1 = 0;
        while (n_1 < pathDataList.n()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var tmp0_2 = n_1;
          n_1 = tmp0_2 + 1 | 0;
          var pathData_0 = pathDataList.f1(tmp0_2);
          writeStencil($this, pathData_0.fcu_1, pathData_0.gcu_1, stencilOpFunc, stencilRef, Companion_getInstance_63().c7w_1);
        }
      } else if (tmp0_1 === 1) {
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_67().m85_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_56().o7v_1, true), Companion_getInstance_67().f85_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_55().m7v_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n_2 = 0;
        while (n_2 < pathDataList.n()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var tmp0_3 = n_2;
          n_2 = tmp0_3 + 1 | 0;
          var pathData_1 = pathDataList.f1(tmp0_3);
          writeStencil($this, pathData_1.fcu_1, pathData_1.gcu_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_66().q85_1, Companion_getInstance_66().o85_1), stencilRef_0, Companion_getInstance_63().c7w_1);
        }
      }
      if (!(clipData == null)) {
        if (winding.equals(Winding_NON_ZERO_getInstance())) {
          writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_56().o7v_1, true), Companion_getInstance_67().m85_1), Companion_getInstance_66().r85_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_55().m7v_1, 0), 255), Companion_getInstance_63().d7w_1);
        }
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_56().o7v_1, true), Companion_getInstance_67().f85_1), Companion_getInstance_66().r85_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_55().m7v_1, 2), Companion_getInstance_63().f7w_1);
        stencilReferenceValue = 3;
      }
    }
    if (drawAntialiasingBorder ? shape.s5j_1 == null : false) {
      renderStroke($this, shape.u5j_1, shape.r5j_1, shape.t5j_1, shape.v5j_1, new StrokeInfo(1.6 / $this.cc4_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_56().o7v_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_56().o7v_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_55().m7v_1, stencilReferenceValue), 0));
    }
    if (drawFill) {
      writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
      $this.nc3_1.v8i(0);
    }
  }
  function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
    var tmp0_$this = $this.nc3_1;
    var tmp1_drawType = Companion_getInstance_52().d84_1;
    var tmp2_paintShader = GpuShapeViewPrograms_getInstance().acu_1;
    var tmp3_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
    var tmp4_blendMode = Companion_getInstance_90().b9y_1;
    tmp0_$this.hcu(tmp1_drawType, tmp2_paintShader, tmp3_colorMask, stencilOpFunc, stencilRef, tmp4_blendMode, cullFace, pathDataStart, pathDataEnd);
  }
  function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
    var vstart = $this.nc3_1.gct();
    var x0 = pathBounds.r2d();
    var y0 = pathBounds.t2d();
    var x1 = pathBounds.s2d();
    var y1 = pathBounds.u2d();
    $this.nc3_1.hct(x0, y0, 0.0, $this.hc4_1);
    $this.nc3_1.hct(x1, y0, 0.0, $this.hc4_1);
    $this.nc3_1.hct(x1, y1, 0.0, $this.hc4_1);
    $this.nc3_1.hct(x0, y1, 0.0, $this.hc4_1);
    var vend = $this.nc3_1.ict();
    var tmp0_$this = $this.nc3_1;
    var tmp1_drawType = Companion_getInstance_52().d84_1;
    var tmp2_colorMask = _AGColorMask___init__impl__j38ai8_1(true);
    var tmp3_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_56().o7v_1, true), stencilCompare);
    var tmp4_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_55().m7v_1, stencilReferenceValue), 0);
    var tmp5_blendMode = $this.jax();
    tmp0_$this.ccu(tmp1_drawType, paintShader, tmp2_colorMask, tmp3_stencilOpFunc, tmp4_stencilRef, tmp5_blendMode, VOID, vstart, vend);
  }
  function GpuShapeView(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    View_init_$Init$(this);
    this.jc3_1 = autoScaling;
    this.kc3_1 = true;
    this.lc3_1 = true;
    this.mc3_1 = true;
    this.nc3_1 = new GpuShapeViewCommands();
    this.oc3_1 = 1000;
    this.pc3_1 = 1000;
    this.qc3_1 = Companion_getInstance_11().f2c_1;
    this.rc3_1 = true;
    this.sc3_1 = false;
    this.tc3_1 = antialiased;
    this.uc3_1 = shape;
    this.vc3_1 = false;
    this.wc3_1 = false;
    this.xc3_1 = false;
    this.yc3_1 = 0;
    this.zc3_1 = Companion_getInstance_5().h2f();
    this.ac4_1 = Companion_getInstance_5().h2f();
    this.bc4_1 = false;
    this.cc4_1 = 1.0;
    var tmp = this;
    tmp.dc4_1 = NaN;
    this.ec4_1 = Companion_getInstance_14().h2f();
    this.fc4_1 = 100000;
    this.gc4_1 = false;
    this.hc4_1 = 10000.0;
    invalidateShape(this);
  }
  protoOf(GpuShapeView).vb4 = function (value) {
    this.qc3_1 = value;
    this.fav();
  };
  protoOf(GpuShapeView).xbc = function () {
    return this.qc3_1;
  };
  protoOf(GpuShapeView).jc4 = function (value) {
    this.tc3_1 = value;
    invalidateShape(this);
  };
  protoOf(GpuShapeView).ic4 = function (value) {
    this.uc3_1 = value;
    invalidateShape(this);
  };
  protoOf(GpuShapeView).yav = function () {
    return _get_shapeBounds__actvvf(this).n2d_1 * this.xbc().p2c_1;
  };
  protoOf(GpuShapeView).zav = function () {
    return _get_shapeBounds__actvvf(this).o2d_1 * this.xbc().q2c_1;
  };
  protoOf(GpuShapeView).fav = function () {
    protoOf(View).fav.call(this);
    invalidateShape(this);
  };
  protoOf(GpuShapeView).jas = function () {
    return new RectangleD(_get_shapeBounds__actvvf(this).l2d_1 - this.yav(), _get_shapeBounds__actvvf(this).m2d_1 - this.zav(), _get_shapeBounds__actvvf(this).n2d_1, _get_shapeBounds__actvvf(this).o2d_1);
  };
  protoOf(GpuShapeView).icu = function (_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, EmptyShape_instance)) {
      tmp = false;
    } else {
      if (_this__u8e3s4 instanceof CompoundShape) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var this_0 = _this__u8e3s4.d5k_1;
          var tmp_0;
          if (isInterface(this_0, Collection)) {
            tmp_0 = this_0.b1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = this_0.u();
          while (tmp0_iterator.v()) {
            var element = tmp0_iterator.x();
            // Inline function 'korlibs.korge.view.vector.GpuShapeView.<get-requireStencil>.<anonymous>' call
            if (this.icu(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof TextShape) {
          tmp = this.icu(_this__u8e3s4.w5k());
        } else {
          if (_this__u8e3s4 instanceof FillShape) {
            tmp = !_this__u8e3s4.b5k();
          } else {
            if (_this__u8e3s4 instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  };
  protoOf(GpuShapeView).mas = function (ctx) {
    this.cc4_1 = this.gax().v2g().s2h() * ctx.n9s_1.maa();
    if (!(this.dc4_1 === this.cc4_1)) {
      invalidateShape(this);
    }
    ctx.y9z();
    var doRequireTexture = this.icu(this.uc3_1);
    // Inline function 'korlibs.time.measureTime' call
    var start = PerformanceCounter_instance.l1q();
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>' call
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.m9s_1.o7u();
      this.oc3_1 = currentFrameBuffer.n7w_1;
      this.pc3_1 = currentFrameBuffer.o7w_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var width = this.oc3_1;
      var height = this.pc3_1;
      ctx.y9z();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.nab(width, height, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.w9t(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var this_0 = ctx.n9t_1;
          var this_1 = this_0.t9y_1;
          if (!(this_1.r9t_1 === this_0)) {
            this_1.r9t_1 = this_0;
            this_1.y9z();
          }
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var scissor = AGScissor_init_$Create$(0, 0, rb.n7w_1, rb.o7w_1);
            var temp = this_0.r9z_1;
            this_0.pa8();
            this_0.r9z_1 = scissor;
            try {
              if (true) {
                ctx.iab(Colors_getInstance().q3b_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              break $l$block;
            }finally {
              this_0.pa8();
              this_0.r9z_1 = temp;
            }
          }
        }finally {
          ctx.x9t();
        }
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>.<anonymous>' call
        var texture = Texture(rb).d2y(0, 0, width, height);
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_2 = ctx.n9t_1;
        var this_3 = this_2.t9y_1;
        if (!(this_3.r9t_1 === this_2)) {
          this_3.r9t_1 = this_2;
          this_3.y9z();
        }
        this_2.aa0(texture, VOID, VOID, VOID, VOID, get_immutable(ctx.n9s_1.uaa()));
        ctx.y9z();
      }finally {
        ctx.oab(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var end = PerformanceCounter_instance.l1q();
    // Inline function 'korlibs.time.microseconds' call
    var this_4 = end - start;
    var time = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
  };
  function ScissorCommand(scissor) {
    this.jcu_1 = scissor;
  }
  protoOf(ScissorCommand).toString = function () {
    return 'ScissorCommand(scissor=' + this.jcu_1 + ')';
  };
  protoOf(ScissorCommand).hashCode = function () {
    return this.jcu_1.hashCode();
  };
  protoOf(ScissorCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!this.jcu_1.equals(tmp0_other_with_cast.jcu_1))
      return false;
    return true;
  };
  function ClearCommand(i) {
    this.kcu_1 = i;
  }
  protoOf(ClearCommand).toString = function () {
    return 'ClearCommand(i=' + this.kcu_1 + ')';
  };
  protoOf(ClearCommand).hashCode = function () {
    return this.kcu_1;
  };
  protoOf(ClearCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.kcu_1 === tmp0_other_with_cast.kcu_1))
      return false;
    return true;
  };
  function ShapeCommand(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_52().y83_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_57().r7v_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_56().o7v_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_55().m7v_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_63().c7w_1 : cullFace;
    this.lcu_1 = drawType;
    this.mcu_1 = vertexIndex;
    this.ncu_1 = vertexEnd;
    this.ocu_1 = paintShader;
    this.pcu_1 = program;
    this.qcu_1 = colorMask;
    this.rcu_1 = stencilOpFunc;
    this.scu_1 = stencilRef;
    this.tcu_1 = blendMode;
    this.ucu_1 = cullFace;
  }
  protoOf(ShapeCommand).xa7 = function () {
    return this.ncu_1 - this.mcu_1 | 0;
  };
  protoOf(ShapeCommand).toString = function () {
    return 'ShapeCommand(drawType=' + new AGDrawType(this.lcu_1) + ', vertexIndex=' + this.mcu_1 + ', vertexEnd=' + this.ncu_1 + ', paintShader=' + this.ocu_1 + ', program=' + this.pcu_1 + ', colorMask=' + new AGColorMask(this.qcu_1) + ', stencilOpFunc=' + new AGStencilOpFunc(this.rcu_1) + ', stencilRef=' + new AGStencilReference(this.scu_1) + ', blendMode=' + this.tcu_1 + ', cullFace=' + new AGCullFace(this.ucu_1) + ')';
  };
  protoOf(ShapeCommand).hashCode = function () {
    var result = AGDrawType__hashCode_impl_ylaury(this.lcu_1);
    result = imul(result, 31) + this.mcu_1 | 0;
    result = imul(result, 31) + this.ncu_1 | 0;
    result = imul(result, 31) + (this.ocu_1 == null ? 0 : this.ocu_1.hashCode()) | 0;
    result = imul(result, 31) + (this.pcu_1 == null ? 0 : this.pcu_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.qcu_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.rcu_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.scu_1) | 0;
    result = imul(result, 31) + (this.tcu_1 == null ? 0 : this.tcu_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.ucu_1) | 0;
    return result;
  };
  protoOf(ShapeCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.lcu_1 === tmp0_other_with_cast.lcu_1))
      return false;
    if (!(this.mcu_1 === tmp0_other_with_cast.mcu_1))
      return false;
    if (!(this.ncu_1 === tmp0_other_with_cast.ncu_1))
      return false;
    if (!equals(this.ocu_1, tmp0_other_with_cast.ocu_1))
      return false;
    if (!equals(this.pcu_1, tmp0_other_with_cast.pcu_1))
      return false;
    if (!(this.qcu_1 === tmp0_other_with_cast.qcu_1))
      return false;
    if (!(this.rcu_1 === tmp0_other_with_cast.rcu_1))
      return false;
    if (!equals(this.scu_1, tmp0_other_with_cast.scu_1))
      return false;
    if (!equals(this.tcu_1, tmp0_other_with_cast.tcu_1))
      return false;
    if (!(this.ucu_1 === tmp0_other_with_cast.ucu_1))
      return false;
    return true;
  };
  function GpuShapeViewCommands() {
    this.tcs_1 = 0;
    this.ucs_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.vcs_1 = ArrayList_init_$Create$();
    this.wcs_1 = null;
    this.xcs_1 = FastArrayList_init_$Create$();
    this.ycs_1 = 0;
    this.zcs_1 = 0;
    this.act_1 = MatrixTransform_init_$Create$();
    this.bct_1 = FastArrayList_init_$Create$();
    this.cct_1 = AGTextureUnits_init_$Create$();
  }
  protoOf(GpuShapeViewCommands).b3 = function () {
    this.tcs_1 = 0;
    this.ucs_1.b3();
    this.vcs_1.b3();
  };
  protoOf(GpuShapeViewCommands).hct = function (x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var tmp1 = this.ycs_1;
      this.ycs_1 = tmp1 + 1 | 0;
      tmp = tmp1 <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.ucs_1.b1t(x, y, len, maxLen);
    var tmp3 = this.tcs_1;
    this.tcs_1 = tmp3 + 1 | 0;
    return tmp3;
  };
  protoOf(GpuShapeViewCommands).gct = function () {
    this.zcs_1 = this.tcs_1;
    return this.zcs_1;
  };
  protoOf(GpuShapeViewCommands).ict = function () {
    return this.tcs_1;
  };
  protoOf(GpuShapeViewCommands).hcu = function (drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.vcs_1;
    var element = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    this_0.r(element);
  };
  protoOf(GpuShapeViewCommands).ccu = function (drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_57().r7v_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_56().o7v_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_55().m7v_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_90().z9x_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_63().c7w_1 : cullFace;
    startIndex = startIndex === VOID ? this.zcs_1 : startIndex;
    endIndex = endIndex === VOID ? this.tcs_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.hcu(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.hcu.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  };
  protoOf(GpuShapeViewCommands).v8i = function (i) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.vcs_1;
    var element = new ClearCommand(i);
    this_0.r(element);
  };
  protoOf(GpuShapeViewCommands).dct = function (i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.v8i(i);
      tmp = Unit_instance;
    } else {
      tmp = $super.v8i.call(this, i);
    }
    return tmp;
  };
  protoOf(GpuShapeViewCommands).ect = function (scissor) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.vcs_1;
    var element = new ScissorCommand(scissor);
    this_0.r(element);
  };
  protoOf(GpuShapeViewCommands).q7u = function () {
    var tmp0_safe_receiver = this.wcs_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.xcs_1.r(tmp0_safe_receiver);
    }
    this.wcs_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.ucs_1.g1t())));
  };
  protoOf(GpuShapeViewCommands).fct = function (ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.wcs_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.h9t_1.la7(this.xcs_1);
    this.xcs_1.b3();
    ctx.y9z();
    var ag = ctx.m9s_1;
    var vao = new AGVertexArrayObject(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().sct_1, ctx.ia7(vertices))]), true);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.n9t_1;
    var this_1 = this_0.t9y_1;
    if (!(this_1.r9t_1 === this_0)) {
      this_1.r9t_1 = this_0;
      this_1.y9z();
    }
    this_0.ya8();
    var tempMat = (doRequireTexture ? Companion_getInstance_14().e2f_1 : this_0.va7()).t2g(globalMatrix);
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    var this_2 = this_0.t9y_1;
    this_2.y9z();
    var temp4 = this_2.a9t_1;
    var temp2d = this_2.b9t_1;
    this_2.b9t_1 = tempMat;
    this_2.a9t_1 = toMatrix4(tempMat);
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_3 = this_2.b82(ProjViewUB_getInstance());
      var tmp1 = this_3.q83();
      this_3.x8n(tmp1 + 1 | 0);
      this_3.l1s(this_3.q83() + 1 | 0);
      var blockSize = this_3.t81_1;
      var index0 = imul(this_3.q83() - 1 | 0, blockSize);
      var index1 = imul(this_3.q83(), blockSize);
      var texBlockSize = this_3.q81_1.f89().n();
      var texIndex0 = imul(this_3.q83() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_3.q83(), texBlockSize);
      if (this_3.q83() > 0) {
        arraycopy_0(this_3.v81_1, index0, this_3.v81_1, index1, blockSize);
      } else {
        arrayfill_0(this_3.v81_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
      var $this$push = this_3.q81_1;
      this_3.w81_1.j8o($this$push.e89(), this_2.a9t_1);
      if (true ? this_3.q83() >= 1 : false) {
        var equals = arrayequal(this_3.v81_1, index0, this_3.v81_1, index1, blockSize);
        if (equals) {
          var tmp3 = this_3.q83();
          this_3.x8n(tmp3 - 1 | 0);
          break $l$block;
        }
      }
    }
    var tmp_0;
    try {
      this.act_1 = globalMatrix.v2g();
      var program = GpuShapeViewPrograms_getInstance().zct_1;
      var scissor = Companion_getInstance_58().a7w_1;
      var this_4 = this.vcs_1;
      var n = 0;
      while (n < this_4.n()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var cmd = this_4.f1(tmp0);
        if (cmd instanceof ScissorCommand) {
          scissor = cmd.jcu_1;
        } else {
          if (cmd instanceof ClearCommand) {
            var tmp1_stencil = cmd.kcu_1;
            ctx.iab(VOID, VOID, tmp1_stencil, false, false, true);
          } else {
            if (cmd instanceof ShapeCommand) {
              var paintShader = cmd.ocu_1;
              this_0.ha9(cmd.xa7());
              var pixelScale = this.act_1.s2h() / ctx.n9s_1.maa();
              if (!(paintShader == null)) {
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var this_5 = this_0.t9y_1.b82(ShapeViewUB_getInstance());
                  var tmp1_0 = this_5.q83();
                  this_5.x8n(tmp1_0 + 1 | 0);
                  this_5.l1s(this_5.q83() + 1 | 0);
                  var blockSize_0 = this_5.t81_1;
                  var index0_0 = imul(this_5.q83() - 1 | 0, blockSize_0);
                  var index1_0 = imul(this_5.q83(), blockSize_0);
                  var texBlockSize_0 = this_5.q81_1.f89().n();
                  var texIndex0_0 = imul(this_5.q83() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(this_5.q83(), texBlockSize_0);
                  if (this_5.q83() > 0) {
                    arraycopy_0(this_5.v81_1, index0_0, this_5.v81_1, index1_0, blockSize_0);
                  } else {
                    arrayfill_0(this_5.v81_1, 0, 0, blockSize_0);
                  }
                  // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var $this$push_0 = this_5.q81_1;
                  var it = this_5.w81_1;
                  it.a8o(paintShader.vcu_1);
                  it.b8o($this$push_0.kcv(), pixelScale);
                  it.f8o($this$push_0.lcv(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (true ? this_5.q83() >= 1 : false) {
                    var equals_0 = arrayequal(this_5.v81_1, index0_0, this_5.v81_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var tmp3_0 = this_5.q83();
                      this_5.x8n(tmp3_0 - 1 | 0);
                      break $l$block_0;
                    }
                  }
                }
                if (!(paintShader.wcu_1 == null)) {
                  var tex = ctx.d9t_1.z1x();
                  tex.h80(paintShader.wcu_1);
                  this.cct_1.b7z(DefaultShaders_getInstance().i8a(), tex);
                  this.bct_1.r(tex);
                }
              }
              var tmp2_elvis_lhs = cmd.pcu_1;
              var _program = tmp2_elvis_lhs == null ? program : tmp2_elvis_lhs;
              var tmp4_frameBuffer = ctx.s9t_1.g7w_1;
              var tmp5_frameBufferInfo = ctx.s9t_1.t7w();
              var tmp6_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp7_uniformBlocks = ctx.faa(_program);
              var tmp8_textureUnits = this.cct_1.g1s();
              var tmp9_stencilOpFunc = cmd.rcu_1;
              var tmp10_stencilRef = cmd.scu_1;
              var tmp11_colorMask = cmd.qcu_1;
              var tmp3_elvis_lhs = cmd.tcu_1;
              var tmp12_blending = (tmp3_elvis_lhs == null ? Companion_getInstance_90().z9x_1 : tmp3_elvis_lhs).za8_1;
              var tmp13_cullFace = cmd.ucu_1;
              var tmp14_drawType = cmd.lcu_1;
              var tmp15_drawOffset = cmd.mcu_1;
              var tmp16_vertexCount = cmd.xa7();
              draw_1(ag, new AGBatch(tmp4_frameBuffer, tmp5_frameBufferInfo, vao, VOID, VOID, _program, tmp7_uniformBlocks, tmp8_textureUnits, tmp12_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp6_scissor, tmp13_cullFace, tmp14_drawType, tmp15_drawOffset, tmp16_vertexCount));
            }
          }
        }
      }
      tmp_0 = Unit_instance;
    }finally {
      this_2.y9z();
      this_2.a9t_1 = temp4;
      this_2.b9t_1 = temp2d;
      this_2.b82(ProjViewUB_getInstance()).y8n();
    }
    var tmp1_iterator = this.bct_1.u();
    while (tmp1_iterator.v()) {
      var tex_0 = tmp1_iterator.x();
      ctx.d9t_1.e1y(tex_0);
    }
    this.bct_1.b3();
  };
  function ShapeViewUB() {
    ShapeViewUB_instance = this;
    UniformBlock.call(this, 5);
    this.ccv_1 = this.k89().c89(this, u_ProgramType$factory());
    this.dcv_1 = this.o89().c89(this, u_Color$factory());
    this.ecv_1 = this.o89().c89(this, u_ColorMul$factory());
    this.fcv_1 = this.k89().c89(this, u_GlobalAlpha$factory());
    this.gcv_1 = this.k89().c89(this, u_GlobalPixelScale$factory());
    this.hcv_1 = this.s88().c89(this, u_Transform$factory());
    this.icv_1 = this.o89().c89(this, u_Gradientp0$factory());
    this.jcv_1 = this.o89().c89(this, u_Gradientp1$factory());
  }
  protoOf(ShapeViewUB).mcv = function () {
    return this.ccv_1.lh(this, u_ProgramType$factory_0());
  };
  protoOf(ShapeViewUB).ncv = function () {
    return this.dcv_1.lh(this, u_Color$factory_0());
  };
  protoOf(ShapeViewUB).lcv = function () {
    return this.ecv_1.lh(this, u_ColorMul$factory_0());
  };
  protoOf(ShapeViewUB).ocv = function () {
    return this.fcv_1.lh(this, u_GlobalAlpha$factory_0());
  };
  protoOf(ShapeViewUB).kcv = function () {
    return this.gcv_1.lh(this, u_GlobalPixelScale$factory_0());
  };
  protoOf(ShapeViewUB).pcv = function () {
    return this.hcv_1.lh(this, u_Transform$factory_0());
  };
  protoOf(ShapeViewUB).qcv = function () {
    return this.icv_1.lh(this, u_Gradientp0$factory_0());
  };
  protoOf(ShapeViewUB).rcv = function () {
    return this.jcv_1.lh(this, u_Gradientp1$factory_0());
  };
  var ShapeViewUB_instance;
  function ShapeViewUB_getInstance() {
    if (ShapeViewUB_instance == null)
      new ShapeViewUB();
    return ShapeViewUB_instance;
  }
  function PaintShader(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().zct_1 : program;
    this.vcu_1 = uniforms;
    this.wcu_1 = texture;
    this.xcu_1 = program;
  }
  protoOf(PaintShader).toString = function () {
    return 'PaintShader(uniforms=' + this.vcu_1 + ', texture=' + this.wcu_1 + ', program=' + this.xcu_1 + ')';
  };
  protoOf(PaintShader).hashCode = function () {
    var result = hashCode(this.vcu_1);
    result = imul(result, 31) + (this.wcu_1 == null ? 0 : hashCode(this.wcu_1)) | 0;
    result = imul(result, 31) + this.xcu_1.hashCode() | 0;
    return result;
  };
  protoOf(PaintShader).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.vcu_1, tmp0_other_with_cast.vcu_1))
      return false;
    if (!equals(this.wcu_1, tmp0_other_with_cast.wcu_1))
      return false;
    if (!this.xcu_1.equals(tmp0_other_with_cast.xcu_1))
      return false;
    return true;
  };
  function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($$this$FragmentShaderDefault) {
    return function ($this$IF_ELSE_LIST, it) {
      var tmp;
      switch (it) {
        case 0:
          $this$IF_ELSE_LIST.y89($this$IF_ELSE_LIST.b8a(), GpuShapeViewPrograms_getInstance().ncv());
          tmp = Unit_instance;
          break;
        case 1:
          $this$IF_ELSE_LIST.y89($this$IF_ELSE_LIST.b8a(), $this$IF_ELSE_LIST.j8a($$this$FragmentShaderDefault.i8a(), $this$IF_ELSE_LIST.n8b($this$IF_ELSE_LIST.p8b([$this$IF_ELSE_LIST.h8a($this$IF_ELSE_LIST.c8a(GpuShapeViewPrograms_getInstance().pcv(), $this$IF_ELSE_LIST.f8a([$$this$FragmentShaderDefault.u89(), $this$IF_ELSE_LIST.e8a(0.0), $this$IF_ELSE_LIST.e8a(1.0)])), 'xy')]))));
          tmp = Unit_instance;
          break;
        case 2:
          $this$IF_ELSE_LIST.y89($this$IF_ELSE_LIST.b8a(), $this$IF_ELSE_LIST.j8a($$this$FragmentShaderDefault.i8a(), $this$IF_ELSE_LIST.h8a($this$IF_ELSE_LIST.c8a(GpuShapeViewPrograms_getInstance().pcv(), $this$IF_ELSE_LIST.f8a([$this$IF_ELSE_LIST.r8b($$this$FragmentShaderDefault.u89()), $this$IF_ELSE_LIST.s8b($$this$FragmentShaderDefault.u89()), $this$IF_ELSE_LIST.e8a(0.0), $this$IF_ELSE_LIST.e8a(1.0)])), 'xy')));
          tmp = Unit_instance;
          break;
        case 3:
          var rpoint = $this$IF_ELSE_LIST.h8b(VarType_Float2_getInstance());
          $this$IF_ELSE_LIST.y89($this$IF_ELSE_LIST.h8a(rpoint, 'xy'), $this$IF_ELSE_LIST.h8a($this$IF_ELSE_LIST.c8a(GpuShapeViewPrograms_getInstance().pcv(), $this$IF_ELSE_LIST.f8a([$this$IF_ELSE_LIST.r8b($$this$FragmentShaderDefault.u89()), $this$IF_ELSE_LIST.s8b($$this$FragmentShaderDefault.u89()), $this$IF_ELSE_LIST.e8a(0.0), $this$IF_ELSE_LIST.e8a(1.0)])), 'xy'));
          var x = $this$IF_ELSE_LIST.r8b(rpoint);
          var y = $this$IF_ELSE_LIST.s8b(rpoint);
          var x0 = $this$IF_ELSE_LIST.r8b(GpuShapeViewPrograms_getInstance().qcv());
          var y0 = $this$IF_ELSE_LIST.s8b(GpuShapeViewPrograms_getInstance().qcv());
          var r0 = $this$IF_ELSE_LIST.t8b(GpuShapeViewPrograms_getInstance().qcv());
          var x1 = $this$IF_ELSE_LIST.r8b(GpuShapeViewPrograms_getInstance().rcv());
          var y1 = $this$IF_ELSE_LIST.s8b(GpuShapeViewPrograms_getInstance().rcv());
          var r1 = $this$IF_ELSE_LIST.t8b(GpuShapeViewPrograms_getInstance().rcv());
          var ratio = $this$IF_ELSE_LIST.r8b($$this$FragmentShaderDefault.m8a());
          var r0r1_2 = $this$IF_ELSE_LIST.s8b($$this$FragmentShaderDefault.m8a());
          var r0pow2 = $this$IF_ELSE_LIST.t8b($$this$FragmentShaderDefault.m8a());
          var r1pow2 = $this$IF_ELSE_LIST.u8b($$this$FragmentShaderDefault.m8a());
          var y0_y1 = $this$IF_ELSE_LIST.r8b($$this$FragmentShaderDefault.c8c());
          var x0_x1 = $this$IF_ELSE_LIST.s8b($$this$FragmentShaderDefault.c8c());
          var r0_r1 = $this$IF_ELSE_LIST.t8b($$this$FragmentShaderDefault.c8c());
          var radial_scale = $this$IF_ELSE_LIST.u8b($$this$FragmentShaderDefault.c8c());
          $this$IF_ELSE_LIST.y89(r0r1_2, $this$IF_ELSE_LIST.c8a($this$IF_ELSE_LIST.c8a($this$IF_ELSE_LIST.e8a(2.0), r0), r1));
          $this$IF_ELSE_LIST.y89(r0pow2, GpuShapeViewPrograms_getInstance().scv(r0));
          $this$IF_ELSE_LIST.y89(r1pow2, GpuShapeViewPrograms_getInstance().scv(r1));
          $this$IF_ELSE_LIST.y89(x0_x1, $this$IF_ELSE_LIST.w8b(x0, x1));
          $this$IF_ELSE_LIST.y89(y0_y1, $this$IF_ELSE_LIST.w8b(y0, y1));
          $this$IF_ELSE_LIST.y89(r0_r1, $this$IF_ELSE_LIST.w8b(r0, r1));
          $this$IF_ELSE_LIST.y89(radial_scale, $this$IF_ELSE_LIST.n8a($this$IF_ELSE_LIST.e8a(1.0), $this$IF_ELSE_LIST.w8b($this$IF_ELSE_LIST.w8b(GpuShapeViewPrograms_getInstance().scv($this$IF_ELSE_LIST.w8b(r0, r1)), GpuShapeViewPrograms_getInstance().scv($this$IF_ELSE_LIST.w8b(x0, x1))), GpuShapeViewPrograms_getInstance().scv($this$IF_ELSE_LIST.w8b(y0, y1)))));
          $this$IF_ELSE_LIST.y89(ratio, $this$IF_ELSE_LIST.w8b($this$IF_ELSE_LIST.e8a(1.0), $this$IF_ELSE_LIST.c8a($this$IF_ELSE_LIST.w8b($this$IF_ELSE_LIST.x8b($this$IF_ELSE_LIST.x8b($this$IF_ELSE_LIST.c8a($this$IF_ELSE_LIST.v8b(r1), r0_r1), $this$IF_ELSE_LIST.c8a(x0_x1, $this$IF_ELSE_LIST.w8b(x1, x))), $this$IF_ELSE_LIST.c8a(y0_y1, $this$IF_ELSE_LIST.w8b(y1, y))), $this$IF_ELSE_LIST.l8b($this$IF_ELSE_LIST.w8b($this$IF_ELSE_LIST.x8b($this$IF_ELSE_LIST.w8b($this$IF_ELSE_LIST.c8a(r1pow2, $this$IF_ELSE_LIST.x8b(GpuShapeViewPrograms_getInstance().scv($this$IF_ELSE_LIST.w8b(x0, x)), GpuShapeViewPrograms_getInstance().scv($this$IF_ELSE_LIST.w8b(y0, y)))), $this$IF_ELSE_LIST.c8a(r0r1_2, $this$IF_ELSE_LIST.x8b($this$IF_ELSE_LIST.c8a($this$IF_ELSE_LIST.w8b(x0, x), $this$IF_ELSE_LIST.w8b(x1, x)), $this$IF_ELSE_LIST.c8a($this$IF_ELSE_LIST.w8b(y0, y), $this$IF_ELSE_LIST.w8b(y1, y))))), $this$IF_ELSE_LIST.c8a(r0pow2, $this$IF_ELSE_LIST.x8b(GpuShapeViewPrograms_getInstance().scv($this$IF_ELSE_LIST.w8b(x1, x)), GpuShapeViewPrograms_getInstance().scv($this$IF_ELSE_LIST.w8b(y1, y))))), GpuShapeViewPrograms_getInstance().scv($this$IF_ELSE_LIST.w8b($this$IF_ELSE_LIST.x8b($this$IF_ELSE_LIST.x8b($this$IF_ELSE_LIST.w8b($this$IF_ELSE_LIST.w8b($this$IF_ELSE_LIST.c8a(x1, y0), $this$IF_ELSE_LIST.c8a(x, y0)), $this$IF_ELSE_LIST.c8a(x0, y1)), $this$IF_ELSE_LIST.c8a(x, y1)), $this$IF_ELSE_LIST.c8a(x0, y)), $this$IF_ELSE_LIST.c8a(x1, y)))))), radial_scale)));
          $this$IF_ELSE_LIST.y89($this$IF_ELSE_LIST.b8a(), $this$IF_ELSE_LIST.j8a($$this$FragmentShaderDefault.i8a(), $this$IF_ELSE_LIST.p8b([ratio, $this$IF_ELSE_LIST.e8a(0.0)])));
          tmp = Unit_instance;
          break;
        case 4:
          var rpoint_0 = $this$IF_ELSE_LIST.h8b(VarType_Float2_getInstance());
          $this$IF_ELSE_LIST.y89($this$IF_ELSE_LIST.h8a(rpoint_0, 'xy'), $this$IF_ELSE_LIST.h8a($this$IF_ELSE_LIST.c8a(GpuShapeViewPrograms_getInstance().pcv(), $this$IF_ELSE_LIST.f8a([$this$IF_ELSE_LIST.r8b($$this$FragmentShaderDefault.u89()), $this$IF_ELSE_LIST.s8b($$this$FragmentShaderDefault.u89()), $this$IF_ELSE_LIST.e8a(0.0), $this$IF_ELSE_LIST.e8a(1.0)])), 'xy'));
          var x_0 = $this$IF_ELSE_LIST.r8b(rpoint_0);
          var y_0 = $this$IF_ELSE_LIST.s8b(rpoint_0);
          var ratio_0 = $this$IF_ELSE_LIST.r8b($$this$FragmentShaderDefault.m8a());
          var angle = $this$IF_ELSE_LIST.s8b($$this$FragmentShaderDefault.m8a());
          var x0_0 = $this$IF_ELSE_LIST.r8b(GpuShapeViewPrograms_getInstance().qcv());
          var y0_0 = $this$IF_ELSE_LIST.s8b(GpuShapeViewPrograms_getInstance().qcv());
          var PI2 = $this$IF_ELSE_LIST.e8a(get_PI() * 2);
          $this$IF_ELSE_LIST.y89(angle, $this$IF_ELSE_LIST.j8b($this$IF_ELSE_LIST.w8b(y_0, y0_0), $this$IF_ELSE_LIST.w8b(x_0, x0_0)));
          // Inline function 'korlibs.graphics.shader.Builder.IF' call

          var cond = $this$IF_ELSE_LIST.z8b(angle, $this$IF_ELSE_LIST.e8a(0.0));
          var body = $this$IF_ELSE_LIST.o8a();
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>.<anonymous>' call

          body.y89(angle, body.x8b(angle, PI2));
          var stmIf = new If(cond, body.q8a());
          // Inline function 'kotlin.collections.plusAssign' call

          $this$IF_ELSE_LIST.x89_1.r(stmIf);
          $this$IF_ELSE_LIST.y89(ratio_0, $this$IF_ELSE_LIST.n8a(angle, PI2));
          $this$IF_ELSE_LIST.y89($this$IF_ELSE_LIST.b8a(), $this$IF_ELSE_LIST.j8a($$this$FragmentShaderDefault.i8a(), $this$IF_ELSE_LIST.n8b($this$IF_ELSE_LIST.p8b([ratio_0, $this$IF_ELSE_LIST.e8a(0.0)]))));
          tmp = Unit_instance;
          break;
      }
      return Unit_instance;
    };
  }
  function GpuShapeViewPrograms() {
    GpuShapeViewPrograms_instance = this;
    this.jct_1 = Attribute_init_$Create$('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.kct_1 = Attribute_init_$Create$('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.lct_1 = Varying_init_$Create$('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.mct_1 = Varying_init_$Create$('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.nct_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l86_1]);
    this.oct_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().m86_1]);
    this.pct_1 = ProgramLayout_init_$Create$([this.kct_1]);
    this.qct_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l86_1, DefaultShaders_getInstance().m86_1]);
    this.rct_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l86_1, this.kct_1]);
    this.sct_1 = ProgramLayout_init_$Create$([DefaultShaders_getInstance().l86_1, this.kct_1, this.jct_1]);
    this.tct_1 = 0;
    this.uct_1 = 1;
    this.vct_1 = 2;
    this.wct_1 = 3;
    this.xct_1 = 4;
    this.yct_1 = 5;
    var tmp = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    this_0.y89(this_0.b8a(), this_0.c8a(this_0.c8a(this_0.d89(), this_0.e89()), this_0.f8a([this_0.d8a(), this_0.e8a(0.0), this_0.e8a(1.0)])));
    this_0.y89(this_0.u89(), DefaultShaders_getInstance().l86_1);
    this_0.y89(GpuShapeViewPrograms_getInstance().mct_1, GpuShapeViewPrograms_getInstance().kct_1);
    this_0.y89(GpuShapeViewPrograms_getInstance().lct_1, GpuShapeViewPrograms_getInstance().jct_1);
    var tmp0_vertex = VertexShader(this_0.g8a());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = new ProgramBuilderDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.y8b(GpuShapeViewPrograms_getInstance().mcv(), this_1.e8a(5.0));
    var body = this_1.o8a();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body.y89(body.b8a(), body.f8a([body.e8a(1.0), body.e8a(0.0), body.e8a(0.0), body.e8a(1.0)]));
    body.g8b();
    var stmIf = new If(cond, body.q8a());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.x89_1.r(stmIf);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_1.b8c(this_1.m8b(GpuShapeViewPrograms_getInstance().mct_1), GpuShapeViewPrograms_getInstance().lct_1);
    var body_0 = this_1.o8a();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body_0.e8b();
    var stmIf_0 = new If(cond_0, body_0.q8a());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.x89_1.r(stmIf_0);
    var tmp_0 = GpuShapeViewPrograms_getInstance().mcv();
    this_1.d8b(tmp_0, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(this_1));
    var aaAlpha = this_1.w8b(this_1.e8a(1.0), this_1.o8b(this_1.w8b(this_1.c8a(GpuShapeViewPrograms_getInstance().lct_1, GpuShapeViewPrograms_getInstance().kcv()), this_1.e8a(1.5)), this_1.c8a(GpuShapeViewPrograms_getInstance().lct_1, GpuShapeViewPrograms_getInstance().kcv()), this_1.m8b(this_1.c8a(GpuShapeViewPrograms_getInstance().mct_1, GpuShapeViewPrograms_getInstance().kcv()))));
    this_1.y89(this_1.b8a(), this_1.c8a(this_1.c8a(this_1.c8a(this_1.b8a(), GpuShapeViewPrograms_getInstance().lcv()), GpuShapeViewPrograms_getInstance().ocv()), aaAlpha));
    var tmp1_fragment = FragmentShader(this_1.g8a());
    tmp.zct_1 = new Program(tmp0_vertex, tmp1_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var block = ShapeViewUB_getInstance();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_2 = new UniformBlockBuffer(block);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    this_2.n1y();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var tmp1 = this_2.q83();
      this_2.x8n(tmp1 + 1 | 0);
      this_2.l1s(this_2.q83() + 1 | 0);
      var blockSize = this_2.t81_1;
      var index0 = imul(this_2.q83() - 1 | 0, blockSize);
      var index1 = imul(this_2.q83(), blockSize);
      var texBlockSize = this_2.q81_1.f89().n();
      var texIndex0 = imul(this_2.q83() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_2.q83(), texBlockSize);
      if (this_2.q83() > 0) {
        arraycopy_0(this_2.v81_1, index0, this_2.v81_1, index1, blockSize);
      } else {
        arrayfill_0(this_2.v81_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
      this_2.q81_1;
      // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.stencilPaintShader.<anonymous>' call
      this_2.w81_1.c8o(ShapeViewUB_getInstance().mcv(), 5.0);
      if (true ? this_2.q83() >= 1 : false) {
        var equals = arrayequal(this_2.v81_1, index0, this_2.v81_1, index1, blockSize);
        if (equals) {
          var tmp3 = this_2.q83();
          this_2.x8n(tmp3 - 1 | 0);
          break $l$block;
        }
      }
    }
    tmp_1.acu_1 = new PaintShader(this_2, null);
  }
  protoOf(GpuShapeViewPrograms).mcv = function () {
    return ShapeViewUB_getInstance().mcv().k83_1;
  };
  protoOf(GpuShapeViewPrograms).ncv = function () {
    return ShapeViewUB_getInstance().ncv().k83_1;
  };
  protoOf(GpuShapeViewPrograms).lcv = function () {
    return ShapeViewUB_getInstance().lcv().k83_1;
  };
  protoOf(GpuShapeViewPrograms).ocv = function () {
    return ShapeViewUB_getInstance().ocv().k83_1;
  };
  protoOf(GpuShapeViewPrograms).kcv = function () {
    return ShapeViewUB_getInstance().kcv().k83_1;
  };
  protoOf(GpuShapeViewPrograms).pcv = function () {
    return ShapeViewUB_getInstance().pcv().k83_1;
  };
  protoOf(GpuShapeViewPrograms).qcv = function () {
    return ShapeViewUB_getInstance().qcv().k83_1;
  };
  protoOf(GpuShapeViewPrograms).rcv = function () {
    return ShapeViewUB_getInstance().rcv().k83_1;
  };
  protoOf(GpuShapeViewPrograms).scv = function (_this__u8e3s4) {
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.<get-pow2>.<anonymous>' call
    var $this$invoke = Companion_getInstance_75().k8v_1;
    return $this$invoke.k8b(_this__u8e3s4, $this$invoke.e8a(2.0));
  };
  protoOf(GpuShapeViewPrograms).bcu = function (stateTransform, paint, globalAlpha, lineWidth) {
    var tmp;
    if (paint instanceof NonePaint) {
      tmp = null;
    } else {
      if (paint instanceof RGBA) {
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var block = ShapeViewUB_getInstance();
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.also' call
        var this_0 = new UniformBlockBuffer(block);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        this_0.n1y();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var tmp1 = this_0.q83();
          this_0.x8n(tmp1 + 1 | 0);
          this_0.l1s(this_0.q83() + 1 | 0);
          var blockSize = this_0.t81_1;
          var index0 = imul(this_0.q83() - 1 | 0, blockSize);
          var index1 = imul(this_0.q83(), blockSize);
          var texBlockSize = this_0.q81_1.f89().n();
          var texIndex0 = imul(this_0.q83() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_0.q83(), texBlockSize);
          if (this_0.q83() > 0) {
            arraycopy_0(this_0.v81_1, index0, this_0.v81_1, index1, blockSize);
          } else {
            arrayfill_0(this_0.v81_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
          var $this$push = this_0.q81_1;
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
          var it = this_0.w81_1;
          it.c8o($this$push.mcv(), 0.0);
          it.f8o($this$push.ncv(), _RGBA___get_premultiplied__impl__3bulqc(paint.b3s_1));
          it.c8o($this$push.ocv(), globalAlpha);
          if (true ? this_0.q83() >= 1 : false) {
            var equals = arrayequal(this_0.v81_1, index0, this_0.v81_1, index1, blockSize);
            if (equals) {
              var tmp3 = this_0.q83();
              this_0.x8n(tmp3 - 1 | 0);
              break $l$block;
            }
          }
        }
        tmp = new PaintShader(this_0, null);
      } else {
        if (paint instanceof BitmapPaint) {
          var mat = Companion_getInstance_14().e2f_1.a2h(paint.h5b_1).a2h(stateTransform).u2g().h2g(1.0 / paint.g5b_1.t39_1, 1.0 / paint.g5b_1.u39_1);
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var block_0 = ShapeViewUB_getInstance();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          var this_1 = new UniformBlockBuffer(block_0);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          this_1.n1y();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var tmp1_0 = this_1.q83();
            this_1.x8n(tmp1_0 + 1 | 0);
            this_1.l1s(this_1.q83() + 1 | 0);
            var blockSize_0 = this_1.t81_1;
            var index0_0 = imul(this_1.q83() - 1 | 0, blockSize_0);
            var index1_0 = imul(this_1.q83(), blockSize_0);
            var texBlockSize_0 = this_1.q81_1.f89().n();
            var texIndex0_0 = imul(this_1.q83() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(this_1.q83(), texBlockSize_0);
            if (this_1.q83() > 0) {
              arraycopy_0(this_1.v81_1, index0_0, this_1.v81_1, index1_0, blockSize_0);
            } else {
              arrayfill_0(this_1.v81_1, 0, 0, blockSize_0);
            }
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
            var $this$push_0 = this_1.q81_1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
            var it_0 = this_1.w81_1;
            it_0.c8o($this$push_0.mcv(), 1.0);
            it_0.j8o($this$push_0.pcv(), toMatrix4(mat));
            it_0.c8o($this$push_0.ocv(), globalAlpha);
            if (true ? this_1.q83() >= 1 : false) {
              var equals_0 = arrayequal(this_1.v81_1, index0_0, this_1.v81_1, index1_0, blockSize_0);
              if (equals_0) {
                var tmp3_0 = this_1.q83();
                this_1.x8n(tmp3_0 - 1 | 0);
                break $l$block_0;
              }
            }
          }
          tmp = new PaintShader(this_1, paint.g5b_1);
        } else {
          if (paint instanceof GradientPaint) {
            var gradientBitmap = new Bitmap32(256, 1, VOID, true);
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var rect = gradientBitmap.y39_1;
            if (true) {
              gradientBitmap.h3a();
            }
            var result;
            try {
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              paint.s5a(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.v3a_1));
            }finally {
              result = true ? gradientBitmap.z3a(rect) : 0;
            }
            var npaint = paint.t5a(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_14().e2f_1.a2h(paint.j4m_1).a2h(stateTransform));
            var mat_0 = paint.z4l_1.ka_1 === 0 ? npaint.p4m_1 : npaint.j4m_1.u2g();
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var block_1 = ShapeViewUB_getInstance();
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.also' call
            var this_2 = new UniformBlockBuffer(block_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            this_2.n1y();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var tmp1_1 = this_2.q83();
              this_2.x8n(tmp1_1 + 1 | 0);
              this_2.l1s(this_2.q83() + 1 | 0);
              var blockSize_1 = this_2.t81_1;
              var index0_1 = imul(this_2.q83() - 1 | 0, blockSize_1);
              var index1_1 = imul(this_2.q83(), blockSize_1);
              var texBlockSize_1 = this_2.q81_1.f89().n();
              var texIndex0_1 = imul(this_2.q83() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(this_2.q83(), texBlockSize_1);
              if (this_2.q83() > 0) {
                arraycopy_0(this_2.v81_1, index0_1, this_2.v81_1, index1_1, blockSize_1);
              } else {
                arrayfill_0(this_2.v81_1, 0, 0, blockSize_1);
              }
              // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
              var $this$push_1 = this_2.q81_1;
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              var it_1 = this_2.w81_1;
              var tmp_0 = $this$push_1.mcv();
              var tmp0 = paint.z4l_1.ka_1;
              it_1.c8o(tmp_0, tmp0 === 1 ? 3 : tmp0 === 2 ? 4 : 2);
              it_1.j8o($this$push_1.pcv(), toMatrix4(mat_0));
              it_1.h8o($this$push_1.qcv(), new Vector4F(paint.a4m_1, paint.b4m_1, paint.c4m_1, 1.0));
              it_1.h8o($this$push_1.rcv(), new Vector4F(paint.d4m_1, paint.e4m_1, paint.f4m_1, 1.0));
              it_1.c8o($this$push_1.ocv(), globalAlpha);
              if (true ? this_2.q83() >= 1 : false) {
                var equals_1 = arrayequal(this_2.v81_1, index0_1, this_2.v81_1, index1_1, blockSize_1);
                if (equals_1) {
                  var tmp3_1 = this_2.q83();
                  this_2.x8n(tmp3_1 - 1 | 0);
                  break $l$block_1;
                }
              }
            }
            tmp = new PaintShader(this_2, gradientBitmap);
          } else {
            var reason = 'paint=' + paint;
            throw new NotImplementedError('An operation is not implemented: ' + reason);
          }
        }
      }
    }
    return tmp;
  };
  var GpuShapeViewPrograms_instance;
  function GpuShapeViewPrograms_getInstance() {
    if (GpuShapeViewPrograms_instance == null)
      new GpuShapeViewPrograms();
    return GpuShapeViewPrograms_instance;
  }
  function u_ProgramType$factory() {
    return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
      return receiver.mcv();
    }, null);
  }
  function u_Color$factory() {
    return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
      return receiver.ncv();
    }, null);
  }
  function u_ColorMul$factory() {
    return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
      return receiver.lcv();
    }, null);
  }
  function u_GlobalAlpha$factory() {
    return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
      return receiver.ocv();
    }, null);
  }
  function u_GlobalPixelScale$factory() {
    return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
      return receiver.kcv();
    }, null);
  }
  function u_Transform$factory() {
    return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
      return receiver.pcv();
    }, null);
  }
  function u_Gradientp0$factory() {
    return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
      return receiver.qcv();
    }, null);
  }
  function u_Gradientp1$factory() {
    return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
      return receiver.rcv();
    }, null);
  }
  function u_ProgramType$factory_0() {
    return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
      return receiver.mcv();
    }, null);
  }
  function u_Color$factory_0() {
    return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
      return receiver.ncv();
    }, null);
  }
  function u_ColorMul$factory_0() {
    return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
      return receiver.lcv();
    }, null);
  }
  function u_GlobalAlpha$factory_0() {
    return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
      return receiver.ocv();
    }, null);
  }
  function u_GlobalPixelScale$factory_0() {
    return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
      return receiver.kcv();
    }, null);
  }
  function u_Transform$factory_0() {
    return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
      return receiver.pcv();
    }, null);
  }
  function u_Gradientp0$factory_0() {
    return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
      return receiver.qcv();
    }, null);
  }
  function u_Gradientp1$factory_0() {
    return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
      return receiver.rcv();
    }, null);
  }
  function DEFAULT() {
  }
  var DEFAULT_instance;
  function DEFAULT_getInstance() {
    return DEFAULT_instance;
  }
  function DeviceDimensionsProvider() {
  }
  var GLOBAL_CHECK_GL;
  var Cursor_DEFAULT_instance;
  var Cursor_CROSSHAIR_instance;
  var Cursor_TEXT_instance;
  var Cursor_HAND_instance;
  var Cursor_MOVE_instance;
  var Cursor_WAIT_instance;
  var Cursor_RESIZE_EAST_instance;
  var Cursor_RESIZE_WEST_instance;
  var Cursor_RESIZE_SOUTH_instance;
  var Cursor_RESIZE_NORTH_instance;
  var Cursor_RESIZE_NORTH_EAST_instance;
  var Cursor_RESIZE_NORTH_WEST_instance;
  var Cursor_RESIZE_SOUTH_EAST_instance;
  var Cursor_RESIZE_SOUTH_WEST_instance;
  function Companion_79() {
    Companion_instance_93 = this;
    this.tcv_1 = mapOf([to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
  var Companion_instance_93;
  function Companion_getInstance_105() {
    Cursor_initEntries();
    if (Companion_instance_93 == null)
      new Companion_79();
    return Companion_instance_93;
  }
  var Cursor_entriesInitialized;
  function Cursor_initEntries() {
    if (Cursor_entriesInitialized)
      return Unit_instance;
    Cursor_entriesInitialized = true;
    Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
    Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
    Cursor_TEXT_instance = new Cursor('TEXT', 2);
    Cursor_HAND_instance = new Cursor('HAND', 3);
    Cursor_MOVE_instance = new Cursor('MOVE', 4);
    Cursor_WAIT_instance = new Cursor('WAIT', 5);
    Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
    Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
    Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
    Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
    Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
    Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
    Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
    Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
    Companion_getInstance_105();
  }
  function GameWindow$MenuItem$_init_$lambda_465oqx() {
    return Unit_instance;
  }
  var Quality_PERFORMANCE_instance;
  var Quality_QUALITY_instance;
  var Quality_AUTOMATIC_instance;
  var Quality_entriesInitialized;
  function Quality_initEntries() {
    if (Quality_entriesInitialized)
      return Unit_instance;
    Quality_entriesInitialized = true;
    Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0, 0.0);
    Quality_QUALITY_instance = new Quality('QUALITY', 1, 1.0);
    Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2, 0.5);
  }
  function Cursor(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MenuItem(text, enabled, children, action) {
    enabled = enabled === VOID ? true : enabled;
    children = children === VOID ? null : children;
    var tmp;
    if (action === VOID) {
      tmp = GameWindow$MenuItem$_init_$lambda_465oqx;
    } else {
      tmp = action;
    }
    action = tmp;
    this.ucv_1 = text;
    this.vcv_1 = enabled;
    this.wcv_1 = children;
    this.xcv_1 = action;
  }
  protoOf(MenuItem).toString = function () {
    return 'MenuItem(text=' + this.ucv_1 + ', enabled=' + this.vcv_1 + ', children=' + this.wcv_1 + ', action=' + this.xcv_1 + ')';
  };
  protoOf(MenuItem).hashCode = function () {
    var result = this.ucv_1 == null ? 0 : getStringHashCode(this.ucv_1);
    result = imul(result, 31) + getBooleanHashCode(this.vcv_1) | 0;
    result = imul(result, 31) + (this.wcv_1 == null ? 0 : hashCode(this.wcv_1)) | 0;
    result = imul(result, 31) + hashCode(this.xcv_1) | 0;
    return result;
  };
  protoOf(MenuItem).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuItem))
      return false;
    var tmp0_other_with_cast = other instanceof MenuItem ? other : THROW_CCE();
    if (!(this.ucv_1 == tmp0_other_with_cast.ucv_1))
      return false;
    if (!(this.vcv_1 === tmp0_other_with_cast.vcv_1))
      return false;
    if (!equals(this.wcv_1, tmp0_other_with_cast.wcv_1))
      return false;
    if (!equals(this.xcv_1, tmp0_other_with_cast.xcv_1))
      return false;
    return true;
  };
  function CoroutineKey() {
    CoroutineKey_instance = this;
    this.ycv_1 = 60;
    this.zcv_1 = Companion_getInstance_2().r24('GameWindow');
    this.acw_1 = new MenuItem(null);
  }
  var CoroutineKey_instance;
  function CoroutineKey_getInstance() {
    if (CoroutineKey_instance == null)
      new CoroutineKey();
    return CoroutineKey_instance;
  }
  function _get_fpsCached__581dty($this) {
    return $this.y9m_1.lh($this, fpsCached$factory());
  }
  function Quality(name, ordinal, level) {
    Enum.call(this, name, ordinal);
    this.dcw_1 = level;
    this.ecw_1 = 4000000;
  }
  protoOf(Quality).d25 = function () {
    return this.dcw_1;
  };
  protoOf(Quality).fcw = function (width, height, devicePixelRatio, targetPixels) {
    var tmp;
    switch (this.ka_1) {
      case 0:
        tmp = 1.0;
        break;
      case 1:
        tmp = devicePixelRatio;
        break;
      case 2:
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = listOf_0([devicePixelRatio, 2.0, 1.0]).u();
          while (tmp0_iterator.v()) {
            var element = tmp0_iterator.x();
            // Inline function 'korlibs.render.Quality.computeTargetScale.<anonymous>' call
            if (imul(width, height) * element <= targetPixels) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }

        var tmp1_elvis_lhs = tmp$ret$1;
        tmp = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(Quality).gcw = function (width, height, devicePixelRatio, targetPixels, $super) {
    targetPixels = targetPixels === VOID ? this.ecw_1 : targetPixels;
    return $super === VOID ? this.fcw(width, height, devicePixelRatio, targetPixels) : $super.fcw.call(this, width, height, devicePixelRatio, targetPixels);
  };
  function GameWindow$fpsCached$delegate$lambda(this$0) {
    return function () {
      return this$0.hcw();
    };
  }
  function GameWindow$loop$slambda($entry, this$0, resultContinuation) {
    this.qcw_1 = $entry;
    this.rcw_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(GameWindow$loop$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(GameWindow$loop$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(GameWindow$loop$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.qcw_1(this.rcw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(GameWindow$loop$slambda).g5a = function (completion) {
    return new GameWindow$loop$slambda(this.qcw_1, this.rcw_1, completion);
  };
  function GameWindow$loop$slambda_0($entry, this$0, resultContinuation) {
    var i = new GameWindow$loop$slambda($entry, this$0, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided__qut3iv($initialValue, this$0) {
    this.tcw_1 = this$0;
    ObservableProperty.call(this, $initialValue);
  }
  protoOf(_no_name_provided__qut3iv).ucw = function (property, oldValue, newValue) {
    var tmp0_safe_receiver = this.tcw_1.r9n_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(newValue);
    return Unit_instance;
  };
  protoOf(_no_name_provided__qut3iv).kh = function (property, oldValue, newValue) {
    var tmp = (!(oldValue == null) ? typeof oldValue === 'boolean' : false) ? oldValue : THROW_CCE();
    return this.ucw(property, tmp, (!(newValue == null) ? typeof newValue === 'boolean' : false) ? newValue : THROW_CCE());
  };
  function Cursor_DEFAULT_getInstance() {
    Cursor_initEntries();
    return Cursor_DEFAULT_instance;
  }
  function Cursor_RESIZE_EAST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_EAST_instance;
  }
  function Cursor_RESIZE_WEST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_WEST_instance;
  }
  function Cursor_RESIZE_SOUTH_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_SOUTH_instance;
  }
  function Cursor_RESIZE_NORTH_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_NORTH_instance;
  }
  function Cursor_RESIZE_NORTH_EAST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_NORTH_EAST_instance;
  }
  function Cursor_RESIZE_NORTH_WEST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_NORTH_WEST_instance;
  }
  function Cursor_RESIZE_SOUTH_EAST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_SOUTH_EAST_instance;
  }
  function Cursor_RESIZE_SOUTH_WEST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_SOUTH_WEST_instance;
  }
  function Quality_PERFORMANCE_getInstance() {
    Quality_initEntries();
    return Quality_PERFORMANCE_instance;
  }
  function Quality_AUTOMATIC_getInstance() {
    Quality_initEntries();
    return Quality_AUTOMATIC_instance;
  }
  function $waitCloseCOROUTINE$18(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dcx_1 = _this__u8e3s4;
  }
  protoOf($waitCloseCOROUTINE$18).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!this.dcx_1.n9n_1) {
              this.fd_1 = 3;
              continue $sm;
            }

            this.fd_1 = 2;
            Companion_getInstance();
            suspendResult = delay(this.dcx_1, toDuration(100, DurationUnit_MILLISECONDS_getInstance()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.fd_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function $loopCOROUTINE$19(_this__u8e3s4, entry, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mcx_1 = _this__u8e3s4;
    this.ncx_1 = entry;
  }
  protoOf($loopCOROUTINE$19).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.fd_1 = 1;
            suspendResult = this.mcx_1.rcx(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ocx_1 = suspendResult;
            launchImmediately_0(this.ocx_1, GameWindow$loop$slambda_0(this.ncx_1, this.mcx_1, null));
            this.fd_1 = 2;
            continue $sm;
          case 2:
            if (!this.mcx_1.n9n_1) {
              this.fd_1 = 5;
              continue $sm;
            }

            this.pcx_1 = this.mcx_1.scx();
            this.qcx_1 = Duration__minus_impl_q5cfm7(this.mcx_1.tcx(), this.pcx_1);
            if (Duration__compareTo_impl_pchp0f(this.qcx_1, Companion_getInstance().va_1) > 0) {
              this.fd_1 = 3;
              suspendResult = delay(this.mcx_1, this.qcx_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fd_1 = 4;
              continue $sm;
            }

          case 3:
            this.fd_1 = 4;
            continue $sm;
          case 4:
            this.fd_1 = 2;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 6) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function GameWindow() {
    CoroutineKey_getInstance();
    BaseEventListener.call(this);
    this.e9m_1 = new Mixin();
    this.f9m_1 = Cursor_DEFAULT_getInstance();
    this.g9m_1 = false;
    this.h9m_1 = new AGDummy();
    this.i9m_1 = SyncEventLoopCoroutineDispatcher_init_$Create$();
    this.j9m_1 = new GameWindowCoroutineDispatcher();
    this.k9m_1 = new PauseEvent();
    this.l9m_1 = new ResumeEvent();
    this.m9m_1 = new StopEvent();
    this.n9m_1 = new DestroyEvent();
    this.o9m_1 = new UpdateEvent();
    this.p9m_1 = new RenderEvent();
    this.q9m_1 = new InitEvent();
    this.r9m_1 = new DisposeEvent();
    this.s9m_1 = new FullScreenEvent();
    this.t9m_1 = new ReshapeEvent();
    this.u9m_1 = new KeyEvent();
    this.v9m_1 = new MouseEvent();
    this.w9m_1 = new GestureEvent();
    this.x9m_1 = new DropFileEvent();
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    tmp.y9m_1 = new IntTimedCache(tmp_0, VOID, GameWindow$fpsCached$delegate$lambda(this));
    this.z9m_1 = 60;
    this.a9n_1 = 0;
    this.b9n_1 = 0;
    this.c9n_1 = true;
    this.d9n_1 = null;
    this.e9n_1 = false;
    this.f9n_1 = false;
    this.g9n_1 = Colors_getInstance().m3b_1;
    this.h9n_1 = new Signal();
    this.i9n_1 = new Signal();
    this.j9n_1 = null;
    this.k9n_1 = false;
    this.l9n_1 = true;
    this.m9n_1 = 0;
    this.n9n_1 = true;
    this.o9n_1 = false;
    var tmp_1 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_1.p9n_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_2 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_2.q9n_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    this.r9n_1 = null;
    var tmp_3 = this;
    // Inline function 'kotlin.properties.Delegates.observable' call
    tmp_3.s9n_1 = new _no_name_provided__qut3iv(true, this);
    this.t9n_1 = false;
    this.u9n_1 = -1;
    this.v9n_1 = -1;
    this.w9n_1 = -1;
    this.x9n_1 = -1;
    this.y9n_1 = false;
    this.z9n_1 = false;
    this.a9o_1 = false;
    this.b9o_1 = 0;
    this.c9o_1 = Companion_getInstance().va_1;
    this.d9o_1 = new Lock();
    this.e9o_1 = booleanArray(Companion_getInstance_46().f7t_1);
    this.f9o_1 = 0;
    this.g9o_1 = 0.0;
    this.h9o_1 = 0.0;
    this.i9o_1 = 0.0;
    this.j9o_1 = false;
    this.k9o_1 = new GamepadInfoEmitter(this);
  }
  protoOf(GameWindow).h23 = function (_set____db54di) {
    this.e9m_1.h23(_set____db54di);
  };
  protoOf(GameWindow).i23 = function () {
    return this.e9m_1.i23();
  };
  protoOf(GameWindow).l2 = function () {
    return CoroutineKey_getInstance();
  };
  protoOf(GameWindow).r9r = function () {
    return this.h9m_1;
  };
  protoOf(GameWindow).q9r = function () {
    return this.j9m_1;
  };
  protoOf(GameWindow).ucx = function (coroutineContext) {
    return coroutineContext.dh(this.q9r());
  };
  protoOf(GameWindow).rcx = function ($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.q6();
    return this.ucx(tmp$ret$0);
  };
  protoOf(GameWindow).v9u = function (block) {
    return this.h7m(Companion_getInstance_36(), block);
  };
  protoOf(GameWindow).tcx = function () {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = 1000000.0 / this.vcx();
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  };
  protoOf(GameWindow).hcw = function () {
    return 60;
  };
  protoOf(GameWindow).m9r = function (name, time) {
  };
  protoOf(GameWindow).vcx = function () {
    return _get_fpsCached__581dty(this);
  };
  protoOf(GameWindow).wcx = function (value) {
    return Unit_instance;
  };
  protoOf(GameWindow).x1q = function () {
    return this.a9n_1;
  };
  protoOf(GameWindow).y1q = function () {
    return this.b9n_1;
  };
  protoOf(GameWindow).n9r = function (_set____db54di) {
    this.d9n_1 = _set____db54di;
  };
  protoOf(GameWindow).xcx = function (_set____db54di) {
    this.e9n_1 = _set____db54di;
  };
  protoOf(GameWindow).cax = function (_set____db54di) {
    this.f9n_1 = _set____db54di;
  };
  protoOf(GameWindow).p9u = function (_set____db54di) {
    this.g9n_1 = _set____db54di;
  };
  protoOf(GameWindow).y9r = function () {
    return this.g9n_1;
  };
  protoOf(GameWindow).p9r = function (value) {
    return Unit_instance;
  };
  protoOf(GameWindow).o9r = function () {
    return Quality_AUTOMATIC_getInstance();
  };
  protoOf(GameWindow).sch = function (value) {
    this.k9n_1 = value;
    this.i9n_1.x5n(value);
    if (value) {
      invoke(this.h9n_1);
    }
  };
  protoOf(GameWindow).s9r = function () {
    return this.k9n_1;
  };
  protoOf(GameWindow).ycx = function (width, height) {
    return Unit_instance;
  };
  protoOf(GameWindow).zcx = function (exitCode) {
    return this.acy(exitCode);
  };
  protoOf(GameWindow).a9s = function (exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.zcx(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.zcx.call(this, exitCode);
    }
    return tmp;
  };
  protoOf(GameWindow).acy = function (exitCode) {
    if (this.o9n_1)
      return Unit_instance;
    this.o9n_1 = true;
    this.n9n_1 = false;
    this.m9n_1 = exitCode;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = CoroutineKey_getInstance().zcv_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.f25(level)) {
      // Inline function 'korlibs.render.GameWindow.close.<anonymous>' call
      var tmp$ret$0 = 'GameWindow.close';
      this_0.g25(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.q9r().p21();
    cancelChildren(this.q9r());
  };
  protoOf(GameWindow).lch = function (exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.acy(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.acy.call(this, exitCode);
    }
    return tmp;
  };
  protoOf(GameWindow).l9o = function ($completion) {
    var tmp = new $waitCloseCOROUTINE$18(this, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(GameWindow).q9u = function (entry, $completion) {
    var tmp = new $loopCOROUTINE$19(this, entry, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(GameWindow).qci = function (_set____db54di) {
    return this.s9n_1.oh(this, continuousRenderMode$factory_0(), _set____db54di);
  };
  protoOf(GameWindow).pci = function () {
    return this.s9n_1.mh(this, continuousRenderMode$factory_1());
  };
  protoOf(GameWindow).lcy = function (doUpdate, doRender, frameStartTime) {
    var startTime = PerformanceCounter_instance.n1q();
    if (doRender) {
      var tmp = this;
      // Inline function 'korlibs.time.measureTime' call
      var start = PerformanceCounter_instance.l1q();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      this.mcy(doUpdate, true);
      var end = PerformanceCounter_instance.l1q();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      tmp.p9n_1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
    }
    if (doUpdate) {
      var tmp_0 = this;
      // Inline function 'korlibs.time.measureTime' call
      var start_0 = PerformanceCounter_instance.l1q();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      if (!doRender) {
        this.mcy(true, false);
      }
      this.ncy(frameStartTime);
      var end_0 = PerformanceCounter_instance.l1q();
      // Inline function 'korlibs.time.microseconds' call
      var this_1 = end_0 - start_0;
      tmp_0.q9n_1 = toDuration(this_1, DurationUnit_MICROSECONDS_getInstance());
    }
    var endTime = PerformanceCounter_instance.n1q();
    return Duration__minus_impl_q5cfm7(endTime, startTime);
  };
  protoOf(GameWindow).scx = function (doUpdate, doRender, frameStartTime, $super) {
    doUpdate = doUpdate === VOID ? true : doUpdate;
    doRender = doRender === VOID ? true : doRender;
    frameStartTime = frameStartTime === VOID ? PerformanceCounter_instance.n1q() : frameStartTime;
    return $super === VOID ? this.lcy(doUpdate, doRender, frameStartTime) : $super.lcy.call(this, doUpdate, doRender, new Duration(frameStartTime)).aj_1;
  };
  protoOf(GameWindow).mcy = function (doUpdate, doRender) {
    if (doRender) {
      if (this.a9o_1) {
        this.a9o_1 = false;
        this.r9r().p7u();
      }
      if (this.t9n_1) {
        this.t9n_1 = false;
        this.r9r().o7u().r7z(this.u9n_1, this.v9n_1, this.w9n_1, this.x9n_1);
        this.ocy(this.u9n_1, this.v9n_1, this.w9n_1, this.x9n_1);
      }
    }
    if (this.y9n_1) {
      this.y9n_1 = false;
      println('---------------- Trigger AG.initialized ag.mainFrameBuffer.setSize (' + this.x1q() + ', ' + this.y1q() + ') --------------');
      // Inline function 'korlibs.event.reset' call
      var this_0 = this.q9m_1;
      this_0.a7n_1 = false;
      // Inline function 'korlibs.event.reset.<anonymous>' call
      this.s7m(this_0);
    }
    try {
      this.pcy(doUpdate, doRender);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(GameWindow).s7u = function () {
    this.b9o_1 = 0;
  };
  protoOf(GameWindow).bci = function () {
    this.b9o_1 = this.b9o_1 + 1 | 0;
  };
  protoOf(GameWindow).ncy = function (startTime) {
    var tmp = this;
    // Inline function 'korlibs.time.measureTime' call
    var start = PerformanceCounter_instance.l1q();
    // Inline function 'korlibs.render.GameWindow.frameUpdate.<anonymous>' call
    this.qcy();
    var end = PerformanceCounter_instance.l1q();
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = end - start;
    tmp.c9o_1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
    try {
      var now = PerformanceCounter_instance.n1q();
      var consumed = Duration__minus_impl_q5cfm7(now, startTime);
      var tmp0_elvis_lhs = this.q9r().jcy_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
        tmp_0 = Duration__times_impl_sfuzvp_0(this.tcx(), 10);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var timeForTasks = tmp_0;
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$3 = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
      var finalTimeForTasks = max_1(timeForTasks, tmp$ret$3);
      this.q9r().rcy(finalTimeForTasks);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(GameWindow).qcy = function () {
  };
  protoOf(GameWindow).pcy = function (update, render) {
    // Inline function 'korlibs.render.GameWindow.updateRenderLock' call
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.d9o_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'korlibs.event.reset' call
        var this_1 = this.p9m_1;
        this_1.a7n_1 = false;
        // Inline function 'korlibs.render.GameWindow.dispatchRenderEvent.<anonymous>.<anonymous>' call
        this_1.r7q_1 = update;
        this_1.s7q_1 = render;
        this.s7m(this_1);
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
  };
  protoOf(GameWindow).scy = function (type, files) {
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.x9m_1;
    this_0.a7n_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchDropfileEvent.<anonymous>' call
    this_0.a7r_1 = type;
    this_0.b7r_1 = files;
    return this.s7m(this_0);
  };
  protoOf(GameWindow).ocy = function (x, y, width, height) {
    this.tcy(x, y, width, height, width, height);
  };
  protoOf(GameWindow).tcy = function (x, y, width, height, fullWidth, fullHeight) {
    this.r9r().o7u().s7z(x, y, width, height, fullWidth, fullHeight);
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.t9m_1;
    this_0.a7n_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchReshapeEventEx.<anonymous>' call
    this_0.k7q_1 = x;
    this_0.l7q_1 = y;
    this_0.m7q_1 = width;
    this_0.n7q_1 = height;
    this.s7m(this_0);
  };
  protoOf(GameWindow).c7t = function () {
    this.k9o_1.c7t();
  };
  protoOf(GameWindow).d7t = function (info) {
    this.k9o_1.d7t(info);
  };
  protoOf(GameWindow).e7t = function (out) {
    return this.k9o_1.e7t(out);
  };
  protoOf(GameWindow).ucy = function (out, $super) {
    out = out === VOID ? new IntArrayList() : out;
    return $super === VOID ? this.e7t(out) : $super.e7t.call(this, out);
  };
  function Impl(quality) {
    quality = quality === VOID ? Quality_AUTOMATIC_getInstance() : quality;
    this.vcy_1 = quality;
  }
  protoOf(Impl).o9r = function () {
    return this.vcy_1;
  };
  function Companion_80() {
    Companion_instance_94 = this;
    this.wcy_1 = new GameWindowCreationConfig();
  }
  var Companion_instance_94;
  function Companion_getInstance_106() {
    if (Companion_instance_94 == null)
      new Companion_80();
    return Companion_instance_94;
  }
  function GameWindowCreationConfig(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable) {
    Companion_getInstance_106();
    multithreaded = multithreaded === VOID ? null : multithreaded;
    hdr = hdr === VOID ? null : hdr;
    msaa = msaa === VOID ? null : msaa;
    checkGl = checkGl === VOID ? false : checkGl;
    logGl = logGl === VOID ? false : logGl;
    cacheGl = cacheGl === VOID ? false : cacheGl;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    decorated = decorated === VOID ? true : decorated;
    transparent = transparent === VOID ? false : transparent;
    resizable = resizable === VOID ? true : resizable;
    this.xcy_1 = multithreaded;
    this.ycy_1 = hdr;
    this.zcy_1 = msaa;
    this.acz_1 = checkGl;
    this.bcz_1 = logGl;
    this.ccz_1 = cacheGl;
    this.dcz_1 = fullscreen;
    this.ecz_1 = decorated;
    this.fcz_1 = transparent;
    this.gcz_1 = resizable;
  }
  protoOf(GameWindowCreationConfig).toString = function () {
    return 'GameWindowCreationConfig(multithreaded=' + this.xcy_1 + ', hdr=' + this.ycy_1 + ', msaa=' + this.zcy_1 + ', checkGl=' + this.acz_1 + ', logGl=' + this.bcz_1 + ', cacheGl=' + this.ccz_1 + ', fullscreen=' + this.dcz_1 + ', decorated=' + this.ecz_1 + ', transparent=' + this.fcz_1 + ', resizable=' + this.gcz_1 + ')';
  };
  protoOf(GameWindowCreationConfig).hashCode = function () {
    var result = this.xcy_1 == null ? 0 : getBooleanHashCode(this.xcy_1);
    result = imul(result, 31) + (this.ycy_1 == null ? 0 : getBooleanHashCode(this.ycy_1)) | 0;
    result = imul(result, 31) + (this.zcy_1 == null ? 0 : this.zcy_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.acz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.bcz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ccz_1) | 0;
    result = imul(result, 31) + (this.dcz_1 == null ? 0 : getBooleanHashCode(this.dcz_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ecz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.fcz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.gcz_1) | 0;
    return result;
  };
  protoOf(GameWindowCreationConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWindowCreationConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameWindowCreationConfig ? other : THROW_CCE();
    if (!(this.xcy_1 == tmp0_other_with_cast.xcy_1))
      return false;
    if (!(this.ycy_1 == tmp0_other_with_cast.ycy_1))
      return false;
    if (!(this.zcy_1 == tmp0_other_with_cast.zcy_1))
      return false;
    if (!(this.acz_1 === tmp0_other_with_cast.acz_1))
      return false;
    if (!(this.bcz_1 === tmp0_other_with_cast.bcz_1))
      return false;
    if (!(this.ccz_1 === tmp0_other_with_cast.ccz_1))
      return false;
    if (!(this.dcz_1 == tmp0_other_with_cast.dcz_1))
      return false;
    if (!(this.ecz_1 === tmp0_other_with_cast.ecz_1))
      return false;
    if (!(this.fcz_1 === tmp0_other_with_cast.fcz_1))
      return false;
    if (!(this.gcz_1 === tmp0_other_with_cast.gcz_1))
      return false;
    return true;
  };
  function configure(_this__u8e3s4, size, title, icon, fullscreen, bgcolor) {
    title = title === VOID ? 'GameWindow' : title;
    icon = icon === VOID ? null : icon;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    bgcolor = bgcolor === VOID ? Colors_getInstance().m3b_1 : bgcolor;
    _this__u8e3s4.ycx(numberToInt(size.r2k_1), numberToInt(size.s2k_1));
    if (!(title == null)) {
      _this__u8e3s4.wcx(title);
    }
    _this__u8e3s4.n9r(icon);
    if (!(fullscreen == null)) {
      _this__u8e3s4.xcx(fullscreen);
    }
    _this__u8e3s4.p9u(bgcolor);
    _this__u8e3s4.cax(true);
  }
  function fpsCached$factory() {
    return getPropertyCallableRef('fpsCached', 1, KProperty1, function (receiver) {
      return _get_fpsCached__581dty(receiver);
    }, null);
  }
  function continuousRenderMode$factory_0() {
    return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
      return receiver.pci();
    }, function (receiver, value) {
      return receiver.qci(value);
    });
  }
  function continuousRenderMode$factory_1() {
    return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
      return receiver.pci();
    }, function (receiver, value) {
      return receiver.qci(value);
    });
  }
  function TimedTask(time, continuation, callback) {
    this.hcz_1 = time;
    this.icz_1 = continuation;
    this.jcz_1 = callback;
    this.kcz_1 = null;
  }
  function Companion_81() {
    Companion_instance_95 = this;
    this.lcz_1 = Companion_getInstance_2().r24('GameWindow');
  }
  var Companion_instance_95;
  function Companion_getInstance_107() {
    if (Companion_instance_95 == null)
      new Companion_81();
    return Companion_instance_95;
  }
  function sam$kotlinx_coroutines_DisposableHandle$0(function_0) {
    this.mcz_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).f1e = function () {
    return this.mcz_1();
  };
  function GameWindowCoroutineDispatcher$_init_$lambda_ooms1e() {
    return new Duration(PerformanceCounter_instance.n1q());
  }
  function GameWindowCoroutineDispatcher$timedTasks$lambda(a, b) {
    return Duration__compareTo_impl_pchp0f(a.hcz_1, b.hcz_1);
  }
  function GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda($task) {
    return function (it) {
      $task.kcz_1 = it;
      return Unit_instance;
    };
  }
  function GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this$0, $task) {
    return function () {
      // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
      this$0.gcy_1;
      this$0.fcy_1.h1u($task);
      return Unit_instance;
    };
  }
  function GameWindowCoroutineDispatcher(nowProvider, fast) {
    Companion_getInstance_107();
    var tmp;
    if (nowProvider === VOID) {
      tmp = GameWindowCoroutineDispatcher$_init_$lambda_ooms1e;
    } else {
      tmp = nowProvider;
    }
    nowProvider = tmp;
    fast = fast === VOID ? false : fast;
    CoroutineDispatcher.call(this);
    this.ccy_1 = nowProvider;
    this.dcy_1 = fast;
    this.ecy_1 = new TGenQueue();
    var tmp_0 = this;
    var tmp_1 = Companion_instance_12;
    tmp_0.fcy_1 = tmp_1.r1y(VOID, GameWindowCoroutineDispatcher$timedTasks$lambda);
    this.gcy_1 = new NonRecursiveLock();
    var tmp_2 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_2.hcy_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_3 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_3.icy_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    this.jcy_1 = null;
    this.kcy_1 = Companion_getInstance_2().r24('Korgw.GameWindow.TooManyCallbacks');
  }
  protoOf(GameWindowCoroutineDispatcher).ncz = function (block) {
    if (block == null)
      return Unit_instance;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    this.gcy_1;
    this.ecy_1.b1z(block);
  };
  protoOf(GameWindowCoroutineDispatcher).v1g = function (context, block) {
    return this.ncz(block);
  };
  protoOf(GameWindowCoroutineDispatcher).ocz = function () {
    return this.ccy_1().aj_1;
  };
  protoOf(GameWindowCoroutineDispatcher).d1h = function (timeMillis, continuation) {
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.u6();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    this.pcz(tmp$ret$0, continuation);
  };
  protoOf(GameWindowCoroutineDispatcher).pcz = function (time, continuation) {
    var task = new TimedTask(Duration__plus_impl_yu9v8f(this.ocz(), time), continuation, null);
    continuation.c1e(GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda(task));
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    this.gcy_1;
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.scheduleResumeAfterDelay.<anonymous>' call
    this.fcy_1.g1u(task);
  };
  protoOf(GameWindowCoroutineDispatcher).e1h = function (timeMillis, block, context) {
    var tmp = this.ocz();
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.u6();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    var task = new TimedTask(Duration__plus_impl_yu9v8f(tmp, tmp$ret$0), null, block);
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    this.gcy_1;
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.invokeOnTimeout.<anonymous>' call
    this.fcy_1.g1u(task);
    var tmp_0 = GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this, task);
    return new sam$kotlinx_coroutines_DisposableHandle$0(tmp_0);
  };
  protoOf(GameWindowCoroutineDispatcher).rcy = function (availableTime) {
    try {
      var startTime = this.ocz();
      var processedTimedTasks = 0;
      var processedTasks = 0;
      var tmp = this;
      // Inline function 'korlibs.time.measureTime' call
      var start = PerformanceCounter_instance.l1q();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_0: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        this.gcy_1;
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.fcy_1.b1()) {
          tmp_1 = this.dcy_1 ? true : Duration__compareTo_impl_pchp0f(startTime, this.fcy_1.x1y().hcz_1) >= 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.fcy_1.y1y();
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var item = tmp_2;
        try {
          if (!(item.kcz_1 == null)) {
            var tmp1_safe_receiver = item.icz_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resumeWithException' call
              // Inline function 'kotlin.Companion.failure' call
              var exception = ensureNotNull(item.kcz_1);
              var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
              tmp1_safe_receiver.s6(tmp$ret$3);
            }
            if (!(item.jcz_1 == null)) {
              var tmp2_safe_receiver = item.kcz_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                printStackTrace(tmp2_safe_receiver);
              }
            }
          } else {
            var tmp3_safe_receiver = item.icz_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resume' call
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
              tmp3_safe_receiver.s6(tmp$ret$5);
            }
            var tmp4_safe_receiver = item.jcz_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.y1f();
            }
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
        finally {
          processedTimedTasks = processedTimedTasks + 1 | 0;
        }
        var elapsedTime = Duration__minus_impl_q5cfm7(this.ocz(), startTime);
        if (Duration__compareTo_impl_pchp0f(elapsedTime, availableTime) >= 0) {
          this.qcz(elapsedTime, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_0;
        }
      }
      var end = PerformanceCounter_instance.l1q();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      tmp.hcy_1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      var tmp_3 = this;
      // Inline function 'korlibs.time.measureTime' call
      var start_0 = PerformanceCounter_instance.l1q();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_2: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        this.gcy_1;
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_4;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.ecy_1.b1()) {
          tmp_4 = this.ecy_1.c1z();
        } else {
          tmp_4 = null;
        }
        var tmp0_elvis_lhs_0 = tmp_4;
        var tmp_5;
        if (tmp0_elvis_lhs_0 == null) {
          break $l$loop_2;
        } else {
          tmp_5 = tmp0_elvis_lhs_0;
        }
        var task = tmp_5;
        // Inline function 'korlibs.time.measureTime' call
        var start_1 = PerformanceCounter_instance.l1q();
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        try {
          task.y1f();
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            printStackTrace(e_0);
          } else {
            throw $p;
          }
        }
        finally {
          processedTasks = processedTasks + 1 | 0;
        }
        var end_0 = PerformanceCounter_instance.l1q();
        // Inline function 'korlibs.time.microseconds' call
        var this_1 = end_0 - start_1;
        var time = toDuration(this_1, DurationUnit_MICROSECONDS_getInstance());
        var elapsed = Duration__minus_impl_q5cfm7(this.ocz(), startTime);
        if (Duration__compareTo_impl_pchp0f(elapsed, availableTime) >= 0) {
          this.qcz(elapsed, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_2;
        }
      }
      var end_1 = PerformanceCounter_instance.l1q();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_1 - start_0;
      tmp_3.icy_1 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
    } catch ($p) {
      if ($p instanceof Error) {
        var e_1 = $p;
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace(e_1);
      } else {
        throw $p;
      }
    }
  };
  protoOf(GameWindowCoroutineDispatcher).qcz = function (elapsedTime, availableTime, processedTimedTasks, processedTasks) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var this_0 = this.kcy_1;
    var level = Level_WARN_getInstance();
    var tmp;
    if (this_0.f25(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.informTooManyCallbacksToHandleInThisFrame.<anonymous>' call
      var tmp$ret$0 = 'Too many callbacks to handle in this frame elapsedTime=' + new Duration(roundMilliseconds(elapsedTime)) + ', availableTime=' + new Duration(roundMilliseconds(availableTime)) + ' pending timedTasks=' + this.fcy_1.u1y_1 + ', tasks=' + this.ecy_1.n() + ', processedTimedTasks=' + processedTimedTasks + ', processedTasks=' + processedTasks;
      this_0.g25(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  };
  protoOf(GameWindowCoroutineDispatcher).p21 = function () {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(2, DurationUnit_SECONDS_getInstance());
    this.rcy(tmp$ret$1);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_107().lcz_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.f25(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.close.<anonymous>' call
      var tmp$ret$2 = 'GameWindowCoroutineDispatcher.close';
      this_0.g25(level, tmp$ret$2);
      tmp = Unit_instance;
    }
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.fcy_1.b1()) {
        break $l$loop;
      }
      var tmp0_safe_receiver = this.fcy_1.y1y().icz_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp0_safe_receiver.s6(tmp$ret$5);
      }
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.ecy_1.b1()) {
        break $l$loop_0;
      }
      this.ecy_1.c1z().y1f();
    }
  };
  protoOf(GameWindowCoroutineDispatcher).toString = function () {
    return 'GameWindowCoroutineDispatcher(setNow=setNow, fast=' + this.dcy_1 + ')';
  };
  function SyncEventLoopCoroutineDispatcher_init_$Init$(precise, immediateRun, $this) {
    precise = precise === VOID ? true : precise;
    immediateRun = immediateRun === VOID ? false : immediateRun;
    SyncEventLoopCoroutineDispatcher.call($this, new SyncEventLoop(precise, immediateRun));
    return $this;
  }
  function SyncEventLoopCoroutineDispatcher_init_$Create$(precise, immediateRun) {
    return SyncEventLoopCoroutineDispatcher_init_$Init$(precise, immediateRun, objectCreate(protoOf(SyncEventLoopCoroutineDispatcher)));
  }
  function SyncEventLoopCoroutineDispatcher$dispatch$lambda($block) {
    return function () {
      $block.y1f();
      return Unit_instance;
    };
  }
  function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda($cancelled) {
    return function (it) {
      $cancelled._v = it;
      return Unit_instance;
    };
  }
  function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($cancelled, $continuation) {
    return function () {
      var tmp;
      if (!($cancelled._v == null)) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        var this_0 = $continuation;
        // Inline function 'kotlin.Companion.failure' call
        var exception = ensureNotNull($cancelled._v);
        var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
        this_0.s6(tmp$ret$0);
        tmp = Unit_instance;
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        var this_1 = $continuation;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
        this_1.s6(tmp$ret$2);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda($block) {
    return function () {
      $block.y1f();
      return Unit_instance;
    };
  }
  function SyncEventLoopCoroutineDispatcher(eventLoop) {
    CoroutineDispatcher.call(this);
    this.scz_1 = eventLoop;
  }
  protoOf(SyncEventLoopCoroutineDispatcher).p21 = function () {
    this.scz_1.p21();
  };
  protoOf(SyncEventLoopCoroutineDispatcher).v1g = function (context, block) {
    this.scz_1.p26(SyncEventLoopCoroutineDispatcher$dispatch$lambda(block));
  };
  protoOf(SyncEventLoopCoroutineDispatcher).d1h = function (timeMillis, continuation) {
    var cancelled = {_v: null};
    continuation.c1e(SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda(cancelled));
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    this.scz_1.q26(tmp, SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(cancelled, continuation));
  };
  protoOf(SyncEventLoopCoroutineDispatcher).e1h = function (timeMillis, block, context) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    return toDisposable(this.scz_1.q26(tmp, SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda(block)));
  };
  var korgwJvmEngine;
  function AGOpenglFactory() {
  }
  protoOf(AGOpenglFactory).ua1 = function () {
    // Inline function 'kotlin.js.unsafeCast' call
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  };
  var AGOpenglFactory_instance;
  function AGOpenglFactory_getInstance() {
    return AGOpenglFactory_instance;
  }
  function get_korgwCanvasQuery() {
    _init_properties_GlExt_kt__oxmdm();
    // Inline function 'kotlin.getValue' call
    var this_0 = korgwCanvasQuery$delegate;
    korgwCanvasQuery$factory();
    return this_0.m2();
  }
  var korgwCanvasQuery$delegate;
  function AGDefaultCanvas() {
    _init_properties_GlExt_kt__oxmdm();
    var tmp0_safe_receiver = get_korgwCanvasQuery();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.gl.AGDefaultCanvas.<anonymous>' call
      var tmp_0 = document.querySelector(tmp0_safe_receiver);
      tmp = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      var tmp_2 = document.createElement('canvas');
      tmp_1 = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  function AGWebgl(config, canvas) {
    canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
    _init_properties_GlExt_kt__oxmdm();
    // Inline function 'kotlin.also' call
    var this_0 = new AGOpengl(new KmlGlJsCanvas(canvas, jsObject([to('premultipliedAlpha', false), to('alpha', false), to('stencil', true), to('antialias', config.c88_1)])));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGWebgl.<anonymous>' call
    // Inline function 'kotlin.js.asDynamic' call
    window.ag = this_0;
    canvas.addEventListener('webglcontextlost', AGWebgl$lambda, false);
    canvas.addEventListener('webglcontextrestored', AGWebgl$lambda_0(this_0), false);
    return this_0;
  }
  function get_isCanvasCreatedAndHandled() {
    _init_properties_GlExt_kt__oxmdm();
    return get_korgwCanvasQuery() == null;
  }
  function jsObject(pairs) {
    _init_properties_GlExt_kt__oxmdm();
    var out = jsEmptyObject();
    var inductionVariable = 0;
    var last = pairs.length;
    while (inductionVariable < last) {
      var tmp1_loop_parameter = pairs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var k = tmp1_loop_parameter.cg();
      var v = tmp1_loop_parameter.dg();
      if (!(v == null))
        out[k] = v;
    }
    return out;
  }
  function jsEmptyObject() {
    _init_properties_GlExt_kt__oxmdm();
    return {};
  }
  function korgwCanvasQuery$delegate$lambda() {
    _init_properties_GlExt_kt__oxmdm();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return window.korgwCanvasQuery;
  }
  function AGWebgl$lambda(e) {
    _init_properties_GlExt_kt__oxmdm();
    e.preventDefault();
    return Unit_instance;
  }
  function AGWebgl$lambda_0($ag) {
    return function (e) {
      $ag.p7u();
      return Unit_instance;
    };
  }
  function korgwCanvasQuery$factory() {
    return getPropertyCallableRef('korgwCanvasQuery', 0, KProperty0, function () {
      return get_korgwCanvasQuery();
    }, null);
  }
  var properties_initialized_GlExt_kt_6pmiss;
  function _init_properties_GlExt_kt__oxmdm() {
    if (!properties_initialized_GlExt_kt_6pmiss) {
      properties_initialized_GlExt_kt_6pmiss = true;
      korgwCanvasQuery$delegate = lazy(korgwCanvasQuery$delegate$lambda);
    }
  }
  function alloc(_this__u8e3s4, $this) {
    if (_this__u8e3s4 === null)
      return 0;
    // Inline function 'kotlin.js.asDynamic' call
    if (_this__u8e3s4.id === undefined) {
      if ($this.cd0_1.b1()) {
        // Inline function 'kotlin.error' call
        var message = 'KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      var index = $this.cd0_1.h1($this.cd0_1.n() - 1 | 0);
      $this.bd0_1[index] = _this__u8e3s4;
      // Inline function 'kotlin.js.asDynamic' call
      _this__u8e3s4.id = index;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.id;
  }
  function get_2(_this__u8e3s4, $this) {
    var tmp;
    if (!(_this__u8e3s4 === 0)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = $this.bd0_1[_this__u8e3s4];
    } else {
      tmp = null;
    }
    return tmp;
  }
  function free(_this__u8e3s4, $this) {
    var tmp;
    if (!(_this__u8e3s4 === 0)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var out = $this.bd0_1[_this__u8e3s4];
      // Inline function 'kotlin.collections.plusAssign' call
      $this.cd0_1.r(_this__u8e3s4);
      $this.bd0_1[_this__u8e3s4] = null;
      tmp = out;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function KmlGlJsCanvas$extensions$delegate$lambda(this$0) {
    return function () {
      var tmp0_elvis_lhs = this$0.ad0_1.getSupportedExtensions();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = [];
      } else {
        tmp = tmp0_elvis_lhs;
      }
      return toSet_0(tmp);
    };
  }
  function KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this$0) {
    return function () {
      return (this$0.ad0_1.getExtension('OES_texture_float_linear') != null ? true : this$0.ad0_1.getExtension('OES_texture_float') != null) ? true : this$0.zcz_1 >= 2;
    };
  }
  function KmlGlJsCanvas(canvas, glOpts) {
    KmlGl.call(this);
    this.xcz_1 = canvas;
    this.ycz_1 = glOpts;
    this.zcz_1 = 1;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    if (null == null) {
      var tmp0_safe_receiver = this.xcz_1.getContext('webgl2', this.ycz_1);
      var tmp_1;
      if (tmp0_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
        this.zcz_1 = 2;
        tmp_1 = tmp0_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = null;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? this.xcz_1.getContext('webgl', this.ycz_1) : tmp2_elvis_lhs;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_safe_receiver = tmp3_elvis_lhs == null ? this.xcz_1.getContext('experimental-webgl', this.ycz_1) : tmp3_elvis_lhs;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      println('Created WebGL version=' + this.zcz_1 + ', opts=' + JSON.stringify(this.ycz_1));
      tmp_2 = tmp4_safe_receiver;
    }
    var tmp5_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp5_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      tmp5_safe_receiver.getExtension('OES_standard_derivatives');
      tmp5_safe_receiver.getExtension('OES_texture_float');
      tmp5_safe_receiver.getExtension('OES_texture_float_linear');
      tmp5_safe_receiver.getExtension('OES_element_index_uint');
      tmp_3 = tmp5_safe_receiver;
    }
    var tmp6_elvis_lhs = tmp_3;
    var tmp_4;
    if (tmp6_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      try {
        var tmp0_safe_receiver_0 = document.body;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.apply' call
          var tmp_5 = document.createElement('div');
          var this_0 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>.<anonymous>' call
          this_0.style.color = 'red';
          this_0.style.font = '30px Arial';
          this_0.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          tmp0_safe_receiver_0.prepend(this_0);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      var message = "Can't get webgl context";
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_4 = tmp6_elvis_lhs;
    }
    tmp.ad0_1 = tmp_4;
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_6.bd0_1 = fillArrayVal(Array(8192), null);
    this.cd0_1 = toMutableList_0(reversed_0(until(1, this.bd0_1.length)));
    var tmp_7 = this;
    tmp_7.dd0_1 = lazy(KmlGlJsCanvas$extensions$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.ed0_1 = lazy(KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this));
    this.fd0_1 = new WebGLExtension(this, 'ANGLE_instanced_arrays', 2, listOf_0(['drawArraysInstanced', 'drawElementsInstanced', 'vertexAttribDivisor']), 'ANGLE');
    this.gd0_1 = new WebGLExtension(this, 'OES_vertex_array_object', 2, listOf_0(['createVertexArrayOES', 'deleteVertexArrayOES', 'isVertexArrayOES', 'bindVertexArrayOES']), 'OES');
  }
  protoOf(KmlGlJsCanvas).y8h = function () {
    return Companion_instance_60.s8o(this.zcz_1);
  };
  protoOf(KmlGlJsCanvas).x8h = function (texture) {
    return this.ad0_1.activeTexture(texture);
  };
  protoOf(KmlGlJsCanvas).x8m = function (program, shader) {
    return this.ad0_1.attachShader(get_2(program, this), get_2(shader, this));
  };
  protoOf(KmlGlJsCanvas).w8m = function (program, index, name) {
    return this.ad0_1.bindAttribLocation(get_2(program, this), index, name);
  };
  protoOf(KmlGlJsCanvas).r8g = function (target, buffer) {
    return this.ad0_1.bindBuffer(target, get_2(buffer, this));
  };
  protoOf(KmlGlJsCanvas).q8l = function (target, framebuffer) {
    return this.ad0_1.bindFramebuffer(target, get_2(framebuffer, this));
  };
  protoOf(KmlGlJsCanvas).x8l = function (target, renderbuffer) {
    return this.ad0_1.bindRenderbuffer(target, get_2(renderbuffer, this));
  };
  protoOf(KmlGlJsCanvas).o8l = function (target, texture) {
    return this.ad0_1.bindTexture(target, get_2(texture, this));
  };
  protoOf(KmlGlJsCanvas).a8j = function (modeRGB, modeAlpha) {
    return this.ad0_1.blendEquationSeparate(modeRGB, modeAlpha);
  };
  protoOf(KmlGlJsCanvas).b8j = function (sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.ad0_1.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  };
  protoOf(KmlGlJsCanvas).b8i = function (target, size, data, usage) {
    return this.ad0_1.bufferData(target, get_arrayUByte(sliceBuffer(data, 0, size)), usage);
  };
  protoOf(KmlGlJsCanvas).a8i = function (target, offset, size, data) {
    return this.ad0_1.bufferSubData(target, offset, get_arrayUByte(sliceBuffer(data, 0, size)));
  };
  protoOf(KmlGlJsCanvas).w8i = function (mask) {
    return this.ad0_1.clear(mask);
  };
  protoOf(KmlGlJsCanvas).r8i = function (red, green, blue, alpha) {
    return this.ad0_1.clearColor(red, green, blue, alpha);
  };
  protoOf(KmlGlJsCanvas).t8i = function (d) {
    return this.ad0_1.clearDepth(d);
  };
  protoOf(KmlGlJsCanvas).v8i = function (s) {
    return this.ad0_1.clearStencil(s);
  };
  protoOf(KmlGlJsCanvas).e8m = function (red, green, blue, alpha) {
    return this.ad0_1.colorMask(red, green, blue, alpha);
  };
  protoOf(KmlGlJsCanvas).o8m = function (shader) {
    return this.ad0_1.compileShader(get_2(shader, this));
  };
  protoOf(KmlGlJsCanvas).q8m = function () {
    return alloc(this.ad0_1.createProgram(), this);
  };
  protoOf(KmlGlJsCanvas).m8m = function (type) {
    return alloc(this.ad0_1.createShader(type), this);
  };
  protoOf(KmlGlJsCanvas).w8j = function (mode) {
    return this.ad0_1.cullFace(mode);
  };
  protoOf(KmlGlJsCanvas).s99 = function (n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.ad0_1.deleteBuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  };
  protoOf(KmlGlJsCanvas).t99 = function (n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.ad0_1.deleteFramebuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  };
  protoOf(KmlGlJsCanvas).l8m = function (program) {
    return this.ad0_1.deleteProgram(get_2(program, this));
  };
  protoOf(KmlGlJsCanvas).u99 = function (n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.ad0_1.deleteRenderbuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  };
  protoOf(KmlGlJsCanvas).k8m = function (shader) {
    return this.ad0_1.deleteShader(get_2(shader, this));
  };
  protoOf(KmlGlJsCanvas).v99 = function (n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.ad0_1.deleteTexture(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  };
  protoOf(KmlGlJsCanvas).d8m = function (func) {
    return this.ad0_1.depthFunc(func);
  };
  protoOf(KmlGlJsCanvas).s8i = function (flag) {
    return this.ad0_1.depthMask(flag);
  };
  protoOf(KmlGlJsCanvas).c8m = function (n, f) {
    return this.ad0_1.depthRange(n, f);
  };
  protoOf(KmlGlJsCanvas).f8j = function (cap) {
    return this.ad0_1.disable(cap);
  };
  protoOf(KmlGlJsCanvas).w8k = function (index) {
    return this.ad0_1.disableVertexAttribArray(index);
  };
  protoOf(KmlGlJsCanvas).m8j = function (mode, first, count) {
    return this.ad0_1.drawArrays(mode, first, count);
  };
  protoOf(KmlGlJsCanvas).o8j = function (mode, count, type, indices) {
    return this.ad0_1.drawElements(mode, count, type, indices);
  };
  protoOf(KmlGlJsCanvas).g8j = function (cap) {
    return this.ad0_1.enable(cap);
  };
  protoOf(KmlGlJsCanvas).a8l = function (index) {
    return this.ad0_1.enableVertexAttribArray(index);
  };
  protoOf(KmlGlJsCanvas).m6 = function () {
    return this.ad0_1.flush();
  };
  protoOf(KmlGlJsCanvas).a8m = function (target, attachment, renderbuffertarget, renderbuffer) {
    return this.ad0_1.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_2(renderbuffer, this));
  };
  protoOf(KmlGlJsCanvas).z8l = function (target, attachment, textarget, texture, level) {
    return this.ad0_1.framebufferTexture2D(target, attachment, textarget, get_2(texture, this), level);
  };
  protoOf(KmlGlJsCanvas).b8m = function (mode) {
    return this.ad0_1.frontFace(mode);
  };
  protoOf(KmlGlJsCanvas).w99 = function (n, buffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(buffers)[p] = alloc(this.ad0_1.createBuffer(), this);
      }
       while (inductionVariable < n);
  };
  protoOf(KmlGlJsCanvas).f8i = function (target) {
    return this.ad0_1.generateMipmap(target);
  };
  protoOf(KmlGlJsCanvas).x99 = function (n, framebuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(framebuffers)[p] = alloc(this.ad0_1.createFramebuffer(), this);
      }
       while (inductionVariable < n);
  };
  protoOf(KmlGlJsCanvas).y99 = function (n, renderbuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(renderbuffers)[p] = alloc(this.ad0_1.createRenderbuffer(), this);
      }
       while (inductionVariable < n);
  };
  protoOf(KmlGlJsCanvas).z99 = function (n, textures) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(textures)[p] = alloc(this.ad0_1.createTexture(), this);
      }
       while (inductionVariable < n);
  };
  protoOf(KmlGlJsCanvas).i8m = function (program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    var prg = get_2(program, this);
    if (prg.uniforms === undefined)
      prg.uniforms = {};
    if (prg.uniforms[name] === undefined)
      prg.uniforms[name] = alloc(this.ad0_1.getUniformLocation(prg, name), this);
    // Inline function 'kotlin.js.unsafeCast' call
    return prg.uniforms[name];
  };
  protoOf(KmlGlJsCanvas).p8m = function () {
    return this.ad0_1.getError();
  };
  protoOf(KmlGlJsCanvas).a9a = function (pname, data) {
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(data)[0] = this.ad0_1.getParameter(pname);
  };
  protoOf(KmlGlJsCanvas).b9a = function (program, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.ad0_1.getProgramInfoLog(get_2(program, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.ad0_1.getProgramParameter(get_2(program, this), pname);
    }
  };
  protoOf(KmlGlJsCanvas).c9a = function (shader, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.ad0_1.getShaderInfoLog(get_2(shader, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.ad0_1.getShaderParameter(get_2(shader, this), pname);
    }
  };
  protoOf(KmlGlJsCanvas).d9a = function (shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs = this.ad0_1.getShaderInfoLog(get_2(shader, this));
    var str = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(length)[0] = str.length;
    putAsciiString(infoLog, str);
  };
  protoOf(KmlGlJsCanvas).m8e = function (name) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.ad0_1.getParameter(name);
  };
  protoOf(KmlGlJsCanvas).y8m = function (program) {
    return this.ad0_1.linkProgram(get_2(program, this));
  };
  protoOf(KmlGlJsCanvas).c8i = function (pname, param) {
    return this.ad0_1.pixelStorei(pname, param);
  };
  protoOf(KmlGlJsCanvas).y8l = function (target, internalformat, width, height) {
    return this.ad0_1.renderbufferStorage(target, internalformat, width, height);
  };
  protoOf(KmlGlJsCanvas).f8m = function (x, y, width, height) {
    return this.ad0_1.scissor(x, y, width, height);
  };
  protoOf(KmlGlJsCanvas).n8m = function (shader, string) {
    return this.ad0_1.shaderSource(get_2(shader, this), string);
  };
  protoOf(KmlGlJsCanvas).i8j = function (func, ref, mask) {
    return this.ad0_1.stencilFunc(func, ref, mask);
  };
  protoOf(KmlGlJsCanvas).h8j = function (face, func, ref, mask) {
    return this.ad0_1.stencilFuncSeparate(face, func, ref, mask);
  };
  protoOf(KmlGlJsCanvas).u8i = function (mask) {
    return this.ad0_1.stencilMask(mask);
  };
  protoOf(KmlGlJsCanvas).l8j = function (face, mask) {
    return this.ad0_1.stencilMaskSeparate(face, mask);
  };
  protoOf(KmlGlJsCanvas).k8j = function (fail, zfail, zpass) {
    return this.ad0_1.stencilOp(fail, zfail, zpass);
  };
  protoOf(KmlGlJsCanvas).j8j = function (face, sfail, dpfail, dppass) {
    return this.ad0_1.stencilOpSeparate(face, sfail, dpfail, dppass);
  };
  protoOf(KmlGlJsCanvas).d8i = function (target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp;
    // Inline function 'korlibs.kgl.KmlGl.FLOAT' call
    if (type === 5126) {
      tmp = pixels == null ? null : get_arrayFloat(pixels);
    } else {
      tmp = pixels == null ? null : get_arrayUByte(pixels);
    }
    var vpixels = tmp;
    this.ad0_1.texImage2D(target, level, internalformat, width, height, border, format, type, vpixels);
  };
  protoOf(KmlGlJsCanvas).e8i = function (target, level, internalformat, format, type, data) {
    // Inline function 'korlibs.math.toInt' call
    var tmp$ret$0 = (!data.b3a_1 ? data.a3a_1 : false) ? 1 : 0;
    this.ad0_1.pixelStorei(37441, tmp$ret$0);
    this.ad0_1.texImage2D(target, level, internalformat, format, type, (data instanceof HtmlNativeImage ? data : THROW_CCE()).t7c_1);
    this.ad0_1.pixelStorei(37441, 0);
  };
  protoOf(KmlGlJsCanvas).w8h = function (target, pname, param) {
    return this.ad0_1.texParameteri(target, pname, param);
  };
  protoOf(KmlGlJsCanvas).s8h = function (location, count, value) {
    return this.ad0_1.uniform1fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 1)));
  };
  protoOf(KmlGlJsCanvas).q8f = function (location, v0) {
    return this.ad0_1.uniform1i(get_2(location, this), v0);
  };
  protoOf(KmlGlJsCanvas).l8h = function (location, count, value) {
    return this.ad0_1.uniform1iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 1)));
  };
  protoOf(KmlGlJsCanvas).t8h = function (location, count, value) {
    return this.ad0_1.uniform2fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 2)));
  };
  protoOf(KmlGlJsCanvas).m8h = function (location, count, value) {
    return this.ad0_1.uniform2iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 2)));
  };
  protoOf(KmlGlJsCanvas).u8h = function (location, count, value) {
    return this.ad0_1.uniform3fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 3)));
  };
  protoOf(KmlGlJsCanvas).n8h = function (location, count, value) {
    return this.ad0_1.uniform3iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 3)));
  };
  protoOf(KmlGlJsCanvas).v8h = function (location, count, value) {
    return this.ad0_1.uniform4fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 4)));
  };
  protoOf(KmlGlJsCanvas).o8h = function (location, count, value) {
    return this.ad0_1.uniform4iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 4)));
  };
  protoOf(KmlGlJsCanvas).p8h = function (location, count, transpose, value) {
    return this.ad0_1.uniformMatrix2fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 4)));
  };
  protoOf(KmlGlJsCanvas).q8h = function (location, count, transpose, value) {
    return this.ad0_1.uniformMatrix3fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 9)));
  };
  protoOf(KmlGlJsCanvas).r8h = function (location, count, transpose, value) {
    return this.ad0_1.uniformMatrix4fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 16)));
  };
  protoOf(KmlGlJsCanvas).j8m = function (program) {
    return this.ad0_1.useProgram(get_2(program, this));
  };
  protoOf(KmlGlJsCanvas).b8l = function (index, size, type, normalized, stride, pointer) {
    return this.ad0_1.vertexAttribPointer(index, size, type, normalized, stride, pointer.kb());
  };
  protoOf(KmlGlJsCanvas).p8l = function (x, y, width, height) {
    return this.ad0_1.viewport(x, y, width, height);
  };
  protoOf(KmlGlJsCanvas).q38 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.dd0_1;
    extensions$factory();
    return this_0.m2();
  };
  protoOf(KmlGlJsCanvas).n8j = function (mode, first, count, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.ad0_1.drawArraysInstanced(mode, first, count, instancecount);
  };
  protoOf(KmlGlJsCanvas).p8j = function (mode, count, type, indices, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.ad0_1.drawElementsInstanced(mode, count, type, indices, instancecount);
  };
  protoOf(KmlGlJsCanvas).v8k = function (index, divisor) {
    // Inline function 'kotlin.js.asDynamic' call
    this.ad0_1.vertexAttribDivisor(index, divisor);
  };
  protoOf(KmlGlJsCanvas).w7u = function () {
    return get_versionInt(this) >= 2;
  };
  protoOf(KmlGlJsCanvas).i8l = function (target, index, buffer, offset, size) {
    // Inline function 'kotlin.js.asDynamic' call
    this.ad0_1.bindBufferRange(target, index, get_2(buffer, this), offset, size);
  };
  protoOf(KmlGlJsCanvas).r8f = function (program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    return this.ad0_1.getUniformBlockIndex(get_2(program, this), name);
  };
  protoOf(KmlGlJsCanvas).s8f = function (program, uniformBlockIndex, uniformBlockBinding) {
    // Inline function 'kotlin.js.asDynamic' call
    this.ad0_1.uniformBlockBinding(get_2(program, this), uniformBlockIndex, uniformBlockBinding);
  };
  protoOf(KmlGlJsCanvas).x7u = function () {
    return this.gd0_1.od0();
  };
  protoOf(KmlGlJsCanvas).e9a = function (n, arrays) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.ad0_1.createVertexArray();
        setInt32(arrays, i, alloc(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  };
  protoOf(KmlGlJsCanvas).x8k = function (array) {
    // Inline function 'kotlin.js.asDynamic' call
    this.ad0_1.bindVertexArray(get_2(array, this));
  };
  function WebGLExtension(canvas, name, coreSince, functions, suffix) {
    coreSince = coreSince === VOID ? 1000 : coreSince;
    functions = functions === VOID ? emptyList() : functions;
    suffix = suffix === VOID ? '' : suffix;
    this.hd0_1 = canvas;
    this.id0_1 = name;
    this.jd0_1 = coreSince;
    this.kd0_1 = functions;
    this.ld0_1 = suffix;
    this.md0_1 = false;
    this.nd0_1 = null;
  }
  protoOf(WebGLExtension).m2 = function () {
    if (!this.md0_1) {
      this.md0_1 = true;
      this.nd0_1 = this.hd0_1.ad0_1.getExtension(this.id0_1);
      var tmp0_iterator = this.kd0_1.u();
      while (tmp0_iterator.v()) {
        var func = tmp0_iterator.x();
        var base = removeSuffix(func, this.ld0_1);
        var vfunc = this.nd0_1[func];
        if (typeof vfunc === 'function') {
          // Inline function 'kotlin.js.asDynamic' call
          this.hd0_1.ad0_1[base] = vfunc.bind(this.nd0_1);
        }
      }
    }
    return this.nd0_1;
  };
  protoOf(WebGLExtension).od0 = function () {
    return this.hd0_1.zcz_1 >= this.jd0_1 ? true : this.m2() != null;
  };
  function extensions$factory() {
    return getPropertyCallableRef('extensions', 1, KProperty1, function (receiver) {
      return receiver.q38();
    }, null);
  }
  function completeViews(views) {
  }
  function get_KorgeReloadInternal() {
    _init_properties_KorgeReload_getReloadedClass_kt__lithzw();
    return KorgeReloadInternal;
  }
  var KorgeReloadInternal;
  function KorgeReloadInternal$1() {
    KorgeReloadInternalImpl.call(this);
  }
  var properties_initialized_KorgeReload_getReloadedClass_kt_tswp16;
  function _init_properties_KorgeReload_getReloadedClass_kt__lithzw() {
    if (!properties_initialized_KorgeReload_getReloadedClass_kt_tswp16) {
      properties_initialized_KorgeReload_getReloadedClass_kt_tswp16 = true;
      KorgeReloadInternal = new KorgeReloadInternal$1();
    }
  }
  function CreateDefaultGameWindow(config) {
    return Companion_instance_2.r1p() ? new NodeJsGameWindow() : new BrowserCanvasJsGameWindow();
  }
  function NodeJsGameWindow() {
    JsGameWindow.call(this);
  }
  function onResized($this) {
    $this.dd3_1 = null;
    if (get_isCanvasCreatedAndHandled()) {
      var scale = $this.o9r().gcw(window.innerWidth, window.innerHeight, $this.zaa());
      var canvasWidth = numberToInt(window.innerWidth * scale);
      var canvasHeight = numberToInt(window.innerHeight * scale);
      $this.ad3_1.width = canvasWidth;
      $this.ad3_1.height = canvasHeight;
      $this.ad3_1.style.position = 'absolute';
      $this.ad3_1.style.left = '0';
      $this.ad3_1.style.right = '0';
      $this.ad3_1.style.width = '' + window.innerWidth + 'px';
      $this.ad3_1.style.height = '' + window.innerHeight + 'px';
      $this.id3_1 = scale;
    } else {
      $this.id3_1 = $this.ad3_1.width / $this.ad3_1.clientWidth;
    }
    $this.ocy(0, 0, $this.ad3_1.width, $this.ad3_1.height);
  }
  function keyEvent($this, me) {
    var tmp;
    switch (me.key) {
      case '0':
        tmp = Key_N0_getInstance();
        break;
      case '1':
        tmp = Key_N1_getInstance();
        break;
      case '2':
        tmp = Key_N2_getInstance();
        break;
      case '3':
        tmp = Key_N3_getInstance();
        break;
      case '4':
        tmp = Key_N4_getInstance();
        break;
      case '5':
        tmp = Key_N5_getInstance();
        break;
      case '6':
        tmp = Key_N6_getInstance();
        break;
      case '7':
        tmp = Key_N7_getInstance();
        break;
      case '8':
        tmp = Key_N8_getInstance();
        break;
      case '9':
        tmp = Key_N9_getInstance();
        break;
      case 'a':
        tmp = Key_A_getInstance();
        break;
      case 'b':
        tmp = Key_B_getInstance();
        break;
      case 'c':
        tmp = Key_C_getInstance();
        break;
      case 'd':
        tmp = Key_D_getInstance();
        break;
      case 'e':
        tmp = Key_E_getInstance();
        break;
      case 'f':
        tmp = Key_F_getInstance();
        break;
      case 'g':
        tmp = Key_G_getInstance();
        break;
      case 'h':
        tmp = Key_H_getInstance();
        break;
      case 'i':
        tmp = Key_I_getInstance();
        break;
      case 'j':
        tmp = Key_J_getInstance();
        break;
      case 'k':
        tmp = Key_K_getInstance();
        break;
      case 'l':
        tmp = Key_L_getInstance();
        break;
      case 'm':
        tmp = Key_M_getInstance();
        break;
      case 'n':
        tmp = Key_N_getInstance();
        break;
      case 'o':
        tmp = Key_O_getInstance();
        break;
      case 'p':
        tmp = Key_P_getInstance();
        break;
      case 'q':
        tmp = Key_Q_getInstance();
        break;
      case 'r':
        tmp = Key_R_getInstance();
        break;
      case 's':
        tmp = Key_S_getInstance();
        break;
      case 't':
        tmp = Key_T_getInstance();
        break;
      case 'u':
        tmp = Key_U_getInstance();
        break;
      case 'v':
        tmp = Key_V_getInstance();
        break;
      case 'w':
        tmp = Key_W_getInstance();
        break;
      case 'x':
        tmp = Key_X_getInstance();
        break;
      case 'y':
        tmp = Key_Y_getInstance();
        break;
      case 'z':
        tmp = Key_Z_getInstance();
        break;
      case 'F1':
        tmp = Key_F1_getInstance();
        break;
      case 'F2':
        tmp = Key_F2_getInstance();
        break;
      case 'F3':
        tmp = Key_F3_getInstance();
        break;
      case 'F4':
        tmp = Key_F4_getInstance();
        break;
      case 'F5':
        tmp = Key_F5_getInstance();
        break;
      case 'F6':
        tmp = Key_F6_getInstance();
        break;
      case 'F7':
        tmp = Key_F7_getInstance();
        break;
      case 'F8':
        tmp = Key_F8_getInstance();
        break;
      case 'F9':
        tmp = Key_F9_getInstance();
        break;
      case 'F10':
        tmp = Key_F10_getInstance();
        break;
      case 'F11':
        tmp = Key_F11_getInstance();
        break;
      case 'F12':
        tmp = Key_F12_getInstance();
        break;
      case 'F13':
        tmp = Key_F13_getInstance();
        break;
      case 'F14':
        tmp = Key_F14_getInstance();
        break;
      case 'F15':
        tmp = Key_F15_getInstance();
        break;
      case 'F16':
        tmp = Key_F16_getInstance();
        break;
      case 'F17':
        tmp = Key_F17_getInstance();
        break;
      case 'F18':
        tmp = Key_F18_getInstance();
        break;
      case 'F19':
        tmp = Key_F19_getInstance();
        break;
      case 'F20':
        tmp = Key_F20_getInstance();
        break;
      case 'F21':
        tmp = Key_F21_getInstance();
        break;
      case 'F22':
        tmp = Key_F22_getInstance();
        break;
      case 'F23':
        tmp = Key_F23_getInstance();
        break;
      case 'F24':
        tmp = Key_F24_getInstance();
        break;
      case 'F25':
        tmp = Key_F25_getInstance();
        break;
      case '+':
        tmp = Key_PLUS_getInstance();
        break;
      case '-':
        tmp = Key_MINUS_getInstance();
        break;
      case "'":
        tmp = Key_APOSTROPHE_getInstance();
        break;
      case '"':
        tmp = Key_QUOTE_getInstance();
        break;
      default:
        var tmp_0;
        switch (me.code) {
          case 'MetaLeft':
            tmp_0 = Companion_getInstance_46().x7t();
            break;
          case 'MetaRight':
            tmp_0 = Companion_getInstance_46().y7t();
            break;
          case 'ShiftLeft':
            tmp_0 = Companion_getInstance_46().t7t();
            break;
          case 'ShiftRight':
            tmp_0 = Companion_getInstance_46().u7t();
            break;
          case 'ControlLeft':
            tmp_0 = Companion_getInstance_46().r7t();
            break;
          case 'ControlRight':
            tmp_0 = Companion_getInstance_46().s7t();
            break;
          case 'AltLeft':
            tmp_0 = Companion_getInstance_46().v7t();
            break;
          case 'AltRight':
            tmp_0 = Companion_getInstance_46().w7t();
            break;
          case 'Space':
            tmp_0 = Key_SPACE_getInstance();
            break;
          case 'ArrowUp':
            tmp_0 = Key_UP_getInstance();
            break;
          case 'ArrowDown':
            tmp_0 = Key_DOWN_getInstance();
            break;
          case 'ArrowLeft':
            tmp_0 = Key_LEFT_getInstance();
            break;
          case 'ArrowRight':
            tmp_0 = Key_RIGHT_getInstance();
            break;
          case 'PageUp':
            tmp_0 = Key_PAGE_UP_getInstance();
            break;
          case 'PageDown':
            tmp_0 = Key_PAGE_DOWN_getInstance();
            break;
          case 'Home':
            tmp_0 = Key_HOME_getInstance();
            break;
          case 'End':
            tmp_0 = Key_END_getInstance();
            break;
          case 'Enter':
            tmp_0 = Key_ENTER_getInstance();
            break;
          case 'Escape':
            tmp_0 = Key_ESCAPE_getInstance();
            break;
          case 'Backspace':
            tmp_0 = Key_BACKSPACE_getInstance();
            break;
          case 'Delete':
            tmp_0 = Key_DELETE_getInstance();
            break;
          case 'Insert':
            tmp_0 = Key_INSERT_getInstance();
            break;
          case 'Period':
            tmp_0 = Key_PERIOD_getInstance();
            break;
          case 'Comma':
            tmp_0 = Key_COMMA_getInstance();
            break;
          case 'Semicolon':
            tmp_0 = Key_SEMICOLON_getInstance();
            break;
          case 'Slash':
            tmp_0 = Key_SLASH_getInstance();
            break;
          case 'Tab':
            tmp_0 = Key_TAB_getInstance();
            break;
          default:
            // Inline function 'kotlin.js.asDynamic' call

            if (window.korgwShowUnsupportedKeys) {
              // Inline function 'korlibs.logger.Logger.info' call
              var this_0 = CoroutineKey_getInstance().zcv_1;
              var level = Level_INFO_getInstance();
              var tmp_1;
              if (this_0.f25(level)) {
                // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.keyEvent.<anonymous>' call
                var tmp$ret$1 = 'Unsupported key key=' + me.key + ', code=' + me.code;
                this_0.g25(level, tmp$ret$1);
                tmp_1 = Unit_instance;
              }
            }

            tmp_0 = Key_UNKNOWN_getInstance();
            break;
        }

        tmp = tmp_0;
        break;
    }
    var key = tmp;
    $this.s7m(invoke_1($this.u9m_1, BrowserCanvasJsGameWindow$keyEvent$lambda(me, key)));
    if (key.equals(Key_TAB_getInstance()) ? true : key.b7u()) {
      me.preventDefault();
    }
  }
  function touchEvent($this, e, type) {
    var canvasBounds = $this.ad3_1.getBoundingClientRect();
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.event.TouchBuilder.frame' call
    var this_0 = $this.jd3_1;
    this_0.e7r_1 = Mode_JS_getInstance();
    this_0.f7r(type, false);
    try {
      // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
      var inductionVariable = 0;
      var last = e.touches.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1_elvis_lhs = e.touches.item(n);
          var tmp;
          if (tmp1_elvis_lhs == null) {
            continue $l$loop;
          } else {
            tmp = tmp1_elvis_lhs;
          }
          var touch = tmp;
          var touchId = touch.identifier;
          // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
          var tmp_0 = (touch.clientX - canvasBounds.left) * $this.id3_1;
          // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
          var tmp$ret$1 = (touch.clientY - canvasBounds.top) * $this.id3_1;
          var tmp_1 = Vector2D_init_$Create$(tmp_0, tmp$ret$1);
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp2_elvis_lhs = touch.force;
          this_0.i7r(touchId, tmp_1, tmp2_elvis_lhs == null ? 1.0 : tmp2_elvis_lhs, Kind_FINGER_getInstance());
        }
         while (inductionVariable < last);
    }finally {
      this_0.g7r();
    }
    var this_1 = this_0.d7r_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
    $this.s7m(this_1);
  }
  function mouseEvent($this, e, type, pressingType) {
    var canvasBounds = $this.ad3_1.getBoundingClientRect();
    // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
    var tmp$ret$0 = (e.clientX - canvasBounds.left) * $this.id3_1;
    var tx = numberToInt(tmp$ret$0);
    // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
    var tmp$ret$1 = (e.clientY - canvasBounds.top) * $this.id3_1;
    var ty = numberToInt(tmp$ret$1);
    invoke_1($this.v9m_1, BrowserCanvasJsGameWindow$mouseEvent$lambda(e, pressingType, type, tx, ty));
    if (!$this.pd3() ? true : type.equals(Type_SCROLL_getInstance())) {
      $this.s7m($this.v9m_1);
    }
  }
  function mouseEvent$default($this, e, type, pressingType, $super) {
    pressingType = pressingType === VOID ? type : pressingType;
    return mouseEvent($this, e, type, pressingType);
  }
  function _get_jsFrame__gugpar($this) {
    var tmp = $this.nd3_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('jsFrame');
    }
  }
  function BrowserCanvasJsGameWindow$keyEvent$lambda($me, $key) {
    return function ($this$invoke) {
      var tmp = $this$invoke;
      var tmp_0;
      switch ($me.type) {
        case 'keydown':
          tmp_0 = Type_DOWN_getInstance();
          break;
        case 'keyup':
          tmp_0 = Type_UP_getInstance();
          break;
        case 'keypress':
          tmp_0 = Type_TYPE_getInstance();
          break;
        default:
          var message = 'Unsupported event type ' + $me.type;
          throw IllegalStateException_init_$Create$(toString(message));
      }
      tmp.n7n_1 = tmp_0;
      $this$invoke.o7n_1 = 0;
      $this$invoke.q7n_1 = $me.keyCode;
      $this$invoke.p7n_1 = $key;
      $this$invoke.s7n_1 = $me.shiftKey;
      $this$invoke.t7n_1 = $me.ctrlKey;
      $this$invoke.u7n_1 = $me.altKey;
      $this$invoke.v7n_1 = $me.metaKey;
      $this$invoke.r7n_1 = numberToChar($me.charCode);
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$mouseEvent$lambda($e, $pressingType, $type, $tx, $ty) {
    return function ($this$invoke) {
      $this$invoke.e7o_1 = !($e.buttons === 0) ? $pressingType : $type;
      $this$invoke.r7o_1 = false;
      $this$invoke.f7o_1 = 0;
      $this$invoke.g7o_1 = $tx;
      $this$invoke.h7o_1 = $ty;
      $this$invoke.i7o_1 = Companion_getInstance_47().f1($e.button);
      $this$invoke.j7o_1 = $e.buttons;
      $this$invoke.n7o_1 = $e.shiftKey;
      $this$invoke.o7o_1 = $e.ctrlKey;
      $this$invoke.p7o_1 = $e.altKey;
      $this$invoke.q7o_1 = $e.metaKey;
      var tmp;
      if ($type.equals(Type_SCROLL_getInstance())) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var we = $e;
        var tmp0_subject = we.deltaMode;
        var mode = tmp0_subject === WheelEvent.DOM_DELTA_PIXEL ? ScrollDeltaMode_PIXEL_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_LINE ? ScrollDeltaMode_LINE_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_PAGE ? ScrollDeltaMode_PAGE_getInstance() : ScrollDeltaMode_LINE_getInstance();
        var sensitivity = 0.05;
        $this$invoke.w7o(mode, we.deltaX * sensitivity, we.deltaY * sensitivity, we.deltaZ * sensitivity);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$close$slambda(this$0, resultContinuation) {
    this.yd3_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BrowserCanvasJsGameWindow$close$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(BrowserCanvasJsGameWindow$close$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(BrowserCanvasJsGameWindow$close$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.zd3_1 = this.yd3_1.md3_1;
            if (this.zd3_1 == null) {
              this.ad4_1 = null;
              this.fd_1 = 2;
              continue $sm;
            } else {
              this.fd_1 = 1;
              suspendResult = cancelAndJoin(this.zd3_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            tmp_0.ad4_1 = Unit_instance;
            this.fd_1 = 2;
            continue $sm;
          case 2:
            window.close();
            return Unit_instance;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(BrowserCanvasJsGameWindow$close$slambda).g5a = function (completion) {
    return new BrowserCanvasJsGameWindow$close$slambda(this.yd3_1, completion);
  };
  function BrowserCanvasJsGameWindow$close$slambda_0(this$0, resultContinuation) {
    var i = new BrowserCanvasJsGameWindow$close$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function BrowserCanvasJsGameWindow$loop$slambda($entry, this$0, resultContinuation) {
    this.jd4_1 = $entry;
    this.kd4_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BrowserCanvasJsGameWindow$loop$slambda).h5q = function ($completion) {
    var tmp = this.g5a($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(BrowserCanvasJsGameWindow$loop$slambda).be = function ($completion) {
    return this.h5q($completion);
  };
  protoOf(BrowserCanvasJsGameWindow$loop$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.jd4_1(this.kd4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(BrowserCanvasJsGameWindow$loop$slambda).g5a = function (completion) {
    return new BrowserCanvasJsGameWindow$loop$slambda(this.jd4_1, this.kd4_1, completion);
  };
  function BrowserCanvasJsGameWindow$loop$slambda_0($entry, this$0, resultContinuation) {
    var i = new BrowserCanvasJsGameWindow$loop$slambda($entry, this$0, resultContinuation);
    var l = function ($completion) {
      return i.h5q($completion);
    };
    l.$arity = 0;
    return l;
  }
  function BrowserCanvasJsGameWindow$lambda(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mouseEvent$default(this$0, it, Type_SCROLL_getInstance());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_0(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mouseEvent$default(this$0, it, Type_ENTER_getInstance());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_1(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mouseEvent$default(this$0, it, Type_EXIT_getInstance());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_2(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_3(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_4(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mouseEvent$default(this$0, it, Type_EXIT_getInstance());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_5(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mouseEvent$default(this$0, it, Type_UP_getInstance_0());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_6(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mouseEvent$default(this$0, it, Type_DOWN_getInstance_0());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_7(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mouseEvent$default(this$0, it, Type_CLICK_getInstance());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_8(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      touchEvent(this$0, it, Type_START_getInstance());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_9(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      touchEvent(this$0, it, Type_MOVE_getInstance_0());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_10(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      touchEvent(this$0, it, Type_END_getInstance());
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_11(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      keyEvent(this$0, it);
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_12(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      keyEvent(this$0, it);
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_13(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      keyEvent(this$0, it);
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_14(this$0) {
    return function (it) {
      onResized(this$0);
      return Unit_instance;
    };
  }
  function BrowserCanvasJsGameWindow$lambda_15(this$0) {
    return function (it) {
      return this$0.scy(Type_START_getInstance_0(), null);
    };
  }
  function BrowserCanvasJsGameWindow$lambda_16(this$0) {
    return function (it) {
      return this$0.scy(Type_END_getInstance_0(), null);
    };
  }
  function BrowserCanvasJsGameWindow$lambda_17(this$0) {
    return function (it) {
      return this$0.scy(Type_END_getInstance_0(), null);
    };
  }
  function BrowserCanvasJsGameWindow$lambda_18(it) {
    it.preventDefault();
    return Unit_instance;
  }
  function BrowserCanvasJsGameWindow$lambda_19(this$0) {
    return function (it) {
      return this$0.scy(Type_START_getInstance_0(), null);
    };
  }
  function BrowserCanvasJsGameWindow$lambda_20(this$0) {
    return function (it) {
      return this$0.scy(Type_END_getInstance_0(), null);
    };
  }
  function BrowserCanvasJsGameWindow$lambda_21(this$0) {
    return function (it) {
      it.preventDefault();
      this$0.scy(Type_END_getInstance_0(), null);
      var items = ensureNotNull(it.dataTransfer).items;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_0 = until(0, items.length);
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<anonymous>.<anonymous>' call
        // Inline function 'org.w3c.dom.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = items[element];
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getAsFile();
        var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : toVfs(tmp1_safe_receiver);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.r(tmp0_safe_receiver_0);
        }
      }
      var files = destination;
      return this$0.scy(Type_DROP_getInstance(), files);
    };
  }
  function BrowserCanvasJsGameWindow$lambda_22(this$0) {
    return function (step) {
      window.requestAnimationFrame(_get_jsFrame__gugpar(this$0));
      this$0.scx();
      return Unit_instance;
    };
  }
  function $loopCOROUTINE$20(_this__u8e3s4, entry, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.td4_1 = _this__u8e3s4;
    this.ud4_1 = entry;
  }
  protoOf($loopCOROUTINE$20).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.fd_1 = 1;
            suspendResult = this.td4_1.rcx(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = launchImmediately_0(ARGUMENT, BrowserCanvasJsGameWindow$loop$slambda_0(this.ud4_1, this.td4_1, null));
            this.td4_1.md3_1 = ARGUMENT_0;
            _get_jsFrame__gugpar(this.td4_1)(0.0);
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function BrowserCanvasJsGameWindow(canvas) {
    canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
    JsGameWindow.call(this);
    this.ad3_1 = canvas;
    this.bd3_1 = AGWebgl(new AGConfig(), this.ad3_1);
    this.cd3_1 = new DialogInterfaceJs();
    this.dd3_1 = null;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ed3_1 = [GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_SYSTEM_getInstance()];
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.fd3_1 = [GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
    this.gd3_1 = new GamepadInfo();
    this.hd3_1 = Quality_AUTOMATIC_getInstance();
    this.id3_1 = 1.0;
    this.jd3_1 = new TouchBuilder();
    this.kd3_1 = Cursor_DEFAULT_getInstance();
    this.ld3_1 = null;
    this.md3_1 = null;
    // Inline function 'kotlin.js.asDynamic' call
    window.canvas = this.ad3_1;
    // Inline function 'kotlin.js.asDynamic' call
    window.ag = this.r9r();
    // Inline function 'kotlin.js.asDynamic' call
    window.gl = this.r9r().d8d_1;
    if (get_isCanvasCreatedAndHandled()) {
      var tmp0_safe_receiver = document.body;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(this.ad3_1);
      var tmp1_safe_receiver = document.body;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
      if (tmp2_safe_receiver != null) {
        tmp2_safe_receiver.margin = '0px';
      }
      var tmp3_safe_receiver = document.body;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
      if (tmp4_safe_receiver != null) {
        tmp4_safe_receiver.padding = '0px';
      }
      var tmp5_safe_receiver = document.body;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
      if (tmp6_safe_receiver != null) {
        tmp6_safe_receiver.overflowX = 'hidden';
      }
      var tmp7_safe_receiver = document.body;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
      if (tmp8_safe_receiver != null) {
        tmp8_safe_receiver.overflowY = 'hidden';
      }
    }
    this.ad3_1.addEventListener('wheel', BrowserCanvasJsGameWindow$lambda(this));
    this.ad3_1.addEventListener('mouseenter', BrowserCanvasJsGameWindow$lambda_0(this));
    this.ad3_1.addEventListener('mouseleave', BrowserCanvasJsGameWindow$lambda_1(this));
    this.ad3_1.addEventListener('mouseover', BrowserCanvasJsGameWindow$lambda_2(this));
    this.ad3_1.addEventListener('mousemove', BrowserCanvasJsGameWindow$lambda_3(this));
    this.ad3_1.addEventListener('mouseout', BrowserCanvasJsGameWindow$lambda_4(this));
    this.ad3_1.addEventListener('mouseup', BrowserCanvasJsGameWindow$lambda_5(this));
    this.ad3_1.addEventListener('mousedown', BrowserCanvasJsGameWindow$lambda_6(this));
    this.ad3_1.addEventListener('click', BrowserCanvasJsGameWindow$lambda_7(this));
    this.ad3_1.addEventListener('touchstart', BrowserCanvasJsGameWindow$lambda_8(this));
    this.ad3_1.addEventListener('touchmove', BrowserCanvasJsGameWindow$lambda_9(this));
    this.ad3_1.addEventListener('touchend', BrowserCanvasJsGameWindow$lambda_10(this));
    var tmp_1 = window;
    tmp_1.addEventListener('keypress', BrowserCanvasJsGameWindow$lambda_11(this));
    var tmp_2 = window;
    tmp_2.addEventListener('keydown', BrowserCanvasJsGameWindow$lambda_12(this));
    var tmp_3 = window;
    tmp_3.addEventListener('keyup', BrowserCanvasJsGameWindow$lambda_13(this));
    var tmp_4 = window;
    tmp_4.addEventListener('resize', BrowserCanvasJsGameWindow$lambda_14(this));
    this.ad3_1.ondragenter = BrowserCanvasJsGameWindow$lambda_15(this);
    this.ad3_1.ondragexit = BrowserCanvasJsGameWindow$lambda_16(this);
    this.ad3_1.ondragleave = BrowserCanvasJsGameWindow$lambda_17(this);
    this.ad3_1.ondragover = BrowserCanvasJsGameWindow$lambda_18;
    this.ad3_1.ondragstart = BrowserCanvasJsGameWindow$lambda_19(this);
    this.ad3_1.ondragend = BrowserCanvasJsGameWindow$lambda_20(this);
    this.ad3_1.ondrop = BrowserCanvasJsGameWindow$lambda_21(this);
    onResized(this);
    var tmp_5 = this;
    tmp_5.nd3_1 = BrowserCanvasJsGameWindow$lambda_22(this);
    this.od3_1 = null;
  }
  protoOf(BrowserCanvasJsGameWindow).vd4 = function () {
    return window.devicePixelRatio;
  };
  protoOf(BrowserCanvasJsGameWindow).zaa = function () {
    return this.vd4() <= 0.0 ? 1.0 : isNaN_0(this.vd4()) ? 1.0 : isInfinite(this.vd4()) ? 1.0 : this.vd4();
  };
  protoOf(BrowserCanvasJsGameWindow).r9r = function () {
    return this.bd3_1;
  };
  protoOf(BrowserCanvasJsGameWindow).pd3 = function () {
    if (this.dd3_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        var e = $p;
        tmp_1 = false;
        tmp_0 = tmp_1;
      }
      tmp.dd3_1 = tmp_0;
    }
    return ensureNotNull(this.dd3_1);
  };
  protoOf(BrowserCanvasJsGameWindow).qcy = function () {
    try {
      if (navigator.getGamepads != null) {
        // Inline function 'kotlin.js.unsafeCast' call
        var gamepads = navigator.getGamepads();
        this.c7t();
        var inductionVariable = 0;
        var last = gamepads.length;
        if (inductionVariable < last)
          $l$loop_0: do {
            var gamepadId = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.render.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp1_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp1_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp1_elvis_lhs;
            }
            var controller = tmp;
            if (!(controller.mapping === 'standard'))
              continue $l$loop_0;
            var gamepad = this.gd3_1;
            gamepad.q7r_1 = controller.id;
            var inductionVariable_0 = 0;
            // Inline function 'kotlin.math.min' call
            var a = controller.buttons.length;
            var b = this.ed3_1.length;
            var last_0 = Math.min(a, b);
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp_0 = gamepad.r7r_1;
                var tmp_1 = this.ed3_1[n].g7s();
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0[tmp_1] = controller.buttons[n].value;
              }
               while (inductionVariable_0 < last_0);
            var inductionVariable_1 = 0;
            // Inline function 'kotlin.math.min' call
            var a_0 = controller.axes.length;
            var b_0 = this.fd3_1.length;
            var last_1 = Math.min(a_0, b_0);
            if (inductionVariable_1 < last_1)
              do {
                var n_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var isX = (n_0 % 2 | 0) === 0;
                var isY = !isX;
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var value = controller.axes[n_0];
                var valueWithoutDeadRange = Companion_instance_30.b7s(value, VOID, n_0 <= 3);
                gamepad.r7r_1[this.fd3_1[n_0].g7s()] = isY ? -valueWithoutDeadRange : valueWithoutDeadRange;
              }
               while (inductionVariable_1 < last_1);
            this.d7t(gamepad);
          }
           while (inductionVariable < last);
        this.ucy();
      }
    } catch ($p) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = CoroutineKey_getInstance().zcv_1;
      var level = Level_ERROR_getInstance();
      var tmp_2;
      if (this_0.f25(level)) {
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.updateGamepads.<anonymous>' call
        this_0.g25(level, e);
        tmp_2 = Unit_instance;
      }
    }
  };
  protoOf(BrowserCanvasJsGameWindow).p9r = function (value) {
    if (!this.hd3_1.equals(value)) {
      this.hd3_1 = value;
      onResized(this);
    }
  };
  protoOf(BrowserCanvasJsGameWindow).o9r = function () {
    return this.hd3_1;
  };
  protoOf(BrowserCanvasJsGameWindow).wcx = function (value) {
    document.title = value;
  };
  protoOf(BrowserCanvasJsGameWindow).x1q = function () {
    return this.ad3_1.clientWidth;
  };
  protoOf(BrowserCanvasJsGameWindow).y1q = function () {
    return this.ad3_1.clientHeight;
  };
  protoOf(BrowserCanvasJsGameWindow).n9r = function (value) {
    this.ld3_1 = value;
    if (!(value == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var link = document.querySelector("link[rel*='icon']");
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = toHtmlNative(value).b7d();
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = document.getElementsByTagName('head')[0];
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(link);
    } else {
      var tmp1_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.remove();
      }
    }
  };
  protoOf(BrowserCanvasJsGameWindow).xcx = function (value) {
    if (!(this.wd4() === value)) {
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        // Inline function 'kotlin.Companion.success' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<set-fullscreen>.<anonymous>' call
        var tmp_0;
        if (value) {
          tmp_0 = this.ad3_1.requestFullscreen();
        } else {
          tmp_0 = document.exitFullscreen();
        }
        var value_0 = tmp_0;
        tmp = _Result___init__impl__xyqfz8(value_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
    }
  };
  protoOf(BrowserCanvasJsGameWindow).wd4 = function () {
    return !(document.fullscreenElement == null);
  };
  protoOf(BrowserCanvasJsGameWindow).cax = function (value) {
    this.ad3_1.style.visibility = value ? 'visible' : 'hidden';
  };
  protoOf(BrowserCanvasJsGameWindow).ycx = function (width, height) {
  };
  protoOf(BrowserCanvasJsGameWindow).acy = function (exitCode) {
    var tmp = MainScope();
    launchImmediately(tmp, BrowserCanvasJsGameWindow$close$slambda_0(this, null));
    this.md3_1 = null;
  };
  protoOf(BrowserCanvasJsGameWindow).q9u = function (entry, $completion) {
    var tmp = new $loopCOROUTINE$20(this, entry, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function JsGameWindow() {
    GameWindow.call(this);
  }
  function DialogInterfaceJs() {
  }
  //region block: post-declaration
  protoOf(Listener).x6g = cancel;
  protoOf(BaseEventListener).r7m = dispatch$default;
  protoOf(BaseEventListener).t7m = onEvents;
  protoOf(BaseEventListener).u7m = dispatchDown;
  protoOf(BaseEventListener).v7m = dispatchUp;
  protoOf(AG).v7u = get_parentFeatures;
  protoOf(AG).w7u = get_isUniformBuffersSupported;
  protoOf(AG).x7u = get_isVertexArraysSupported;
  protoOf(Builder).i8b = get_Float1;
  protoOf(Builder).u8v = get_Float2;
  protoOf(Builder).t8w = get_Float4;
  protoOf(Builder).b8a = get_out;
  protoOf(Builder).j8b = atan;
  protoOf(Builder).j8a = texture2D;
  protoOf(Builder).v8v = TERNARY;
  protoOf(Builder).k8b = pow;
  protoOf(Builder).l8b = sqrt;
  protoOf(Builder).m8b = abs;
  protoOf(Builder).n8b = fract;
  protoOf(Builder).w8v = clamp_3;
  protoOf(Builder).x8v = min_2;
  protoOf(Builder).y8v = max_2;
  protoOf(Builder).z8v = fwidth;
  protoOf(Builder).a8w = mix;
  protoOf(Builder).o8b = smoothstep;
  protoOf(Builder).b8w = length;
  protoOf(Builder).e8a = get_lit;
  protoOf(Builder).p8b = vec2;
  protoOf(Builder).q8b = vec2_0;
  protoOf(Builder).f8a = vec4;
  protoOf(Builder).h8a = get_1;
  protoOf(Builder).r8b = get_x;
  protoOf(Builder).s8b = get_y;
  protoOf(Builder).t8b = get_z;
  protoOf(Builder).u8b = get_w;
  protoOf(Builder).l8a = get_a;
  protoOf(Builder).v8b = unaryMinus;
  protoOf(Builder).w8b = minus;
  protoOf(Builder).c8w = minus_0;
  protoOf(Builder).x8b = plus_2;
  protoOf(Builder).d8w = plus_3;
  protoOf(Builder).e8w = plus_4;
  protoOf(Builder).c8a = times;
  protoOf(Builder).f8w = times_0;
  protoOf(Builder).n8a = div;
  protoOf(Builder).y8b = eq;
  protoOf(Builder).z8b = lt;
  protoOf(Builder).a8c = le;
  protoOf(Builder).b8c = gt;
  protoOf(Builder).g8w = gt_0;
  protoOf(ProgramBuilderDefault).i8a = get_u_Tex;
  protoOf(ProgramBuilderDefault).d89 = get_u_ProjMat;
  protoOf(ProgramBuilderDefault).e89 = get_u_ViewMat;
  protoOf(ProgramBuilderDefault).d8a = get_a_Pos;
  protoOf(ProgramBuilderDefault).v89 = get_a_Tex;
  protoOf(ProgramBuilderDefault).a8a = get_a_Col;
  protoOf(ProgramBuilderDefault).u89 = get_v_Tex;
  protoOf(ProgramBuilderDefault).z89 = get_v_Col;
  protoOf(ProgramBuilderDefault).m8a = get_t_Temp0;
  protoOf(ProgramBuilderDefault).c8c = get_t_Temp1;
  protoOf(GlslGenerator).i8s = precToString;
  protoOf(GlslGenerator).j8s = typeToString;
  protoOf(GlslGenerator).k8s = get_arrayDecl;
  protoOf(GlslGenerator).h8s = get_IN;
  protoOf(GlslGenerator).m8s = get_OUT;
  protoOf(GlslGenerator).l8s = get_UNIFORM;
  protoOf(GlslBodyGenerator).j8s = typeToString;
  protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).k8b = pow;
  protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).e8a = get_lit;
  protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).h8a = get_1;
  protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).w8b = minus;
  protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).x8b = plus_2;
  protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).c8a = times;
  protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).b8c = gt;
  protoOf(KmlGl).v7u = get_parentFeatures;
  protoOf(KmlGl).w7u = get_isUniformBuffersSupported;
  protoOf(KmlGl).x7u = get_isVertexArraysSupported;
  protoOf(Transition$1).nay = start;
  protoOf(Transition$1).oay = end;
  protoOf(Image).sc7 = forceLoadSourceFile$default;
  protoOf(Mixin_0).sc7 = forceLoadSourceFile$default;
  protoOf(Base).jaa = get_actualVirtualWidth;
  protoOf(Base).iaa = get_actualVirtualHeight;
  protoOf(Base).qaa = get_virtualLeft;
  protoOf(Base).saa = get_virtualTop;
  protoOf(Base).raa = get_virtualRight;
  protoOf(Base).paa = get_virtualBottom;
  protoOf(Base).vaa = get_windowToGlobalScaleAvg;
  protoOf(Base).maa = get_globalToWindowScaleAvg;
  protoOf(Base).y9o = windowToGlobalCoords;
  protoOf(IdentityFilter).mcr = get_recommendedFilterScale;
  protoOf(IdentityFilter).ncr = computeBorder;
  protoOf(ViewRenderPhaseFilter).icf = beforeRender;
  protoOf(ViewRenderPhaseFilter).jcf = afterRender;
  protoOf(DEFAULT).zaa = get_devicePixelRatio;
  protoOf(DEFAULT).aab = get_pixelsPerInch;
  protoOf(DEFAULT).bab = get_pixelsPerLogicalInchRatio;
  protoOf(DEFAULT).yaa = get_computedPixelRatio;
  protoOf(GameWindow).zaa = get_devicePixelRatio;
  protoOf(GameWindow).aab = get_pixelsPerInch;
  protoOf(GameWindow).bab = get_pixelsPerLogicalInchRatio;
  protoOf(GameWindow).yaa = get_computedPixelRatio;
  protoOf(GameWindow).md = get_0;
  protoOf(GameWindow).ch = fold;
  protoOf(GameWindow).bh = minusKey;
  protoOf(GameWindow).dh = plus_1;
  //endregion
  //region block: init
  Companion_instance_18 = new Companion_4();
  Companion_instance_19 = new Companion_5();
  Companion_instance_20 = new Companion_6();
  Companion_instance_21 = new Companion_7();
  Companion_instance_22 = new Companion_8();
  Companion_instance_23 = new Companion_9();
  Companion_instance_26 = new Companion_12();
  Companion_instance_27 = new Companion_13();
  Companion_instance_29 = new Companion_15();
  Companion_instance_30 = new Companion_16();
  Companion_instance_37 = new Companion_23();
  Companion_instance_38 = new Companion_24();
  AGFinish_instance = new AGFinish();
  Companion_instance_56 = new Companion_42();
  ShaderIndices_instance = new ShaderIndices();
  Companion_instance_59 = new Companion_45();
  Companion_instance_60 = new Companion_46();
  Companion_instance_64 = new Companion_50();
  Companion_instance_65 = new Companion_51();
  KorgeRunner_instance = new KorgeRunner();
  Companion_instance_68 = new Companion_54();
  debugBmpFontOrNull = null;
  Companion_instance_70 = new Companion_56();
  Companion_instance_71 = new Companion_57();
  Companion_instance_72 = new Companion_58();
  TEXTURED_ARRAY_COMPONENTS_PER_VERTEX = 6;
  VERTEX_INDEX_SIZE = 6;
  ZIndexComparator_instance = new ZIndexComparator();
  Companion_instance_80 = new Companion_66();
  Companion_instance_81 = new Companion_67();
  Companion_instance_82 = new Companion_68();
  Companion_instance_83 = new Companion_69();
  Companion_instance_84 = new Companion_70();
  Companion_instance_85 = new Companion_71();
  Companion_instance_86 = new Companion_72();
  Companion_instance_87 = new Companion_73();
  Companion_instance_88 = new Companion_74();
  Companion_instance_91 = new Companion_77();
  DEFAULT_instance = new DEFAULT();
  GLOBAL_CHECK_GL = false;
  korgwJvmEngine = null;
  AGOpenglFactory_instance = new AGOpenglFactory();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = GameButton_BUTTON_SOUTH_getInstance;
  _.$_$.b = GameButton_LX_getInstance;
  _.$_$.c = GameButton_LY_getInstance;
  _.$_$.d = Key_DOWN_getInstance;
  _.$_$.e = Key_LEFT_getInstance;
  _.$_$.f = Key_RIGHT_getInstance;
  _.$_$.g = Key_SPACE_getInstance;
  _.$_$.h = Key_UP_getInstance;
  _.$_$.i = TileMapRepeat_NONE_getInstance;
  _.$_$.j = views;
  _.$_$.k = Korge_0;
  _.$_$.l = TileMap_init_$Create$;
  _.$_$.m = _TileInfo___init__impl__kuhpkr_0;
  _.$_$.n = _TileInfo___get_data__impl__56jsba;
  _.$_$.o = Companion_getInstance_45;
  _.$_$.p = Companion_getInstance_88;
  _.$_$.q = Companion_instance_88;
  _.$_$.r = Nearest_getInstance;
  _.$_$.s = Companion_instance_83;
  _.$_$.t = GamepadInfo;
  _.$_$.u = animator;
  _.$_$.v = block;
  _.$_$.w = tween;
  _.$_$.x = get_gamepad;
  _.$_$.y = singleTouch;
  _.$_$.z = get_AlphaTransition;
  _.$_$.a1 = SceneContainer;
  _.$_$.b1 = Scene;
  _.$_$.c1 = withEasing;
  _.$_$.d1 = ImageDataView;
  _.$_$.e1 = set_filter;
  _.$_$.f1 = get_filterScale;
  _.$_$.g1 = set_filterScale;
  _.$_$.h1 = TileMap;
  _.$_$.i1 = Camera;
  _.$_$.j1 = Container;
  _.$_$.k1 = FastEllipse;
  _.$_$.l1 = FixedSizeContainer;
  _.$_$.m1 = SolidRect;
  _.$_$.n1 = Stage;
  _.$_$.o1 = Text;
  _.$_$.p1 = addFixedUpdater_0;
  _.$_$.q1 = addTo;
  _.$_$.r1 = alpha;
  _.$_$.s1 = anchor;
  _.$_$.t1 = colorMul;
  _.$_$.u1 = findFirstAscendant;
  _.$_$.v1 = onStageResized;
  _.$_$.w1 = xy;
  _.$_$.x1 = xy_0;
  _.$_$.y1 = KorgeDisplayMode;
  //endregion
  return _;
}));
